// Generated by js_of_ocaml 4.1.0
(function(b){typeof
globalThis!=="object"&&(this?c():(b.defineProperty(b.prototype,"_T_",{configurable:true,get:c}),_T_));function
c(){var
c=this||self;c.globalThis=c;delete
b.prototype._T_}}(Object));(function(bz){"use strict";var
b1x=bz,b1y=typeof
module==="object"&&module.exports||bz,kB=4812,Fz="38527",g7=424,Bu=4050,bn="\xc3\x89ligibilit\xc3\xa9PrestationsFamiliales",Bt="colocation",Bs=4710,Br="Article L521-1",xO=794,iI="Paragraphe 2 : Ouverture du droit et liquidation.",mI=365180284,xN="Changement",Bq=775,lF=1184,I0="26714",IZ=2138,IY=163,Fy="redevance_in",nI="SaintMartin",Fx="1015",nH=891,dX="Section 1 : Seuils de constitution d'un impay\xc3\xa9",Fw=4290,b3="Article 1",Fv="559500",cO="aide_finale_formule",lE=122,Ft="35630",Fu=1207,qc="Article 31",is="50",bp="Unexpected '",Fs=299,IX="34700",Bp=181,Fr=2441,lD=305,mH="Article 19",dc=128,ic="Avant",Bo="43000",qT="identifiant",nG="Oui",qS="Article D832-26",xM=573,mG=383,IW=146,kA=">",Bn=575,lC=941,nF=731,rG=1027,xL=1129,mF=1153,nE="Article 17",aw="Section 2 : Accession \xc3\xa0 la propri\xc3\xa9t\xc3\xa9",Bm="b\xc3\xa9n\xc3\xa9ficiaire_aide_adulte_ou_enfant_handicap\xc3\xa9s_in",ep="Chapitre 5 : Prestations familiales et prestations assimil\xc3\xa9es",xK="local_habit\xc3\xa9_premi\xc3\xa8re_fois_b\xc3\xa9n\xc3\xa9ficiaire_in",lB="baseMensuelleAllocationsFamiliales",xJ="35762",M="Archives de l'arr\xc3\xaat\xc3\xa9 du 27 septembre 2019 relatif au calcul des aides personnelles au logement et de la prime de d\xc3\xa9m\xc3\xa9nagement",nD=739,P="Calcul du montant de l'allocation logement",nC=1221,dG=2011,aI=2023,Bl=3331,eL="Article L841-1",Fo=583,Fp="ServicesSociauxAllocationVerseeALaFamille",Fq=1251,xH="186000",kz=1036,xI="Instruction interminist\xc3\xa9rielle no DSS/SD2B/2020/33 du 18 f\xc3\xa9vrier 2020 relative \xc3\xa0 la revalorisation au 1er avril 2020 des prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 La R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et dans le d\xc3\xa9partement de Mayotte",lA=1028,xG="16.25",pD="0.0315",iH="traitement_aide_finale_diminu\xc3\xa9",xF=2211,IV="\xc3\xa9ligibilit\xc3\xa9_commune.date_courante",xE=720,Fn="40758",Fm=3153,nB="e",Fl=896,gA="Autre",lz=395,IU=505,ky=1150,Bk="Article L822-2",Bi=3825,Bj=392,kx=3709,Bh=4178,fj="smic",xD="39445",IT=4861,cq="Article D842-6",xB=-43,xC=612,Fk="Neuf",pC=901,kw=485,rF="Article 27",IR=897,IS="inf",Bg="calculetteAidesAuLogementGardeAlternee",ib=306,xA="27365",Bf="Circulaire interminist\xc3\xa9rielle N\xc2\xb0 DSS/SD2B/2017/352 du 22 d\xc3\xa9cembre 2017 relative \xc3\xa0 la revalorisation au 1er janvier 2018 des plafonds de ressources d\xe2\x80\x99attribution de certaines prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 la R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et \xc3\xa0 Mayotte",hk="Article L862-3",ly=1172,nA="verificationAgeSuperieurA",IQ="41392",ir=111,xz=676,Be="Location",pB=782,Fj="240400",nz=2392,rE="Ordonnance n\xc2\xb0 96-50 du 24 janvier 1996 relative au remboursement de la dette sociale",Bd="33500",qR=3672,qb="758400",iG="CalculNombrePartsAccessionPropri\xc3\xa9t\xc3\xa9",cN="Article D823-9",IP=393,bF="traitement_aide_finale_minoration_forfaitaire",xy=4720,pA="\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\xff\xff\x03\0\0\0\x86\0\xff\xff\x03\0\xff\xff\x86\0E\x01\x92\x019\0\xff\xffE\x01\x92\x01\xff\xff\xff\xff\xff\xff\xff\xff}\0\x8a\0\xff\xff\0\0\xff\xff\0\0\x03\0\xa9\0\x86\0\xae\0\xff\xff\0\0\n\x01E\x01\x92\x01\f\x01\0\0\n\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0s\0\0\0}\0\x81\0\x05\0\xec\x01\x88\0\xff\x01&\0\xff\xff\n\0\x88\0f\0:\0\0\0k\0f\0\xff\xff\x0b\0\0\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x1d\0&\0\0\0o\0\xd0\0\xe9\0\xff\0\f\x01\x0f\0\x11\0<\0\x0b\0\n\0\0\0\x14\0\x18\0\x1f\0 \0\"\0\x16\0\x1a\0\0\0\x0e\0\x1b\0!\0\x12\0\x17\0\0\0\x10\0\x13\0#\0(\0$\0&\0\0\0)\0*\0+\0,\0-\0.\0:\0R\0\x0b\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0'\0?\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0U\0\x8c\0<\0\r\0\x8f\0\x90\0\x91\x000\0\x93\x000\0\x94\0'\x000\x000\x000\x000\x000\x000\x000\x000\x000\x000\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\0A\0'\0\x95\0\x96\0\x9c\0?\0\x9d\x003\0\x9e\x003\0\x9f\x002\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\0\x9b\x002\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\0\xa1\0\xa2\0\x9b\0[\0A\0\0\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x009\0D\0f\0k\0s\0\x83\0\x85\0\x85\0}\0\x8a\0\x85\0\xa3\0^\0\xa5\0D\0\xa6\0\xa7\0\xa8\0\xab\0o\0\xac\0\xad\0\xce\0\xcb\0\xcf\0\xd2\0\xd3\0:\0R\0\x85\0\xd4\0\xd5\0\xd6\0\xd7\0\xd9\0\x8c\0\xda\0a\0\xdb\0\xdc\0w\0\xdd\0\xde\0\xdf\0\x85\0[\0\xcb\0\"\x01>\x01\xe9\0\x98\0\x01\x01P\x01\xf7\0<\0\xfb\x006\x01:\x01Q\x01D\0)\x01R\x01S\x01\x06\x01\x1a\x01D\0w\0\x1e\x01\x0f\x01D\0^\0\x0f\x01T\x01U\x01V\x01G\x01X\x01D\0\xcb\x002\x01G\x01D\0Y\x01D\0D\0G\0G\0G\0G\0G\0G\0G\0G\0G\0G\0a\0L\x01w\0Z\x01?\0\x01\x01\\\x01G\0G\0G\0G\0G\0G\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0\x98\0L\x01]\x01_\x01a\x01b\x01-\x01N\0N\0N\0N\0N\0N\0c\x01\x98\0d\x01G\0G\0G\0G\0G\0G\0\xb4\0\xb4\0\xb4\0\xb4\0\xb4\0\xb4\0\xb4\0\xb4\0\xb4\0\xb4\0\x14\x01L\x01A\0\x14\x01e\x01f\x01h\x01N\0N\0N\0N\0N\0N\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0i\x01j\x01-\x01$\x01k\x01l\x01m\x01O\0O\0O\0O\0O\0O\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0n\x01\x1a\x01y\x01\x9d\x01\x1e\x01\x9e\x01\x14\x01P\0P\0P\0P\0P\0P\0[\0\x9f\x01>\x01O\0O\0O\0O\0O\0O\0\xf7\0\xa0\x01\xfb\0\xa1\x01:\x01D\0V\0V\0V\0V\0V\0V\0V\0V\0V\0V\0^\0P\0P\0P\0P\0P\0P\0V\0V\0V\0V\0V\0V\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0$\x01)\x01a\0\xa2\x01\xa3\x01w\0\x01\x01W\0W\0W\0W\0W\0W\0\xa5\x016\x01\x98\0V\0V\0V\0V\0V\0V\0\x06\x01\xa6\x01\xa7\x01\xa8\x01\x0f\x01\xa9\x01X\0X\0X\0X\0X\0X\0X\0X\0X\0X\x002\x01W\0W\0W\0W\0W\0W\0X\0X\0X\0X\0X\0X\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0_\0\x85\x01\xaa\x01\xab\x01\x9a\x01\x85\x01\xac\x01Y\0Y\0Y\0Y\0Y\0Y\0_\0\xb0\0\xad\x01X\0X\0X\0X\0X\0X\0-\x01\xae\x01\xaf\x01\xb0\0\xb0\x01\x9a\x01\xb0\0\xb0\0\xb0\0\xb0\0\xb0\0\xb0\0\xb0\0\xb0\0\xb0\0\xb0\0z\x01Y\0Y\0Y\0Y\0Y\0Y\0\x94\x01\xb1\x01\x14\x01\xb2\x01b\0\x94\x01\xb3\x01\xb4\x01\xb5\x01\xb6\x01\xb7\x01\xd8\x01\xc1\x01_\0\x9a\x01\xd8\x01\xcd\x01b\0\xde\x01_\0\xcd\x01\xe5\x01\x01\x02_\0\xda\x01$\x01\xd7\x01\xd7\x01\x02\x02\xda\x01\xd7\x01_\0\x04\x02\x05\x02\xd8\x01_\0\x06\x02_\0_\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0\xd7\x01\x07\x02z\x01\b\x02\t\x02\n\x02\x0b\x02`\0`\0`\0`\0`\0`\0b\0\f\x02\xd7\x01\xf7\x01\r\x02\x0e\x02b\0\x0f\x02}\x01\x80\x01b\0\x10\x02\xdc\x01\x11\x02\xfb\x01\x12\x02\x13\x02\x14\x02b\0y\x01\x15\x02\xc2\x01b\0\x16\x02b\0b\0`\0`\0`\0`\0`\0`\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0\xe7\x01\x17\x02\xee\x01\x18\x02\xfb\x01\xee\x01\x19\x02c\0c\0c\0c\0c\0c\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0\xf3\x01}\x01\x80\x01\xe0\x01\x1a\x02\xc5\x01\x1b\x02d\0d\0d\0d\0d\0d\0\x1c\x02\xc2\x01\x1d\x02c\0c\0c\0c\0c\0c\0\x1e\x02\x1f\x02 \x02\xc8\x01\xe7\x01\x85\x01e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0\xff\xffd\0d\0d\0d\0d\0d\0e\0e\0e\0e\0e\0e\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xff\xff\xff\xff\xc5\x01\xb0\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb9\0\xff\xffe\0e\0e\0e\0e\0e\0\xc8\x01\xe0\x01\xff\xff\xb9\0\xcd\x01z\x01\xb9\0\xb9\0\xb9\0\xb9\0\xb9\0\xb9\0\xb9\0\xb9\0\xb9\0\xb9\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbf\0\xbf\0\xbf\0\xbf\0\xbf\0\xbf\0\xbf\0\xbf\0\xbf\0\xbf\0\xc0\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc0\0\xc1\x01\xf7\x01\xc0\0\xc0\0\xc0\0\xc0\0\xc0\0\xc0\0\xc0\0\xc0\0\xc0\0\xc0\0\xc6\0\xc6\0\xc6\0\xc6\0\xc6\0\xc6\0\xc6\0\xc6\0\xc6\0\xc6\0\xc7\0\xe2\0\xe2\0\xe2\0\xe2\0\xe2\0\xe2\0\xe2\0\xe2\0\xe2\0\xe2\0\xc7\0}\x01\x80\x01\xc7\0\xc7\0\xc7\0\xc7\0\xc7\0\xc7\0\xc7\0\xc7\0\xc7\0\xc7\0\xcc\0\xc2\x01\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xe7\x01\xff\xff\xff\xff\xc7\0\xdc\x01\xee\x01\xfb\x01\xff\xff\xc7\0\xf3\x01\xff\xff\xcc\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xcd\0\xe1\0\xff\xff\xe1\0\xff\xff\xe0\x01\xe1\0\xe1\0\xe1\0\xe1\0\xe1\0\xe1\0\xe1\0\xe1\0\xe1\0\xe1\0\xcd\0\xc5\x01\xff\xff\xff\xff\xff\xff\xff\xff\xcc\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xff\xff\xff\xff\xff\xff\xff\xff\xc8\x01\xff\xff\xff\xff\xe4\0\xff\xff\xe4\0\xff\xff\xe3\0\xe4\0\xe4\0\xe4\0\xe4\0\xe4\0\xe4\0\xe4\0\xe4\0\xe4\0\xe4\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe6\0\xe6\0\xe6\0\xe6\0\xe6\0\xe6\0\xe6\0\xe6\0\xe6\0\xe6\0\xff\xff\xe3\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xb9\0\xe8\0\xe8\0\xe8\0\xe8\0\xe8\0\xe8\0\xe8\0\xe8\0\xe8\0\xe8\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xed\0\xff\xffM\x01\xff\xffM\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01q\x01q\x01q\x01q\x01q\x01q\x01q\x01q\x01q\x01q\x01\xff\xffM\x01\xff\xff\xff\xff\xc0\0\xff\xff\xff\xff\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0M\x01\xff\xff\xff\xff\xff\xff\xed\0\xc7\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xed\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xff\xff\xf2\0\xff\xff\xff\xff\xf0\0\xff\xff\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xff\xff\xff\xff\xff\xff\xff\xff\xf2\0\xff\xff\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xf2\0\xed\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xff\xff\xff\xff\xff\xff\xff\xff\xf5\0\xff\xff\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0B\x01B\x01\xff\xff\xff\xffB\x01O\x01O\x01O\x01O\x01O\x01O\x01O\x01O\x01O\x01O\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffB\x01\xff\xffB\x01\xff\xff\xff\xff\xff\xff\xff\xffO\x01B\x01\xff\xff\xff\xff\xff\xff\xff\xffB\x01\xff\xffB\x01B\x01B\x01B\x01B\x01B\x01B\x01B\x01B\x01B\x01B\x01\xff\xff\xff\xffB\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xf2\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffB\x01p\x01\xff\xffp\x01\xff\xffB\x01p\x01p\x01p\x01p\x01p\x01p\x01p\x01p\x01p\x01p\x01\xff\xff\xff\xffB\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01B\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffB\x01\xff\xff\xff\xffr\x01\xff\xff\xff\xffB\x01\xff\xff\xff\xffs\x01\xff\xffs\x01\xff\xffB\x01s\x01s\x01s\x01s\x01s\x01s\x01s\x01s\x01s\x01s\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01\xff\xffr\x01u\x01u\x01u\x01u\x01u\x01u\x01u\x01u\x01u\x01u\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01w\x01w\x01w\x01w\x01w\x01w\x01w\x01w\x01w\x01w\x01\xff\xff~\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\xff\xff\xff\xff~\x01\xff\xff\xff\xff\xff\xff\x81\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x81\x01\xff\xff\xff\xff\x9b\x01\xff\xff\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x7f\x01\x9b\x01\xff\xff~\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff~\x01\xff\xff\xff\xff\xff\xff~\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x81\x01~\x01\xff\xff\xff\xffB\x01~\x01\x81\x01~\x01~\x01\xff\xff\x81\x01\xff\xff\xff\xff\x9b\x01\xff\xff\xff\xff\xff\xff\xff\xff\x81\x01\xff\xff\xff\xff\xff\xff\x81\x01\xff\xff\x81\x01\x81\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\xff\xff\xff\xff\xff\xff\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\xff\xff\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\xb8\x01\x8a\x01\xb8\x01\xff\xff\xff\xff\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb8\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xb9\x01\xff\xff\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\xff\xff\xff\xff\xff\xff\xff\xff\x8a\x01\xff\xff\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8a\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\xff\xff\xff\xff\xff\xff\xff\xff\x8d\x01\xff\xff\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8f\x01\x8f\x01\xff\xff\xff\xff\x8f\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\x9c\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xc6\x01\x8f\x01\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xff\xff\x9c\x01\x8f\x01\xff\xff\xff\xff\xff\xff\xc6\x01\x8f\x01\xff\xff\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\x8f\x01\xff\xff\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x8a\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xff\xff\x8f\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xc6\x01\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xc6\x01\xff\xff\xff\xff\xff\xff\xc6\x01\xba\x01\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xff\xff\xc6\x01\xff\xff\xff\xff\x8f\x01\xc6\x01\xff\xff\xc6\x01\xc6\x01\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x8f\x01\xff\xff\xff\xff\xff\xff\xff\xff\xbb\x01\xff\xff\xbb\x01\xff\xff\xba\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbb\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbd\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xbf\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc9\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc9\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xc7\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xc9\x01\xff\xff\xff\xff\xff\xff\xff\xff\x8f\x01\xc9\x01\xff\xff\xff\xff\xff\xff\xc9\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xc9\x01\xff\xff\xff\xff\xff\xff\xc9\x01\xff\xff\xc9\x01\xc9\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xff\xff\xff\xff\xff\xff\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xff\xff\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xff\xff\xd2\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xff\xff\xff\xff\xff\xff\xff\xff\xd2\x01\xff\xff\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd2\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xff\xff\xff\xff\xff\xff\xff\xff\xd5\x01\xff\xff\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xd2\x01\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",IO="infinity",IN=1855,gz="2.5",Bc="3663",dZ="Chapitre IV : Impay\xc3\xa9s de d\xc3\xa9penses de logement",Bb=2358,Fi=318,fe="examples/allocations_familiales/../base_mensuelle_allocations_familiales/bmaf.catala_fr",Fh=3693,xw=717,xx="\\t",lx=955,Fg=211,IL=2457,IM=1011,al="examples/aides_logement/code_construction_legislatif.catala_fr",Ff=1102,Fe="situation_r822_11_13_17_in",fZ=330,qQ=391,aR="Titre 2 : Prestations g\xc3\xa9n\xc3\xa9rales d'entretien",Fd=1629,rD=112,xv=3799,xu="487000",g6="1000",Fc=2999,xt=563,ny=4145,mE="1858",Ba=2252,df="examples/aides_logement/code_s\xc3\xa9curit\xc3\xa9_sociale.catala_fr",xs="210600",nx=599,xr=1146,mD=4816,xq="Couple",kv="SaintPierreEtMiquelon",A$="loyer_minimal",co="PrestationsFamiliales",qP=110,IK="214700",xp=352,dL="Calcul\xc3\x89quivalenceLoyerMinimale",A_=1096,nw=554,IJ="42926",xo=-32,Fb="39016",qO=847,nv="AllocationLogementFamiliale",dW=1023,II="interfaceAllocationsFamiliales",xn=1440,A9=561,ku="AllocationLogementSociale",xm=323,lw=1043,xl="plafond_l512_3_2",A8=542,fd=117,qN="Chapitre II : Des contributions pour le remboursement de la dette sociale.",a1="examples/allocations_familiales/decrets_divers.catala_fr",iq="compl\xc3\xa9ment_d\xc3\xa9gressif",IH=1214,pz="Livre VIII : Allocations aux personnes \xc3\xa2g\xc3\xa9es - Allocation aux adultes handicap\xc3\xa9s - Aides \xc3\xa0 l'emploi pour la garde des jeunes enfants - Protection compl\xc3\xa9mentaire en mati\xc3\xa8re de sant\xc3\xa9",IF="240200",IG="Assert_failure",bo="Section 1 : Secteur locatif ordinaire",IE="568400",nu=496,rC="0.32",xj=755,xk=4388,ip=308,Fa="40961",ID=350,A7=2341,nt="Non",i2="Article R824-2",f3="Section 2 : Allocations de logement",IC=1e14,xi="D331_76_1",lv="Article R521-3",E$="17607",IB=3518,G=2022,IA=2272,A6="Fatal error: exception %s\n",Iz="34865",A5=865,E_="261800",E9=740,dz="Article 2",fc=256,py=558,xh="Article L521-3",A4="Article R822-1",xg="45064",A2=614,A3="taux_francs_vers_euros",qM=667,xf=3319,i1="abattement_d\xc3\xa9pense_nette_minimale_d832_10",Iy="44593",Ix=3872,ns="mensualit\xc3\xa9_\xc3\xa9ligible",mC="D\xc3\xa9cret n\xc2\xb0 2021-1741 du 22 d\xc3\xa9cembre 2021 portant rel\xc3\xa8vement du salaire minimum de croissance",rB="ENOENT",hj=384,xe=3060,ia=288,kt="0.0006",fR=200,px="EnfantLePlus\xc3\x82g\xc3\xa9",xd=751,A1=841,rA=437,xc=556,A0=885,E8=3404,cr="examples/aides_logement/../prestations_familiales/../smic/smic.catala_fr",mA=1012,mB=389,E7="228000",Iw="ENOTEMPTY",qa="Article 13",AZ="calcul_apl_logement_foyer.nombre_personnes_\xc3\xa0_charge",E6="copropri\xc3\xa9t\xc3\xa9_in",AY="35947",E5="D331_59_8",Iv="Loyer",E4=4061,It=564,Iu=4257,E3="brut_horaire",xb=172,AX=647,E1=4545,E2=1187,xa="Sous-section 1 : Aides personnelles au logement",AV="logement_meubl\xc3\xa9_d842_2",AW=335,Is="calculAidePersonnaliseeLogementAccessionPropriete",w$=547,E0=509,h$="Article D755-5",io=588,im=1223,iF=680,Ir="Article D842-4",a3="Articles en vigueur \xc3\xa0 partir du du 1er octobre 2020 - Arr\xc3\xaat\xc3\xa9 du 25 septembre 2020 relatif au calcul des aides personnelles au logement et de l'aide \xc3\xa0 l'accession sociale et \xc3\xa0 la sortie de l'insalubrit\xc3\xa9 sp\xc3\xa9cifique \xc3\xa0 l'outre-mer NOR : LOGL2020835A",p$="%d",nr=314,w_="Z.of_substring_base: invalid digit",AU=2649,Iq="logement_est_chambre_in",w9=285,EZ="buffer.ml",qL=729,p="Prologue : aides au logement",aa="Secteur accession \xc3\xa0 la propri\xc3\xa9t\xc3\xa9",EY=1434,AS="167600",AT="39590",AR=1799,lu=272,AP=3213,AQ=113,qK=2056,nq=4160,fV=2008,qJ="0.0179",mz=4147,w8=4754,np=681,Ip=3476,EX="245700",ao="Prologue",no=760,ks="calcul_nombre_parts.nombre_personnes_\xc3\xa0_charge",nn=1552,AO="Metropole",de=100,w7=1021,p_=851,i0="prise_en_compte_personne_\xc3\xa0_charge",Z="3",ba="Partie r\xc3\xa9glementaire - D\xc3\xa9crets simples",pw=230,Io="835",nm="169.",EW="plafond_\xc3\xa9quivalence_loyer_\xc3\xa9ligible",rz=478,w6=0.5,In=990,w5=790,cM="Article D521-1",Il="conventionn\xc3\xa9_livre_III_titre_V_chap_III",Im="sous_calcul_traitement",w4=4769,AN="Accord",lt=399,qI="Section III : Allocations de logement",nl=965,il="Article D842-11",dF="Livre 7 : R\xc3\xa9gimes divers - Dispositions diverses",EV=107,nk=4817,my=381,w2=2422,w3=345,mx="Article D842-12",gP="prestations_familiales",iZ="est_enfant_le_plus_\xc3\xa2g\xc3\xa9",EU="26440",cZ="969",w1=649,kr=4152,Ik="201700",nj="Unix.Unix_error",ET=1139,AM="calculAidePersonnaliseeLogement",Ij=553,pv=1948,ES=347,w0="Stack_overflow",eK="condition_2_r823_4",a$="Sous-Section 2 : Conditions d'octroi de l'aide personnalis\xc3\xa9e au logement aux personnes r\xc3\xa9sidant dans un logement-foyer",aT="\xc3\x89ligibilit\xc3\xa9AidesPersonnelleLogement",wZ="850900",AL=4089,Ii=4843,ER="/static/",ni=4418,mw=253,wY=894,gy=368,AK="Not_found",pu="\x01\0\0\0\0\0\xff\xff\0\0\xff\xff\0\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\x009\0<\0\0\0<\0\0\0\0\0A\0\0\0A\0\0\0\0\0F\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff\0\0T\0\0\0\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0^\0\0\0\0\0a\0\xff\xff\xff\xffa\0\xff\xff\xff\xff\xff\xff\xff\xffh\0\0\0\0\0\0\0\0\0m\0\0\0\0\0\0\0q\0\0\0\0\0\0\0u\0\0\0\0\0\0\0y\0\0\0\0\0\0\0\0\0\0\0~\0\0\0\0\0\0\0\xff\xff\0\0\xff\xff\0\0\xff\xff\xff\xff\0\0\xff\xff\0\0\x8a\0\0\0\x8e\0\0\0\0\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\0\0\x9a\0\0\0\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xb2\0\0\0\0\0\0\0\xff\xff\0\0\xff\xff\0\0\xff\xff\xbb\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\xc2\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\xc9\0\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xeb\0\0\0\0\0\0\0\xef\0\0\0\0\0\xff\xff\0\0\xf4\0\0\0\0\0\xff\xff\0\0\xf9\0\0\0\0\0\0\0\xfd\0\0\0\0\0\0\0\xff\xff\0\0\x03\x01\0\0\0\0\0\0\0\0\b\x01\0\0\0\0\0\0\xff\xff\0\0\xff\xff\0\0\0\0\x11\x01\0\0\0\0\0\0\0\0\x16\x01\0\0\0\0\0\0\0\0\0\0\x1c\x01\0\0\0\0\0\0 \x01\0\0\0\0\0\0\xff\xff\0\0&\x01\0\0\0\0\0\0\0\0+\x01\0\0\0\0\0\0/\x01\0\0\0\0\0\0\0\x004\x01\0\0\0\0\0\x008\x01\0\0\0\0\0\0<\x01\0\0\0\0\0\0@\x01\0\0\0\0\0\0C\x01\0\0\0\0\xff\xff\0\0\xff\xff\0\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0y\x01}\x01\0\0\0\0\x80\x01\xff\xff\xff\xff\x80\x01\xff\xff\xff\xff\xff\xff\xff\xff\x87\x01\0\0\0\0\0\0\0\0\x8c\x01\0\0\0\0\xff\xff\0\0\x90\x01\0\0\0\0\xff\xff\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xc1\x01\xc5\x01\0\0\0\0\xc8\x01\xff\xff\xff\xff\xc8\x01\xff\xff\xff\xff\xff\xff\xff\xff\xcf\x01\0\0\0\0\0\0\0\0\xd4\x01\0\0\0\0\xff\xff\0\0\xff\xff\xff\xff\0\0\xff\xff\0\0\xdc\x01\0\0\xff\xff\0\0\xe2\x01\0\0\0\0\0\0\0\0\xff\xff\0\0\xe9\x01\0\0\0\0\0\0\0\0\xff\xff\0\0\xf0\x01\0\0\0\0\0\0\0\0\xf5\x01\0\0\0\0\0\0\xf9\x01\0\0\0\0\0\0\xfc\x01\0\0\0\0\0\0\xff\xff\0\0\x02\x02\x04\x02\0\0\x05\x02\x06\x02\x07\x02\b\x02\t\x02\n\x02\x0b\x02\f\x02\r\x02\x0e\x02\x0f\x02\x10\x02\x11\x02\x12\x02\x13\x02\x14\x02\x15\x02\x16\x02\x17\x02\x18\x02\x19\x02\x1a\x02\x1b\x02\x1c\x02\x1d\x02\x1e\x02\x1f\x02 \x02!\x02\x03\x02",EQ="1085",wX="851",ry="Capitre I : Guadeloupe, Guyane, Martinique, La R\xc3\xa9union et Mayotte",wW="41268",AJ="calcul_apl_logement_foyer.date_courante",bu="examples/allocations_familiales/epilogue.catala_fr",rx=174,ls="Mayotte",bY=848054398,Ih="smic.date_courante",fU="1224",AI="calcul_apl_locatif",Ig=1267,dr="calcul_plafond_mensualit\xc3\xa9_d832_10_3",gw="0.0169",gx=1049,pt="rmdir",AH=696,lr="participation_minimale",EP=2517,mv=3705,If=32752,p9="19100",AG=4399,EO="33623",EN="37478",fu="calcul_nombre_parts",lq="Article R842-5",AF=280,rw="Article 23",fQ=1026,p8=149,AE=2757,bO="montant",dE="Article L521-2",nh="taux_composition_familiale",cn="examples/allocations_familiales/../smic/smic.catala_fr",AD=675,wU="calculAllocationLogementLocatif",wV="false",AC=849,EM="37906",ng="Invalid integer: ",EK="PasDeChangement",EL=4447,cp="\xc3\x89ligibilit\xc3\xa9 \xc3\xa0 la prime de d\xc3\xa9m\xc3\xa9nagement",EJ=2365,g5=106,wT=1417,kq=186,dV=0x80,p7="Fatal error: exception ",eY="Chapitre 1er : Dispositions relatives aux prestations",nf="\xc3\xa9ligibilit\xc3\xa9_commune",p6="0.0234",AB="43378",wS=913,EI="calcul_apl_logement_foyer.date_conventionnement",lo=1038,lp=303,EH="calcul_apl_logement_foyer.logement_foyer_jeunes_travailleurs",Ie="25978",iE=1147,Id="Section 2 : R\xc3\xa8gles de non-cumul",mu=3878,eo="929",g4="zone_in",EG=2610,rv="_",EF="eligibilitePrimeDeDemenagement",qH="compare: functional value",by="0.",gO="1938",wQ="40928",wR="19300",qF=1387,cL="Articles en vigueur \xc3\xa0 partir du 1er juillet 2022 - Arr\xc3\xaat\xc3\xa9 du 29 juillet 2022 relatif au calcul des aides personnelles au logement NOR : TREL2220748A - Arr\xc3\xaat\xc3\xa9 du 16 ao\xc3\xbbt 2022 relatif au calcul des aides personnelles au logement et de l'aide \xc3\xa0 l'accession sociale et \xc3\xa0 la sortie de l'insalubrit\xc3\xa9 sp\xc3\xa9cifique \xc3\xa0 l'outre-mer - NOR : TREL2220744A",qG=114,EE=5476,ED=3423,ne=1030,Ic=721,wP="197700",wO="Invalid_argument",AA=656,Ib=4433,ru="D\xc3\xa9cret n\xc2\xb0 2021-1750 du 21 d\xc3\xa9cembre 2021 portant diverses mesures sur les aides personnelles au logement et relatif aux aides personnelles au logement \xc3\xa0 Saint-Pierre-et-Miquelon",Az="EndCall([ ",EC=823,wN=3185,ln="0.9",EB="calcul_aide_personnalis\xc3\xa9e_logement",mt=3711,kp=249,Ax="34301",Ay="577500",wM="%ni",Aw=1108,ms=4819,nd="calcul_\xc3\xa9quivalence_loyer_minimale.date_courante",EA="Section 3 : Aide personnalis\xc3\xa9e au logement dans les logements-foyers",ko=949,Av=324,wL=4164,p5=238,F=2020,Ia="PersonneSeule",eT="0.0238",mr="Article 47",hi="Article 9",H$="225100",p4=290,H_="AutresPersonnes",aD="6",Ez=4414,Ey="173600",r="0",as="Section 3 : Logements-foyers",kn="1864",km="montant_forfaitaire_charges_d823_16",o="examples/aides_logement/prologue.catala_fr",mq="Article L161-17-2",Au=2410,H9="eligibiliteAidesPersonnelleLogement",wK=4198,bl=248,Ex=4124,H8=322,rt="Sous-section III : Modalit\xc3\xa9s de liquidation et de versement",At=2370,H7=651,f2=2007,H6="208200",wI="Zone1",wJ="R\xc3\xa8glement (CE) n\xc2\xb02866/98 du conseil du 31 d\xc3\xa9cembre 1998 concernant les taux de conversion entre l'euro et les monnaies des \xc3\x89tats membres adoptant l'euro",Eu="Locataire",Ev=301,Ew="37457",mp=396,H5="562800",wH=3768,Et="535744",wG="235800",As=481,g3="0.0299",Es=555,wF=930,Ar="resetLog",V="AllocationsFamiliales",Er="\xc3\xa2ge_l512_3_2",wD="situation_familiale_calcul_apl",wE="GardeAlterneeAllocataireUnique",mo="D\xc3\xa9cret n\xc2\xb0 2022-1608 du 22 d\xc3\xa9cembre 2022 portant rel\xc3\xa8vement du salaire minimum de croissance",Aq="haut",lm=1232,eS=1024,nc=1143,wB="204761",wC="3.1",Ap=726,mn=133,H4="35780",wA="calculAidePersonnaliseeLogementFoyer",gv="0.0217",H2="The function 'limitation_majoration_personnes_a_charge_in' translation isn't yet supported...",H3=567,ll=945,mm=366,eR=0xffffff,H1="34829",Eq=4179,Ao="36378",ik="Titre III: Titre III : Dispositions communes relatives au financement",a0="Calculette globale",ml=492,ps=286,An="149600",Ep=1091,Eo=671,iY="Article R824-1",cU=1994,wz=465,fP=2010,dP="Prologue : prestations familiales",p3=2147483647,H0="774",wy=", characters ",Am=757,qE="180100",hh="BaseMensuelleAllocationsFamiliales",Al="819",En=2192,qD="prestations_familiales.r\xc3\xa9sidence",bk="Chapitre IV : Calcul des allocations de logement en secteur accession",Ak=4038,El=611,Em=".0",HZ="36733",cY="3767",pr="AllocationFamilialesAvril2008",Aj=855,kl="mensualit\xc3\xa9_minimale",iX="2.",Ek=2589,wx=737,eP="5612",ww="Concubins",bI="calcul_plafond_mensualit\xc3\xa9_d842_6_avec_copropri\xc3\xa9t\xc3\xa9",wv="date_entr\xc3\xa9e_logement_in",rs="Montants revaloris\xc3\xa9s de l'allocation de solidarit\xc3\xa9 aux personnes \xc3\xa2g\xc3\xa9es",wu=4875,wt="SaintBarth\xc3\xa9lemy",Ej="Instruction interminist\xc3\xa9rielle N\xc2\xb0 DSS/2B/2023/41 du 24 mars 2023 relative \xc3\xa0 la revalorisation au 1er avril 2023 des prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 la R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et dans le d\xc3\xa9partement de Mayotte",pq=223,X="Partie l\xc3\xa9gislative",gu=2003,bq="examples/allocations_familiales/securite_sociale_D.catala_fr",Ei="32956",fY="Article R823-4",Eh="294500",qC="examples/aides_logement/../prestations_familiales/s\xc3\xa9curit\xc3\xa9_sociale_R.catala_fr",Ai=1035,ft="Montant des plafonds de ressources",br="Annexe",Ah=3913,gN=448,HY=4085,eO="Section 1 : B\xc3\xa9n\xc3\xa9ficiaires",ws=3747,HX="3524",Ef=2244,Eg="Article D832-27",wr=3946,Ag=1101,h_="500",Ee="Zone3",gM=304,wq="40144",dK=2015,nb=3236,dt="calcul_plafond_mensualit\xc3\xa9_d842_6_avec_limitation_dom_tom",eN="prise_en_compte",Ed=5545,hg=1816,Ec=65536,wp=838,Af="223900",Eb=718,Ea=452,rr=138,lk=1998,w="Livre VIII : Aides personnelles au logement",D$="225500",mk="Chapitre II : Saint-Barth\xc3\xa9lemy et Saint-Martin",wo=905,iD="caract\xc3\xa9ristiques_pr\xc3\xaat_l831_1_6",Ae="38892",qB="nan",D_=2461,HW=1430,wn="Article L823-1",Ad=2637,D8="calculNombrePartLogementFoyer",D9=646,iW="Impay\xc3\xa9D\xc3\xa9penseLogement",bX="Calculette avec garde altern\xc3\xa9e",HV=0xdfff,dU="/",mj="4.3",wm=756,D7=1017,HU=2157,mi=951,HT=1823,wl=1427,rq="ENOTDIR",mh=4149,HS=1426,p2="0.0068",D5=1889,D6="\\r",HR=271,Ac=560,dD="Titre VI : Disposition particuli\xc3\xa8res \xc3\xa0 l'outre-mer",lj=154,rp=513,HQ="calcul_allocation_logement",kk="coefficient_prise_en_charge",D3=734,D4=743,HP="1107",ij="Article D161-2-1-9",Ab=674,D2=923,HO=3282,li="Guyane",lg="PasDeTravaux",lh=311,D1=883,qA=255,HN="Revenu",cV="Partie r\xc3\xa9glementaire - D\xc3\xa9crets en Conseil d'Etat",bH="droit_ouvert_majoration",A="Partie r\xc3\xa9glementaire",Aa="coefficient_r_d832_25",D0=3867,HM=3133,wk="Article R861-5",B="D\xc3\xa9clarations des champs d'application",DZ="Chapitre 1er : G\xc3\xa9n\xc3\xa9ralit\xc3\xa9s",pp="est_sup\xc3\xa9rieur",DY="1062600",DX="End_of_file",HK="logement_foyer_jeunes_travailleurs_in",HL="calcul_apl_logement_foyer.condition_2_du_832_25",eJ="Chapitre V : Calcul de l'aide personnalis\xc3\xa9e au logement en secteur logement-foyer",DW="calculAllocationLogementFoyer",iC="traitement_aide_finale_r\xc3\xa9duction_loyer_solidarit\xc3\xa9",hf="Article 24",qz="Failure",HJ="267871",HI="37032",z$="26887",wj=6545,DV="167800",na=906,a6="CalculetteAidesAuLogement",HG=2554,HH="7",DU="nationalit\xc3\xa9",qy="\xff\xff\xff\xff\xff\xff\x11\0\xff\xff\x13\0\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\x07\0\xff\xff\x13\0\x13\0\x13\0\x13\0\x13\0\x13\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\b\0\b\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\t\0\xff\xff\t\0\xff\xff\t\0\xff\xff\xff\xff\x0e\0\xff\xff\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\x01\0\xff\xff\x04\0\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x04\0\x04\0\x04\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\0\0\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\x02\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\x02\0\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\x03\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\x03\0\xff\xff\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x10\0\xff\xff\x12\0\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\x07\0\xff\xff\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\b\0\xff\xff\b\0\xff\xff\b\0\xff\xff\xff\xff\r\0\xff\xff\xff\xff\xff\xff\x01\0\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\t\0\xff\xff\x0b\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\0\0\xff\xff\0\0\xff\xff\xff\xff\x06\0\xff\xff\xff\xff\xff\xff\x01\0\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\x04\0\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",DT=0xdc00,wi="389618",ea="932",m$="3.",HF=438,m_="examples/aides_logement/../prestations_familiales/../smic/../prologue_france/prologue.catala_fr",wh="185800",z_=1072,ro="0.0201",m9=3412,HE="Sys_error",iV=130,fq="Article D521-2",rn="nombre_personnes_\xc3\xa0_charge_prises_en_compte",eI="Sous-section 4 : Assurance vieillesse",z9="Printexc.handle_uncaught_exception",DS=1363,dq="Article D832-24",lf="30500",fO="V\xc3\xa9rification\xc3\x82geInf\xc3\xa9rieurOu\xc3\x89gal\xc3\x80",mg=1079,HD="Chapitre IV : Conditions de peuplement",kj="int_of_string",DQ="194810",DR=3822,wg="Chapitre Ier : Principes g\xc3\xa9n\xc3\xa9raux",gL="Article 37",K="examples/aides_logement/arrete_2019-09-27.catala_fr",wf="39340",mf=3882,DP="name",we=3327,iU=103,le=966,gK=4173,ab="Chapitre 2 : Modalit\xc3\xa9s de liquidation et de versement des allocations de logement",m8=428,wd=525,z8=792,ii="traitement_aide_finale_redevance",gJ=132,z7="1.4",DO=" ])",wc=648,po="31797",z6=2320,me=761,wb="type_travaux_logement_in",DN="19484",m7=4154,DM=988,ki=325,bW="Article 7",DL=": file descriptor already closed",HC="%Li",wa=3963,g2=591,DK=616,fX="Article L861-6",v$=302,pn="r\xc3\xa9muneration_mensuelle",iB=960,ce="Article 14",DJ="34570",HB=4790,qx="date_de_naissance",z5=795,DI="base_mensuelle_allocations_familiales",cT="Articles en vigueur \xc3\xa0 partir du 1er janvier 2022 - Arr\xc3\xaat\xc3\xa9 du 20 d\xc3\xa9cembre 2021 relatif au calcul des aides personnelles au logement pour l'ann\xc3\xa9e 2022 NOR : LOGL2134477A",v_=2162,md="_z",he=2000,rm=1951,HA=3188,ld="Arr\xc3\xaat\xc3\xa9 du 29 juillet 2022 relatif au rel\xc3\xa8vement du salaire minimum de croissance",mc=762,Hy=4042,Hz=738,z4=1784,Hx=2220,z3=4001,bR="Titre IV : Allocations de logement",lc=475,DH=2178,lb=959,cg="3640",dY="InterfaceAllocationsFamiliales",DG="retrieveRawEvents",rl=227,Hw=4787,m6="examples/allocations_familiales/../smic/../prologue_france/prologue.catala_fr",h9="Pendant",pm="%a",z2=2266,ci="936",fp=", ",eH="5422",gt=199,cI=2018,z1="17012",la="calcul_\xc3\xa9quivalence_loyer_minimale.condition_2_du_832_25",Hv=3719,v9=4753,hd="0.0194",Hu=710,bB="Chapitre III : Calcul des aides personnelles au logement en secteur locatif",kh=682,dC="Prestations familiales",zZ="Enfant\xc3\x80Charge",z0="calculette",ek="Article D823-16",zY="172500",zX=1109,gI="Article D861-8",Ht="ann\xc3\xa9es_in",rk=754,rj="n_nombre_parts_d832_25",g1=3234,DF=2047,ri="Apres",mb=1032,kg=4156,v8="logement_est_chambre",dJ="examples/aides_logement/../prestations_familiales/prologue.catala_fr",Hs=408,zW="179800",eX=" ",v7=361,zU=1359,aQ="Secteur locatif",zV="Undefined_recursive_module",Y="output",DE="195500",pl=884,qw="199900",ch=-976970511,v5="' kind for the enumeration 'SituationObligationScolaire.t'",v6="%.16g",zT="220100",rh=189,h8="droit_ouvert_forfaitaire",k$=1225,DC=1813,DD="%i",v4="0.01",zS=742,DB=1732,zR="262985",DA="916300",k_=507,Dz="409505",Hr=4306,v3="LogementFoyer",v2="1152",zQ="139700",zP=629,p1="Article L822-4",Hq=1840,Dx=419,Dy="41252",ma=369,Hp=506,zO="0.1",hc=382,eG="5399",qv="2805",d1=123,zN=4667,g0=152,zL=650,zM=3169,Dw="calcul_apl_logement_foyer.type_logement_foyer",Ho=3329,gs="0.0173",J="Arr\xc3\xaat\xc3\xa9 du 27 septembre 2019 relatif au calcul des aides personnelles au logement et de la prime de d\xc3\xa9m\xc3\xa9nagement",Hn=1573,zK=3510,Dv=159,v1="LocationAccession",zJ=1067,zI=183,pk="a_d\xc3\xa9j\xc3\xa0_ouvert_droit_aux_allocations_familiales",Du=3752,Hm="41338",dp=0xff,hb="0.018",kf="Arr\xc3\xaat\xc3\xa9 du 19 avril 2022 relatif au rel\xc3\xa8vement du salaire minimum de croissance",zH=-12,Hl=4640,l_="calcul_\xc3\xa9quivalence_loyer_minimale.ressources_m\xc3\xa9nage_arrondies",l$=4167,Hk=4950,fb="Article 15",cX="0.75",Dt=191,iA="Titre 5 : Dispositions particuli\xc3\xa8res \xc3\xa0 la Guadeloupe, \xc3\xa0 la Guyane, \xc3\xa0 la Martinique, \xc3\xa0 La R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy et \xc3\xa0 Saint-Martin",Hj="22355",cG="Articles en vigueur \xc3\xa0 partir du 1er janvier 2020 - Arr\xc3\xaat\xc3\xa9 du 3 janvier 2020 relatif au calcul des aides personnelles au logement pour l'ann\xc3\xa9e 2020 NOR : LOGL1934006A",l9=3654863,zG="140800",Hi=436,rg=145,rf="Chapitre 5 : Allocation de solidarit\xc3\xa9 aux personnes \xc3\xa2g\xc3\xa9es",zF=1997,Ds="163000",Hh=991,ke="Chapitre III : Saint-Pierre-et-Miquelon",h7="0.5",Hg="Article R842-14",v0="fd ",Dr=1116,Dq="41751",Dp="181800",vZ="41316",bG="traitement_aide_finale_contributions_sociales_arrondi",Do="\xc3\xa9quivalence_loyer_\xc3\xa9ligible",vY=993,gZ="0.0162",Dn="cat\xc3\xa9gorie_calcul_apl",Dm="757",iT="coefficents_enfants_garde_altern\xc3\xa9e_pris_en_compte",gY=1081,p0=1651,fa=2001,re="Article D863-7",m5=4175,vX=922,zE="b\xc3\xa9n\xc3\xa9ficiaire_aide_adulte_ou_enfant_handicap\xc3\xa9s",Hf="smic.r\xc3\xa9sidence",e$=489,ax="Livre 5 : Prestations familiales et prestations assimil\xc3\xa9es",bt="Article D842-1",zD="Article D832-18",Dl=108,kd=-2147483648,y="1",Dk="Article R844-4",en=2002,He=890,zC="42605",vV="VendeurQuandDemandeurAContratLocationAccession",vW="Article R755-0-2",zB="calculNombrePartsAccessionPropriete",pZ=": Not a directory",l8=1227,Hd="allocationFamilialesAvril2008",vU="b",vT=3896,zA="18900",Dj=1609,Hc="Article D521-3",Dh=1295,Di=4265,cK="CalculAidePersonnalis\xc3\xa9eLogement",vS="D331_63_64",dB=2012,aW="Articles en vigueur \xc3\xa0 partir du 1er octobre 2021 - Arr\xc3\xaat\xc3\xa9 du 23 septembre 2021 relatif au calcul des aides personnelles au logement et de l'aide \xc3\xa0 l'accession sociale et \xc3\xa0 la sortie de l'insalubrit\xc3\xa9 sp\xc3\xa9cifique \xc3\xa0 l'outre-mer NOR : LOGL2123452A",zy=3940,zz="Out_of_memory",Hb="42469",_="4",z="examples/aides_logement/code_construction_reglementaire.catala_fr",Ha=": closedir failed",rd="index out of bounds",k9=1182,Dg=986,fs="Chapitre IX : Calcul des allocations de logement en outre-mer",zx="27900",G_=668,G$=903,m4="_bigarr02",Df="32910",vR="31264",De=3003,pj=895,G9="LaR\xc3\xa9union",pY=1746,k8="981600",Dd=574,l7=1151,d$=0xffff,gH=2009,G8="%.17g",kc=400,Dc=1454,l6="calcul_\xc3\xa9quivalence_loyer_minimale.n_nombre_parts_d832_25",db="100.",zw="1.25",ac="input0",Db=3990,vQ="44729",em="\xc3\xa2ge_minimum_alin\xc3\xa9a_1_l521_3",fN=963043957,I="5",l5=142,G7=741,zv=3658,G6="AllocationSoutienFamilial",gr=840,zu="SousLocataire",G5=207,C$=735,Da="34713",C_=416,be="Section 1 : Calcul, liquidation et versement des aides",G4=2382,e_="Article L512-3",C9="0.98",rc=1626,vP=4035,pX=917,C8="633129",vO="41440",zt=899,da="\xc3\x89ligibilit\xc3\xa9PrimeDeD\xc3\xa9m\xc3\xa9nagement",c$="Sous-section 2 : Calcul de l'aide en secteur locatif",kb=252,zs="enfant_le_plus_\xc3\xa2g\xc3\xa9",az="examples/allocations_familiales/prologue.catala_fr",aq="CalculAidePersonnalis\xc3\xa9eLogementFoyer",ej=".",zr=0xf0,G3=1730,vN="eligibilitePrestationsFamiliales",cH="12.",l4="Guadeloupe",iS=1168,pi=276,C7=2288,k7="230500",fi="1872",qu=116,vM="enfantLePlusAge",zq=576,zp=365,C6=627,zo=1007,eW="traitement_aide_finale_montant_minimal",m3=294,vL="impossible case",G2=1073,dO="examples/allocations_familiales/securite_sociale_R.catala_fr",vK=3119,zn=4116,C5=4896,zm=3232,eM="R\xc3\xa8gles diverses",G1=3299,zl=-1080,C4="26329",G0="18185",C3="closedir",vI=1098,vJ="SaintBarthelemy",C2="calcul_nombre_parts.date_courante",GY=-1023,GZ=3801,zk="type_logement_foyer_in",pW=221,vH="ressources_m\xc3\xa9nage_avec_arrondi",fW="1272",GW="ouvertureDroitsRetraite",GX="\xc3\xa9ligibilit\xc3\xa9_aide_personnalis\xc3\xa9e_logement",zi="883400",zj="204700",pV="Article L755-12",cW="traitement_aide_finale_mont\xc3\xa9e_en_charge_saint_pierre_miquelon",vG="TravauxPourAcquisitionD832_15_1",zh="Ancien",GV=2584,pU="lib/read.mll",C1=853,fT="1229",GU="Article premier",k6=4423,b4="\xc3\x89ligibilit\xc3\xa9 \xc3\xa0 l'aide personnalis\xc3\xa9e au logement",k5=476,ka='"',GS="Arr\xc3\xaat\xc3\xa9 du 14 d\xc3\xa9cembre 2020 relatif au montant des plafonds de ressources de certaines prestations familiales et aux tranches du bar\xc3\xa8me applicable au recouvrement des indus et \xc3\xa0 la saisie des prestations",GT=1022,h6="examples/aides_logement/../prestations_familiales/s\xc3\xa9curit\xc3\xa9_sociale_L.catala_fr",cF="CalculAllocationLogement",zg=170,zf=477,C0=2599,GR="3539",rb="<",ph=931,CY="208500",l3=4419,qt="prestations_familiales.date_courante",CZ=0x800,k4=3409,ze=331,CW=2143,CX=6513,iQ="\xc3\xa9ligibilit\xc3\xa9",iR=327,vF=0.012,zd=2201,CV="233000",GQ=4481,CU="calculAidePersonnaliseeLogementLocatif",bP="Article 33",gq=156,GP="M\xc3\xa9tropole",k3=1044,vE=842,zc="40696",GO=209,pT="Article D815-1",gG="conditions_hors_\xc3\xa2ge",vC=3810,vD=997,eg="traitement_aide_finale_abattement",pS=727,bg="Dispositions sp\xc3\xa9ciales relatives \xc3\xa0 Mayotte",vA=726928360,vB=562,CT="221100",vz="([^/]+)",m2="plafond_loyer_d823_16_2",za="697700",zb="Article 39",CS=1764,ra=0xf,vy="798",y$="BailleurSocial",h5="montant_initial_m\xc3\xa9tropole_majoration",ef=125,l2=490,y_=658,y9=907,iP="ressources_m\xc3\xa9nage_arrondies_in",l1=3876,CR="Division_by_zero",GM=736,GN=3138,m1=4171,pg="Article L832-3",y8=4216,vx=708012133,GL="SituationObligationScolaire",h4=1180,y7=4076,y6="AutrePersonne\xc3\x80Charge",GK="44440",dn=2014,GI=4195,GJ=1059,y5="22262",CQ=552,y4="Article D842-17",k2=380,fo="date_courante_in",el="5.",vw=1208,GH="Article L751-1",f1=119,iz="montant_avec_garde_altern\xc3\xa9e_majoration",GG="70",vu="calculette_sans_garde_altern\xc3\xa9e",vv="Instruction interminist\xc3\xa9rielle n\xc2\xb0DSS/2B/2022/82 du 28 mars 2022 relative \xc3\xa0 la revalorisation au 1er avril 2022 des prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 la R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et dans le d\xc3\xa9partement de Mayotte",y3=321,CP="version_avril_2008",q$=279,vt="38361",GF=439,eF=2013,y2="ouverture_droits_retraite",k1=102,vs="mensualit\xc3\xa9_principale_in",pf=340,y1=1923,j$=722,GE="997500",gp="100000.",q_=1420,vr="18261",fn=101,m0="calcul_nombre_parts.situation_familiale_calcul_apl",k0="participation_personnelle",y0="body",GD=1164,go="Calcul des contributions sociales s'appliquant aux aides personnelles au logement",vq="Unexpected '%s' kind for the enumeration 'Collectivite.t'",CO=3093,fS=1e7,q9="\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x03\0\x04\0\0\0\x03\0\x03\0\x86\0\0\0\x03\0\0\0\x86\0E\x01\x92\x01\xff\xff\0\0E\x01\x92\x01\0\0\0\0\0\0\0\0\x7f\0\x8b\0\0\0\x03\0\0\0\f\0\x03\0\xaa\0\x86\0\xaf\0\0\0\x07\0\x0b\x01E\x01\x92\x01\x0e\x01\r\x001\0\x05\0\n\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\x008\0v\0\x06\0\x81\0\x82\x009\0\xed\x01\x89\0\0\x021\0\0\x000\0\x8a\0j\0>\0\x0e\0n\0i\0\0\x001\0\x0f\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x1e\x000\0\b\0r\0\xd1\0\xec\0\0\x01\r\x01\x1d\0\x16\0\xff\xff0\x000\0\x11\0\x15\0\x19\0 \0!\0#\0\x17\0\x1b\0\x10\0\x1f\0\x1c\0\"\0\x13\0\x18\0\x12\0\x1a\0\x14\0$\0)\0%\x000\0\t\0*\0+\0,\0-\0.\0/\0=\0U\x000\0&\0'\0'\0'\0'\0'\0'\0'\0'\0'\x001\0C\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0V\0\x8f\0\xff\xff(\0\x90\0\x91\0\x92\x007\0\x94\x007\0\x95\x000\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\0\xff\xff0\0\x96\0\x97\0\xa1\0B\0\x9e\x005\0\x9f\x005\0\xa0\x003\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\0\xa5\x003\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\0\xa2\0\xa3\0\xa6\0]\0\xff\xff\x02\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\0\xff\xffM\0g\0l\0t\0\x84\0\x86\0\x87\0\x80\0\x8b\0\x86\0\xa4\0]\0\xab\0M\0\xa7\0\xa8\0\xa9\0\xac\0p\0\xad\0\xae\0\xd2\0\xe2\0\xd0\0\xd3\0\xd4\0;\0S\0\x86\0\xd5\0\xd6\0\xd7\0\xd8\0\xda\0\x8d\0\xdb\0]\0\xdc\0\xdd\0{\0\xde\0\xdf\0\xe0\0\x88\0_\0\xe1\0#\x01A\x01\xea\0\x9b\0\x05\x01a\x01\xfa\0\xff\xff\xfe\x009\x01=\x01_\x01M\0,\x01\\\x01X\x01\t\x01\x1d\x01L\0|\0!\x01\x12\x01K\0b\0\x13\x01U\x01V\x01W\x01x\x01Y\x01J\0\xe1\x005\x01y\x01I\0Z\x01H\0G\0N\0N\0N\0N\0N\0N\0N\0N\0N\0N\0b\0q\x01z\0[\x01@\0\x04\x01]\x01N\0N\0N\0N\0N\0N\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0\x9c\0p\x01^\x01`\x01b\x01c\x011\x01O\0O\0O\0O\0O\0O\0d\x01\x9d\0e\x01N\0N\0N\0N\0N\0N\0\xb7\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\x18\x01p\x01\xff\xff\x19\x01f\x01g\x01i\x01O\0O\0O\0O\0O\0O\0P\0P\0P\0P\0P\0P\0P\0P\0P\0P\0j\x01k\x010\x01(\x01l\x01m\x01n\x01P\0P\0P\0P\0P\0P\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0Q\0o\x01\x1b\x01\xff\xff\xab\x01\x1f\x01\xaa\x01\x17\x01Q\0Q\0Q\0Q\0Q\0Q\0\\\0\xa8\x01?\x01P\0P\0P\0P\0P\0P\0\xf8\0\xa5\x01\xfc\0\xa2\x01;\x01E\0W\0W\0W\0W\0W\0W\0W\0W\0W\0W\0\xff\xffQ\0Q\0Q\0Q\0Q\0Q\0W\0W\0W\0W\0W\0W\0X\0X\0X\0X\0X\0X\0X\0X\0X\0X\0'\x01*\x01\xff\xff\xa3\x01\xa4\x01x\0\x02\x01X\0X\0X\0X\0X\0X\0\xa6\x017\x01\x99\0W\0W\0W\0W\0W\0W\0\x07\x01\xa7\x01\xa4\x01\xa9\x01\x10\x01\xa4\x01Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\0Y\x003\x01X\0X\0X\0X\0X\0X\0Y\0Y\0Y\0Y\0Y\0Y\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0Z\0a\0\x89\x01\xa4\x01\xac\x01\xb9\x01\x88\x01\xad\x01Z\0Z\0Z\0Z\0Z\0Z\0a\0\xb3\0\xae\x01Y\0Y\0Y\0Y\0Y\0Y\0.\x01\xaf\x01\xb0\x01\xb4\0\xa4\x01\xb8\x01\xb5\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0|\x01Z\0Z\0Z\0Z\0Z\0Z\0\xc0\x01\xb2\x01\x15\x01\xb3\x01a\0\xc1\x01\xb4\x01\xb5\x01\xb6\x01\xb7\x01\xa4\x01\xd8\x01\xff\xffa\0\xb8\x01\xd8\x01\xd1\x01a\0\xdf\x01a\0\xd0\x01\xe6\x01\x03\x02a\0\xdb\x01%\x01\xd8\x01\xd9\x01\x03\x02\xdc\x01\xd8\x01a\0\x03\x02\x03\x02\xd8\x01a\0\x03\x02a\0`\0c\0c\0c\0c\0c\0c\0c\0c\0c\0c\0\xd8\x01\x03\x02~\x01\x03\x02\x03\x02\x03\x02\x03\x02c\0c\0c\0c\0c\0c\0a\0\x03\x02\xda\x01\xfa\x01\x03\x02\x03\x02a\0\x03\x02|\x01|\x01a\0\x03\x02\xdd\x01\x03\x02\xfd\x01\x03\x02\x03\x02\x03\x02a\0\xff\xff\x03\x02\xc4\x01a\0\x03\x02a\0`\0c\0c\0c\0c\0c\0c\0d\0d\0d\0d\0d\0d\0d\0d\0d\0d\0\xeb\x01\x03\x02\xf1\x01\x03\x02\xff\x01\xf2\x01\x03\x02d\0d\0d\0d\0d\0d\0e\0e\0e\0e\0e\0e\0e\0e\0e\0e\0\xf6\x01\x81\x01\x81\x01\xe4\x01\x03\x02\xc4\x01\x03\x02e\0e\0e\0e\0e\0e\0\x03\x02\xc6\x01\x03\x02d\0d\0d\0d\0d\0d\0\x03\x02\x03\x02\x03\x02\xc4\x01\xea\x01\x86\x01a\0a\0a\0a\0a\0a\0a\0a\0a\0a\0\0\0e\0e\0e\0e\0e\0e\0a\0a\0a\0a\0a\0a\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\xb6\0\0\0\0\0\xc9\x01\xb1\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xb8\0\xbc\0\0\0a\0a\0a\0a\0a\0a\0\xc9\x01\xe3\x01\0\0\xbf\0\xce\x01{\x01\xbd\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbd\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xbe\0\xc3\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc6\0\xff\xff\xf8\x01\xc4\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc4\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xc5\0\xca\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xcd\0\xff\xff\xff\xff\xcb\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xe2\0\xc3\x01\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xe8\x01\0\0\0\0\xce\0\xdd\x01\xef\x01\xfe\x01\0\0\xcf\0\xf4\x01\0\0\xe1\0\xcb\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xcc\0\xe8\0\0\0\xe8\0\0\0\xe1\x01\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xd9\0\xff\xff\0\0\0\0\0\0\0\0\xe1\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\xe3\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\xe6\0\0\0\xe6\0\0\0\xe4\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\xe5\0\0\0\xe4\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xba\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\xe7\0\0\0\0\0\0\0\0\0\0\0\xf1\0\0\0q\x01\0\0M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01\0\0p\x01\0\0\0\0\xc1\0\0\0\0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0p\x01\0\0\0\0\0\0\xf0\0\xc8\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\0\0\xf6\0\0\0\0\0\xf0\0\0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf0\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\0\0\0\0\0\0\0\0\xf5\0\0\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xee\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\0\0\0\0\0\0\0\0\xf5\0\0\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0\xf5\0E\x01F\x01\0\0\0\0E\x01L\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0E\x01\0\0N\x01\0\0\0\0\0\0\0\0h\x01I\x01\0\0\0\0\0\0\0\0O\x01\0\0G\x01L\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01M\x01\0\0\0\0H\x01\0\0\0\0\0\0\0\0\0\0\xf3\0\0\0\0\0\0\0\0\0\0\0\0\0P\x01w\x01\0\0w\x01\0\0Q\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01\0\0\0\0J\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01r\x01S\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0R\x01\0\0\0\0s\x01\0\0\0\0T\x01\0\0\0\0u\x01\0\0u\x01\0\0K\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01\0\0s\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01t\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01v\x01\0\0\x80\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\0\0\0\0\x80\x01\0\0\0\0\0\0\x80\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\0\0\0\0\0\0\0\0\0\0\0\0\x80\x01\0\0\0\0\xb9\x01\0\0\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\0\0\0\0\0\0\0\0\0\0\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\x82\x01\xb8\x01\0\0\x80\x01\0\0\0\0\0\0\0\0\0\0\x80\x01\0\0\0\0\0\0\x80\x01\0\0\0\0\0\0\0\0\0\0\0\0\x80\x01\x80\x01\0\0\0\0D\x01\x80\x01\x80\x01\x80\x01\x7f\x01\0\0\x80\x01\0\0\0\0\xb8\x01\0\0\0\0\0\0\0\0\x80\x01\0\0\0\0\0\0\x80\x01\0\0\x80\x01\x7f\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\0\0\0\0\0\0\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\x83\x01\0\0\0\0\0\0\0\0\0\0\0\0\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\0\0\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x84\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\xbf\x01\x8e\x01\xbf\x01\0\0\0\0\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\0\0\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x80\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\0\0\0\0\0\0\0\0\x8d\x01\0\0\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\0\0\0\0\0\0\0\0\x8d\x01\0\0\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x8d\x01\x92\x01\x93\x01\0\0\0\0\x92\x01\x9a\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xc8\x01\x92\x01\0\0\x99\x01\0\0\0\0\0\0\0\0\xb1\x01\x96\x01\0\0\0\0\0\0\xc8\x01\x9c\x01\0\0\x94\x01\x9a\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\x9b\x01\0\0\0\0\x95\x01\0\0\0\0\0\0\0\0\0\0\0\0\x8b\x01\0\0\0\0\0\0\0\0\0\0\x9d\x01\0\0\0\0\0\0\0\0\x9e\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xba\x01\xc8\x01\0\0\x97\x01\0\0\0\0\0\0\xc8\x01\0\0\0\0\0\0\xc8\x01\xbb\x01\0\0\xa0\x01\0\0\0\0\0\0\0\0\xc8\x01\0\0\0\0\x9f\x01\xc8\x01\0\0\xc8\x01\xc7\x01\0\0\xa1\x01\0\0\0\0\0\0\0\0\0\0\0\0\x98\x01\0\0\0\0\0\0\0\0\xbd\x01\0\0\xbd\x01\0\0\xbb\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbc\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xbe\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xc8\x01\0\0\0\0\0\0\0\0\0\0\0\0\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xc8\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\xca\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xc8\x01\0\0\0\0\0\0\0\0\x91\x01\xc8\x01\0\0\0\0\0\0\xc8\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xc8\x01\0\0\0\0\0\0\xc8\x01\0\0\xc8\x01\xc7\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\0\0\0\0\0\0\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\xcb\x01\0\0\0\0\0\0\0\0\0\0\0\0\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\0\0\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xcc\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\0\0\xd6\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xc8\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\0\0\0\0\0\0\0\0\xd5\x01\0\0\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\0\0\0\0\0\0\0\0\xd5\x01\0\0\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\xd5\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xd3\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",iy=254,GC="calcul_apl_logement_foyer.zone",vp=407,bf="6.",vo="1003",pe=3564,d_="Article L841-2",q8=" : flags Open_text and Open_binary are not compatible",vn=902,fm="Article D832-15",yZ=164,CN="43248",eQ="Titre VI : Dispositions relatives aux prestations et aux soins - Contr\xc3\xb4le m\xc3\xa9dical - Tutelle aux prestations sociales",fg=1992,fh="examples/aides_logement/../base_mensuelle_allocations_familiales/bmaf.catala_fr",yY=4564,vm="\\\\",GB=584,kZ=1219,v="Code de la construction et de l'habitation",CL=1489,CM="Instruction interministerielle no DSS/SD2B/2019/261 du 18 d\xc3\xa9cembre 2019 relative \xc3\xa0 la revalorisation au 1er janvier 2020 des plafonds de ressources d\xe2\x80\x99attribution de certaines prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 La R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et \xc3\xa0 Mayotte",GA="Article 38",vl=2297,mZ=1045,yX="0.04",mY=160,CK="0.0226",qs=270,vk="192500",pd="Article D862-7",Gz="230700",yW="0.0463",CJ="217600",l0=1145,CI="GardeAlterneePartageAllocations",h3="contributions_sociales.lieu",qr="\0\0\xec\xff\xed\xff\x03\0\xef\xff\x10\0\xf2\xff\xf3\xff\xf4\xff\xf5\xff\0\0\x1f\0\xf9\xffU\0\x01\0\0\0\0\0\x01\0\0\0\x01\0\x02\0\xff\xff\0\0\0\0\x03\0\xfe\xff\x01\0\x04\0\xfd\xff\x0b\0\xfc\xff\x03\0\x01\0\x03\0\x02\0\x03\0\0\0\xfb\xff\x15\0a\0\n\0\x16\0\x14\0\x10\0\x16\0\f\0\b\0\xfa\xffw\0\x81\0\x8b\0\xa1\0\xab\0\xb5\0\xc1\0\xd1\0\xf0\xff\x0b\0&\0\xfc\xffA\0\xfe\xff\xff\xffn\0\xfc\xff\xa3\0\xfe\xff\xff\xff\xea\0\xf7\xff\xf8\xff0\x01\xfa\xff\xfb\xff\xfc\xff\xfd\xff\xfe\xff\xff\xffG\x01~\x01\x95\x01\xf9\xff'\0\xfd\xff\xfe\xff&\0\xbb\x01\xd2\x01\xf8\x01\x0f\x02\xff\xff\xdc\0\xfd\xff\xff\xff\xf5\0'\x02m\x02\x0e\x01X\x02\xa4\x02\xbb\x02\xe1\x02\r\0\xfc\xff\xfd\xff\xfe\xff\xff\xff\x0e\0\xfd\xff\xfe\xff\xff\xff\x1e\0\xfd\xff\xfe\xff\xff\xff\x0f\0\xfd\xff\xfe\xff\xff\xff\x11\x01\xfb\xff\xfc\xff\xfd\xff\xfe\xff\xff\xff\x13\0\xfc\xff\xfd\xff\xfe\xff\x0f\0\xff\xff\x10\0\xff\xff\b\x01\x05\0\xfd\xff\x17\0\xfe\xff\x14\0\xff\xff.\0\xfd\xff\xfe\xff*\x004\x005\0\xff\xff5\x000\0[\0\\\0\xff\xff\x1b\x01\xfa\xff\xfb\xff\x89\0h\0Y\0X\0j\0\xff\xff\x8f\0\x89\0\xb1\0\xfe\xff\xb7\0\xa8\0\xa6\0\xb7\0\x02\0\xfd\xff\xb1\0\xac\0\xbb\0\x04\0\xfc\xff5\x02\xfb\xff\xfc\xff\xfd\xffg\x01\xff\xff\xf8\x02\xfe\xff\x06\x03\x1e\x03\xfc\xff\xfd\xff\xfe\xff\xff\xff(\x032\x03J\x03\xfc\xff\xfd\xff\xfe\xff\xff\xff=\x03T\x03l\x03\xf9\xff\xfa\xff\xfb\xff\xf4\0x\x03\x8e\x03\xb3\0\xc2\0\x0f\0\xff\xff\xbe\0\xbc\0\xbb\0\xc1\0\xb7\0\xb3\0\xfe\xff\xbf\0\xc9\0\xc8\0\xc4\0\xcb\0\xc1\0\xbd\0\xfd\xff\x9d\x03_\x03\xae\x03\xc4\x03\xce\x03\xd8\x03\xe4\x03\xef\x03<\0\xfd\xff\xfe\xff\xff\xff\f\x04\xfc\xff\xfd\xffW\x04\xff\xff\x91\x04\xfc\xff\xfd\xff\xdd\x04\xff\xff\xe5\0\xfd\xff\xfe\xff\xff\xff\xe7\0\xfd\xff\xfe\xff\xff\xff\x02\0\xff\xff\x12\x01\xfc\xff\xfd\xff\xfe\xff\xff\xff\"\x01\xfd\xff\xfe\xff\xff\xff\0\0\xff\xff\x03\0\xfe\xff\xff\xff&\x01\xfc\xff\xfd\xff\xfe\xff\xff\xffx\x01\xfb\xff\xfc\xff\xfd\xff\xfe\xff\xff\xff\xd0\0\xfd\xff\xfe\xff\xff\xff\xd3\0\xfd\xff\xfe\xff\xff\xff\xbd\0\xff\xff\x8f\x01\xfc\xff\xfd\xff\xfe\xff\xff\xff\r\x01\xfd\xff\xfe\xff\xff\xff_\x01\xfc\xff\xfd\xff\xfe\xff\xff\xff2\x01\xfd\xff\xfe\xff\xff\xff\x1a\x01\xfd\xff\xfe\xff\xff\xff\xe9\0\xfd\xff\xfe\xff\xff\xff\xde\0\xfd\xff\xfe\xff\xff\xffO\x05\xed\xff\xee\xff\n\0\xf0\xff,\x01\xf3\xff\xf4\xff\xf5\xff\xf6\xff=\x01\x02\x04\xf9\xff-\x05\xd1\0\xe4\0\xd3\0\xe8\0\xe1\0\xdf\0\xf0\0\xff\xff\xeb\0\xea\0\b\x01\xfe\xff\x04\x01\x17\x01\xfd\xff6\x01\xfc\xff\x1f\x01\x1d\x01 \x01'\x011\x01-\x01\xfb\xff9\x01R\x01P\x01N\x01T\x01J\x01V\x01\xfa\xffn\x05\f\x04{\x05\x9b\x05\xa5\x05\xb1\x05\xbb\x05\xc5\x05\xf1\xff\xc7\x01M\x02\xfd\xff\xff\xff\x9a\x02\xde\x05\xd1\x05\x9b\x02\xef\x055\x06L\x06r\x06\x10\x02\xfc\xff\xfd\xff\xfe\xff\xff\xff\x98\x06\xfc\xff\xfd\xff\xe3\x06\xff\xffU\x07\xf4\xff\xf5\xff\x0b\0\xf7\xffL\x02\xfa\xff\xfb\xff\xfc\xff\xfd\xff\xfe\xff\x1f\x02\xf3\x053\x07d\x01s\x01h\x01\x85\x01v\x01\x9a\x01\xab\x01\xff\xff\xad\x01\xb0\x01\xbf\x01\xb9\x01\xbb\x01\xfd\x01\xe6\x01\xe6\x01\xea\x01\xf7\x01\xed\x01\xea\x01\t\x02\x13\x02\x13\x02\x0f\x02\x15\x02\x0b\x02\x07\x02\x8e\x06\x98\x06t\x07\xaa\x07\xb4\x07\xbe\x07\xc8\x07\xd2\x07\xf8\xffx\x02\xa7\x02\xfd\xff\xff\xff\xd8\x02R\x07\xdc\x07\xec\x02\xf4\x07:\bQ\bw\bL\x02\xfc\xff\xfd\xff\xfe\xff\xff\xff\x9d\b\xfc\xff\xfd\xff\xe8\b\xff\xff\x87\x02x\x02\xfd\xffd\x02\xfe\xff\xb6\x02\xff\xff\x0b\x02\xff\xff\xcc\x02\xfc\xff\xfd\xff\xfe\xff\xff\xff.\x02\xff\xff\xb2\x02\xfc\xff\xfd\xff\xfe\xff\xff\xff\x17\0\xff\xff\xb7\x02\xfc\xff\xfd\xff\xfe\xff\xff\xff\xbb\x02\xfd\xff\xfe\xff\xff\xffy\x02\xfd\xff\xfe\xff\xff\xff\xb8\x02\xfc\xff\xfd\xff\xfe\xff\x13\0\xff\xff\x8c\x01\x92\x01\xff\xff\x96\x01\x97\x01\x9a\x01\xa8\x01\xaa\x01\xab\x01\xac\x01\xad\x01\xb5\x01\xb8\x01\xb9\x01\xbb\x01\xbf\x01\xc1\x01\xc3\x01\xc4\x01\xc5\x01\xc8\x01\xcb\x01\xdf\x01\xe1\x01\xe4\x01\xf9\x01\xfb\x01\x02\x02\x04\x02\x0b\x02\f\x02\r\x02\0\0",mX="0.55",yV=2534,bE="droit_ouvert",aB="Champs d'applications",Gy=109,Gw=669,Gx=995,j_=3880,bm="ContributionsSocialesAidesPersonnelleLogement",gF="Article D832-10",b9="Interface du programme",at="Calcul de l'aide au logement effective",qq=-97,N="examples/aides_logement/archives.catala_fr",d0="V\xc3\xa9rification\xc3\x82geSup\xc3\xa9rieur\xc3\x80",Gv=3517,yU=3470,kY=953,CH=2572,CG=281,pc="Article D823-20",vj="ServicesSociauxAllocationVerseeAuxServicesSociaux",ih="d\xc3\xa9pense_nette_minimale_d832_27",kX=195,CF="218700",Gu=2486,dy="1.",vi=3186,yT=3454,vh=2372,gE=1040,vg="45200",dd="d\xc3\xa9pense_nette_minimale",fM=445,CD=728,CE=844,mW="Arr\xc3\xaat\xc3\xa9 du 26 avril 2023 relatif au rel\xc3\xa8vement du salaire minimum de croissance",pb="Titre I : Allocations aux personnes \xc3\xa2g\xc3\xa9es",ix="Livre I : G\xc3\xa9n\xc3\xa9ralit\xc3\xa9s - Dispositions communes \xc3\xa0 tout ou partie des r\xc3\xa9gimes de base",CC=2204,CB=3919,vf=1350,iw=388,mV="Article D823-17",yS="Instruction minist\xc3\xa9rielle N\xc2\xb0DSS/SD2B/2019/65 du 25 mars 2019 relative \xc3\xa0 la revalorisation au 1er avril 2019 des prestations familiales servies en m\xc3\xa9tropole",Gs=3883,Gt=546,ve=4617,ei="3614",Cz="5186",CA="Unexpected '%s' kind for the enumeration 'SituationObligationScolaire.t'",yR="calcul_apl_logement_foyer.situation_familiale_calcul_apl",lZ=1065,vd="142303",pa=316,Cy="37778",Gr=569,Gq=4094,q7=215,eE="Article D832-11",vc="5390",kW=947,Cw=201,Cx="LaReunion",Cv=1412,va="16941",vb="multiplicateur_majoration_charges",aY="Montant du salaire minimum de croissance",Gp="AgrandirOuRendreHabitableD331_63",Cu=557,fr="Section 4 : Allocations de logement",u$=2311,o$="0.3",u_="true",Ct=2687,b7="Chapitre II : Conditions g\xc3\xa9n\xc3\xa9rales d'attribution",Cr=2520,Cs=2395,ha=426,ak="Titre II : Dispositions communes aux aides personnelles au logement",j9=4809,kV=4425,Go="25116",j8="Paragraphe 1 : Information et simplification des d\xc3\xa9marches des assur\xc3\xa9s.",yQ=1068,qp="1500",Cq=" is too large for shifting.",Gn="237200",j7="Map.bal",yO="5208",yP="0.08",lY="242800",u8=2690,u9="@[",ah="Titre III : Aide personnalis\xc3\xa9e au logement",Gm="Apr\xc3\xa8s",u7=3048,ae="Code de la s\xc3\xa9curit\xc3\xa9 sociale",yN="42892",kU=1292,yM=1410,Cp=3376,u6=789,u5=994,ap="Article 46",lX="ml_z_overflow",Gl=677,u4="1.8",ig="contributions_sociales.date_courante",yL=233,Gj=2488,Gk=4941,Co=653,u3=239,lW=488,Gi=850,h2=307,u2="calcul_apl_logement_foyer.redevance",gX=309,Gh=242,yK=-752863768,pQ="Article D832-17",yJ=904,pR=360,q6="202500",yI="allocationsFamiliales",Gf="Article 10",Gg="Instruction interminist\xc3\xa9rielle n\xc2\xb0DSS/2B/2021/65 du 19 mars 2021 relative \xc3\xa0 la revalorisation au 1er avril 2021 des prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 la R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et dans le d\xc3\xa9partement de Mayotte",o_="Section II : Dispositions communes aux aides personnelles au logement",yH=167,lV=4169,Cn="582700",Ge="4986",u1=4136,kT=433,au="CalculAidePersonnalis\xc3\xa9eLogementLocatif",ee="abattement_d\xc3\xa9pense_nette_minimale",yG="Sys_blocked_io",Cm=548,lU=450,u0="0.0588",kR=3410,kS="Chapitre 2 : Champ d'application.",fl="Chapitre 2 : Champ d'application",q5=457,a2="\xc3\x89ligibilit\xc3\xa9 aux aides personnelles au logement",bV="Article D842-15",yF=892,Gd=1010,g$="nombre_personnes_\xc3\xa0_charge_in",yE=441,uY="37900",uZ="%u",uX=2669,lT="Article L831-1",Cl=1529,pP="Section 2 : Dispositions communes aux aides personnelles au logement",aJ="Chapitre IV : Calcul de l'aide personnalis\xc3\xa9e au logement en secteur accession",fk="calcul_\xc3\xa9quivalence_loyer_minimale",ds="input1",ie="Article 40",Ck=1498,bQ="\xc3\x89ligibilit\xc3\xa9AidePersonnalis\xc3\xa9eLogement",uW="19402",lS=1178,T="2",j6=127,uV="Article 30",Cj="@{",cE="Montant de la base mensuelle des allocations familiales",Ci=886,qo=" : flags Open_rdonly and Open_wronly are not compatible",uU="0.232",q4="OuvertureDroitsRetraite",yD=1256,Cg="Zone2",Ch="43505",mU="D\xc3\xa9cret n\xc2\xb0 2019-1387 du 18 d\xc3\xa9cembre 2019 portant rel\xc3\xa8vement du salaire minimum de croissance",cz="-",yC=2715,Cf=3893,yB="type_aide_in",uS="n_nombre_parts_d832_11",uT=216,qn=" : file already exists",mT=1070,uR=2958,j5=397,o9="EffectiveEtPermanente",kQ=514,uQ="1127",Gb="calculAllocationLogementAccessionPropriete",Gc="41481",uP="calcul_apl_logement_foyer.limitation_majoration_personnes_\xc3\xa0_charge",eD="0.0045",Ce=3080,uO=1099,yz=190,yA="retrieveEvents",uN="20165",yy=1399,gD="situation_familiale_calcul_apl_in",Cd=1272,pO="2699",Cc=1265,iv=644,uM="prestationsFamiliales",Cb="Infini",mS=1163,uL="\\b",dI="Article 43",j4="Martinique",yx=3278,$="Titre IV : Allocations de Logement",b8="Article D832-25",uK="Sous-Section 1 : Conditions d'assimilation des logements-foyers aux logements \xc3\xa0 usage locatif",q3=837,uJ=12520,Ga="Collectivit\xc3\xa9",gW="r\xc3\xa9sidence_in",Ca=4163,F_=401,F$="42228",aP="Chapitre 1er : Allocations familiales",iO="Quantification des impay\xc3\xa9s de d\xc3\xa9pense de logement",gV=2016,pN="832200",h1=1176,F9=996,g_=1000,L="CalculAllocationLogementAccessionPropri\xc3\xa9t\xc3\xa9",d="",yw="^",q2=737456202,F8=1206,uI=4821,F7=4829,j3="Section 2 : Prime de d\xc3\xa9m\xc3\xa9nagement",yv=1593,gn=0x3f,yu="' kind for the enumeration 'Collectivite.t'",yt=4461,q1="184000",gm=334,B$="251500",F6=166,c_="Article 16",kP=1149,F5="Article D842-9",ys="0.0167",B_="Match_failure",yr=1236,U=2021,gC="0.085",ff="CalculNombrePartLogementFoyer",B9=" : is a directory",iN="d\xc3\xa9pense_nette_minimale_d832_10",yq="35130",lR=940,h0="montant_initial_majoration",eV="+",F4="Section 3 : Conditions relatives au logement",yp="1057",mR=587,yn="Article L861-5",yo="870",lQ=425,dH="Chapitre Ier : Guadeloupe, Guyane, Martinique, La R\xc3\xa9union et Mayotte",F3="%li",uH="PasdAccord",ym="234600",gU="Smic",B8=237,F2="colocation_in",uG="logement_meubl\xc3\xa9_d842_2_in",j2=1041,uF=4659,F1="39051",B7="20900",mQ="calcul_apl_logement_foyer",q0="208600",F0="impayeDepenseLogement",FZ="calcul_nombre_parts.condition_2_du_832_25",B6=0xe0,yl="20100",uE=882,yk="D331_32",ed="contributions_sociales",FY=1136,uD=3611,pM=1020,FX="\xc3\xa2g\xc3\xa9es_ou_handicap_adultes_h\xc3\xa9berg\xc3\xa9es_on\xc3\xa9reux_particuliers_in",j1=250,ad="Secteur logement-foyer",B4="calcul_apl_logement_foyer.ressources_m\xc3\xa9nage_arrondies",B5=1196,o8="Article L831-2",aV="Allocations familiales",FW=893,kN=624,kO=1034,B3=545,qm="0.027",uB="\xc3\xa9ligibilit\xc3\xa9_commune.m\xc3\xa9nage",uC="allocations_familiales",kM=1255,yj=3733,bN="examples/allocations_familiales/securite_sociale_L.catala_fr",g9="Article 8",kL="Article R521-1",ec=0x8000,W=2019,qZ="jsError",bj="Chapitre Ier : Champ d'application",FV="Section 1 : Conditions relatives au b\xc3\xa9n\xc3\xa9ficiaire",yi="43074",gT="0.0281",gB=449,B2="6.55957",mP=1161,B1="eligibiliteAidePersonnaliseeLogement",mO=1174,FU=4144,B0=320,FT="calcul_apl_logement_foyer.r\xc3\xa9sidence",yg=2740,yh=129,BZ=1213,j0=766,BY=3852,lP=4814,iM="abattement_d\xc3\xa9pense_nette_minimale_d832_27",an="Chapitre II : Modalit\xc3\xa9s de liquidation et de versement de l'aide personnalis\xc3\xa9e au logement",uA=497,o7="3.7",uz=194,dA="Tous secteurs",lO=310,cy="calcul_plafond_mensualit\xc3\xa9_d842_6_base",yf=-48,iu="Article 34",g8=2005,jZ="9",uy="35000",kK=423,qk=1944,ql="EBADF",pL="est_inf\xc3\xa9rieur_ou_\xc3\xa9gal",jY=1229,ye="1025",cf="camlinternalFormat.ml",BX=1872,id=686,kJ=312,yd=203,qY=549,ux=3984,FR=2248,mN=943,FS=148,yc="132000",uw="Article R822-25",qj="0.0185",BW="924600",cJ=2017,FQ="date_naissance",iL=317,mM=343,gl=1155,mL=1428,aj="CalculAidePersonnalis\xc3\xa9eLogementAccessionPropri\xc3\xa9t\xc3\xa9",kI=1217,dN="Titre 1 : Champ d'application - G\xc3\xa9n\xc3\xa9ralit\xc3\xa9s",pK="obligation_scolaire",pJ=1555,BV="EEXIST",FP="r\xc3\xa9duction_loyer_solidarit\xc3\xa9_in",iK=550,FO=4170,BU=733,FN=4629,lN=121,mK=961,jX=1238,kH=1999,eb="3625",yb="\\n",FM="\xc3\xa9ligibilit\xc3\xa9_commune.demandeur",BT=544,FK=3786,FL=1312,lM=120,hZ="16",lL="verificationAgeInferieurOuEgalA",ya="Article D832-14",pI=512,FJ="23138",pH=724,x$=4119,BS=0x7ff0,uv=1731,BR="eligibiliteAllocationLogement",uu=5438,BQ=4186,qi="montant_forfaitaire_charges",x_=177,eh="traitement_aide_finale_d\xc3\xa9pense_nette_minimale",o6=144,BP="\xc3\xa9quivalence_loyer_minimale",x9="Ascendant",BO="0x",jW="0.005",S="Calcul du montant de l'aide personnalis\xc3\xa9e au logement",jV=484,lK="D\xc3\xa9cret n\xc2\xb0 2020-1598 du 16 d\xc3\xa9cembre 2020 portant rel\xc3\xa8vement du salaire minimum de croissance",FI="40888",iJ="lib/dates.ml",ut="0.208",BN="bas",lJ=957,us="date_conventionnement_in",x8=3465,BM="210900",FH="219900",uq="r\xc3\xa9gime_outre_mer_l751_1",ur="Invalid function call ([ ",BL=105,aA="traitement_aide_finale",up="Instruction interminist\xc3\xa9rielle n\xc2\xb0 DSS/SD2B/2018/279 du 17 d\xc3\xa9cembre 2018 relative \xc3\xa0 la revalorisation au 1er janvier 2019 des plafonds de ressources d\xe2\x80\x99attribution de certaines prestations familiales servies en m\xc3\xa9tropole, en Guadeloupe, en Guyane, en Martinique, \xc3\xa0 la R\xc3\xa9union, \xc3\xa0 Saint-Barth\xc3\xa9lemy, \xc3\xa0 Saint-Martin et \xc3\xa0 Mayotte",x7=551,lI="Article R512-2",jU=4421,x6="31664",a9="direct",BJ="948800",BK=1135,x5=454,BI="44693",o5="2710",jT=1165,gS="0.45",uo=429,dM="input",un="39839",qg="0.2",qh=473,pG=364,jS="D\xc3\xa9cret n\xc2\xb0 2018-1173 du 19 d\xc3\xa9cembre 2018 portant rel\xc3\xa8vement du salaire minimum de croissance",BH=390,dm="examples/aides_logement/autres_sources.catala_fr",x4=283,BG=3846,um="calculAllocationLogement",pF="Article L841-3",qf="mkdir",fL="Article L822-3",a5="Chapitre III : Modalit\xc3\xa9s de liquidation et de versement",jR=1157,kG=1013,kE=592,kF=4808,mJ=": No such file or directory",o4=266,cd="Titre VI : Dispositions particuli\xc3\xa8res \xc3\xa0 l'outre-mer",BF="\xc3\xa9quivalence_loyer",BE=655,eU="Chapitre VII : Calcul des allocations de logement en secteur logement-foyer",f0="Titre 5 : D\xc3\xa9partements d'outre-mer",o3=992,BD="766",FG=4385,cD="CalculetteAidesAuLogementGardeAltern\xc3\xa9e",x3="calculetteAidesAuLogement",pE="Section 1 : Ouverture du droit et liquidation de l'allocation de solidarit\xc3\xa9 aux personnes \xc3\xa2g\xc3\xa9es",qd=830,qe=1354,lH=151,BC=1137,FF="Descendant",bZ="\xc3\x89ligibilit\xc3\xa9AllocationLogement",bd="D\xc3\xa9cret n\xc2\xb02002-423 du 29 mars 2002 relatif aux prestations familiales \xc3\xa0 Mayotte",x2=626,kD=3707,gR=1159,FE="\xc3\xa9ligibilit\xc3\xa9_apl",o2="Demandeur",x1=1097,BB="taux",a8="CalculAllocationLogementLocatif",kC=446,x0="BeginCall([ ",FD=843,ul=332,xZ=5762,qX=329,uk=3988,BA=1863,it="caract\xc3\xa9ristiques_pr\xc3\xaat_l831_1_1",qW=921,xY="coefficient_multiplicateur_d832_25",bv="\xc3\x89pilogue",xW=2469,xX="943900",af="CalculAllocationLogementFoyer",xV="bmaf",xU="date_naissance_in",FC="calculEquivalenceLoyerMinimale",xT="contributionsSocialesAidesPersonnelleLogement",lG=2006,gQ="0.95",ui=363,uj="Pervasives.do_at_exit",xS="222300",By="limitation_majoration_personnes_\xc3\xa0_charge",Bz=863,xR=2082,FB="225000",Bx=657,uh="date_signature_pr\xc3\xaat_in",FA=376,ug="\xc3\xa9ligibilit\xc3\xa9_allocation_logement",qV="0.0283",uf=2409,qU="0.16",a_="Article 18",o1=3105,jQ=4158,xQ="36815",Bw=643,Bv=4366,xP=2723,ue=2408,bC="\xc3\x89ligibilit\xc3\xa9 aux allocations de logement";function
b0P(e,c,f,d,a){if(d<=c)for(var
b=1;b<=a;b++)f[d+b]=e[c+b];else
for(var
b=a;b>=1;b--)f[d+b]=e[c+b];return 0}function
nY(e,c,b){var
f=String.fromCharCode;if(c==0&&b<=4096&&b==e.length)return f.apply(null,e);var
a=d;for(;0<b;c+=eS,b-=eS)a+=f.apply(null,e.slice(c,c+Math.min(b,eS)));return a}function
nM(c){var
d=new
Uint8Array(c.l),f=c.c,e=f.length,b=0;for(;b<e;b++)d[b]=f.charCodeAt(b);for(e=c.l;b<e;b++)d[b]=0;c.c=d;c.t=4;return d}function
eZ(e,f,c,a,d){if(d==0)return 0;if(a==0&&(d>=c.l||c.t==2&&d>=c.c.length)){c.c=e.t==4?nY(e.c,f,d):f==0&&e.c.length==d?e.c:e.c.substr(f,d);c.t=c.c.length==c.l?0:2}else
if(c.t==2&&a==c.c.length){c.c+=e.t==4?nY(e.c,f,d):f==0&&e.c.length==d?e.c:e.c.substr(f,d);c.t=c.c.length==c.l?0:2}else{if(c.t!=4)nM(c);var
g=e.c,h=c.c;if(e.t==4)if(a<=f)for(var
b=0;b<d;b++)h[a+b]=g[f+b];else
for(var
b=d-1;b>=0;b--)h[a+b]=g[f+b];else{var
i=Math.min(d,g.length-f);for(var
b=0;b<i;b++)h[a+b]=g.charCodeAt(f+b);for(;b<d;b++)h[a+b]=0}}return 0}function
fw(b){return b}function
er(b,c,d,e,f){eZ(fw(b),c,d,e,f);return 0}function
b1n(c,b){throw[0,c,b]}function
hq(c,b){if(c==0)return d;if(b.repeat)return b.repeat(c);var
f=d,e=0;for(;;){if(c&1)f+=b;c>>=1;if(c==0)return f;b+=b;e++;if(e==9)b.slice(0,1)}}function
hn(b){if(b.t==2)b.c+=hq(b.l-b.c.length,"\0");else
b.c=nY(b.c,0,b.c.length);b.t=0}function
Jv(b){if(b.length<24){for(var
c=0;c<b.length;c++)if(b.charCodeAt(c)>j6)return false;return true}else
return!/[^\x00-\x7f]/.test(b)}function
b1t(a){for(var
k=d,e=d,h,g,i,b,c=0,j=a.length;c<j;c++){g=a.charCodeAt(c);if(g<dV){for(var
f=c+1;f<j&&(g=a.charCodeAt(f))<dV;f++);if(f-c>pI){e.substr(0,1);k+=e;e=d;k+=a.slice(c,f)}else
e+=a.slice(c,f);if(f==j)break;c=f}b=1;if(++c<j&&((i=a.charCodeAt(c))&-64)==dc){h=i+(g<<6);if(g<B6){b=h-0x3080;if(b<dV)b=1}else{b=2;if(++c<j&&((i=a.charCodeAt(c))&-64)==dc){h=i+(h<<6);if(g<zr){b=h-0xe2080;if(b<CZ||b>=0xd7ff&&b<0xe000)b=2}else{b=3;if(++c<j&&((i=a.charCodeAt(c))&-64)==dc&&g<0xf5){b=i-0x3c82080+(h<<6);if(b<0x10000||b>0x10ffff)b=3}}}}}if(b<4){c-=b;e+="\ufffd"}else
if(b>d$)e+=String.fromCharCode(0xd7c0+(b>>10),DT+(b&0x3FF));else
e+=String.fromCharCode(b);if(e.length>eS){e.substr(0,1);k+=e;e=d}}return k+e}function
eq(d,b,c){this.t=d;this.c=b;this.l=c}eq.prototype.toString=function(){switch(this.t){case
9:return this.c;default:hn(this);case
0:if(Jv(this.c)){this.t=9;return this.c}this.t=8;case
8:return this.c}};eq.prototype.toUtf16=function(){var
b=this.toString();if(this.t==9)return b;return b1t(b)};eq.prototype.slice=function(){var
b=this.t==4?this.c.slice():this.c;return new
eq(this.t,b,this.l)};function
I9(b){return new
eq(0,b,b.length)}function
b(b){return I9(b)}function
rV(d,c){b1n(d,b(c))}var
dQ=[0];function
bS(b){rV(dQ.Invalid_argument,b)}function
b0S(){bS(rd)}function
b0(b,d,c){c&=dp;if(b.t!=4){if(d==b.c.length){b.c+=String.fromCharCode(c);if(d+1==b.l)b.t=0;return 0}nM(b)}b.c[d]=c;return 0}function
hm(c,b,d){if(b>>>0>=c.l)b0S();return b0(c,b,d)}function
nJ(b,c){switch(b.t&6){default:if(c>=b.c.length)return 0;case
0:return b.c.charCodeAt(c);case
4:return b.c[c]}}function
du(c,b){if(c.fun)return du(c.fun,b);if(typeof
c!=="function")return c;var
d=c.length|0;if(d===0)return c.apply(null,b);var
f=b.length|0,e=d-f|0;if(e==0)return c.apply(null,b);else
if(e<0)return du(c.apply(null,b.slice(0,d)),b.slice(d));else
return function(){var
f=arguments.length==0?1:arguments.length,e=new
Array(b.length+f);for(var
d=0;d<b.length;d++)e[d]=b[d];for(var
d=0;d<arguments.length;d++)e[b.length+d]=arguments[d];return du(c,e)}}function
i4(){bS(rd)}function
c0(b,c){if(c>>>0>=b.length-1)i4();return b}function
nK(b){if(isFinite(b)){if(Math.abs(b)>=2.2250738585072014e-308)return 0;if(b!=0)return 1;return 2}return isNaN(b)?4:3}function
b0V(){return[0]}function
b_(b){if(b<0)bS("Bytes.create");return new
eq(b?2:9,d,b)}function
i$(b){throw b}function
ja(){i$(dQ.Division_by_zero)}function
Ja(c,b){if(b==0)ja();return c/b|0}function
es(b){b.t&6&&hn(b);return b.c}var
b1A=Math.log2&&Math.log2(1.1235582092889474E+307)==pM;function
Ju(b){if(b1A)return Math.floor(Math.log2(b));var
c=0;if(b==0)return-Infinity;if(b>=1)while(b>=2){b/=2;c++}else
while(b<1){b*=2;c--}return c}function
rN(d){var
b=new
Float32Array(1);b[0]=d;var
c=new
Int32Array(b.buffer);return c[0]|0}var
Jh=Math.pow(2,-24);function
aU(c,d,b){this.lo=c&eR;this.mi=d&eR;this.hi=b&d$}aU.prototype.caml_custom="_j";aU.prototype.copy=function(){return new
aU(this.lo,this.mi,this.hi)};aU.prototype.ucompare=function(b){if(this.hi>b.hi)return 1;if(this.hi<b.hi)return-1;if(this.mi>b.mi)return 1;if(this.mi<b.mi)return-1;if(this.lo>b.lo)return 1;if(this.lo<b.lo)return-1;return 0};aU.prototype.compare=function(b){var
c=this.hi<<16,d=b.hi<<16;if(c>d)return 1;if(c<d)return-1;if(this.mi>b.mi)return 1;if(this.mi<b.mi)return-1;if(this.lo>b.lo)return 1;if(this.lo<b.lo)return-1;return 0};aU.prototype.neg=function(){var
b=-this.lo,c=-this.mi+(b>>24),d=-this.hi+(c>>24);return new
aU(b,c,d)};aU.prototype.add=function(b){var
c=this.lo+b.lo,d=this.mi+b.mi+(c>>24),e=this.hi+b.hi+(d>>24);return new
aU(c,d,e)};aU.prototype.sub=function(b){var
c=this.lo-b.lo,d=this.mi-b.mi+(c>>24),e=this.hi-b.hi+(d>>24);return new
aU(c,d,e)};aU.prototype.mul=function(b){var
c=this.lo*b.lo,d=(c*Jh|0)+this.mi*b.lo+this.lo*b.mi,e=(d*Jh|0)+this.hi*b.lo+this.mi*b.mi+this.lo*b.hi;return new
aU(c,d,e)};aU.prototype.isZero=function(){return(this.lo|this.mi|this.hi)==0};aU.prototype.isNeg=function(){return this.hi<<16<0};aU.prototype.and=function(b){return new
aU(this.lo&b.lo,this.mi&b.mi,this.hi&b.hi)};aU.prototype.or=function(b){return new
aU(this.lo|b.lo,this.mi|b.mi,this.hi|b.hi)};aU.prototype.xor=function(b){return new
aU(this.lo^b.lo,this.mi^b.mi,this.hi^b.hi)};aU.prototype.shift_left=function(b){b=b&63;if(b==0)return this;if(b<24)return new
aU(this.lo<<b,this.mi<<b|this.lo>>24-b,this.hi<<b|this.mi>>24-b);if(b<48)return new
aU(0,this.lo<<b-24,this.mi<<b-24|this.lo>>48-b);return new
aU(0,0,this.lo<<b-48)};aU.prototype.shift_right_unsigned=function(b){b=b&63;if(b==0)return this;if(b<24)return new
aU(this.lo>>b|this.mi<<24-b,this.mi>>b|this.hi<<24-b,this.hi>>b);if(b<48)return new
aU(this.mi>>b-24|this.hi<<48-b,this.hi>>b-24,0);return new
aU(this.hi>>b-48,0,0)};aU.prototype.shift_right=function(b){b=b&63;if(b==0)return this;var
d=this.hi<<16>>16;if(b<24)return new
aU(this.lo>>b|this.mi<<24-b,this.mi>>b|d<<24-b,this.hi<<16>>b>>>16);var
c=this.hi<<16>>31;if(b<48)return new
aU(this.mi>>b-24|this.hi<<48-b,this.hi<<16>>b-24>>16,c&d$);return new
aU(this.hi<<16>>b-32,c,c)};aU.prototype.lsl1=function(){this.hi=this.hi<<1|this.mi>>23;this.mi=(this.mi<<1|this.lo>>23)&eR;this.lo=this.lo<<1&eR};aU.prototype.lsr1=function(){this.lo=(this.lo>>>1|this.mi<<23)&eR;this.mi=(this.mi>>>1|this.hi<<23)&eR;this.hi=this.hi>>>1};aU.prototype.udivmod=function(f){var
d=0,c=this.copy(),b=f.copy(),e=new
aU(0,0,0);while(c.ucompare(b)>0){d++;b.lsl1()}while(d>=0){d--;e.lsl1();if(c.ucompare(b)>=0){e.lo++;c=c.sub(b)}b.lsr1()}return{quotient:e,modulus:c}};aU.prototype.div=function(b){var
c=this;if(b.isZero())ja();var
e=c.hi^b.hi;if(c.hi&ec)c=c.neg();if(b.hi&ec)b=b.neg();var
d=c.udivmod(b).quotient;if(e&ec)d=d.neg();return d};aU.prototype.mod=function(c){var
b=this;if(c.isZero())ja();var
e=b.hi;if(b.hi&ec)b=b.neg();if(c.hi&ec)c=c.neg();var
d=b.udivmod(c).modulus;if(e&ec)d=d.neg();return d};aU.prototype.toInt=function(){return this.lo|this.mi<<24};aU.prototype.toFloat=function(){return(this.hi<<16)*Math.pow(2,32)+this.mi*Math.pow(2,24)+this.lo};aU.prototype.toArray=function(){return[this.hi>>8,this.hi&dp,this.mi>>16,this.mi>>8&dp,this.mi&dp,this.lo>>16,this.lo>>8&dp,this.lo&dp]};aU.prototype.lo32=function(){return this.lo|(this.mi&dp)<<24};aU.prototype.hi32=function(){return this.mi>>>8&d$|this.hi<<16};function
fx(c,d,b){return new
aU(c,d,b)}function
nP(b){if(!isFinite(b)){if(isNaN(b))return fx(1,0,BS);return b>0?fx(0,0,BS):fx(0,0,0xfff0)}var
a=b==0&&1/b==-Infinity?ec:b>=0?0:ec;if(a)b=-b;var
c=Ju(b)+dW;if(c<=0){c=0;b/=Math.pow(2,-fQ)}else{b/=Math.pow(2,c-rG);if(b<16){b*=2;c-=1}if(c==0)b/=2}var
e=Math.pow(2,24),d=b|0;b=(b-d)*e;var
f=b|0;b=(b-f)*e;var
g=b|0;d=d&ra|a|c<<4;return fx(g,f,d)}function
i7(b){return b.toArray()}function
I7(d,c,g){d.write(32,c.dims.length);d.write(32,c.kind|c.layout<<8);if(c.caml_custom==m4)for(var
b=0;b<c.dims.length;b++)if(c.dims[b]<d$)d.write(16,c.dims[b]);else{d.write(16,d$);d.write(32,0);d.write(32,c.dims[b])}else
for(var
b=0;b<c.dims.length;b++)d.write(32,c.dims[b]);switch(c.kind){case
2:case
3:case
12:for(var
b=0;b<c.data.length;b++)d.write(8,c.data[b]);break;case
4:case
5:for(var
b=0;b<c.data.length;b++)d.write(16,c.data[b]);break;case
6:for(var
b=0;b<c.data.length;b++)d.write(32,c.data[b]);break;case
8:case
9:d.write(8,0);for(var
b=0;b<c.data.length;b++)d.write(32,c.data[b]);break;case
7:for(var
b=0;b<c.data.length/2;b++){var
f=i7(c.get(b));for(var
e=0;e<8;e++)d.write(8,f[e])}break;case
1:for(var
b=0;b<c.data.length;b++){var
f=i7(nP(c.get(b)));for(var
e=0;e<8;e++)d.write(8,f[e])}break;case
0:for(var
b=0;b<c.data.length;b++){var
f=rN(c.get(b));d.write(32,f)}break;case
10:for(var
b=0;b<c.data.length/2;b++){var
e=c.get(b);d.write(32,rN(e[1]));d.write(32,rN(e[2]))}break;case
11:for(var
b=0;b<c.data.length/2;b++){var
a=c.get(b),f=i7(nP(a[1]));for(var
e=0;e<8;e++)d.write(8,f[e]);var
f=i7(nP(a[2]));for(var
e=0;e<8;e++)d.write(8,f[e])}break}g[0]=(4+c.dims.length)*4;g[1]=(4+c.dims.length)*8}function
I5(b){switch(b){case
7:case
10:case
11:return 2;default:return 1}}function
b0Q(c,e){var
b;switch(c){case
0:b=Float32Array;break;case
1:b=Float64Array;break;case
2:b=Int8Array;break;case
3:b=Uint8Array;break;case
4:b=Int16Array;break;case
5:b=Uint16Array;break;case
6:b=Int32Array;break;case
7:b=Int32Array;break;case
8:b=Int32Array;break;case
9:b=Int32Array;break;case
10:b=Float32Array;break;case
11:b=Float64Array;break;case
12:b=Uint8Array;break}if(!b)bS("Bigarray.create: unsupported kind");var
d=new
b(e*I5(c));return d}function
rO(d){var
b=new
Int32Array(1);b[0]=d;var
c=new
Float32Array(b.buffer);return c[0]}function
i6(b){return new
aU(b[7]<<0|b[6]<<8|b[5]<<16,b[4]<<0|b[3]<<8|b[2]<<16,b[1]<<0|b[0]<<8)}function
ho(e){var
a=e.lo,g=e.mi,c=e.hi,d=(c&0x7fff)>>4;if(d==DF)return(a|g|c&ra)==0?c&ec?-Infinity:Infinity:NaN;var
f=Math.pow(2,-24),b=(a*f+g)*f+(c&ra);if(d>0){b+=16;b*=Math.pow(2,d-rG)}else
b*=Math.pow(2,-fQ);if(c&ec)b=-b;return b}function
rH(c){var
e=c.length,d=1;for(var
b=0;b<e;b++){if(c[b]<0)bS("Bigarray.create: negative dimension");d=d*c[b]}return d}function
Jg(c,b){return new
aU(c&eR,c>>>24&dp|(b&d$)<<8,b>>>16&d$)}function
rP(b){return b.hi32()}function
rQ(b){return b.lo32()}var
b0R=m4;function
fv(d,e,c,b){this.kind=d;this.layout=e;this.dims=c;this.data=b}fv.prototype.caml_custom=b0R;fv.prototype.offset=function(c){var
d=0;if(typeof
c==="number")c=[c];if(!(c
instanceof
Array))bS("bigarray.js: invalid offset");if(this.dims.length!=c.length)bS("Bigarray.get/set: bad number of dimensions");if(this.layout==0)for(var
b=0;b<this.dims.length;b++){if(c[b]<0||c[b]>=this.dims[b])i4();d=d*this.dims[b]+c[b]}else
for(var
b=this.dims.length-1;b>=0;b--){if(c[b]<1||c[b]>this.dims[b])i4();d=d*this.dims[b]+(c[b]-1)}return d};fv.prototype.get=function(b){switch(this.kind){case
7:var
e=this.data[b*2+0],c=this.data[b*2+1];return Jg(e,c);case
10:case
11:var
f=this.data[b*2+0],d=this.data[b*2+1];return[iy,f,d];default:return this.data[b]}};fv.prototype.set=function(b,c){switch(this.kind){case
7:this.data[b*2+0]=rQ(c);this.data[b*2+1]=rP(c);break;case
10:case
11:this.data[b*2+0]=c[1];this.data[b*2+1]=c[2];break;default:this.data[b]=c;break}return 0};fv.prototype.fill=function(c){switch(this.kind){case
7:var
d=rQ(c),f=rP(c);if(d==f)this.data.fill(d);else
for(var
b=0;b<this.data.length;b++)this.data[b]=b%2==0?d:f;break;case
10:case
11:var
e=c[1],a=c[2];if(e==a)this.data.fill(e);else
for(var
b=0;b<this.data.length;b++)this.data[b]=b%2==0?e:a;break;default:this.data.fill(c);break}};fv.prototype.compare=function(c,g){if(this.layout!=c.layout||this.kind!=c.kind){var
f=this.kind|this.layout<<8,a=c.kind|c.layout<<8;return a-f}if(this.dims.length!=c.dims.length)return c.dims.length-this.dims.length;for(var
b=0;b<this.dims.length;b++)if(this.dims[b]!=c.dims[b])return this.dims[b]<c.dims[b]?-1:1;switch(this.kind){case
0:case
1:case
10:case
11:var
d,e;for(var
b=0;b<this.data.length;b++){d=this.data[b];e=c.data[b];if(d<e)return-1;if(d>e)return 1;if(d!=e){if(!g)return NaN;if(d==d)return 1;if(e==e)return-1}}break;case
7:for(var
b=0;b<this.data.length;b+=2){if(this.data[b+1]<c.data[b+1])return-1;if(this.data[b+1]>c.data[b+1])return 1;if(this.data[b]>>>0<c.data[b]>>>0)return-1;if(this.data[b]>>>0>c.data[b]>>>0)return 1}break;case
2:case
3:case
4:case
5:case
6:case
8:case
9:case
12:for(var
b=0;b<this.data.length;b++){if(this.data[b]<c.data[b])return-1;if(this.data[b]>c.data[b])return 1}break}return 0};function
hl(d,e,c,b){this.kind=d;this.layout=e;this.dims=c;this.data=b}hl.prototype=new
fv();hl.prototype.offset=function(b){if(typeof
b!=="number")if(b
instanceof
Array&&b.length==1)b=b[0];else
bS("Ml_Bigarray_c_1_1.offset");if(b<0||b>=this.dims[0])i4();return b};hl.prototype.get=function(b){return this.data[b]};hl.prototype.set=function(b,c){this.data[b]=c;return 0};hl.prototype.fill=function(b){this.data.fill(b);return 0};function
I3(d,e,b,c){var
f=I5(d);if(rH(b)*f!=c.length)bS("length doesn't match dims");if(e==0&&b.length==1&&f==1)return new
hl(d,e,b,c);return new
fv(d,e,b,c)}function
dg(c){if(!dQ.Failure)dQ.Failure=[bl,b(qz),-3];rV(dQ.Failure,c)}function
I4(c,v,r){var
i=c.read32s();if(i<0||i>16)dg("input_value: wrong number of bigarray dimensions");var
p=c.read32s(),j=p&dp,o=p>>8&1,h=[];if(r==m4)for(var
b=0;b<i;b++){var
n=c.read16u();if(n==d$){var
t=c.read32u(),u=c.read32u();if(t!=0)dg("input_value: bigarray dimension overflow in 32bit");n=u}h.push(n)}else
for(var
b=0;b<i;b++)h.push(c.read32u());var
e=rH(h),a=b0Q(j,e),g=I3(j,o,h,a);switch(j){case
2:for(var
b=0;b<e;b++)a[b]=c.read8s();break;case
3:case
12:for(var
b=0;b<e;b++)a[b]=c.read8u();break;case
4:for(var
b=0;b<e;b++)a[b]=c.read16s();break;case
5:for(var
b=0;b<e;b++)a[b]=c.read16u();break;case
6:for(var
b=0;b<e;b++)a[b]=c.read32s();break;case
8:case
9:var
s=c.read8u();if(s)dg("input_value: cannot read bigarray with 64-bit OCaml ints");for(var
b=0;b<e;b++)a[b]=c.read32s();break;case
7:var
f=new
Array(8);for(var
b=0;b<e;b++){for(var
d=0;d<8;d++)f[d]=c.read8u();var
q=i6(f);g.set(b,q)}break;case
1:var
f=new
Array(8);for(var
b=0;b<e;b++){for(var
d=0;d<8;d++)f[d]=c.read8u();var
k=ho(i6(f));g.set(b,k)}break;case
0:for(var
b=0;b<e;b++){var
k=rO(c.read32s());g.set(b,k)}break;case
10:for(var
b=0;b<e;b++){var
m=rO(c.read32s()),l=rO(c.read32s());g.set(b,[iy,m,l])}break;case
11:var
f=new
Array(8);for(var
b=0;b<e;b++){for(var
d=0;d<8;d++)f[d]=c.read8u();var
m=ho(i6(f));for(var
d=0;d<8;d++)f[d]=c.read8u();var
l=ho(i6(f));g.set(b,[iy,m,l])}break}v[0]=(4+i)*4;return I3(j,o,h,a)}function
I2(b,c,d){return b.compare(c,d)}function
hp(b,c){return Math.imul(b,c)}function
d3(c,b){b=hp(b,0xcc9e2d51|0);b=b<<15|b>>>32-15;b=hp(b,0x1b873593);c^=b;c=c<<13|c>>>32-13;return(c+(c<<2)|0)+(0xe6546b64|0)|0}function
b02(b,c){b=d3(b,rQ(c));b=d3(b,rP(c));return b}function
Jf(b,c){return b02(b,nP(c))}function
I6(d){var
c=rH(d.dims),e=0;switch(d.kind){case
2:case
3:case
12:if(c>fc)c=fc;var
f=0,b=0;for(b=0;b+4<=d.data.length;b+=4){f=d.data[b+0]|d.data[b+1]<<8|d.data[b+2]<<16|d.data[b+3]<<24;e=d3(e,f)}f=0;switch(c&3){case
3:f=d.data[b+2]<<16;case
2:f|=d.data[b+1]<<8;case
1:f|=d.data[b+0];e=d3(e,f)}break;case
4:case
5:if(c>dc)c=dc;var
f=0,b=0;for(b=0;b+2<=d.data.length;b+=2){f=d.data[b+0]|d.data[b+1]<<16;e=d3(e,f)}if((c&1)!=0)e=d3(e,d.data[b]);break;case
6:if(c>64)c=64;for(var
b=0;b<c;b++)e=d3(e,d.data[b]);break;case
8:case
9:if(c>64)c=64;for(var
b=0;b<c;b++)e=d3(e,d.data[b]);break;case
7:if(c>32)c=32;c*=2;for(var
b=0;b<c;b++)e=d3(e,d.data[b]);break;case
10:c*=2;case
0:if(c>64)c=64;for(var
b=0;b<c;b++)e=Jf(e,d.data[b]);break;case
11:c*=2;case
1:if(c>32)c=32;for(var
b=0;b<c;b++)e=Jf(e,d.data[b]);break}return e}function
b04(b,c){c[0]=4;return b.read32s()}function
b1k(b,c){switch(b.read8u()){case
1:c[0]=4;return b.read32s();case
2:dg("input_value: native integer value too large");default:dg("input_value: ill-formed native integer")}}function
b1d(d,e){var
c=new
Array(8);for(var
b=0;b<8;b++)c[b]=d.read8u();e[0]=8;return i6(c)}function
b0_(f,e,c){var
d=i7(e);for(var
b=0;b<8;b++)f.write(8,d[b]);c[0]=8;c[1]=8}function
b05(b,c,d){return b.compare(c)}function
b07(b){return b.lo32()^b.hi32()}var
rK={"_j":{deserialize:b1d,serialize:b0_,fixed_length:8,compare:b05,hash:b07},"_i":{deserialize:b04,fixed_length:4},"_n":{deserialize:b1k,fixed_length:4},"_bigarray":{deserialize:function(b,c){return I4(b,c,"_bigarray")},serialize:I7,compare:I2,hash:I6},"_bigarr02":{deserialize:function(b,c){return I4(b,c,m4)},serialize:I7,compare:I2,hash:I6}};function
rJ(b){return rK[b.caml_custom]&&rK[b.caml_custom].compare}function
I_(a,d,e,f){var
c=rJ(d);if(c){var
b=e>0?c(d,a,f):c(a,d,f);if(f&&b!=b)return e;if(+b!=+b)return+b;if((b|0)!=0)return b|0}return e}function
nS(b){return b
instanceof
eq}function
rR(b){return nS(b)}function
I$(b){if(typeof
b==="number")return g_;else
if(nS(b))return kb;else
if(rR(b))return 1252;else
if(b
instanceof
Array&&b[0]===b[0]>>>0&&b[0]<=qA){var
c=b[0]|0;return c==iy?0:c}else
if(b
instanceof
String)return uJ;else
if(typeof
b=="string")return uJ;else
if(b
instanceof
Number)return g_;else
if(b&&b.caml_custom)return kM;else
if(b&&b.compare)return yD;else
if(typeof
b=="function")return 1247;else
if(typeof
b=="symbol")return Fq;return 1001}function
fy(b,c){if(b<c)return-1;if(b==c)return 0;return 1}function
I8(b,c){b.t&6&&hn(b);c.t&6&&hn(c);return b.c<c.c?-1:b.c>c.c?1:0}function
rX(b,c){return I8(b,c)}function
nL(b,c,e){var
f=[];for(;;){if(!(e&&b===c)){var
a=I$(b);if(a==j1){b=b[1];continue}var
g=I$(c);if(g==j1){c=c[1];continue}if(a!==g){if(a==g_){if(g==kM)return I_(b,c,-1,e);return-1}if(g==g_){if(a==kM)return I_(c,b,1,e);return 1}return a<g?-1:1}switch(a){case
247:bS(qH);break;case
248:var
d=fy(b[2],c[2]);if(d!=0)return d|0;break;case
249:bS(qH);break;case
250:bS("equal: got Forward_tag, should not happen");break;case
251:bS("equal: abstract value");break;case
252:if(b!==c){var
d=I8(b,c);if(d!=0)return d|0}break;case
253:bS("equal: got Double_tag, should not happen");break;case
254:bS("equal: got Double_array_tag, should not happen");break;case
255:bS("equal: got Custom_tag, should not happen");break;case
1247:bS(qH);break;case
1255:var
i=rJ(b);if(i!=rJ(c))return b.caml_custom<c.caml_custom?-1:1;if(!i)bS("compare: abstract value");var
d=i(b,c,e);if(d!=d)return e?-1:d;if(d!==(d|0))return-1;if(d!=0)return d|0;break;case
1256:var
d=b.compare(c,e);if(d!=d)return e?-1:d;if(d!==(d|0))return-1;if(d!=0)return d|0;break;case
1000:b=+b;c=+c;if(b<c)return-1;if(b>c)return 1;if(b!=c){if(!e)return NaN;if(b==b)return 1;if(c==c)return-1}break;case
1001:if(b<c)return-1;if(b>c)return 1;if(b!=c){if(!e)return NaN;if(b==b)return 1;if(c==c)return-1}break;case
1251:if(b!==c){if(!e)return NaN;return 1}break;case
1252:var
b=es(b),c=es(c);if(b!==c){if(b<c)return-1;if(b>c)return 1}break;case
12520:var
b=b.toString(),c=c.toString();if(b!==c){if(b<c)return-1;if(b>c)return 1}break;case
246:case
254:default:if(b.length!=c.length)return b.length<c.length?-1:1;if(b.length>1)f.push(b,c,1);break}}if(f.length==0)return 0;var
h=f.pop();c=f.pop();b=f.pop();if(h+1<b.length)f.push(b,c,h+1);b=b[h];c=c[h]}}function
a(b,c){return+(nL(b,c,false)==0)}function
b0X(b,e,c,f){if(c>0)if(e==0&&(c>=b.l||b.t==2&&c>=b.c.length))if(f==0){b.c=d;b.t=2}else{b.c=hq(c,String.fromCharCode(f));b.t=c==b.l?0:2}else{if(b.t!=4)nM(b);for(c+=e;e<c;e++)b.c[e]=f}return 0}function
Jc(b){var
c;b=es(b);c=+b;if(b.length>0&&c===c)return c;b=b.replace(/_/g,d);c=+b;if(b.length>0&&c===c||/^[+-]?nan$/i.test(b))return c;var
e=/^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)(p([+-]?[0-9]+))?/i.exec(b);if(e){var
f=e[3].replace(/0+$/,d),g=parseInt(e[1]+e[2]+f,16),a=(e[5]|0)-4*f.length;c=g*Math.pow(2,a);return c}if(/^\+?inf(inity)?$/i.test(b))return Infinity;if(/^-inf(inity)?$/i.test(b))return-Infinity;dg("float_of_string")}function
rU(e){e=es(e);var
f=e.length;if(f>31)bS("format_int: format too long");var
b={justify:eV,signstyle:cz,filler:eX,alternate:false,base:0,signedconv:false,width:0,uppercase:false,sign:1,prec:-1,conv:"f"};for(var
d=0;d<f;d++){var
c=e.charAt(d);switch(c){case"-":b.justify=cz;break;case"+":case" ":b.signstyle=c;break;case"0":b.filler=r;break;case"#":b.alternate=true;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":b.width=0;while(c=e.charCodeAt(d)-48,c>=0&&c<=9){b.width=b.width*10+c;d++}d--;break;case".":b.prec=0;d++;while(c=e.charCodeAt(d)-48,c>=0&&c<=9){b.prec=b.prec*10+c;d++}d--;case"d":case"i":b.signedconv=true;case"u":b.base=10;break;case"x":b.base=16;break;case"X":b.base=16;b.uppercase=true;break;case"o":b.base=8;break;case"e":case"f":case"g":b.signedconv=true;b.conv=c;break;case"E":case"F":case"G":b.signedconv=true;b.uppercase=true;b.conv=c.toLowerCase();break}}return b}function
rL(c,g){if(c.uppercase)g=g.toUpperCase();var
a=g.length;if(c.signedconv&&(c.sign<0||c.signstyle!=cz))a++;if(c.alternate){if(c.base==8)a+=1;if(c.base==16)a+=2}var
e=d;if(c.justify==eV&&c.filler==eX)for(var
f=a;f<c.width;f++)e+=eX;if(c.signedconv)if(c.sign<0)e+=cz;else
if(c.signstyle!=cz)e+=c.signstyle;if(c.alternate&&c.base==8)e+=r;if(c.alternate&&c.base==16)e+=c.uppercase?"0X":BO;if(c.justify==eV&&c.filler==r)for(var
f=a;f<c.width;f++)e+=r;e+=g;if(c.justify==cz)for(var
f=a;f<c.width;f++)e+=eX;return b(e)}function
rM(i,d){function
j(b,c){if(Math.abs(b)<1.0)return b.toFixed(c);else{var
d=parseInt(b.toString().split(eV)[1]);if(d>20){d-=20;b/=Math.pow(10,d);b+=new
Array(d+1).join(r);if(c>0)b=b+ej+new
Array(c+1).join(r);return b}else
return b.toFixed(c)}}var
b,f=rU(i),e=f.prec<0?6:f.prec;if(d<0||d==0&&1/d==-Infinity){f.sign=-1;d=-d}if(isNaN(d)){b=qB;f.filler=eX}else
if(!isFinite(d)){b=IS;f.filler=eX}else
switch(f.conv){case"e":var
b=d.toExponential(e),c=b.length;if(b.charAt(c-3)==nB)b=b.slice(0,c-1)+r+b.slice(c-1);break;case"f":b=j(d,e);break;case"g":e=e?e:1;b=d.toExponential(e-1);var
h=b.indexOf(nB),g=+b.slice(h+1);if(g<-4||d>=1e21||d.toFixed(0).length>e){var
c=h-1;while(b.charAt(c)==r)c--;if(b.charAt(c)==ej)c--;b=b.slice(0,c+1)+b.slice(h);c=b.length;if(b.charAt(c-3)==nB)b=b.slice(0,c-1)+r+b.slice(c-1);break}else{var
a=e;if(g<0){a-=g+1;b=d.toFixed(a)}else
while(b=d.toFixed(a),b.length>e+1)a--;if(a){var
c=b.length-1;while(b.charAt(c)==r)c--;if(b.charAt(c)==ej)c--;b=b.slice(0,c+1)}}break}return rL(f,b)}function
nN(a,e){if(es(a)==p$)return b(d+e);var
c=rU(a);if(e<0)if(c.signedconv){c.sign=-1;e=-e}else
e>>>=0;var
f=e.toString(c.base);if(c.prec>=0){c.filler=eX;var
g=c.prec-f.length;if(g>0)f=hq(g,r)+f}return rL(c,f)}var
Jn=0;function
c1(){return Jn++}function
b0Z(b){if(b==0||!isFinite(b))return[0,b,0];var
d=b<0;if(d)b=-b;var
c=Math.max(-dW,Ju(b)+1);b*=Math.pow(2,-c);while(b<w6){b*=2;c--}while(b>=1){b*=w6;c++}if(d)b=-b;return[0,b,c]}function
dR(b){return b.toUtf16()}function
jb(){return typeof
bz.process!=="undefined"&&typeof
bz.process.versions!=="undefined"&&typeof
bz.process.versions.node!=="undefined"}function
b1B(){function
b(b){if(b.charAt(0)===dU)return[d,b.substring(1)];return}function
c(e){var
h=/^([a-zA-Z]:|[\\/]{2}[^\\/]+[\\/]+[^\\/]+)?([\\/])?([\s\S]*?)$/,b=h.exec(e),c=b[1]||d,a=Boolean(c&&c.charAt(1)!==":");if(Boolean(b[2]||a)){var
f=b[1]||d,g=b[2]||d;return[f,e.substring(f.length+g.length)]}return}return jb()&&bz.process&&bz.process.platform?bz.process.platform==="win32"?c:b:b}var
r4=b1B();function
Js(b){return b.slice(-1)!==dU?b+dU:b}if(jb()&&bz.process&&bz.process.cwd)var
i5=bz.process.cwd().replace(/\\/g,dU);else
var
i5="/static";i5=Js(i5);function
b1f(b){b=dR(b);if(!r4(b))b=i5+b;var
f=r4(b),e=f[1].split(dU),c=[];for(var
d=0;d<e.length;d++)switch(e[d]){case"..":if(c.length>1)c.pop();break;case".":break;case"":break;default:c.push(e[d]);break}c.unshift(f[0]);c.orig=b;return c}function
b1u(a){for(var
g=d,c=g,b,i,e=0,h=a.length;e<h;e++){b=a.charCodeAt(e);if(b<dV){for(var
f=e+1;f<h&&(b=a.charCodeAt(f))<dV;f++);if(f-e>pI){c.substr(0,1);g+=c;c=d;g+=a.slice(e,f)}else
c+=a.slice(e,f);if(f==h)break;e=f}if(b<CZ){c+=String.fromCharCode(0xc0|b>>6);c+=String.fromCharCode(dV|b&gn)}else
if(b<0xd800||b>=HV)c+=String.fromCharCode(B6|b>>12,dV|b>>6&gn,dV|b&gn);else
if(b>=0xdbff||e+1==h||(i=a.charCodeAt(e+1))<DT||i>HV)c+="\xef\xbf\xbd";else{e++;b=(b<<10)+i-0x35fdc00;c+=String.fromCharCode(zr|b>>18,dV|b>>12&gn,dV|b>>6&gn,dV|b&gn)}if(c.length>eS){c.substr(0,1);g+=c;c=d}}return g+c}function
b0U(b){var
c=9;if(!Jv(b))c=8,b=b1u(b);return new
eq(c,b,b.length)}function
a4(b){return b0U(b)}var
b1S=["E2BIG","EACCES","EAGAIN",ql,"EBUSY","ECHILD","EDEADLK","EDOM",BV,"EFAULT","EFBIG","EINTR","EINVAL","EIO","EISDIR","EMFILE","EMLINK","ENAMETOOLONG","ENFILE","ENODEV",rB,"ENOEXEC","ENOLCK","ENOMEM","ENOSPC","ENOSYS",rq,Iw,"ENOTTY","ENXIO","EPERM","EPIPE","ERANGE","EROFS","ESPIPE","ESRCH","EXDEV","EWOULDBLOCK","EINPROGRESS","EALREADY","ENOTSOCK","EDESTADDRREQ","EMSGSIZE","EPROTOTYPE","ENOPROTOOPT","EPROTONOSUPPORT","ESOCKTNOSUPPORT","EOPNOTSUPP","EPFNOSUPPORT","EAFNOSUPPORT","EADDRINUSE","EADDRNOTAVAIL","ENETDOWN","ENETUNREACH","ENETRESET","ECONNABORTED","ECONNRESET","ENOBUFS","EISCONN","ENOTCONN","ESHUTDOWN","ETOOMANYREFS","ETIMEDOUT","ECONNREFUSED","EHOSTDOWN","EHOSTUNREACH","ELOOP","EOVERFLOW"];function
e2(f,g,a,b){var
c=b1S.indexOf(f);if(c<0){if(b==null)b=-9999;c=[0,b]}var
e=[c,a4(g||d),a4(a||d)];return e}var
Jl={};function
d4(b){return Jl[b]}function
e1(c,b){throw[0,c].concat(b)}function
rI(b){if(!(b
instanceof
Uint8Array))b=new
Uint8Array(b);return new
eq(4,b,b.length)}function
bb(b){rV(dQ.Sys_error,b)}function
Jp(b){bb(b+mJ)}function
r0(b){if(b.t!=4)nM(b);return b.c}function
dv(b){return b.l}function
I1(){}function
cP(b){this.data=b}cP.prototype=new
I1();cP.prototype.constructor=cP;cP.prototype.truncate=function(b){var
c=this.data;this.data=b_(b|0);eZ(c,0,this.data,0,b)};cP.prototype.length=function(){return dv(this.data)};cP.prototype.write=function(c,e,g,b){var
d=this.length();if(c+b>=d){var
f=b_(c+b),a=this.data;this.data=f;eZ(a,0,this.data,0,d)}eZ(rI(e),g,this.data,c,b);return 0};cP.prototype.read=function(c,f,a,b){var
d=this.length();if(c+b>=d)b=d-c;if(b){var
e=b_(b|0);eZ(this.data,c,e,0,b);f.set(r0(e),a)}return b};function
f4(d,b,c){this.file=b;this.name=d;this.flags=c}f4.prototype.err_closed=function(){bb(this.name+DL)};f4.prototype.length=function(){if(this.file)return this.file.length();this.err_closed()};f4.prototype.write=function(d,b,e,c){if(this.file)return this.file.write(d,b,e,c);this.err_closed()};f4.prototype.read=function(d,b,e,c){if(this.file)return this.file.read(d,b,e,c);this.err_closed()};f4.prototype.close=function(){this.file=undefined};function
cx(c,b){this.content={};this.root=c;this.lookupFun=b}cx.prototype.nm=function(b){return this.root+b};cx.prototype.create_dir_if_needed=function(f){var
e=f.split(dU),c=d;for(var
b=0;b<e.length-1;b++){c+=e[b]+dU;if(this.content[c])continue;this.content[c]=Symbol("directory")}};cx.prototype.slash=function(b){return/\/$/.test(b)?b:b+dU};cx.prototype.lookup=function(c){if(!this.content[c]&&this.lookupFun){var
d=this.lookupFun(b(this.root),b(c));if(d!==0){this.create_dir_if_needed(c);this.content[c]=new
cP(fw(d[1]))}}};cx.prototype.exists=function(b){if(b==d)return 1;var
c=this.slash(b);if(this.content[c])return 1;this.lookup(b);return this.content[b]?1:0};cx.prototype.mkdir=function(e,a,f){var
c=f&&d4(nj);if(this.exists(e))if(c)e1(c,e2(BV,qf,this.nm(e)));else
bb(e+": File exists");var
b=/^(.*)\/[^/]+/.exec(e);b=b&&b[1]||d;if(!this.exists(b))if(c)e1(c,e2(rB,qf,this.nm(b)));else
bb(b+mJ);if(!this.is_dir(b))if(c)e1(c,e2(rq,qf,this.nm(b)));else
bb(b+pZ);this.create_dir_if_needed(this.slash(e))};cx.prototype.rmdir=function(b,g){var
c=g&&d4(nj),e=b==d?d:this.slash(b),a=new
RegExp(yw+e+vz);if(!this.exists(b))if(c)e1(c,e2(rB,pt,this.nm(b)));else
bb(b+mJ);if(!this.is_dir(b))if(c)e1(c,e2(rq,pt,this.nm(b)));else
bb(b+pZ);for(var
f
in
this.content)if(f.match(a))if(c)e1(c,e2(Iw,pt,this.nm(b)));else
bb(this.nm(b)+": Directory not empty");delete
this.content[e]};cx.prototype.readdir=function(b){var
g=b==d?d:this.slash(b);if(!this.exists(b))bb(b+mJ);if(!this.is_dir(b))bb(b+pZ);var
h=new
RegExp(yw+g+vz),f={},e=[];for(var
a
in
this.content){var
c=a.match(h);if(c&&!f[c[1]]){f[c[1]]=true;e.push(c[1])}}return e};cx.prototype.opendir=function(b,a){var
c=a&&d4(nj),d=this.readdir(b),e=false,f=0;return{readSync:function(){if(e)if(c)e1(c,e2(ql,C3,this.nm(b)));else
bb(b+Ha);if(f==d.length)return null;var
a=d[f];f++;return{name:a}},closeSync:function(){if(e)if(c)e1(c,e2(ql,C3,this.nm(b)));else
bb(b+Ha);e=true;d=[]}}};cx.prototype.is_dir=function(b){if(b==d)return true;var
c=this.slash(b);return this.content[c]?1:0};cx.prototype.unlink=function(b){var
c=this.content[b]?true:false;delete
this.content[b];return c};cx.prototype.open=function(b,c){var
d;if(c.rdonly&&c.wronly)bb(this.nm(b)+qo);if(c.text&&c.binary)bb(this.nm(b)+q8);this.lookup(b);if(this.content[b]){if(this.is_dir(b))bb(this.nm(b)+B9);if(c.create&&c.excl)bb(this.nm(b)+qn);d=this.content[b];if(c.truncate)d.truncate()}else
if(c.create){this.create_dir_if_needed(b);this.content[b]=new
cP(b_(0));d=this.content[b]}else
Jp(this.nm(b));return new
f4(this.nm(b),d,c)};cx.prototype.open=function(b,c){var
d;if(c.rdonly&&c.wronly)bb(this.nm(b)+qo);if(c.text&&c.binary)bb(this.nm(b)+q8);this.lookup(b);if(this.content[b]){if(this.is_dir(b))bb(this.nm(b)+B9);if(c.create&&c.excl)bb(this.nm(b)+qn);d=this.content[b];if(c.truncate)d.truncate()}else
if(c.create){this.create_dir_if_needed(b);this.content[b]=new
cP(b_(0));d=this.content[b]}else
Jp(this.nm(b));return new
f4(this.nm(b),d,c)};cx.prototype.register=function(d,b){var
c;if(this.content[d])bb(this.nm(d)+qn);if(nS(b))c=new
cP(b);if(rR(b))c=new
cP(fw(b));else
if(b
instanceof
Array)c=new
cP(rI(b));else
if(typeof
b==="string")c=new
cP(I9(b));else
if(b.toString){var
e=fw(a4(b.toString()));c=new
cP(e)}if(c){this.create_dir_if_needed(d);this.content[d]=c}else
bb(this.nm(d)+" : registering file with invalid content type")};cx.prototype.constructor=cx;function
aM(b){return dv(b)}function
dh(c,b){return nJ(c,b)}function
b1U(e){var
d=aM(e),c=new
Array(d),b=0;for(;b<d;b++)c[b]=dh(e,b);return c}function
d2(b,c){this.fs=require("fs");this.fd=b;this.flags=c}d2.prototype=new
I1();d2.prototype.constructor=d2;d2.prototype.truncate=function(b){try{this.fs.ftruncateSync(this.fd,b|0)}catch(b){bb(b.toString())}};d2.prototype.length=function(){try{return this.fs.fstatSync(this.fd).size}catch(b){bb(b.toString())}};d2.prototype.write=function(e,b,c,d){try{if(this.flags.isCharacterDevice)this.fs.writeSync(this.fd,b,c,d);else
this.fs.writeSync(this.fd,b,c,d,e)}catch(b){bb(b.toString())}return 0};d2.prototype.read=function(f,b,c,d){try{if(this.flags.isCharacterDevice)var
e=this.fs.readSync(this.fd,b,c,d);else
var
e=this.fs.readSync(this.fd,b,c,d,f);return e}catch(b){bb(b.toString())}};d2.prototype.close=function(){try{this.fs.closeSync(this.fd);return 0}catch(b){bb(b.toString())}};function
cj(b){this.fs=require("fs");this.root=b}cj.prototype.nm=function(b){return this.root+b};cj.prototype.exists=function(b){try{return this.fs.existsSync(this.nm(b))?1:0}catch(a){return 0}};cj.prototype.mkdir=function(c,b,d){try{this.fs.mkdirSync(this.nm(c),{mode:b});return 0}catch(b){this.raise_nodejs_error(b,d)}};cj.prototype.rmdir=function(b,c){try{this.fs.rmdirSync(this.nm(b));return 0}catch(b){this.raise_nodejs_error(b,c)}};cj.prototype.readdir=function(b,c){try{return this.fs.readdirSync(this.nm(b))}catch(b){this.raise_nodejs_error(b,c)}};cj.prototype.is_dir=function(b){try{return this.fs.statSync(this.nm(b)).isDirectory()?1:0}catch(b){bb(b.toString())}};cj.prototype.unlink=function(b,d){try{var
c=this.fs.existsSync(this.nm(b))?1:0;this.fs.unlinkSync(this.nm(b));return c}catch(b){this.raise_nodejs_error(b,d)}};cj.prototype.open=function(e,d,h){var
b=require("constants"),c=0;for(var
g
in
d)switch(g){case"rdonly":c|=b.O_RDONLY;break;case"wronly":c|=b.O_WRONLY;break;case"append":c|=b.O_WRONLY|b.O_APPEND;break;case"create":c|=b.O_CREAT;break;case"truncate":c|=b.O_TRUNC;break;case"excl":c|=b.O_EXCL;break;case"binary":c|=b.O_BINARY;break;case"text":c|=b.O_TEXT;break;case"nonblock":c|=b.O_NONBLOCK;break}try{var
f=this.fs.openSync(this.nm(e),c),a=this.fs.lstatSync(this.nm(e)).isCharacterDevice();d.isCharacterDevice=a;return new
d2(f,d)}catch(b){this.raise_nodejs_error(b,h)}};cj.prototype.rename=function(c,b,d){try{this.fs.renameSync(this.nm(c),this.nm(b))}catch(b){this.raise_nodejs_error(b,d)}};cj.prototype.stat=function(c,d){try{var
b=this.fs.statSync(this.nm(c));return this.stats_from_js(b)}catch(b){this.raise_nodejs_error(b,d)}};cj.prototype.lstat=function(c,d){try{var
b=this.fs.lstatSync(this.nm(c));return this.stats_from_js(b)}catch(b){this.raise_nodejs_error(b,d)}};cj.prototype.symlink=function(e,d,b,c){try{this.fs.symlinkSync(this.nm(d),this.nm(b),e?"dir":"file");return 0}catch(b){this.raise_nodejs_error(b,c)}};cj.prototype.readlink=function(c,d){try{var
b=this.fs.readlinkSync(this.nm(c),"utf8");return a4(b)}catch(b){this.raise_nodejs_error(b,d)}};cj.prototype.opendir=function(b,c){try{return this.fs.opendirSync(this.nm(b))}catch(b){this.raise_nodejs_error(b,c)}};cj.prototype.raise_nodejs_error=function(b,e){var
c=d4(nj);if(e&&c){var
d=e2(b.code,b.syscall,b.path,b.errno);e1(c,d)}else
bb(b.toString())};cj.prototype.stats_from_js=function(b){var
c;if(b.isFile())c=0;else
if(b.isDirectory())c=1;else
if(b.isCharacterDevice())c=2;else
if(b.isBlockDevice())c=3;else
if(b.isSymbolicLink())c=4;else
if(b.isFIFO())c=5;else
if(b.isSocket())c=6;return[0,b.dev,b.ino,c,b.mode,b.nlink,b.uid,b.gid,b.rdev,b.size,b.atimeMs,b.mtimeMs,b.ctimeMs]};cj.prototype.constructor=cj;function
Je(c){var
b=r4(c);if(!b)return;return b[0]+dU}var
nX=Je(i5)||dg("unable to compute caml_root"),hr=[];if(jb())hr.push({path:nX,device:new
cj(nX)});else
hr.push({path:nX,device:new
cx(nX)});hr.push({path:ER,device:new
cx(ER)});function
JB(c){var
g=b1f(c),c=g.join(dU),a=Js(c),d;for(var
f=0;f<hr.length;f++){var
b=hr[f];if(a.search(b.path)==0&&(!d||d.path.length<b.path.length))d={path:b.path,device:b.device,rest:c.substring(b.path.length,c.length)}}if(!d&&jb()){var
e=Je(c);if(e&&e.match(/^[a-zA-Z]:\/$/)){var
b={path:e,device:new
cj(e)};hr.push(b);d={path:b.path,device:b.device,rest:c.substring(b.path.length,c.length)}}}if(d)return d;bb("no device found for "+a)}function
b0W(d,c){var
b=JB(d);if(!b.device.register)dg("cannot register file");b.device.register(b.rest,c);return 0}function
Jt(d,c){var
d=b(d),c=b(c);return b0W(d,c)}function
b00(){var
c=bz.caml_fs_tmp;if(c)for(var
b=0;b<c.length;b++)Jt(c[b].name,c[b].content);bz.jsoo_create_file=Jt;bz.caml_fs_tmp=[];return 0}function
Jd(){return[0]}var
nV=[];function
nO(i,h,e){var
c=i[1],g=nV[e];if(g===undefined)for(var
a=nV.length;a<e;a++)nV[a]=0;else
if(c[g]===h)return c[g-1];var
b=3,f=c[1]*2+1,d;while(b<f){d=b+f>>1|1;if(h<c[d+1])f=d-2;else
b=d}nV[e]=b+1;return h==c[b+1]?c[b]:0}function
b01(b,c){return+(nL(b,c,false)>=0)}function
b03(b,e,l){if(!isFinite(b)){if(isNaN(b))return a4(qB);return a4(b>0?IO:"-infinity")}var
j=b==0&&1/b==-Infinity?1:b>=0?0:1;if(j)b=-b;var
f=0;if(b==0);else
if(b<1)while(b<1&&f>-GT){b*=2;f--}else
while(b>=2){b/=2;f++}var
k=f<0?d:eV,a=d;if(j)a=cz;else
switch(l){case
43:a=eV;break;case
32:a=eX;break;default:break}if(e>=0&&e<13){var
h=Math.pow(2,e*4);b=Math.round(b*h)/h}var
c=b.toString(16);if(e>=0){var
i=c.indexOf(ej);if(i<0)c+=ej+hq(e,r);else{var
g=i+1+e;if(c.length<g)c+=hq(g-c.length,r);else
c=c.substr(0,g)}}return a4(a+BO+c+"p"+k+f.toString(10))}function
b09(b){return+b.isZero()}function
b1a(b){return new
aU(b&eR,b>>24&eR,b>>31&d$)}function
b1c(b){return b.toInt()}function
b08(b){return+b.isNeg()}function
b0$(b){return b.neg()}function
b06(h,e){var
b=rU(h);if(b.signedconv&&b08(e)){b.sign=-1;e=b0$(e)}var
c=d,i=b1a(b.base),g="0123456789abcdef";do{var
a=e.udivmod(i);e=a.quotient;c=g.charAt(b1c(a.modulus))+c}while(!b09(e));if(b.prec>=0){b.filler=eX;var
f=b.prec-c.length;if(f>0)c=hq(f,r)+c}return rL(b,c)}function
b1b(b,c){return b.or(c)}function
nQ(b){return b.toFloat()}function
b1l(d){var
b=0,f=aM(d),c=10,e=1;if(f>0)switch(dh(d,b)){case
45:b++;e=-1;break;case
43:b++;e=1;break}if(b+1<f&&dh(d,b)==48)switch(dh(d,b+1)){case
120:case
88:c=16;b+=2;break;case
111:case
79:c=8;b+=2;break;case
98:case
66:c=2;b+=2;break;case
117:case
85:b+=2;break}return[b,e,c]}function
Jo(b){if(b>=48&&b<=57)return b-48;if(b>=65&&b<=90)return b-55;if(b>=97&&b<=lE)return b-87;return-1}function
nR(a){var
h=b1l(a),d=h[0],i=h[1],e=h[2],g=aM(a),j=-1>>>0,f=d<g?dh(a,d):0,c=Jo(f);if(c<0||c>=e)dg(kj);var
b=c;for(d++;d<g;d++){f=dh(a,d);if(f==95)continue;c=Jo(f);if(c<0||c>=e)break;b=e*b+c;if(b>j)dg(kj)}if(d!=g)dg(kj);b=i*b;if(e==10&&(b|0)!=b)dg(kj);return b|0}function
fz(b){return b.slice(1)}function
i8(d){var
e=d.length,c=new
Array(e+1);c[0]=0;for(var
b=0;b<e;b++)c[b+1]=d[b];return c}function
bh(d){return function(){var
c=arguments.length;if(c>0){var
e=new
Array(c);for(var
b=0;b<c;b++)e[b]=arguments[b];return du(d,e)}else
return du(d,[undefined])}}function
am(e){return function(){var
d=arguments.length,c=new
Array(d+1);c[0]=this;for(var
b=0;b<d;b++)c[b+1]=arguments[b];return du(e,c)}}function
nT(c,b){b|=0;if(b>dW){b-=dW;c*=Math.pow(2,dW);if(b>dW){b-=dW;c*=Math.pow(2,dW)}}if(b<-dW){b+=dW;c*=Math.pow(2,-dW)}c*=Math.pow(2,b);return c}function
Ji(b,c){return+(nL(b,c,false)<0)}function
i9(c){c=es(c);var
e=c.length/2,d=new
Array(e);for(var
b=0;b<e;b++)d[b]=(c.charCodeAt(2*b)|c.charCodeAt(2*b+1)<<8)<<16>>16;return d}function
rS(c,t,b){var
n=2,o=3,r=5,e=6,h=7,g=8,j=9,m=1,l=2,q=3,s=4,p=5;if(!c.lex_default){c.lex_base=i9(c[m]);c.lex_backtrk=i9(c[l]);c.lex_check=i9(c[p]);c.lex_trans=i9(c[s]);c.lex_default=i9(c[q])}var
f,d=t,k=r0(b[n]);if(d>=0){b[h]=b[r]=b[e];b[g]=-1}else
d=-d-1;for(;;){var
a=c.lex_base[d];if(a<0)return-a-1;var
i=c.lex_backtrk[d];if(i>=0){b[h]=b[e];b[g]=i}if(b[e]>=b[o])if(b[j]==0)return-d-1;else
f=fc;else{f=k[b[e]];b[e]++}if(c.lex_check[a+f]==d)d=c.lex_trans[a+f];else
d=c.lex_default[d];if(d<0){b[e]=b[h];if(b[g]==-1)dg("lexing: empty token");else
return b[g]}else
if(f==fc)b[j]=0}}function
nU(b,e){if(b<0)i4();var
b=b+1|0,c=new
Array(b);c[0]=0;for(var
d=1;d<b;d++)c[d]=e;return c}function
b1g(){return 0}var
e0=new
Array();function
et(c){var
b=e0[c];if(!b.opened)bb("Cannot flush a closed channel");if(!b.buffer||b.buffer_curr==0)return 0;if(b.output)b.output(nY(b.buffer,0,b.buffer_curr));else
b.file.write(b.offset,b.buffer,0,b.buffer_curr);b.offset+=b.buffer_curr;b.buffer_curr=0;return 0}function
b1s(c,b){if(b.name)try{var
e=require("fs"),d=e.openSync(b.name,"rs");return new
d2(d,b)}catch(a){}return new
d2(c,b)}var
nZ=new
Array(3);function
i3(b,c){cP.call(this,b_(0));this.log=function(b){return 0};if(b==1&&typeof
console.log=="function")this.log=console.log;else
if(b==2&&typeof
console.error=="function")this.log=console.error;else
if(typeof
console.log=="function")this.log=console.log;this.flags=c}i3.prototype.length=function(){return 0};i3.prototype.write=function(f,d,c,b){if(this.log){if(b>0&&c>=0&&c+b<=d.length&&d[c+b-1]==10)b--;var
e=b_(b);eZ(rI(d),c,e,0,b);this.log(e.toUtf16());return 0}bb(this.fd+DL)};i3.prototype.read=function(d,b,e,c){bb(this.fd+": file descriptor is write only")};i3.prototype.close=function(){this.log=undefined};function
n0(c,b){if(b==undefined)b=nZ.length;nZ[b]=c;return b}function
b1T(d,c,a){var
b={};while(c){switch(c[1]){case
0:b.rdonly=1;break;case
1:b.wronly=1;break;case
2:b.append=1;break;case
3:b.create=1;break;case
4:b.truncate=1;break;case
5:b.excl=1;break;case
6:b.binary=1;break;case
7:b.text=1;break;case
8:b.nonblock=1;break}c=c[2]}if(b.rdonly&&b.wronly)bb(es(d)+qo);if(b.text&&b.binary)bb(es(d)+q8);var
e=JB(d),f=e.device.open(e.rest,b);return n0(f,undefined)}(function(){function
b(b,c){return jb()?b1s(b,c):new
i3(b,c)}n0(b(0,{rdonly:1,altname:"/dev/stdin",isCharacterDevice:true}),0);n0(b(1,{buffered:2,wronly:1,isCharacterDevice:true}),1);n0(b(2,{buffered:2,wronly:1,isCharacterDevice:true}),2)}());function
b1h(d){var
b=nZ[d];if(b.flags.wronly)bb(v0+d+" is writeonly");var
e=null,c={file:b,offset:b.flags.append?b.length():0,fd:d,opened:true,out:false,buffer_curr:0,buffer_max:0,buffer:new
Uint8Array(Ec),refill:e};e0[c.fd]=c;return c.fd}function
Jj(d){var
b=nZ[d];if(b.flags.rdonly)bb(v0+d+" is readonly");var
e=b.flags.buffered!==undefined?b.flags.buffered:1,c={file:b,offset:b.flags.append?b.length():0,fd:d,opened:true,out:true,buffer_curr:0,buffer:new
Uint8Array(Ec),buffered:e};e0[c.fd]=c;return c.fd}function
b1i(){var
c=0;for(var
b=0;b<e0.length;b++)if(e0[b]&&e0[b].opened&&e0[b].out)c=[0,e0[b].fd,c];return c}function
cQ(b){return b}function
b1j(d,c,a,g){var
b=e0[d];if(!b.opened)bb("Cannot output to a closed channel");var
c=r0(c);c=c.subarray(a,a+g);if(b.buffer_curr+c.length>b.buffer.length){var
f=new
Uint8Array(b.buffer_curr+c.length);f.set(b.buffer);b.buffer=f}switch(b.buffered){case
0:b.buffer.set(c,b.buffer_curr);b.buffer_curr+=c.length;et(d);break;case
1:b.buffer.set(c,b.buffer_curr);b.buffer_curr+=c.length;if(b.buffer_curr>=b.buffer.length)et(d);break;case
2:var
e=c.lastIndexOf(10);if(e<0){b.buffer.set(c,b.buffer_curr);b.buffer_curr+=c.length;if(b.buffer_curr>=b.buffer.length)et(d)}else{b.buffer.set(c.subarray(0,e+1),b.buffer_curr);b.buffer_curr+=e+1;et(d);b.buffer.set(c.subarray(e+1),b.buffer_curr);b.buffer_curr+=c.length-e-1}break}return 0}function
rT(c,b,e,d){return b1j(c,fw(b),e,d)}function
Jk(d,c){var
e=b(String.fromCharCode(c));rT(d,e,0,1);return 0}function
i_(b,c){return+(nL(b,c,false)!=0)}function
Jm(e,d){var
c=new
Array(d+1);c[0]=e;for(var
b=1;b<=d;b++)c[b]=0;return c}function
nW(b){if(b
instanceof
Array&&b[0]==b[0]>>>0)return b[0];else
if(nS(b))return kb;else
if(rR(b))return kb;else
if(b
instanceof
Function||typeof
b=="function")return 247;else
if(b&&b.caml_custom)return qA;else
return g_}function
dS(c,d,b){if(b&&bz.toplevelReloc)c=bz.toplevelReloc(b);dQ[c+1]=d;if(b)dQ[b]=d}function
rW(b,c){Jl[es(b)]=c;return 0}function
b1o(b){b[2]=Jn++;return b}function
b0T(b,c){if(b===c)return 1;b.t&6&&hn(b);c.t&6&&hn(c);return b.c==c.c?1:0}function
rY(b,c){return b0T(b,c)}function
b1q(){bS(rd)}function
bJ(c,b){if(b>>>0>=aM(c))b1q();return dh(c,b)}function
R(b,c){return 1-rY(b,c)}function
b1r(){return 0x7FFFFFFF/4|0}function
b1m(){i$(dQ.Not_found)}function
Jr(d){var
c=bz.process,b=dR(d);if(c&&c.env&&c.env[b]!=undefined)return a4(c.env[b]);if(bz.jsoo_static_env&&bz.jsoo_static_env[b])return a4(bz.jsoo_static_env[b]);b1m()}function
rZ(b){var
c=1;while(b&&b.joo_tramp){b=b.joo_tramp.apply(null,b.joo_args);c++}return b}function
cs(c,b){return{joo_tramp:c,joo_args:b}}function
Jq(b){return b}function
n(b){if(b
instanceof
Array)return b;if(bz.RangeError&&b
instanceof
bz.RangeError&&b.message&&b.message.match(/maximum call stack/i))return Jq(dQ.Stack_overflow);if(bz.InternalError&&b
instanceof
bz.InternalError&&b.message&&b.message.match(/too much recursion/i))return Jq(dQ.Stack_overflow);if(b
instanceof
bz.Error&&d4(qZ))return[0,d4(qZ),b];return[0,dQ.Failure,a4(String(b))]}var
av=function(A){"use strict";var
g=fS,aa=7,t=9007199254740992,I=p(t),N="0123456789abcdefghijklmnopqrstuvwxyz",h=b1x.BigInt,G=typeof
h==="function";function
f(b,c,d,e){if(typeof
b==="undefined")return f[0];if(typeof
c!=="undefined")return+c===10&&!d?a(b):ae(b,c,d,e);return a(b)}function
b(c,b){this.value=c;this.sign=b;this.isSmall=false;this.caml_custom=md}b.prototype=Object.create(f.prototype);function
c(b){this.value=b;this.sign=b<0;this.isSmall=true;this.caml_custom=md}c.prototype=Object.create(f.prototype);function
e(b){this.value=b;this.caml_custom=md}e.prototype=Object.create(f.prototype);function
o(b){return-t<b&&b<t}function
p(b){if(b<fS)return[b];if(b<IC)return[b%fS,Math.floor(b/fS)];return[b%fS,Math.floor(b/fS)%fS,Math.floor(b/IC)]}function
l(b){q(b);var
c=b.length;if(c<4&&m(b,I)<0)switch(c){case
0:return 0;case
1:return b[0];case
2:return b[0]+b[1]*g;default:return b[0]+(b[1]+b[2]*g)*g}return b}function
q(b){var
c=b.length;while(b[--c]===0);b.length=c+1}function
C(c){var
d=new
Array(c),b=-1;while(++b<c)d[b]=0;return d}function
s(b){if(b>0)return Math.floor(b);return Math.ceil(b)}function
O(a,h){var
i=a.length,j=h.length,f=new
Array(i),c=0,e=g,d,b;for(b=0;b<j;b++){d=a[b]+h[b]+c;c=d>=e?1:0;f[b]=d-c*e}while(b<i){d=a[b]+c;c=d===e?1:0;f[b++]=d-c*e}if(c>0)f.push(c);return f}function
u(b,c){if(b.length>=c.length)return O(b,c);return O(c,b)}function
B(a,b){var
h=a.length,e=new
Array(h),d=g,f,c;for(c=0;c<h;c++){f=a[c]-d+b;b=Math.floor(f/d);e[c]=f-b*d;b+=1}while(b>0){e[c++]=b%d;b=Math.floor(b/d)}return e}b.prototype.add=function(f){var
c=a(f);if(this.sign!==c.sign)return this.subtract(c.negate());var
d=this.value,e=c.value;if(c.isSmall)return new
b(B(d,Math.abs(e)),this.sign);return new
b(u(d,e),this.sign)};b.prototype.plus=b.prototype.add;c.prototype.add=function(g){var
f=a(g),d=this.value;if(d<0!==f.sign)return this.subtract(f.negate());var
e=f.value;if(f.isSmall){if(o(d+e))return new
c(d+e);e=p(Math.abs(e))}return new
b(B(e,Math.abs(d)),d<0)};c.prototype.plus=c.prototype.add;e.prototype.add=function(b){return new
e(this.value+a(b).value)};e.prototype.plus=e.prototype.add;function
x(e,h){var
a=e.length,i=h.length,d=new
Array(a),f=0,j=g,b,c;for(b=0;b<i;b++){c=e[b]-f-h[b];if(c<0){c+=j;f=1}else
f=0;d[b]=c}for(b=i;b<a;b++){c=e[b]-f;if(c<0)c+=j;else{d[b++]=c;break}d[b]=c}for(;b<a;b++)d[b]=e[b];q(d);return d}function
ai(f,a,e){var
d;if(m(f,a)>=0)d=x(f,a);else{d=x(a,f);e=!e}d=l(d);if(typeof
d==="number"){if(e)d=-d;return new
c(d)}return new
b(d,e)}function
F(h,m,k){var
j=h.length,d=new
Array(j),i=-m,a=g,f,e;for(f=0;f<j;f++){e=h[f]+i;i=Math.floor(e/a);e%=a;d[f]=e<0?e+a:e}d=l(d);if(typeof
d==="number"){if(k)d=-d;return new
c(d)}return new
b(d,k)}b.prototype.subtract=function(e){var
b=a(e);if(this.sign!==b.sign)return this.add(b.negate());var
c=this.value,d=b.value;if(b.isSmall)return F(c,Math.abs(d),this.sign);return ai(c,d,this.sign)};b.prototype.minus=b.prototype.subtract;c.prototype.subtract=function(f){var
d=a(f),b=this.value;if(b<0!==d.sign)return this.add(d.negate());var
e=d.value;if(d.isSmall)return new
c(b-e);return F(e,Math.abs(b),b>=0)};c.prototype.minus=c.prototype.subtract;e.prototype.subtract=function(b){return new
e(this.value-a(b).value)};e.prototype.minus=e.prototype.subtract;b.prototype.negate=function(){return new
b(this.value,!this.sign)};c.prototype.negate=function(){var
d=this.sign,b=new
c(-this.value);b.sign=!d;return b};e.prototype.negate=function(){return new
e(-this.value)};b.prototype.abs=function(){return new
b(this.value,false)};c.prototype.abs=function(){return new
c(Math.abs(this.value))};e.prototype.abs=function(){return new
e(this.value>=0?this.value:-this.value)};function
M(a,j){var
i=a.length,l=j.length,n=i+l,d=C(n),m=g,f,e,b,h,k;for(b=0;b<i;++b){h=a[b];for(var
c=0;c<l;++c){k=j[c];f=h*k+d[b+c];e=Math.floor(f/m);d[b+c]=f-e*m;d[b+c+1]+=e}}q(d);return d}function
v(a,i){var
h=a.length,f=new
Array(h),d=g,b=0,e,c;for(c=0;c<h;c++){e=a[c]*i+b;b=Math.floor(e/d);f[c]=e-b*d}while(b>0){f[c++]=b%d;b=Math.floor(b/d)}return f}function
X(d,c){var
b=[];while(c-->0)b.push(0);return b.concat(d)}function
D(c,d){var
b=Math.max(c.length,d.length);if(b<=30)return M(c,d);b=Math.ceil(b/2);var
a=c.slice(b),e=c.slice(0,b),i=d.slice(b),h=d.slice(0,b),f=D(e,h),g=D(a,i),k=D(u(e,a),u(h,i)),j=u(u(f,X(x(x(k,f),g),b)),X(g,2*b));q(j);return j}function
aj(b,c){return-(vF*b)-vF*c+0.000015*b*c>0}b.prototype.multiply=function(j){var
h=a(j),d=this.value,c=h.value,i=this.sign!==h.sign,e;if(h.isSmall){if(c===0)return f[0];if(c===1)return this;if(c===-1)return this.negate();e=Math.abs(c);if(e<g)return new
b(v(d,e),i);c=p(e)}if(aj(d.length,c.length))return new
b(D(d,c),i);return new
b(M(d,c),i)};b.prototype.times=b.prototype.multiply;function
U(c,d,e){if(c<g)return new
b(v(d,c),e);return new
b(M(d,p(c)),e)}c.prototype._multiplyBySmall=function(b){if(o(b.value*this.value))return new
c(b.value*this.value);return U(Math.abs(b.value),p(Math.abs(this.value)),this.sign!==b.sign)};b.prototype._multiplyBySmall=function(b){if(b.value===0)return f[0];if(b.value===1)return this;if(b.value===-1)return this.negate();return U(Math.abs(b.value),this.value,this.sign!==b.sign)};c.prototype.multiply=function(b){return a(b)._multiplyBySmall(this)};c.prototype.times=c.prototype.multiply;e.prototype.multiply=function(b){return new
e(this.value*a(b).value)};e.prototype.times=e.prototype.multiply;function
Z(h){var
e=h.length,f=C(e+e),k=g,i,c,b,a,j;for(b=0;b<e;b++){a=h[b];c=0-a*a;for(var
d=b;d<e;d++){j=h[d];i=2*(a*j)+f[b+d]+c;c=Math.floor(i/k);f[b+d]=i-c*k}f[b+e]=c}q(f);return f}b.prototype.square=function(){return new
b(Z(this.value),false)};c.prototype.square=function(){var
d=this.value*this.value;if(o(d))return new
c(d);return new
b(Z(p(Math.abs(this.value))),false)};e.prototype.square=function(b){return new
e(this.value*this.value)};function
ab(q,k){var
r=q.length,h=k.length,a=g,s=C(k.length),m=k[h-1],o=Math.ceil(a/(2*m)),c=v(q,o),i=v(k,o),j,e,d,f,b,n,p;if(c.length<=r)c.push(0);i.push(0);m=i[h-1];for(e=r-h;e>=0;e--){j=a-1;if(c[e+h]!==m)j=Math.floor((c[e+h]*a+c[e+h-1])/m);d=0;f=0;n=i.length;for(b=0;b<n;b++){d+=j*i[b];p=Math.floor(d/a);f+=c[e+b]-(d-p*a);d=p;if(f<0){c[e+b]=f+a;f=-1}else{c[e+b]=f;f=0}}while(f!==0){j-=1;d=0;for(b=0;b<n;b++){d+=c[e+b]-a+i[b];if(d<0){c[e+b]=d+a;d=0}else{c[e+b]=d;d=1}}f+=d}s[e]=j}c=P(c,o)[0];return[l(s),l(c)]}function
ac(k,c){var
n=k.length,h=c.length,f=[],b=[],i=g,d,a,e,o,j;while(n){b.unshift(k[--n]);q(b);if(m(b,c)<0){f.push(0);continue}a=b.length;e=b[a-1]*i+b[a-2];o=c[h-1]*i+c[h-2];if(a>h)e=(e+1)*i;d=Math.ceil(e/o);do{j=v(c,d);if(m(j,b)<=0)break;d--}while(d);f.push(d);b=x(b,j)}f.reverse();return[l(f),l(b)]}function
P(i,f){var
a=i.length,h=C(a),j=g,b,e,c,d;c=0;for(b=a-1;b>=0;--b){d=c*j+i[b];e=s(d/f);c=d-e*f;h[b]=e|0}return[h,c|0]}function
j(h,w){var
o,j=a(w);if(G)return[new
e(h.value/j.value),new
e(h.value%j.value)];var
n=h.value,i=j.value,d;if(i===0)throw new
Error("Cannot divide by zero");if(h.isSmall){if(j.isSmall)return[new
c(s(n/i)),new
c(n%i)];return[f[0],h]}if(j.isSmall){if(i===1)return[h,f[0]];if(i==-1)return[h.negate(),f[0]];var
r=Math.abs(i);if(r<g){o=P(n,r);d=l(o[0]);var
q=o[1];if(h.sign)q=-q;if(typeof
d==="number"){if(h.sign!==j.sign)d=-d;return[new
c(d),new
c(q)]}return[new
b(d,h.sign!==j.sign),new
c(q)]}i=p(r)}var
t=m(n,i);if(t===-1)return[f[0],h];if(t===0)return[f[h.sign===j.sign?1:-1],f[0]];if(n.length+i.length<=fR)o=ab(n,i);else
o=ac(n,i);d=o[0];var
v=h.sign!==j.sign,k=o[1],u=h.sign;if(typeof
d==="number"){if(v)d=-d;d=new
c(d)}else
d=new
b(d,v);if(typeof
k==="number"){if(u)k=-k;k=new
c(k)}else
k=new
b(k,u);return[d,k]}b.prototype.divmod=function(c){var
b=j(this,c);return{quotient:b[0],remainder:b[1]}};e.prototype.divmod=c.prototype.divmod=b.prototype.divmod;b.prototype.divide=function(b){return j(this,b)[0]};e.prototype.over=e.prototype.divide=function(b){return new
e(this.value/a(b).value)};c.prototype.over=c.prototype.divide=b.prototype.over=b.prototype.divide;b.prototype.mod=function(b){return j(this,b)[1]};e.prototype.mod=e.prototype.remainder=function(b){return new
e(this.value%a(b).value)};c.prototype.remainder=c.prototype.mod=b.prototype.remainder=b.prototype.mod;b.prototype.pow=function(j){var
d=a(j),e=this.value,b=d.value,i,g,h;if(b===0)return f[1];if(e===0)return f[0];if(e===1)return f[1];if(e===-1)return d.isEven()?f[1]:f[-1];if(d.sign)return f[0];if(!d.isSmall)throw new
Error("The exponent "+d.toString()+" is too large.");if(this.isSmall)if(o(i=Math.pow(e,b)))return new
c(s(i));g=this;h=f[1];while(true){if(b&1===1){h=h.times(g);--b}if(b===0)break;b/=2;g=g.square()}return h};c.prototype.pow=b.prototype.pow;e.prototype.pow=function(m){var
i=a(m),g=this.value,b=i.value,c=h(0),d=h(1),l=h(2);if(b===c)return f[1];if(g===c)return f[0];if(g===d)return f[1];if(g===h(-1))return i.isEven()?f[1]:f[-1];if(i.isNegative())return new
e(c);var
j=this,k=f[1];while(true){if((b&d)===d){k=k.times(j);--b}if(b===c)break;b/=l;j=j.square()}return k};b.prototype.modPow=function(b,c){b=a(b);c=a(c);if(c.isZero())throw new
Error("Cannot take modPow with modulus 0");var
e=f[1],d=this.mod(c);if(b.isNegative()){b=b.multiply(f[-1]);d=d.modInv(c)}while(b.isPositive()){if(d.isZero())return f[0];if(b.isOdd())e=e.multiply(d).mod(c);b=b.divide(2);d=d.square().mod(c)}return e};e.prototype.modPow=c.prototype.modPow=b.prototype.modPow;function
m(c,d){if(c.length!==d.length)return c.length>d.length?1:-1;for(var
b=c.length-1;b>=0;b--)if(c[b]!==d[b])return c[b]>d[b]?1:-1;return 0}b.prototype.compareAbs=function(e){var
b=a(e),c=this.value,d=b.value;if(b.isSmall)return 1;return m(c,d)};c.prototype.compareAbs=function(e){var
d=a(e),c=Math.abs(this.value),b=d.value;if(d.isSmall){b=Math.abs(b);return c===b?0:c>b?1:-1}return-1};e.prototype.compareAbs=function(d){var
b=this.value,c=a(d).value;b=b>=0?b:-b;c=c>=0?c:-c;return b===c?0:b>c?1:-1};b.prototype.compare=function(c){if(c===Infinity)return-1;if(c===-Infinity)return 1;var
b=a(c),d=this.value,e=b.value;if(this.sign!==b.sign)return b.sign?1:-1;if(b.isSmall)return this.sign?-1:1;return m(d,e)*(this.sign?-1:1)};b.prototype.compareTo=b.prototype.compare;c.prototype.compare=function(d){if(d===Infinity)return-1;if(d===-Infinity)return 1;var
c=a(d),b=this.value,e=c.value;if(c.isSmall)return b==e?0:b>e?1:-1;if(b<0!==c.sign)return b<0?-1:1;return b<0?1:-1};c.prototype.compareTo=c.prototype.compare;e.prototype.compare=function(b){if(b===Infinity)return-1;if(b===-Infinity)return 1;var
c=this.value,d=a(b).value;return c===d?0:c>d?1:-1};e.prototype.compareTo=e.prototype.compare;b.prototype.equals=function(b){return this.compare(b)===0};e.prototype.eq=e.prototype.equals=c.prototype.eq=c.prototype.equals=b.prototype.eq=b.prototype.equals;b.prototype.notEquals=function(b){return this.compare(b)!==0};e.prototype.neq=e.prototype.notEquals=c.prototype.neq=c.prototype.notEquals=b.prototype.neq=b.prototype.notEquals;b.prototype.greater=function(b){return this.compare(b)>0};e.prototype.gt=e.prototype.greater=c.prototype.gt=c.prototype.greater=b.prototype.gt=b.prototype.greater;b.prototype.lesser=function(b){return this.compare(b)<0};e.prototype.lt=e.prototype.lesser=c.prototype.lt=c.prototype.lesser=b.prototype.lt=b.prototype.lesser;b.prototype.greaterOrEquals=function(b){return this.compare(b)>=0};e.prototype.geq=e.prototype.greaterOrEquals=c.prototype.geq=c.prototype.greaterOrEquals=b.prototype.geq=b.prototype.greaterOrEquals;b.prototype.lesserOrEquals=function(b){return this.compare(b)<=0};e.prototype.leq=e.prototype.lesserOrEquals=c.prototype.leq=c.prototype.lesserOrEquals=b.prototype.leq=b.prototype.lesserOrEquals;b.prototype.isEven=function(){return(this.value[0]&1)===0};c.prototype.isEven=function(){return(this.value&1)===0};e.prototype.isEven=function(){return(this.value&h(1))===h(0)};b.prototype.isOdd=function(){return(this.value[0]&1)===1};c.prototype.isOdd=function(){return(this.value&1)===1};e.prototype.isOdd=function(){return(this.value&h(1))===h(1)};b.prototype.isPositive=function(){return!this.sign};c.prototype.isPositive=function(){return this.value>0};e.prototype.isPositive=c.prototype.isPositive;b.prototype.isNegative=function(){return this.sign};c.prototype.isNegative=function(){return this.value<0};e.prototype.isNegative=c.prototype.isNegative;b.prototype.isUnit=function(){return false};c.prototype.isUnit=function(){return Math.abs(this.value)===1};e.prototype.isUnit=function(){return this.abs().value===h(1)};b.prototype.isZero=function(){return false};c.prototype.isZero=function(){return this.value===0};e.prototype.isZero=function(){return this.value===h(0)};b.prototype.isDivisibleBy=function(c){var
b=a(c);if(b.isZero())return false;if(b.isUnit())return true;if(b.compareAbs(2)===0)return this.isEven();return this.mod(b).isZero()};e.prototype.isDivisibleBy=c.prototype.isDivisibleBy=b.prototype.isDivisibleBy;function
S(c){var
b=c.abs();if(b.isUnit())return false;if(b.equals(2)||b.equals(3)||b.equals(5))return true;if(b.isEven()||b.isDivisibleBy(3)||b.isDivisibleBy(5))return false;if(b.lesser(49))return true}function
K(e,f){var
g=e.prev(),d=g,h=0,a,i,c,b;while(d.isEven())d=d.divide(2),h++;next:for(c=0;c<f.length;c++){if(e.lesser(f[c]))continue;b=av(f[c]).modPow(d,e);if(b.isUnit()||b.equals(g))continue;for(a=h-1;a!=0;a--){b=b.square().mod(e);if(b.isUnit())return false;if(b.equals(g))continue next}return false}return true}b.prototype.isPrime=function(g){var
f=S(this);if(f!==A)return f;var
c=this.abs(),e=c.bitLength();if(e<=64)return K(c,[2,3,5,7,11,13,17,19,23,29,31,37]);var
a=Math.log(2)*e.toJSNumber(),h=Math.ceil(g===true?2*Math.pow(a,2):a);for(var
d=[],b=0;b<h;b++)d.push(av(b+2));return K(c,d)};e.prototype.isPrime=c.prototype.isPrime=b.prototype.isPrime;b.prototype.isProbablePrime=function(e){var
d=S(this);if(d!==A)return d;var
f=this.abs(),a=e===A?5:e;for(var
b=[],c=0;c<a;c++)b.push(av.randBetween(2,f.minus(2)));return K(f,b)};e.prototype.isProbablePrime=c.prototype.isProbablePrime=b.prototype.isProbablePrime;b.prototype.modInv=function(e){var
b=av.zero,f=av.one,d=a(e),c=this.abs(),g,i,h;while(!c.isZero()){g=d.divide(c);i=b;h=d;b=f;d=c;f=i.subtract(g.multiply(f));c=h.subtract(g.multiply(c))}if(!d.isUnit())throw new
Error(this.toString()+" and "+e.toString()+" are not co-prime");if(b.compare(0)===-1)b=b.add(e);if(this.isNegative())return b.negate();return b};e.prototype.modInv=c.prototype.modInv=b.prototype.modInv;b.prototype.next=function(){var
c=this.value;if(this.sign)return F(c,1,this.sign);return new
b(B(c,1),this.sign)};c.prototype.next=function(){var
d=this.value;if(d+1<t)return new
c(d+1);return new
b(I,false)};e.prototype.next=function(){return new
e(this.value+h(1))};b.prototype.prev=function(){var
c=this.value;if(this.sign)return new
b(B(c,1),true);return F(c,1,this.sign)};c.prototype.prev=function(){var
d=this.value;if(d-1>-t)return new
c(d-1);return new
b(I,true)};e.prototype.prev=function(){return new
e(this.value-h(1))};var
i=[1];while(2*i[i.length-1]<=g)i.push(2*i[i.length-1]);var
w=i.length,k=i[w-1];function
Y(b){return Math.abs(b)<=g}b.prototype.shiftLeft=function(d){var
b=a(d).toJSNumber();if(!Y(b))throw new
Error(String(b)+Cq);if(b<0)return this.shiftRight(-b);var
c=this;if(c.isZero())return c;while(b>=w){c=c.multiply(k);b-=w-1}return c.multiply(i[b])};e.prototype.shiftLeft=c.prototype.shiftLeft=b.prototype.shiftLeft;b.prototype.shiftRight=function(e){var
b,c=a(e).toJSNumber();if(!Y(c))throw new
Error(String(c)+Cq);if(c<0)return this.shiftLeft(-c);var
d=this;while(c>=w){if(d.isZero()||d.isNegative()&&d.isUnit())return d;b=j(d,k);d=b[1].isNegative()?b[0].prev():b[0];c-=w-1}b=j(d,i[c]);return b[1].isNegative()?b[0].prev():b[0]};e.prototype.shiftRight=c.prototype.shiftRight=b.prototype.shiftRight;function
J(h,b,q){b=a(b);var
m=h.isNegative(),p=b.isNegative(),l=m?h.not():h,o=p?b.not():b,c=0,d=0,i=null,n=null,f=[];while(!l.isZero()||!o.isZero()){i=j(l,k);c=i[1].toJSNumber();if(m)c=k-1-c;n=j(o,k);d=n[1].toJSNumber();if(p)d=k-1-d;l=i[0];o=n[0];f.push(q(c,d))}var
g=q(m?1:0,p?1:0)!==0?av(-1):av(0);for(var
e=f.length-1;e>=0;e-=1)g=g.multiply(k).add(av(f[e]));return g}b.prototype.not=function(){return this.negate().prev()};e.prototype.not=c.prototype.not=b.prototype.not;b.prototype.and=function(b){return J(this,b,function(b,c){return b&c})};e.prototype.and=c.prototype.and=b.prototype.and;b.prototype.or=function(b){return J(this,b,function(b,c){return b|c})};e.prototype.or=c.prototype.or=b.prototype.or;b.prototype.xor=function(b){return J(this,b,function(b,c){return b^c})};e.prototype.xor=c.prototype.xor=b.prototype.xor;var
H=1<<30,$=(g&-g)*(g&-g)|H;function
E(d){var
b=d.value,c=typeof
b==="number"?b|H:typeof
b==="bigint"?b|h(H):b[0]+b[1]*g|$;return c&-c}function
R(c,b){if(b.compareTo(c)<=0){var
a=R(c,b.square(b)),e=a.p,d=a.e,f=e.multiply(b);return f.compareTo(c)<=0?{p:f,e:d*2+1}:{p:e,e:d*2}}return{p:av(1),e:0}}b.prototype.bitLength=function(){var
b=this;if(b.compareTo(av(0))<0)b=b.negate().subtract(av(1));if(b.compareTo(av(0))===0)return av(0);return av(R(b,av(2)).e).add(av(1))};e.prototype.bitLength=c.prototype.bitLength=b.prototype.bitLength;function
T(b,c){b=a(b);c=a(c);return b.greater(c)?b:c}function
L(b,c){b=a(b);c=a(c);return b.lesser(c)?b:c}function
Q(b,c){b=a(b).abs();c=a(c).abs();if(b.equals(c))return b;if(b.isZero())return c;if(c.isZero())return b;var
d=f[1],e,g;while(b.isEven()&&c.isEven()){e=L(E(b),E(c));b=b.divide(e);c=c.divide(e);d=d.multiply(e)}while(b.isEven())b=b.divide(E(b));do{while(c.isEven())c=c.divide(E(c));if(b.greater(c)){g=c;c=b;b=g}c=c.subtract(b)}while(!c.isZero());return d.isUnit()?b:b.multiply(d)}function
ad(b,c){b=a(b).abs();c=a(c).abs();return b.divide(Q(b,c)).multiply(c)}function
ag(b,c){b=a(b);c=a(c);var
e=L(b,c),n=T(b,c),h=n.subtract(e).add(1);if(h.isSmall)return e.add(Math.floor(Math.random()*h));var
j=z(h,g).value,l=[],k=true;for(var
d=0;d<j.length;d++){var
m=k?j[d]:g,i=s(Math.random()*m);l.push(i);if(i<m)k=false}return e.add(f.fromArray(l,g,false))}function
ae(c,g,e,k){e=e||N;c=String(c);if(!k){c=c.toLowerCase();e=e.toLowerCase()}var
l=c.length,b,i=Math.abs(g),f={};for(b=0;b<e.length;b++)f[e[b]]=b;for(b=0;b<l;b++){var
d=c[b];if(d===cz)continue;if(d
in
f)if(f[d]>=i){if(d===y&&i===1)continue;throw new
Error(d+" is not a valid digit in base "+g+ej)}}g=a(g);var
h=[],j=c[0]===cz;for(b=j?1:0;b<c.length;b++){var
d=c[b];if(d
in
f)h.push(a(f[d]));else
if(d===rb){var
m=b;do
b++;while(c[b]!==kA&&b<c.length);h.push(a(c.slice(m+1,b)))}else
throw new
Error(d+" is not a valid character")}return V(h,g,j)}function
V(e,a,g){var
c=f[0],d=f[1],b;for(b=e.length-1;b>=0;b--){c=c.add(e[b].times(d));d=d.times(a)}return g?c.negate():c}function
ah(c,b){b=b||N;if(c<b.length)return b[c];return rb+c+kA}function
z(b,c){c=av(c);if(c.isZero()){if(b.isZero())return{value:[0],isNegative:false};throw new
Error("Cannot convert nonzero numbers to base 0.")}if(c.equals(-1)){if(b.isZero())return{value:[0],isNegative:false};if(b.isNegative())return{value:[].concat.apply([],Array.apply(null,Array(-b.toJSNumber())).map(Array.prototype.valueOf,[1,0])),isNegative:false};var
h=Array.apply(null,Array(b.toJSNumber()-1)).map(Array.prototype.valueOf,[0,1]);h.unshift([1]);return{value:[].concat.apply([],h),isNegative:false}}var
a=false;if(b.isNegative()&&c.isPositive()){a=true;b=b.abs()}if(c.isUnit()){if(b.isZero())return{value:[0],isNegative:false};return{value:Array.apply(null,Array(b.toJSNumber())).map(Number.prototype.valueOf,1),isNegative:a}}var
g=[],d=b,f;while(d.isNegative()||d.compareAbs(c)>=0){f=d.divmod(c);d=f.quotient;var
e=f.remainder;if(e.isNegative()){e=c.minus(e).abs();d=d.next()}g.push(e.toJSNumber())}g.push(d.toJSNumber());return{value:g.reverse(),isNegative:a}}function
_(f,e,c){var
b=z(f,e);return(b.isNegative?cz:d)+b.value.map(function(b){return ah(b,c)}).join(d)}b.prototype.toArray=function(b){return z(this,b)};c.prototype.toArray=function(b){return z(this,b)};e.prototype.toArray=function(b){return z(this,b)};b.prototype.toString=function(b,g){if(b===A)b=10;if(b!==10)return _(this,b,g);var
f=this.value,e=f.length,a=String(f[--e]),i="0000000",c;while(--e>=0){c=String(f[e]);a+=i.slice(c.length)+c}var
h=this.sign?cz:d;return h+a};c.prototype.toString=function(b,c){if(b===A)b=10;if(b!=10)return _(this,b,c);return String(this.value)};e.prototype.toString=c.prototype.toString;e.prototype.toJSON=b.prototype.toJSON=c.prototype.toJSON=function(){return this.toString()};b.prototype.valueOf=function(){return parseInt(this.toString(),10)};b.prototype.toJSNumber=b.prototype.valueOf;c.prototype.valueOf=function(){return this.value};c.prototype.toJSNumber=c.prototype.valueOf;e.prototype.valueOf=e.prototype.toJSNumber=function(){return parseInt(this.toString(),10)};function
W(d){if(o(+d)){var
l=+d;if(l===s(l))return G?new
e(h(l)):new
c(l);throw new
Error(ng+d)}var
p=d[0]===cz;if(p)d=d.slice(1);var
g=d.split(/e/i);if(g.length>2)throw new
Error(ng+g.join(nB));if(g.length===2){var
f=g[1];if(f[0]===eV)f=f.slice(1);f=+f;if(f!==s(f)||!o(f))throw new
Error(ng+f+" is not a valid exponent.");var
a=g[0],i=a.indexOf(ej);if(i>=0){f-=a.length-i-1;a=a.slice(0,i)+a.slice(i+1)}if(f<0)throw new
Error("Cannot include negative exponent part for integers");a+=new
Array(f+1).join(r);d=a}var
t=/^([0-9][0-9]*)$/.test(d);if(!t)throw new
Error(ng+d);if(G)return new
e(h(p?cz+d:d));var
n=[],j=d.length,m=aa,k=j-m;while(j>0){n.push(+d.slice(k,j));k-=m;if(k<0)k=0;j-=m}q(n);return new
b(n,p)}function
af(b){if(G)return new
e(h(b));if(o(b)){if(b!==s(b))throw new
Error(b+" is not an integer.");return new
c(b)}return W(b.toString())}function
a(b){if(typeof
b==="number")return af(b);if(typeof
b==="string")return W(b);if(typeof
b==="bigint")return new
e(b);return b}for(var
n=0;n<g_;n++){f[n]=a(n);if(n>0)f[-n]=a(-n)}f.one=f[1];f.zero=f[0];f.minusOne=f[-1];f.max=T;f.min=L;f.gcd=Q;f.lcm=ad;f.isInstance=function(d){return d
instanceof
b||d
instanceof
c||d
instanceof
e};f.randBetween=ag;f.fromArray=function(c,b,d){return V(c.map(a),a(b||10),d)};return f}();function
cA(b){var
c=b.toJSNumber()|0;if(b.equals(av(c)))return c;return b}function
Jw(b){return cA(av(b).abs())}function
Jx(b,c){return cA(av(b).add(av(c)))}function
eu(b,c){return av(b).compare(av(c))}function
hs(c,b){b=av(b);if(b.equals(av(0)))ja();return cA(av(c).divide(av(b)))}function
b1O(c,b){b=av(b);if(b.equals(av(0)))ja();return cA(av(c).mod(b))}function
r1(b,c){return[0,hs(b,c),b1O(b,c)]}function
Jy(b,c){return hs(b,c)}function
b1C(b,c){return av(b).equals(av(c))?1:0}function
c2(b){return av(b).compare(av.zero)}function
r3(b,c){return cA(av(b).subtract(av(c)))}function
b1D(b,c){var
d=c2(b),e=c2(c);if(d*e<0)if(!av(b).mod(av(c)).equals(av(0)))return r3(hs(b,c),av(1));return hs(b,c)}function
b1F(b,c){return cA(av.gcd(av(b),av(c)).abs())}function
b1v(d,f,g){f=av(f);var
b=f.toArray(Math.pow(2,32));d.write(8,b.isNegative?1:0);var
a=b.value.length,e=a*4;d.write(32,e);for(var
c=a-1;c>=0;c--){d.write(8,b.value[c]>>>0&dp);d.write(8,b.value[c]>>>8&dp);d.write(8,b.value[c]>>>16&dp);d.write(8,b.value[c]>>>24&dp)}g[0]=4*(1+((e+3)/4|0));g[1]=8*(1+((e+7)/8|0))}function
b1w(c,g){var
f;switch(c.read8u()){case
1:f=true;break;case
0:f=false;break;default:dg("input_value: z (malformed input)")}var
a=c.read32u(),d=av(0);for(var
e=0;e<a/4;e++){var
b=av(c.read8u());b=b.add(c.read8u()<<8);b=b.add(c.read8u()<<16);b=b.add(c.read8u()<<24>>>0);d=b.shiftLeft(e*32).add(d)}if(f)d=d.negate();g[0]=a+4;return cA(d)}function
b1G(e){var
c=av(e).toArray(Math.pow(2,32)),b=0;for(var
d=0;d<c.value.length;d++)b=d3(b,c.value[d]);if(c.value.length%2!=0)b=d3(b,0);if(c.isNegative)b=b+1;return b|0}function
b1H(b){rK[md]={serialize:b1v,deserialize:b1w,hash:b1G,compare:eu};return 0}function
b1I(b,c){return cA(av(b).or(av(c)))}function
b1J(b,c){return cA(av(b).multiply(av(c)))}function
b1K(c,d){var
b=c*d;return b!=(b|0)}function
b1L(b){return cA(av(b).negate())}function
r2(c){c=av(c).abs();var
d=0,b=av.one;while(b.leq(c)){d+=1;b=b.multiply(2)}return d}function
b1M(b){if(b==Infinity||b==-Infinity||b!=b)i$(d4(lX));return cA(av(b<0?Math.ceil(b):Math.floor(b)))}function
b1z(e,b){if(e==0){e=10;var
c=0,h=1;if(b[c]==cz){h=-1;c++}else
if(b[c]==eV)c++;if(b[c]==r){c++;if(b.length==c)return 0;else{var
a=b[c];if(a=="o"||a=="O")e=8;else
if(a=="x"||a=="X")e=16;else
if(a==vU||a=="B")e=2;if(e!=10){b=b.substring(c+1);if(h==-1)b=cz+b}}}}function
i(b){if(b>=48&&b<=57)return b-48;if(b>=97&&b<=k1)return b-97+10;if(b>=65&&b<=70)return b-65+10}var
f=0;if(b[f]==eV)b=b.substring(1);else
if(b[f]==cz)f++;if(b[f]==rv)bS(w_);b=b.replace(/_/g,d);if(b==cz||b==d)b=r;for(;f<b.length;f++){var
g=i(b.charCodeAt(f));if(g==undefined||g>=e)bS(w_)}return cA(av(b,e))}function
f5(e,b,c,d){b=es(b);if(c!=0||d!=b.length){if(b.length-c<d)bS("Z.of_substring_base: invalid offset or length");b=b.slice(c,c+d)}return b1z(e,b)}function
Jz(c,b){b=av(b);if(b.lt(av(0)))bS("Z.pow: exponent must be nonnegative");return cA(av(c).pow(b))}function
b1N(b){return cA(av(b).prev())}function
JA(c,b){return cA(av(c).shiftLeft(b))}function
b1P(c,b){return cA(av(c).shiftRight(b))}function
b1Q(b){return cA(av(b).next())}function
b1R(b){if(b==(b|0))return b|0;i$(d4(lX))}function
b1E(b){b=av(b);return b.compare(av("9223372036854775807"))<=0&&b.compare(av("-9223372036854775808"))>=0?1:0}function
n1(b){b=av(b);if(!b1E(b))i$(d4(lX));var
c=av(0xffffffff),e=b.and(c).toJSNumber(),d=b.shiftRight(32).and(c).toJSNumber(),f=Jg(e,d);return f}function
b1e(b){switch(b[2]){case-8:case-11:case-12:return 1;default:return 0}}function
b0Y(c){var
b=d;if(c[0]==0){b+=c[1][1];if(c.length==3&&c[2][0]==0&&b1e(c[1]))var
a=c[2],g=1;else
var
g=2,a=c;b+="(";for(var
f=g;f<a.length;f++){if(f>g)b+=fp;var
e=a[f];if(typeof
e=="number")b+=e.toString();else
if(e
instanceof
eq)b+=ka+e.toString()+ka;else
if(typeof
e=="string")b+=ka+e.toString()+ka;else
b+=rv}b+=")"}else
if(c[0]==bl)b+=c[1];return b}function
Jb(b){if(b
instanceof
Array&&(b[0]==0||b[0]==bl)){var
d=d4(z9);if(d)d(b,false);else{var
e=b0Y(b),c=d4(uj);if(c)c(0);console.error(p7+e+"\n")}}else
throw b}function
b1p(){var
b=bz.process;if(b&&b.on)b.on("uncaughtException",function(c,d){Jb(c);b.exit(2)});else
if(bz.addEventListener)bz.addEventListener("error",function(b){if(b.error)Jb(b.error)})}b1p();function
u(b,c){return b.length==1?b(c):du(b,[c])}function
ar(b,c,d){return b.length==2?b(c,d):du(b,[c,d])}function
cm(b,c,d,e){return b.length==3?b(c,d,e):du(b,[c,d,e])}function
ud(b,c,d,e,f){return b.length==4?b(c,d,e,f):du(b,[c,d,e,f])}function
jP(b,c,d,e,f,a){return b.length==5?b(c,d,e,f,a):du(b,[c,d,e,f,a])}function
b0O(b,c,d,e,f,a,g){return b.length==6?b(c,d,e,f,a,g):du(b,[c,d,e,f,a,g])}function
b0N(b,c,d,e,f,a,g,h){return b.length==7?b(c,d,e,f,a,g,h):du(b,[c,d,e,f,a,g,h])}b00();var
n3=[bl,b(zz),-1],r9=[bl,b(HE),-2],jc=[bl,b(qz),-3],r5=[bl,b(wO),-4],n4=[bl,b(CR),-6],di=[bl,b(AK),-7],r7=[bl,b(B_),-8],r8=[bl,b(w0),-9],bi=[bl,b(IG),-11],r_=[bl,b(zV),zH],b0K=[4,0,0,0,[12,45,[4,0,0,0,0]]],oe=[0,[11,b('File "'),[2,0,[11,b('", line '),[4,0,0,0,[11,b(wy),[4,0,0,0,[12,45,[4,0,0,0,[11,b(": "),[2,0,0]]]]]]]]]],b('File "%s", line %d, characters %d-%d: %s')],b0L=[12,41,0],b0M=[4,0,0,0,[12,46,0]],uc=[0,b("eventsManager"),b("computeAllocationsFamiliales"),b("computeAidesAuLogement")];dS(11,r_,zV);dS(10,bi,IG);dS(9,[bl,b(yG),-10],yG);dS(8,r8,w0);dS(7,r7,B_);dS(6,di,AK);dS(5,n4,CR);dS(4,[bl,b(DX),-5],DX);dS(3,r5,wO);dS(2,jc,qz);dS(1,r9,HE);dS(0,n3,zz);var
JP=b("output_substring"),JM=b("%.12g"),JL=b(ej),JJ=b(u_),JK=b(wV),JC=b("Stdlib.Exit"),JE=fx(0,0,If),JF=fx(0,0,65520),JG=fx(1,0,If),JS=b(vm),JT=b("\\'"),JU=b(uL),JV=b(xx),JW=b(yb),JX=b(D6),JR=b("Char.chr"),J0=b("nth"),J1=b("List.nth"),JZ=b("tl"),JY=b("hd"),J4=b("String.blit / Bytes.blit_string"),J3=b("Bytes.blit"),J2=b("String.sub / Bytes.sub"),J9=b("String.contains_from / Bytes.contains_from"),J6=b(d),J5=b("String.concat"),J$=b("Array.blit"),Ke=b("Map.remove_min_elt"),Kf=[0,0,0,0],Kg=[0,b("map.ml"),kc,10],Kh=[0,0,0],Ka=b(j7),Kb=b(j7),Kc=b(j7),Kd=b(j7),Ki=b("Stdlib.Queue.Empty"),Ko=b("Buffer.add_substring/add_subbytes"),Kn=b("Buffer.add: cannot grow buffer"),Km=[0,b(EZ),93,2],Kl=[0,b(EZ),94,2],Kk=b("Buffer.sub"),Kx=b("%c"),Ky=b("%s"),Kz=b(DD),KA=b(F3),KB=b(wM),KC=b(HC),KD=b("%f"),KE=b("%B"),KF=b("%{"),KG=b("%}"),KH=b("%("),KI=b("%)"),KJ=b(pm),KK=b("%t"),KL=b("%?"),KM=b("%r"),KN=b("%_r"),KO=[0,b(cf),Gi,23],KZ=[0,b(cf),814,21],KR=[0,b(cf),815,21],K0=[0,b(cf),818,21],KS=[0,b(cf),819,21],K1=[0,b(cf),822,19],KT=[0,b(cf),EC,19],K2=[0,b(cf),826,22],KU=[0,b(cf),827,22],K3=[0,b(cf),831,30],KV=[0,b(cf),832,30],KX=[0,b(cf),836,26],KP=[0,b(cf),q3,26],KY=[0,b(cf),846,28],KQ=[0,b(cf),qO,28],KW=[0,b(cf),p_,23],L6=b(uZ),L4=[0,b(cf),1558,4],L5=b("Printf: bad conversion %["),L7=[0,b(cf),rc,39],L8=[0,b(cf),1649,31],L9=[0,b(cf),1650,31],L_=b("Printf: bad conversion %_"),L$=b(Cj),Ma=b(u9),Mb=b(Cj),Mc=b(u9),Mg=[0,[11,b("invalid box description "),[3,0,0]],b("invalid box description %S")],Me=b(d),Mf=[0,0,4],Mh=b(d),Mi=b(vU),Mj=b("h"),Mk=b("hov"),Ml=b("hv"),Mm=b("v"),L2=b(qB),L0=b("neg_infinity"),L1=b(IO),LZ=b(ej),LU=[0,iU],LI=b("%+nd"),LJ=b("% nd"),LL=b("%+ni"),LM=b("% ni"),LN=b("%nx"),LO=b("%#nx"),LP=b("%nX"),LQ=b("%#nX"),LR=b("%no"),LS=b("%#no"),LH=b("%nd"),LK=b(wM),LT=b("%nu"),Lv=b("%+ld"),Lw=b("% ld"),Ly=b("%+li"),Lz=b("% li"),LA=b("%lx"),LB=b("%#lx"),LC=b("%lX"),LD=b("%#lX"),LE=b("%lo"),LF=b("%#lo"),Lu=b("%ld"),Lx=b(F3),LG=b("%lu"),Li=b("%+Ld"),Lj=b("% Ld"),Ll=b("%+Li"),Lm=b("% Li"),Ln=b("%Lx"),Lo=b("%#Lx"),Lp=b("%LX"),Lq=b("%#LX"),Lr=b("%Lo"),Ls=b("%#Lo"),Lh=b("%Ld"),Lk=b(HC),Lt=b("%Lu"),K7=b("%+d"),K8=b("% d"),K_=b("%+i"),K$=b("% i"),La=b("%x"),Lb=b("%#x"),Lc=b("%X"),Ld=b("%#X"),Le=b("%o"),Lf=b("%#o"),K6=b(p$),K9=b(DD),Lg=b(uZ),Kp=b("@]"),Kq=b("@}"),Kr=b("@?"),Ks=b("@\n"),Kt=b("@."),Ku=b("@@"),Kv=b("@%"),Kw=b("@"),K4=b("CamlinternalFormat.Type_mismatch"),Mq=b(d),Mr=[0,[11,b(fp),[2,0,[2,0,0]]],b(", %s%s")],MQ=[0,[11,b(p7),[2,0,[12,10,0]]],b(A6)],MR=[0,[11,b("Fatal error in uncaught exception handler: exception "),[2,0,[12,10,0]]],b("Fatal error in uncaught exception handler: exception %s\n")],MP=b("Fatal error: out of memory in uncaught exception handler"),MN=[0,[11,b(p7),[2,0,[12,10,0]]],b(A6)],MJ=[0,[2,0,[12,10,0]],b("%s\n")],MB=b("Raised at"),MC=b("Re-raised at"),MD=b("Raised by primitive operation at"),ME=b("Called from"),MF=b(" (inlined)"),MH=b(d),MG=[0,[2,0,[12,32,[2,0,[11,b(' in file "'),[2,0,[12,34,[2,0,[11,b(", line "),[4,0,0,0,[11,b(wy),b0K]]]]]]]]]],b('%s %s in file "%s"%s, line %d, characters %d-%d')],MI=[0,[2,0,[11,b(" unknown location"),0]],b("%s unknown location")],Mw=b("Out of memory"),Mx=b("Stack overflow"),My=b("Pattern matching failed"),Mz=b("Assertion failed"),MA=b("Undefined recursive module"),Ms=[0,[12,40,[2,0,[2,0,[12,41,0]]]],b("(%s%s)")],Mt=b(d),Mu=b(d),Mv=[0,[12,40,[2,0,[12,41,0]]],b("(%s)")],Mp=[0,[4,0,0,0,0],b(p$)],Mn=[0,[3,0,0],b("%S")],Mo=b(rv),MK=[0,b(d),b("(Cannot print locations:\n bytecode executable program file not found)"),b("(Cannot print locations:\n bytecode executable program file appears to be corrupt)"),b("(Cannot print locations:\n bytecode executable program file has wrong magic number)"),b("(Cannot print locations:\n bytecode executable program file cannot be opened;\n -- too many open files. Try running with OCAMLRUNPARAM=b=2)")],b0I=b("OCAMLRUNPARAM"),b0G=b("CAMLRUNPARAM"),MS=b(d),Nf=[3,0,3],Ng=b(ej),Na=b(kA),Nb=b("<\/"),Nc=b(d),M8=b(kA),M9=b(rb),M_=b(d),M6=b("\n"),M2=b(d),M3=b(d),M4=b(d),M5=b(d),M1=[0,b(d)],MX=b(d),MY=b(d),MZ=b(d),M0=b(d),MV=[0,b(d),0,b(d)],MU=b(d),MT=b("Stdlib.Format.String_tag"),Nr=b(d),NC=[0,b(iJ),226,2],NB=[0,[4,0,[0,2,4],0,[12,45,[4,0,[0,2,2],0,[12,45,[4,0,[0,2,2],0,0]]]]],b("%04d-%02d-%02d")],Ny=[0,b(iJ),d1,2],Nz=[0,b(iJ),124,2],Nw=[0,b(iJ),Gy,2],Nx=[0,b(iJ),qP,2],Nv=[0,[12,91,[4,0,0,0,[11,b(" years, "),[4,0,0,0,[11,b(" months, "),[4,0,0,0,[11,b(" days]"),0]]]]]]],b("[%d years, %d months, %d days]")],Ns=b("Dates_calc.Dates.InvalidDate"),Nt=b("Dates_calc.Dates.AmbiguousComputation"),NH=fx(1,0,0),ND=b("Z.Overflow"),NE=b(lX),NL=b(d),NM=b("+inf"),NN=b("-inf"),NO=b(IS),NP=b("undef"),NR=[0,b("q.ml"),486,25],NQ=b("Q.of_string: invalid digit"),NJ=b(vL),NI=b(vL),Oo=[0,b(pU),72,32],Ol=[0,b(pU),72,32],Ok=b(d),Og=b("NaN value not allowed in standard JSON"),Oh=[0,[8,[0,0,3],0,[0,16],0],b(v6)],Oj=[0,[8,[0,0,3],0,[0,17],0],b(G8)],Oi=b(Em),Oe=b("Infinity value not allowed in standard JSON"),Of=b("-Infinity value not allowed in standard JSON"),Oa=b("NaN"),Ob=[0,[8,[0,0,3],0,[0,16],0],b(v6)],Od=[0,[8,[0,0,3],0,[0,17],0],b(G8)],Oc=b(Em),N_=b("Infinity"),N$=b("-Infinity"),N8=b(u_),N9=b(wV),N7=b("null"),N1=b(uL),N2=b(xx),N3=b(yb),N4=b("\\f"),N5=b(D6),N6=b('\\"'),N0=b(vm),NZ=[0,[11,b("src="),[3,0,[11,b(" start="),[4,3,0,0,[11,b(" len="),[4,3,0,0,[12,10,[10,0]]]]]]]],b("src=%S start=%i len=%i\n%!")],NX=b("\\u00"),NU=[0,b(pU),72,32],NS=b("Yojson.Json_error"),NW=[0,b(qr),b(qy),b(pu),b(q9),b(pA),b(d),b(d),b(d),b(d),b(d),b(d)],On=[0,b(qr),b(qy),b(pu),b(q9),b(pA),b(d),b(d),b(d),b(d),b(d),b(d)],Oq=[0,b(qr),b(qy),b(pu),b(q9),b(pA),b(d),b(d),b(d),b(d),b(d),b(d)],Pv=[0,0,0],Pz=b("unreachable due to the [is_subscope_call] test"),PB=b("unreachable due to the [is_subscope_input_var_def] test"),PC=b("]"),PD=b("["),PE=b(" ]): expected variable definition (function output), found: "),PF=b(fp),PG=b(ur),PH=b(" ]): expected variable definition (function output), found: end of tokens"),PI=b(fp),PJ=b(ur),PA=b("Unexpected event: "),PK=[0,b("runtimes/ocaml/runtime.ml"),535,19],PL=b("Missing function output variable definition."),PM=b("Invalid start of function call."),Py=b(dM),Px=b(Y),PN=[0,[11,b("An error occurred while parsing raw events: "),[2,0,[12,10,0]]],b("An error occurred while parsing raw events: %s\n")],Pm=b(DO),Pn=b(fp),Po=[0,[11,b(x0),0],b(x0)],Pp=b(DO),Pq=b(fp),Pr=[0,[11,b(Az),0],b(Az)],Ps=b(fp),Pt=[0,[11,b("VariableDefinition([ "),[2,0,[11,b(" ], "),[2,0,[11,b(fp),[2,0,[12,41,0]]]]]]],b("VariableDefinition([ %s ], %s, %s)")],Pu=[0,[11,b("DecisionTaken("),[2,0,[12,58,[4,0,0,0,[12,46,[4,0,0,0,[12,45,[4,0,0,0,[12,46,[4,0,0,0,b0L]]]]]]]]]],b("DecisionTaken(%s:%d.%d-%d.%d)")],Pl=b("internal"),Pd=b(Y),Pk=b(d),Pe=b(dU),Pj=b(d),Pf=b(d),Ph=b(dM),Pi=b("reentrant"),Pg=[0,[2,0,[2,0,[2,0,0]]],b("%s%s%s")],OY=[0,ch,b("VarComputation")],OZ=[0,ch,b("FunCall")],O0=b(y0),O1=b("inputs"),O2=b(DP),O3=[0,ch,b("SubScopeCall")],O4=b("fun_calls"),O5=b("value"),O6=b("io"),O7=b(DP),O8=b("pos"),O9=b(Y),O_=b(y0),O$=b("fun_inputs"),Pa=b("fun_name"),ON=[0,bY,[0,[0,ch,b("Unit")],0]],OO=[0,bY,[0,[0,ch,b("Unembeddable")],0]],OP=[0,ch,b("Bool")],OQ=[0,ch,b("Money")],OR=[0,ch,b("Integer")],OS=[0,ch,b("Decimal")],OT=[0,ch,b("Date")],OU=[0,ch,b("Duration")],OV=[0,ch,b("Enum")],OW=[0,ch,b("Struct")],OX=[0,ch,b("Array")],OM=[0,[15,0],b(pm)],OL=[0,[15,0],b(pm)],Ox=b("law_headings"),Oy=b("end_column"),Oz=b("end_line"),OA=b("start_column"),OB=b("start_line"),OC=b("filename"),Ou=b("io_output"),Ov=b("io_input"),Or=[0,bY,[0,[0,ch,b("NoInput")],0]],Os=[0,bY,[0,[0,ch,b("OnlyInput")],0]],Ot=[0,bY,[0,[0,ch,b("Reentrant")],0]],OD=b("Runtime_ocaml.Runtime.EmptyError"),OE=b("Runtime_ocaml.Runtime.AssertionFailed"),OF=b("Runtime_ocaml.Runtime.ConflictError"),OG=b("Runtime_ocaml.Runtime.UncomparableDurations"),OI=b("Runtime_ocaml.Runtime.ImpossibleDate"),OK=b("Runtime_ocaml.Runtime.NoValueProvided"),PO=b("Jsoo_runtime.Error.Exn"),PP=b(qZ),P7=[0,[2,0,[11,b(" in file "),[2,0,[11,b(", position "),[4,0,0,0,[12,58,[4,0,0,0,[11,b("--"),[4,0,0,0,[12,58,b0M]]]]]]]]]],b("%s in file %s, position %d:%d--%d:%d.")],P8=b("No rule applies in the given context to give a value to the variable"),P9=b("A conflict happened between two rules giving a value to the variable"),P_=b("A failure happened in the assertion"),P0=b("Begin call"),P1=b("End call"),P2=b("Variable definition"),P3=b("Decision taken"),PY=b(d),PW=b("date_of_jsoo: invalid date"),PU=[0,b(DG),b(yA),b(Ar)],PV=[0,b(DG),b(Ar),b(yA)],aeP=[0,b(bu),90,14,90,29,[0,b(b9),[0,b(bv),0]]],aeH=[0,b(bu),fn,18,fn,64,[0,b(b9),[0,b(bv),0]]],aeI=[0,b(d),0,1,0,1,0],aeG=[0,b(bu),de,5,de,72,[0,b(b9),[0,b(bv),0]]],aeB=[0,b(bu),87,14,87,53,[0,b(b9),[0,b(bv),0]]],aew=[0,b(bu),86,14,86,50,[0,b(b9),[0,b(bv),0]]],aer=[0,b(bu),89,14,89,46,[0,b(b9),[0,b(bv),0]]],aem=[0,b(bu),88,14,88,54,[0,b(b9),[0,b(bv),0]]],aeg=[0,b(bu),97,18,97,72,[0,b(b9),[0,b(bv),0]]],aeh=[0,b(d),0,1,0,1,0],aef=[0,b(bu),96,5,96,80,[0,b(b9),[0,b(bv),0]]],ad$=[0,b(bu),93,18,93,67,[0,b(b9),[0,b(bv),0]]],aea=[0,b(d),0,1,0,1,0],ad_=[0,b(bu),92,5,92,75,[0,b(b9),[0,b(bv),0]]],ad5=[0,b(bu),fd,14,fd,30,[0,b("Article L131-1"),[0,b(b9),[0,b(bv),0]]]],ad2=[0,0],ad3=[1,0],ad4=[2,0],ad6=[0,b(d),0,1,0,1,0],ad1=[0,b(bu),76,11,76,27,[0,b(b9),[0,b(bv),0]]],ad7=[0,0,0],ad8=[0,b(dY),[0,b("enfants_\xc3\xa0_charge"),0]],aeb=[0,b(d),0,1,0,1,0],aec=[0,1,0],aed=[0,b(dY),[0,b("allocations_familiales.personne_charge_effective_permanente_est_parent"),0]],ad9=[0,b(bu),92,5,92,75,[0,b(b9),[0,b(bv),0]]],aei=[0,b(d),0,1,0,1,0],aej=[0,1,0],aek=[0,b(dY),[0,b("allocations_familiales.personne_charge_effective_permanente_remplit_titre_I"),0]],aee=[0,b(bu),96,5,96,80,[0,b(b9),[0,b(bv),0]]],aen=[0,b(d),0,1,0,1,0],aeo=[0,1,0],aep=[0,b(dY),[0,b("allocations_familiales.ressources_m\xc3\xa9nage"),0]],ael=[0,b(bu),88,14,88,54,[0,b(b9),[0,b(bv),0]]],aes=[0,b(d),0,1,0,1,0],aet=[0,1,0],aeu=[0,b(dY),[0,b("allocations_familiales.r\xc3\xa9sidence"),0]],aeq=[0,b(bu),89,14,89,46,[0,b(b9),[0,b(bv),0]]],aex=[0,b(d),0,1,0,1,0],aey=[0,1,0],aez=[0,b(dY),[0,b("allocations_familiales.date_courante"),0]],aev=[0,b(bu),86,14,86,50,[0,b(b9),[0,b(bv),0]]],aeC=[0,b(d),0,1,0,1,0],aeD=[0,1,0],aeE=[0,b(dY),[0,b("allocations_familiales.enfants_\xc3\xa0_charge"),0]],aeA=[0,b(bu),87,14,87,53,[0,b(b9),[0,b(bv),0]]],aeJ=[0,b(d),0,1,0,1,0],aeK=[0,1,0],aeL=[0,b(dY),[0,b("allocations_familiales.avait_enfant_\xc3\xa0_charge_avant_1er_janvier_2012"),0]],aeF=[0,b(bu),de,5,de,72,[0,b(b9),[0,b(bv),0]]],aeM=[0,b(dY),[0,b(uC),[0,b(V),0]]],aeN=[0,b(dY),[0,b(uC),[0,b(V),0]]],aeQ=[0,b(d),0,1,0,1,0],aeO=[0,b(bu),80,12,80,27,[0,b(b9),[0,b(bv),0]]],aeR=[0,0,1],aeS=[0,b(dY),[0,b("i_montant_vers\xc3\xa9"),0]],adV=[0,b(bu),45,14,45,27,[0,b(eM),[0,b(bv),0]]],adU=b(r),adP=[0,b(bq),zI,14,zI,62,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],adI=[0,1,0],adJ=[0,b(V),[0,b(iq),[0,b(ac),0]]],adK=[0,b(V),[0,b(iq),0]],adL=[0,0,1],adM=[0,b(V),[0,b(iq),[0,b(Y),0]]],adN=[0,b(V),[0,b(iq),0]],adO=b(r),adD=[0,b(bq),rh,14,rh,61,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],ady=[0,b(bu),39,14,39,38,[0,b(eM),[0,b(bv),0]]],adq=[0,1,0],adr=[0,b(V),[0,b(iz),[0,b(ac),0]]],ads=[0,b(V),[0,b(iz),0]],adt=[0,0,1],adu=[0,b(V),[0,b(iz),[0,b(Y),0]]],adv=[0,b(V),[0,b(iz),0]],adw=b(r),adx=b(r),adl=[0,b(bu),37,14,37,32,[0,b(eM),[0,b(bv),0]]],adk=b(r),adf=[0,b(dO),kq,5,kq,43,[0,b("Article R521-4"),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],ac2=[0,1,0],ac3=[0,b(V),[0,b(eN),[0,b(ac),0]]],ac4=[0,b(V),[0,b(eN),0]],ac5=[0,0,1],ac6=[0,b(V),[0,b(eN),[0,b(Y),0]]],ac7=[0,b(V),[0,b(eN),0]],ac8=b(dy),add=b(h7),ade=b(by),ac9=[0,1,0],ac_=[0,b(V),[0,b(h0),[0,b(ac),0]]],ac$=[0,b(V),[0,b(h0),0]],ada=[0,0,1],adb=[0,b(V),[0,b(h0),[0,b(Y),0]]],adc=[0,b(V),[0,b(h0),0]],adg=[0,b(d),0,1,0,1,0],ac1=[0,b(az),d1,11,d1,49,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],acX=[0,b(dO),ef,14,ef,46,[0,b(lv),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],acO=b(cH),acP=[0,b(bq),268,5,qs,41,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],acL=b(cH),acM=b(dy),acN=b(cH),acQ=[0,b(d),0,1,0,1,0],acI=b(cH),acJ=[0,b(bq),278,5,AF,40,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],acF=b(cH),acG=b(dy),acH=b(cH),acK=[0,b(d),0,1,0,1,0],acR=[0,b(d),0,1,0,1,0],acS=[0,b(d),0,1,0,1,0],acE=[0,b(bq),ps,14,ps,55,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],acD=b(r),aco=b(y),acp=[0,1,0],acq=[0,b(V),[0,b(bH),[0,b(ac),0]]],acr=[0,b(V),[0,b(bH),0]],acs=[0,0,1],act=[0,b(V),[0,b(bH),[0,b(Y),0]]],acu=[0,b(V),[0,b(bH),0]],acv=[0,b(bq),378,5,hc,55,[0,b(h$),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(ba),[0,b(ae),0]]]]]]],acn=b("0.0369"),acw=[0,b(d),0,1,0,1,0],ace=b(y),acf=[0,1,0],acg=[0,b(V),[0,b(bH),[0,b(ac),0]]],ach=[0,b(V),[0,b(bH),0]],aci=[0,0,1],acj=[0,b(V),[0,b(bH),[0,b(Y),0]]],ack=[0,b(V),[0,b(bH),0]],acl=[0,b(bq),iw,5,qQ,56,[0,b(h$),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(ba),[0,b(ae),0]]]]]]],acd=b("0.0567"),acm=[0,b(d),0,1,0,1,0],acx=[0,b(d),0,1,0,1,0],acy=[0,b(d),0,1,0,1,0],acc=[0,b(bq),22,14,22,40,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],ab8=[0,1,0],ab9=[0,b(V),[0,b(h5),[0,b(ac),0]]],ab_=[0,b(V),[0,b(h5),0]],ab$=[0,0,1],aca=[0,b(V),[0,b(h5),[0,b(Y),0]]],acb=[0,b(V),[0,b(h5),0]],acz=[0,b(d),0,1,0,1,0],ab7=[0,b(az),lN,11,lN,37,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],abZ=b(y),ab0=[0,b(bq),355,5,356,69,[0,b(h$),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(ba),[0,b(ae),0]]]]]]],ab1=[0,b(d),0,1,0,1,0],abW=[8,0],abX=[0,b(a1),lH,24,lH,44,[0,b(bW),[0,b(bd),[0,b(bg),0]]]],abY=[0,b(d),0,1,0,1,0],ab2=[0,b(d),0,1,0,1,0],ab3=[0,b(d),0,1,0,1,0],abV=[0,b(bq),18,14,18,34,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],abQ=[0,b(bq),gt,14,gt,39,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],abK=[0,1,0],abL=[0,b(V),[0,b(h8),[0,b(ac),0]]],abM=[0,b(V),[0,b(h8),0]],abN=[0,0,1],abO=[0,b(V),[0,b(h8),[0,b(Y),0]]],abP=[0,b(V),[0,b(h8),0]],abx=[0,1,0],aby=[0,b(V),[0,b(bH),[0,b(ac),0]]],abz=[0,b(V),[0,b(bH),0]],abA=[0,0,1],abB=[0,b(V),[0,b(bH),[0,b(Y),0]]],abC=[0,b(V),[0,b(bH),0]],abD=[0,b(bq),60,5,60,38,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],abw=b(qU),abE=[0,b(d),0,1,0,1,0],abo=[0,1,0],abp=[0,b(V),[0,b(bH),[0,b(ac),0]]],abq=[0,b(V),[0,b(bH),0]],abr=[0,0,1],abs=[0,b(V),[0,b(bH),[0,b(Y),0]]],abt=[0,b(V),[0,b(bH),0]],abu=[0,b(bq),fn,5,fn,38,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],abn=b(yP),abv=[0,b(d),0,1,0,1,0],abf=[0,1,0],abg=[0,b(V),[0,b(bH),[0,b(ac),0]]],abh=[0,b(V),[0,b(bH),0]],abi=[0,0,1],abj=[0,b(V),[0,b(bH),[0,b(Y),0]]],abk=[0,b(V),[0,b(bH),0]],abl=[0,b(bq),rr,5,rr,38,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],abe=b(yX),abm=[0,b(d),0,1,0,1,0],aa8=[0,1,0],aa9=[0,b(V),[0,b(bH),[0,b(ac),0]]],aa_=[0,b(V),[0,b(bH),0]],aa$=[0,0,1],aba=[0,b(V),[0,b(bH),[0,b(Y),0]]],abb=[0,b(V),[0,b(bH),0]],abc=[0,b(bu),28,5,28,44,[0,b(eM),[0,b(bv),0]]],aa7=b(r),abd=[0,b(d),0,1,0,1,0],abF=[0,b(d),0,1,0,1,0],abG=[0,b(d),0,1,0,1,0],aa6=[0,b(az),f1,11,f1,47,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],aa2=[0,b(dO),dc,14,dc,41,[0,b(lv),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],aa0=b(by),aa1=b(by),aaQ=[8,0],aaR=[0,b(a1),xp,5,xp,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aaN=b(y),aaO=b(uU),aaP=b(r),aaS=[0,b(d),0,1,0,1,0],aaK=[8,0],aaL=[0,b(a1),pR,5,pR,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aaH=b(y),aaI=b("0.2379"),aaJ=b(r),aaM=[0,b(d),0,1,0,1,0],aaE=[8,0],aaF=[0,b(a1),gy,5,gy,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aaB=b(y),aaC=b("0.2437"),aaD=b(r),aaG=[0,b(d),0,1,0,1,0],aay=[8,0],aaz=[0,b(a1),FA,5,FA,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aav=b(y),aaw=b("0.2496"),aax=b(r),aaA=[0,b(d),0,1,0,1,0],aas=[8,0],aat=[0,b(a1),hj,5,hj,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aap=b(y),aaq=b("0.2555"),aar=b(r),aau=[0,b(d),0,1,0,1,0],aam=[8,0],aan=[0,b(a1),Bj,5,Bj,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aaj=b(y),aak=b("0.2613"),aal=b(r),aao=[0,b(d),0,1,0,1,0],aag=[8,0],aah=[0,b(a1),kc,5,kc,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],aad=b(y),aae=b("0.2672"),aaf=b(r),aai=[0,b(d),0,1,0,1,0],aaa=[8,0],aab=[0,b(a1),Hs,5,Hs,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],$9=b(y),$_=b("0.2804"),$$=b(r),aac=[0,b(d),0,1,0,1,0],$6=[8,0],$7=[0,b(a1),C_,5,C_,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],$3=b(y),$4=b("0.2936"),$5=b(r),$8=[0,b(d),0,1,0,1,0],$0=[8,0],$1=[0,b(a1),g7,5,g7,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],$X=b(y),$Y=b("0.3068"),$Z=b(r),$2=[0,b(d),0,1,0,1,0],aaT=[0,b(d),0,1,0,1,0],aaU=[0,b(d),0,1,0,1,0],$V=[8,0],$W=[0,b(a1),x_,14,x_,50,[0,b(bW),[0,b(bd),[0,b(bg),0]]]],$S=b(y),$T=b(rC),$U=b(r),aaV=[0,b(d),0,1,0,1,0],$P=[0,b(bq),38,14,38,50,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],$M=b(y),$N=b(rC),$O=b(r),$Q=[0,b(d),0,1,0,1,0],$K=[0,b(bq),79,14,79,50,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],$H=b(y),$I=b(qU),$J=b(r),$L=[0,b(d),0,1,0,1,0],$F=[0,b(bq),fd,14,fd,50,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],$C=b(y),$D=b(yP),$E=b(r),$G=[0,b(d),0,1,0,1,0],$R=[0,b(d),0,1,0,1,0],$v=[0,b(bq),43,14,43,59,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],$r=b(T),$s=b(T),$t=b("0.41"),$u=b(r),$w=[0,b(d),0,1,0,1,0],$p=[0,b(bq),84,14,84,59,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],$l=b(T),$m=b(T),$n=b("0.205"),$o=b(r),$q=[0,b(d),0,1,0,1,0],$j=[0,b(bq),lE,14,lE,59,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],$f=b(T),$g=b(T),$h=b("0.1025"),$i=b(r),$k=[0,b(d),0,1,0,1,0],$x=[0,b(d),0,1,0,1,0],__=[0,b(bq),pW,5,pW,42,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],_9=b("0.20234"),_$=[0,b(d),0,1,0,1,0],_7=[0,b(bq),235,5,236,45,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],_6=b("0.10117"),_8=[0,b(d),0,1,0,1,0],_4=[0,b(bq),kp,5,kp,42,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],_3=b("0.05059"),_5=[0,b(d),0,1,0,1,0],$a=[0,b(d),0,1,0,1,0],_U=b(cH),_V=[0,b(bq),165,5,F6,65,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],_R=b(cH),_S=b(dy),_T=b(cH),_W=[0,b(d),0,1,0,1,0],_O=b(cH),_P=[0,b(bq),rx,5,175,65,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],_L=b(cH),_M=b(dy),_N=b(cH),_Q=[0,b(d),0,1,0,1,0],_X=[0,b(d),0,1,0,1,0],_Y=[0,b(d),0,1,0,1,0],_K=[0,b(bq),Bp,14,Bp,34,[0,b(cM),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],_J=b(r),_Z=[0,b(d),0,1,0,1,0],_I=[0,b(az),iV,11,iV,31,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],_w=[0,1,0],_x=[0,b(V),[0,b(em),[0,b(ac),0]]],_y=[0,b(V),[0,b(em),0]],_z=[0,0,1],_A=[0,b(V),[0,b(em),[0,b(Y),0]]],_B=[0,b(V),[0,b(em),0]],_C=[0,b(bN),pf,5,mM,21,[0,b(xh),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],_D=[0,b(d),0,1,0,1,0],_j=[0,1,0],_k=[0,b(V),[0,b(em),[0,b(ac),0]]],_l=[0,b(V),[0,b(em),0]],_m=[0,0,1],_n=[0,b(V),[0,b(em),[0,b(Y),0]]],_o=[0,b(V),[0,b(em),0]],_p=[0,1,0],_q=[0,b(V),[0,b(iZ),[0,b(ac),0]]],_r=[0,b(V),[0,b(iZ),0]],_s=[0,0,1],_t=[0,b(V),[0,b(iZ),[0,b(Y),0]]],_u=[0,b(V),[0,b(iZ),0]],_v=[0,b(bN),ki,5,iR,21,[0,b(xh),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],_E=[0,b(d),0,1,0,1,0],_i=[0,b(az),fd,11,fd,34,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],_F=[0,b(d),0,1,0,1,0],_h=[0,b(az),fd,11,fd,34,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Z8=b(y),Z9=[8,0],Z_=[0,b(a1),Dv,6,Dv,71,[0,b(bW),[0,b(bd),[0,b(bg),0]]]],Z$=[0,b(d),0,1,0,1,0],Z6=b(y),Z7=[0,b(bN),442,5,443,72,[0,b(pV),[0,b(ep),[0,b(iA),[0,b(dF),[0,b(X),[0,b(ae),0]]]]]]],_a=[0,b(d),0,1,0,1,0],_b=[0,b(d),0,1,0,1,0],_c=[0,b(d),0,1,0,1,0],Z4=b(T),Z5=[0,b(bN),f1,5,f1,70,[0,b(Br),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],_d=[0,b(d),0,1,0,1,0],Z3=[0,b(az),94,11,94,28,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],ZT=[8,0],ZU=[0,b(a1),mw,5,iy,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],ZQ=b(r),ZR=b("0.145"),ZS=b(r),ZV=[0,b(d),0,1,0,1,0],ZN=[8,0],ZO=[0,b(a1),262,5,263,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],ZK=b(r),ZL=b("0.1393"),ZM=b(r),ZP=[0,b(d),0,1,0,1,0],ZH=[8,0],ZI=[0,b(a1),HR,5,lu,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],ZE=b(r),ZF=b("0.1335"),ZG=b(r),ZJ=[0,b(d),0,1,0,1,0],ZB=[8,0],ZC=[0,b(a1),AF,5,CG,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Zy=b(r),Zz=b("0.1278"),ZA=b(r),ZD=[0,b(d),0,1,0,1,0],Zv=[8,0],Zw=[0,b(a1),289,5,p4,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Zs=b(r),Zt=b("0.122"),Zu=b(r),Zx=[0,b(d),0,1,0,1,0],Zp=[8,0],Zq=[0,b(a1),298,5,Fs,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Zm=b(r),Zn=b("0.1163"),Zo=b(r),Zr=[0,b(d),0,1,0,1,0],Zj=[8,0],Zk=[0,b(a1),h2,5,ip,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Zg=b(r),Zh=b("0.1105"),Zi=b(r),Zl=[0,b(d),0,1,0,1,0],Zd=[8,0],Ze=[0,b(a1),pa,5,iL,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Za=b(r),Zb=b("0.0976"),Zc=b(r),Zf=[0,b(d),0,1,0,1,0],Y9=[8,0],Y_=[0,b(a1),ki,5,326,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Y6=b(r),Y7=b("0.0847"),Y8=b(r),Y$=[0,b(d),0,1,0,1,0],Y3=[8,0],Y4=[0,b(a1),gm,5,AW,53,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Y0=b(r),Y1=b("0.0717"),Y2=b(r),Y5=[0,b(d),0,1,0,1,0],YX=[8,0],YY=[0,b(a1),mM,5,mM,49,[0,b(br),[0,b(bd),[0,b(bg),0]]]],YU=b(r),YV=b("5728"),YW=b(r),YZ=[0,b(d),0,1,0,1,0],ZW=[0,b(d),0,1,0,1,0],ZX=[0,b(d),0,1,0,1,0],YS=[8,0],YT=[0,b(a1),yH,14,yH,49,[0,b(bW),[0,b(bd),[0,b(bg),0]]]],YP=b(r),YQ=b(u0),YR=b(r),ZY=[0,b(d),0,1,0,1,0],YM=b(y),YN=[0,b(bq),pG,5,zp,71,[0,b(h$),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(ba),[0,b(ae),0]]]]]]],YL=b(u0),YO=[0,b(d),0,1,0,1,0],YK=[0,b(bq),v7,29,v7,64,[0,b(h$),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(ba),[0,b(ae),0]]]]]]],YJ=b(r),YE=[0,b(dO),l5,14,l5,34,[0,b(lv),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],Yu=[0,1,0],Yv=[0,b(V),[0,b(eN),[0,b(ac),0]]],Yw=[0,b(V),[0,b(eN),0]],Yx=[0,0,1],Yy=[0,b(V),[0,b(eN),[0,b(Y),0]]],Yz=[0,b(V),[0,b(eN),0]],YA=b(dy),YB=b(h7),YC=b(by),YD=b(by),Yp=[0,b(dO),mY,14,mY,34,[0,b(lv),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],Yg=[8,0],Yh=[0,b(a1),kT,5,kT,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Yd=b(T),Ye=b(yW),Yf=b(r),Yi=[0,b(d),0,1,0,1,0],Ya=[8,0],Yb=[0,b(a1),yE,5,yE,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],X9=b(T),X_=b("0.0539"),X$=b(r),Yc=[0,b(d),0,1,0,1,0],X6=[8,0],X7=[0,b(a1),gB,5,gB,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],X3=b(T),X4=b("0.0615"),X5=b(r),X8=[0,b(d),0,1,0,1,0],X0=[8,0],X1=[0,b(a1),q5,5,q5,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],XX=b(T),XY=b("0.069"),XZ=b(r),X2=[0,b(d),0,1,0,1,0],XU=[8,0],XV=[0,b(a1),wz,5,wz,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],XR=b(T),XS=b("0.0766"),XT=b(r),XW=[0,b(d),0,1,0,1,0],XO=[8,0],XP=[0,b(a1),qh,5,qh,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],XL=b(T),XM=b("0.0842"),XN=b(r),XQ=[0,b(d),0,1,0,1,0],XI=[8,0],XJ=[0,b(a1),As,5,As,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],XF=b(T),XG=b("0.0918"),XH=b(r),XK=[0,b(d),0,1,0,1,0],XC=[8,0],XD=[0,b(a1),e$,5,e$,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Xz=b(T),XA=b("0.1089"),XB=b(r),XE=[0,b(d),0,1,0,1,0],Xw=[8,0],Xx=[0,b(a1),uA,5,uA,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Xt=b(T),Xu=b("0.1259"),Xv=b(r),Xy=[0,b(d),0,1,0,1,0],Xq=[8,0],Xr=[0,b(a1),IU,5,IU,67,[0,b(br),[0,b(bd),[0,b(bg),0]]]],Xn=b(T),Xo=b("0.143"),Xp=b(r),Xs=[0,b(d),0,1,0,1,0],Yj=[0,b(d),0,1,0,1,0],Yk=[0,b(d),0,1,0,1,0],Xm=[0,b(a1),kq,14,kq,59,[0,b(bW),[0,b(bd),[0,b(bg),0]]]],Xj=b(T),Xk=b(qU),Xl=b(r),Xe=[0,b(a1),kX,14,kX,67,[0,b(bW),[0,b(bd),[0,b(bg),0]]]],Xa=b(Z),Xb=b(Z),Xc=b(yW),Xd=b(r),W4=b(y),W5=[0,b(bN),456,6,q5,72,[0,b(pV),[0,b(ep),[0,b(iA),[0,b(dF),[0,b(X),[0,b(ae),0]]]]]]],W6=[0,b(d),0,1,0,1,0],WX=[0,1,0],WY=[0,b(co),[0,b(gG),[0,b(ac),0]]],WZ=[0,b(co),[0,b(gG),0]],W0=[0,0,1],W1=[0,b(co),[0,b(gG),[0,b(Y),0]]],W2=[0,b(co),[0,b(gG),0]],W3=[0,b(bN),137,5,o6,59,[0,b(Br),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],W7=[0,b(d),0,1,0,1,0],WW=[0,b(az),ir,11,ir,35,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],W8=[0,b(d),0,1,0,1,0],WV=[0,b(az),ir,11,ir,35,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],WO=b(y),WP=[0,b(bN),462,5,463,71,[0,b(pV),[0,b(ep),[0,b(iA),[0,b(dF),[0,b(X),[0,b(ae),0]]]]]]],WQ=[0,b(d),0,1,0,1,0],WN=[0,b(bu),31,9,31,32,[0,b(eM),[0,b(bv),0]]],WR=[0,b(d),0,1,0,1,0],WM=[0,b(az),dc,11,dc,34,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],WE=[0,b(a1),23,5,23,67,[0,b(Bf),[0,b(ft),0]]],WC=b(H5),WD=b("5628600"),WF=[0,b(d),0,1,0,1,0],WA=[0,b(a1),56,5,56,67,[0,b(up),[0,b(ft),0]]],Wy=b(IE),Wz=b("5684900"),WB=[0,b(d),0,1,0,1,0],Ww=[0,b(a1),89,5,89,67,[0,b(CM),[0,b(ft),0]]],Wu=b(Ay),Wv=b("5775900"),Wx=[0,b(d),0,1,0,1,0],Ws=[0,b(a1),qu,5,qu,67,[0,b(b3),[0,b(GS),[0,b(ft),0]]]],Wq=b(Cn),Wr=b("5827900"),Wt=[0,b(d),0,1,0,1,0],WG=[0,b(d),0,1,0,1,0],WH=[0,b(d),0,1,0,1,0],Wp=[0,b(bq),gM,14,gM,30,[0,b(Hc),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],Wn=b(Fv),Wo=b("5595000"),Wf=[0,b(a1),30,5,30,67,[0,b(Bf),[0,b(ft),0]]],Wd=b(H5),We=b("7877000"),Wg=[0,b(d),0,1,0,1,0],Wb=[0,b(a1),63,5,63,67,[0,b(up),[0,b(ft),0]]],V$=b(IE),Wa=b("7955800"),Wc=[0,b(d),0,1,0,1,0],V9=[0,b(a1),96,5,96,67,[0,b(CM),[0,b(ft),0]]],V7=b(Ay),V8=b("8083100"),V_=[0,b(d),0,1,0,1,0],V5=[0,b(a1),gJ,5,gJ,67,[0,b(b3),[0,b(GS),[0,b(ft),0]]]],V3=b(Cn),V4=b("8155800"),V6=[0,b(d),0,1,0,1,0],Wh=[0,b(d),0,1,0,1,0],Wi=[0,b(d),0,1,0,1,0],V2=[0,b(bq),nr,14,nr,31,[0,b(Hc),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],V0=b(Fv),V1=b("7830000"),VV=[0,b(bu),34,14,34,36,[0,b(eM),[0,b(bv),0]]],VW=[0,b(d),0,1,0,1,0],VU=[0,b(az),IW,11,IW,33,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],VQ=[0,b(bN),80,14,80,64,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],VK=[0,1,0],VL=[0,b(co),[0,b(bE),[0,b(ac),0]]],VM=[0,b(co),[0,b(bE),0]],VN=[0,0,1],VO=[0,b(co),[0,b(bE),[0,b(Y),0]]],VP=[0,b(co),[0,b(bE),0]],VE=[0,b(dO),83,19,83,67,[0,b(kL),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],VF=[0,b(d),0,1,0,1,0],VD=[0,b(dO),56,14,56,41,[0,b(kL),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],VG=[0,b(d),0,1,0,1,0],VC=[0,b(az),l5,11,l5,38,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Vw=[0,b(bu),33,14,33,40,[0,b(eM),[0,b(bv),0]]],Vp=[0,b(az),lj,14,lj,46,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Vk=[0,b(az),g0,14,g0,50,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Vd=[0,b(az),gq,14,gq,32,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],U7=[0,b(bq),m3,14,m3,44,[0,b(fq),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(ba),[0,b(ae),0]]]]]]],U6=b(Z),U1=[0,b(dO),64,14,64,44,[0,b(kL),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],U0=b(Z),UT=[0,b(bN),pi,5,277,56,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],US=[1,0],UU=[0,b(d),0,1,0,1,0],UN=[0,b(bN),287,5,ia,48,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],UM=[0,0],UO=[0,b(d),0,1,0,1,0],UL=[0,b(bN),B8,5,B8,70,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],UK=[0,0],UP=[0,b(d),0,1,0,1,0],UJ=[0,b(bN),rl,5,rl,69,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],UI=[0,0],UQ=[0,b(d),0,1,0,1,0],UH=[0,b(bN),G5,5,G5,60,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],UG=[0,0],UR=[0,b(d),0,1,0,1,0],UV=[0,b(d),0,1,0,1,0],UW=[0,b(d),0,1,0,1,0],UF=[0,b(az),88,12,88,21,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Uz=[0,b(bN),yL,5,yL,70,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Uy=[1,0],UA=[0,b(d),0,1,0,1,0],Uw=[0,b(bN),HR,5,lu,56,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Uv=[2,0],Ux=[0,b(d),0,1,0,1,0],Ur=[0,b(bN),CG,5,282,48,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Uq=[0,0],Us=[0,b(d),0,1,0,1,0],Up=[0,b(bN),pq,5,pq,69,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Uo=[0,0],Ut=[0,b(d),0,1,0,1,0],Un=[0,b(bN),yd,5,yd,60,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Um=[0,0],Uu=[0,b(d),0,1,0,1,0],UB=[0,b(d),0,1,0,1,0],UC=[0,b(d),0,1,0,1,0],Ul=[0,b(az),87,11,87,26,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],UD=[0,0,0],UE=[0,b(V),[0,b(eN),0]],UX=[0,0,1],UY=[0,b(V),[0,b("versement"),0]],U2=[0,b(d),0,1,0,1,0],UZ=[0,b(az),o6,11,o6,41,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],U3=[0,0,0],U4=[0,b(V),[0,b("nombre_enfants_alin\xc3\xa9a_2_l521_3"),0]],U8=[0,b(d),0,1,0,1,0],U5=[0,b(az),rg,11,rg,41,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],U9=[0,0,0],U_=[0,b(V),[0,b("nombre_enfants_alin\xc3\xa9a_2_l521_1"),0]],U$=[0,b(V),[0,b(CP),[0,b(pr),0]]],Va=[0,b(V),[0,b(CP),[0,b(pr),0]]],Vb=[0,b(bN),kp,5,mw,6,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],adZ=[0,b(bN),kp,5,mw,6,[0,b(dE),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Ve=[0,b(d),0,1,0,1,0],Vf=[0,1,0],Vg=[0,b(V),[0,b("bmaf.date_courante"),0]],Vc=[0,b(az),gq,14,gq,32,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Vh=[0,b(V),[0,b(xV),[0,b(hh),0]]],Vi=[0,b(V),[0,b(xV),[0,b(hh),0]]],Vl=[0,b(d),0,1,0,1,0],Vm=[0,1,0],Vn=[0,b(V),[0,b(qt),0]],Vj=[0,b(az),g0,14,g0,50,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Vq=[0,b(d),0,1,0,1,0],Vr=[0,1,0],Vs=[0,b(V),[0,b(qD),0]],Vo=[0,b(az),lj,14,lj,46,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Vt=[0,b(V),[0,b(gP),[0,b(co),0]]],Vu=[0,b(V),[0,b(gP),[0,b(co),0]]],Vx=[0,b(d),0,1,0,1,0],Vy=[0,1,0],Vz=[0,b(V),[0,b("enfant_le_plus_\xc3\xa2g\xc3\xa9.enfants"),0]],Vv=[0,b(bu),33,14,33,40,[0,b(eM),[0,b(bv),0]]],VA=[0,b(V),[0,b(zs),[0,b(px),0]]],VB=[0,b(V),[0,b(zs),[0,b(px),0]]],VH=[0,0,0],VI=[0,b(V),[0,b(em),0]],VR=[0,b(d),0,1,0,1,0],VJ=[0,b(az),85,11,85,61,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],VS=[0,0,0],VT=[0,b(V),[0,b("enfants_\xc3\xa0_charge_droit_ouvert_prestation_familiale"),0]],VX=[0,0,0],VY=[0,b(V),[0,b(iZ),0]],Wj=[0,b(d),0,1,0,1,0],VZ=[0,b(az),p8,11,p8,28,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Wk=[0,0,0],Wl=[0,b(V),[0,b("plafond_II_d521_3"),0]],WI=[0,b(d),0,1,0,1,0],Wm=[0,b(az),FS,11,FS,27,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],WJ=[0,0,0],WK=[0,b(V),[0,b("plafond_I_d521_3"),0]],WS=[0,b(d),0,1,0,1,0],WL=[0,b(az),dc,11,dc,34,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],WT=[0,0,0],WU=[0,b(V),[0,b("droit_ouvert_compl\xc3\xa9ment"),0]],W9=[0,0,0],W_=[0,b(V),[0,b(h8),0]],Xf=[0,b(d),0,1,0,1,0],W$=[0,b(az),Dl,11,Dl,64,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Xg=[0,0,0],Xh=[0,b(V),[0,b("montant_initial_base_quatri\xc3\xa8me_enfant_et_plus_mayotte"),0]],Yl=[0,b(d),0,1,0,1,0],Xi=[0,b(az),EV,11,EV,56,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Ym=[0,0,0],Yn=[0,b(V),[0,b("montant_initial_base_troisi\xc3\xa8me_enfant_mayotte"),0]],Yq=[0,b(d),0,1,0,1,0],Yo=[0,b(az),fn,11,fn,31,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Yr=[0,0,0],Ys=[0,b(V),[0,b("nombre_total_enfants"),0]],YF=[0,b(d),0,1,0,1,0],Yt=[0,b(az),de,11,de,31,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],YG=[0,0,0],YH=[0,b(V),[0,b("nombre_moyen_enfants"),0]],ZZ=[0,b(d),0,1,0,1,0],YI=[0,b(az),96,11,96,46,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],Z0=[0,0,0],Z1=[0,b(V),[0,b("montant_initial_base_premier_enfant"),0]],_e=[0,b(d),0,1,0,1,0],Z2=[0,b(az),94,11,94,28,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],_f=[0,0,0],_g=[0,b(V),[0,b("droit_ouvert_base"),0]],_G=[0,0,0],_H=[0,b(V),[0,b(bH),0]],_0=[0,0,0],_1=[0,b(V),[0,b(iq),0]],$b=[0,b(d),0,1,0,1,0],_2=[0,b(az),AQ,11,AQ,47,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],$c=[0,0,0],$d=[0,b(V),[0,b("montant_vers\xc3\xa9_forfaitaire_par_enfant"),0]],$y=[0,b(d),0,1,0,1,0],$e=[0,b(az),98,11,98,56,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],$z=[0,0,0],$A=[0,b(V),[0,b("montant_initial_base_troisi\xc3\xa8me_enfant_et_plus"),0]],aaW=[0,b(d),0,1,0,1,0],$B=[0,b(az),97,11,97,47,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],aaX=[0,0,0],aaY=[0,b(V),[0,b("montant_initial_base_deuxi\xc3\xa8me_enfant"),0]],aa3=[0,b(d),0,1,0,1,0],aaZ=[0,b(az),99,11,99,38,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],aa4=[0,0,0],aa5=[0,b(V),[0,b("rapport_enfants_total_moyen"),0]],abH=[0,0,0],abI=[0,b(V),[0,b(h5),0]],abR=[0,b(d),0,1,0,1,0],abJ=[0,b(az),qG,11,qG,36,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],abS=[0,0,0],abT=[0,b(V),[0,b("montant_vers\xc3\xa9_forfaitaire"),0]],ab4=[0,b(d),0,1,0,1,0],abU=[0,b(az),95,11,95,31,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],ab5=[0,0,0],ab6=[0,b(V),[0,b("montant_initial_base"),0]],acA=[0,0,0],acB=[0,b(V),[0,b(h0),0]],acT=[0,b(d),0,1,0,1,0],acC=[0,b(az),mn,11,mn,52,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],acU=[0,0,0],acV=[0,b(V),[0,b("montant_vers\xc3\xa9_compl\xc3\xa9ment_pour_forfaitaire"),0]],acY=[0,b(d),0,1,0,1,0],acW=[0,b(az),k1,11,k1,43,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],acZ=[0,0,0],ac0=[0,b(V),[0,b("montant_avec_garde_altern\xc3\xa9e_base"),0]],adh=[0,0,0],adi=[0,b(V),[0,b(iz),0]],adm=[0,b(d),0,1,0,1,0],adj=[0,b(az),iU,11,iU,29,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],adn=[0,0,0],ado=[0,b(V),[0,b("montant_vers\xc3\xa9_base"),0]],adz=[0,b(d),0,1,0,1,0],adp=[0,b(az),ef,11,ef,35,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],adA=[0,0,0],adB=[0,b(V),[0,b("montant_vers\xc3\xa9_majoration"),0]],adE=[0,b(d),0,1,0,1,0],adC=[0,b(az),yh,11,yh,58,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],adF=[0,0,0],adG=[0,b(V),[0,b("montant_base_compl\xc3\xa9ment_pour_base_et_majoration"),0]],adQ=[0,b(d),0,1,0,1,0],adH=[0,b(az),gJ,11,gJ,59,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],adR=[0,0,0],adS=[0,b(V),[0,b("montant_vers\xc3\xa9_compl\xc3\xa9ment_pour_base_et_majoration"),0]],adW=[0,b(d),0,1,0,1,0],adT=[0,b(az),91,12,91,25,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],adX=[0,0,1],adY=[0,b(V),[0,b("montant_vers\xc3\xa9"),0]],Uf=[0,b("examples/allocations_familiales/autres_codes.catala_fr"),24,5,24,63,[0,b("Article L821-3"),[0,b(xa),[0,b(Id),[0,b(wg),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]]],Ug=[0,b(d),0,1,0,1,0],Ub=[0,b(bN),65,5,67,62,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Uc=[0,b(d),0,1,0,1,0],Ua=[0,b(bN),54,5,55,50,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],Ud=[0,b(d),0,1,0,1,0],Ue=[0,b(d),0,1,0,1,0],Uh=[0,b(d),0,1,0,1,0],T$=[0,b(az),48,12,48,24,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],Ui=[0,b(d),0,1,0,1,0],T_=[0,b(az),48,12,48,24,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],T5=[0,b(bN),73,5,76,56,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],T6=[0,b(d),0,1,0,1,0],T4=[0,b(az),49,12,49,31,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],T7=[0,b(d),0,1,0,1,0],T3=[0,b(az),49,12,49,31,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],TY=[0,b(dO),q7,18,q7,41,[0,b(vW),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(cV),[0,b(ae),0]]]]]]],TW=b(nm),TX=b(mX),TZ=[0,b(d),0,1,0,1,0],TV=[0,b(dO),31,14,31,30,[0,b(lI),[0,b(kS),[0,b(dN),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],TT=b(nm),TU=b(mX),TH=[5,0],TI=[4,0],TJ=[3,0],TK=[2,0],TL=[1,0],TM=[0,0],TN=[0,b(bN),hc,5,387,30,[0,b(GH),[0,b(DZ),[0,b(iA),[0,b(dF),[0,b(X),[0,b(ae),0]]]]]]],TO=[0,b(d),0,1,0,1,0],TG=[0,b(az),52,12,52,35,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],Tz=[0,b(az),58,14,58,28,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],Tu=[0,b(az),59,14,59,32,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],Tp=[0,b(dO),21,14,21,26,[0,b(lI),[0,b(kS),[0,b(dN),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],Tq=[0,b(d),0,1,0,1,0],To=[0,b(az),51,12,51,24,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],Tr=[0,0,1],Ts=[0,b(co),[0,b(Er),0]],Tv=[0,b(d),0,1,0,1,0],Tw=[0,1,0],Tx=[0,b(co),[0,b(Ih),0]],Tt=[0,b(az),59,14,59,32,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],TA=[0,b(d),0,1,0,1,0],TB=[0,1,0],TC=[0,b(co),[0,b(Hf),0]],Ty=[0,b(az),58,14,58,28,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],TD=[0,b(co),[0,b(fj),[0,b(gU),0]]],TE=[0,b(co),[0,b(fj),[0,b(gU),0]]],TP=[0,b(d),0,1,0,1,0],TF=[0,b(az),52,12,52,35,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],TQ=[0,0,1],TR=[0,b(co),[0,b(uq),0]],T0=[0,b(d),0,1,0,1,0],TS=[0,b(az),50,11,50,27,[0,b(dC),[0,b(aB),[0,b(ao),0]]]],T1=[0,0,0],T2=[0,b(co),[0,b(xl),0]],T8=[0,0,1],T9=[0,b(co),[0,b(gG),0]],Uj=[0,0,1],Uk=[0,b(co),[0,b(bE),0]],Th=[0,b(fe),32,5,33,33,[0,b(yS),[0,b(cE),0]]],Tg=b(vZ),Ti=[0,b(d),0,1,0,1,0],Te=[0,b(fe),52,5,53,33,[0,b(xI),[0,b(cE),0]]],Td=b(vO),Tf=[0,b(d),0,1,0,1,0],Tb=[0,b(fe),68,5,69,33,[0,b(Gg),[0,b(cE),0]]],Ta=b(Gc),Tc=[0,b(d),0,1,0,1,0],S_=[0,b(fe),86,5,87,33,[0,b(vv),[0,b(cE),0]]],S9=b(F$),S$=[0,b(d),0,1,0,1,0],S7=[0,b(fe),g5,5,g5,34,[0,b(Ej),[0,b(cE),0]]],S6=b(Iy),S8=[0,b(d),0,1,0,1,0],Tj=[0,b(d),0,1,0,1,0],S4=[0,b(fe),10,13,10,42,[0,b(cE),0]],Tn=[0,b(fe),10,13,10,42,[0,b(cE),0]],Tk=[0,b(d),0,1,0,1,0],S5=[0,b(fe),6,12,6,19,[0,b(cE),0]],Tl=[0,0,1],Tm=[0,b(hh),[0,b(bO),0]],SP=[7,0],SQ=[5,0],SR=[4,0],SS=[3,0],ST=[2,0],SU=[1,0],SV=[0,0],SW=[6,0],SX=[0,b(cn),34,5,43,6,[0,b(b3),[0,b(jS),[0,b(aY),0]]]],SO=b(vo),SY=[0,b(d),0,1,0,1,0],SL=[8,0],SM=[0,b(cn),52,5,54,6,[0,b(b3),[0,b(jS),[0,b(aY),0]]]],SK=b(Dm),SN=[0,b(d),0,1,0,1,0],SA=[7,0],SB=[5,0],SC=[4,0],SD=[3,0],SE=[2,0],SF=[1,0],SG=[0,0],SH=[6,0],SI=[0,b(cn),73,5,82,6,[0,b(b3),[0,b(mU),[0,b(aY),0]]]],Sz=b(Fx),SJ=[0,b(d),0,1,0,1,0],Sw=[8,0],Sx=[0,b(cn),91,5,93,6,[0,b(b3),[0,b(mU),[0,b(aY),0]]]],Sv=b(BD),Sy=[0,b(d),0,1,0,1,0],Sl=[7,0],Sm=[5,0],Sn=[4,0],So=[3,0],Sp=[2,0],Sq=[1,0],Sr=[0,0],Ss=[6,0],St=[0,b(cn),rD,5,lN,6,[0,b(b3),[0,b(lK),[0,b(aY),0]]]],Sk=b(ye),Su=[0,b(d),0,1,0,1,0],Sh=[8,0],Si=[0,b(cn),iV,5,gJ,6,[0,b(b3),[0,b(lK),[0,b(aY),0]]]],Sg=b(H0),Sj=[0,b(d),0,1,0,1,0],R8=[7,0],R9=[5,0],R_=[4,0],R$=[3,0],Sa=[2,0],Sb=[1,0],Sc=[0,0],Sd=[6,0],Se=[0,b(cn),lH,5,mY,6,[0,b(b3),[0,b(mC),[0,b(aY),0]]]],R7=b(yp),Sf=[0,b(d),0,1,0,1,0],R4=[8,0],R5=[0,b(cn),zg,5,xb,6,[0,b(b3),[0,b(mC),[0,b(aY),0]]]],R3=b(vy),R6=[0,b(d),0,1,0,1,0],RT=[7,0],RU=[5,0],RV=[4,0],RW=[3,0],RX=[2,0],RY=[1,0],RZ=[0,0],R0=[6,0],R1=[0,b(cn),Dt,5,fR,6,[0,b(dz),[0,b(kf),[0,b(aY),0]]]],RS=b(EQ),R2=[0,b(d),0,1,0,1,0],RP=[8,0],RQ=[0,b(cn),GO,5,Fg,6,[0,b(dz),[0,b(kf),[0,b(aY),0]]]],RO=b(Al),RR=[0,b(d),0,1,0,1,0],RE=[7,0],RF=[5,0],RG=[4,0],RH=[3,0],RI=[2,0],RJ=[1,0],RK=[0,0],RL=[6,0],RM=[0,b(cn),pw,5,u3,6,[0,b(dz),[0,b(ld),[0,b(aY),0]]]],RD=b(HP),RN=[0,b(d),0,1,0,1,0],RA=[8,0],RB=[0,b(cn),bl,5,j1,6,[0,b(dz),[0,b(ld),[0,b(aY),0]]]],Rz=b(Io),RC=[0,b(d),0,1,0,1,0],Rp=[7,0],Rq=[5,0],Rr=[4,0],Rs=[3,0],Rt=[2,0],Ru=[1,0],Rv=[0,0],Rw=[6,0],Rx=[0,b(cn),qs,5,q$,6,[0,b(b3),[0,b(mo),[0,b(aY),0]]]],Ro=b(uQ),Ry=[0,b(d),0,1,0,1,0],Rl=[8,0],Rm=[0,b(cn),ia,5,p4,6,[0,b(b3),[0,b(mo),[0,b(aY),0]]]],Rk=b(wX),Rn=[0,b(d),0,1,0,1,0],Ra=[7,0],Rb=[5,0],Rc=[4,0],Rd=[3,0],Re=[2,0],Rf=[1,0],Rg=[0,0],Rh=[6,0],Ri=[0,b(cn),gX,5,Fi,6,[0,b(dz),[0,b(mW),[0,b(aY),0]]]],Q$=b(v2),Rj=[0,b(d),0,1,0,1,0],Q8=[8,0],Q9=[0,b(cn),iR,5,qX,6,[0,b(dz),[0,b(mW),[0,b(aY),0]]]],Q7=b(yo),Q_=[0,b(d),0,1,0,1,0],SZ=[0,b(d),0,1,0,1,0],Q5=[0,b(cn),16,13,16,42,[0,b(ao),[0,b(aY),0]]],S3=[0,b(cn),16,13,16,42,[0,b(ao),[0,b(aY),0]]],S0=[0,b(d),0,1,0,1,0],Q6=[0,b(cn),11,12,11,24,[0,b(ao),[0,b(aY),0]]],S1=[0,0,1],S2=[0,b(gU),[0,b(E3),0]],Q1=[0,b(m6),36,14,36,27,[0,b(ao),[0,b(aY),0]]],Q2=[0,b(d),0,1,0,1,0],Q0=[0,b(m6),33,12,33,25,[0,b(ao),[0,b(aY),0]]],Q3=[0,0,1],Q4=[0,b(d0),[0,b(pp),0]],QV=[0,b(m6),25,14,25,35,[0,b(ao),[0,b(aY),0]]],QW=[0,b(d),0,1,0,1,0],QU=[0,b(m6),22,12,22,33,[0,b(ao),[0,b(aY),0]]],QX=[0,0,1],QY=[0,b(fO),[0,b(pL),0]],QP=[0,b(bu),12,14,12,25,[0,b(eM),[0,b(bv),0]]],QL=[2,0],QM=b(r),QN=[1,0],QO=b("-1"),QQ=[0,b(d),0,1,0,1,0],QK=[0,b(az),70,12,70,23,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],QR=[0,0,1],QS=[0,b(px),[0,b("le_plus_\xc3\xa2g\xc3\xa9"),0]],QG=[0,b(dO),78,14,78,41,[0,b(kL),[0,b(aP),[0,b(aR),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],QH=[0,b(d),0,1,0,1,0],QF=[0,b(az),66,12,66,39,[0,b(aV),[0,b(aB),[0,b(ao),0]]]],QI=[0,0,1],QJ=[0,b(pr),[0,b(em),0]],Qx=b("b\xc3\xa9n\xc3\xa9ficie_titre_personnel_aide_personnelle_logement"),Qy=b(pk),Qz=b("prise_en_charge"),QA=b(qx),QB=b(pn),QC=b(pK),QD=b(qT),QE=[0,b("Enfant"),0],Qn=b(l4),Qp=b(li),Qq=b(j4),Qr=b(G9),Qs=b(wt),Qt=b(nI),Qu=b(GP),Qv=b(kv),Qw=b(ls),Qo=[0,b(Ga),0],Qj=b("Compl\xc3\xa8te"),Ql=b("Partag\xc3\xa9e"),Qm=b("Z\xc3\xa9ro"),Qk=[0,b("PriseEnCompte"),0],Qf=b(ic),Qh=b(h9),Qi=b(Gm),Qg=[0,b(GL),0],P$=b("GardeAltern\xc3\xa9ePartageAllocations"),Qb=b("GardeAltern\xc3\xa9eAllocataireUnique"),Qc=b(o9),Qd=b("ServicesSociauxAllocationVers\xc3\xa9e\xc3\x80LaFamille"),Qe=b("ServicesSociauxAllocationVers\xc3\xa9eAuxServicesSociaux"),Qa=[0,b("PriseEnCharge"),0],afD=b(d),afb=b(l4),afc=b(li),afd=b(Cx),afe=b(j4),aff=b(ls),afg=b(AO),afh=b(vJ),afi=b(nI),afj=b(kv),afl=[7,0],afm=[5,0],afn=[4,0],afo=[6,0],afp=[8,0],afq=[2,0],afr=[3,0],afs=[1,0],aft=[0,0],afk=[0,[11,b(bp),[2,0,[11,b(yu),0]]],b(vq)],ae6=b(ri),ae7=b(ic),ae8=b(h9),ae_=[1,0],ae$=[0,0],afa=[2,0],ae9=[0,[11,b(bp),[2,0,[11,b(v5),0]]],b(CA)],aeV=b(o9),aeW=b(wE),aeX=b(CI),aeY=b(Fp),aeZ=b(vj),ae1=[4,0],ae2=[3,0],ae3=[0,0],ae4=[1,0],ae5=[2,0],ae0=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'PriseEnCharge.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'PriseEnCharge.t'")],aeT=[0,b(yI),b(lB),b(fj),b(Hd),b(lL),b(II),b(uM),b(vM),b(nA)],aeU=[0,b(nA),b(lL),b(fj),b(uM),b(II),b(vM),b(lB),b(yI),b(Hd)],afN=b("AllocationsFamilialesLib"),bWB=[0,b(dm),x4,14,x4,25,[0,b("Conseil d'\xc3\x89tat, 5\xc3\xa8me - 4\xc3\xa8me chambres r\xc3\xa9unies, 21/07/2017, 398563"),0]],bWs=b(r),bWt=b(r),bWA=b(by),bWu=[0,1,0],bWv=[0,b(a6),[0,b(aA),[0,b(ac),0]]],bWw=[0,b(a6),[0,b(aA),0]],bWx=[0,0,1],bWy=[0,b(a6),[0,b(aA),[0,b(Y),0]]],bWz=[0,b(a6),[0,b(aA),0]],bWn=[0,b(o),yr,14,yr,63,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWi=[0,b(o),Ig,14,Ig,25,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWb=[0,b(o),lm,5,lm,70,[0,b(bX),[0,b(at),[0,b(p),0]]]],bV8=[0,b(o),jY,14,jY,58,[0,b(bX),[0,b(at),[0,b(p),0]]]],bV3=[0,b(o),l8,14,l8,54,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVY=[0,b(o),k$,14,k$,51,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVR=[0,b(o),im,14,im,59,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVM=[0,b(o),nC,14,nC,38,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVH=[0,b(o),kZ,14,kZ,34,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVC=[0,b(o),kI,14,kI,31,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVx=[0,b(o),jX,14,jX,48,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVy=[0,b(d),0,1,0,1,0],bVw=[0,b(o),F8,11,F8,45,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVz=[0,0,0],bVA=[0,b(cD),[0,b("m\xc3\xa9nage_sans_enfants_garde_altern\xc3\xa9e"),0]],bVD=[0,b(d),0,1,0,1,0],bVE=[0,1,0],bVF=[0,b(cD),[0,b("calculette.m\xc3\xa9nage"),0]],bVB=[0,b(o),kI,14,kI,31,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVI=[0,b(d),0,1,0,1,0],bVJ=[0,1,0],bVK=[0,b(cD),[0,b("calculette.demandeur"),0]],bVG=[0,b(o),kZ,14,kZ,34,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVN=[0,b(d),0,1,0,1,0],bVO=[0,1,0],bVP=[0,b(cD),[0,b("calculette.date_courante"),0]],bVL=[0,b(o),nC,14,nC,38,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVS=[0,b(d),0,1,0,1,0],bVT=[0,1,0],bVU=[0,b(cD),[0,b("calculette.ressources_m\xc3\xa9nage_prises_en_compte"),0]],bVQ=[0,b(o),im,14,im,59,[0,b(bX),[0,b(at),[0,b(p),0]]]],bVV=[0,b(cD),[0,b(z0),[0,b(a6),0]]],bVW=[0,b(cD),[0,b(z0),[0,b(a6),0]]],bVZ=[0,b(d),0,1,0,1,0],bV0=[0,1,0],bV1=[0,b(cD),[0,b("calculette_sans_garde_altern\xc3\xa9e.m\xc3\xa9nage"),0]],bVX=[0,b(o),k$,14,k$,51,[0,b(bX),[0,b(at),[0,b(p),0]]]],bV4=[0,b(d),0,1,0,1,0],bV5=[0,1,0],bV6=[0,b(cD),[0,b("calculette_sans_garde_altern\xc3\xa9e.demandeur"),0]],bV2=[0,b(o),l8,14,l8,54,[0,b(bX),[0,b(at),[0,b(p),0]]]],bV9=[0,b(d),0,1,0,1,0],bV_=[0,1,0],bV$=[0,b(cD),[0,b("calculette_sans_garde_altern\xc3\xa9e.date_courante"),0]],bV7=[0,b(o),jY,14,jY,58,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWc=[0,b(d),0,1,0,1,0],bWd=[0,1,0],bWe=[0,b(cD),[0,b("calculette_sans_garde_altern\xc3\xa9e.ressources_m\xc3\xa9nage_prises_en_compte"),0]],bWa=[0,b(o),lm,5,lm,70,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWf=[0,b(cD),[0,b(vu),[0,b(a6),0]]],bWg=[0,b(cD),[0,b(vu),[0,b(a6),0]]],bWj=[0,b(d),0,1,0,1,0],bWh=[0,b(o),BZ,12,BZ,23,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWk=[0,0,1],bWl=[0,b(cD),[0,b(iQ),0]],bWo=[0,b(d),0,1,0,1,0],bWm=[0,b(o),Fu,11,Fu,60,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWp=[0,0,0],bWq=[0,b(cD),[0,b(iT),0]],bWC=[0,b(d),0,1,0,1,0],bWr=[0,b(o),IH,12,IH,23,[0,b(bX),[0,b(at),[0,b(p),0]]]],bWD=[0,0,1],bWE=[0,b(cD),[0,b("aide_finale"),0]],bVr=[0,b(al),Ep,14,Ep,33,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bVe=b(r),bVf=[0,1,0],bVg=[0,b(cF),[0,b(aA),[0,b(ac),0]]],bVh=[0,b(cF),[0,b(aA),0]],bVi=[0,0,1],bVj=[0,b(cF),[0,b(aA),[0,b(Y),0]]],bVk=[0,b(cF),[0,b(aA),0]],bVl=[0,1,0],bVm=[0,b(cK),[0,b(aA),[0,b(ac),0]]],bVn=[0,b(cK),[0,b(aA),0]],bVo=[0,0,1],bVp=[0,b(cK),[0,b(aA),[0,b(Y),0]]],bVq=[0,b(cK),[0,b(aA),0]],bU$=[0,b(al),Aw,14,Aw,36,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bUZ=[0,1,0],bU0=[0,b(cK),[0,b(aA),[0,b(ac),0]]],bU1=[0,b(cK),[0,b(aA),0]],bU2=[0,0,1],bU3=[0,b(cK),[0,b(aA),[0,b(Y),0]]],bU4=[0,b(cK),[0,b(aA),0]],bU5=[0,1,0],bU6=[0,b(cF),[0,b(aA),[0,b(ac),0]]],bU7=[0,b(cF),[0,b(aA),0]],bU8=[0,0,1],bU9=[0,b(cF),[0,b(aA),[0,b(Y),0]]],bU_=[0,b(cF),[0,b(aA),0]],bVa=[0,b(d),0,1,0,1,0],bUY=[0,b(o),BC,12,BC,34,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUU=[0,b(al),mT,14,mT,25,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bUP=[0,b(o),E2,14,E2,63,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUI=[0,b(o),k9,14,k9,58,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUD=[0,b(o),lS,14,lS,62,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUy=[0,b(o),mO,14,mO,53,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUt=[0,b(o),iS,5,iS,65,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUo=[0,b(o),mS,14,mS,68,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUj=[0,b(o),gR,14,gR,66,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUe=[0,b(al),mg,14,mg,58,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bUd=[0,0],bT_=[0,b(o),gl,14,gl,64,[0,b(a0),[0,b(at),[0,b(p),0]]]],bT3=[0,b(o),lF,14,lF,50,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTY=[0,b(al),gY,14,gY,50,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bTV=[2,0],bTW=[1,0],bTX=[2,0],bTQ=[0,b(o),h4,14,h4,54,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTL=[0,b(o),h1,14,h1,45,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTG=[0,b(o),ly,14,ly,66,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTB=[0,b(o),jT,14,jT,60,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTw=[0,b(o),mP,14,mP,58,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTr=[0,b(o),jR,14,jR,56,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTk=[0,b(o),l7,14,l7,67,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTf=[0,b(o),iE,14,iE,63,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTa=[0,b(o),nc,14,nc,60,[0,b(a0),[0,b(at),[0,b(p),0]]]],bS5=[0,b(al),lZ,5,lZ,74,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bS0=[0,b(o),kP,14,kP,55,[0,b(a0),[0,b(at),[0,b(p),0]]]],bSV=[0,b(o),l0,14,l0,52,[0,b(a0),[0,b(at),[0,b(p),0]]]],bSQ=[0,b(o),mF,14,mF,59,[0,b(a0),[0,b(at),[0,b(p),0]]]],bSR=[0,b(d),0,1,0,1,0],bSS=[0,1,0],bST=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_allocation_logement.date_courante"),0]],bSP=[0,b(o),mF,14,mF,59,[0,b(a0),[0,b(at),[0,b(p),0]]]],bSW=[0,b(d),0,1,0,1,0],bSX=[0,1,0],bSY=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_allocation_logement.m\xc3\xa9nage"),0]],bSU=[0,b(o),l0,14,l0,52,[0,b(a0),[0,b(at),[0,b(p),0]]]],bS1=[0,b(d),0,1,0,1,0],bS2=[0,1,0],bS3=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_allocation_logement.demandeur"),0]],bSZ=[0,b(o),kP,14,kP,55,[0,b(a0),[0,b(at),[0,b(p),0]]]],bS6=[0,b(d),0,1,0,1,0],bS7=[0,1,0],bS8=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_allocation_logement.b\xc3\xa9n\xc3\xa9ficie_aide_personnalis\xc3\xa9e_logement"),0]],bS4=[0,b(al),lZ,5,lZ,74,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bS9=[0,b(a6),[0,b(ug),[0,b(bZ),0]]],bS_=[0,b(a6),[0,b(ug),[0,b(bZ),0]]],bTb=[0,b(d),0,1,0,1,0],bTc=[0,1,0],bTd=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_aide_personnalis\xc3\xa9e_logement.m\xc3\xa9nage"),0]],bS$=[0,b(o),nc,14,nc,60,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTg=[0,b(d),0,1,0,1,0],bTh=[0,1,0],bTi=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_aide_personnalis\xc3\xa9e_logement.demandeur"),0]],bTe=[0,b(o),iE,14,iE,63,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTl=[0,b(d),0,1,0,1,0],bTm=[0,1,0],bTn=[0,b(a6),[0,b("\xc3\xa9ligibilit\xc3\xa9_aide_personnalis\xc3\xa9e_logement.date_courante"),0]],bTj=[0,b(o),l7,14,l7,67,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTo=[0,b(a6),[0,b(GX),[0,b(bQ),0]]],bTp=[0,b(a6),[0,b(GX),[0,b(bQ),0]]],bTs=[0,b(d),0,1,0,1,0],bTt=[0,1,0],bTu=[0,b(a6),[0,b("calcul_allocation_logement.mode_occupation"),0]],bTq=[0,b(o),jR,14,jR,56,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTx=[0,b(d),0,1,0,1,0],bTy=[0,1,0],bTz=[0,b(a6),[0,b("calcul_allocation_logement.ressources_m\xc3\xa9nage_sans_arrondi"),0]],bTv=[0,b(o),mP,14,mP,58,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTC=[0,b(d),0,1,0,1,0],bTD=[0,1,0],bTE=[0,b(a6),[0,b("calcul_allocation_logement.situation_familiale"),0]],bTA=[0,b(o),jT,14,jT,60,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTH=[0,b(d),0,1,0,1,0],bTI=[0,1,0],bTJ=[0,b(a6),[0,b("calcul_allocation_logement.nombre_personnes_\xc3\xa0_charge"),0]],bTF=[0,b(o),ly,14,ly,66,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTM=[0,b(d),0,1,0,1,0],bTN=[0,1,0],bTO=[0,b(a6),[0,b("calcul_allocation_logement.zone"),0]],bTK=[0,b(o),h1,14,h1,45,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTR=[0,b(d),0,1,0,1,0],bTS=[0,1,0],bTT=[0,b(a6),[0,b("calcul_allocation_logement.date_courante"),0]],bTP=[0,b(o),h4,14,h4,54,[0,b(a0),[0,b(at),[0,b(p),0]]]],bTZ=[0,b(d),0,1,0,1,0],bT0=[0,1,0],bT1=[0,b(a6),[0,b("calcul_allocation_logement.type_aide"),0]],bTU=[0,b(al),gY,14,gY,50,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bT4=[0,b(d),0,1,0,1,0],bT5=[0,1,0],bT6=[0,b(a6),[0,b("calcul_allocation_logement.r\xc3\xa9sidence"),0]],bT2=[0,b(o),lF,14,lF,50,[0,b(a0),[0,b(at),[0,b(p),0]]]],bT7=[0,b(a6),[0,b(HQ),[0,b(cF),0]]],bT8=[0,b(a6),[0,b(HQ),[0,b(cF),0]]],bT$=[0,b(d),0,1,0,1,0],bUa=[0,1,0],bUb=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.mode_occupation"),0]],bT9=[0,b(o),gl,14,gl,64,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUf=[0,b(d),0,1,0,1,0],bUg=[0,1,0],bUh=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.type_aide"),0]],bUc=[0,b(al),mg,14,mg,58,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bUk=[0,b(d),0,1,0,1,0],bUl=[0,1,0],bUm=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.ressources_m\xc3\xa9nage_sans_arrondi"),0]],bUi=[0,b(o),gR,14,gR,66,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUp=[0,b(d),0,1,0,1,0],bUq=[0,1,0],bUr=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.situation_familiale"),0]],bUn=[0,b(o),mS,14,mS,68,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUu=[0,b(d),0,1,0,1,0],bUv=[0,1,0],bUw=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.nombre_personnes_\xc3\xa0_charge"),0]],bUs=[0,b(o),iS,5,iS,65,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUz=[0,b(d),0,1,0,1,0],bUA=[0,1,0],bUB=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.zone"),0]],bUx=[0,b(o),mO,14,mO,53,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUE=[0,b(d),0,1,0,1,0],bUF=[0,1,0],bUG=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.date_courante"),0]],bUC=[0,b(o),lS,14,lS,62,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUJ=[0,b(d),0,1,0,1,0],bUK=[0,1,0],bUL=[0,b(a6),[0,b("calcul_aide_personnalis\xc3\xa9e_logement.r\xc3\xa9sidence"),0]],bUH=[0,b(o),k9,14,k9,58,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUM=[0,b(a6),[0,b(EB),[0,b(cK),0]]],bUN=[0,b(a6),[0,b(EB),[0,b(cK),0]]],bUQ=[0,b(d),0,1,0,1,0],bUO=[0,b(o),ET,12,ET,61,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUR=[0,0,1],bUS=[0,b(a6),[0,b(iT),0]],bUV=[0,b(d),0,1,0,1,0],bUT=[0,b(o),BK,12,BK,23,[0,b(a0),[0,b(at),[0,b(p),0]]]],bUW=[0,0,1],bUX=[0,b(a6),[0,b(iQ),0]],bVb=[0,0,1],bVc=[0,b(a6),[0,b(aA),0]],bVs=[0,b(d),0,1,0,1,0],bVd=[0,b(o),FY,12,FY,31,[0,b(a0),[0,b(at),[0,b(p),0]]]],bVt=[0,0,1],bVu=[0,b(a6),[0,b(cO),0]],bSL=[0,b(z),yM,14,yM,33,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bSG=[0,b(z),Cv,14,Cv,36,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bSH=[0,b(d),0,1,0,1,0],bSF=[0,b(o),G2,12,G2,34,[0,b(dA),[0,b(ad),[0,b(P),[0,b(p),0]]]]],bSA=[0,b(z),CX,5,CX,50,[0,b(re),[0,b(rt),[0,b(o_),[0,b(ke),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bSq=[0,1,0],bSr=[0,b(a8),[0,b(aA),[0,b(ac),0]]],bSs=[0,b(a8),[0,b(aA),0]],bSt=[0,0,1],bSu=[0,b(a8),[0,b(aA),[0,b(Y),0]]],bSv=[0,b(a8),[0,b(aA),0]],bSi=b(r),bSj=b(r),bSk=[1,0],bSm=b(r),bSl=[0,b(z),wj,42,wj,45,[0,b(re),[0,b(rt),[0,b(o_),[0,b(ke),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bSn=[0,1,0],bSo=[0,b(a8),[0,b(a9),[0,b(dM),0]]],bSp=[0,b(a8),[0,b(a9),0]],bSw=[0,b(z),6518,9,6548,10,[0,b(re),[0,b(rt),[0,b(o_),[0,b(ke),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bSx=[0,0,1],bSy=[0,b(a8),[0,b(a9),[0,b(Y),0]]],bSz=[0,b(a8),[0,b(a9),0]],bSB=[0,b(d),0,1,0,1,0],bSh=[0,b(z),Cl,14,Cl,36,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bR9=[0,1,0],bR_=[0,b(af),[0,b(aA),[0,b(ac),0]]],bR$=[0,b(af),[0,b(aA),0]],bSa=[0,0,1],bSb=[0,b(af),[0,b(aA),[0,b(Y),0]]],bSc=[0,b(af),[0,b(aA),0]],bRW=[0,1,0],bRX=[0,b(L),[0,b(aA),[0,b(ac),0]]],bRY=[0,b(L),[0,b(aA),0]],bRZ=[0,0,1],bR0=[0,b(L),[0,b(aA),[0,b(Y),0]]],bR1=[0,b(L),[0,b(aA),0]],bRH=[0,1,0],bRI=[0,b(a8),[0,b(aA),[0,b(ac),0]]],bRJ=[0,b(a8),[0,b(aA),0]],bRK=[0,0,1],bRL=[0,b(a8),[0,b(aA),[0,b(Y),0]]],bRM=[0,b(a8),[0,b(aA),0]],bRR=b(r),bRS=b(r),bRD=[0,b(z),1549,16,nn,39,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bRE=[0,1,0],bRF=[0,b(a8),[0,b(a9),[0,b(dM),0]]],bRG=[0,b(a8),[0,b(a9),0]],bRN=[0,b(z),1533,9,pJ,10,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bRO=[0,0,1],bRP=[0,b(a8),[0,b(a9),[0,b(Y),0]]],bRQ=[0,b(a8),[0,b(a9),0]],bRT=[0,1,0],bRU=[0,b(L),[0,b(a9),[0,b(dM),0]]],bRV=[0,b(L),[0,b(a9),0]],bR2=[0,b(z),1590,10,Dj,11,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bR3=[0,0,1],bR4=[0,b(L),[0,b(a9),[0,b(Y),0]]],bR5=[0,b(L),[0,b(a9),0]],bR6=[0,1,0],bR7=[0,b(af),[0,b(a9),[0,b(dM),0]]],bR8=[0,b(af),[0,b(a9),0]],bSd=[0,b(z),1566,9,1580,10,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bSe=[0,0,1],bSf=[0,b(af),[0,b(a9),[0,b(Y),0]]],bSg=[0,b(af),[0,b(a9),0]],bRy=[0,b(K),93,14,93,44,[0,b(bW),[0,b(bB),[0,b(J),0]]]],bRs=[0,0],bRt=[1,0],bRu=[1,0],bRv=[1,0],bRw=[0,0],bRx=[1,0],bRn=[0,b(z),pv,14,pv,31,[0,b(mV),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],bRi=[0,b(z),yy,14,yy,34,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bRj=[0,b(d),0,1,0,1,0],bRh=[0,b(o),zJ,11,zJ,31,[0,b(dA),[0,b(ad),[0,b(P),[0,b(p),0]]]]],bRk=[0,0,0],bRl=[0,b(cF),[0,b(Dn),0]],bRo=[0,b(d),0,1,0,1,0],bRm=[0,b(o),GJ,10,GJ,22,[0,b(dA),[0,b(ad),[0,b(P),[0,b(p),0]]]]],bRp=[0,0,0],bRq=[0,b(cF),[0,b(vH),0]],bRz=[0,b(d),0,1,0,1,0],bRr=[0,b(o),yQ,11,yQ,41,[0,b(dA),[0,b(ad),[0,b(P),[0,b(p),0]]]]],bRA=[0,0,0],bRB=[0,b(cF),[0,b(wD),0]],bSC=[0,b(d),0,1,0,1,0],bRC=[0,b(o),mT,11,mT,33,[0,b(dA),[0,b(ad),[0,b(P),[0,b(p),0]]]]],bSD=[0,0,0],bSE=[0,b(cF),[0,b(Im),0]],bSI=[0,0,1],bSJ=[0,b(cF),[0,b(aA),0]],bSM=[0,b(d),0,1,0,1,0],bSK=[0,b(o),z_,12,z_,31,[0,b(dA),[0,b(ad),[0,b(P),[0,b(p),0]]]]],bSN=[0,0,1],bSO=[0,b(cF),[0,b(cO),0]],bRb=[0,b(al),yD,5,1257,54,[0,b("Article L860-3"),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bRc=[0,b(d),0,1,0,1,0],bRa=[0,b(al),613,5,615,36,[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bRd=[0,b(d),0,1,0,1,0],bQ$=[0,b(o),iw,12,iw,23,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQ3=[0,b(al),763,5,776,30,[0,b(o8),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQ4=[0,b(d),0,1,0,1,0],bQ2=[0,b(al),744,5,749,30,[0,b(o8),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQ5=[0,b(d),0,1,0,1,0],bQ1=[0,b(al),nD,31,nD,54,[0,b(o8),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQ6=[0,b(d),0,1,0,1,0],bQ0=[0,b(o),hc,11,hc,34,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQV=[0,b(o),lt,14,lt,56,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQQ=[0,b(o),F_,14,F_,63,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQG=[0,b(z),5699,5,5703,30,[0,b("Article R861-20"),[0,b(EA),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bQH=[0,b(d),0,1,0,1,0],bQF=[0,b(z),3570,5,3573,30,[0,b("Article R832-20"),[0,b(uK),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],bQI=[0,b(d),0,1,0,1,0],bQJ=[0,b(d),0,1,0,1,0],bQK=[0,b(d),0,1,0,1,0],bQA=[0,b(z),3629,5,3634,30,[0,b("Article R832-21"),[0,b(uK),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],bQB=[0,b(d),0,1,0,1,0],bQz=[0,b(al),1397,5,1400,30,[0,b("Article L861-5-1"),[0,b("Section 3 : Aide personnalis\xc3\xa9e au logement"),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bQC=[0,b(d),0,1,0,1,0],bQy=[0,b(al),707,5,Hu,30,[0,b(lT),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQD=[0,b(d),0,1,0,1,0],bQE=[0,b(d),0,1,0,1,0],bQL=[0,b(d),0,1,0,1,0],bQn=[0,1,0],bQo=[0,b(bQ),[0,b(iD),[0,b(ac),0]]],bQp=[0,b(bQ),[0,b(iD),0]],bQq=[0,0,1],bQr=[0,b(bQ),[0,b(iD),[0,b(Y),0]]],bQs=[0,b(bQ),[0,b(iD),0]],bQm=[0,b(al),pH,5,pS,30,[0,b(lT),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQt=[0,b(d),0,1,0,1,0],bQl=[0,b(al),663,5,672,30,[0,b(lT),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQu=[0,b(d),0,1,0,1,0],bQf=[0,1,0],bQg=[0,b(bQ),[0,b(it),[0,b(ac),0]]],bQh=[0,b(bQ),[0,b(it),0]],bQi=[0,0,1],bQj=[0,b(bQ),[0,b(it),[0,b(Y),0]]],bQk=[0,b(bQ),[0,b(it),0]],bQe=[0,b(al),642,5,645,30,[0,b(lT),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bQv=[0,b(d),0,1,0,1,0],bQw=[0,b(d),0,1,0,1,0],bQx=[0,b(d),0,1,0,1,0],bQd=[0,b(o),my,11,my,38,[0,b(b4),[0,b(B),[0,b(p),0]]]],bP9=[0,b(K),zN,6,zN,43,[0,b("Article 49"),[0,b("Chapitre XI : Dispositions communes"),[0,b(J),0]]]],bP_=[0,b(d),0,1,0,1,0],bP8=[0,b(o),k2,11,k2,53,[0,b(b4),[0,b(B),[0,b(p),0]]]],bP1=[0,b(z),5442,5,5443,53,[0,b(wk),[0,b(ry),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bP2=[0,b(d),0,1,0,1,0],bP3=[0,2,0],bP4=[0,b(bQ),[0,b("\xc3\xa9ligibilit\xc3\xa9_commune.date_entr\xc3\xa9e_vigueur_diff\xc3\xa9r\xc3\xa9e_cch"),0]],bPX=[0,b(o),j5,14,j5,47,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPS=[0,b(o),mp,14,mp,43,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPN=[0,b(o),lz,14,lz,40,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPI=[0,b(o),hj,11,hj,41,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPJ=[0,b(d),0,1,0,1,0],bPH=[0,b(o),hj,11,hj,41,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPz=[0,b(z),2996,5,Fc,41,[0,b("Article R832-7"),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bPA=[0,b(d),0,1,0,1,0],bPy=[0,b(z),2961,5,2963,42,[0,b("Article R832-5"),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bPB=[0,b(d),0,1,0,1,0],bPC=[0,b(d),0,1,0,1,0],bPD=[0,b(d),0,1,0,1,0],bPx=[0,b(o),mG,11,mG,41,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPE=[0,b(d),0,1,0,1,0],bPw=[0,b(o),mG,11,mG,41,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPF=[0,0,0],bPG=[0,b(bQ),[0,b(it),0]],bPK=[0,0,0],bPL=[0,b(bQ),[0,b(iD),0]],bPO=[0,b(d),0,1,0,1,0],bPP=[0,1,0],bPQ=[0,b(bQ),[0,b(uB),0]],bPM=[0,b(o),lz,14,lz,40,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPT=[0,b(d),0,1,0,1,0],bPU=[0,1,0],bPV=[0,b(bQ),[0,b(FM),0]],bPR=[0,b(o),mp,14,mp,43,[0,b(b4),[0,b(B),[0,b(p),0]]]],bPY=[0,b(d),0,1,0,1,0],bPZ=[0,1,0],bP0=[0,b(bQ),[0,b(IV),0]],bPW=[0,b(o),j5,14,j5,47,[0,b(b4),[0,b(B),[0,b(p),0]]]],bP5=[0,b(bQ),[0,b(nf),[0,b(aT),0]]],bP6=[0,b(bQ),[0,b(nf),[0,b(aT),0]]],bP$=[0,b(d),0,1,0,1,0],bP7=[0,b(o),k2,11,k2,53,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQa=[0,0,0],bQb=[0,b(bQ),[0,b("logement_situ\xc3\xa9_commune_d\xc3\xa9s\xc3\xa9quilibre_l831_2"),0]],bQM=[0,b(d),0,1,0,1,0],bQc=[0,b(o),my,11,my,38,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQN=[0,0,0],bQO=[0,b(bQ),[0,b("condition_logement_bailleur"),0]],bQR=[0,b(d),0,1,0,1,0],bQP=[0,b(o),BH,12,BH,61,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQS=[0,0,1],bQT=[0,b(bQ),[0,b(iT),0]],bQW=[0,b(d),0,1,0,1,0],bQU=[0,b(o),mB,12,mB,54,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQX=[0,0,1],bQY=[0,b(bQ),[0,b(rn),0]],bQ7=[0,b(d),0,1,0,1,0],bQZ=[0,b(o),hc,11,hc,34,[0,b(b4),[0,b(B),[0,b(p),0]]]],bQ8=[0,0,0],bQ9=[0,b(bQ),[0,b("condition_logement_pr\xc3\xaat"),0]],bRe=[0,b(d),0,1,0,1,0],bQ_=[0,b(o),iw,12,iw,23,[0,b(b4),[0,b(B),[0,b(p),0]]]],bRf=[0,0,1],bRg=[0,b(bQ),[0,b(iQ),0]],bPo=[0,b(al),1608,5,Dj,79,[0,b("Article L861-8"),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bPn=[0,0],bPp=[0,b(d),0,1,0,1,0],bPm=[0,b(al),1574,5,1583,28,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bPl=[0,0],bPq=[0,b(d),0,1,0,1,0],bPk=[0,b(al),1173,5,h1,28,[0,b("Article L841-4"),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bPj=[0,0],bPr=[0,b(d),0,1,0,1,0],bPh=[0,b(al),gR,5,gR,73,[0,b(pF),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bPg=[2,0],bPi=[0,b(d),0,1,0,1,0],bPf=[0,b(al),gx,29,gx,40,[0,b(d_),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bPb=[0,0],bPc=[0,0],bPd=[1,0],bPe=[2,0],bOW=[0,b(al),z4,5,z4,66,[0,b(hk),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bOX=[0,b(d),0,1,0,1,0],bOP=[0,1,0],bOQ=[0,b(bn),[0,b(bE),[0,b(ac),0]]],bOR=[0,b(bn),[0,b(bE),0]],bOS=[0,0,1],bOT=[0,b(bn),[0,b(bE),[0,b(Y),0]]],bOU=[0,b(bn),[0,b(bE),0]],bOO=b(y),bOV=[0,b(al),1753,5,1766,9,[0,b(hk),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bOY=[0,b(d),0,1,0,1,0],bON=[0,b(al),Ck,5,Ck,66,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bOZ=[0,b(d),0,1,0,1,0],bOG=[0,1,0],bOH=[0,b(bn),[0,b(bE),[0,b(ac),0]]],bOI=[0,b(bn),[0,b(bE),0]],bOJ=[0,0,1],bOK=[0,b(bn),[0,b(bE),[0,b(Y),0]]],bOL=[0,b(bn),[0,b(bE),0]],bOF=b(y),bOM=[0,b(al),1464,5,1477,9,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bO0=[0,b(d),0,1,0,1,0],bOD=b(r),bOE=[0,b(al),D7,5,GT,29,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bO1=[0,b(d),0,1,0,1,0],bOB=b(y),bOC=[0,b(al),o3,5,1003,13,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bO2=[0,b(d),0,1,0,1,0],bOu=[0,1,0],bOv=[0,b(aT),[0,b(eK),[0,b(ac),0]]],bOw=[0,b(aT),[0,b(eK),0]],bOx=[0,0,1],bOy=[0,b(aT),[0,b(eK),[0,b(Y),0]]],bOz=[0,b(aT),[0,b(eK),0]],bOt=b(y),bOA=[0,b(al),974,5,976,9,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bO3=[0,b(d),0,1,0,1,0],bOm=[0,1,0],bOn=[0,b(bn),[0,b(bE),[0,b(ac),0]]],bOo=[0,b(bn),[0,b(bE),0]],bOp=[0,0,1],bOq=[0,b(bn),[0,b(bE),[0,b(Y),0]]],bOr=[0,b(bn),[0,b(bE),0]],bOl=b(r),bOs=[0,b(al),942,5,iB,29,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bO4=[0,b(d),0,1,0,1,0],bOe=[0,1,0],bOf=[0,b(bn),[0,b(bE),[0,b(ac),0]]],bOg=[0,b(bn),[0,b(bE),0]],bOh=[0,0,1],bOi=[0,b(bn),[0,b(bE),[0,b(Y),0]]],bOj=[0,b(bn),[0,b(bE),0]],bOd=b(y),bOk=[0,b(al),pX,5,ph,8,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bO5=[0,b(d),0,1,0,1,0],bN_=[3,0],bN$=[2,0],bOa=[1,0],bOb=[0,0],bOc=[0,b(al),pj,5,pC,6,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bO6=[0,b(d),0,1,0,1,0],bO7=[0,b(d),0,1,0,1,0],bO8=[0,b(d),0,1,0,1,0],bN9=[0,b(o),m8,11,m8,52,[0,b(bC),[0,b(B),[0,b(p),0]]]],bN4=[0,b(al),Bz,14,Bz,25,[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bN2=[0,0],bN3=[2,0],bNX=[0,b(o),Ea,14,Ea,56,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNS=[0,b(o),x5,14,x5,63,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNL=[0,b(z),w8,9,w8,55,[0,b(Hg),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bNM=[0,b(d),0,1,0,1,0],bNN=[0,2,0],bNO=[0,b(bZ),[0,b("\xc3\xa9ligibilit\xc3\xa9_commune.condition_logement_surface"),0]],bNH=[0,b(z),v9,9,v9,68,[0,b(Hg),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bNI=[0,b(d),0,1,0,1,0],bNJ=[0,2,0],bNK=[0,b(bZ),[0,b("\xc3\xa9ligibilit\xc3\xa9_commune.condition_logement_r\xc3\xa9sidence_principale"),0]],bND=[0,b(o),lU,14,lU,47,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNy=[0,b(o),gB,14,gB,43,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNt=[0,b(o),gN,14,gN,40,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNh=[0,b(z),4348,5,4353,28,[0,b(lq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bNi=[0,b(d),0,1,0,1,0],bNg=[0,b(z),4331,5,4336,28,[0,b(lq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bNj=[0,b(d),0,1,0,1,0],bNf=[0,b(z),4314,5,4321,28,[0,b(lq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bNk=[0,b(d),0,1,0,1,0],bNl=[0,b(d),0,1,0,1,0],bNm=[0,b(d),0,1,0,1,0],bNe=[0,b(z),4284,5,4286,28,[0,b(lq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bNn=[0,b(d),0,1,0,1,0],bNd=[0,b(o),kK,11,kK,40,[0,b(bC),[0,b(B),[0,b(p),0]]]],bM5=[0,b(al),G3,19,G3,39,[0,b(hk),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bM6=[0,b(d),0,1,0,1,0],bM4=[0,b(al),HS,19,HS,39,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bM7=[0,b(d),0,1,0,1,0],bM8=[0,b(d),0,1,0,1,0],bM9=[0,b(d),0,1,0,1,0],bM3=[0,b(al),nH,9,nH,29,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bM_=[0,b(d),0,1,0,1,0],bM2=[0,b(o),g7,11,g7,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMS=[0,b(al),uv,19,uv,39,[0,b(hk),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bMT=[0,b(d),0,1,0,1,0],bMR=[0,b(al),wl,19,wl,39,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bMU=[0,b(d),0,1,0,1,0],bMV=[0,b(d),0,1,0,1,0],bMW=[0,b(d),0,1,0,1,0],bMQ=[0,b(al),wS,9,wS,29,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bMX=[0,b(d),0,1,0,1,0],bMP=[0,b(o),lQ,11,lQ,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMF=[0,b(al),DB,19,DB,39,[0,b(hk),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bMG=[0,b(d),0,1,0,1,0],bME=[0,b(al),mL,19,mL,39,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bMH=[0,b(d),0,1,0,1,0],bMI=[0,b(d),0,1,0,1,0],bMJ=[0,b(d),0,1,0,1,0],bMD=[0,b(al),kG,9,kG,29,[0,b(eL),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bMK=[0,b(d),0,1,0,1,0],bMC=[0,b(o),ha,11,ha,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMv=[0,b(o),kC,14,kC,46,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMq=[0,b(o),fM,14,fM,50,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMl=[0,b(z),x$,14,x$,28,[0,b("Article D841-1"),[0,b("Chapitre 1 : Champ d'application"),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bMm=[0,b(d),0,1,0,1,0],bMk=[0,b(o),uo,11,uo,25,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMn=[0,0,0],bMo=[0,b(bZ),[0,b("dur\xc3\xa9e_l841_1_3"),0]],bMr=[0,b(d),0,1,0,1,0],bMs=[0,1,0],bMt=[0,b(bZ),[0,b(qt),0]],bMp=[0,b(o),fM,14,fM,50,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMw=[0,b(d),0,1,0,1,0],bMx=[0,1,0],bMy=[0,b(bZ),[0,b(qD),0]],bMu=[0,b(o),kC,14,kC,46,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMz=[0,b(bZ),[0,b(gP),[0,b(bn),0]]],bMA=[0,b(bZ),[0,b(gP),[0,b(bn),0]]],bML=[0,b(d),0,1,0,1,0],bMB=[0,b(o),ha,11,ha,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMM=[0,0,0],bMN=[0,b(bZ),[0,b("l_841_1_6_applicable"),0]],bMY=[0,b(d),0,1,0,1,0],bMO=[0,b(o),lQ,11,lQ,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bMZ=[0,0,0],bM0=[0,b(bZ),[0,b("l_841_1_2_applicable"),0]],bM$=[0,b(d),0,1,0,1,0],bM1=[0,b(o),g7,11,g7,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNa=[0,0,0],bNb=[0,b(bZ),[0,b("l_841_1_1_applicable"),0]],bNo=[0,b(d),0,1,0,1,0],bNc=[0,b(o),kK,11,kK,40,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNp=[0,0,0],bNq=[0,b(bZ),[0,b("condition_accession_propri\xc3\xa9t\xc3\xa9"),0]],bNr=[0,b(al),ky,13,gl,81,[0,b(pF),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bPv=[0,b(al),ky,13,gl,81,[0,b(pF),[0,b(bj),[0,b(bR),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bNu=[0,b(d),0,1,0,1,0],bNv=[0,1,0],bNw=[0,b(bZ),[0,b(uB),0]],bNs=[0,b(o),gN,14,gN,40,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNz=[0,b(d),0,1,0,1,0],bNA=[0,1,0],bNB=[0,b(bZ),[0,b(FM),0]],bNx=[0,b(o),gB,14,gB,43,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNE=[0,b(d),0,1,0,1,0],bNF=[0,1,0],bNG=[0,b(bZ),[0,b(IV),0]],bNC=[0,b(o),lU,14,lU,47,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNP=[0,b(bZ),[0,b(nf),[0,b(aT),0]]],bNQ=[0,b(bZ),[0,b(nf),[0,b(aT),0]]],bNT=[0,b(d),0,1,0,1,0],bNR=[0,b(o),GF,12,GF,61,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNU=[0,0,1],bNV=[0,b(bZ),[0,b(iT),0]],bNY=[0,b(d),0,1,0,1,0],bNW=[0,b(o),HF,12,HF,54,[0,b(bC),[0,b(B),[0,b(p),0]]]],bNZ=[0,0,1],bN0=[0,b(bZ),[0,b(rn),0]],bN5=[0,b(d),0,1,0,1,0],bN1=[0,b(o),Hi,10,Hi,31,[0,b(bC),[0,b(B),[0,b(p),0]]]],bN6=[0,0,0],bN7=[0,b(bZ),[0,b("\xc3\xa9ligibilit\xc3\xa9_dispositions_communes"),0]],bO9=[0,b(d),0,1,0,1,0],bN8=[0,b(o),m8,11,m8,52,[0,b(bC),[0,b(B),[0,b(p),0]]]],bO_=[0,0,0],bO$=[0,b(bZ),[0,b("\xc3\xa9ligibilit\xc3\xa9_allocation_logement_familiale"),0]],bPs=[0,b(d),0,1,0,1,0],bPa=[0,b(o),rA,10,rA,16,[0,b(bC),[0,b(B),[0,b(p),0]]]],bPt=[0,0,1],bPu=[0,b(bZ),[0,b("\xc3\xa9ligibilit\xc3\xa9_l841_2"),0]],bMf=[0,b(z),xR,14,xR,40,[0,b("Article D823-22"),[0,b(j3),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bMe=b(r),bL5=[0,b(z),EE,5,EE,40,[0,b("Article D861-7"),[0,b(ry),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bL6=[0,b(d),0,1,0,1,0],bL4=[0,b(al),IN,5,IN,54,[0,b("Article L863-2"),[0,b("Section 2 : Dispositions communes aux aides applicables \xc3\xa0 Saint-Pierre-et-Miquelon"),[0,b(ke),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bL7=[0,b(d),0,1,0,1,0],bL3=[0,b(al),kU,5,kU,40,[0,b("Article L861-4"),[0,b(pP),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bL8=[0,b(d),0,1,0,1,0],bL9=[0,b(d),0,1,0,1,0],bL_=[0,b(d),0,1,0,1,0],bL2=[0,b(al),585,5,io,42,[0,b("Article L823-8"),[0,b(a5),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bL$=[0,b(d),0,1,0,1,0],bL1=[0,b(o),jV,12,jV,23,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLW=[0,b(K),Hr,14,Hr,29,[0,b("Article 45"),[0,b("Chapitre VIII : Prime de d\xc3\xa9m\xc3\xa9nagement"),[0,b(J),0]]]],bLR=b(Z),bLS=b(qg),bLT=b(Z),bLV=b(r),bLU=b("2.4"),bLL=[0,b(z),2041,6,2052,75,[0,b(pc),[0,b(j3),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bLM=[0,b(d),0,1,0,1,0],bLK=[0,b(o),k5,11,k5,41,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLD=[0,b(o),l2,14,l2,43,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLy=[0,b(o),e$,14,e$,39,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLt=[0,b(o),lW,14,lW,36,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLm=[0,b(o),ml,14,ml,65,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLe=b(Z),bLf=[0,b(z),2032,5,2037,77,[0,b(pc),[0,b(j3),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bLg=[0,b(d),0,1,0,1,0],bLd=[0,b(o),lc,11,lc,32,[0,b(cp),[0,b(B),[0,b(p),0]]]],bK_=[0,b(z),qK,14,qK,47,[0,b(pc),[0,b(j3),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bK$=[0,b(d),0,1,0,1,0],bK9=[0,b(o),zf,11,zf,44,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLa=[0,0,0],bLb=[0,b(da),[0,b("d\xc3\xa9lai_apr\xc3\xa8s_emm\xc3\xa9nagement_l823_8_2"),0]],bLh=[0,b(d),0,1,0,1,0],bLc=[0,b(o),lc,11,lc,32,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLi=[0,0,0],bLj=[0,b(da),[0,b("condition_rang_enfant"),0]],bLk=[0,b(o),nu,13,nu,42,[0,b(cp),[0,b(B),[0,b(p),0]]]],bMj=[0,b(o),nu,13,nu,42,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLn=[0,b(d),0,1,0,1,0],bLo=[0,1,0],bLp=[0,b(da),[0,b("base_mensuelle_allocations_familiales.date_courante"),0]],bLl=[0,b(o),ml,14,ml,65,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLq=[0,b(da),[0,b(DI),[0,b(hh),0]]],bLr=[0,b(da),[0,b(DI),[0,b(hh),0]]],bLu=[0,b(d),0,1,0,1,0],bLv=[0,1,0],bLw=[0,b(da),[0,b("\xc3\xa9ligibilit\xc3\xa9_apl.m\xc3\xa9nage"),0]],bLs=[0,b(o),lW,14,lW,36,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLz=[0,b(d),0,1,0,1,0],bLA=[0,1,0],bLB=[0,b(da),[0,b("\xc3\xa9ligibilit\xc3\xa9_apl.demandeur"),0]],bLx=[0,b(o),e$,14,e$,39,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLE=[0,b(d),0,1,0,1,0],bLF=[0,1,0],bLG=[0,b(da),[0,b("\xc3\xa9ligibilit\xc3\xa9_apl.date_courante"),0]],bLC=[0,b(o),l2,14,l2,43,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLH=[0,b(da),[0,b(FE),[0,b(aT),0]]],bLI=[0,b(da),[0,b(FE),[0,b(aT),0]]],bLN=[0,b(d),0,1,0,1,0],bLJ=[0,b(o),k5,11,k5,41,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLO=[0,0,0],bLP=[0,b(da),[0,b("condition_p\xc3\xa9riode_d\xc3\xa9m\xc3\xa9nagement"),0]],bLX=[0,b(d),0,1,0,1,0],bLQ=[0,b(o),rz,11,rz,26,[0,b(cp),[0,b(B),[0,b(p),0]]]],bLY=[0,0,0],bLZ=[0,b(da),[0,b("plafond_d823_22"),0]],bMa=[0,b(d),0,1,0,1,0],bL0=[0,b(o),jV,12,jV,23,[0,b(cp),[0,b(B),[0,b(p),0]]]],bMb=[0,0,1],bMc=[0,b(da),[0,b(iQ),0]],bMg=[0,b(d),0,1,0,1,0],bMd=[0,b(o),kw,12,kw,38,[0,b(cp),[0,b(B),[0,b(p),0]]]],bMh=[0,0,1],bMi=[0,b(da),[0,b("montant_prime_d\xc3\xa9m\xc3\xa9nagement"),0]],bK4=[0,b(z),mL,14,mL,33,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bKZ=[0,b(z),HW,14,HW,36,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bK0=[0,b(d),0,1,0,1,0],bKY=[0,b(o),z5,12,z5,34,[0,b(dA),[0,b(S),[0,b(B),[0,b(p),0]]]]],bKU=[0,b(z),xn,14,xn,36,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bKK=[0,1,0],bKL=[0,b(aq),[0,b(aA),[0,b(ac),0]]],bKM=[0,b(aq),[0,b(aA),0]],bKN=[0,0,1],bKO=[0,b(aq),[0,b(aA),[0,b(Y),0]]],bKP=[0,b(aq),[0,b(aA),0]],bKx=[0,1,0],bKy=[0,b(aj),[0,b(aA),[0,b(ac),0]]],bKz=[0,b(aj),[0,b(aA),0]],bKA=[0,0,1],bKB=[0,b(aj),[0,b(aA),[0,b(Y),0]]],bKC=[0,b(aj),[0,b(aA),0]],bKi=[0,1,0],bKj=[0,b(au),[0,b(aA),[0,b(ac),0]]],bKk=[0,b(au),[0,b(aA),0]],bKl=[0,0,1],bKm=[0,b(au),[0,b(aA),[0,b(Y),0]]],bKn=[0,b(au),[0,b(aA),0]],bKs=b(r),bKt=b(r),bKe=[0,b(z),1459,16,1462,39,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bKf=[0,1,0],bKg=[0,b(au),[0,b(a9),[0,b(dM),0]]],bKh=[0,b(au),[0,b(a9),0]],bKo=[0,b(z),1444,9,1465,10,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bKp=[0,0,1],bKq=[0,b(au),[0,b(a9),[0,b(Y),0]]],bKr=[0,b(au),[0,b(a9),0]],bKu=[0,1,0],bKv=[0,b(aj),[0,b(a9),[0,b(dM),0]]],bKw=[0,b(aj),[0,b(a9),0]],bKD=[0,b(z),1499,10,1516,11,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bKE=[0,0,1],bKF=[0,b(aj),[0,b(a9),[0,b(Y),0]]],bKG=[0,b(aj),[0,b(a9),0]],bKH=[0,1,0],bKI=[0,b(aq),[0,b(a9),[0,b(dM),0]]],bKJ=[0,b(aq),[0,b(a9),0]],bKQ=[0,b(z),1476,9,1488,10,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bKR=[0,0,1],bKS=[0,b(aq),[0,b(a9),[0,b(Y),0]]],bKT=[0,b(aq),[0,b(a9),0]],bJ$=[0,b(K),83,14,83,44,[0,b(bW),[0,b(bB),[0,b(J),0]]]],bJ5=[0,0],bJ6=[1,0],bJ7=[1,0],bJ8=[1,0],bJ9=[0,0],bJ_=[1,0],bJ0=[0,b(z),qk,14,qk,31,[0,b(mV),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],bJV=[0,b(z),wT,14,wT,34,[0,b(cN),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bJW=[0,b(d),0,1,0,1,0],bJU=[0,b(o),u6,11,u6,31,[0,b(dA),[0,b(S),[0,b(B),[0,b(p),0]]]]],bJX=[0,0,0],bJY=[0,b(cK),[0,b(Dn),0]],bJ1=[0,b(d),0,1,0,1,0],bJZ=[0,b(o),pB,10,pB,22,[0,b(dA),[0,b(S),[0,b(B),[0,b(p),0]]]]],bJ2=[0,0,0],bJ3=[0,b(cK),[0,b(vH),0]],bKa=[0,b(d),0,1,0,1,0],bJ4=[0,b(o),w5,11,w5,41,[0,b(dA),[0,b(S),[0,b(B),[0,b(p),0]]]]],bKb=[0,0,0],bKc=[0,b(cK),[0,b(wD),0]],bKV=[0,b(d),0,1,0,1,0],bKd=[0,b(o),z8,11,z8,33,[0,b(dA),[0,b(S),[0,b(B),[0,b(p),0]]]]],bKW=[0,0,0],bKX=[0,b(cK),[0,b(Im),0]],bK1=[0,0,1],bK2=[0,b(cK),[0,b(aA),0]],bK5=[0,b(d),0,1,0,1,0],bK3=[0,b(o),xO,12,xO,31,[0,b(dA),[0,b(S),[0,b(B),[0,b(p),0]]]]],bK6=[0,0,1],bK7=[0,b(cK),[0,b(cO),0]],bJP=[0,b(z),Iu,24,Iu,43,[0,b(Ir),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bJO=b(r),bJQ=[0,b(d),0,1,0,1,0],bJN=[0,b(z),Bh,14,Bh,33,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bJH=[0,b(z),Di,24,Di,46,[0,b(Ir),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bJI=[0,b(d),0,1,0,1,0],bJG=[0,b(z),Eq,14,Eq,36,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bJA=[0,1,0],bJB=[0,b(au),[0,b(eW),[0,b(ac),0]]],bJC=[0,b(au),[0,b(eW),0]],bJD=[0,0,1],bJE=[0,b(au),[0,b(eW),[0,b(Y),0]]],bJF=[0,b(au),[0,b(eW),0]],bJJ=[0,b(d),0,1,0,1,0],bJz=[0,b(o),wp,12,wp,34,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJv=[0,b(o),qO,14,qO,49,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJq=[0,b(o),AC,14,AC,37,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJl=[0,b(o),p_,14,p_,36,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJg=[0,b(o),C1,14,C1,40,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJb=[0,b(o),Aj,14,Aj,39,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bI6=[0,b(z),m5,14,m5,42,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bI1=[0,b(z),gK,14,gK,55,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIW=[0,b(z),m1,14,m1,59,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIR=[0,b(z),lV,14,lV,43,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIM=[0,b(z),l$,14,l$,42,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIH=[0,b(z),Ca,5,wL,63,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIC=[0,b(z),nq,14,nq,53,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIx=[0,b(z),jQ,14,jQ,37,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIs=[0,b(z),kg,14,kg,63,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIn=[0,b(z),m7,14,m7,58,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIi=[0,b(z),kr,14,kr,46,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bId=[0,b(z),mh,14,mh,78,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bH_=[0,b(z),mz,14,mz,60,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bH5=[0,b(z),ny,14,ny,48,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bH6=[0,b(d),0,1,0,1,0],bH7=[0,1,0],bH8=[0,b(a8),[0,b("calcul_apl_locatif.loyer_principal_base"),0]],bH4=[0,b(z),ny,14,ny,48,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bH$=[0,b(d),0,1,0,1,0],bIa=[0,1,0],bIb=[0,b(a8),[0,b("calcul_apl_locatif.ressources_m\xc3\xa9nage_arrondies"),0]],bH9=[0,b(z),mz,14,mz,60,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIe=[0,b(d),0,1,0,1,0],bIf=[0,1,0],bIg=[0,b(a8),[0,b("calcul_apl_locatif.b\xc3\xa9n\xc3\xa9ficiaire_aide_adulte_ou_enfant_handicap\xc3\xa9s"),0]],bIc=[0,b(z),mh,14,mh,78,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIj=[0,b(d),0,1,0,1,0],bIk=[0,1,0],bIl=[0,b(a8),[0,b("calcul_apl_locatif.date_courante"),0]],bIh=[0,b(z),kr,14,kr,46,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIo=[0,b(d),0,1,0,1,0],bIp=[0,1,0],bIq=[0,b(a8),[0,b("calcul_apl_locatif.nombre_personnes_\xc3\xa0_charge"),0]],bIm=[0,b(z),m7,14,m7,58,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIt=[0,b(d),0,1,0,1,0],bIu=[0,1,0],bIv=[0,b(a8),[0,b("calcul_apl_locatif.situation_familiale_calcul_apl"),0]],bIr=[0,b(z),kg,14,kg,63,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIy=[0,b(d),0,1,0,1,0],bIz=[0,1,0],bIA=[0,b(a8),[0,b("calcul_apl_locatif.zone"),0]],bIw=[0,b(z),jQ,14,jQ,37,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bID=[0,b(d),0,1,0,1,0],bIE=[0,1,0],bIF=[0,b(a8),[0,b("calcul_apl_locatif.logement_est_chambre"),0]],bIB=[0,b(z),nq,14,nq,53,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bII=[0,b(d),0,1,0,1,0],bIJ=[0,1,0],bIK=[0,b(a8),[0,b("calcul_apl_locatif.\xc3\xa2g\xc3\xa9es_ou_handicap_adultes_h\xc3\xa9berg\xc3\xa9es_on\xc3\xa9reux_particuliers"),0]],bIG=[0,b(z),Ca,5,wL,63,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIN=[0,b(d),0,1,0,1,0],bIO=[0,1,0],bIP=[0,b(a8),[0,b("calcul_apl_locatif.type_aide"),0]],bIL=[0,b(z),l$,14,l$,42,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIS=[0,b(d),0,1,0,1,0],bIT=[0,1,0],bIU=[0,b(a8),[0,b("calcul_apl_locatif.colocation"),0]],bIQ=[0,b(z),lV,14,lV,43,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bIX=[0,b(d),0,1,0,1,0],bIY=[0,1,0],bIZ=[0,b(a8),[0,b("calcul_apl_locatif.r\xc3\xa9duction_loyer_solidarit\xc3\xa9"),0]],bIV=[0,b(z),m1,14,m1,59,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bI2=[0,b(d),0,1,0,1,0],bI3=[0,1,0],bI4=[0,b(a8),[0,b("calcul_apl_locatif.logement_meubl\xc3\xa9_d842_2"),0]],bI0=[0,b(z),gK,14,gK,55,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bI7=[0,b(d),0,1,0,1,0],bI8=[0,1,0],bI9=[0,b(a8),[0,b("calcul_apl_locatif.r\xc3\xa9sidence"),0]],bI5=[0,b(z),m5,14,m5,42,[0,b(bt),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bI_=[0,b(a8),[0,b(AI),[0,b(au),0]]],bI$=[0,b(a8),[0,b(AI),[0,b(au),0]]],bJc=[0,b(d),0,1,0,1,0],bJa=[0,b(o),CE,12,CE,37,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJd=[0,0,1],bJe=[0,b(a8),[0,b(k0),0]],bJh=[0,b(d),0,1,0,1,0],bJf=[0,b(o),FD,12,FD,38,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJi=[0,0,1],bJj=[0,b(a8),[0,b(nh),0]],bJm=[0,b(d),0,1,0,1,0],bJk=[0,b(o),vE,12,vE,34,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJn=[0,0,1],bJo=[0,b(a8),[0,b(lr),0]],bJr=[0,b(d),0,1,0,1,0],bJp=[0,b(o),A1,12,A1,35,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJs=[0,0,1],bJt=[0,b(a8),[0,b(m2),0]],bJw=[0,b(d),0,1,0,1,0],bJu=[0,b(o),gr,12,gr,47,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJx=[0,0,1],bJy=[0,b(a8),[0,b(km),0]],bJK=[0,0,1],bJL=[0,b(a8),[0,b(aA),0]],bJR=[0,b(d),0,1,0,1,0],bJM=[0,b(o),q3,12,q3,31,[0,b(aQ),[0,b(P),[0,b(p),0]]]],bJS=[0,0,1],bJT=[0,b(a8),[0,b(cO),0]],bHX=[0,b(o),w3,14,w3,56,[0,b(a2),[0,b(B),[0,b(p),0]]]],bHS=[0,b(o),ES,14,ES,63,[0,b(a2),[0,b(B),[0,b(p),0]]]],bHQ=b(by),bHR=b(by),bHL=[0,b(z),Dr,14,Dr,49,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bHF=[0,1,0],bHG=[0,b(aT),[0,b(i0),[0,b(ac),0]]],bHH=[0,b(aT),[0,b(i0),0]],bHI=[0,0,1],bHJ=[0,b(aT),[0,b(i0),[0,b(Y),0]]],bHK=[0,b(aT),[0,b(i0),0]],bHy=b(zw),bHx=[0,b(z),1215,4,im,48,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bHz=[0,b(d),0,1,0,1,0],bHq=[0,1,0],bHr=[0,b(aT),[0,b(eK),[0,b(ac),0]]],bHs=[0,b(aT),[0,b(eK),0]],bHt=[0,0,1],bHu=[0,b(aT),[0,b(eK),[0,b(Y),0]]],bHv=[0,b(aT),[0,b(eK),0]],bHw=[0,b(z),B5,5,B5,44,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bHA=[0,b(d),0,1,0,1,0],bHj=[0,b(al),1810,5,hg,34,[0,b(hk),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bHk=[0,b(d),0,1,0,1,0],bHi=[0,b(al),1544,5,1550,34,[0,b(fX),[0,b(fr),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bHl=[0,b(d),0,1,0,1,0],bHh=[0,b(al),rA,5,fM,28,[0,b(wn),[0,b(a5),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bHm=[0,b(d),0,1,0,1,0],bHn=[0,b(d),0,1,0,1,0],bHo=[0,b(d),0,1,0,1,0],bHa=[0,1,0],bHb=[0,b(bn),[0,b(bE),[0,b(ac),0]]],bHc=[0,b(bn),[0,b(bE),0]],bHd=[0,0,1],bHe=[0,b(bn),[0,b(bE),[0,b(Y),0]]],bHf=[0,b(bn),[0,b(bE),0]],bHg=[0,b(z),1133,5,iE,44,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bHp=[0,b(d),0,1,0,1,0],bG$=[0,b(o),kJ,11,kJ,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bHB=[0,b(d),0,1,0,1,0],bG_=[0,b(o),kJ,11,kJ,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bG5=[0,b(o),341,5,mM,25,[0,b(a2),[0,b(B),[0,b(p),0]]]],bG6=[0,b(d),0,1,0,1,0],bG4=[0,b(o),fZ,12,fZ,23,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGQ=[0,1,0],bGR=[0,b(fO),[0,b(a9),[0,b(dM),0]]],bGS=[0,b(fO),[0,b(a9),0]],bGT=[0,b(z),h4,17,1183,37,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bGU=[0,0,1],bGV=[0,b(fO),[0,b(a9),[0,b(Y),0]]],bGW=[0,b(fO),[0,b(a9),0]],bGX=b(zw),bGY=[0,0],bGP=[0,b(z),iS,5,1191,10,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bGZ=[0,b(d),0,1,0,1,0],bGO=[0,b(o),gm,12,gm,30,[0,b(a2),[0,b(B),[0,b(p),0]]]],bG0=[0,b(d),0,1,0,1,0],bGN=[0,b(o),gm,12,gm,30,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGH=[0,b(al),91,5,92,52,[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bGI=[0,b(d),0,1,0,1,0],bGG=[0,b(al),84,5,87,52,[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]],bGJ=[0,b(d),0,1,0,1,0],bGF=[0,b(o),lh,11,lh,31,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGA=[0,b(df),IY,14,IY,31,[0,b("Article L351-8"),[0,b("Section 5 : Taux et montant de la pension"),[0,b("Chapitre 1er : Ouverture du droit, liquidation et calcul des pensions de retraite"),[0,b("Titre V : Assurance vieillesse - Assurance veuvage"),[0,b("Livre III : Dispositions relatives aux assurances sociales et \xc3\xa0 diverses cat\xc3\xa9gories de personnes rattach\xc3\xa9es au r\xc3\xa9gime g\xc3\xa9n\xc3\xa9rale"),[0,b(X),[0,b(ae),0]]]]]]]],bGu=[0,b(al),mB,18,mB,44,[0,b("Article L822-10"),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bGv=[0,b(d),0,1,0,1,0],bGt=[0,b(o),gX,11,gX,58,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGo=[0,b(df),ef,14,ef,32,[0,b(mq),[0,b(j8),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ik),[0,b(X),[0,b(ae),0]]]]]]]]]],bGe=b(T),bGf=[0,b(z),5256,5,5257,34,[0,b(Dk),[0,b(HD),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bGg=[0,b(d),0,1,0,1,0],bGa=b(y),bGb=b(jZ),bGd=b(hZ),bGc=[0,b(z),5249,5,5251,58,[0,b(Dk),[0,b(HD),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bGh=[0,b(d),0,1,0,1,0],bF1=b(jZ),bF2=b(jZ),bF7=b(hZ),bF8=b(hZ),bF9=b(hZ),bF_=b(jZ),bF$=b(hZ),bF3=b("8"),bF4=b(GG),bF5=b(GG),bF6=[0,b(z),1025,5,1042,65,[0,b(uw),[0,b(F4),[0,b(b7),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bGi=[0,b(d),0,1,0,1,0],bF0=[0,b(o),ib,12,ib,38,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGj=[0,b(d),0,1,0,1,0],bFS=b(by),bFR=b(by),bFQ=[0,b(al),rh,5,kX,65,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFT=[0,b(d),0,1,0,1,0],bFP=[0,b(al),rx,5,176,30,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFU=[0,b(d),0,1,0,1,0],bFO=[0,b(al),143,5,p8,33,[0,b(Bk),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFV=[0,b(d),0,1,0,1,0],bFN=[0,b(o),gM,11,gM,45,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFy=[0,b(z),5838,5,5841,28,[0,b("Article R862-2"),[0,b("Section I : Dispositions communes aux aides personnelles au logement"),[0,b(mk),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bFz=[0,b(d),0,1,0,1,0],bFx=[0,b(z),5632,6,5638,30,[0,b("Article D861-9"),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bFA=[0,b(d),0,1,0,1,0],bFB=[0,b(d),0,1,0,1,0],bFC=[0,b(d),0,1,0,1,0],bFw=[0,b(z),xL,14,xL,49,[0,b(fY),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bFD=[0,b(d),0,1,0,1,0],bFE=[0,2,0],bFF=[0,b(aT),[0,b("prestations_familiales.\xc3\xa2ge_l512_3_2"),0]],bFs=[0,b(o),ma,14,ma,46,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFn=[0,b(o),gy,14,gy,50,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFa=[0,1,0],bFb=[0,b(d0),[0,b(a9),[0,b(dM),0]]],bFc=[0,b(d0),[0,b(a9),0]],bFd=[0,b(al),224,8,rl,29,[0,b(p1),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFe=[0,0,1],bFf=[0,b(d0),[0,b(a9),[0,b(Y),0]]],bFg=[0,b(d0),[0,b(a9),0]],bE$=[0,b(al),pW,5,229,39,[0,b(p1),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFh=[0,b(d),0,1,0,1,0],bE_=[0,b(al),q7,5,uT,34,[0,b(p1),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFi=[0,b(d),0,1,0,1,0],bE9=[0,b(o),lD,11,lD,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bE2=[0,b(df),qX,5,fZ,34,[0,b(pT),[0,b(pE),[0,b(rf),[0,b(pb),[0,b(pz),[0,b(ba),[0,b(ae),0]]]]]]]],bE1=b("999840"),bE3=[0,b(d),0,1,0,1,0],bEZ=[0,b(df),gm,5,AW,34,[0,b(pT),[0,b(pE),[0,b(rf),[0,b(pb),[0,b(pz),[0,b(ba),[0,b(ae),0]]]]]]]],bEY=b("1041840"),bE0=[0,b(d),0,1,0,1,0],bEW=[0,b(df),339,5,pf,34,[0,b(pT),[0,b(pE),[0,b(rf),[0,b(pb),[0,b(pz),[0,b(ba),[0,b(ae),0]]]]]]]],bEV=b("1083840"),bEX=[0,b(d),0,1,0,1,0],bET=[0,b(dm),58,5,58,34,[0,b('Circulaire de la CNAV 2023-3 du 09/01/2022 "Revalorisation \xc3\xa0 compter du 1er janvier 2023"'),[0,b(rs),0]]],bES=b("1153302"),bEU=[0,b(d),0,1,0,1,0],bEQ=[0,b(dm),89,5,90,33,[0,b('Circulaire de la CNAV 2022-3 du 11/01/2022 "Revalorisation \xc3\xa0 compter du 1er janvier 2022"'),[0,b(rs),0]]],bEP=b("1100144"),bER=[0,b(d),0,1,0,1,0],bEN=[0,b(dm),lE,5,d1,33,[0,b('Circulaire de la CNAV 2021-1 du 11/01/2021 "Revalorisation \xc3\xa0 compter du 1er janvier 2021"'),[0,b(rs),0]]],bEM=b("1088175"),bEO=[0,b(d),0,1,0,1,0],bE4=[0,b(d),0,1,0,1,0],bEF=[0,b(al),FL,5,FL,40,[0,b(yn),[0,b(pP),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bEG=[0,b(d),0,1,0,1,0],bEE=[0,b(al),ef,14,ef,35,[0,b(Bk),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bEx=[0,b(df),d1,14,d1,61,[0,b(mq),[0,b(j8),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ik),[0,b(X),[0,b(ae),0]]]]]]]]]],bEq=[0,b(al),46,5,46,41,[0,b("Article L821-2"),[0,b(xa),[0,b(Id),[0,b(wg),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]]],bEr=[0,b(d),0,1,0,1,0],bEp=[0,b(o),lp,12,lp,51,[0,b(a2),[0,b(B),[0,b(p),0]]]],bEs=[0,b(d),0,1,0,1,0],bEj=[0,b(al),ID,18,ID,67,[0,b("Article L822-8"),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bEk=[0,b(d),0,1,0,1,0],bEi=[0,b(o),h2,11,h2,41,[0,b(a2),[0,b(B),[0,b(p),0]]]],bEc=[0,b(al),pG,18,pG,61,[0,b("Article L822-9"),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bEd=[0,b(d),0,1,0,1,0],bEb=[0,b(o),ip,11,ip,58,[0,b(a2),[0,b(B),[0,b(p),0]]]],bD6=[0,b(al),qe,5,qe,40,[0,b(yn),[0,b(pP),[0,b(dH),[0,b(cd),[0,b(w),[0,b(X),[0,b(v),0]]]]]]]],bD7=[0,b(d),0,1,0,1,0],bD5=[0,b(al),kT,9,kT,42,[0,b(wn),[0,b(a5),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bD8=[0,b(d),0,1,0,1,0],bD4=[0,b(o),lO,11,lO,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bDZ=[0,b(z),mA,14,mA,39,[0,b(uw),[0,b(F4),[0,b(b7),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bDT=b(y),bDU=b(T),bDV=b(T),bDW=b(T),bDX=b(y),bDY=b(T),bDO=[0,b(al),yZ,14,yZ,43,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bDJ=[0,b(z),g5,14,g5,41,[0,b(A4),[0,b(FV),[0,b(b7),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bDI=b(zO),bDD=[0,b(z),BL,14,BL,42,[0,b(A4),[0,b(FV),[0,b(b7),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bDC=b(zO),bDw=[0,b(z),uu,14,uu,46,[0,b(wk),[0,b(ry),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bDx=[0,b(d),0,1,0,1,0],bDy=[0,b(d),0,1,0,1,0],bDv=[0,b(o),pa,12,pa,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bDz=[0,2,0],bDA=[0,b(aT),[0,b("date_entr\xc3\xa9e_vigueur_diff\xc3\xa9r\xc3\xa9e_cch"),0]],bDE=[0,b(d),0,1,0,1,0],bDB=[0,b(o),y3,11,y3,39,[0,b(a2),[0,b(B),[0,b(p),0]]]],bDF=[0,0,0],bDG=[0,b(aT),[0,b("seuil_l822_3_parts_propri\xc3\xa9t\xc3\xa9"),0]],bDK=[0,b(d),0,1,0,1,0],bDH=[0,b(o),H8,11,H8,38,[0,b(a2),[0,b(B),[0,b(p),0]]]],bDL=[0,0,0],bDM=[0,b(aT),[0,b("seuil_l822_3_parts_usufruit"),0]],bDP=[0,b(d),0,1,0,1,0],bDN=[0,b(o),B0,11,B0,40,[0,b(a2),[0,b(B),[0,b(p),0]]]],bDQ=[0,0,0],bDR=[0,b(aT),[0,b("usufruit_ou_propri\xc3\xa9t\xc3\xa9_famille"),0]],bD0=[0,b(d),0,1,0,1,0],bDS=[0,b(o),iL,11,iL,36,[0,b(a2),[0,b(B),[0,b(p),0]]]],bD1=[0,0,0],bD2=[0,b(aT),[0,b("nombre_personnes_logement"),0]],bD9=[0,b(d),0,1,0,1,0],bD3=[0,b(o),lO,11,lO,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bD_=[0,0,0],bD$=[0,b(aT),[0,b("septi\xc3\xa8me_alin\xc3\xa9a_l823_1_applicable"),0]],bEe=[0,b(d),0,1,0,1,0],bEa=[0,b(o),ip,11,ip,58,[0,b(a2),[0,b(B),[0,b(p),0]]]],bEf=[0,0,0],bEg=[0,b(aT),[0,b("condition_non_ouverture_l822_9_decence_logement"),0]],bEl=[0,b(d),0,1,0,1,0],bEh=[0,b(o),h2,11,h2,41,[0,b(a2),[0,b(B),[0,b(p),0]]]],bEm=[0,0,0],bEn=[0,b(aT),[0,b("condition_non_ouverture_l822_8"),0]],bEt=[0,b(d),0,1,0,1,0],bEo=[0,b(o),lp,12,lp,51,[0,b(a2),[0,b(B),[0,b(p),0]]]],bEu=[0,2,0],bEv=[0,b(aT),[0,b("condition_logement_r\xc3\xa9sidence_principale"),0]],bEy=[0,b(d),0,1,0,1,0],bEz=[0,1,0],bEA=[0,b(aT),[0,b("ouverture_droits_retraite.date_naissance_assur\xc3\xa9"),0]],bEw=[0,b(df),d1,14,d1,61,[0,b(mq),[0,b(j8),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ik),[0,b(X),[0,b(ae),0]]]]]]]]]],bEB=[0,b(aT),[0,b(y2),[0,b(q4),0]]],bEC=[0,b(aT),[0,b(y2),[0,b(q4),0]]],bEH=[0,b(d),0,1,0,1,0],bED=[0,b(o),v$,11,v$,32,[0,b(a2),[0,b(B),[0,b(p),0]]]],bEI=[0,0,0],bEJ=[0,b(aT),[0,b("condition_nationalit\xc3\xa9"),0]],bEK=[0,b(o),mm,13,mm,42,[0,b(a2),[0,b(B),[0,b(p),0]]]],bH3=[0,b(o),mm,13,mm,42,[0,b(a2),[0,b(B),[0,b(p),0]]]],bE5=[0,b(d),0,1,0,1,0],bEL=[0,b(o),ki,11,ki,41,[0,b(a2),[0,b(B),[0,b(p),0]]]],bE6=[0,0,0],bE7=[0,b(aT),[0,b("plafond_individuel_l815_9_s\xc3\xa9cu"),0]],bFj=[0,b(d),0,1,0,1,0],bE8=[0,b(o),lD,11,lD,44,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFk=[0,0,0],bFl=[0,b(aT),[0,b("condition_logement_location_tiers"),0]],bFo=[0,b(d),0,1,0,1,0],bFp=[0,1,0],bFq=[0,b(aT),[0,b(qt),0]],bFm=[0,b(o),gy,14,gy,50,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFt=[0,b(d),0,1,0,1,0],bFu=[0,1,0],bFv=[0,b(aT),[0,b(qD),0]],bFr=[0,b(o),ma,14,ma,46,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFG=[0,b(aT),[0,b(gP),[0,b(bn),0]]],bFH=[0,b(aT),[0,b(gP),[0,b(bn),0]]],bFJ=b(qg),bFI=[0,b(al),gt,13,gt,48,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bH2=[0,b(al),gt,13,gt,48,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFL=b(qg),bFK=[0,b(al),fR,13,fR,47,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bH1=[0,b(al),fR,13,fR,47,[0,b(fL),[0,b(b7),[0,b(ak),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],bFW=[0,b(d),0,1,0,1,0],bFM=[0,b(o),gM,11,gM,45,[0,b(a2),[0,b(B),[0,b(p),0]]]],bFX=[0,0,0],bFY=[0,b(aT),[0,b("condition_logement_mode_occupation"),0]],bGk=[0,b(d),0,1,0,1,0],bFZ=[0,b(o),ib,12,ib,38,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGl=[0,2,0],bGm=[0,b(aT),[0,b("condition_logement_surface"),0]],bGp=[0,b(d),0,1,0,1,0],bGn=[0,b(o),Av,11,Av,29,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGq=[0,0,0],bGr=[0,b(aT),[0,b("\xc3\xa2ge_l161_17_2_s\xc3\xa9cu"),0]],bGw=[0,b(d),0,1,0,1,0],bGs=[0,b(o),gX,11,gX,58,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGx=[0,0,0],bGy=[0,b(aT),[0,b("condition_ouverture_l822_10_peuplement_logement"),0]],bGB=[0,b(d),0,1,0,1,0],bGz=[0,b(o),xm,11,xm,28,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGC=[0,0,0],bGD=[0,b(aT),[0,b("\xc3\xa2ge_l351_8_1_s\xc3\xa9cu"),0]],bGK=[0,b(d),0,1,0,1,0],bGE=[0,b(o),lh,11,lh,31,[0,b(a2),[0,b(B),[0,b(p),0]]]],bGL=[0,0,0],bGM=[0,b(aT),[0,b("\xc3\xa9ligibilit\xc3\xa9_logement"),0]],bG1=[0,0,1],bG2=[0,b(aT),[0,b(eK),0]],bG7=[0,b(d),0,1,0,1,0],bG3=[0,b(o),fZ,12,fZ,23,[0,b(a2),[0,b(B),[0,b(p),0]]]],bG8=[0,0,1],bG9=[0,b(aT),[0,b(iQ),0]],bHC=[0,0,0],bHD=[0,b(aT),[0,b(i0),0]],bHM=[0,b(d),0,1,0,1,0],bHE=[0,b(o),nr,11,nr,46,[0,b(a2),[0,b(B),[0,b(p),0]]]],bHN=[0,0,0],bHO=[0,b(aT),[0,b("personnes_\xc3\xa0_charge_prises_en_compte"),0]],bHT=[0,b(d),0,1,0,1,0],bHP=[0,b(o),ul,12,ul,61,[0,b(a2),[0,b(B),[0,b(p),0]]]],bHU=[0,0,1],bHV=[0,b(aT),[0,b(iT),0]],bHY=[0,b(d),0,1,0,1,0],bHW=[0,b(o),ze,12,ze,54,[0,b(a2),[0,b(B),[0,b(p),0]]]],bHZ=[0,0,1],bH0=[0,b(aT),[0,b(rn),0]],bDp=[0,b(z),GQ,14,GQ,36,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bDi=[0,1,0],bDj=[0,b(L),[0,b(cW),[0,b(ac),0]]],bDk=[0,b(L),[0,b(cW),0]],bDl=[0,0,1],bDm=[0,b(L),[0,b(cW),[0,b(Y),0]]],bDn=[0,b(L),[0,b(cW),0]],bDo=b(r),bDq=[0,b(d),0,1,0,1,0],bDh=[0,b(o),ph,10,ph,25,[0,b(aa),[0,b(P),[0,b(p),0]]]],bDd=[0,b(dm),vp,14,vp,36,[0,b(bW),[0,b(ru),0]]],bC9=[0,1,0],bC_=[0,b(L),[0,b(bG),[0,b(ac),0]]],bC$=[0,b(L),[0,b(bG),0]],bDa=[0,0,1],bDb=[0,b(L),[0,b(bG),[0,b(Y),0]]],bDc=[0,b(L),[0,b(bG),0]],bDe=[0,b(d),0,1,0,1,0],bC8=[0,b(o),wF,10,wF,48,[0,b(aa),[0,b(P),[0,b(p),0]]]],bC4=[0,b(z),yt,14,yt,36,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bCP=[0,1,0],bCQ=[0,b(L),[0,b(eh),[0,b(ac),0]]],bCR=[0,b(L),[0,b(eh),0]],bCS=[0,0,1],bCT=[0,b(L),[0,b(eh),[0,b(Y),0]]],bCU=[0,b(L),[0,b(eh),0]],bCV=[0,1,0],bCW=[0,b(bm),[0,b(bO),[0,b(ac),0]]],bCX=[0,b(bm),[0,b(bO),0]],bCY=[0,0,1],bCZ=[0,b(bm),[0,b(bO),[0,b(Y),0]]],bC0=[0,b(bm),[0,b(bO),0]],bC1=b(is),bC2=b(r),bC3=b(r),bC5=[0,b(d),0,1,0,1,0],bCO=[0,b(o),D2,10,D2,40,[0,b(aa),[0,b(P),[0,b(p),0]]]],bCK=[0,b(z),Bv,14,Bv,33,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bCF=[0,b(z),EL,14,EL,36,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bCs=[0,1,0],bCt=[0,b(L),[0,b(bF),[0,b(ac),0]]],bCu=[0,b(L),[0,b(bF),0]],bCv=[0,0,1],bCw=[0,b(L),[0,b(bF),[0,b(Y),0]]],bCx=[0,b(L),[0,b(bF),0]],bCy=[0,1,0],bCz=[0,b(L),[0,b(ee),[0,b(ac),0]]],bCA=[0,b(L),[0,b(ee),0]],bCB=[0,0,1],bCC=[0,b(L),[0,b(ee),[0,b(Y),0]]],bCD=[0,b(L),[0,b(ee),0]],bCE=b(r),bCG=[0,b(d),0,1,0,1,0],bCr=[0,b(o),vX,10,vX,32,[0,b(aa),[0,b(P),[0,b(p),0]]]],bCn=[0,b(z),AG,14,AG,33,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bCi=[0,b(z),FN,14,FN,47,[0,b(il),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bCb=[0,1,0],bCc=[0,b(L),[0,b(dd),[0,b(ac),0]]],bCd=[0,b(L),[0,b(dd),0]],bCe=[0,0,1],bCf=[0,b(L),[0,b(dd),[0,b(Y),0]]],bCg=[0,b(L),[0,b(dd),0]],bCh=b(r),bCj=[0,b(d),0,1,0,1,0],bCa=[0,b(o),zt,11,zt,44,[0,b(aa),[0,b(P),[0,b(p),0]]]],bB8=[0,b(z),xk,14,xk,41,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bB3=[0,b(z),Ez,14,Ez,33,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bBX=[0,b(z),yY,5,yY,44,[0,b(F5),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bBJ=[0,1,0],bBK=[0,b(L),[0,b(dt),[0,b(ds),0]]],bBL=[0,1,0],bBM=[0,b(L),[0,b(dt),[0,b(ac),0]]],bBN=[0,0,1],bBO=[0,b(L),[0,b(dt),[0,b(Y),0]]],bBP=[0,b(L),[0,b(dt),0]],bBQ=[0,1,0],bBR=[0,b(L),[0,b(dt),[0,b(ds),0]]],bBS=[0,1,0],bBT=[0,b(L),[0,b(dt),[0,b(ac),0]]],bBU=[0,0,1],bBV=[0,b(L),[0,b(dt),[0,b(Y),0]]],bBW=[0,b(L),[0,b(dt),0]],bBY=[0,b(d),0,1,0,1,0],bBI=[0,b(z),E1,14,E1,39,[0,b(F5),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bBB=[0,1,0],bBC=[0,b(L),[0,b(dt),[0,b(ds),0]]],bBD=[0,1,0],bBE=[0,b(L),[0,b(dt),[0,b(ac),0]]],bBF=[0,0,1],bBG=[0,b(L),[0,b(dt),[0,b(Y),0]]],bBH=[0,b(L),[0,b(dt),0]],bBv=[0,b(z),uF,7,uF,26,[0,b(il),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bBw=[0,b(d),0,1,0,1,0],bBu=[0,b(z),Hl,14,Hl,50,[0,b(il),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bBk=[0,b(z),6062,5,6065,28,[0,b(pd),[0,b(qI),[0,b(mk),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bBl=[0,b(d),0,1,0,1,0],bBj=[0,b(z),5556,5,5562,28,[0,b(gI),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bBm=[0,b(d),0,1,0,1,0],bBn=[0,b(d),0,1,0,1,0],bBo=[0,b(d),0,1,0,1,0],bBp=[0,2,0],bBq=[0,b(L),[0,b(uP),0]],bBf=[0,b(z),FG,14,FG,61,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bBg=[0,b(d),0,1,0,1,0],bBh=[0,2,0],bBi=[0,b(L),[0,b(HL),0]],bBb=[0,b(o),kW,14,kW,49,[0,b(aa),[0,b(P),[0,b(p),0]]]],bBa=b(r),bA7=[0,b(o),lJ,14,lJ,53,[0,b(aa),[0,b(P),[0,b(p),0]]]],bA2=[0,b(o),lx,14,lx,44,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAX=[0,b(o),kY,14,kY,70,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAS=[0,b(o),mi,14,mi,65,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAN=[0,b(o),ko,14,ko,67,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAI=[0,b(o),ll,14,ll,61,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAD=[0,b(o),lC,14,lC,59,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAC=[1,0],bAx=[0,b(o),mN,14,mN,74,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAs=[0,b(o),lR,14,lR,49,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAl=[0,b(z),jU,14,jU,70,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bAg=[0,b(z),ni,14,ni,69,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bAb=[0,b(z),l3,14,l3,75,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bz8=[0,b(o),mK,14,mK,61,[0,b(aa),[0,b(P),[0,b(p),0]]]],bzV=b(aD),bzW=[0,b(N),3512,5,3520,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],bzN=b(aD),bzO=[0,1,0],bzP=[0,b(L),[0,b(bI),[0,b(ds),0]]],bzQ=[0,1,0],bzR=[0,b(L),[0,b(bI),[0,b(ac),0]]],bzS=[0,0,1],bzT=[0,b(L),[0,b(bI),[0,b(Y),0]]],bzU=[0,b(L),[0,b(bI),0]],bzX=[0,b(d),0,1,0,1,0],bzL=b(aD),bzM=[0,b(N),2951,5,2959,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],bzD=b(aD),bzE=[0,1,0],bzF=[0,b(L),[0,b(bI),[0,b(ds),0]]],bzG=[0,1,0],bzH=[0,b(L),[0,b(bI),[0,b(ac),0]]],bzI=[0,0,1],bzJ=[0,b(L),[0,b(bI),[0,b(Y),0]]],bzK=[0,b(L),[0,b(bI),0]],bzY=[0,b(d),0,1,0,1,0],bzB=b(aD),bzC=[0,b(N),1861,5,1869,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],bzt=b(aD),bzu=[0,1,0],bzv=[0,b(L),[0,b(bI),[0,b(ds),0]]],bzw=[0,1,0],bzx=[0,b(L),[0,b(bI),[0,b(ac),0]]],bzy=[0,0,1],bzz=[0,b(L),[0,b(bI),[0,b(Y),0]]],bzA=[0,b(L),[0,b(bI),0]],bzZ=[0,b(d),0,1,0,1,0],bzr=b(aD),bzs=[0,b(N),723,5,nF,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],bzj=b(aD),bzk=[0,1,0],bzl=[0,b(L),[0,b(bI),[0,b(ds),0]]],bzm=[0,1,0],bzn=[0,b(L),[0,b(bI),[0,b(ac),0]]],bzo=[0,0,1],bzp=[0,b(L),[0,b(bI),[0,b(Y),0]]],bzq=[0,b(L),[0,b(bI),0]],bz0=[0,b(d),0,1,0,1,0],bzh=b(aD),bzi=[0,b(N),208,5,uT,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],by$=b(aD),bza=[0,1,0],bzb=[0,b(L),[0,b(bI),[0,b(ds),0]]],bzc=[0,1,0],bzd=[0,b(L),[0,b(bI),[0,b(ac),0]]],bze=[0,0,1],bzf=[0,b(L),[0,b(bI),[0,b(Y),0]]],bzg=[0,b(L),[0,b(bI),0]],bz1=[0,b(d),0,1,0,1,0],bz2=[0,b(d),0,1,0,1,0],bz3=[0,b(d),0,1,0,1,0],by_=[0,b(K),Db,14,Db,46,[0,b(bP),[0,b(bk),[0,b(J),0]]]],by3=[0,1,0],by4=[0,b(L),[0,b(bI),[0,b(ds),0]]],by5=[0,1,0],by6=[0,b(L),[0,b(bI),[0,b(ac),0]]],by7=[0,0,1],by8=[0,b(L),[0,b(bI),[0,b(Y),0]]],by9=[0,b(L),[0,b(bI),0]],bz4=[0,b(d),0,1,0,1,0],by2=[0,b(o),yF,10,yF,33,[0,b(aa),[0,b(P),[0,b(p),0]]]],byX=[0,b(z),xy,5,xy,28,[0,b(mx),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],byY=[0,b(d),0,1,0,1,0],byW=[0,b(z),Bs,14,Bs,41,[0,b(mx),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],byT=b(db),byU=b(v4),byV=b("4999"),byO=[0,b(z),ve,15,ve,37,[0,b(il),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],byP=[0,b(d),0,1,0,1,0],byN=[0,b(o),IR,11,IR,33,[0,b(aa),[0,b(P),[0,b(p),0]]]],byE=[0,b(N),uX,5,uX,16,[0,b(gL),[0,b(a3),[0,b(M),0]]]],byw=b(cX),byx=[0,1,0],byy=[0,b(L),[0,b(cy),[0,b(ds),0]]],byz=[0,1,0],byA=[0,b(L),[0,b(cy),[0,b(ac),0]]],byB=[0,0,1],byC=[0,b(L),[0,b(cy),[0,b(Y),0]]],byD=[0,b(L),[0,b(cy),0]],byF=[0,b(d),0,1,0,1,0],byv=[0,b(N),Hn,5,Hn,16,[0,b(gL),[0,b(aW),[0,b(M),0]]]],byn=b(cX),byo=[0,1,0],byp=[0,b(L),[0,b(cy),[0,b(ds),0]]],byq=[0,1,0],byr=[0,b(L),[0,b(cy),[0,b(ac),0]]],bys=[0,0,1],byt=[0,b(L),[0,b(cy),[0,b(Y),0]]],byu=[0,b(L),[0,b(cy),0]],byG=[0,b(d),0,1,0,1,0],bym=[0,b(K),y7,5,y7,16,[0,b(gL),[0,b(bk),[0,b(J),0]]]],bye=b(cX),byf=[0,1,0],byg=[0,b(L),[0,b(cy),[0,b(ds),0]]],byh=[0,1,0],byi=[0,b(L),[0,b(cy),[0,b(ac),0]]],byj=[0,0,1],byk=[0,b(L),[0,b(cy),[0,b(Y),0]]],byl=[0,b(L),[0,b(cy),0]],byH=[0,b(d),0,1,0,1,0],byI=[0,b(d),0,1,0,1,0],byJ=[0,b(d),0,1,0,1,0],byd=[0,b(K),ux,14,ux,46,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bx8=[0,1,0],bx9=[0,b(L),[0,b(cy),[0,b(ds),0]]],bx_=[0,1,0],bx$=[0,b(L),[0,b(cy),[0,b(ac),0]]],bya=[0,0,1],byb=[0,b(L),[0,b(cy),[0,b(Y),0]]],byc=[0,b(L),[0,b(cy),0]],byK=[0,b(d),0,1,0,1,0],bx7=[0,b(o),nH,10,nH,26,[0,b(aa),[0,b(P),[0,b(p),0]]]],bx3=[0,b(z),Ib,14,Ib,36,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bx1=b(r),bx2=b(r),bx4=[0,b(d),0,1,0,1,0],bx0=[0,b(o),qW,10,qW,32,[0,b(aa),[0,b(P),[0,b(p),0]]]],bxU=[0,b(z),4681,6,4687,6,[0,b(mx),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bxV=[0,b(d),0,1,0,1,0],bxS=[0,b(z),4699,5,4700,59,[0,b(mx),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bxT=[0,b(d),0,1,0,1,0],bxW=[0,b(d),0,1,0,1,0],bxI=[0,b(K),4462,5,4470,16,[0,b(ap),[0,b(fs),[0,b(J),0]]]],bxF=b(cZ),bxG=b(gO),bxH=b(cY),bxJ=[0,b(d),0,1,0,1,0],bxD=[0,b(N),pR,6,367,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],bxw=b(cZ),bxx=b(gO),bxC=b(cY),bxy=b(bf),bxz=b(cZ),bxA=b(gO),bxB=b(cY),bxE=[0,b(d),0,1,0,1,0],bxt=[0,b(N),eF,6,F,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],bxm=b(ci),bxn=b(fi),bxs=b(cg),bxo=b(bf),bxp=b(ci),bxq=b(fi),bxr=b(cg),bxu=[0,b(d),0,1,0,1,0],bxl=[0,b(N),877,6,pl,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],bxe=b(ci),bxf=b(fi),bxk=b(cg),bxg=b(bf),bxh=b(ci),bxi=b(fi),bxj=b(cg),bxv=[0,b(d),0,1,0,1,0],bxc=[0,b(N),o1,6,3112,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],bw7=b(ea),bw8=b(kn),bxb=b(eb),bw9=b(bf),bw_=b(ea),bw$=b(kn),bxa=b(eb),bxd=[0,b(d),0,1,0,1,0],bw5=[0,b(N),3665,6,qR,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],bwY=b(eo),bwZ=b(mE),bw4=b(ei),bw0=b(bf),bw1=b(eo),bw2=b(mE),bw3=b(ei),bw6=[0,b(d),0,1,0,1,0],bxK=[0,b(d),0,1,0,1,0],bxL=[0,b(d),0,1,0,1,0],bwV=[0,b(K),4395,6,4402,28,[0,b(ap),[0,b(fs),[0,b(J),0]]]],bwT=b(cZ),bwU=b(cY),bwW=[0,b(d),0,1,0,1,0],bwR=[0,b(N),q$,6,ps,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],bwM=b(cZ),bwN=b(cY),bwO=b(bf),bwP=b(cZ),bwQ=b(cY),bwS=[0,b(d),0,1,0,1,0],bwJ=[0,b(N),1933,6,1940,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],bwE=b(ci),bwF=b(cg),bwG=b(bf),bwH=b(ci),bwI=b(cg),bwK=[0,b(d),0,1,0,1,0],bwD=[0,b(N),796,6,803,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],bwy=b(ci),bwz=b(cg),bwA=b(bf),bwB=b(ci),bwC=b(cg),bwL=[0,b(d),0,1,0,1,0],bww=[0,b(N),3025,6,3032,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],bwr=b(ea),bws=b(eb),bwt=b(bf),bwu=b(ea),bwv=b(eb),bwx=[0,b(d),0,1,0,1,0],bwp=[0,b(N),3585,6,3592,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],bwk=b(eo),bwl=b(ei),bwm=b(bf),bwn=b(eo),bwo=b(ei),bwq=[0,b(d),0,1,0,1,0],bwX=[0,b(d),0,1,0,1,0],bxM=[0,b(d),0,1,0,1,0],bwh=[0,b(K),Gq,57,Gq,68,[0,b(gL),[0,b(bk),[0,b(J),0]]]],bwe=b(fW),bwf=b(qv),bwg=b(eP),bwi=[0,b(d),0,1,0,1,0],bwc=[0,b(N),yv,5,yv,16,[0,b(gL),[0,b(aW),[0,b(M),0]]]],bv$=b(fT),bwa=b(o5),bwb=b(eH),bwd=[0,b(d),0,1,0,1,0],bv9=[0,b(N),u8,5,u8,16,[0,b(gL),[0,b(a3),[0,b(M),0]]]],bv6=b(fU),bv7=b(pO),bv8=b(eG),bv_=[0,b(d),0,1,0,1,0],bwj=[0,b(d),0,1,0,1,0],bxN=[0,b(d),0,1,0,1,0],bv3=[0,b(K),Ak,29,Ak,56,[0,b(iu),[0,b(bk),[0,b(J),0]]]],bvZ=b(r),bv0=b(eP),bv1=b(fW),bv2=b(eP),bv4=[0,b(d),0,1,0,1,0],bvX=[0,b(N),pJ,29,pJ,56,[0,b(iu),[0,b(aW),[0,b(M),0]]]],bvT=b(r),bvU=b(eH),bvV=b(fT),bvW=b(eH),bvY=[0,b(d),0,1,0,1,0],bvR=[0,b(N),AU,29,AU,56,[0,b(iu),[0,b(a3),[0,b(M),0]]]],bvN=b(r),bvO=b(eG),bvP=b(fU),bvQ=b(eG),bvS=[0,b(d),0,1,0,1,0],bv5=[0,b(d),0,1,0,1,0],bvG=[0,b(K),uR,5,uR,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],buW=b(r),buX=b("158700"),buY=b("191300"),buZ=b(y),bu0=b("205500"),bu1=b(T),bu2=b("211300"),bu3=b(Z),bu4=b("217100"),bu5=b(_),bu6=b("222900"),bu7=b(I),bu8=b(E7),bu9=b(I),bu_=b("19800"),bu$=b(E7),bva=b(r),bvb=b("139300"),bvc=b("170600"),bvd=b(y),bve=b("184700"),bvf=b(T),bvg=b("191200"),bvh=b(Z),bvi=b(wP),bvj=b(_),bvk=b("204200"),bvl=b(I),bvm=b(CF),bvn=b(I),bvo=b(p9),bvp=b(CF),bvq=b(r),bvr=b("130600"),bvs=b("158400"),bvt=b(y),bvu=b("172600"),bvv=b(T),bvw=b(zW),bvx=b(Z),bvy=b("187000"),bvz=b(_),bvA=b("194200"),bvB=b(I),bvC=b(q0),bvD=b(I),bvE=b("18200"),bvF=b(q0),bvH=[0,b(d),0,1,0,1,0],buU=[0,b(K),De,5,De,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bt_=b(r),bt$=b("160400"),bua=b("193400"),bub=b(y),buc=b("207800"),bud=b(T),bue=b("213700"),buf=b(Z),bug=b("219600"),buh=b(_),bui=b(D$),buj=b(I),buk=b(k7),bul=b(I),bum=b("20000"),bun=b(k7),buo=b(r),bup=b(zG),buq=b(zY),bur=b(y),bus=b("186700"),but=b(T),buu=b("193300"),buv=b(Z),buw=b(qw),bux=b(_),buy=b("206500"),buz=b(I),buA=b(CT),buB=b(I),buC=b(wR),buD=b(CT),buE=b(r),buF=b(yc),buG=b(qE),buH=b(y),buI=b("174500"),buJ=b(T),buK=b(Dp),buL=b(Z),buM=b("189100"),buN=b(_),buO=b("196400"),buP=b(I),buQ=b(BM),buR=b(I),buS=b("18400"),buT=b(BM),buV=[0,b(d),0,1,0,1,0],bt8=[0,b(K),u7,5,u7,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],btm=b(r),btn=b("163300"),bto=b("196900"),btp=b(y),btq=b("211600"),btr=b(T),bts=b(CJ),btt=b(Z),btu=b("223600"),btv=b(_),btw=b("229600"),btx=b(I),bty=b(ym),btz=b(I),btA=b("20400"),btB=b(ym),btC=b(r),btD=b("143300"),btE=b("175600"),btF=b(y),btG=b("190100"),btH=b(T),btI=b("196600"),btJ=b(Z),btK=b("203500"),btL=b(_),btM=b("210200"),btN=b(I),btO=b(H$),btP=b(I),btQ=b("19600"),btR=b(H$),btS=b(r),btT=b("134400"),btU=b(Ds),btV=b(y),btW=b("177700"),btX=b(T),btY=b("185100"),btZ=b(Z),bt0=b(vk),bt1=b(_),bt2=b(qw),bt3=b(I),bt4=b(IK),bt5=b(I),bt6=b("18700"),bt7=b(IK),bt9=[0,b(d),0,1,0,1,0],btk=[0,b(K),CO,5,CO,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bsA=b(r),bsB=b("167200"),bsC=b("201600"),bsD=b(y),bsE=b("216700"),bsF=b(T),bsG=b("222800"),bsH=b(Z),bsI=b("229000"),bsJ=b(_),bsK=b("235100"),bsL=b(I),bsM=b(IF),bsN=b(I),bsO=b(B7),bsP=b(IF),bsQ=b(r),bsR=b("146700"),bsS=b(zW),bsT=b(y),bsU=b("194700"),bsV=b(T),bsW=b("201500"),bsX=b(Z),bsY=b("208400"),bsZ=b(_),bs0=b("215200"),bs1=b(I),bs2=b(k7),bs3=b(I),bs4=b(yl),bs5=b(k7),bs6=b(r),bs7=b("137600"),bs8=b("166900"),bs9=b(y),bs_=b("182000"),bs$=b(T),bta=b("189500"),btb=b(Z),btc=b("197100"),btd=b(_),bte=b(zj),btf=b(I),btg=b(FH),bth=b(I),bti=b(p9),btj=b(FH),btl=[0,b(d),0,1,0,1,0],bsy=[0,b(K),GN,5,GN,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],brO=b(r),brP=b("167400"),brQ=b("201800"),brR=b(y),brS=b("216900"),brT=b(T),brU=b("223000"),brV=b(Z),brW=b("229200"),brX=b(_),brY=b("235300"),brZ=b(I),br0=b(Fj),br1=b(I),br2=b(B7),br3=b(Fj),br4=b(r),br5=b("146800"),br6=b("180000"),br7=b(y),br8=b("194900"),br9=b(T),br_=b(Ik),br$=b(Z),bsa=b(q0),bsb=b(_),bsc=b("215400"),bsd=b(I),bse=b(Gz),bsf=b(I),bsg=b(yl),bsh=b(Gz),bsi=b(r),bsj=b("137700"),bsk=b("167100"),bsl=b(y),bsm=b("182200"),bsn=b(T),bso=b("189700"),bsp=b(Z),bsq=b("197300"),bsr=b(_),bss=b("204900"),bst=b(I),bsu=b(zT),bsv=b(I),bsw=b(p9),bsx=b(zT),bsz=[0,b(d),0,1,0,1,0],brM=[0,b(K),vi,5,vi,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bq2=b(r),bq3=b("169100"),bq4=b("203800"),bq5=b(y),bq6=b("219100"),bq7=b(T),bq8=b("225200"),bq9=b(Z),bq_=b("231500"),bq$=b(_),bra=b("237700"),brb=b(I),brc=b(lY),brd=b(I),bre=b("21100"),brf=b(lY),brg=b(r),brh=b("148300"),bri=b(Dp),brj=b(y),brk=b("196800"),brl=b(T),brm=b("203700"),brn=b(Z),bro=b("210700"),brp=b(_),brq=b(CJ),brr=b(I),brs=b(CV),brt=b(I),bru=b("20300"),brv=b(CV),brw=b(r),brx=b("139100"),bry=b("168800"),brz=b(y),brA=b(q1),brB=b(T),brC=b("191600"),brD=b(Z),brE=b("199300"),brF=b(_),brG=b("206900"),brH=b(I),brI=b(xS),brJ=b(I),brK=b(wR),brL=b(xS),brN=[0,b(d),0,1,0,1,0],bq0=[0,b(K),g1,5,g1,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bqe=b(r),bqf=b("171100"),bqg=b("206200"),bqh=b(y),bqi=b("221700"),bqj=b(T),bqk=b("227900"),bql=b(Z),bqm=b("234300"),bqn=b(_),bqo=b("240600"),bqp=b(I),bqq=b(EX),bqr=b(I),bqs=b("21400"),bqt=b(EX),bqu=b(r),bqv=b("150100"),bqw=b(q1),bqx=b(y),bqy=b("199200"),bqz=b(T),bqA=b("206100"),bqB=b(Z),bqC=b("213200"),bqD=b(_),bqE=b("220200"),bqF=b(I),bqG=b(wG),bqH=b(I),bqI=b("20500"),bqJ=b(wG),bqK=b(r),bqL=b(zG),bqM=b("170800"),bqN=b(y),bqO=b("186200"),bqP=b(T),bqQ=b("193900"),bqR=b(Z),bqS=b(Ik),bqT=b(_),bqU=b("209400"),bqV=b(I),bqW=b(FB),bqX=b(I),bqY=b("19500"),bqZ=b(FB),bq1=[0,b(d),0,1,0,1,0],bqc=[0,b(K),HO,5,HO,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bps=b(r),bpt=b("26084"),bpu=b("31435"),bpv=b(y),bpw=b("33798"),bpx=b(T),bpy=b("34743"),bpz=b(Z),bpA=b("35719"),bpB=b(_),bpC=b("36679"),bpD=b(I),bpE=b(Ew),bpF=b(I),bpG=b("3262"),bpH=b(Ew),bpI=b(r),bpJ=b("22883"),bpK=b("28051"),bpL=b(y),bpM=b("30368"),bpN=b(T),bpO=b("31420"),bpP=b(Z),bpQ=b("32502"),bpR=b(_),bpS=b("33569"),bpT=b(I),bpU=b(AY),bpV=b(I),bpW=b("3125"),bpX=b(AY),bpY=b(r),bpZ=b("21465"),bp0=b("26038"),bp1=b(y),bp2=b("28386"),bp3=b(T),bp4=b("29560"),bp5=b(Z),bp6=b("30749"),bp7=b(_),bp8=b("31923"),bp9=b(I),bp_=b(Ax),bp$=b(I),bqa=b("2973"),bqb=b(Ax),bqd=[0,b(d),0,1,0,1,0],bpq=[0,b(K),Ho,5,Ho,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],boG=b(r),boH=b("26397"),boI=b("31812"),boJ=b(y),boK=b("34204"),boL=b(T),boM=b("35160"),boN=b(Z),boO=b("36148"),boP=b(_),boQ=b("37119"),boR=b(I),boS=b(EM),boT=b(I),boU=b("3301"),boV=b(EM),boW=b(r),boX=b("23158"),boY=b("28388"),boZ=b(y),bo0=b("30732"),bo1=b(T),bo2=b(po),bo3=b(Z),bo4=b("32892"),bo5=b(_),bo6=b("33972"),bo7=b(I),bo8=b(Ao),bo9=b(I),bo_=b("3163"),bo$=b(Ao),bpa=b(r),bpb=b("21723"),bpc=b("26350"),bpd=b(y),bpe=b("28727"),bpf=b(T),bpg=b("29915"),bph=b(Z),bpi=b("31118"),bpj=b(_),bpk=b("32306"),bpl=b(I),bpm=b(Da),bpn=b(I),bpo=b("3009"),bpp=b(Da),bpr=[0,b(d),0,1,0,1,0],boE=[0,b(K),Cp,5,Cp,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bnU=b(r),bnV=b(I0),bnW=b("32194"),bnX=b(y),bnY=b("34614"),bnZ=b(T),bn0=b("35582"),bn1=b(Z),bn2=b("36582"),bn3=b(_),bn4=b("37564"),bn5=b(I),bn6=b(vt),bn7=b(I),bn8=b("3341"),bn9=b(vt),bn_=b(r),bn$=b("23436"),boa=b("28729"),bob=b(y),boc=b("31101"),bod=b(T),boe=b("32179"),bof=b(Z),bog=b("33287"),boh=b(_),boi=b("34380"),boj=b(I),bok=b(xQ),bol=b(I),bom=b("3201"),bon=b(xQ),boo=b(r),bop=b("21984"),boq=b("26666"),bor=b(y),bos=b("29072"),bot=b(T),bou=b("30274"),bov=b(Z),bow=b("31491"),box=b(_),boy=b("32694"),boz=b(I),boA=b(yq),boB=b(I),boC=b("3045"),boD=b(yq),boF=[0,b(d),0,1,0,1,0],bnS=[0,b(K),ED,5,ED,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bm8=b(r),bm9=b("27195"),bm_=b("32773"),bm$=b(y),bna=b("35237"),bnb=b(T),bnc=b("36222"),bnd=b(Z),bne=b("37240"),bnf=b(_),bng=b("38240"),bnh=b(I),bni=b(F1),bnj=b(I),bnk=b("3401"),bnl=b(F1),bnm=b(r),bnn=b("23858"),bno=b("29246"),bnp=b(y),bnq=b("31661"),bnr=b(T),bns=b("32758"),bnt=b(Z),bnu=b("33886"),bnv=b(_),bnw=b("34999"),bnx=b(I),bny=b(EN),bnz=b(I),bnA=b("3259"),bnB=b(EN),bnC=b(r),bnD=b("22380"),bnE=b("27146"),bnF=b(y),bnG=b("29595"),bnH=b(T),bnI=b("30819"),bnJ=b(Z),bnK=b("32058"),bnL=b(_),bnM=b("33282"),bnN=b(I),bnO=b(xJ),bnP=b(I),bnQ=b("3100"),bnR=b(xJ),bnT=[0,b(d),0,1,0,1,0],bm6=[0,b(K),yU,5,yU,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bmk=b(r),bml=b("27956"),bmm=b("33691"),bmn=b(y),bmo=b("36224"),bmp=b(T),bmq=b("37236"),bmr=b(Z),bms=b("38283"),bmt=b(_),bmu=b("39311"),bmv=b(I),bmw=b(wq),bmx=b(I),bmy=b("3496"),bmz=b(wq),bmA=b(r),bmB=b("24526"),bmC=b("30065"),bmD=b(y),bmE=b("32548"),bmF=b(T),bmG=b("33675"),bmH=b(Z),bmI=b(Iz),bmJ=b(_),bmK=b("35979"),bmL=b(I),bmM=b(Fz),bmN=b(I),bmO=b("3350"),bmP=b(Fz),bmQ=b(r),bmR=b("23007"),bmS=b("27906"),bmT=b(y),bmU=b("30424"),bmV=b(T),bmW=b("31682"),bmX=b(Z),bmY=b(Ei),bmZ=b(_),bm0=b("34214"),bm1=b(I),bm2=b(HZ),bm3=b(I),bm4=b("3187"),bm5=b(HZ),bm7=[0,b(d),0,1,0,1,0],bmi=[0,b(K),Gv,5,Gv,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bly=b(r),blz=b("28728"),blA=b("34621"),blB=b(y),blC=b("37224"),blD=b(T),blE=b("38264"),blF=b(Z),blG=b(wf),blH=b(_),blI=b("40396"),blJ=b(I),blK=b(Dy),blL=b(I),blM=b("3592"),blN=b(Dy),blO=b(r),blP=b("25203"),blQ=b("30895"),blR=b(y),blS=b("33446"),blT=b(T),blU=b("34604"),blV=b(Z),blW=b("35796"),blX=b(_),blY=b("36972"),blZ=b(I),bl0=b(AT),bl1=b(I),bl2=b("3442"),bl3=b(AT),bl4=b(r),bl5=b("23642"),bl6=b("28676"),bl7=b(y),bl8=b(vR),bl9=b(T),bl_=b("32556"),bl$=b(Z),bma=b("33866"),bmb=b(_),bmc=b("35158"),bmd=b(I),bme=b(Cy),bmf=b(I),bmg=b("3275"),bmh=b(Cy),bmj=[0,b(d),0,1,0,1,0],blw=[0,b(K),pe,5,pe,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bkM=b(r),bkN=b("29575"),bkO=b("35642"),bkP=b(y),bkQ=b("38322"),bkR=b(T),bkS=b("39393"),bkT=b(Z),bkU=b("40501"),bkV=b(_),bkW=b("41588"),bkX=b(I),bkY=b(Hb),bkZ=b(I),bk0=b("3698"),bk1=b(Hb),bk2=b(r),bk3=b("25946"),bk4=b("31806"),bk5=b(y),bk6=b("34433"),bk7=b(T),bk8=b("35625"),bk9=b(Z),bk_=b("36852"),bk$=b(_),bla=b("38063"),blb=b(I),blc=b(Fn),bld=b(I),ble=b("3544"),blf=b(Fn),blg=b(r),blh=b("24339"),bli=b("29522"),blj=b(y),blk=b("32186"),bll=b(T),blm=b("33516"),bln=b(Z),blo=b(Iz),blp=b(_),blq=b("36195"),blr=b(I),bls=b(Ae),blt=b(I),blu=b("3372"),blv=b(Ae),blx=[0,b(d),0,1,0,1,0],bkK=[0,b(K),uD,5,uD,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bj0=b(r),bj1=b("29670"),bj2=b("35757"),bj3=b(y),bj4=b("38445"),bj5=b(T),bj6=b("39519"),bj7=b(Z),bj8=b("40601"),bj9=b(_),bj_=b("41721"),bj$=b(I),bka=b(zC),bkb=b(I),bkc=b("3710"),bkd=b(zC),bke=b(r),bkf=b("26029"),bkg=b("31908"),bkh=b(y),bki=b("34643"),bkj=b(T),bkk=b("35739"),bkl=b(Z),bkm=b("36970"),bkn=b(_),bko=b("38185"),bkp=b(I),bkq=b(FI),bkr=b(I),bks=b("3555"),bkt=b(FI),bku=b(r),bkv=b("24417"),bkw=b("29616"),bkx=b(y),bky=b("32289"),bkz=b(T),bkA=b(EO),bkB=b(Z),bkC=b("34977"),bkD=b(_),bkE=b("36311"),bkF=b(I),bkG=b(Fb),bkH=b(I),bkI=b("3383"),bkJ=b(Fb),bkL=[0,b(d),0,1,0,1,0],bjY=[0,b(K),zv,5,zv,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bjc=b(r),bjd=b("29996"),bje=b("36149"),bjf=b(y),bjg=b("38868"),bjh=b(T),bji=b("39954"),bjj=b(Z),bjk=b("41078"),bjl=b(_),bjm=b("42180"),bjn=b(I),bjo=b(yi),bjp=b(I),bjq=b("3751"),bjr=b(yi),bjs=b(r),bjt=b("26315"),bju=b("32259"),bjv=b(y),bjw=b("34923"),bjx=b(T),bjy=b("36132"),bjz=b(Z),bjA=b("37373"),bjB=b(_),bjC=b("38605"),bjD=b(I),bjE=b(Hm),bjF=b(I),bjG=b("3594"),bjH=b(Hm),bjI=b(r),bjJ=b("24686"),bjK=b("29942"),bjL=b(y),bjM=b("32644"),bjN=b(T),bjO=b("33993"),bjP=b(Z),bjQ=b("35362"),bjR=b(_),bjS=b("36710"),bjT=b(I),bjU=b(xD),bjV=b(I),bjW=b("3420"),bjX=b(xD),bjZ=[0,b(d),0,1,0,1,0],bja=[0,b(K),mv,5,mv,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],biq=b(r),bir=b("30296"),bis=b("36510"),bit=b(y),biu=b("39257"),biv=b(T),biw=b("40354"),bix=b(Z),biy=b("41489"),biz=b(_),biA=b("42602"),biB=b(I),biC=b(Ch),biD=b(I),biE=b("3789"),biF=b(Ch),biG=b(r),biH=b("26578"),biI=b("32582"),biJ=b(y),biK=b("35272"),biL=b(T),biM=b("36493"),biN=b(Z),biO=b("37751"),biP=b(_),biQ=b("38991"),biR=b(I),biS=b(Dq),biT=b(I),biU=b("3630"),biV=b(Dq),biW=b(r),biX=b("24933"),biY=b("30241"),biZ=b(y),bi0=b("32970"),bi1=b(T),bi2=b("34333"),bi3=b(Z),bi4=b("35716"),bi5=b(_),bi6=b("37077"),bi7=b(I),bi8=b(un),bi9=b(I),bi_=b("3454"),bi$=b(un),bjb=[0,b(d),0,1,0,1,0],bio=[0,b(K),Du,5,Du,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bhE=b(r),bhF=b("30947"),bhG=b("37295"),bhH=b(y),bhI=b("40101"),bhJ=b(T),bhK=b("41222"),bhL=b(Z),bhM=b("42381"),bhN=b(_),bhO=b("43518"),bhP=b(I),bhQ=b(GK),bhR=b(I),bhS=b("3870"),bhT=b(GK),bhU=b(r),bhV=b("27149"),bhW=b("33283"),bhX=b(y),bhY=b("36030"),bhZ=b(T),bh0=b("37278"),bh1=b(Z),bh2=b("38563"),bh3=b(_),bh4=b("39829"),bh5=b(I),bh6=b("42649"),bh7=b(I),bh8=b("3708"),bh9=b("42659"),bh_=b(r),bh$=b("25469"),bia=b("30891"),bib=b(y),bic=b("33679"),bid=b(T),bie=b("35071"),bif=b(Z),big=b("36484"),bih=b(_),bii=b("37874"),bij=b(I),bik=b(zc),bil=b(I),bim=b("3528"),bin=b(zc),bip=[0,b(d),0,1,0,1,0],bhC=[0,b(K),xv,5,xv,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bgS=b(r),bgT=b("31123"),bgU=b("37508"),bgV=b(y),bgW=b("40330"),bgX=b(T),bgY=b("41457"),bgZ=b(Z),bg0=b("42623"),bg1=b(_),bg2=b("43766"),bg3=b(I),bg4=b(BI),bg5=b(I),bg6=b("3892"),bg7=b(BI),bg8=b(r),bg9=b("27304"),bg_=b("33473"),bg$=b(y),bha=b("36235"),bhb=b(T),bhc=b("37490"),bhd=b(Z),bhe=b("38783"),bhf=b(_),bhg=b("40056"),bhh=b(I),bhi=b(yN),bhj=b(I),bhk=b("3729"),bhl=b(yN),bhm=b(r),bhn=b("25614"),bho=b("31067"),bhp=b(y),bhq=b("33871"),bhr=b(T),bhs=b("35271"),bht=b(Z),bhu=b("36692"),bhv=b(_),bhw=b("38090"),bhx=b(I),bhy=b(wQ),bhz=b(I),bhA=b("3548"),bhB=b(wQ),bhD=[0,b(d),0,1,0,1,0],bgQ=[0,b(K),BG,5,BG,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bf6=b(r),bf7=b("31148"),bf8=b("37538"),bf9=b(y),bf_=b("40362"),bf$=b(T),bga=b("41490"),bgb=b(Z),bgc=b("42657"),bgd=b(_),bge=b("43801"),bgf=b(I),bgg=b(vQ),bgh=b(I),bgi=b("3895"),bgj=b(vQ),bgk=b(r),bgl=b("27326"),bgm=b(Bd),bgn=b(y),bgo=b("36264"),bgp=b(T),bgq=b("37520"),bgr=b(Z),bgs=b("38814"),bgt=b(_),bgu=b("40088"),bgv=b(I),bgw=b(IJ),bgx=b(I),bgy=b("3732"),bgz=b(IJ),bgA=b(r),bgB=b("25634"),bgC=b("31092"),bgD=b(y),bgE=b("33898"),bgF=b(T),bgG=b("35299"),bgH=b(Z),bgI=b("36721"),bgJ=b(_),bgK=b("38120"),bgL=b(I),bgM=b(Fa),bgN=b(I),bgO=b("3551"),bgP=b(Fa),bgR=[0,b(d),0,1,0,1,0],bf4=[0,b(K),Cf,5,Cf,62,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bfi=b(r),bfj=b("31382"),bfk=b("37820"),bfl=b(y),bfm=b("40665"),bfn=b(T),bfo=b("41801"),bfp=b(Z),bfq=b("42977"),bfr=b(_),bfs=b("44130"),bft=b(I),bfu=b(xg),bfv=b(I),bfw=b("3924"),bfx=b(xg),bfy=b(r),bfz=b("27531"),bfA=b("33751"),bfB=b(y),bfC=b("36536"),bfD=b(T),bfE=b("37801"),bfF=b(Z),bfG=b("39105"),bfH=b(_),bfI=b("40389"),bfJ=b(I),bfK=b(CN),bfL=b(I),bfM=b("3760"),bfN=b(CN),bfO=b(r),bfP=b("25826"),bfQ=b("31325"),bfR=b(y),bfS=b("34152"),bfT=b(T),bfU=b("35564"),bfV=b(Z),bfW=b("36996"),bfX=b(_),bfY=b("38406"),bfZ=b(I),bf0=b(wW),bf1=b(I),bf2=b("3578"),bf3=b(wW),bf5=[0,b(d),0,1,0,1,0],bfg=[0,b(K),zy,5,zy,32,[0,b(bP),[0,b(bk),[0,b(J),0]]]],bew=b(r),bex=b("31476"),bey=b("37933"),bez=b(y),beA=b("40787"),beB=b(T),beC=b("41927"),beD=b(Z),beE=b("43106"),beF=b(_),beG=b("44262"),beH=b(I),beI=b(vg),beJ=b(I),beK=b("3936"),beL=b(vg),beM=b(r),beN=b("27614"),beO=b("33853"),beP=b(y),beQ=b("36646"),beR=b(T),beS=b("37915"),beT=b(Z),beU=b("39222"),beV=b(_),beW=b("40510"),beX=b(I),beY=b(AB),beZ=b(I),be0=b("3771"),be1=b(AB),be2=b(r),be3=b("25904"),be4=b("31419"),be5=b(y),be6=b("34255"),be7=b(T),be8=b("35670"),be9=b(Z),be_=b("37107"),be$=b(_),bfa=b("38521"),bfb=b(I),bfc=b(IQ),bfd=b(I),bfe=b("3588"),bff=b(IQ),bfh=[0,b(d),0,1,0,1,0],bvI=[0,b(d),0,1,0,1,0],bvJ=[0,b(d),0,1,0,1,0],bev=[0,b(o),He,10,He,14,[0,b(aa),[0,b(P),[0,b(p),0]]]],bek=[0,b(z),6077,4,6081,72,[0,b(pd),[0,b(qI),[0,b(mk),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bel=[0,b(d),0,1,0,1,0],bej=[0,b(z),6029,4,6033,72,[0,b(pd),[0,b(qI),[0,b(mk),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],bem=[0,b(d),0,1,0,1,0],bei=[0,b(z),5574,4,5581,72,[0,b(gI),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],ben=[0,b(d),0,1,0,1,0],beh=[0,b(z),5494,4,5501,72,[0,b(gI),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],beo=[0,b(d),0,1,0,1,0],bep=[0,b(d),0,1,0,1,0],beq=[0,b(d),0,1,0,1,0],beg=[0,b(z),4652,6,4655,44,[0,b(il),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ber=[0,b(d),0,1,0,1,0],bef=[0,b(o),na,11,na,30,[0,b(aa),[0,b(P),[0,b(p),0]]]],bd$=[0,b(K),Bu,14,Bu,40,[0,b("Article 35"),[0,b(bk),[0,b(J),0]]]],bd_=b(h_),bd5=[0,b(K),E4,14,E4,41,[0,b("Article 36"),[0,b(bk),[0,b(J),0]]]],bd4=b(g6),bdZ=[0,b(K),zn,14,zn,41,[0,b(GA),[0,b(bk),[0,b(J),0]]]],bdY=b(qp),bdT=[0,b(K),FU,14,FU,41,[0,b(zb),[0,b(bk),[0,b(J),0]]]],bdS=b("390000"),bdN=[0,b(K),Ex,14,Ex,33,[0,b(GA),[0,b(bk),[0,b(J),0]]]],bdM=b(p6),bdH=[0,b(K),u1,14,u1,33,[0,b(zb),[0,b(bk),[0,b(J),0]]]],bdG=b(xG),bdt=b(aD),bdu=[0,b(N),3433,5,3441,35,[0,b(ap),[0,b(cG),[0,b(M),0]]]],bds=b(bf),bdv=[0,b(d),0,1,0,1,0],bdq=b(aD),bdr=[0,b(N),2873,5,2881,35,[0,b(ap),[0,b(a3),[0,b(M),0]]]],bdp=b(bf),bdw=[0,b(d),0,1,0,1,0],bdn=b(aD),bdo=[0,b(N),1782,5,1790,35,[0,b(ap),[0,b(aW),[0,b(M),0]]]],bdm=b(bf),bdx=[0,b(d),0,1,0,1,0],bdk=b(aD),bdl=[0,b(N),iv,5,652,35,[0,b(ap),[0,b(cT),[0,b(M),0]]]],bdj=b(bf),bdy=[0,b(d),0,1,0,1,0],bdh=b(aD),bdi=[0,b(N),iV,5,rr,35,[0,b(ap),[0,b(cL),[0,b(M),0]]]],bdg=b(bf),bdz=[0,b(d),0,1,0,1,0],bdA=[0,b(d),0,1,0,1,0],bdB=[0,b(d),0,1,0,1,0],bdc=[0,b(N),nn,14,nn,47,[0,b(iu),[0,b(aW),[0,b(M),0]]]],bdd=[0,b(d),0,1,0,1,0],bdb=[0,b(K),vP,14,vP,47,[0,b(iu),[0,b(bk),[0,b(J),0]]]],bde=[0,b(d),0,1,0,1,0],bdf=[0,b(d),0,1,0,1,0],bc6=[0,b(o),iB,14,iB,41,[0,b(aa),[0,b(P),[0,b(p),0]]]],bc1=[0,b(o),lb,14,lb,50,[0,b(aa),[0,b(P),[0,b(p),0]]]],bcT=[0,b(z),kV,14,kV,64,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bcO=[0,b(z),k6,14,k6,59,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bcJ=[0,b(dm),fZ,14,fZ,36,[0,b(GU),[0,b(wJ),0]]],bcH=b(B2),bcI=b(dy),bcK=[0,b(d),0,1,0,1,0],bcG=[0,b(o),Fl,11,Fl,33,[0,b(aa),[0,b(P),[0,b(p),0]]]],bcL=[0,0,0],bcM=[0,b(L),[0,b(A3),0]],bcP=[0,b(d),0,1,0,1,0],bcQ=[0,1,0],bcR=[0,b(L),[0,b(ks),0]],bcN=[0,b(z),k6,14,k6,59,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bcU=[0,b(d),0,1,0,1,0],bcV=[0,1,0],bcW=[0,b(L),[0,b(m0),0]],bcS=[0,b(z),kV,14,kV,64,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bcX=[0,b(L),[0,b(fu),[0,b(iG),0]]],bcY=[0,b(L),[0,b(fu),[0,b(iG),0]]],bcZ=[0,b(o),nl,13,nl,42,[0,b(aa),[0,b(P),[0,b(p),0]]]],bDu=[0,b(o),nl,13,nl,42,[0,b(aa),[0,b(P),[0,b(p),0]]]],bc2=[0,b(d),0,1,0,1,0],bc3=[0,1,0],bc4=[0,b(L),[0,b(ig),0]],bc0=[0,b(o),lb,14,lb,50,[0,b(aa),[0,b(P),[0,b(p),0]]]],bc7=[0,b(d),0,1,0,1,0],bc8=[0,1,0],bc9=[0,b(L),[0,b(h3),0]],bc5=[0,b(o),iB,14,iB,41,[0,b(aa),[0,b(P),[0,b(p),0]]]],bc_=[0,b(L),[0,b(ed),[0,b(bm),0]]],bc$=[0,b(L),[0,b(ed),[0,b(bm),0]]],bdC=[0,b(d),0,1,0,1,0],bda=[0,b(o),y9,11,y9,44,[0,b(aa),[0,b(P),[0,b(p),0]]]],bdD=[0,0,0],bdE=[0,b(L),[0,b(vb),0]],bdI=[0,b(d),0,1,0,1,0],bdF=[0,b(o),wo,11,wo,30,[0,b(aa),[0,b(P),[0,b(p),0]]]],bdJ=[0,0,0],bdK=[0,b(L),[0,b("coefficient_d842_12"),0]],bdO=[0,b(d),0,1,0,1,0],bdL=[0,b(o),yJ,11,yJ,30,[0,b(aa),[0,b(P),[0,b(p),0]]]],bdP=[0,0,0],bdQ=[0,b(L),[0,b("coefficient_d842_11"),0]],bdU=[0,b(d),0,1,0,1,0],bdR=[0,b(o),G$,11,G$,38,[0,b(aa),[0,b(P),[0,b(p),0]]]],bdV=[0,0,0],bdW=[0,b(L),[0,b("montant_forfaitaire_d842_12"),0]],bd0=[0,b(d),0,1,0,1,0],bdX=[0,b(o),vn,11,vn,38,[0,b(aa),[0,b(P),[0,b(p),0]]]],bd1=[0,0,0],bd2=[0,b(L),[0,b("montant_forfaitaire_d842_11"),0]],bd6=[0,b(d),0,1,0,1,0],bd3=[0,b(o),pC,11,pC,38,[0,b(aa),[0,b(P),[0,b(p),0]]]],bd7=[0,0,0],bd8=[0,b(L),[0,b("montant_minimal_aide_d842_6"),0]],bea=[0,b(d),0,1,0,1,0],bd9=[0,b(o),FW,11,FW,37,[0,b(aa),[0,b(P),[0,b(p),0]]]],beb=[0,0,0],bec=[0,b(L),[0,b("montant_forfaitaire_d842_6"),0]],bed=[0,b(o),le,13,le,48,[0,b(aa),[0,b(P),[0,b(p),0]]]],bDt=[0,b(o),le,13,le,48,[0,b(aa),[0,b(P),[0,b(p),0]]]],bes=[0,b(d),0,1,0,1,0],bee=[0,b(o),na,11,na,30,[0,b(aa),[0,b(P),[0,b(p),0]]]],bet=[0,0,0],beu=[0,b(L),[0,b("condition_d842_11_3"),0]],bvK=[0,0,0],bvL=[0,b(L),[0,b(cy),0]],bxO=[0,b(d),0,1,0,1,0],bvM=[0,b(o),D1,11,D1,38,[0,b(aa),[0,b(P),[0,b(p),0]]]],bxP=[0,0,0],bxQ=[0,b(L),[0,b(qi),0]],bxX=[0,b(d),0,1,0,1,0],bxR=[0,b(o),pj,11,pj,42,[0,b(aa),[0,b(P),[0,b(p),0]]]],bxY=[0,0,0],bxZ=[0,b(L),[0,b("seuil_minimal_ressources_m\xc3\xa9nage"),0]],bx5=[0,0,0],bx6=[0,b(L),[0,b(bF),0]],byL=[0,0,0],byM=[0,b(L),[0,b(bI),0]],byQ=[0,0,0],byR=[0,b(L),[0,b(dd),0]],byZ=[0,b(d),0,1,0,1,0],byS=[0,b(o),A5,10,A5,15,[0,b(aa),[0,b(P),[0,b(p),0]]]],by0=[0,0,0],by1=[0,b(L),[0,b("ressources_m\xc3\xa9nage_arrondies_seuil"),0]],bz5=[0,0,0],bz6=[0,b(L),[0,b(dt),0]],bz9=[0,b(d),0,1,0,1,0],bz_=[0,1,0],bz$=[0,b(L),[0,b(nd),0]],bz7=[0,b(o),mK,14,mK,61,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAc=[0,b(d),0,1,0,1,0],bAd=[0,1,0],bAe=[0,b(L),[0,b(l_),0]],bAa=[0,b(z),l3,14,l3,75,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bAh=[0,b(d),0,1,0,1,0],bAi=[0,1,0],bAj=[0,b(L),[0,b(la),0]],bAf=[0,b(z),ni,14,ni,69,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bAm=[0,b(d),0,1,0,1,0],bAn=[0,1,0],bAo=[0,b(L),[0,b(l6),0]],bAk=[0,b(z),jU,14,jU,70,[0,b(cq),[0,b(aw),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bAp=[0,b(L),[0,b(fk),[0,b(dL),0]]],bAq=[0,b(L),[0,b(fk),[0,b(dL),0]]],bAt=[0,b(d),0,1,0,1,0],bAu=[0,1,0],bAv=[0,b(L),[0,b(FT),0]],bAr=[0,b(o),lR,14,lR,49,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAy=[0,b(d),0,1,0,1,0],bAz=[0,1,0],bAA=[0,b(L),[0,b(EH),0]],bAw=[0,b(o),mN,14,mN,74,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAE=[0,b(d),0,1,0,1,0],bAF=[0,1,0],bAG=[0,b(L),[0,b(Dw),0]],bAB=[0,b(o),lC,14,lC,59,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAJ=[0,b(d),0,1,0,1,0],bAK=[0,1,0],bAL=[0,b(L),[0,b(EI),0]],bAH=[0,b(o),ll,14,ll,61,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAO=[0,b(d),0,1,0,1,0],bAP=[0,1,0],bAQ=[0,b(L),[0,b(B4),0]],bAM=[0,b(o),ko,14,ko,67,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAT=[0,b(d),0,1,0,1,0],bAU=[0,1,0],bAV=[0,b(L),[0,b(AZ),0]],bAR=[0,b(o),mi,14,mi,65,[0,b(aa),[0,b(P),[0,b(p),0]]]],bAY=[0,b(d),0,1,0,1,0],bAZ=[0,1,0],bA0=[0,b(L),[0,b(yR),0]],bAW=[0,b(o),kY,14,kY,70,[0,b(aa),[0,b(P),[0,b(p),0]]]],bA3=[0,b(d),0,1,0,1,0],bA4=[0,1,0],bA5=[0,b(L),[0,b(GC),0]],bA1=[0,b(o),lx,14,lx,44,[0,b(aa),[0,b(P),[0,b(p),0]]]],bA8=[0,b(d),0,1,0,1,0],bA9=[0,1,0],bA_=[0,b(L),[0,b(AJ),0]],bA6=[0,b(o),lJ,14,lJ,53,[0,b(aa),[0,b(P),[0,b(p),0]]]],bBc=[0,b(d),0,1,0,1,0],bBd=[0,1,0],bBe=[0,b(L),[0,b(u2),0]],bA$=[0,b(o),kW,14,kW,49,[0,b(aa),[0,b(P),[0,b(p),0]]]],bBr=[0,b(L),[0,b(mQ),[0,b(aq),0]]],bBs=[0,b(L),[0,b(mQ),[0,b(aq),0]]],bBx=[0,b(d),0,1,0,1,0],bBt=[0,b(o),wY,11,wY,47,[0,b(aa),[0,b(P),[0,b(p),0]]]],bBy=[0,0,0],bBz=[0,b(L),[0,b("seuil_minimal_d\xc3\xa9pense_nette_minimale"),0]],bBZ=[0,b(d),0,1,0,1,0],bBA=[0,b(o),Ci,11,Ci,36,[0,b(aa),[0,b(P),[0,b(p),0]]]],bB0=[0,0,0],bB1=[0,b(L),[0,b("plafond_mensualit\xc3\xa9_d842_6"),0]],bB4=[0,b(d),0,1,0,1,0],bB2=[0,b(o),pl,12,pl,31,[0,b(aa),[0,b(P),[0,b(p),0]]]],bB5=[0,0,1],bB6=[0,b(L),[0,b(kl),0]],bB9=[0,b(d),0,1,0,1,0],bB7=[0,b(o),A0,12,A0,39,[0,b(aa),[0,b(P),[0,b(p),0]]]],bB_=[0,0,1],bB$=[0,b(L),[0,b(kk),0]],bCk=[0,0,0],bCl=[0,b(L),[0,b(ee),0]],bCo=[0,b(d),0,1,0,1,0],bCm=[0,b(o),uE,12,uE,31,[0,b(aa),[0,b(P),[0,b(p),0]]]],bCp=[0,0,1],bCq=[0,b(L),[0,b(ns),0]],bCH=[0,0,0],bCI=[0,b(L),[0,b(eh),0]],bCL=[0,b(d),0,1,0,1,0],bCJ=[0,b(o),pX,12,pX,31,[0,b(aa),[0,b(P),[0,b(p),0]]]],bCM=[0,0,1],bCN=[0,b(L),[0,b(cO),0]],bC6=[0,0,0],bC7=[0,b(L),[0,b(bG),0]],bDf=[0,0,0],bDg=[0,b(L),[0,b(cW),0]],bDr=[0,0,1],bDs=[0,b(L),[0,b(eW),0]],bcB=[0,b(z),C5,14,C5,36,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bcu=[0,1,0],bcv=[0,b(af),[0,b(cW),[0,b(ac),0]]],bcw=[0,b(af),[0,b(cW),0]],bcx=[0,0,1],bcy=[0,b(af),[0,b(cW),[0,b(Y),0]]],bcz=[0,b(af),[0,b(cW),0]],bcA=b(r),bcC=[0,b(d),0,1,0,1,0],bct=[0,b(o),w7,10,w7,25,[0,b(ad),[0,b(P),[0,b(p),0]]]],bcp=[0,b(dm),lt,14,lt,36,[0,b(bW),[0,b(ru),0]]],bcj=[0,1,0],bck=[0,b(af),[0,b(bG),[0,b(ac),0]]],bcl=[0,b(af),[0,b(bG),0]],bcm=[0,0,1],bcn=[0,b(af),[0,b(bG),[0,b(Y),0]]],bco=[0,b(af),[0,b(bG),0]],bcq=[0,b(d),0,1,0,1,0],bci=[0,b(o),pM,10,pM,48,[0,b(ad),[0,b(P),[0,b(p),0]]]],bce=[0,b(z),wu,14,wu,36,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bb1=[0,1,0],bb2=[0,b(af),[0,b(ii),[0,b(ac),0]]],bb3=[0,b(af),[0,b(ii),0]],bb4=[0,0,1],bb5=[0,b(af),[0,b(ii),[0,b(Y),0]]],bb6=[0,b(af),[0,b(ii),0]],bb7=[0,1,0],bb8=[0,b(bm),[0,b(bO),[0,b(ac),0]]],bb9=[0,b(bm),[0,b(bO),0]],bb_=[0,0,1],bb$=[0,b(bm),[0,b(bO),[0,b(Y),0]]],bca=[0,b(bm),[0,b(bO),0]],bcb=b(is),bcc=b(r),bcd=b(r),bcf=[0,b(d),0,1,0,1,0],bb0=[0,b(o),kG,10,kG,40,[0,b(ad),[0,b(P),[0,b(p),0]]]],bbW=[0,b(z),IT,14,IT,36,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bbQ=[0,1,0],bbR=[0,b(af),[0,b(eh),[0,b(ac),0]]],bbS=[0,b(af),[0,b(eh),0]],bbT=[0,0,1],bbU=[0,b(af),[0,b(eh),[0,b(Y),0]]],bbV=[0,b(af),[0,b(eh),0]],bbX=[0,b(d),0,1,0,1,0],bbP=[0,b(o),mA,10,mA,19,[0,b(ad),[0,b(P),[0,b(p),0]]]],bbL=[0,b(z),Ii,14,Ii,36,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bbx=[0,1,0],bby=[0,b(af),[0,b(bF),[0,b(ac),0]]],bbz=[0,b(af),[0,b(bF),0]],bbA=[0,0,1],bbB=[0,b(af),[0,b(bF),[0,b(Y),0]]],bbC=[0,b(af),[0,b(bF),0]],bbD=[0,1,0],bbE=[0,b(af),[0,b(ee),[0,b(ac),0]]],bbF=[0,b(af),[0,b(ee),0]],bbG=[0,0,1],bbH=[0,b(af),[0,b(ee),[0,b(Y),0]]],bbI=[0,b(af),[0,b(ee),0]],bbJ=b(r),bbK=b(r),bbM=[0,b(d),0,1,0,1,0],bbw=[0,b(o),IM,10,IM,32,[0,b(ad),[0,b(P),[0,b(p),0]]]],bbs=[0,b(z),Hk,14,Hk,47,[0,b(y4),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],bbf=[0,1,0],bbg=[0,b(af),[0,b(dd),[0,b(ac),0]]],bbh=[0,b(af),[0,b(dd),0]],bbi=[0,0,1],bbj=[0,b(af),[0,b(dd),[0,b(Y),0]]],bbk=[0,b(af),[0,b(dd),0]],bbl=[0,1,0],bbm=[0,b(af),[0,b(dd),[0,b(ac),0]]],bbn=[0,b(af),[0,b(dd),0]],bbo=[0,0,1],bbp=[0,b(af),[0,b(dd),[0,b(Y),0]]],bbq=[0,b(af),[0,b(dd),0]],bbr=b(r),bbt=[0,b(d),0,1,0,1,0],bbe=[0,b(o),DM,11,DM,44,[0,b(ad),[0,b(P),[0,b(p),0]]]],bba=[0,b(z),w4,14,w4,33,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ba7=[0,b(z),Gk,14,Gk,36,[0,b(y4),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ba8=[0,b(d),0,1,0,1,0],ba6=[0,b(o),Dg,11,Dg,33,[0,b(ad),[0,b(P),[0,b(p),0]]]],ba2=[0,b(z),uI,14,uI,27,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],baX=[0,b(z),F7,14,F7,36,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],baV=b(r),baW=b(r),baY=[0,b(d),0,1,0,1,0],baU=[0,b(o),Gd,10,Gd,32,[0,b(ad),[0,b(P),[0,b(p),0]]]],baN=[0,b(K),4409,6,4416,28,[0,b(ap),[0,b(fs),[0,b(J),0]]]],baL=b(cZ),baM=b(cY),baO=[0,b(d),0,1,0,1,0],baJ=[0,b(N),Fs,6,ib,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],baE=b(cZ),baF=b(cY),baG=b(bf),baH=b(cZ),baI=b(cY),baK=[0,b(d),0,1,0,1,0],baB=[0,b(N),1953,6,1960,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],baw=b(ci),bax=b(cg),bay=b(bf),baz=b(ci),baA=b(cg),baC=[0,b(d),0,1,0,1,0],bav=[0,b(N),816,6,EC,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],baq=b(ci),bar=b(cg),bas=b(bf),bat=b(ci),bau=b(cg),baD=[0,b(d),0,1,0,1,0],bao=[0,b(N),3045,6,3052,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],baj=b(ea),bak=b(eb),bal=b(bf),bam=b(ea),ban=b(eb),bap=[0,b(d),0,1,0,1,0],bah=[0,b(N),3605,6,3612,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],bac=b(eo),bad=b(ei),bae=b(bf),baf=b(eo),bag=b(ei),bai=[0,b(d),0,1,0,1,0],baP=[0,b(d),0,1,0,1,0],baQ=[0,b(d),0,1,0,1,0],a$$=[0,b(K),gK,29,gK,56,[0,b(ie),[0,b(eU),[0,b(J),0]]]],a$7=b(r),a$8=b(eP),a$9=b(fW),a$_=b(eP),baa=[0,b(d),0,1,0,1,0],a$5=[0,b(N),Fd,29,Fd,56,[0,b(ie),[0,b(aW),[0,b(M),0]]]],a$1=b(r),a$2=b(eH),a$3=b(fT),a$4=b(eH),a$6=[0,b(d),0,1,0,1,0],a$Z=[0,b(N),yC,29,yC,56,[0,b(ie),[0,b(a3),[0,b(M),0]]]],a$V=b(r),a$W=b(eG),a$X=b(fU),a$Y=b(eG),a$0=[0,b(d),0,1,0,1,0],bab=[0,b(d),0,1,0,1,0],a$O=[0,b(z),ms,14,ms,70,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$J=[0,b(z),kF,14,kF,69,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$E=[0,b(z),j9,14,j9,75,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$z=[0,b(o),mZ,14,mZ,61,[0,b(ad),[0,b(P),[0,b(p),0]]]],a$u=[0,b(z),HB,14,HB,41,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$n=[0,b(K),y8,6,y8,79,[0,b(dI),[0,b(eU),[0,b(J),0]]]],a$l=b("8708"),a$m=b("13559"),a$o=[0,b(d),0,1,0,1,0],a$j=[0,b(K),4251,6,4252,38,[0,b(dI),[0,b(eU),[0,b(J),0]]]],a$h=b("21362"),a$i=b("33196"),a$k=[0,b(d),0,1,0,1,0],a$e=[0,b(K),4269,6,4270,24,[0,b(dI),[0,b(eU),[0,b(J),0]]]],a$c=b(E$),a$d=b(xA),a$f=[0,b(d),0,1,0,1,0],a$b=[0,b(K),4233,6,4234,46,[0,b(dI),[0,b(eU),[0,b(J),0]]]],a_$=b(E$),a$a=b(xA),a$g=[0,b(d),0,1,0,1,0],a_9=[0,b(N),p0,6,p0,79,[0,b(dI),[0,b(aW),[0,b(M),0]]]],a_7=b("8414"),a_8=b("13100"),a__=[0,b(d),0,1,0,1,0],a_5=[0,b(N),1688,6,1689,38,[0,b(dI),[0,b(aW),[0,b(M),0]]]],a_3=b("20640"),a_4=b("32073"),a_6=[0,b(d),0,1,0,1,0],a_0=[0,b(N),1707,6,1708,24,[0,b(dI),[0,b(aW),[0,b(M),0]]]],a_Y=b(z1),a_Z=b(EU),a_1=[0,b(d),0,1,0,1,0],a_X=[0,b(N),1669,6,1670,46,[0,b(dI),[0,b(aW),[0,b(M),0]]]],a_V=b(z1),a_W=b(EU),a_2=[0,b(d),0,1,0,1,0],a_T=[0,b(N),yg,6,yg,79,[0,b(dI),[0,b(a3),[0,b(M),0]]]],a_R=b("8379"),a_S=b("13045"),a_U=[0,b(d),0,1,0,1,0],a_P=[0,b(N),2777,6,2778,38,[0,b(dI),[0,b(a3),[0,b(M),0]]]],a_N=b("20554"),a_O=b("31939"),a_Q=[0,b(d),0,1,0,1,0],a_K=[0,b(N),2796,6,2797,24,[0,b(dI),[0,b(a3),[0,b(M),0]]]],a_I=b(va),a_J=b(C4),a_L=[0,b(d),0,1,0,1,0],a_H=[0,b(N),2758,6,2759,46,[0,b(dI),[0,b(a3),[0,b(M),0]]]],a_F=b(va),a_G=b(C4),a_M=[0,b(d),0,1,0,1,0],a$p=[0,b(d),0,1,0,1,0],a_A=[0,b(K),wK,14,wK,42,[0,b("Article 42"),[0,b(eU),[0,b(J),0]]]],a_z=b(g6),a_u=[0,b(K),BQ,14,BQ,41,[0,b("Article 41"),[0,b(eU),[0,b(J),0]]]],a_t=b(h_),a_o=[0,b(K),Fw,14,Fw,51,[0,b("Article 44"),[0,b(eU),[0,b(J),0]]]],a_n=b(qp),a_a=b(aD),a_b=[0,b(N),3448,5,3456,35,[0,b(ap),[0,b(cG),[0,b(M),0]]]],a9$=b(bf),a_c=[0,b(d),0,1,0,1,0],a99=b(aD),a9_=[0,b(N),2888,5,2896,35,[0,b(ap),[0,b(a3),[0,b(M),0]]]],a98=b(bf),a_d=[0,b(d),0,1,0,1,0],a96=b(aD),a97=[0,b(N),1797,5,1805,35,[0,b(ap),[0,b(aW),[0,b(M),0]]]],a95=b(bf),a_e=[0,b(d),0,1,0,1,0],a93=b(aD),a94=[0,b(N),659,5,qM,35,[0,b(ap),[0,b(cT),[0,b(M),0]]]],a92=b(bf),a_f=[0,b(d),0,1,0,1,0],a90=b(aD),a91=[0,b(N),rg,5,153,35,[0,b(ap),[0,b(cL),[0,b(M),0]]]],a9Z=b(bf),a_g=[0,b(d),0,1,0,1,0],a_h=[0,b(d),0,1,0,1,0],a_i=[0,b(d),0,1,0,1,0],a9V=[0,b(N),rc,14,rc,47,[0,b(ie),[0,b(aW),[0,b(M),0]]]],a9W=[0,b(d),0,1,0,1,0],a9U=[0,b(K),FO,14,FO,47,[0,b(ie),[0,b(eU),[0,b(J),0]]]],a9X=[0,b(d),0,1,0,1,0],a9Y=[0,b(d),0,1,0,1,0],a9N=[0,b(z),lP,14,lP,64,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9I=[0,b(z),kB,14,kB,59,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9D=[0,b(z),mD,14,mD,55,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9y=[0,b(z),nk,14,nk,47,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9r=[0,b(z),5601,5,5607,28,[0,b(gI),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],a9s=[0,b(d),0,1,0,1,0],a9t=[0,2,0],a9u=[0,b(af),[0,b(uP),0]],a9n=[0,b(z),Hw,14,Hw,61,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9o=[0,b(d),0,1,0,1,0],a9p=[0,2,0],a9q=[0,b(af),[0,b(HL),0]],a9j=[0,b(o),mb,14,mb,49,[0,b(ad),[0,b(P),[0,b(p),0]]]],a9e=[0,b(o),j2,14,j2,53,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8$=[0,b(o),gE,14,gE,44,[0,b(ad),[0,b(P),[0,b(p),0]]]],a86=[0,b(o),lo,14,lo,70,[0,b(ad),[0,b(P),[0,b(p),0]]]],a81=[0,b(o),kz,14,kz,65,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8W=[0,b(o),kO,14,kO,67,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8R=[0,b(o),ne,14,ne,61,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8M=[0,b(o),fQ,14,fQ,59,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8H=[0,b(o),lA,14,lA,74,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8C=[0,b(o),eS,14,eS,49,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8v=[0,b(o),k3,14,k3,41,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8q=[0,b(o),lw,14,lw,50,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8o=[0,b(o),gx,13,gx,42,[0,b(ad),[0,b(P),[0,b(p),0]]]],bcF=[0,b(o),gx,13,gx,42,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8r=[0,b(d),0,1,0,1,0],a8s=[0,1,0],a8t=[0,b(af),[0,b(ig),0]],a8p=[0,b(o),lw,14,lw,50,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8w=[0,b(d),0,1,0,1,0],a8x=[0,1,0],a8y=[0,b(af),[0,b(h3),0]],a8u=[0,b(o),k3,14,k3,41,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8z=[0,b(af),[0,b(ed),[0,b(bm),0]]],a8A=[0,b(af),[0,b(ed),[0,b(bm),0]]],a8D=[0,b(d),0,1,0,1,0],a8E=[0,1,0],a8F=[0,b(af),[0,b(FT),0]],a8B=[0,b(o),eS,14,eS,49,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8I=[0,b(d),0,1,0,1,0],a8J=[0,1,0],a8K=[0,b(af),[0,b(EH),0]],a8G=[0,b(o),lA,14,lA,74,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8N=[0,b(d),0,1,0,1,0],a8O=[0,1,0],a8P=[0,b(af),[0,b(Dw),0]],a8L=[0,b(o),fQ,14,fQ,59,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8S=[0,b(d),0,1,0,1,0],a8T=[0,1,0],a8U=[0,b(af),[0,b(EI),0]],a8Q=[0,b(o),ne,14,ne,61,[0,b(ad),[0,b(P),[0,b(p),0]]]],a8X=[0,b(d),0,1,0,1,0],a8Y=[0,1,0],a8Z=[0,b(af),[0,b(B4),0]],a8V=[0,b(o),kO,14,kO,67,[0,b(ad),[0,b(P),[0,b(p),0]]]],a82=[0,b(d),0,1,0,1,0],a83=[0,1,0],a84=[0,b(af),[0,b(AZ),0]],a80=[0,b(o),kz,14,kz,65,[0,b(ad),[0,b(P),[0,b(p),0]]]],a87=[0,b(d),0,1,0,1,0],a88=[0,1,0],a89=[0,b(af),[0,b(yR),0]],a85=[0,b(o),lo,14,lo,70,[0,b(ad),[0,b(P),[0,b(p),0]]]],a9a=[0,b(d),0,1,0,1,0],a9b=[0,1,0],a9c=[0,b(af),[0,b(GC),0]],a8_=[0,b(o),gE,14,gE,44,[0,b(ad),[0,b(P),[0,b(p),0]]]],a9f=[0,b(d),0,1,0,1,0],a9g=[0,1,0],a9h=[0,b(af),[0,b(AJ),0]],a9d=[0,b(o),j2,14,j2,53,[0,b(ad),[0,b(P),[0,b(p),0]]]],a9k=[0,b(d),0,1,0,1,0],a9l=[0,1,0],a9m=[0,b(af),[0,b(u2),0]],a9i=[0,b(o),mb,14,mb,49,[0,b(ad),[0,b(P),[0,b(p),0]]]],a9v=[0,b(af),[0,b(mQ),[0,b(aq),0]]],a9w=[0,b(af),[0,b(mQ),[0,b(aq),0]]],a9z=[0,b(d),0,1,0,1,0],a9A=[0,1,0],a9B=[0,b(af),[0,b(C2),0]],a9x=[0,b(z),nk,14,nk,47,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9E=[0,b(d),0,1,0,1,0],a9F=[0,1,0],a9G=[0,b(af),[0,b(FZ),0]],a9C=[0,b(z),mD,14,mD,55,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9J=[0,b(d),0,1,0,1,0],a9K=[0,1,0],a9L=[0,b(af),[0,b(ks),0]],a9H=[0,b(z),kB,14,kB,59,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9O=[0,b(d),0,1,0,1,0],a9P=[0,1,0],a9Q=[0,b(af),[0,b(m0),0]],a9M=[0,b(z),lP,14,lP,64,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a9R=[0,b(af),[0,b(fu),[0,b(ff),0]]],a9S=[0,b(af),[0,b(fu),[0,b(ff),0]]],a_j=[0,b(d),0,1,0,1,0],a9T=[0,b(o),vY,11,vY,44,[0,b(ad),[0,b(P),[0,b(p),0]]]],a_k=[0,0,0],a_l=[0,b(af),[0,b(vb),0]],a_p=[0,b(d),0,1,0,1,0],a_m=[0,b(o),o3,11,o3,48,[0,b(ad),[0,b(P),[0,b(p),0]]]],a_q=[0,0,0],a_r=[0,b(af),[0,b("montant_minimal_d\xc3\xa9pense_nette_d842_17"),0]],a_v=[0,b(d),0,1,0,1,0],a_s=[0,b(o),Hh,11,Hh,38,[0,b(ad),[0,b(P),[0,b(p),0]]]],a_w=[0,0,0],a_x=[0,b(af),[0,b("montant_forfaitaire_d842_15"),0]],a_B=[0,b(d),0,1,0,1,0],a_y=[0,b(o),In,11,In,39,[0,b(ad),[0,b(P),[0,b(p),0]]]],a_C=[0,0,0],a_D=[0,b(af),[0,b("montant_minimal_aide_d842_15"),0]],a$q=[0,b(d),0,1,0,1,0],a_E=[0,b(o),Gx,12,Gx,29,[0,b(ad),[0,b(P),[0,b(p),0]]]],a$r=[0,0,1],a$s=[0,b(af),[0,b(BF),0]],a$v=[0,b(d),0,1,0,1,0],a$t=[0,b(o),u5,12,u5,39,[0,b(ad),[0,b(P),[0,b(p),0]]]],a$w=[0,0,1],a$x=[0,b(af),[0,b(kk),0]],a$A=[0,b(d),0,1,0,1,0],a$B=[0,1,0],a$C=[0,b(af),[0,b(nd),0]],a$y=[0,b(o),mZ,14,mZ,61,[0,b(ad),[0,b(P),[0,b(p),0]]]],a$F=[0,b(d),0,1,0,1,0],a$G=[0,1,0],a$H=[0,b(af),[0,b(l_),0]],a$D=[0,b(z),j9,14,j9,75,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$K=[0,b(d),0,1,0,1,0],a$L=[0,1,0],a$M=[0,b(af),[0,b(la),0]],a$I=[0,b(z),kF,14,kF,69,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$P=[0,b(d),0,1,0,1,0],a$Q=[0,1,0],a$R=[0,b(af),[0,b(l6),0]],a$N=[0,b(z),ms,14,ms,70,[0,b(bV),[0,b(as),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],a$S=[0,b(af),[0,b(fk),[0,b(dL),0]]],a$T=[0,b(af),[0,b(fk),[0,b(dL),0]]],baR=[0,b(d),0,1,0,1,0],a$U=[0,b(o),F9,12,F9,39,[0,b(ad),[0,b(P),[0,b(p),0]]]],baS=[0,0,1],baT=[0,b(af),[0,b(qi),0]],baZ=[0,0,0],ba0=[0,b(af),[0,b(bF),0]],ba3=[0,b(d),0,1,0,1,0],ba1=[0,b(o),vD,12,vD,25,[0,b(ad),[0,b(P),[0,b(p),0]]]],ba4=[0,0,1],ba5=[0,b(af),[0,b(A$),0]],ba9=[0,0,0],ba_=[0,b(af),[0,b(dd),0]],bbb=[0,b(d),0,1,0,1,0],ba$=[0,b(o),zo,12,zo,31,[0,b(ad),[0,b(P),[0,b(p),0]]]],bbc=[0,0,1],bbd=[0,b(af),[0,b(cO),0]],bbu=[0,0,0],bbv=[0,b(af),[0,b(ee),0]],bbN=[0,0,0],bbO=[0,b(af),[0,b(eh),0]],bbY=[0,0,0],bbZ=[0,b(af),[0,b(ii),0]],bcg=[0,0,0],bch=[0,b(af),[0,b(bG),0]],bcr=[0,0,0],bcs=[0,b(af),[0,b(cW),0]],bcD=[0,0,1],bcE=[0,b(af),[0,b(eW),0]],a8f=[0,b(z),pY,14,pY,33,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a8d=b(r),a8e=b(r),a7_=[0,b(z),BX,14,BX,36,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a73=[0,1,0],a74=[0,b(au),[0,b(cW),[0,b(ac),0]]],a75=[0,b(au),[0,b(cW),0]],a76=[0,0,1],a77=[0,b(au),[0,b(cW),[0,b(Y),0]]],a78=[0,b(au),[0,b(cW),0]],a79=b(r),a7$=[0,b(d),0,1,0,1,0],a72=[0,b(o),GB,10,GB,25,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a7Y=[0,b(z),D5,14,D5,39,[0,b(mV),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a7W=b(r),a7X=b(r),a7R=[0,b(dm),qQ,14,qQ,36,[0,b(bW),[0,b(ru),0]]],a7L=[0,1,0],a7M=[0,b(au),[0,b(iC),[0,b(ac),0]]],a7N=[0,b(au),[0,b(iC),0]],a7O=[0,0,1],a7P=[0,b(au),[0,b(iC),[0,b(Y),0]]],a7Q=[0,b(au),[0,b(iC),0]],a7S=[0,b(d),0,1,0,1,0],a7K=[0,b(o),Fo,10,Fo,48,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a7G=[0,b(z),y1,14,y1,42,[0,b(mV),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a7B=[0,b(al),qd,14,qd,36,[0,b(pg),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],a7t=[0,1,0],a7u=[0,b(au),[0,b(bG),[0,b(ac),0]]],a7v=[0,b(au),[0,b(bG),0]],a7w=[0,0,1],a7x=[0,b(au),[0,b(bG),[0,b(Y),0]]],a7y=[0,b(au),[0,b(bG),0]],a7z=b(r),a7A=b(r),a7C=[0,b(d),0,1,0,1,0],a7s=[0,b(o),zq,10,zq,36,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a7k=[0,b(N),vh,14,vh,33,[0,b(ce),[0,b(a3),[0,b(M),0]]]],a7i=b(gp),a7j=b(gp),a7l=[0,b(d),0,1,0,1,0],a7h=[0,b(N),Cd,14,Cd,33,[0,b(ce),[0,b(aW),[0,b(M),0]]]],a7f=b(gp),a7g=b(gp),a7m=[0,b(d),0,1,0,1,0],a7e=[0,b(K),ha,14,ha,33,[0,b(ce),[0,b(bB),[0,b(J),0]]]],a7c=b(gp),a7d=b(gp),a7n=[0,b(d),0,1,0,1,0],a7o=[0,b(d),0,1,0,1,0],a69=[0,b(z),Hq,14,Hq,36,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a6U=[0,1,0],a6V=[0,b(au),[0,b(bF),[0,b(ac),0]]],a6W=[0,b(au),[0,b(bF),0]],a6X=[0,0,1],a6Y=[0,b(au),[0,b(bF),[0,b(Y),0]]],a6Z=[0,b(au),[0,b(bF),0]],a60=[0,1,0],a61=[0,b(bm),[0,b(bO),[0,b(ac),0]]],a62=[0,b(bm),[0,b(bO),0]],a63=[0,0,1],a64=[0,b(bm),[0,b(bO),[0,b(Y),0]]],a65=[0,b(bm),[0,b(bO),0]],a66=b(is),a67=b(r),a68=b(r),a6_=[0,b(d),0,1,0,1,0],a6T=[0,b(o),Bn,10,Bn,40,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a6L=[0,b(N),EJ,14,EJ,33,[0,b(ce),[0,b(a3),[0,b(M),0]]]],a6z=b(gS),a6A=b(by),a6B=b(cX),a6C=b(gS),a6D=b(eD),a6E=b(eD),a6F=b(cX),a6G=b(cX),a6H=b(p2),a6I=b(o$),a6J=b(eD),a6K=b(by),a6M=[0,b(d),0,1,0,1,0],a6y=[0,b(N),Cc,14,Cc,33,[0,b(ce),[0,b(aW),[0,b(M),0]]]],a6m=b(gS),a6n=b(by),a6o=b(cX),a6p=b(gS),a6q=b(eD),a6r=b(eD),a6s=b(cX),a6t=b(cX),a6u=b(p2),a6v=b(o$),a6w=b(eD),a6x=b(by),a6N=[0,b(d),0,1,0,1,0],a6l=[0,b(K),Dx,14,Dx,33,[0,b(ce),[0,b(bB),[0,b(J),0]]]],a5$=b(gS),a6a=b(by),a6b=b(cX),a6c=b(gS),a6d=b(eD),a6e=b(eD),a6f=b(cX),a6g=b(cX),a6h=b(p2),a6i=b(o$),a6j=b(eD),a6k=b(by),a6O=[0,b(d),0,1,0,1,0],a6P=[0,b(d),0,1,0,1,0],a56=[0,b(z),HT,14,HT,36,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a5Y=[0,1,0],a5Z=[0,b(au),[0,b(iH),[0,b(ac),0]]],a50=[0,b(au),[0,b(iH),0]],a51=[0,0,1],a52=[0,b(au),[0,b(iH),[0,b(Y),0]]],a53=[0,b(au),[0,b(iH),0]],a54=b(r),a55=b(r),a57=[0,b(d),0,1,0,1,0],a5X=[0,b(o),Dd,10,Dd,32,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a5P=[0,b(N),A7,14,A7,28,[0,b(ce),[0,b(a3),[0,b(M),0]]]],a5N=b(db),a5O=b(db),a5Q=[0,b(d),0,1,0,1,0],a5M=[0,b(N),jX,14,jX,28,[0,b(ce),[0,b(aW),[0,b(M),0]]]],a5K=b(db),a5L=b(db),a5R=[0,b(d),0,1,0,1,0],a5J=[0,b(K),IP,14,IP,28,[0,b(ce),[0,b(bB),[0,b(J),0]]]],a5H=b(db),a5I=b(db),a5S=[0,b(d),0,1,0,1,0],a5T=[0,b(d),0,1,0,1,0],a5A=[0,b(K),iL,14,iL,36,[0,b(qa),[0,b(bB),[0,b(J),0]]]],a5w=b(Bc),a5x=b(gC),a5y=b(gC),a5z=b(Bc),a5B=[0,b(d),0,1,0,1,0],a5u=[0,b(N),GD,14,GD,36,[0,b(qa),[0,b(aW),[0,b(M),0]]]],a5q=b(GR),a5r=b(gC),a5s=b(gC),a5t=b(GR),a5v=[0,b(d),0,1,0,1,0],a5o=[0,b(N),z2,14,z2,36,[0,b(qa),[0,b(a3),[0,b(M),0]]]],a5k=b(HX),a5l=b(gC),a5m=b(gC),a5n=b(HX),a5p=[0,b(d),0,1,0,1,0],a5C=[0,b(d),0,1,0,1,0],a5e=[0,b(z),DC,5,DC,50,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a5f=[0,b(d),0,1,0,1,0],a5d=[0,b(z),AR,14,AR,36,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a5c=b(r),a5g=[0,b(d),0,1,0,1,0],a5b=[0,b(o),xM,10,xM,17,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a47=[0,b(z),CS,14,CS,28,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a42=[0,b(K),o4,14,o4,42,[0,b(Gf),[0,b(bB),[0,b(J),0]]]],a4Z=b("3.4"),a40=b(gz),a41=b(gz),a4U=[0,b(K),lu,14,lu,41,[0,b(Gf),[0,b(bB),[0,b(J),0]]]],a4R=b("4."),a4S=b(wC),a4T=b(wC),a4I=b(r),a4J=[0,b(K),qY,5,iK,34,[0,b(c_),[0,b(bB),[0,b(J),0]]]],a4F=b(FJ),a4G=b(uN),a4H=b(zA),a4K=[0,b(d),0,1,0,1,0],a4C=b(r),a4D=[0,b(K),py,5,559,34,[0,b(c_),[0,b(bB),[0,b(J),0]]]],a4z=b("27905"),a4A=b("24683"),a4B=b("22911"),a4E=[0,b(d),0,1,0,1,0],a4w=b(y),a4x=[0,b(K),H3,5,H3,35,[0,b(c_),[0,b(bB),[0,b(J),0]]]],a4q=b("4576"),a4r=b("31539"),a4s=b("4043"),a4t=b("27774"),a4u=b("3682"),a4v=b("25689"),a4y=[0,b(d),0,1,0,1,0],a4n=b(r),a4o=[0,b(N),1341,5,1342,34,[0,b(c_),[0,b(aW),[0,b(M),0]]]],a4k=b(Hj),a4l=b(DN),a4m=b(vr),a4p=[0,b(d),0,1,0,1,0],a4h=b(r),a4i=[0,b(N),vf,5,1351,34,[0,b(c_),[0,b(aW),[0,b(M),0]]]],a4e=b("26962"),a4f=b("23848"),a4g=b("22136"),a4j=[0,b(d),0,1,0,1,0],a4b=b(y),a4c=[0,b(N),DS,5,DS,35,[0,b(c_),[0,b(aW),[0,b(M),0]]]],a37=b("4421"),a38=b("30473"),a39=b("3906"),a3_=b("26835"),a3$=b("3557"),a4a=b("24821"),a4d=[0,b(d),0,1,0,1,0],a34=b(r),a35=[0,b(N),2439,5,2440,34,[0,b(c_),[0,b(a3),[0,b(M),0]]]],a31=b(y5),a32=b(uW),a33=b(G0),a36=[0,b(d),0,1,0,1,0],a3Y=b(r),a3Z=[0,b(N),2448,5,2449,34,[0,b(c_),[0,b(a3),[0,b(M),0]]]],a3V=b("26849"),a3W=b("23748"),a3X=b("22044"),a30=[0,b(d),0,1,0,1,0],a3S=b(y),a3T=[0,b(N),D_,5,D_,35,[0,b(c_),[0,b(a3),[0,b(M),0]]]],a3M=b("4403"),a3N=b("30345"),a3O=b("3890"),a3P=b("26723"),a3Q=b("3542"),a3R=b("24717"),a3U=[0,b(d),0,1,0,1,0],a4L=[0,b(d),0,1,0,1,0],a4M=[0,b(d),0,1,0,1,0],a3H=[0,b(K),Cw,5,Cw,61,[0,b(g9),[0,b(bB),[0,b(J),0]]]],a3E=b(FJ),a3F=b(uN),a3G=b(zA),a3I=[0,b(d),0,1,0,1,0],a3C=[0,b(N),zX,5,zX,61,[0,b(g9),[0,b(aW),[0,b(M),0]]]],a3z=b(Hj),a3A=b(DN),a3B=b(vr),a3D=[0,b(d),0,1,0,1,0],a3x=[0,b(N),xF,5,xF,61,[0,b(g9),[0,b(a3),[0,b(M),0]]]],a3u=b(y5),a3v=b(uW),a3w=b(G0),a3y=[0,b(d),0,1,0,1,0],a3J=[0,b(d),0,1,0,1,0],a3K=[0,b(d),0,1,0,1,0],a3r=[0,b(K),uz,14,uz,37,[0,b(g9),[0,b(bB),[0,b(J),0]]]],a3o=b("27765"),a3p=b("24198"),a3q=b("22680"),a3s=[0,b(d),0,1,0,1,0],a3m=[0,b(N),Ff,14,Ff,37,[0,b(g9),[0,b(aW),[0,b(M),0]]]],a3j=b("26826"),a3k=b("23380"),a3l=b("21913"),a3n=[0,b(d),0,1,0,1,0],a3h=[0,b(N),CC,14,CC,37,[0,b(g9),[0,b(a3),[0,b(M),0]]]],a3e=b(I0),a3f=b("23282"),a3g=b("21821"),a3i=[0,b(d),0,1,0,1,0],a3t=[0,b(d),0,1,0,1,0],a3L=[0,b(d),0,1,0,1,0],a3a=b(r),a3b=[0,b(K),Gy,5,qP,34,[0,b(bW),[0,b(bB),[0,b(J),0]]]],a29=b("30850"),a2_=b(z$),a2$=b("25200"),a3c=[0,b(d),0,1,0,1,0],a26=b(r),a27=[0,b(K),f1,5,lM,34,[0,b(bW),[0,b(bB),[0,b(J),0]]]],a23=b("37207"),a24=b(Df),a25=b("30548"),a28=[0,b(d),0,1,0,1,0],a20=b(y),a21=[0,b(K),mn,5,mn,35,[0,b(bW),[0,b(bB),[0,b(J),0]]]],a2U=b("6101"),a2V=b("42052"),a2W=b(vc),a2X=b(HI),a2Y=b("4909"),a2Z=b("34252"),a22=[0,b(d),0,1,0,1,0],a2R=b(r),a2S=[0,b(N),1016,5,D7,34,[0,b(bW),[0,b(aW),[0,b(M),0]]]],a2O=b("29807"),a2P=b(Ie),a2Q=b("24348"),a2T=[0,b(d),0,1,0,1,0],a2L=b(r),a2M=[0,b(N),fQ,5,rG,34,[0,b(bW),[0,b(aW),[0,b(M),0]]]],a2I=b("35949"),a2J=b(po),a2K=b("29515"),a2N=[0,b(d),0,1,0,1,0],a2F=b(y),a2G=[0,b(N),gE,5,gE,35,[0,b(bW),[0,b(aW),[0,b(M),0]]]],a2z=b("5895"),a2A=b("40630"),a2B=b(yO),a2C=b(H4),a2D=b("4743"),a2E=b("33094"),a2H=[0,b(d),0,1,0,1,0],a2w=b(r),a2x=[0,b(N),2119,5,2120,34,[0,b(bW),[0,b(a3),[0,b(M),0]]]],a2t=b("29682"),a2u=b("25859"),a2v=b("24246"),a2y=[0,b(d),0,1,0,1,0],a2q=b(r),a2r=[0,b(N),2129,5,2130,34,[0,b(bW),[0,b(a3),[0,b(M),0]]]],a2n=b("35799"),a2o=b(x6),a2p=b("29392"),a2s=[0,b(d),0,1,0,1,0],a2k=b(y),a2l=[0,b(N),CW,5,CW,35,[0,b(bW),[0,b(a3),[0,b(M),0]]]],a2e=b("5870"),a2f=b("40460"),a2g=b(Cz),a2h=b(Ft),a2i=b("4723"),a2j=b(Ei),a2m=[0,b(d),0,1,0,1,0],a3d=[0,b(d),0,1,0,1,0],a19=[0,b(K),gN,14,gN,29,[0,b(ce),[0,b(bB),[0,b(J),0]]]],a14=b(r),a15=b(z$),a16=b(Df),a17=b(vc),a18=b(HI),a1_=[0,b(d),0,1,0,1,0],a12=[0,b(N),Dh,14,Dh,29,[0,b(ce),[0,b(aW),[0,b(M),0]]]],a1X=b(r),a1Y=b(Ie),a1Z=b(po),a10=b(yO),a11=b(H4),a13=[0,b(d),0,1,0,1,0],a1V=[0,b(N),Cs,14,Cs,29,[0,b(ce),[0,b(a3),[0,b(M),0]]]],a1Q=b(r),a1R=b("25869"),a1S=b(x6),a1T=b(Cz),a1U=b(Ft),a1W=[0,b(d),0,1,0,1,0],a1$=[0,b(d),0,1,0,1,0],a1H=[0,b(N),yx,5,yx,33,[0,b(mr),[0,b("Articles en vigueur \xc3\xa0 partir du 01 janvier 2021 - Arr\xc3\xaat\xc3\xa9 du 31 d\xc3\xa9cembre 2020 relatif au calcul des aides personnelles au logement pour l'ann\xc3\xa9e 2021 NOR : LOGL2028351A"),[0,b(M),0]]]],a1t=b(r),a1u=b("427400"),a1v=b("612200"),a1w=b(y),a1x=b("699000"),a1y=b(T),a1z=b("743200"),a1A=b(Z),a1B=b("785400"),a1C=b(_),a1D=b("828300"),a1E=b(I),a1F=b("871100"),a1G=b("913900"),a1I=[0,b(d),0,1,0,1,0],a1r=[0,b(N),vC,5,vC,33,[0,b(mr),[0,b(cG),[0,b(M),0]]]],a1d=b(r),a1e=b("396000"),a1f=b("567300"),a1g=b(y),a1h=b("639600"),a1i=b(T),a1j=b("684900"),a1k=b(Z),a1l=b("738600"),a1m=b(_),a1n=b("793500"),a1o=b(I),a1p=b("848400"),a1q=b("903200"),a1s=[0,b(d),0,1,0,1,0],a1J=[0,b(d),0,1,0,1,0],a1K=[0,b(d),0,1,0,1,0],a0_=b(y),a0$=[0,b(N),2974,5,2982,34,[0,b(ap),[0,b(a3),[0,b(M),0]]]],a09=b(qb),a1a=[0,b(d),0,1,0,1,0],a07=b(y),a08=[0,b(N),1884,5,1892,34,[0,b(ap),[0,b(aW),[0,b(M),0]]]],a06=b(qb),a1b=[0,b(d),0,1,0,1,0],a1c=[0,b(d),0,1,0,1,0],a1L=[0,b(d),0,1,0,1,0],a01=b(y),a02=[0,b(K),4343,5,4351,34,[0,b(ap),[0,b(fs),[0,b(J),0]]]],a00=b("818100"),a03=[0,b(d),0,1,0,1,0],a0Y=[0,b(K),4613,5,4615,28,[0,b(mr),[0,b(fs),[0,b(J),0]]]],a0G=b(r),a0H=b("527200"),a0I=b("755200"),a0J=b(y),a0K=b("900800"),a0L=b(T),a0M=b("921100"),a0N=b(Z),a0O=b("956300"),a0P=b(_),a0Q=b("991900"),a0R=b(I),a0S=b("1027100"),a0T=b(aD),a0U=b(DY),a0V=b(aD),a0W=b(uy),a0X=b(DY),a0Z=[0,b(d),0,1,0,1,0],a0D=b(y),a0E=[0,b(N),pw,5,p5,34,[0,b(ap),[0,b(cL),[0,b(M),0]]]],a0C=b("805100"),a0F=[0,b(d),0,1,0,1,0],a0A=[0,b(N),rz,5,480,28,[0,b(mr),[0,b(cL),[0,b(M),0]]]],a0i=b(r),a0j=b(xu),a0k=b(za),a0l=b(y),a0m=b(pN),a0n=b(T),a0o=b(wZ),a0p=b(Z),a0q=b(zi),a0r=b(_),a0s=b(DA),a0t=b(I),a0u=b(BJ),a0v=b(aD),a0w=b(k8),a0x=b(aD),a0y=b(uy),a0z=b(k8),a0B=[0,b(d),0,1,0,1,0],a0f=b(y),a0g=[0,b(N),746,5,rk,34,[0,b(ap),[0,b(cT),[0,b(M),0]]]],a0e=b("774200"),a0h=[0,b(d),0,1,0,1,0],a0b=b(y),a0c=[0,b(N),3535,5,3543,34,[0,b(ap),[0,b(cG),[0,b(M),0]]]],a0a=b(qb),a0d=[0,b(d),0,1,0,1,0],a04=[0,b(d),0,1,0,1,0],a05=[0,b(d),0,1,0,1,0],aZ9=[0,b(K),e$,14,e$,44,[0,b(fb),[0,b(bB),[0,b(J),0]]]],aZS=b(r),aZT=b("494900"),aZU=b("709000"),aZV=b(y),aZW=b("845600"),aZX=b(T),aZY=b("864600"),aZZ=b(Z),aZ0=b("897700"),aZ1=b(_),aZ2=b("931100"),aZ3=b(I),aZ4=b("964200"),aZ5=b(aD),aZ6=b(GE),aZ7=b("32800"),aZ8=b(GE),aZ_=[0,b(d),0,1,0,1,0],aZQ=[0,b(N),39,14,39,44,[0,b(fb),[0,b(cL),[0,b(M),0]]]],aZz=b(r),aZA=b(xu),aZB=b(za),aZC=b(y),aZD=b(pN),aZE=b(T),aZF=b(wZ),aZG=b(Z),aZH=b(zi),aZI=b(_),aZJ=b(DA),aZK=b(I),aZL=b(BJ),aZM=b(aD),aZN=b(k8),aZO=b("32300"),aZP=b(k8),aZR=[0,b(d),0,1,0,1,0],aZx=[0,b(N),nw,14,nw,44,[0,b(fb),[0,b(cT),[0,b(M),0]]]],aZg=b(r),aZh=b("468300"),aZi=b("670900"),aZj=b(y),aZk=b("800200"),aZl=b(T),aZm=b("819200"),aZn=b(Z),aZo=b("849500"),aZp=b(_),aZq=b("881100"),aZr=b(I),aZs=b("912400"),aZt=b(aD),aZu=b(xX),aZv=b("31100"),aZw=b(xX),aZy=[0,b(d),0,1,0,1,0],aZe=[0,b(N),Bl,14,Bl,44,[0,b(fb),[0,b(cG),[0,b(M),0]]]],aYY=b(r),aYZ=b("458800"),aY0=b("657200"),aY1=b(y),aY2=b("783900"),aY3=b(T),aY4=b("801500"),aY5=b(Z),aY6=b(pN),aY7=b(_),aY8=b("863100"),aY9=b(I),aY_=b("893800"),aY$=b(aD),aZa=b(BW),aZb=b(aD),aZc=b(lf),aZd=b(BW),aZf=[0,b(d),0,1,0,1,0],aZ$=[0,b(d),0,1,0,1,0],aYO=[0,b(K),4443,5,4451,15,[0,b(ap),[0,b(fs),[0,b(J),0]]]],aYL=b(cZ),aYM=b(gO),aYN=b(cY),aYP=[0,b(d),0,1,0,1,0],aYJ=[0,b(N),333,6,pf,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],aYC=b(cZ),aYD=b(gO),aYI=b(cY),aYE=b(bf),aYF=b(cZ),aYG=b(gO),aYH=b(cY),aYK=[0,b(d),0,1,0,1,0],aYz=[0,b(N),1986,6,1993,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],aYs=b(ci),aYt=b(fi),aYy=b(cg),aYu=b(bf),aYv=b(ci),aYw=b(fi),aYx=b(cg),aYA=[0,b(d),0,1,0,1,0],aYr=[0,b(N),Gi,6,857,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],aYk=b(ci),aYl=b(fi),aYq=b(cg),aYm=b(bf),aYn=b(ci),aYo=b(fi),aYp=b(cg),aYB=[0,b(d),0,1,0,1,0],aYi=[0,b(N),3078,6,3085,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],aYb=b(ea),aYc=b(kn),aYh=b(eb),aYd=b(bf),aYe=b(ea),aYf=b(kn),aYg=b(eb),aYj=[0,b(d),0,1,0,1,0],aX$=[0,b(N),3638,6,3645,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],aX4=b(eo),aX5=b(mE),aX_=b(ei),aX6=b(bf),aX7=b(eo),aX8=b(mE),aX9=b(ei),aYa=[0,b(d),0,1,0,1,0],aYQ=[0,b(d),0,1,0,1,0],aYR=[0,b(d),0,1,0,1,0],aX1=[0,b(K),g2,14,g2,49,[0,b(c_),[0,b(bB),[0,b(J),0]]]],aXY=b(fW),aXZ=b(qv),aX0=b(eP),aX2=[0,b(d),0,1,0,1,0],aXW=[0,b(N),qF,14,qF,49,[0,b(c_),[0,b(aW),[0,b(M),0]]]],aXT=b(fT),aXU=b(o5),aXV=b(eH),aXX=[0,b(d),0,1,0,1,0],aXR=[0,b(N),Gu,14,Gu,49,[0,b(c_),[0,b(a3),[0,b(M),0]]]],aXO=b(fU),aXP=b(pO),aXQ=b(eG),aXS=[0,b(d),0,1,0,1,0],aX3=[0,b(d),0,1,0,1,0],aYS=[0,b(d),0,1,0,1,0],aXL=[0,b(K),4380,6,4387,28,[0,b(ap),[0,b(fs),[0,b(J),0]]]],aXJ=b(cZ),aXK=b(cY),aXM=[0,b(d),0,1,0,1,0],aXH=[0,b(N),258,6,265,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],aXC=b(cZ),aXD=b(cY),aXE=b(bf),aXF=b(cZ),aXG=b(cY),aXI=[0,b(d),0,1,0,1,0],aXz=[0,b(N),1912,6,1919,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],aXu=b(ci),aXv=b(cg),aXw=b(bf),aXx=b(ci),aXy=b(cg),aXA=[0,b(d),0,1,0,1,0],aXt=[0,b(N),Bq,6,pB,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],aXo=b(ci),aXp=b(cg),aXq=b(bf),aXr=b(ci),aXs=b(cg),aXB=[0,b(d),0,1,0,1,0],aXm=[0,b(N),3004,6,3011,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],aXh=b(ea),aXi=b(eb),aXj=b(bf),aXk=b(ea),aXl=b(eb),aXn=[0,b(d),0,1,0,1,0],aXf=[0,b(N),pe,6,3571,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],aXa=b(eo),aXb=b(ei),aXc=b(bf),aXd=b(eo),aXe=b(ei),aXg=[0,b(d),0,1,0,1,0],aXN=[0,b(d),0,1,0,1,0],aYT=[0,b(d),0,1,0,1,0],aW9=[0,b(K),Gh,14,Gh,49,[0,b(hi),[0,b(bB),[0,b(J),0]]]],aW7=b(fW),aW8=b(eP),aW_=[0,b(d),0,1,0,1,0],aW5=[0,b(N),ky,14,ky,49,[0,b(hi),[0,b(aW),[0,b(M),0]]]],aW3=b(fT),aW4=b(eH),aW6=[0,b(d),0,1,0,1,0],aW1=[0,b(N),Ba,14,Ba,49,[0,b(hi),[0,b(a3),[0,b(M),0]]]],aWZ=b(fU),aW0=b(eG),aW2=[0,b(d),0,1,0,1,0],aW$=[0,b(d),0,1,0,1,0],aWJ=b(aD),aWK=[0,b(N),3385,5,3393,35,[0,b(ap),[0,b(cG),[0,b(M),0]]]],aWI=b(el),aWL=[0,b(d),0,1,0,1,0],aWG=b(aD),aWH=[0,b(N),2825,5,2833,35,[0,b(ap),[0,b(a3),[0,b(M),0]]]],aWF=b(el),aWM=[0,b(d),0,1,0,1,0],aWD=b(aD),aWE=[0,b(N),1735,5,1743,35,[0,b(ap),[0,b(aW),[0,b(M),0]]]],aWC=b(el),aWN=[0,b(d),0,1,0,1,0],aWA=b(aD),aWB=[0,b(N),596,5,604,35,[0,b(ap),[0,b(cT),[0,b(M),0]]]],aWz=b(el),aWO=[0,b(d),0,1,0,1,0],aWx=b(aD),aWy=[0,b(N),82,5,90,35,[0,b(ap),[0,b(cL),[0,b(M),0]]]],aWw=b(el),aWP=[0,b(d),0,1,0,1,0],aWQ=[0,b(d),0,1,0,1,0],aWR=[0,b(d),0,1,0,1,0],aWp=[0,b(N),IL,14,IL,63,[0,b(c_),[0,b(a3),[0,b(M),0]]]],aWo=b(y),aWq=[0,b(d),0,1,0,1,0],aWn=[0,b(N),IZ,14,IZ,63,[0,b(bW),[0,b(a3),[0,b(M),0]]]],aWm=b(y),aWr=[0,b(d),0,1,0,1,0],aWl=[0,b(N),zU,14,zU,63,[0,b(c_),[0,b(aW),[0,b(M),0]]]],aWk=b(y),aWs=[0,b(d),0,1,0,1,0],aWj=[0,b(N),Ai,14,Ai,63,[0,b(bW),[0,b(aW),[0,b(M),0]]]],aWi=b(y),aWt=[0,b(d),0,1,0,1,0],aWh=[0,b(K),dc,14,dc,63,[0,b(bW),[0,b(bB),[0,b(J),0]]]],aWg=b(y),aWu=[0,b(d),0,1,0,1,0],aWv=[0,b(d),0,1,0,1,0],aV5=b(aD),aV6=[0,b(N),3469,5,3477,35,[0,b(ap),[0,b(cG),[0,b(M),0]]]],aV4=b(el),aV7=[0,b(d),0,1,0,1,0],aV2=b(aD),aV3=[0,b(N),2909,5,2917,35,[0,b(ap),[0,b(a3),[0,b(M),0]]]],aV1=b(el),aV8=[0,b(d),0,1,0,1,0],aVZ=b(aD),aV0=[0,b(N),1818,5,1826,35,[0,b(ap),[0,b(aW),[0,b(M),0]]]],aVY=b(el),aV9=[0,b(d),0,1,0,1,0],aVW=b(aD),aVX=[0,b(N),iF,5,688,35,[0,b(ap),[0,b(cT),[0,b(M),0]]]],aVV=b(el),aV_=[0,b(d),0,1,0,1,0],aVT=b(aD),aVU=[0,b(N),F6,5,rx,35,[0,b(ap),[0,b(cL),[0,b(M),0]]]],aVS=b(el),aV$=[0,b(d),0,1,0,1,0],aWa=[0,b(d),0,1,0,1,0],aWb=[0,b(d),0,1,0,1,0],aVN=[0,b(N),nz,14,nz,55,[0,b(ce),[0,b(a3),[0,b(M),0]]]],aVM=b(y),aVO=[0,b(d),0,1,0,1,0],aVL=[0,b(N),kU,14,kU,55,[0,b(ce),[0,b(aW),[0,b(M),0]]]],aVK=b(y),aVP=[0,b(d),0,1,0,1,0],aVJ=[0,b(K),fM,14,fM,55,[0,b(ce),[0,b(bB),[0,b(J),0]]]],aVI=b(y),aVQ=[0,b(d),0,1,0,1,0],aVR=[0,b(d),0,1,0,1,0],aVv=b(aD),aVw=[0,b(N),3491,5,3499,35,[0,b(ap),[0,b(cG),[0,b(M),0]]]],aVu=b(by),aVx=[0,b(d),0,1,0,1,0],aVs=b(aD),aVt=[0,b(N),2930,5,2938,35,[0,b(ap),[0,b(a3),[0,b(M),0]]]],aVr=b(by),aVy=[0,b(d),0,1,0,1,0],aVp=b(aD),aVq=[0,b(N),1839,5,1847,35,[0,b(ap),[0,b(aW),[0,b(M),0]]]],aVo=b(by),aVz=[0,b(d),0,1,0,1,0],aVm=b(aD),aVn=[0,b(N),702,5,Hu,35,[0,b(ap),[0,b(cT),[0,b(M),0]]]],aVl=b(by),aVA=[0,b(d),0,1,0,1,0],aVj=b(aD),aVk=[0,b(N),187,5,kX,35,[0,b(ap),[0,b(cL),[0,b(M),0]]]],aVi=b(by),aVB=[0,b(d),0,1,0,1,0],aVC=[0,b(d),0,1,0,1,0],aVD=[0,b(d),0,1,0,1,0],aVc=[0,b(N),we,14,we,42,[0,b(fb),[0,b(cG),[0,b(M),0]]]],aVb=b(aD),aVd=[0,b(d),0,1,0,1,0],aVa=[0,b(N),iK,14,iK,42,[0,b(fb),[0,b(cT),[0,b(M),0]]]],aU$=b(aD),aVe=[0,b(d),0,1,0,1,0],aU_=[0,b(N),35,14,35,42,[0,b(fb),[0,b(cL),[0,b(M),0]]]],aU9=b(aD),aVf=[0,b(d),0,1,0,1,0],aU8=[0,b(K),kw,14,kw,42,[0,b(fb),[0,b(bB),[0,b(J),0]]]],aU7=b(aD),aVg=[0,b(d),0,1,0,1,0],aVh=[0,b(d),0,1,0,1,0],aUZ=[0,b(K),4522,6,4529,28,[0,b(ap),[0,b(fs),[0,b(J),0]]]],aUF=b(r),aUG=b(gT),aUH=b(g3),aUI=b(y),aUJ=b(eT),aUK=b(T),aUL=b(gv),aUM=b(Z),aUN=b(hd),aUO=b(_),aUP=b(hb),aUQ=b(I),aUR=b(gw),aUS=b(aD),aUT=b(gZ),aUU=b(HH),aUV=b(ys),aUW=b(HH),aUX=b(kt),aUY=b(ys),aU0=[0,b(d),0,1,0,1,0],aUz=[0,b(N),3710,6,3717,28,[0,b(ap),[0,b(cG),[0,b(M),0]]]],aUl=b(r),aUm=b(gT),aUn=b(g3),aUo=b(y),aUp=b(eT),aUq=b(T),aUr=b(gv),aUs=b(Z),aUt=b(hd),aUu=b(_),aUv=b(hb),aUw=b(I),aUx=b(gw),aUy=b(gZ),aUA=[0,b(d),0,1,0,1,0],aUk=[0,b(N),3149,6,3156,28,[0,b(ap),[0,b(a3),[0,b(M),0]]]],aT8=b(r),aT9=b(gT),aT_=b(g3),aT$=b(y),aUa=b(eT),aUb=b(T),aUc=b(gv),aUd=b(Z),aUe=b(hd),aUf=b(_),aUg=b(hb),aUh=b(I),aUi=b(gw),aUj=b(gZ),aUB=[0,b(d),0,1,0,1,0],aT7=[0,b(N),qK,6,2063,28,[0,b(ap),[0,b(aW),[0,b(M),0]]]],aTT=b(r),aTU=b(gT),aTV=b(g3),aTW=b(y),aTX=b(eT),aTY=b(T),aTZ=b(gv),aT0=b(Z),aT1=b(hd),aT2=b(_),aT3=b(hb),aT4=b(I),aT5=b(gw),aT6=b(gZ),aUC=[0,b(d),0,1,0,1,0],aTS=[0,b(N),qW,6,928,28,[0,b(ap),[0,b(cT),[0,b(M),0]]]],aTE=b(r),aTF=b(gT),aTG=b(g3),aTH=b(y),aTI=b(eT),aTJ=b(T),aTK=b(gv),aTL=b(Z),aTM=b(hd),aTN=b(_),aTO=b(hb),aTP=b(I),aTQ=b(gw),aTR=b(gZ),aUD=[0,b(d),0,1,0,1,0],aTD=[0,b(N),404,6,411,28,[0,b(ap),[0,b(cL),[0,b(M),0]]]],aTp=b(r),aTq=b(gT),aTr=b(g3),aTs=b(y),aTt=b(eT),aTu=b(T),aTv=b(gv),aTw=b(Z),aTx=b(hd),aTy=b(_),aTz=b(hb),aTA=b(I),aTB=b(gw),aTC=b(gZ),aUE=[0,b(d),0,1,0,1,0],aU1=[0,b(d),0,1,0,1,0],aU2=[0,b(d),0,1,0,1,0],aTk=[0,b(N),u$,29,u$,55,[0,b(ce),[0,b(a3),[0,b(M),0]]]],aS4=b(r),aS5=b(qV),aS6=b(pD),aS7=b(y),aS8=b(qm),aS9=b(T),aS_=b(eT),aS$=b(Z),aTa=b(ro),aTb=b(_),aTc=b(qj),aTd=b(I),aTe=b(qJ),aTf=b(aD),aTg=b(gs),aTh=b(aD),aTi=b(kt),aTj=b(gs),aTl=[0,b(d),0,1,0,1,0],aS3=[0,b(N),vw,29,vw,55,[0,b(ce),[0,b(aW),[0,b(M),0]]]],aSL=b(r),aSM=b(qV),aSN=b(pD),aSO=b(y),aSP=b(qm),aSQ=b(T),aSR=b(eT),aSS=b(Z),aST=b(ro),aSU=b(_),aSV=b(qj),aSW=b(I),aSX=b(qJ),aSY=b(aD),aSZ=b(gs),aS0=b(aD),aS1=b(kt),aS2=b(gs),aTm=[0,b(d),0,1,0,1,0],aSK=[0,b(K),ui,29,ui,55,[0,b(ce),[0,b(bB),[0,b(J),0]]]],aSs=b(r),aSt=b(qV),aSu=b(pD),aSv=b(y),aSw=b(qm),aSx=b(T),aSy=b(eT),aSz=b(Z),aSA=b(ro),aSB=b(_),aSC=b(qj),aSD=b(I),aSE=b(qJ),aSF=b(aD),aSG=b(gs),aSH=b(aD),aSI=b(kt),aSJ=b(gs),aTn=[0,b(d),0,1,0,1,0],aTo=[0,b(d),0,1,0,1,0],aSl=[0,b(o),io,14,io,41,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aSg=[0,b(o),mR,14,mR,50,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aSb=[0,b(z),GI,14,GI,29,[0,b("Article D842-2"),[0,b(bo),[0,b(ab),[0,b($),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aR$=b(m$),aSa=b(iX),aR5=[0,b(K),Ev,14,Ev,42,[0,b("Article 12"),[0,b(bB),[0,b(J),0]]]],aR2=b(r),aR3=b(g6),aR4=b(g6),aRT=[0,b(N),FR,14,FR,55,[0,b(hi),[0,b(a3),[0,b(M),0]]]],aRU=[0,b(d),0,1,0,1,0],aRS=[0,b(N),xr,14,xr,55,[0,b(hi),[0,b(aW),[0,b(M),0]]]],aRV=[0,b(d),0,1,0,1,0],aRR=[0,b(K),p5,14,p5,55,[0,b(hi),[0,b(bB),[0,b(J),0]]]],aRW=[0,b(d),0,1,0,1,0],aRX=[0,b(d),0,1,0,1,0],aRK=[0,b(K),ia,14,ia,41,[0,b("Article 11"),[0,b(bB),[0,b(J),0]]]],aRJ=b(h_),aRD=[0,b(z),BA,14,BA,29,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],aRC=b(C9),aRE=[0,b(d),0,1,0,1,0],aRB=[0,b(o),Cm,11,Cm,26,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aRF=[0,0,0],aRG=[0,b(au),[0,b("fraction_l832_3"),0]],aRH=[0,b(o),g2,13,g2,42,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a8n=[0,b(o),g2,13,g2,42,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aRL=[0,b(d),0,1,0,1,0],aRI=[0,b(o),x7,11,x7,38,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aRM=[0,0,0],aRN=[0,b(au),[0,b("montant_forfaitaire_d823_16"),0]],aRP=b(r),aRO=[0,b(o),kE,13,kE,43,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a8m=[0,b(o),kE,13,kE,43,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aRY=[0,b(d),0,1,0,1,0],aRQ=[0,b(o),xc,11,xc,52,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aRZ=[0,0,0],aR0=[0,b(au),[0,b("multiplicateur_majoration_charges_d823_16"),0]],aR6=[0,b(d),0,1,0,1,0],aR1=[0,b(o),CQ,11,CQ,39,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aR7=[0,0,0],aR8=[0,b(au),[0,b("montant_minimal_aide_d823_16"),0]],aR9=[0,b(o),nx,13,nx,53,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a8l=[0,b(o),nx,13,nx,53,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aSc=[0,b(d),0,1,0,1,0],aR_=[0,b(o),wd,10,wd,31,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aSd=[0,0,0],aSe=[0,b(au),[0,b("loyer_principal_avec_r\xc3\xa9duction_meubl\xc3\xa9"),0]],aSh=[0,b(d),0,1,0,1,0],aSi=[0,1,0],aSj=[0,b(au),[0,b(ig),0]],aSf=[0,b(o),mR,14,mR,50,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aSm=[0,b(d),0,1,0,1,0],aSn=[0,1,0],aSo=[0,b(au),[0,b(h3),0]],aSk=[0,b(o),io,14,io,41,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aSp=[0,b(au),[0,b(ed),[0,b(bm),0]]],aSq=[0,b(au),[0,b(ed),[0,b(bm),0]]],aU3=[0,b(d),0,1,0,1,0],aSr=[0,b(o),xt,12,xt,38,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aU4=[0,0,1],aU5=[0,b(au),[0,b(nh),0]],aVE=[0,b(d),0,1,0,1,0],aU6=[0,b(o),py,11,py,39,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aVF=[0,0,0],aVG=[0,b(au),[0,b("multiplicateur_majoration_r0"),0]],aWc=[0,b(d),0,1,0,1,0],aVH=[0,b(o),Cu,11,Cu,52,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aWd=[0,0,0],aWe=[0,b(au),[0,b("multiplicateur_majoration_loyer_r\xc3\xa9f\xc3\xa9rence"),0]],aWS=[0,b(d),0,1,0,1,0],aWf=[0,b(o),Es,11,Es,60,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aWT=[0,0,0],aWU=[0,b(au),[0,b("multiplicateur_majoration_plafond_loyer_d823_16_2"),0]],aWW=b(C9),aWX=b(ln),aWV=[0,b(al),gr,13,gr,61,[0,b(pg),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],a8k=[0,b(al),gr,13,gr,61,[0,b(pg),[0,b(bj),[0,b(ah),[0,b(w),[0,b(X),[0,b(v),0]]]]]]],aYU=[0,b(d),0,1,0,1,0],aWY=[0,b(o),Ac,12,Ac,47,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],aYV=[0,0,1],aYW=[0,b(au),[0,b(km),0]],a1M=[0,b(d),0,1,0,1,0],aYX=[0,b(o),Ij,11,Ij,41,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a1N=[0,0,0],a1O=[0,b(au),[0,b("abattement_forfaitaire_d823_17"),0]],a2a=[0,b(d),0,1,0,1,0],a1P=[0,b(o),w$,11,w$,26,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a2b=[0,0,0],a2c=[0,b(au),[0,b("loyer_r\xc3\xa9f\xc3\xa9rence"),0]],a4N=[0,b(d),0,1,0,1,0],a2d=[0,b(o),A9,12,A9,35,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a4O=[0,0,1],a4P=[0,b(au),[0,b(m2),0]],a4V=[0,b(d),0,1,0,1,0],a4Q=[0,b(o),iK,11,iK,38,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a4W=[0,0,0],a4X=[0,b(au),[0,b("plafond_suppression_d823_16"),0]],a43=[0,b(d),0,1,0,1,0],a4Y=[0,b(o),qY,11,qY,39,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a44=[0,0,0],a45=[0,b(au),[0,b("plafond_d\xc3\xa9gressivit\xc3\xa9_d823_16"),0]],a48=[0,b(d),0,1,0,1,0],a46=[0,b(o),A8,11,A8,25,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a49=[0,0,0],a4_=[0,b(au),[0,b("loyer_\xc3\xa9ligible"),0]],a5a=b(gz),a4$=[0,b(z),hg,13,hg,74,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a8j=[0,b(z),hg,13,hg,74,[0,b(ek),[0,b(c$),[0,b(be),[0,b(a5),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],a5h=[0,0,0],a5i=[0,b(au),[0,b(iH),0]],a5D=[0,b(d),0,1,0,1,0],a5j=[0,b(o),vB,12,vB,34,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a5E=[0,0,1],a5F=[0,b(au),[0,b(lr),0]],a5U=[0,b(d),0,1,0,1,0],a5G=[0,b(o),Gt,11,Gt,25,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a5V=[0,0,0],a5W=[0,b(au),[0,b("rapport_loyers"),0]],a58=[0,0,0],a59=[0,b(au),[0,b(bF),0]],a6Q=[0,b(d),0,1,0,1,0],a5_=[0,b(o),BT,10,BT,17,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a6R=[0,0,0],a6S=[0,b(au),[0,b("taux_loyer_\xc3\xa9ligible_formule"),0]],a6$=[0,0,0],a7a=[0,b(au),[0,b(bG),0]],a7p=[0,b(d),0,1,0,1,0],a7b=[0,b(o),B3,10,B3,22,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a7q=[0,0,0],a7r=[0,b(au),[0,b("taux_loyer_\xc3\xa9ligible_taux_arrondi"),0]],a7D=[0,0,0],a7E=[0,b(au),[0,b(iC),0]],a7H=[0,b(d),0,1,0,1,0],a7F=[0,b(o),nw,11,nw,39,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a7I=[0,0,0],a7J=[0,b(au),[0,b("taux_prise_compte_ressources"),0]],a7T=[0,0,0],a7U=[0,b(au),[0,b(cW),0]],a7Z=[0,b(d),0,1,0,1,0],a7V=[0,b(o),It,12,It,37,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a70=[0,0,1],a71=[0,b(au),[0,b(k0),0]],a8a=[0,0,1],a8b=[0,b(au),[0,b(eW),0]],a8g=[0,b(d),0,1,0,1,0],a8c=[0,b(o),Gr,12,Gr,31,[0,b(aQ),[0,b(S),[0,b(B),[0,b(p),0]]]]],a8h=[0,0,1],a8i=[0,b(au),[0,b(cO),0]],aRm=[0,1,0],aRn=[0,b(d0),[0,b(a9),[0,b(dM),0]]],aRo=[0,b(d0),[0,b(a9),0]],aRp=[0,b(h6),65,6,68,44,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],aRq=[0,0,1],aRr=[0,b(d0),[0,b(a9),[0,b(Y),0]]],aRs=[0,b(d0),[0,b(a9),0]],aRt=[0,b(h6),63,5,68,59,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],aRu=[0,b(d),0,1,0,1,0],aRl=[0,b(h6),52,5,53,50,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],aRv=[0,b(d),0,1,0,1,0],aRw=[0,b(d),0,1,0,1,0],aRx=[0,b(d),0,1,0,1,0],aRk=[0,b(dJ),27,12,27,24,[0,b(dP),0]],aRy=[0,b(d),0,1,0,1,0],aRj=[0,b(dJ),27,12,27,24,[0,b(dP),0]],aRe=[0,b(h6),74,5,78,24,[0,b(e_),[0,b(fl),[0,b(dN),[0,b(ax),[0,b(X),[0,b(ae),0]]]]]]],aRf=[0,b(d),0,1,0,1,0],aRd=[0,b(dJ),29,12,29,31,[0,b(dP),0]],aRg=[0,b(d),0,1,0,1,0],aRc=[0,b(dJ),29,12,29,31,[0,b(dP),0]],aQ9=[0,b(qC),62,18,62,41,[0,b(vW),[0,b(ep),[0,b(f0),[0,b(dF),[0,b(cV),[0,b(ae),0]]]]]]],aQ7=b(nm),aQ8=b(mX),aQ_=[0,b(d),0,1,0,1,0],aQ6=[0,b(qC),31,14,31,30,[0,b(lI),[0,b(kS),[0,b(dN),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],aQ4=b(nm),aQ5=b(mX),aQS=[5,0],aQT=[4,0],aQU=[3,0],aQV=[2,0],aQW=[1,0],aQX=[0,0],aQY=[0,b(h6),d1,5,dc,30,[0,b(GH),[0,b(DZ),[0,b(iA),[0,b(dF),[0,b(X),[0,b(ae),0]]]]]]],aQZ=[0,b(d),0,1,0,1,0],aQR=[0,b(dJ),31,12,31,35,[0,b(dP),0]],aQK=[0,b(dJ),36,14,36,28,[0,b(dP),0]],aQF=[0,b(dJ),37,14,37,32,[0,b(dP),0]],aQz=[0,b(qC),21,14,21,26,[0,b(lI),[0,b(kS),[0,b(dN),[0,b(ax),[0,b(cV),[0,b(ae),0]]]]]]],aQA=[0,b(d),0,1,0,1,0],aQB=[0,b(d),0,1,0,1,0],aQy=[0,b(dJ),26,21,26,33,[0,b(dP),0]],aQC=[0,2,1],aQD=[0,b(bn),[0,b(Er),0]],aQG=[0,b(d),0,1,0,1,0],aQH=[0,1,0],aQI=[0,b(bn),[0,b(Ih),0]],aQE=[0,b(dJ),37,14,37,32,[0,b(dP),0]],aQL=[0,b(d),0,1,0,1,0],aQM=[0,1,0],aQN=[0,b(bn),[0,b(Hf),0]],aQJ=[0,b(dJ),36,14,36,28,[0,b(dP),0]],aQO=[0,b(bn),[0,b(fj),[0,b(gU),0]]],aQP=[0,b(bn),[0,b(fj),[0,b(gU),0]]],aQ0=[0,b(d),0,1,0,1,0],aQQ=[0,b(dJ),31,12,31,35,[0,b(dP),0]],aQ1=[0,0,1],aQ2=[0,b(bn),[0,b(uq),0]],aQ$=[0,b(d),0,1,0,1,0],aQ3=[0,b(dJ),24,11,24,27,[0,b(dP),0]],aRa=[0,0,0],aRb=[0,b(bn),[0,b(xl),0]],aRh=[0,0,1],aRi=[0,b(bn),[0,b(gG),0]],aRz=[0,0,1],aRA=[0,b(bn),[0,b(bE),0]],aQt=[0,b(z),Fm,14,Fm,36,[0,b(gF),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aQm=[0,1,0],aQn=[0,b(aj),[0,b(bG),[0,b(ac),0]]],aQo=[0,b(aj),[0,b(bG),0]],aQp=[0,0,1],aQq=[0,b(aj),[0,b(bG),[0,b(Y),0]]],aQr=[0,b(aj),[0,b(bG),0]],aQs=b(r),aQu=[0,b(d),0,1,0,1,0],aQl=[0,b(o),Am,10,Am,25,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aQh=[0,b(z),xe,14,xe,33,[0,b(gF),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aQf=b(r),aQg=b(r),aQa=[0,b(z),HM,14,HM,36,[0,b(gF),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPX=[0,1,0],aPY=[0,b(aj),[0,b(eg),[0,b(ac),0]]],aPZ=[0,b(aj),[0,b(eg),0]],aP0=[0,0,1],aP1=[0,b(aj),[0,b(eg),[0,b(Y),0]]],aP2=[0,b(aj),[0,b(eg),0]],aP3=[0,1,0],aP4=[0,b(bm),[0,b(bO),[0,b(ac),0]]],aP5=[0,b(bm),[0,b(bO),0]],aP6=[0,0,1],aP7=[0,b(bm),[0,b(bO),[0,b(Y),0]]],aP8=[0,b(bm),[0,b(bO),0]],aP9=b(is),aP_=b(r),aP$=b(r),aQb=[0,b(d),0,1,0,1,0],aPW=[0,b(o),wm,10,wm,40,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aPS=[0,b(z),HA,14,HA,49,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPQ=b(gQ),aPR=b(gQ),aPL=[0,b(z),Ce,14,Ce,33,[0,b(gF),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPG=[0,b(z),vK,14,vK,36,[0,b(gF),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPs=[0,1,0],aPt=[0,b(aj),[0,b(bF),[0,b(ac),0]]],aPu=[0,b(aj),[0,b(bF),0]],aPv=[0,0,1],aPw=[0,b(aj),[0,b(bF),[0,b(Y),0]]],aPx=[0,b(aj),[0,b(bF),0]],aPy=[0,1,0],aPz=[0,b(aj),[0,b(i1),[0,b(ac),0]]],aPA=[0,b(aj),[0,b(i1),0]],aPB=[0,0,1],aPC=[0,b(aj),[0,b(i1),[0,b(Y),0]]],aPD=[0,b(aj),[0,b(i1),0]],aPE=b(r),aPF=b(r),aPH=[0,b(d),0,1,0,1,0],aPr=[0,b(o),xj,10,xj,20,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aPn=[0,b(z),wN,14,wN,49,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPk=b(db),aPl=b(db),aPm=b(jW),aPd=[0,b(z),3349,5,3361,77,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPb=b(cH),aPc=b(by),aPe=[0,b(d),0,1,0,1,0],aO$=[0,b(z),E8,5,E8,75,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aPa=[0,b(d),0,1,0,1,0],aPf=[0,b(d),0,1,0,1,0],aO2=[0,b(N),yV,14,yV,42,[0,b(hf),[0,b(a3),[0,b(M),0]]]],aO1=b(cX),aO3=[0,b(d),0,1,0,1,0],aO0=[0,b(N),EY,14,EY,42,[0,b(hf),[0,b(aW),[0,b(M),0]]]],aOZ=b(cX),aO4=[0,b(d),0,1,0,1,0],aOY=[0,b(K),w2,14,w2,42,[0,b(hf),[0,b(aJ),[0,b(J),0]]]],aOX=b(cX),aO5=[0,b(d),0,1,0,1,0],aO6=[0,b(d),0,1,0,1,0],aOS=[0,b(z),Ip,14,Ip,55,[0,b(pQ),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOL=[0,1,0],aOM=[0,b(aj),[0,b(iN),[0,b(ac),0]]],aON=[0,b(aj),[0,b(iN),0]],aOO=[0,0,1],aOP=[0,b(aj),[0,b(iN),[0,b(Y),0]]],aOQ=[0,b(aj),[0,b(iN),0]],aOR=b(r),aOT=[0,b(d),0,1,0,1,0],aOK=[0,b(o),nF,11,nF,52,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aOG=[0,b(z),zM,14,zM,49,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOF=b(gQ),aOy=[0,b(z),m9,14,m9,70,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOt=[0,b(z),k4,14,k4,69,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOo=[0,b(z),kR,14,kR,75,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOj=[0,b(o),mc,14,mc,61,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aOd=[0,b(z),xf,5,xf,44,[0,b(ya),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aN3=[0,1,0],aN4=[0,b(aj),[0,b(dr),[0,b(ac),0]]],aN5=[0,b(aj),[0,b(dr),0]],aN6=[0,0,1],aN7=[0,b(aj),[0,b(dr),[0,b(Y),0]]],aN8=[0,b(aj),[0,b(dr),0]],aN9=[0,1,0],aN_=[0,b(aj),[0,b(dr),[0,b(ac),0]]],aN$=[0,b(aj),[0,b(dr),0]],aOa=[0,0,1],aOb=[0,b(aj),[0,b(dr),[0,b(Y),0]]],aOc=[0,b(aj),[0,b(dr),0]],aOe=[0,b(d),0,1,0,1,0],aN2=[0,b(z),G1,14,G1,42,[0,b(ya),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aNW=[0,1,0],aNX=[0,b(aj),[0,b(dr),[0,b(ac),0]]],aNY=[0,b(aj),[0,b(dr),0]],aNZ=[0,0,1],aN0=[0,b(aj),[0,b(dr),[0,b(Y),0]]],aN1=[0,b(aj),[0,b(dr),0]],aNQ=[0,b(z),yT,5,yT,40,[0,b(pQ),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aNR=[0,b(d),0,1,0,1,0],aNP=[0,b(z),x8,14,x8,44,[0,b(pQ),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aNS=[0,b(d),0,1,0,1,0],aNO=[0,b(o),qL,11,qL,41,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aNK=[0,b(z),o1,14,o1,36,[0,b(gF),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aNI=b(r),aNJ=b(r),aNL=[0,b(d),0,1,0,1,0],aNH=[0,b(o),rk,10,rk,32,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aNC=[0,b(z),IB,5,IB,28,[0,b(zD),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aND=[0,b(d),0,1,0,1,0],aNB=[0,b(z),zK,14,zK,44,[0,b(zD),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aNw=[0,b(z),zm,14,zm,36,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aNp=[0,b(K),qd,5,845,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aNj=b(r),aNk=b("86900"),aNl=b("97100"),aNm=b(y),aNn=b("10200"),aNo=b("107300"),aNq=[0,b(d),0,1,0,1,0],aNg=[0,b(K),1086,5,1090,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aM0=b(r),aM1=b(CY),aM2=b(B$),aM3=b(y),aM4=b(Bo),aM5=b(Eh),aM6=b(r),aM7=b(xH),aM8=b(Af),aM9=b(y),aM_=b(uY),aM$=b(E_),aNa=b(r),aNb=b(Ey),aNc=b(H6),aNd=b(y),aNe=b("34600"),aNf=b(lY),aNh=[0,b(d),0,1,0,1,0],aMY=[0,b(K),1119,5,1123,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aMG=b(r),aMH=b(DV),aMI=b(q6),aMJ=b(y),aMK=b(IX),aML=b(Gn),aMM=b(r),aMN=b(An),aMO=b(qE),aMP=b(y),aMQ=b(lf),aMR=b(xs),aMS=b(r),aMT=b(zQ),aMU=b(AS),aMV=b(y),aMW=b(zx),aMX=b(DE),aMZ=[0,b(d),0,1,0,1,0],aME=[0,b(K),1152,5,1156,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aMm=b(r),aMn=b("198100"),aMo=b("239000"),aMp=b(y),aMq=b("40900"),aMr=b("279900"),aMs=b(r),aMt=b("176800"),aMu=b("212800"),aMv=b(y),aMw=b("36000"),aMx=b("248800"),aMy=b(r),aMz=b("165000"),aMA=b("197900"),aMB=b(y),aMC=b("32900"),aMD=b("230800"),aMF=[0,b(d),0,1,0,1,0],aMk=[0,b(K),1185,5,1189,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aL4=b(r),aL5=b("159500"),aL6=b(vk),aL7=b(y),aL8=b("33000"),aL9=b(D$),aL_=b(r),aL$=b("142200"),aMa=b("171200"),aMb=b(y),aMc=b("29000"),aMd=b("200200"),aMe=b(r),aMf=b("132800"),aMg=b("159300"),aMh=b(y),aMi=b("26500"),aMj=b(wh),aMl=[0,b(d),0,1,0,1,0],aL2=[0,b(K),1218,5,1222,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aLK=b(r),aLL=b("200100"),aLM=b("141400"),aLN=b(y),aLO=b("41300"),aLP=b("182700"),aLQ=b(r),aLR=b("178600"),aLS=b("215000"),aLT=b(y),aLU=b("36400"),aLV=b("251400"),aLW=b(r),aLX=b("166700"),aLY=b(qw),aLZ=b(y),aL0=b("33200"),aL1=b("233100"),aL3=[0,b(d),0,1,0,1,0],aLI=[0,b(K),Fq,5,kM,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aLq=b(r),aLr=b("161100"),aLs=b("194400"),aLt=b(y),aLu=b("33300"),aLv=b("227700"),aLw=b(r),aLx=b("143600"),aLy=b("172900"),aLz=b(y),aLA=b("29300"),aLB=b("202200"),aLC=b(r),aLD=b("134100"),aLE=b("160900"),aLF=b(y),aLG=b("26800"),aLH=b("187700"),aLJ=[0,b(d),0,1,0,1,0],aLo=[0,b(K),1284,5,1288,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aK8=b(r),aK9=b(q6),aK_=b("244300"),aK$=b(y),aLa=b("41800"),aLb=b("286100"),aLc=b(r),aLd=b("180700"),aLe=b("217500"),aLf=b(y),aLg=b("36800"),aLh=b("254300"),aLi=b(r),aLj=b("168700"),aLk=b("202300"),aLl=b(y),aLm=b("33600"),aLn=b("235900"),aLp=[0,b(d),0,1,0,1,0],aK6=[0,b(K),1317,5,1321,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aKO=b(r),aKP=b("30871"),aKQ=b("37243"),aKR=b(y),aKS=b("6372"),aKT=b("43615"),aKU=b(r),aKV=b("27548"),aKW=b("33148"),aKX=b(y),aKY=b("5610"),aKZ=b("38768"),aK0=b(r),aK1=b("25718"),aK2=b("30840"),aK3=b(y),aK4=b("5122"),aK5=b("35962"),aK7=[0,b(d),0,1,0,1,0],aKM=[0,b(K),vf,5,qe,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aKu=b(r),aKv=b(Ds),aKw=b("196700"),aKx=b(y),aKy=b("33700"),aKz=b("230400"),aKA=b(r),aKB=b("145300"),aKC=b("175000"),aKD=b(y),aKE=b("29700"),aKF=b(zj),aKG=b(r),aKH=b("135700"),aKI=b("162800"),aKJ=b(y),aKK=b("27100"),aKL=b("189900"),aKN=[0,b(d),0,1,0,1,0],aKs=[0,b(K),1383,5,qF,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aKa=b(r),aKb=b("24849"),aKc=b("29987"),aKd=b(y),aKe=b("5138"),aKf=b("35125"),aKg=b(r),aKh=b("22151"),aKi=b("26679"),aKj=b(y),aKk=b("4528"),aKl=b("31207"),aKm=b(r),aKn=b("20687"),aKo=b("24818"),aKp=b(y),aKq=b("4131"),aKr=b("28949"),aKt=[0,b(d),0,1,0,1,0],aJ_=[0,b(K),1416,5,q_,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aJS=b(r),aJT=b("31241"),aJU=b("37689"),aJV=b(y),aJW=b("6448"),aJX=b("44137"),aJY=b(r),aJZ=b("27879"),aJ0=b("33556"),aJ1=b(y),aJ2=b("5677"),aJ3=b("39233"),aJ4=b(r),aJ5=b("26027"),aJ6=b("31210"),aJ7=b(y),aJ8=b("5183"),aJ9=b("36393"),aJ$=[0,b(d),0,1,0,1,0],aJQ=[0,b(K),1449,5,1453,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aJy=b(r),aJz=b("25147"),aJA=b("30347"),aJB=b(y),aJC=b("5200"),aJD=b("35547"),aJE=b(r),aJF=b("22417"),aJG=b("26999"),aJH=b(y),aJI=b("4582"),aJJ=b("31581"),aJK=b(r),aJL=b("20935"),aJM=b(Go),aJN=b(y),aJO=b("4181"),aJP=b("29297"),aJR=[0,b(d),0,1,0,1,0],aJw=[0,b(K),1482,5,1486,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aJe=b(r),aJf=b("31616"),aJg=b("38141"),aJh=b(y),aJi=b("6525"),aJj=b("44666"),aJk=b(r),aJl=b("28214"),aJm=b("33959"),aJn=b(y),aJo=b("5745"),aJp=b("39704"),aJq=b(r),aJr=b("26339"),aJs=b("31584"),aJt=b(y),aJu=b("5245"),aJv=b("36829"),aJx=[0,b(d),0,1,0,1,0],aJc=[0,b(K),1515,5,1519,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aIW=b(r),aIX=b("25449"),aIY=b("30711"),aIZ=b(y),aI0=b("5262"),aI1=b("35973"),aI2=b(r),aI3=b("22686"),aI4=b("27323"),aI5=b(y),aI6=b("4637"),aI7=b("31960"),aI8=b(r),aI9=b("21186"),aI_=b("25417"),aI$=b(y),aJa=b("4231"),aJb=b("29648"),aJd=[0,b(d),0,1,0,1,0],aIU=[0,b(K),1548,5,nn,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aIC=b(r),aID=b("32185"),aIE=b("38827"),aIF=b(y),aIG=b("6642"),aIH=b("45469"),aII=b(r),aIJ=b("28722"),aIK=b(DJ),aIL=b(y),aIM=b("5848"),aIN=b("40418"),aIO=b(r),aIP=b("26813"),aIQ=b("32152"),aIR=b(y),aIS=b("5339"),aIT=b("37491"),aIV=[0,b(d),0,1,0,1,0],aIA=[0,b(K),1581,5,1585,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aIi=b(r),aIj=b("25907"),aIk=b(vR),aIl=b(y),aIm=b("5357"),aIn=b("36621"),aIo=b(r),aIp=b("23094"),aIq=b("27814"),aIr=b(y),aIs=b("4720"),aIt=b("32534"),aIu=b(r),aIv=b("21567"),aIw=b("25874"),aIx=b(y),aIy=b("4307"),aIz=b("30181"),aIB=[0,b(d),0,1,0,1,0],aIg=[0,b(K),1614,5,1618,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aH0=b(r),aH1=b("33086"),aH2=b("39914"),aH3=b(y),aH4=b("6828"),aH5=b("46742"),aH6=b(r),aH7=b("29526"),aH8=b("35538"),aH9=b(y),aH_=b("6012"),aH$=b("41550"),aIa=b(r),aIb=b("27564"),aIc=b("33052"),aId=b(y),aIe=b("5488"),aIf=b("38541"),aIh=[0,b(d),0,1,0,1,0],aHY=[0,b(K),1647,5,p0,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aHG=b(r),aHH=b("26632"),aHI=b("32139"),aHJ=b(y),aHK=b("5507"),aHL=b("37646"),aHM=b(r),aHN=b("23741"),aHO=b("28593"),aHP=b(y),aHQ=b("4852"),aHR=b("33445"),aHS=b(r),aHT=b("22171"),aHU=b("36598"),aHV=b(y),aHW=b("4428"),aHX=b("31026"),aHZ=[0,b(d),0,1,0,1,0],aHE=[0,b(K),1680,5,1684,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aHm=b(r),aHn=b("33999"),aHo=b("41016"),aHp=b(y),aHq=b("7016"),aHr=b("48032"),aHs=b(r),aHt=b("30341"),aHu=b("36519"),aHv=b(y),aHw=b("6178"),aHx=b("42697"),aHy=b(r),aHz=b("28325"),aHA=b("33964"),aHB=b(y),aHC=b("5639"),aHD=b("39605"),aHF=[0,b(d),0,1,0,1,0],aHk=[0,b(K),1713,5,1717,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aG4=b(r),aG5=b("27367"),aG6=b("33026"),aG7=b(y),aG8=b("5659"),aG9=b("38685"),aG_=b(r),aG$=b("24396"),aHa=b("29382"),aHb=b(y),aHc=b(Ge),aHd=b("34368"),aHe=b(r),aHf=b("22783"),aHg=b("27332"),aHh=b(y),aHi=b("4550"),aHj=b("31882"),aHl=[0,b(d),0,1,0,1,0],aG2=[0,b(K),pY,5,1750,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aGK=b(r),aGL=b("35002"),aGM=b("42226"),aGN=b(y),aGO=b("7223"),aGP=b("49449"),aGQ=b(r),aGR=b("31236"),aGS=b("37596"),aGT=b(y),aGU=b("6360"),aGV=b("43957"),aGW=b(r),aGX=b("29161"),aGY=b("34966"),aGZ=b(y),aG0=b("5805"),aG1=b("40773"),aG3=[0,b(d),0,1,0,1,0],aGI=[0,b(K),1779,5,1783,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aGq=b(r),aGr=b("28174"),aGs=b("34000"),aGt=b(y),aGu=b("5826"),aGv=b("39826"),aGw=b(r),aGx=b(Go),aGy=b("30249"),aGz=b(y),aGA=b("5133"),aGB=b("35382"),aGC=b(r),aGD=b("23455"),aGE=b("28138"),aGF=b(y),aGG=b("4684"),aGH=b("32823"),aGJ=[0,b(d),0,1,0,1,0],aGo=[0,b(K),1812,5,hg,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aF8=b(r),aF9=b("35114"),aF_=b("42361"),aF$=b(y),aGa=b("7246"),aGb=b("49607"),aGc=b(r),aGd=b("31336"),aGe=b("37716"),aGf=b(y),aGg=b("6380"),aGh=b("44098"),aGi=b(r),aGj=b("29254"),aGk=b("35078"),aGl=b(y),aGm=b("5824"),aGn=b("40903"),aGp=[0,b(d),0,1,0,1,0],aF6=[0,b(K),1845,5,1849,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aFO=b(r),aFP=b("28264"),aFQ=b("34109"),aFR=b(y),aFS=b("5845"),aFT=b("39953"),aFU=b(r),aFV=b("25196"),aFW=b("30346"),aFX=b(y),aFY=b("5149"),aFZ=b("35495"),aF0=b(r),aF1=b("23530"),aF2=b("28228"),aF3=b(y),aF4=b("4699"),aF5=b("32928"),aF7=[0,b(d),0,1,0,1,0],aFM=[0,b(K),1878,5,1882,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aFu=b(r),aFv=b("35500"),aFw=b("42827"),aFx=b(y),aFy=b("7326"),aFz=b("50153"),aFA=b(r),aFB=b("31681"),aFC=b("38131"),aFD=b(y),aFE=b("6450"),aFF=b("44583"),aFG=b(r),aFH=b("29576"),aFI=b("35464"),aFJ=b(y),aFK=b("5888"),aFL=b("41353"),aFN=[0,b(d),0,1,0,1,0],aFs=[0,b(K),1911,5,1915,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aFa=b(r),aFb=b("28575"),aFc=b("34484"),aFd=b(y),aFe=b("5909"),aFf=b("40392"),aFg=b(r),aFh=b("25473"),aFi=b("30680"),aFj=b(y),aFk=b("5206"),aFl=b("35885"),aFm=b(r),aFn=b("23789"),aFo=b("28539"),aFp=b(y),aFq=b("4751"),aFr=b("33290"),aFt=[0,b(d),0,1,0,1,0],aE_=[0,b(K),qk,5,pv,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aES=b(r),aET=b("35855"),aEU=b("43255"),aEV=b(y),aEW=b("7399"),aEX=b("50655"),aEY=b(r),aEZ=b("31998"),aE0=b("38512"),aE1=b(y),aE2=b("6515"),aE3=b("45029"),aE4=b(r),aE5=b("29872"),aE6=b("35819"),aE7=b(y),aE8=b("5947"),aE9=b("41767"),aE$=[0,b(d),0,1,0,1,0],aEQ=[0,b(K),1977,5,1981,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aEy=b(r),aEz=b("28861"),aEA=b(H1),aEB=b(y),aEC=b("5968"),aED=b("40796"),aEE=b(r),aEF=b("25728"),aEG=b("30987"),aEH=b(y),aEI=b("5258"),aEJ=b("36244"),aEK=b(r),aEL=b("24027"),aEM=b("28824"),aEN=b(y),aEO=b("4799"),aEP=b(EO),aER=[0,b(d),0,1,0,1,0],aEw=[0,b(K),fP,5,dn,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aEe=b(r),aEf=b("36626"),aEg=b("44185"),aEh=b(y),aEi=b("7558"),aEj=b("51744"),aEk=b(r),aEl=b("32686"),aEm=b(wf),aEn=b(y),aEo=b("6655"),aEp=b("45997"),aEq=b(r),aEr=b("30514"),aEs=b("36589"),aEt=b(y),aEu=b("6075"),aEv=b("42665"),aEx=[0,b(d),0,1,0,1,0],aEc=[0,b(K),2043,5,DF,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aDW=b(r),aDX=b("29482"),aDY=b("35578"),aDZ=b(y),aD0=b("6096"),aD1=b("41673"),aD2=b(r),aD3=b("26281"),aD4=b("31653"),aD5=b(y),aD6=b("5371"),aD7=b("37023"),aD8=b(r),aD9=b("24544"),aD_=b("29444"),aD$=b(y),aEa=b("4902"),aEb=b("34346"),aEd=[0,b(d),0,1,0,1,0],aDU=[0,b(K),2076,5,2080,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aDC=b(r),aDD=b("36835"),aDE=b("44437"),aDF=b(y),aDG=b("7601"),aDH=b("52039"),aDI=b(r),aDJ=b("32872"),aDK=b("39564"),aDL=b(y),aDM=b("6693"),aDN=b("46259"),aDO=b(r),aDP=b("30688"),aDQ=b("36798"),aDR=b(y),aDS=b("6110"),aDT=b("42908"),aDV=[0,b(d),0,1,0,1,0],aDA=[0,b(K),2109,5,2113,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aDi=b(r),aDj=b("29650"),aDk=b("35781"),aDl=b(y),aDm=b("6131"),aDn=b("41911"),aDo=b(r),aDp=b("26431"),aDq=b("31833"),aDr=b(y),aDs=b("5402"),aDt=b("37234"),aDu=b(r),aDv=b("24684"),aDw=b("29612"),aDx=b(y),aDy=b("4930"),aDz=b("34542"),aDB=[0,b(d),0,1,0,1,0],aDg=[0,b(K),2142,5,2146,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aC0=b(r),aC1=b("36864"),aC2=b("44473"),aC3=b(y),aC4=b("7607"),aC5=b("52081"),aC6=b(r),aC7=b("32898"),aC8=b("39596"),aC9=b(y),aC_=b("6698"),aC$=b("46296"),aDa=b(r),aDb=b("30713"),aDc=b("36827"),aDd=b(y),aDe=b("6115"),aDf=b("42942"),aDh=[0,b(d),0,1,0,1,0],aCY=[0,b(K),2175,5,2179,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aCG=b(r),aCH=b("29674"),aCI=b("35810"),aCJ=b(y),aCK=b("6136"),aCL=b("41945"),aCM=b(r),aCN=b("26452"),aCO=b("31858"),aCP=b(y),aCQ=b("5406"),aCR=b("37264"),aCS=b(r),aCT=b("24704"),aCU=b("29636"),aCV=b(y),aCW=b("4934"),aCX=b(DJ),aCZ=[0,b(d),0,1,0,1,0],aCE=[0,b(K),2208,5,2212,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aCm=b(r),aCn=b("37140"),aCo=b("44807"),aCp=b(y),aCq=b("7664"),aCr=b("52472"),aCs=b(r),aCt=b("33145"),aCu=b("39893"),aCv=b(y),aCw=b("6748"),aCx=b("46643"),aCy=b(r),aCz=b("30943"),aCA=b("37103"),aCB=b(y),aCC=b("6161"),aCD=b("43264"),aCF=[0,b(d),0,1,0,1,0],aCk=[0,b(K),2241,5,2245,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aB4=b(r),aB5=b("29897"),aB6=b("36079"),aB7=b(y),aB8=b("6182"),aB9=b("42260"),aB_=b(r),aB$=b("26650"),aCa=b("32097"),aCb=b(y),aCc=b("5447"),aCd=b("37543"),aCe=b(r),aCf=b("24889"),aCg=b("29858"),aCh=b(y),aCi=b("4971"),aCj=b(H1),aCl=[0,b(d),0,1,0,1,0],aB2=[0,b(K),2274,5,2277,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aBK=b(r),aBL=b("37252"),aBM=b("44941"),aBN=b(y),aBO=b("7687"),aBP=b("52629"),aBQ=b(r),aBR=b("33244"),aBS=b("40013"),aBT=b(y),aBU=b("6768"),aBV=b("46783"),aBW=b(r),aBX=b("31036"),aBY=b("37215"),aBZ=b(y),aB0=b("6179"),aB1=b("43394"),aB3=[0,b(d),0,1,0,1,0],aBI=[0,b(K),2306,5,2309,36,[0,b(a_),[0,b(aJ),[0,b(J),0]]]],aBq=b(r),aBr=b("29986"),aBs=b("36187"),aBt=b(y),aBu=b("6201"),aBv=b("42386"),aBw=b(r),aBx=b("26730"),aBy=b("32193"),aBz=b(y),aBA=b("5463"),aBB=b("37656"),aBC=b(r),aBD=b("24964"),aBE=b("29948"),aBF=b(y),aBG=b(Ge),aBH=b("34934"),aBJ=[0,b(d),0,1,0,1,0],aNi=[0,b(d),0,1,0,1,0],aNr=[0,b(d),0,1,0,1,0],aBm=[0,b(K),638,5,641,33,[0,b(nE),[0,b(aJ),[0,b(J),0]]]],aA6=b(r),aA7=b(CY),aA8=b(B$),aA9=b(y),aA_=b(Bo),aA$=b(Eh),aBa=b(r),aBb=b(xH),aBc=b(Af),aBd=b(y),aBe=b(uY),aBf=b(E_),aBg=b(r),aBh=b(Ey),aBi=b(H6),aBj=b(y),aBk=b("35600"),aBl=b(lY),aBn=[0,b(d),0,1,0,1,0],aA4=[0,b(K),683,5,id,33,[0,b(nE),[0,b(aJ),[0,b(J),0]]]],aAM=b(r),aAN=b(DV),aAO=b(q6),aAP=b(y),aAQ=b(IX),aAR=b(Gn),aAS=b(r),aAT=b(An),aAU=b(qE),aAV=b(y),aAW=b(lf),aAX=b(xs),aAY=b(r),aAZ=b(zQ),aA0=b(AS),aA1=b(y),aA2=b(zx),aA3=b(DE),aA5=[0,b(d),0,1,0,1,0],aAK=[0,b(K),qL,5,nF,33,[0,b(nE),[0,b(aJ),[0,b(J),0]]]],aAs=b(r),aAt=b(q1),aAu=b("220000"),aAv=b(y),aAw=b("38000"),aAx=b("260000"),aAy=b(r),aAz=b("164200"),aAA=b(wP),aAB=b(y),aAC=b(Bd),aAD=b("231200"),aAE=b(r),aAF=b("153200"),aAG=b("183700"),aAH=b(y),aAI=b(lf),aAJ=b("214200"),aAL=[0,b(d),0,1,0,1,0],aAq=[0,b(K),773,5,Bq,33,[0,b(nE),[0,b(aJ),[0,b(J),0]]]],az_=b(r),az$=b("148100"),aAa=b("178700"),aAb=b(y),aAc=b("30600"),aAd=b("209300"),aAe=b(r),aAf=b(yc),aAg=b("158900"),aAh=b(y),aAi=b("26900"),aAj=b(wh),aAk=b(r),aAl=b("123300"),aAm=b("147900"),aAn=b(y),aAo=b("24600"),aAp=b(zY),aAr=[0,b(d),0,1,0,1,0],aBo=[0,b(d),0,1,0,1,0],aBp=[0,b(d),0,1,0,1,0],az9=[0,b(o),j$,55,j$,61,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aNs=[0,b(d),0,1,0,1,0],az8=[0,b(o),j$,11,j$,46,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],az2=[0,b(o),me,14,me,41,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],azX=[0,b(o),no,14,no,50,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],azP=[0,b(K),Fr,7,Fr,18,[0,b(hf),[0,b(aJ),[0,b(J),0]]]],azM=b(fW),azN=b(qv),azO=b(eP),azQ=[0,b(d),0,1,0,1,0],azK=[0,b(N),Dc,7,Dc,18,[0,b(hf),[0,b(aW),[0,b(M),0]]]],azH=b(fT),azI=b(o5),azJ=b(eH),azL=[0,b(d),0,1,0,1,0],azF=[0,b(N),HG,7,HG,18,[0,b(hf),[0,b(a3),[0,b(M),0]]]],azC=b(fU),azD=b(pO),azE=b(eG),azG=[0,b(d),0,1,0,1,0],azR=[0,b(d),0,1,0,1,0],azS=[0,b(d),0,1,0,1,0],azz=[0,b(K),Bb,29,Bb,64,[0,b(mH),[0,b(aJ),[0,b(J),0]]]],azx=b(fW),azy=b(eP),azA=[0,b(d),0,1,0,1,0],azv=[0,b(N),q_,29,q_,64,[0,b(mH),[0,b(aW),[0,b(M),0]]]],azt=b(fT),azu=b(eH),azw=[0,b(d),0,1,0,1,0],azr=[0,b(N),Cr,29,Cr,64,[0,b(mH),[0,b(a3),[0,b(M),0]]]],azp=b(fU),azq=b(eG),azs=[0,b(d),0,1,0,1,0],azB=[0,b(d),0,1,0,1,0],azk=[0,b(K),At,14,At,41,[0,b("Article 20"),[0,b(aJ),[0,b(J),0]]]],azj=b(h_),aze=[0,b(K),G4,14,G4,42,[0,b("Article 21"),[0,b(aJ),[0,b(J),0]]]],azd=b(g6),ay_=[0,b(K),xW,14,xW,50,[0,b("Article 25"),[0,b(aJ),[0,b(J),0]]]],ay5=b(CK),ay6=b(p6),ay7=b("0.0172"),ay8=b(CK),ay9=b(p6),ay0=[0,b(K),nz,14,nz,48,[0,b("Article 22"),[0,b(aJ),[0,b(J),0]]]],ayZ=b("2211133"),ayU=[0,b(K),Gj,14,Gj,48,[0,b("Article 26"),[0,b(aJ),[0,b(J),0]]]],ayT=b(xG),ayO=[0,b(K),ue,14,ue,47,[0,b(rw),[0,b(aJ),[0,b(J),0]]]],ayN=b("560085"),ayI=[0,b(K),uf,14,uf,47,[0,b(rw),[0,b(aJ),[0,b(J),0]]]],ayH=b(ut),ayC=[0,b(K),Au,14,Au,47,[0,b(rw),[0,b(aJ),[0,b(J),0]]]],ayB=b("0.416"),ayt=[0,b(z),nb,14,nb,64,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ayo=[0,b(z),g1,14,g1,59,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ayj=[0,b(dm),iR,14,iR,36,[0,b(GU),[0,b(wJ),0]]],ayh=b(B2),ayi=b(dy),ayk=[0,b(d),0,1,0,1,0],ayg=[0,b(o),D4,11,D4,33,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayl=[0,0,0],aym=[0,b(aj),[0,b(A3),0]],ayp=[0,b(d),0,1,0,1,0],ayq=[0,1,0],ayr=[0,b(aj),[0,b(ks),0]],ayn=[0,b(z),g1,14,g1,59,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ayu=[0,b(d),0,1,0,1,0],ayv=[0,1,0],ayw=[0,b(aj),[0,b(m0),0]],ays=[0,b(z),nb,14,nb,64,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ayx=[0,b(aj),[0,b(fu),[0,b(iG),0]]],ayy=[0,b(aj),[0,b(fu),[0,b(iG),0]]],ayz=[0,b(o),j0,13,j0,42,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aQx=[0,b(o),j0,13,j0,42,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayD=[0,b(d),0,1,0,1,0],ayA=[0,b(o),zS,11,zS,44,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayE=[0,0,0],ayF=[0,b(aj),[0,b("taux_tranche_sup\xc3\xa9rieure_d832_15_1"),0]],ayJ=[0,b(d),0,1,0,1,0],ayG=[0,b(o),G7,11,G7,44,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayK=[0,0,0],ayL=[0,b(aj),[0,b("taux_tranche_inf\xc3\xa9rieure_d832_15_1"),0]],ayP=[0,b(d),0,1,0,1,0],ayM=[0,b(o),E9,11,E9,44,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayQ=[0,0,0],ayR=[0,b(aj),[0,b("montant_limite_tranches_d832_15_1"),0]],ayV=[0,b(d),0,1,0,1,0],ayS=[0,b(o),nD,11,nD,45,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayW=[0,0,0],ayX=[0,b(aj),[0,b("coefficient_multiplicateur_d832_18"),0]],ay1=[0,b(d),0,1,0,1,0],ayY=[0,b(o),Hz,11,Hz,45,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],ay2=[0,0,0],ay3=[0,b(aj),[0,b("coefficient_multiplicateur_d832_11"),0]],ay$=[0,b(d),0,1,0,1,0],ay4=[0,b(o),wx,11,wx,47,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aza=[0,0,0],azb=[0,b(aj),[0,b("coefficient_multiplicateur_d832_17_3"),0]],azf=[0,b(d),0,1,0,1,0],azc=[0,b(o),GM,11,GM,39,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],azg=[0,0,0],azh=[0,b(aj),[0,b("montant_minimal_aide_d832_10"),0]],azl=[0,b(d),0,1,0,1,0],azi=[0,b(o),C$,11,C$,38,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],azm=[0,0,0],azn=[0,b(aj),[0,b("montant_forfaitaire_d832_10"),0]],azT=[0,b(d),0,1,0,1,0],azo=[0,b(o),D3,11,D3,46,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],azU=[0,0,0],azV=[0,b(aj),[0,b("montant_forfaitaire_charges_d832_10"),0]],azY=[0,b(d),0,1,0,1,0],azZ=[0,1,0],az0=[0,b(aj),[0,b(ig),0]],azW=[0,b(o),no,14,no,50,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],az3=[0,b(d),0,1,0,1,0],az4=[0,1,0],az5=[0,b(aj),[0,b(h3),0]],az1=[0,b(o),me,14,me,41,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],az6=[0,b(aj),[0,b(ed),[0,b(bm),0]]],az7=[0,b(aj),[0,b(ed),[0,b(bm),0]]],aNt=[0,0,0],aNu=[0,b(aj),[0,b(dr),0]],aNx=[0,b(d),0,1,0,1,0],aNv=[0,b(o),pH,11,pH,33,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aNy=[0,0,0],aNz=[0,b(aj),[0,b(uS),0]],aNE=[0,b(d),0,1,0,1,0],aNA=[0,b(o),BU,11,BU,41,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aNF=[0,0,0],aNG=[0,b(aj),[0,b("ressources_m\xc3\xa9nage_avec_d832_18"),0]],aNM=[0,0,0],aNN=[0,b(aj),[0,b(bF),0]],aNT=[0,0,0],aNU=[0,b(aj),[0,b(iN),0]],aOf=[0,b(d),0,1,0,1,0],aNV=[0,b(o),xE,10,xE,14,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aOg=[0,0,0],aOh=[0,b(aj),[0,b("plafond_mensualit\xc3\xa9_d832_10_3_base"),0]],aOk=[0,b(d),0,1,0,1,0],aOl=[0,1,0],aOm=[0,b(aj),[0,b(nd),0]],aOi=[0,b(o),mc,14,mc,61,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aOp=[0,b(d),0,1,0,1,0],aOq=[0,1,0],aOr=[0,b(aj),[0,b(l_),0]],aOn=[0,b(z),kR,14,kR,75,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOu=[0,b(d),0,1,0,1,0],aOv=[0,1,0],aOw=[0,b(aj),[0,b(la),0]],aOs=[0,b(z),k4,14,k4,69,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOz=[0,b(d),0,1,0,1,0],aOA=[0,1,0],aOB=[0,b(aj),[0,b(l6),0]],aOx=[0,b(z),m9,14,m9,70,[0,b(fm),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aOC=[0,b(aj),[0,b(fk),[0,b(dL),0]]],aOD=[0,b(aj),[0,b(fk),[0,b(dL),0]]],aOH=[0,b(d),0,1,0,1,0],aOE=[0,b(o),Ap,10,Ap,17,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aOI=[0,0,0],aOJ=[0,b(aj),[0,b("coefficient_prise_en_charge_d832_10_formule"),0]],aOU=[0,0,0],aOV=[0,b(aj),[0,b(i1),0]],aO7=[0,b(d),0,1,0,1,0],aOW=[0,b(o),Ic,10,Ic,25,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aO8=[0,0,0],aO9=[0,b(aj),[0,b("plafond_mensualit\xc3\xa9_d832_10_3_copropri\xc3\xa9taires"),0]],aPg=[0,b(d),0,1,0,1,0],aO_=[0,b(o),Eb,12,Eb,31,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aPh=[0,0,1],aPi=[0,b(aj),[0,b(kl),0]],aPo=[0,b(d),0,1,0,1,0],aPj=[0,b(o),pS,10,pS,23,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aPp=[0,0,0],aPq=[0,b(aj),[0,b("coefficient_prise_en_charge_d832_10_coeff_arrondi"),0]],aPI=[0,0,0],aPJ=[0,b(aj),[0,b(eg),0]],aPM=[0,b(d),0,1,0,1,0],aPK=[0,b(o),xw,12,xw,31,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aPN=[0,0,1],aPO=[0,b(aj),[0,b(ns),0]],aPT=[0,b(d),0,1,0,1,0],aPP=[0,b(o),CD,10,CD,15,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aPU=[0,0,1],aPV=[0,b(aj),[0,b("coefficient_prise_en_charge_d832_10_seuil"),0]],aQc=[0,0,0],aQd=[0,b(aj),[0,b(bG),0]],aQi=[0,b(d),0,1,0,1,0],aQe=[0,b(o),xd,12,xd,31,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aQj=[0,0,1],aQk=[0,b(aj),[0,b(cO),0]],aQv=[0,0,1],aQw=[0,b(aj),[0,b(eW),0]],ayb=[0,b(z),qR,14,qR,33,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],ax$=b(r),aya=b(r),ax6=[0,b(z),wH,14,wH,36,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],axZ=[0,1,0],ax0=[0,b(aq),[0,b(bG),[0,b(ac),0]]],ax1=[0,b(aq),[0,b(bG),0]],ax2=[0,0,1],ax3=[0,b(aq),[0,b(bG),[0,b(Y),0]]],ax4=[0,b(aq),[0,b(bG),0]],ax5=b(r),ax7=[0,b(d),0,1,0,1,0],axY=[0,b(o),Gl,10,Gl,25,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],axT=[0,b(z),CB,5,CB,26,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],axR=b(ln),axS=b(ln),axU=[0,b(d),0,1,0,1,0],axQ=[0,b(z),Bi,14,Bi,49,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],axO=b(gQ),axP=b(gQ),axJ=[0,b(z),ws,14,ws,36,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],axu=[0,1,0],axv=[0,b(aq),[0,b(eg),[0,b(ac),0]]],axw=[0,b(aq),[0,b(eg),0]],axx=[0,0,1],axy=[0,b(aq),[0,b(eg),[0,b(Y),0]]],axz=[0,b(aq),[0,b(eg),0]],axA=[0,1,0],axB=[0,b(bm),[0,b(bO),[0,b(ac),0]]],axC=[0,b(bm),[0,b(bO),0]],axD=[0,0,1],axE=[0,b(bm),[0,b(bO),[0,b(Y),0]]],axF=[0,b(bm),[0,b(bO),0]],axG=b(is),axH=b(r),axI=b(r),axK=[0,b(d),0,1,0,1,0],axt=[0,b(o),xz,10,xz,40,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],axo=[0,b(z),Ah,5,Ah,26,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],axl=b(db),axm=b(db),axn=b(jW),axp=[0,b(d),0,1,0,1,0],axk=[0,b(z),DR,14,DR,49,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],axh=b(db),axi=b(db),axj=b(jW),axc=[0,b(z),mv,14,mv,40,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],aw9=[0,b(z),yj,14,yj,36,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awV=[0,1,0],awW=[0,b(aq),[0,b(bF),[0,b(ac),0]]],awX=[0,b(aq),[0,b(bF),0]],awY=[0,0,1],awZ=[0,b(aq),[0,b(bF),[0,b(Y),0]]],aw0=[0,b(aq),[0,b(bF),0]],aw1=[0,1,0],aw2=[0,b(aq),[0,b(iM),[0,b(ac),0]]],aw3=[0,b(aq),[0,b(iM),0]],aw4=[0,0,1],aw5=[0,b(aq),[0,b(iM),[0,b(Y),0]]],aw6=[0,b(aq),[0,b(iM),0]],aw7=b(r),aw8=b(r),aw_=[0,b(d),0,1,0,1,0],awU=[0,b(o),AD,10,AD,20,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],awP=[0,b(z),vT,5,vT,26,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awO=b(ln),awQ=[0,b(d),0,1,0,1,0],awN=[0,b(z),GZ,14,GZ,49,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awK=b(r),awL=b(r),awM=b(gQ),awD=[0,b(z),mt,14,mt,70,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awy=[0,b(z),kD,14,kD,69,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awt=[0,b(z),kx,14,kx,75,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awo=[0,b(o),kh,14,kh,61,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],awj=[0,b(z),AL,14,AL,55,[0,b(Eg),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awc=[0,1,0],awd=[0,b(aq),[0,b(ih),[0,b(ac),0]]],awe=[0,b(aq),[0,b(ih),0]],awf=[0,0,1],awg=[0,b(aq),[0,b(ih),[0,b(Y),0]]],awh=[0,b(aq),[0,b(ih),0]],awi=b(r),awk=[0,b(d),0,1,0,1,0],awb=[0,b(o),H7,11,H7,52,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],av8=[0,b(z),Gs,14,Gs,36,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],av9=[0,b(d),0,1,0,1,0],av3=[0,b(z),HY,14,HY,44,[0,b(Eg),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],av4=[0,b(d),0,1,0,1,0],av2=[0,b(o),Co,11,Co,41,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],avY=[0,b(K),EG,14,EG,48,[0,b(uV),[0,b(eJ),[0,b(J),0]]]],avW=b("2142091"),avX=b("1339340"),avR=[0,b(K),AE,14,AE,41,[0,b("Article 32"),[0,b(eJ),[0,b(J),0]]]],avP=b(qp),avQ=b("2668"),avI=[0,b(z),Ed,5,Ed,45,[0,b(gI),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],avJ=[0,b(d),0,1,0,1,0],avK=[0,2,0],avL=[0,b(aq),[0,b("calcul_nombre_parts.limitation_majoration_personnes_\xc3\xa0_charge"),0]],avE=[0,b(z),mu,14,mu,64,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avz=[0,b(z),l1,14,l1,59,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avu=[0,b(z),j_,14,j_,55,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avp=[0,b(z),mf,14,mf,47,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avk=[0,b(z),Fh,14,Fh,40,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avf=[0,b(z),Hv,14,Hv,36,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avd=b(r),ave=b(r),avg=[0,b(d),0,1,0,1,0],avc=[0,b(o),Ab,10,Ab,32,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],au8=[0,b(z),xZ,24,xZ,45,[0,b("Article D861-21"),[0,b(EA),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],au9=[0,b(d),0,1,0,1,0],au7=[0,b(z),FK,14,FK,35,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],au_=[0,b(d),0,1,0,1,0],au2=[0,b(K),C0,14,C0,35,[0,b(uV),[0,b(eJ),[0,b(J),0]]]],au1=b("121726"),auU=[0,b(K),EP,14,EP,48,[0,b(rF),[0,b(eJ),[0,b(J),0]]]],auk=b(r),aul=b("46192"),aum=b("54152"),aun=b(y),auo=b("57741"),aup=b(T),auq=b("61794"),aur=b(Z),aus=b("65862"),aut=b(_),auu=b("7368"),auv=b("71039"),auw=b(r),aux=b("42242"),auy=b("49299"),auz=b(y),auA=b("52565"),auB=b(T),auC=b("56268"),auD=b(Z),auE=b("59957"),auF=b(_),auG=b("6659"),auH=b("63887"),auI=b(r),auJ=b("40096"),auK=b("46634"),auL=b(y),auM=b("49475"),auN=b(T),auO=b("52740"),auP=b(Z),auQ=b("56004"),auR=b(_),auS=b("6180"),auT=b("59675"),auV=[0,b(d),0,1,0,1,0],aui=[0,b(N),CL,14,CL,48,[0,b(rF),[0,b(aW),[0,b(M),0]]]],atK=b(r),atL=b("44630"),atM=b("52321"),atN=b(y),atO=b("55788"),atP=b(T),atQ=b("59704"),atR=b(Z),atS=b("63635"),atT=b(_),atU=b("7119"),atV=b("68637"),atW=b(r),atX=b("40814"),atY=b("47632"),atZ=b(y),at0=b("50787"),at1=b(T),at2=b("54365"),at3=b(Z),at4=b("57929"),at5=b(_),at6=b("6434"),at7=b("61727"),at8=b(r),at9=b("38740"),at_=b("45057"),at$=b(y),aua=b("47802"),aub=b(T),auc=b("50957"),aud=b(Z),aue=b("54110"),auf=b(_),aug=b("5971"),auh=b("57657"),auj=[0,b(d),0,1,0,1,0],atI=[0,b(N),Ek,14,Ek,48,[0,b(rF),[0,b(a3),[0,b(M),0]]]],as_=b(r),as$=b("44443"),ata=b("52101"),atb=b(y),atc=b("55555"),atd=b(T),ate=b("59454"),atf=b(Z),atg=b("63369"),ath=b(_),ati=b("7089"),atj=b("68350"),atk=b(r),atl=b("40643"),atm=b("47433"),atn=b(y),ato=b("50575"),atp=b(T),atq=b("54138"),atr=b(Z),ats=b("57687"),att=b(_),atu=b("6407"),atv=b("61469"),atw=b(r),atx=b("38578"),aty=b("44869"),atz=b(y),atA=b("47602"),atB=b(T),atC=b("50744"),atD=b(Z),atE=b("53884"),atF=b(_),atG=b("5946"),atH=b("57416"),atJ=[0,b(d),0,1,0,1,0],auW=[0,b(d),0,1,0,1,0],as5=[0,b(K),CH,14,CH,41,[0,b("Article 28"),[0,b(eJ),[0,b(J),0]]]],as4=b(h_),asZ=[0,b(K),GV,14,GV,42,[0,b("Article 29"),[0,b(eJ),[0,b(J),0]]]],asY=b(g6),asR=[0,b(o),np,14,np,41,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asM=[0,b(o),iF,14,iF,50,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asF=[0,b(o),iv,12,iv,52,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asG=[0,b(d),0,1,0,1,0],asH=[0,b(d),0,1,0,1,0],asE=[0,b(o),iv,12,iv,52,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asI=[0,2,0],asJ=[0,b(aq),[0,b(By),0]],asK=[0,b(o),id,13,id,42,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayf=[0,b(o),id,13,id,42,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asN=[0,b(d),0,1,0,1,0],asO=[0,1,0],asP=[0,b(aq),[0,b(ig),0]],asL=[0,b(o),iF,14,iF,50,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asS=[0,b(d),0,1,0,1,0],asT=[0,1,0],asU=[0,b(aq),[0,b(h3),0]],asQ=[0,b(o),np,14,np,41,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],asV=[0,b(aq),[0,b(ed),[0,b(bm),0]]],asW=[0,b(aq),[0,b(ed),[0,b(bm),0]]],as0=[0,b(d),0,1,0,1,0],asX=[0,b(o),Bx,11,Bx,39,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],as1=[0,0,0],as2=[0,b(aq),[0,b("montant_minimal_aide_d823_24"),0]],as6=[0,b(d),0,1,0,1,0],as3=[0,b(o),BE,11,BE,38,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],as7=[0,0,0],as8=[0,b(aq),[0,b("montant_forfaitaire_d832_24"),0]],auX=[0,b(d),0,1,0,1,0],as9=[0,b(o),zL,12,zL,46,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],auY=[0,0,1],auZ=[0,b(aq),[0,b(EW),0]],au3=[0,b(d),0,1,0,1,0],au0=[0,b(o),AX,12,AX,33,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],au4=[0,0,1],au5=[0,b(aq),[0,b(Aa),0]],au$=[0,b(d),0,1,0,1,0],au6=[0,b(o),Bw,12,Bw,33,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],ava=[0,2,0],avb=[0,b(aq),[0,b("condition_2_du_832_25"),0]],avh=[0,0,0],avi=[0,b(aq),[0,b(bF),0]],avl=[0,b(d),0,1,0,1,0],avj=[0,b(o),w1,12,w1,38,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],avm=[0,0,1],avn=[0,b(aq),[0,b(Do),0]],avq=[0,b(d),0,1,0,1,0],avr=[0,1,0],avs=[0,b(aq),[0,b(C2),0]],avo=[0,b(z),mf,14,mf,47,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avv=[0,b(d),0,1,0,1,0],avw=[0,1,0],avx=[0,b(aq),[0,b(FZ),0]],avt=[0,b(z),j_,14,j_,55,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avA=[0,b(d),0,1,0,1,0],avB=[0,1,0],avC=[0,b(aq),[0,b(ks),0]],avy=[0,b(z),l1,14,l1,59,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avF=[0,b(d),0,1,0,1,0],avG=[0,1,0],avH=[0,b(aq),[0,b(m0),0]],avD=[0,b(z),mu,14,mu,64,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],avM=[0,b(aq),[0,b(fu),[0,b(ff),0]]],avN=[0,b(aq),[0,b(fu),[0,b(ff),0]]],avS=[0,b(d),0,1,0,1,0],avO=[0,b(o),AA,11,AA,38,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],avT=[0,0,0],avU=[0,b(aq),[0,b("montant_forfaitaire_d832_27"),0]],avZ=[0,b(d),0,1,0,1,0],avV=[0,b(o),D9,12,D9,46,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],av0=[0,0,1],av1=[0,b(aq),[0,b(xY),0]],av5=[0,0,0],av6=[0,b(aq),[0,b(ih),0]],av_=[0,b(d),0,1,0,1,0],av7=[0,b(o),wc,21,wc,43,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],av$=[0,2,1],awa=[0,b(aq),[0,b(rj),0]],awl=[0,0,0],awm=[0,b(aq),[0,b(iM),0]],awp=[0,b(d),0,1,0,1,0],awq=[0,1,0],awr=[0,b(aq),[0,b(nd),0]],awn=[0,b(o),kh,14,kh,61,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],awu=[0,b(d),0,1,0,1,0],awv=[0,1,0],aww=[0,b(aq),[0,b(l_),0]],aws=[0,b(z),kx,14,kx,75,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awz=[0,b(d),0,1,0,1,0],awA=[0,1,0],awB=[0,b(aq),[0,b(la),0]],awx=[0,b(z),kD,14,kD,69,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awE=[0,b(d),0,1,0,1,0],awF=[0,1,0],awG=[0,b(aq),[0,b(l6),0]],awC=[0,b(z),mt,14,mt,70,[0,b(dq),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],awH=[0,b(aq),[0,b(fk),[0,b(dL),0]]],awI=[0,b(aq),[0,b(fk),[0,b(dL),0]]],awR=[0,b(d),0,1,0,1,0],awJ=[0,b(o),qM,10,qM,17,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],awS=[0,0,0],awT=[0,b(aq),[0,b("coefficient_prise_en_charge_d832_25_formule"),0]],aw$=[0,0,0],axa=[0,b(aq),[0,b(eg),0]],axd=[0,b(d),0,1,0,1,0],axb=[0,b(o),y_,12,y_,38,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],axe=[0,0,1],axf=[0,b(aq),[0,b(BP),0]],axq=[0,b(d),0,1,0,1,0],axg=[0,b(o),G_,10,G_,23,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],axr=[0,0,0],axs=[0,b(aq),[0,b("coefficient_prise_en_charge_d832_25_coeff_arrondi"),0]],axL=[0,0,0],axM=[0,b(aq),[0,b(bG),0]],axV=[0,b(d),0,1,0,1,0],axN=[0,b(o),Gw,10,Gw,15,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],axW=[0,0,1],axX=[0,b(aq),[0,b("coefficient_prise_en_charge_d832_25_seuil"),0]],ax8=[0,0,1],ax9=[0,b(aq),[0,b(eW),0]],ayc=[0,b(d),0,1,0,1,0],ax_=[0,b(o),Eo,12,Eo,31,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],ayd=[0,0,1],aye=[0,b(aq),[0,b(cO),0]],asB=b("8."),asC=b("2026"),asD=b(dy),asA=b(r),asx=b(db),asy=b("49"),asz=b(v4),asi=[7,0],asj=[5,0],ask=[4,0],asl=[3,0],asm=[2,0],asn=[1,0],aso=[0,0],asp=[6,0],asq=[0,b(cr),34,5,43,6,[0,b(b3),[0,b(jS),[0,b(aY),0]]]],ash=b(vo),asr=[0,b(d),0,1,0,1,0],ase=[8,0],asf=[0,b(cr),52,5,54,6,[0,b(b3),[0,b(jS),[0,b(aY),0]]]],asd=b(Dm),asg=[0,b(d),0,1,0,1,0],ar5=[7,0],ar6=[5,0],ar7=[4,0],ar8=[3,0],ar9=[2,0],ar_=[1,0],ar$=[0,0],asa=[6,0],asb=[0,b(cr),73,5,82,6,[0,b(b3),[0,b(mU),[0,b(aY),0]]]],ar4=b(Fx),asc=[0,b(d),0,1,0,1,0],ar1=[8,0],ar2=[0,b(cr),91,5,93,6,[0,b(b3),[0,b(mU),[0,b(aY),0]]]],ar0=b(BD),ar3=[0,b(d),0,1,0,1,0],arQ=[7,0],arR=[5,0],arS=[4,0],arT=[3,0],arU=[2,0],arV=[1,0],arW=[0,0],arX=[6,0],arY=[0,b(cr),rD,5,lN,6,[0,b(b3),[0,b(lK),[0,b(aY),0]]]],arP=b(ye),arZ=[0,b(d),0,1,0,1,0],arM=[8,0],arN=[0,b(cr),iV,5,gJ,6,[0,b(b3),[0,b(lK),[0,b(aY),0]]]],arL=b(H0),arO=[0,b(d),0,1,0,1,0],arB=[7,0],arC=[5,0],arD=[4,0],arE=[3,0],arF=[2,0],arG=[1,0],arH=[0,0],arI=[6,0],arJ=[0,b(cr),lH,5,mY,6,[0,b(b3),[0,b(mC),[0,b(aY),0]]]],arA=b(yp),arK=[0,b(d),0,1,0,1,0],arx=[8,0],ary=[0,b(cr),zg,5,xb,6,[0,b(b3),[0,b(mC),[0,b(aY),0]]]],arw=b(vy),arz=[0,b(d),0,1,0,1,0],arm=[7,0],arn=[5,0],aro=[4,0],arp=[3,0],arq=[2,0],arr=[1,0],ars=[0,0],art=[6,0],aru=[0,b(cr),Dt,5,fR,6,[0,b(dz),[0,b(kf),[0,b(aY),0]]]],arl=b(EQ),arv=[0,b(d),0,1,0,1,0],ari=[8,0],arj=[0,b(cr),GO,5,Fg,6,[0,b(dz),[0,b(kf),[0,b(aY),0]]]],arh=b(Al),ark=[0,b(d),0,1,0,1,0],aq9=[7,0],aq_=[5,0],aq$=[4,0],ara=[3,0],arb=[2,0],arc=[1,0],ard=[0,0],are=[6,0],arf=[0,b(cr),pw,5,u3,6,[0,b(dz),[0,b(ld),[0,b(aY),0]]]],aq8=b(HP),arg=[0,b(d),0,1,0,1,0],aq5=[8,0],aq6=[0,b(cr),bl,5,j1,6,[0,b(dz),[0,b(ld),[0,b(aY),0]]]],aq4=b(Io),aq7=[0,b(d),0,1,0,1,0],aqU=[7,0],aqV=[5,0],aqW=[4,0],aqX=[3,0],aqY=[2,0],aqZ=[1,0],aq0=[0,0],aq1=[6,0],aq2=[0,b(cr),qs,5,q$,6,[0,b(b3),[0,b(mo),[0,b(aY),0]]]],aqT=b(uQ),aq3=[0,b(d),0,1,0,1,0],aqQ=[8,0],aqR=[0,b(cr),ia,5,p4,6,[0,b(b3),[0,b(mo),[0,b(aY),0]]]],aqP=b(wX),aqS=[0,b(d),0,1,0,1,0],aqF=[7,0],aqG=[5,0],aqH=[4,0],aqI=[3,0],aqJ=[2,0],aqK=[1,0],aqL=[0,0],aqM=[6,0],aqN=[0,b(cr),gX,5,Fi,6,[0,b(dz),[0,b(mW),[0,b(aY),0]]]],aqE=b(v2),aqO=[0,b(d),0,1,0,1,0],aqB=[8,0],aqC=[0,b(cr),iR,5,qX,6,[0,b(dz),[0,b(mW),[0,b(aY),0]]]],aqA=b(yo),aqD=[0,b(d),0,1,0,1,0],ass=[0,b(d),0,1,0,1,0],aqy=[0,b(cr),16,13,16,42,[0,b(ao),[0,b(aY),0]]],asw=[0,b(cr),16,13,16,42,[0,b(ao),[0,b(aY),0]]],ast=[0,b(d),0,1,0,1,0],aqz=[0,b(cr),11,12,11,24,[0,b(ao),[0,b(aY),0]]],asu=[0,0,1],asv=[0,b(gU),[0,b(E3),0]],aqu=[0,b(m_),36,14,36,27,[0,b(ao),[0,b(aY),0]]],aqv=[0,b(d),0,1,0,1,0],aqt=[0,b(m_),33,12,33,25,[0,b(ao),[0,b(aY),0]]],aqw=[0,0,1],aqx=[0,b(d0),[0,b(pp),0]],aqp=[0,b(m_),25,14,25,35,[0,b(ao),[0,b(aY),0]]],aqq=[0,b(d),0,1,0,1,0],aqo=[0,b(m_),22,12,22,33,[0,b(ao),[0,b(aY),0]]],aqr=[0,0,1],aqs=[0,b(fO),[0,b(pL),0]],aqh=[0,b(fh),32,5,33,33,[0,b(yS),[0,b(cE),0]]],aqg=b(vZ),aqi=[0,b(d),0,1,0,1,0],aqe=[0,b(fh),52,5,53,33,[0,b(xI),[0,b(cE),0]]],aqd=b(vO),aqf=[0,b(d),0,1,0,1,0],aqb=[0,b(fh),68,5,69,33,[0,b(Gg),[0,b(cE),0]]],aqa=b(Gc),aqc=[0,b(d),0,1,0,1,0],ap_=[0,b(fh),86,5,87,33,[0,b(vv),[0,b(cE),0]]],ap9=b(F$),ap$=[0,b(d),0,1,0,1,0],ap7=[0,b(fh),g5,5,g5,34,[0,b(Ej),[0,b(cE),0]]],ap6=b(Iy),ap8=[0,b(d),0,1,0,1,0],aqj=[0,b(d),0,1,0,1,0],ap4=[0,b(fh),10,13,10,42,[0,b(cE),0]],aqn=[0,b(fh),10,13,10,42,[0,b(cE),0]],aqk=[0,b(d),0,1,0,1,0],ap5=[0,b(fh),6,12,6,19,[0,b(cE),0]],aql=[0,0,1],aqm=[0,b(hh),[0,b(bO),0]],apX=[0,b(z),Hx,14,Hx,28,[0,b(i2),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apW=b(r),apY=[0,b(d),0,1,0,1,0],apV=[0,b(z),HU,14,HU,28,[0,b(iY),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apU=b(r),apZ=[0,b(d),0,1,0,1,0],ap0=[0,b(d),0,1,0,1,0],apN=[0,b(z),v_,20,v_,55,[0,b(iY),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apK=b(r),apL=b(r),apM=b(iX),apO=[0,b(d),0,1,0,1,0],apI=[0,b(z),DH,20,DH,51,[0,b(iY),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apF=b(r),apG=b(r),apH=b(iX),apJ=[0,b(d),0,1,0,1,0],apD=[0,b(z),Ef,7,Ef,42,[0,b(i2),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apz=b(bf),apA=b(dy),apB=b(iX),apC=b(r),apE=[0,b(d),0,1,0,1,0],apx=[0,b(z),IA,7,IA,51,[0,b(i2),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apt=b(bf),apu=b(dy),apv=b(iX),apw=b(r),apy=[0,b(d),0,1,0,1,0],apP=[0,b(d),0,1,0,1,0],apm=[0,b(z),zd,14,zd,36,[0,b(iY),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apn=[0,b(d),0,1,0,1,0],apk=[0,b(z),vl,14,vl,36,[0,b(i2),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apj=b(cH),apl=[0,b(d),0,1,0,1,0],apo=[0,b(d),0,1,0,1,0],apb=[0,b(z),C7,14,C7,36,[0,b(i2),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apc=[0,b(d),0,1,0,1,0],apa=[0,b(z),En,14,En,36,[0,b(iY),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],apd=[0,b(d),0,1,0,1,0],ape=[0,b(d),0,1,0,1,0],ao7=[0,b(z),z6,14,z6,36,[0,b("Article R824-3"),[0,b(dX),[0,b(dZ),[0,b(ak),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],ao2=[0,0],ao3=[1,0],ao4=[1,0],ao5=[0,0],ao6=[0,0],ao8=[0,b(d),0,1,0,1,0],ao1=[0,b(o),x1,11,x1,33,[0,b(iO),[0,b(P),[0,b(p),0]]]],ao9=[0,0,0],ao_=[0,b(iW),[0,b("mode_occupation_impay\xc3\xa9"),0]],apf=[0,b(d),0,1,0,1,0],ao$=[0,b(o),vI,11,vI,33,[0,b(iO),[0,b(P),[0,b(p),0]]]],apg=[0,0,0],aph=[0,b(iW),[0,b("d\xc3\xa9pense_logement_brute"),0]],app=[0,b(d),0,1,0,1,0],api=[0,b(o),uO,11,uO,33,[0,b(iO),[0,b(P),[0,b(p),0]]]],apq=[0,0,0],apr=[0,b(iW),[0,b("d\xc3\xa9pense_logement_nette"),0]],apQ=[0,b(d),0,1,0,1,0],aps=[0,b(o),A_,11,A_,43,[0,b(iO),[0,b(P),[0,b(p),0]]]],apR=[0,0,0],apS=[0,b(iW),[0,b("seuil_impay\xc3\xa9_d\xc3\xa9pense_de_logement"),0]],ap1=[0,b(d),0,1,0,1,0],apT=[0,b(o),Ag,12,Ag,26,[0,b(iO),[0,b(P),[0,b(p),0]]]],ap2=[0,0,1],ap3=[0,b(iW),[0,b("montant_impay\xc3\xa9"),0]],aoU=[0,b(df),f1,5,f1,42,[0,b(mq),[0,b(j8),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ik),[0,b(X),[0,b(ae),0]]]]]]]]]],aoV=[0,b(d),0,1,0,1,0],aoS=[0,b(df),fc,5,fc,41,[0,b(ij),[0,b(iI),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ix),[0,b(ba),[0,b(ae),0]]]]]]]]]],aoT=[0,b(d),0,1,0,1,0],aoQ=[0,b(df),o4,5,267,42,[0,b(ij),[0,b(iI),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ix),[0,b(ba),[0,b(ae),0]]]]]]]]]],aoR=[0,b(d),0,1,0,1,0],aoN=b("1952"),aoO=[0,b(df),pi,5,pi,48,[0,b(ij),[0,b(iI),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ix),[0,b(ba),[0,b(ae),0]]]]]]]]]],aoP=[0,b(d),0,1,0,1,0],aoK=b("1953"),aoL=[0,b(df),w9,5,w9,48,[0,b(ij),[0,b(iI),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ix),[0,b(ba),[0,b(ae),0]]]]]]]]]],aoM=[0,b(d),0,1,0,1,0],aoH=b("1954"),aoI=[0,b(df),m3,5,m3,48,[0,b(ij),[0,b(iI),[0,b(eI),[0,b(eO),[0,b(eY),[0,b(eQ),[0,b(ix),[0,b(ba),[0,b(ae),0]]]]]]]]]],aoJ=[0,b(d),0,1,0,1,0],aoW=[0,b(d),0,1,0,1,0],aoX=[0,b(d),0,1,0,1,0],aoG=[0,b(o),gY,12,gY,31,[0,b("Date d'ouverture des droits \xc3\xa0 la retraite"),[0,b(P),[0,b(p),0]]]],aoY=[0,0,1],aoZ=[0,b(q4),[0,b("\xc3\xa2ge_ouverture_droit"),0]],aoC=[0,b(z),AP,14,AP,36,[0,b(eE),[0,b(aw),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]],aoo=b(r),aop=b(z7),aoq=b(u4),aor=b(y),aos=b(gz),aot=b(T),aou=b(m$),aov=b(Z),aow=b(o7),aox=b(_),aoy=b(mj),aoz=b(_),aoA=b(h7),aoB=b(mj),aoD=[0,b(d),0,1,0,1,0],aon=[0,b(o),AH,12,AH,34,[0,b(aa),[0,b(S),[0,b(B),[0,b(p),0]]]]],aoE=[0,0,1],aoF=[0,b(iG),[0,b(uS),0]],aoj=[0,b(z),Ix,14,Ix,36,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],aob=b(aD),aoc=[0,b(z),5527,5,5528,34,[0,b(gI),[0,b(f3),[0,b(dD),[0,b(w),[0,b(A),[0,b(v),0]]]]]]],aoa=b(dy),aod=[0,b(d),0,1,0,1,0],an$=[0,b(z),wa,5,wa,26,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],an7=b(_),an8=b(_),an9=b(h7),an_=b(by),aoe=[0,b(d),0,1,0,1,0],an6=[0,b(z),D0,14,D0,47,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],an2=b(_),an3=b(_),an4=b(h7),an5=b(by),anW=[0,b(z),wr,5,wr,26,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],anM=b(r),anN=b("1.2"),anO=b("1.5"),anP=b(y),anQ=b(gz),anR=b(T),anS=b(m$),anT=b(Z),anU=b(o7),anV=b(mj),anX=[0,b(d),0,1,0,1,0],anL=[0,b(z),BY,14,BY,41,[0,b(b8),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],anB=b(r),anC=b(z7),anD=b(u4),anE=b(y),anF=b(gz),anG=b(T),anH=b(m$),anI=b(Z),anJ=b(o7),anK=b(mj),anv=[0,b(o),kN,12,kN,52,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],anw=[0,b(d),0,1,0,1,0],anx=[0,b(d),0,1,0,1,0],anu=[0,b(o),kN,12,kN,52,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],any=[0,2,0],anz=[0,b(ff),[0,b(By),0]],anY=[0,b(d),0,1,0,1,0],anA=[0,b(o),x2,11,x2,38,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],anZ=[0,0,0],an0=[0,b(ff),[0,b("n_nombre_parts_d832_25_base"),0]],aof=[0,b(d),0,1,0,1,0],an1=[0,b(o),C6,11,C6,44,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],aog=[0,0,0],aoh=[0,b(ff),[0,b("n_nombre_parts_d832_25_majoration"),0]],aok=[0,b(d),0,1,0,1,0],aoi=[0,b(o),zP,12,zP,34,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],aol=[0,0,1],aom=[0,b(ff),[0,b(rj),0]],anp=[0,b(z),Hy,5,Hy,26,[0,b(qS),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],ann=b(by),anm=b(cH),ano=b(by),anq=[0,b(d),0,1,0,1,0],anl=[0,b(z),z3,14,z3,21,[0,b(qS),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],anj=b(by),ani=b(cH),ank=b(by),and=[0,b(z),uk,14,uk,50,[0,b(qS),[0,b(a$),[0,b(as),[0,b(an),[0,b(ah),[0,b(w),[0,b(A),[0,b(v),0]]]]]]]]],anc=[1,0],am8=[0,b(K),Ct,5,Ct,26,[0,b(qc),[0,b(eJ),[0,b(J),0]]]],amT=b("0.328"),amU=b(Dz),amV=[1,0],amW=b(uU),amX=b(zR),amY=b(Dz),amZ=b(ut),am0=b(wB),am1=b(zR),am2=b("0.024"),am3=b(vd),am4=b(wB),am5=b(by),am6=b(r),am7=b(vd),am9=[0,b(d),0,1,0,1,0],amS=[0,b(K),Ad,14,Ad,38,[0,b(qc),[0,b(eJ),[0,b(J),0]]]],amA=b("0.48"),amB=b(C8),amC=[1,0],amD=b(rC),amE=b(Et),amF=b(C8),amG=b("0.264"),amH=b(wi),amI=b(Et),amJ=b("0.216"),amK=b(HJ),amL=b(wi),amM=b("0.104"),amN=b(DQ),amO=b(HJ),amP=b(yX),amQ=b(r),amR=b(DQ),amv=[0,b(K),xP,14,xP,41,[0,b(qc),[0,b(eJ),[0,b(J),0]]]],amt=b("7632"),amu=b("4557"),amw=[0,b(d),0,1,0,1,0],ams=[0,b(o),A2,11,A2,38,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],amx=[0,0,0],amy=[0,b(dL),[0,b("montant_forfaitaire_d832_26"),0]],am_=[0,b(d),0,1,0,1,0],amz=[0,b(o),El,11,El,35,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],am$=[0,0,0],ana=[0,b(dL),[0,b("tranches_revenus_d832_26"),0]],ane=[0,b(d),0,1,0,1,0],anb=[0,b(o),xC,11,xC,47,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],anf=[0,0,0],ang=[0,b(dL),[0,b("tranches_revenus_d832_26_multipli\xc3\xa9es"),0]],anr=[0,b(d),0,1,0,1,0],anh=[0,b(o),DK,12,DK,19,[0,b(ad),[0,b(S),[0,b(B),[0,b(p),0]]]]],ans=[0,0,1],ant=[0,b(dL),[0,b(bO),0]],aml=[0,b(dm),472,5,qh,42,[0,b("Article LO6414-1"),[0,b("Chapitre IV : Comp\xc3\xa9tences"),[0,b("Titre Ier : Dispositions g\xc3\xa9n\xc3\xa9rales"),[0,b("Livre IV : Saint-Pierre-et-Miquelon"),[0,b("Sixi\xc3\xa8me partie : collectivit\xc3\xa9s d'outre-mer r\xc3\xa9gies par l'article 74 de la constitution"),[0,b(X),[0,b("Code g\xc3\xa9n\xc3\xa9ral des collectivit\xc3\xa9s territoriales"),0]]]]]]]],amk=b(r),amm=[0,b(d),0,1,0,1,0],amj=[0,b(dm),g0,5,g0,34,[0,b(ce),[0,b(qN),[0,b(rE),0]]]],amn=[0,b(d),0,1,0,1,0],ami=[0,b(o),E0,12,E0,19,[0,b(go),[0,b(B),[0,b(p),0]]]],ame=[0,b(dm),yz,39,yz,68,[0,b(mH),[0,b(qN),[0,b(rE),0]]]],amd=b(jW),al8=[0,b(df),37,9,37,20,[0,b("Article L136-1-3"),[0,b("Section 1 : De la contribution sociale sur les revenus d'activit\xc3\xa9 et sur les revenus de remplacement"),[0,b("Chapitre 6 : Contribution sociale g\xc3\xa9n\xc3\xa9ralis\xc3\xa9e"),[0,b(ik),[0,b(X),[0,b(ae),0]]]]]]],al9=[0,b(d),0,1,0,1,0],al7=[0,b(o),k_,11,k_,22,[0,b(go),[0,b(B),[0,b(p),0]]]],al_=[0,b(d),0,1,0,1,0],al6=[0,b(o),k_,11,k_,22,[0,b(go),[0,b(B),[0,b(p),0]]]],al$=[0,0,0],ama=[0,b(bm),[0,b("exon\xc3\xa9r\xc3\xa9_csg"),0]],amb=[0,b(o),kQ,13,kQ,42,[0,b(go),[0,b(B),[0,b(p),0]]]],amr=[0,b(o),kQ,13,kQ,42,[0,b(go),[0,b(B),[0,b(p),0]]]],amf=[0,b(d),0,1,0,1,0],amc=[0,b(o),Hp,11,Hp,20,[0,b(go),[0,b(B),[0,b(p),0]]]],amg=[0,0,0],amh=[0,b(bm),[0,b("taux_crds"),0]],amq=[0,b(dm),gq,13,gq,24,[0,b(ce),[0,b(qN),[0,b(rE),0]]]],amo=[0,0,1],amp=[0,b(bm),[0,b(bO),0]],al2=b(Ht),al3=b(fo),al4=b(xU),al5=[0,b("V\xc3\xa9rification\xc3\x82geSup\xc3\xa9rieur\xc3\x80_in"),0],alY=b(Ht),alZ=b(fo),al0=b(xU),al1=[0,b("V\xc3\xa9rification\xc3\x82geInf\xc3\xa9rieurOu\xc3\x89gal\xc3\x80_in"),0],alL=b("cat\xc3\xa9gorie_\xc3\xa9quivalence_loyer_d842_16_in"),alM=b(fo),alN=b(g4),alO=b(gD),alP=b(g$),alQ=b(iP),alR=b(Fy),alS=b(gW),alT=b(us),alU=b(HK),alV=b(zk),alW=[0,b("CalculAllocationLogementFoyer_in"),0],alu=b("op\xc3\xa9rations_logement_\xc3\xa9volutifs_sociaux_accession_propri\xc3\xa9t\xc3\xa9_aid\xc3\xa9e_\xc3\x89tat_in"),alv=b(E6),alw=b("charges_mensuelles_pr\xc3\xaat_in"),alx=b(wv),aly=b(xK),alz=b(wb),alA=b(uh),alB=b(Fe),alC=b(vs),alD=b(fo),alE=b(gW),alF=b(g4),alG=b(gD),alH=b(g$),alI=b("ressources_m\xc3\xa9nage_arrondies_base_in"),alJ=[0,b("CalculAllocationLogementAccessionPropri\xc3\xa9t\xc3\xa9_in"),0],ald=b("changement_logement_d842_4_in"),ale=b(gW),alf=b(uG),alg=b(FP),alh=b(F2),ali=b(yB),alj=b(FX),alk=b(Iq),all=b(g4),alm=b(gD),aln=b(g$),alo=b(fo),alp=b(Bm),alq=b(iP),alr=b("loyer_principal_in"),als=[0,b("CalculAllocationLogementLocatif_in"),0],akZ=b(gW),ak0=b(fo),ak1=b("anciennet\xc3\xa9_logement_in"),ak2=b("type_pr\xc3\xaat_in"),ak3=b(g4),ak4=b(Fe),ak5=b(E6),ak6=b(wv),ak7=b(xK),ak8=b(uh),ak9=b(wb),ak_=b(gD),ak$=b(g$),ala=b(iP),alb=b(vs),alc=[0,b("CalculAidePersonnalis\xc3\xa9eLogementAccessionPropri\xc3\xa9t\xc3\xa9_in"),0],akK=b("n_nombre_parts_d832_25_in"),akL=b("limitation_majoration_personnes_\xc3\xa0_charge_in"),akM=b("condition_2_du_832_25_in"),akN=b(Fy),akO=b(fo),akP=b(g4),akQ=b(gD),akR=b(g$),akS=b(iP),akT=b(us),akU=b(zk),akV=b(HK),akW=b(gW),akX=[0,b("CalculAidePersonnalis\xc3\xa9eLogementFoyer_in"),0],aku=b(gW),akv=b(uG),akw=b(FP),akx=b(F2),aky=b(yB),akz=b(FX),akA=b(Iq),akB=b(g4),akC=b(gD),akD=b(g$),akE=b(fo),akF=b(Bm),akG=b(iP),akH=b("loyer_principal_base_in"),akI=[0,b("CalculAidePersonnalis\xc3\xa9eLogementLocatif_in"),0],akj=b("r\xc3\xa9sidence"),akk=b("personnes_\xc3\xa2g\xc3\xa9es_handicap\xc3\xa9es_foyer_r844_4"),akl=b("enfant_\xc3\xa0_na\xc3\xaetre_apr\xc3\xa8s_quatri\xc3\xa8me_mois_grossesse"),akm=b("condition_rattach\xc3\xa9_foyer_fiscal_parent_ifi"),akn=b("situation_familiale"),ako=b("nombre_autres_occupants_logement"),akp=b("personnes_\xc3\xa0_charge"),akq=b("logement"),akr=b("prestations_re\xc3\xa7ues"),aks=[0,b("M\xc3\xa9nage"),0],aka=b("zone"),akb=b("surface_m_carr\xc3\xa9s"),akc=b("logement_decent_l89_462"),akd=b("usufruit"),ake=b("lou\xc3\xa9_ou_sous_lou\xc3\xa9_\xc3\xa0_des_tiers"),akf=b("propri\xc3\xa9taire"),akg=b("mode_occupation"),akh=b("r\xc3\xa9sidence_principale"),aki=[0,b("Logement"),0],aj6=b(Eu),aj8=b("R\xc3\xa9sidentLogementFoyer"),aj9=b("AccessionPropri\xc3\xa9t\xc3\xa9LocalUsageExclusifHabitation"),aj_=b(zu),aj$=b(v1),aj7=[0,b("ModeOccupation"),0],aj2=b(Be),aj4=b("AccessionPropri\xc3\xa9t\xc3\xa9"),aj5=b(v3),aj3=[0,b("Cat\xc3\xa9gorieCalculAPL"),0],ajZ=b(zZ),aj1=b(y6),aj0=[0,b("Personne\xc3\x80Charge"),0],ajQ=b("changement_logement_d842_4"),ajR=b(AV),ajS=b("\xc3\xa2g\xc3\xa9es_ou_handicap_adultes_h\xc3\xa9berg\xc3\xa9es_on\xc3\xa9reux_particuliers"),ajT=b(Bt),ajU=b(v8),ajV=b(zE),ajW=b("loyer_principal"),ajX=b("bailleur"),ajY=[0,b(Be),0],ajH=b("\xc3\xa9tudes_apprentissage_stage_formation_pro_impossibilit\xc3\xa9_travail"),ajI=b("situation_garde_altern\xc3\xa9e"),ajJ=b(pK),ajK=b(pn),ajL=b(qx),ajM=b(pk),ajN=b(DU),ajO=b(qT),ajP=[0,b(zZ),0],ajB=b("magistrat_fonctionnaire_centre_int\xc3\xa9r\xc3\xaats_mat\xc3\xa9riels_familiaux_hors_mayotte"),ajC=b("est_non_salari\xc3\xa9_agricole_l781_8_l_781_46_code_rural"),ajD=b("personne_h\xc3\xa9berg\xc3\xa9e_centre_soin_l_L162_22_3_s\xc3\xa9curit\xc3\xa9_sociale"),ajE=b(DU),ajF=b(FQ),ajG=[0,b(o2),0],ajp=b("op\xc3\xa9rations_logement_\xc3\xa9volutifs_sociaux_accession_propri\xc3\xa9t\xc3\xa9_aid\xc3\xa9e_\xc3\x89tat"),ajq=b("pr\xc3\xaat"),ajr=b("anciennet\xc3\xa9_logement"),ajs=b("situation_r822_11_13_17"),ajt=b("copropri\xc3\xa9t\xc3\xa9"),aju=b("local_habit\xc3\xa9_premi\xc3\xa8re_fois_b\xc3\xa9n\xc3\xa9ficiaire"),ajv=b("type_travaux_logement_r842_5"),ajw=b("type_travaux_logement_d832_15"),ajx=b("date_entr\xc3\xa9e_logement"),ajy=b("charges_mensuelles_pr\xc3\xaat"),ajz=b("mensualit\xc3\xa9_principale"),ajA=[0,b("Propri\xc3\xa9taire"),0],ajm=b(xN),ajo=b(EK),ajn=[0,b("ChangementLogementD842_4"),0],ajj=b("Fran\xc3\xa7aise"),ajl=b("\xc3\x89trang\xc3\xa8re"),ajk=[0,b("Nationalit\xc3\xa9"),0],ajg=b(nt),aji=b(nG),ajh=[0,b("Lou\xc3\xa9OuSousLou\xc3\xa9\xc3\x80DesTiers"),0],ajc=b(y$),aje=b("BailleurPriv\xc3\xa9AvecConventionnementSocial"),ajf=b("BailleurPriv\xc3\xa9"),ajd=[0,b("TypeBailleur"),0],ai8=b(pk),ai9=b(qx),ai_=b(pn),ai$=b(pK),aja=b(qT),ajb=[0,b("EnfantPrestationsFamiliales"),0],aiU=b(Bt),aiV=b(v8),aiW=b(AV),aiX=b(zE),aiY=b("cat\xc3\xa9gorie_\xc3\xa9quivalence_loyer_d842_16"),aiZ=b("redevance"),ai0=b("construit_application_loi_1957_12_III"),ai1=b("date_conventionnement"),ai2=b("conventionn\xc3\xa9_selon_r\xc3\xa8gles_drom"),ai3=b(Il),ai4=b("remplit_conditions_r832_21"),ai5=b("logement_foyer_jeunes_travailleurs"),ai6=b("type"),ai7=[0,b(v3),0],aiP=b("accord_financement_repr\xc3\xa9sentant_\xc3\x89tat_outre_mer"),aiQ=b("titulaire_pr\xc3\xaat"),aiR=b("date_signature"),aiS=b("type_pr\xc3\xaat"),aiT=[0,b("Pr\xc3\xaat"),0],aiH=b("titulaire_allocation_personne_\xc3\xa2g\xc3\xa9e"),aiI=b("b\xc3\xa9n\xc3\xa9ficiaire_l161_19_l351_8_l643_3_s\xc3\xa9cu"),aiJ=b("incapacit\xc3\xa9_80_pourcent_ou_restriction_emploi"),aiK=b("parent\xc3\xa9"),aiL=b("ascendant_descendant_collat\xc3\xa9ral_deuxi\xc3\xa8me_troisi\xc3\xa8me_degr\xc3\xa9"),aiM=b("ressources"),aiN=b(FQ),aiO=[0,b(y6),0],aiD=b(BB),aiE=b(BN),aiF=b(Aq),aiG=[0,b("TrancheRevenuD\xc3\xa9cimal"),0],aiy=b(BB),aiz=b(BN),aiA=b(Aq),aiB=[0,b("TrancheRevenu"),0],aiu=b(Fk),aiw=b(zh),aiv=[0,b("NeufOuAncien"),0],ais=b(pp),ait=[0,b(d0),0],aiq=b(pL),air=[0,b(fO),0],aii=b(aA),aij=b(cO),aik=b(A$),ail=b(qi),aim=b(BF),ain=b(kk),aio=[0,b(af),0],aib=b(aA),aic=b(cO),aid=b(kk),aie=b(kl),aif=b(ns),aig=[0,b(L),0],ah4=b(k0),ah5=b(nh),ah6=b(lr),ah7=b(m2),ah8=b(km),ah9=b(aA),ah_=b(cO),ah$=[0,b(a8),0],ah1=b("ancienne_allocation_logement"),ah2=b("ancien_loyer_principal"),ah3=[0,b("InfosChangementLogementD842_4"),0],ahY=b(aA),ahZ=b(cO),ah0=[0,b("Traitement_formule_aide_finale"),0],ahS=b(aA),ahT=b(cO),ahU=b("coefficient_prise_en_charge_d832_10"),ahV=b(kl),ahW=b(ns),ahX=[0,b(aj),0],ahH=b(aA),ahI=b(cO),ahJ=b("coefficient_prise_en_charge_d832_25"),ahK=b(BP),ahL=b(EW),ahM=b(Do),ahN=b(rj),ahO=b(Aa),ahP=b(xY),ahQ=[0,b(aq),0],ahy=b(aA),ahz=b(cO),ahA=b(k0),ahB=b(nh),ahC=b(lr),ahD=b(m2),ahE=b(km),ahF=[0,b(au),0],ahu=b("satisfait_art_4_ordonnance_2002_mayotte"),ahv=b("satisfait_conditions_l512_2_code_s\xc3\xa9curit\xc3\xa9_sociale"),ahw=[0,b("Conditions\xc3\x89trangers"),0],ahr=b("conforme_article_l442_1"),ahs=b("date_naissance_personne_sous_location"),aht=[0,b("PersonneSousLocation"),0],ahp=b("conventionn\xc3\xa9_livre_III_titre_II_chap_I_sec_3"),ahq=[0,b("ConventionANHA"),0],ahm=b("r\xc3\xa9duction_loyer_solidarit\xc3\xa9_per\xc3\xa7ue"),ahn=b(Il),aho=[0,b("ConventionBailleurSocial"),0],ahi=b(ic),ahk=b(h9),ahl=b(Gm),ahj=[0,b(GL),0],ag_=b(l4),aha=b(li),ahb=b(j4),ahc=b(G9),ahd=b(wt),ahe=b(nI),ahf=b(GP),ahg=b(kv),ahh=b(ls),ag$=[0,b(Ga),0],ag7=b(Ia),ag9=b(xq),ag8=[0,b("SituationFamilialeCalculAPL"),0],ag2=b("\xc3\x89tudiantLog\xc3\xa9EnChambreCROUS"),ag4=b("\xc3\x89tudiantLog\xc3\xa9EnChambreCROUSR\xc3\xa9habilit\xc3\xa9e"),ag5=b("Personnes\xc3\x82g\xc3\xa9esSelon3DeD842_16"),ag6=b(H_),ag3=[0,b("Cat\xc3\xa9gorie\xc3\x89quivalenceLoyerAllocationLogementFoyer"),0],agX=b("LogementPersonnes\xc3\x82g\xc3\xa9esOuHandicap\xc3\xa9es"),agZ=b("R\xc3\xa9sidenceSociale"),ag0=b("FoyerJeunesTravailleursOuMigrantsConventionn\xc3\xa9L353_2Avant1995"),ag1=b(gA),agY=[0,b("TypeLogementFoyer"),0],agQ=b("C\xc3\xa9libataire"),agS=b("Mari\xc3\xa9s"),agT=b("Pacs\xc3\xa9s"),agU=b(ww),agV=b("C\xc3\xa9libataireS\xc3\xa9par\xc3\xa9DeFait"),agW=b("ConcubinageDontS\xc3\xa9par\xc3\xa9DeFait"),agR=[0,b("SituationFamiliale"),0],agM=b("AidePersonnalis\xc3\xa9eLogement"),agO=b(nv),agP=b(ku),agN=[0,b("TypeAidesPersonnelleLogement"),0],agJ=b(AN),agL=b(uH),agK=[0,b("AccordFinancementRepr\xc3\xa9sentant\xc3\x89tatOutreMer"),0],agF=b("Pas\xc3\x89ligible"),agH=b(nv),agI=b(ku),agG=[0,b("Type\xc3\x89ligibilit\xc3\xa9AllocationLogement"),0],agC=b("Impay\xc3\xa9Loyer"),agE=b("Impay\xc3\xa9Pr\xc3\xaat"),agD=[0,b("ModeOccupationImpay\xc3\xa9"),0],agx=b("TotalAnnuel\xc3\x89ch\xc3\xa9ances"),agz=b("Mensualit\xc3\xa9"),agA=b(Iv),agy=[0,b("D\xc3\xa9penseLogement"),0],agt=b(wI),agv=b(Cg),agw=b(Ee),agu=[0,b("ZoneDHabitation"),0],agp=b(x9),agr=b(FF),ags=b("Collat\xc3\xa9ralDeuxi\xc3\xa8meTroisi\xc3\xa8meDegr\xc3\xa9"),agq=[0,b("Parent\xc3\xa9"),0],agm=b("PasDeGardeAltern\xc3\xa9e"),ago=b("GardeAltern\xc3\xa9eCoefficientPriseEnCharge"),agn=[0,b("SituationGardeAltern\xc3\xa9e"),0],agj=b("DemandeurOuConjointOuParentOuViaPartsSoci\xc3\xa9t\xc3\xa9s"),agl=b(gA),agk=[0,b("ParentOuAutre"),0],age=b(V),agg=b("Compl\xc3\xa9mentFamilial"),agh=b(G6),agi=b("AllocationSoutienEnfantHandicap\xc3\xa9"),agf=[0,b("PrestationRe\xc3\xa7ue"),0],aga=b(HN),agc=b(Cb),agb=[0,b("LimiteTrancheD\xc3\xa9cimal"),0],af9=b(HN),af$=b(Cb),af_=[0,b("LimiteTranche"),0],af6=b(nG),af8=b(nt),af7=[0,b("Am\xc3\xa9lior\xc3\xa9ParOccupant"),0],af1=b("ObjectifD\xc3\xa9cenceLogement"),af3=b("Pr\xc3\xa9vuDansListeR321_15"),af4=b(Gp),af5=b(lg),af2=[0,b("TypeTravauxLogementR842_5"),0],afX=b(vG),afZ=b("TravauxSurLogementD\xc3\xa9j\xc3\xa0AcquisD832_15_2"),af0=b(lg),afY=[0,b("TypeTravauxLogementD832_15"),0],afU=b(o2),afW=b(vV),afV=[0,b("TitulairePr\xc3\xaat"),0],afO=b(yk),afQ=b(vS),afR=b(E5),afS=b(xi),afT=b(gA),afP=[0,b("TypePr\xc3\xaat"),0],b0b=b(d),bZN=b("The function 'age_l512_3_2_in' translation isn't yet supported..."),bZK=b("The function 'n_nombre_parts_d832_25_in' translation isn't yet supported..."),bZL=b(H2),bZM=b("The function 'condition_2_du_832_25_in' translation isn't yet supported..."),bZJ=b(H2),bZG=b("The function 'date_entree_vigueur_differee_cch_in' translation isn't yet supported..."),bZH=b("The function 'condition_logement_surface_in' translation isn't yet supported..."),bZI=b("The function 'condition_logement_residence_principale_in' translation isn't yet supported..."),bZA=b("AccessionProprieteLocalUsageExclusifHabitation"),bZB=b(Eu),bZC=b(v1),bZD=b("ResidentLogementFoyer"),bZE=b(zu),bZF=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'ModeOccupation.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'ModeOccupation.t'")],bZx=b("AutrePersonneACharge"),bZy=b("EnfantACharge"),bZz=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'PersonneACharge.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'PersonneACharge.t'")],bZt=b(xN),bZu=b(EK),bZw=[1,0],bZv=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'ChangementLogementD8424.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'ChangementLogementD8424.t'")],bZp=b("Etrangere"),bZq=b("Francaise"),bZs=[0,0],bZr=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'Nationalite.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'Nationalite.t'")],bZl=b(nt),bZm=b(nG),bZo=[0,0],bZn=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'LoueOuSousLoueADesTiers.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'LoueOuSousLoueADesTiers.t'")],bZg=b("BailleurPrive"),bZh=b("BailleurPriveAvecConventionnementSocial"),bZi=b(y$),bZk=[2,0],bZj=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TypeBailleur.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TypeBailleur.t'")],bZc=b("MoinsDeTroisEnfants"),bZd=b("PlusDeTroisEnfants"),bZf=[0,0],bZe=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'DateNaissanceTroisiemeOuDernierPlusEnfant.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'DateNaissanceTroisiemeOuDernierPlusEnfant.t'")],bY_=b(zh),bY$=b(Fk),bZb=[0,0],bZa=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'NeufOuAncien.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'NeufOuAncien.t'")],bY3=b(ri),bY4=b(ic),bY5=b(h9),bY7=[1,0],bY8=[0,0],bY9=[2,0],bY6=[0,[11,b(bp),[2,0,[11,b(v5),0]]],b(CA)],bYK=b(l4),bYL=b(li),bYM=b(Cx),bYN=b(j4),bYO=b(ls),bYP=b(AO),bYQ=b(vJ),bYR=b(nI),bYS=b(kv),bYU=[7,0],bYV=[5,0],bYW=[4,0],bYX=[6,0],bYY=[8,0],bYZ=[2,0],bY0=[3,0],bY1=[1,0],bY2=[0,0],bYT=[0,[11,b(bp),[2,0,[11,b(yu),0]]],b(vq)],bYF=b(xq),bYG=b(Ia),bYI=[0,0],bYJ=[1,0],bYH=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'SituationFamilialeCalculAPL.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'SituationFamilialeCalculAPL.t'")],bYw=b(H_),bYx=b("EtudiantLogeEnChambreCROUS"),bYy=b("EtudiantLogeEnChambreCROUSRehabilitee"),bYz=b("PersonnesAgeesSelon3DeD842_16"),bYB=[2,0],bYC=[1,0],bYD=[0,0],bYE=[3,0],bYA=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'CategorieEquivalenceLoyerAllocationLogementFoyer.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'CategorieEquivalenceLoyerAllocationLogementFoyer.t'")],bYn=b(gA),bYo=b("FoyerJeunesTravailleursOuMigrantsConventionneL353_2Avant1995"),bYp=b("LogementPersonnesAgeesOuHandicapees"),bYq=b("ResidenceSociale"),bYs=[1,0],bYt=[0,0],bYu=[2,0],bYv=[3,0],bYr=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TypeLogementFoyer.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TypeLogementFoyer.t'")],bYb=b("Celibataire"),bYc=b("CelibataireSepareDeFait"),bYd=b("ConcubinageDontSepareDeFait"),bYe=b(ww),bYf=b("Maries"),bYg=b("Pacses"),bYi=[2,0],bYj=[3,0],bYk=[5,0],bYl=[4,0],bYm=[0,0],bYh=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'SituationFamiliale.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'SituationFamiliale.t'")],bX6=b("AidePersonnaliseeLogement"),bX7=b(nv),bX8=b(ku),bX_=[2,0],bX$=[1,0],bYa=[0,0],bX9=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TypeAidesPersonnelleLogement.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TypeAidesPersonnelleLogement.t'")],bX2=b(AN),bX3=b(uH),bX5=[1,0],bX4=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'AccordFinancementRepresentantEtatOutreMer.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'AccordFinancementRepresentantEtatOutreMer.t'")],bXY=b(Iv),bXZ=b("Mensualite"),bX0=b("TotalAnnuelEcheances"),bX1=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'DepenseLogement.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'DepenseLogement.t'")],bXR=b("Bailleur"),bXS=b("Beneficiaire"),bXT=b("EtablissementHabilite"),bXV=[2,0],bXW=[1,0],bXX=[0,0],bXU=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'VersementA.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'VersementA.t'")],bXK=b(wI),bXL=b(Cg),bXM=b(Ee),bXO=[2,0],bXP=[1,0],bXQ=[0,0],bXN=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'ZoneDHabitation.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'ZoneDHabitation.t'")],bXE=b("ApresPremierJourMoisCivilTroisiemeMoisDeGrossesse"),bXF=b("AvantPremierJourMoisCivilTroisiemeMoisDeGrossesse"),bXG=b("DateDeNaissance"),bXI=[1,0],bXJ=[2,0],bXH=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'DateDeNaissanceOuMoisDeGrossesse.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'DateDeNaissanceOuMoisDeGrossesse.t'")],bXx=b(x9),bXy=b("CollateralDeuxiemeTroisiemeDegre"),bXz=b(FF),bXB=[1,0],bXC=[2,0],bXD=[0,0],bXA=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'Parente.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'Parente.t'")],bXt=b("GardeAlterneeCoefficientPriseEnCharge"),bXu=b("PasDeGardeAlternee"),bXw=[0,0],bXv=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'SituationGardeAlternee.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'SituationGardeAlternee.t'")],bXp=b(gA),bXq=b("DemandeurOuConjointOuParentOuViaPartsSocietes"),bXs=[1,0],bXr=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'ParentOuAutre.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'ParentOuAutre.t'")],bXg=b("AllocationSoutienEnfantHandicape"),bXh=b(G6),bXi=b(V),bXj=b("ComplementFamilial"),bXl=[1,0],bXm=[0,0],bXn=[2,0],bXo=[3,0],bXk=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'PrestationRecue.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'PrestationRecue.t'")],bXb=b(nt),bXc=b(nG),bXe=[0,0],bXf=[1,0],bXd=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'AmelioreParOccupant.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'AmelioreParOccupant.t'")],bW4=b(Gp),bW5=b("ObjectifDecenceLogement"),bW6=b(lg),bW7=b("PrevuDansListeR321_15"),bW9=[1,0],bW_=[3,0],bW$=[0,0],bXa=[2,0],bW8=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TypeTravauxLogementR8425.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TypeTravauxLogementR8425.t'")],bWX=b(lg),bWY=b(vG),bWZ=b("TravauxSurLogementDejaAcquisD832_15_2"),bW1=[1,0],bW2=[0,0],bW3=[2,0],bW0=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TypeTravauxLogementD83215.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TypeTravauxLogementD83215.t'")],bWS=b(o2),bWT=b(vV),bWV=[1,0],bWW=[0,0],bWU=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TitulairePret.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TitulairePret.t'")],bWH=b(gA),bWI=b(yk),bWJ=b(E5),bWK=b(vS),bWL=b(xi),bWN=[3,0],bWO=[1,0],bWP=[2,0],bWQ=[0,0],bWR=[4,0],bWM=[0,[11,b(bp),[2,0,[11,b("' kind for the enumeration 'TypePret.t'"),0]]],b("Unexpected '%s' kind for the enumeration 'TypePret.t'")],bWF=[0,b(Is),b(wU),b(H9),b(vN),b(lB),b(fj),b(xT),b(lL),b(wA),b(B1),b(zB),b(DW),b(x3),b(D8),b(AM),b(GW),b(F0),b(EF),b(Bg),b(Gb),b(BR),b(CU),b(FC),b(um),b(nA)],bWG=[0,b(nA),b(lL),b(fj),b(GW),b(F0),b(EF),b(vN),b(BR),b(H9),b(B1),b(xT),b(Bg),b(x3),b(zB),b(D8),b(FC),b(wU),b(DW),b(Gb),b(um),b(CU),b(wA),b(Is),b(AM),b(lB)],b0B=b("AidesLogementLib"),b0D=b(d);function
bK(b){if(typeof
b==="number")return 0;else
switch(b[0]){case
0:return[0,bK(b[1])];case
1:return[1,bK(b[1])];case
2:return[2,bK(b[1])];case
3:return[3,bK(b[1])];case
4:return[4,bK(b[1])];case
5:return[5,bK(b[1])];case
6:return[6,bK(b[1])];case
7:return[7,bK(b[1])];case
8:var
d=b[1];return[8,d,bK(b[2])];case
9:var
c=b[1];return[9,c,c,bK(b[3])];case
10:return[10,bK(b[1])];case
11:return[11,bK(b[1])];case
12:return[12,bK(b[1])];case
13:return[13,bK(b[1])];default:return[14,bK(b[1])]}}function
cB(b,c){if(typeof
b==="number")return c;else
switch(b[0]){case
0:return[0,cB(b[1],c)];case
1:return[1,cB(b[1],c)];case
2:return[2,cB(b[1],c)];case
3:return[3,cB(b[1],c)];case
4:return[4,cB(b[1],c)];case
5:return[5,cB(b[1],c)];case
6:return[6,cB(b[1],c)];case
7:return[7,cB(b[1],c)];case
8:var
d=b[1];return[8,d,cB(b[2],c)];case
9:var
e=b[2],f=b[1];return[9,f,e,cB(b[3],c)];case
10:return[10,cB(b[1],c)];case
11:return[11,cB(b[1],c)];case
12:return[12,cB(b[1],c)];case
13:return[13,cB(b[1],c)];default:return[14,cB(b[1],c)]}}function
bD(b,c){if(typeof
b==="number")return c;else
switch(b[0]){case
0:return[0,bD(b[1],c)];case
1:return[1,bD(b[1],c)];case
2:var
d=b[1];return[2,d,bD(b[2],c)];case
3:var
e=b[1];return[3,e,bD(b[2],c)];case
4:var
f=b[3],a=b[2],g=b[1];return[4,g,a,f,bD(b[4],c)];case
5:var
h=b[3],i=b[2],j=b[1];return[5,j,i,h,bD(b[4],c)];case
6:var
k=b[3],l=b[2],m=b[1];return[6,m,l,k,bD(b[4],c)];case
7:var
n=b[3],o=b[2],p=b[1];return[7,p,o,n,bD(b[4],c)];case
8:var
q=b[3],r=b[2],s=b[1];return[8,s,r,q,bD(b[4],c)];case
9:var
t=b[1];return[9,t,bD(b[2],c)];case
10:return[10,bD(b[1],c)];case
11:var
u=b[1];return[11,u,bD(b[2],c)];case
12:var
v=b[1];return[12,v,bD(b[2],c)];case
13:var
w=b[2],x=b[1];return[13,x,w,bD(b[3],c)];case
14:var
y=b[2],z=b[1];return[14,z,y,bD(b[3],c)];case
15:return[15,bD(b[1],c)];case
16:return[16,bD(b[1],c)];case
17:var
A=b[1];return[17,A,bD(b[2],c)];case
18:var
B=b[1];return[18,B,bD(b[2],c)];case
19:return[19,bD(b[1],c)];case
20:var
C=b[2],D=b[1];return[20,D,C,bD(b[3],c)];case
21:var
E=b[1];return[21,E,bD(b[2],c)];case
22:return[22,bD(b[1],c)];case
23:var
F=b[1];return[23,F,bD(b[2],c)];default:var
G=b[2],H=b[1];return[24,H,G,bD(b[3],c)]}}function
n2(b,d,c){return b[1]===d?(b[1]=c,1):0}function
aE(b){throw[0,jc,b]}function
b$(b){throw[0,r5,b]}var
r6=[bl,JC,c1(0)];function
ht(b){return 0<=b?b:-b|0}var
r$=ho(JE),sa=ho(JF),JD=p3,JH=ho(JG);function
b1(e,d){var
b=aM(e),f=aM(d),c=b_(b+f|0);er(e,0,c,0,b);er(d,0,c,b,f);return cQ(c)}function
JI(b){return b?JJ:JK}b1h(0);var
JN=Jj(1),d5=Jj(2);function
JO(c){function
b(c){var
b=c;for(;;){if(b){var
d=b[2],e=b[1];try{et(e)}catch(b){b=n(b);if(b[1]!==r9)throw b;var
f=b}var
b=d;continue}return 0}}return b(b1i(0))}function
hu(c,b){return rT(c,b,0,aM(b))}function
sb(b){hu(d5,b);Jk(d5,10);return et(d5)}var
n5=[0,JO];function
JQ(d){for(;;){var
b=n5[1],e=[0,1],c=1-n2(n5,b,function(b,c){return function(e){if(n2(b,1,0))u(d,0);return u(c,0)}}(e,b));if(c)continue;return c}}function
n6(b){return u(n5[1],0)}rW(b(uj),n6);var
hv=(4*b1r(0)|0)-1|0;function
sc(b){if(0<=b&&!(qA<b))return b;return b$(JR)}function
e3(d){var
c=0,b=d;for(;;){if(b){var
c=c+1|0,b=b[2];continue}return c}}function
sd(b){return b?b[1]:aE(JY)}function
se(b){return b?b[2]:aE(JZ)}function
jd(e,d){if(0<=d){var
b=e,c=d;for(;;){if(b){var
f=b[2],a=b[1];if(0===c)return a;var
b=f,c=c-1|0;continue}return aE(J0)}}return b$(J1)}function
ev(e){var
b=e,c=0;for(;;){if(b){var
d=[0,b[1],c],b=b[2],c=d;continue}return c}}function
f6(c,b){if(b){var
d=b[2],e=u(c,b[1]);return[0,e,f6(c,d)]}return 0}function
fA(b,d){var
c=b_(b);b0X(c,0,b,d);return c}function
sf(d,c,b){if(0<=c&&0<=b&&!((dv(d)-b|0)<c)){var
e=b_(b);eZ(d,c,e,0,b);return e}return b$(J2)}function
je(d,c,b){return cQ(sf(d,c,b))}function
sg(f,d,e,c,b){if(0<=b&&0<=d&&!((dv(f)-b|0)<d)&&0<=c&&!((dv(e)-b|0)<c))return eZ(f,d,e,c,b);return b$(J3)}function
ew(f,d,e,c,b){if(0<=b&&0<=d&&!((aM(f)-b|0)<d)&&0<=c&&!((dv(e)-b|0)<c))return er(f,d,e,c,b);return b$(J4)}function
jf(c,b){return cQ(fA(c,b))}function
f7(d,c,b){return cQ(sf(fw(d),c,b))}function
hw(k,g){if(g){var
h=aM(k),d=0,c=g,p=0;for(;;){if(c){var
i=c[1];if(c[2]){var
j=(aM(i)+h|0)+d|0,m=c[2],n=d<=j?j:b$(J5),d=n,c=m;continue}var
l=aM(i)+d|0}else
var
l=d;var
a=b_(l),f=p,e=g;for(;;){if(e){var
b=e[1];if(e[2]){var
o=e[2];er(b,0,a,f,aM(b));er(k,0,a,f+aM(b)|0,h);var
f=(f+aM(b)|0)+h|0,e=o;continue}er(b,0,a,f,aM(b))}return cQ(a)}}}return J6}function
sh(f,e,d,c){var
b=d;for(;;){if(e<=b)throw di;if(dh(f,b)===c)return b;var
b=b+1|0;continue}}function
J7(b,c){return sh(b,aM(b),0,c)}function
J8(c,b,e){var
d=aM(c);if(0<=b&&!(d<b))try{sh(c,d,b,e);var
f=1;return f}catch(b){b=n(b);if(b===di)return 0;throw b}return b$(J9)}function
n7(c,b){return J8(c,0,b)}function
n8(a,c){var
d=[0,0],e=[0,aM(c)],f=aM(c)-1|0;if(!(f<0)){var
b=f;for(;;){if(dh(c,b)===a){var
h=d[1];d[1]=[0,f7(c,b+1|0,(e[1]-b|0)-1|0),h];e[1]=b}var
i=b-1|0;if(0!==b){var
b=i;continue}break}}var
g=d[1];return[0,f7(c,0,e[1]),g]}var
J_=rX;function
ck(e,c){var
d=c.length-1;if(0===d)return[0];var
f=nU(d,u(e,c[1])),a=d-1|0,g=1;if(!(a<1)){var
b=g;for(;;){f[1+b]=u(e,c[1+b]);var
h=b+1|0;if(a!==b){var
b=h;continue}break}}return f}function
hx(b){if(b){var
e=0,d=b,g=b[2],h=b[1];for(;;){if(d){var
e=e+1|0,d=d[2];continue}var
a=nU(e,h),f=1,c=g;for(;;){if(c){var
i=c[2];a[1+f]=c[1];var
f=f+1|0,c=i;continue}return a}}}return[0]}function
si(a,f,d){var
c=[0,f],e=d.length-1-1|0,g=0;if(!(e<0)){var
b=g;for(;;){c[1]=ar(a,c[1],d[1+b]);var
h=b+1|0;if(e!==b){var
b=h;continue}break}}return c[1]}function
n9(b){return je(b[2],b[5],b[6]-b[5]|0)}function
jg(f){function
a(b){return b?b[5]:0}function
d(c,g,f,b){var
d=a(c),e=a(b),h=e<=d?d+1|0:e+1|0;return[0,c,g,f,b,h]}function
n(c,b){return[0,0,c,b,0,1]}function
b(c,h,g,b){var
i=c?c[5]:0,j=b?b[5]:0;if((j+2|0)<i){if(c){var
e=c[4],m=c[3],n=c[2],k=c[1],q=a(e);if(q<=a(k))return d(k,n,m,d(e,h,g,b));if(e){var
r=e[3],s=e[2],t=e[1],u=d(e[4],h,g,b);return d(d(k,n,m,t),s,r,u)}return b$(Ka)}return b$(Kb)}if((i+2|0)<j){if(b){var
l=b[4],o=b[3],p=b[2],f=b[1],v=a(f);if(v<=a(l))return d(d(c,h,g,f),p,o,l);if(f){var
w=f[3],x=f[2],y=f[1],z=d(f[4],p,o,l);return d(d(c,h,g,y),x,w,z)}return b$(Kc)}return b$(Kd)}var
A=j<=i?i+1|0:j+1|0;return[0,c,h,g,b,A]}var
z=0;function
M(b){return b?0:1}function
k(e,d,c){if(c){var
a=c[4],h=c[3],i=c[2],g=c[1],n=c[5],j=ar(f[1],e,i);if(0===j)return h===d?c:[0,g,e,d,a,n];if(0<=j){var
l=k(e,d,a);return a===l?c:b(g,i,h,l)}var
m=k(e,d,g);return g===m?c:b(m,i,h,a)}return[0,0,e,d,0,1]}function
N(e,d){var
b=d;for(;;){if(b){var
a=b[4],g=b[3],h=b[1],c=ar(f[1],e,b[2]);if(0===c)return g;var
i=0<=c?a:h,b=i;continue}throw di}}function
O(a,k){var
c=k;for(;;){if(c){var
g=c[2],l=c[4],m=c[3],n=c[1];if(u(a,g)){var
e=g,d=m,b=n;for(;;){if(b){var
f=b[2],h=b[4],i=b[3],j=b[1];if(u(a,f)){var
e=f,d=i,b=j;continue}var
b=h;continue}return[0,e,d]}}var
c=l;continue}throw di}}function
P(a,k){var
c=k;for(;;){if(c){var
g=c[2],l=c[4],m=c[3],n=c[1];if(u(a,g)){var
e=g,d=m,b=n;for(;;){if(b){var
f=b[2],h=b[4],i=b[3],j=b[1];if(u(a,f)){var
e=f,d=i,b=j;continue}var
b=h;continue}return[0,[0,e,d]]}}var
c=l;continue}return 0}}function
Q(a,k){var
c=k;for(;;){if(c){var
g=c[2],l=c[4],m=c[3],n=c[1];if(u(a,g)){var
e=g,d=m,b=l;for(;;){if(b){var
f=b[2],h=b[4],i=b[3],j=b[1];if(u(a,f)){var
e=f,d=i,b=h;continue}var
b=j;continue}return[0,e,d]}}var
c=n;continue}throw di}}function
R(a,k){var
c=k;for(;;){if(c){var
g=c[2],l=c[4],m=c[3],n=c[1];if(u(a,g)){var
e=g,d=m,b=l;for(;;){if(b){var
f=b[2],h=b[4],i=b[3],j=b[1];if(u(a,f)){var
e=f,d=i,b=h;continue}var
b=j;continue}return[0,[0,e,d]]}}var
c=n;continue}return 0}}function
S(e,d){var
b=d;for(;;){if(b){var
a=b[4],g=b[3],h=b[1],c=ar(f[1],e,b[2]);if(0===c)return[0,g];var
i=0<=c?a:h,b=i;continue}return 0}}function
T(a,e){var
b=e;for(;;){if(b){var
g=b[4],h=b[1],c=ar(f[1],a,b[2]),d=0===c?1:0;if(d)return d;var
i=0<=c?g:h,b=i;continue}return 0}}function
l(d){var
b=d;for(;;){if(b){var
c=b[1];if(c){var
b=c;continue}return[0,b[2],b[3]]}throw di}}function
A(d){var
b=d;for(;;){if(b){var
c=b[1];if(c){var
b=c;continue}return[0,[0,b[2],b[3]]]}return 0}}function
U(c){var
b=c;for(;;){if(b){if(b[4]){var
b=b[4];continue}return[0,b[2],b[3]]}throw di}}function
V(c){var
b=c;for(;;){if(b){if(b[4]){var
b=b[4];continue}return[0,[0,b[2],b[3]]]}return 0}}function
o(c){if(c){var
d=c[1];if(d){var
e=c[4],f=c[3],a=c[2];return b(o(d),a,f,e)}return c[4]}return b$(Ke)}function
B(d,c){if(d){if(c){var
e=l(c),f=e[2],a=e[1];return b(d,a,f,o(c))}return d}return c}function
p(a,c){if(c){var
d=c[4],h=c[3],g=c[2],e=c[1],i=ar(f[1],a,g);if(0===i)return B(e,d);if(0<=i){var
j=p(a,d);return d===j?c:b(e,g,h,j)}var
k=p(a,e);return e===k?c:b(k,g,h,d)}return 0}function
q(d,g,c){if(c){var
e=c[4],h=c[3],i=c[2],a=c[1],p=c[5],j=ar(f[1],d,i);if(0===j){var
k=u(g,[0,h]);if(k){var
l=k[1];return h===l?c:[0,a,d,l,e,p]}return B(a,e)}if(0<=j){var
m=q(d,g,e);return e===m?c:b(a,i,h,m)}var
n=q(d,g,a);return a===n?c:b(n,i,h,e)}var
o=u(g,0);return o?[0,0,d,o[1],0,1]:0}function
C(c,d){var
b=d;for(;;){if(b){var
e=b[4],f=b[3],a=b[2];C(c,b[1]);ar(c,a,f);var
b=e;continue}return 0}}function
r(c,b){if(b){var
d=b[5],e=b[4],f=b[3],a=b[2],g=r(c,b[1]),h=u(c,f);return[0,g,a,h,r(c,e),d]}return 0}function
s(c,b){if(b){var
d=b[2],e=b[5],f=b[4],a=b[3],g=s(c,b[1]),h=ar(c,d,a);return[0,g,d,h,s(c,f),e]}return 0}function
D(d,f,e){var
b=f,c=e;for(;;){if(b){var
a=b[4],g=b[3],h=b[2],i=cm(d,h,g,D(d,b[1],c)),b=a,c=i;continue}return c}}function
E(c,a){var
b=a;for(;;){if(b){var
g=b[4],h=b[1],d=ar(c,b[2],b[3]);if(d){var
e=E(c,h);if(e){var
b=g;continue}var
f=e}else
var
f=d;return f}return 1}}function
F(c,a){var
b=a;for(;;){if(b){var
g=b[4],h=b[1],d=ar(c,b[2],b[3]);if(d)var
e=d;else{var
f=F(c,h);if(!f){var
b=g;continue}var
e=f}return e}return 0}}function
G(e,d,c){if(c){var
f=c[4],a=c[3],g=c[2];return b(G(e,d,c[1]),g,a,f)}return n(e,d)}function
H(e,d,c){if(c){var
f=c[3],a=c[2],g=c[1];return b(g,a,f,H(e,d,c[4]))}return n(e,d)}function
c(f,g,a,e){if(f){if(e){var
h=e[5],i=f[5],j=e[4],k=e[3],l=e[2],m=e[1],n=f[4],o=f[3],p=f[2],q=f[1];return(h+2|0)<i?b(q,p,o,c(n,g,a,e)):(i+2|0)<h?b(c(f,g,a,m),l,k,j):d(f,g,a,e)}return H(g,a,f)}return G(g,a,e)}function
h(d,b){if(d){if(b){var
e=l(b),f=e[2],a=e[1];return c(d,a,f,o(b))}return d}return b}function
m(e,f,d,b){return d?c(e,f,d[1],b):h(e,b)}function
g(d,b){if(b){var
e=b[4],a=b[3],h=b[2],i=b[1],l=ar(f[1],d,h);if(0===l)return[0,i,[0,a],e];if(0<=l){var
j=g(d,e),m=j[3],n=j[2];return[0,c(i,h,a,j[1]),n,m]}var
k=g(d,i),o=k[2],p=k[1];return[0,p,o,c(k[3],h,a,e)]}return Kf}function
i(d,c,b){if(c){var
e=c[2],k=c[5],l=c[4],n=c[3],o=c[1];if(a(b)<=k){var
f=g(e,b),p=f[2],q=f[1],r=i(d,l,f[3]),s=cm(d,e,[0,n],p);return m(i(d,o,q),e,s,r)}}else
if(!b)return 0;if(b){var
h=b[2],t=b[4],u=b[3],v=b[1],j=g(h,c),w=j[2],x=j[1],y=i(d,j[3],t),z=cm(d,h,w,[0,u]);return m(i(d,x,v),h,z,y)}throw[0,bi,Kg]}function
j(e,d,b){if(d){if(b){var
k=b[3],f=b[2],l=d[3],a=d[2],u=b[4],v=b[1],w=d[4],x=d[1];if(b[5]<=d[5]){var
h=g(a,b),n=h[2],y=h[3],o=j(e,x,h[1]),p=j(e,w,y);return n?m(o,a,cm(e,a,l,n[1]),p):c(o,a,l,p)}var
i=g(f,d),q=i[2],z=i[3],r=j(e,i[1],v),s=j(e,z,u);return q?m(r,f,cm(e,f,q[1],k),s):c(r,f,k,s)}var
t=d}else
var
t=b;return t}function
t(d,b){if(b){var
a=b[4],g=b[3],i=b[2],j=b[1],e=t(d,j),k=ar(d,i,g),f=t(d,a);if(k){if(j===e&&a===f)return b;return c(e,i,g,f)}return h(e,f)}return 0}function
v(d,b){if(b){var
e=b[2],i=b[4],j=b[3],f=v(d,b[1]),a=ar(d,e,j),g=v(d,i);return a?c(f,e,a[1],g):h(f,g)}return 0}function
w(d,b){if(b){var
e=b[3],f=b[2],m=b[4],a=w(d,b[1]),g=a[2],i=a[1],n=ar(d,f,e),j=w(d,m),k=j[2],l=j[1];if(n){var
o=h(g,k);return[0,c(i,f,e,l),o]}var
p=c(g,f,e,k);return[0,h(i,l),p]}return Kh}function
e(e,d){var
b=e,c=d;for(;;){if(b){var
f=[0,b[2],b[3],b[4],c],b=b[1],c=f;continue}return c}}function
W(i,h,g){var
q=e(g,0),c=e(h,0),b=q;for(;;){if(c){if(b){var
j=b[4],k=b[3],l=b[2],m=c[4],n=c[3],o=c[2],d=ar(f[1],c[1],b[1]);if(0===d){var
a=ar(i,o,l);if(0===a){var
p=e(k,j),c=e(n,m),b=p;continue}return a}return d}return 1}return b?-1:0}}function
X(j,i,h){var
r=e(h,0),c=e(i,0),b=r;for(;;){if(c){if(b){var
k=b[4],l=b[3],m=b[2],n=c[4],o=c[3],p=c[2],d=0===ar(f[1],c[1],b[1])?1:0;if(d){var
a=ar(j,p,m);if(a){var
q=e(l,k),c=e(o,n),b=q;continue}var
g=a}else
var
g=d;return g}return 0}return b?0:1}}function
x(b){if(b){var
c=b[1],d=x(b[4]);return(x(c)+1|0)+d|0}return 0}function
I(e,d){var
c=e,b=d;for(;;){if(b){var
f=b[3],a=b[2],g=b[1],c=[0,[0,a,f],I(c,b[4])],b=g;continue}return c}}function
Y(b){return I(0,b)}function
J(g,a){var
b=a,d=g;for(;;){var
c=u(d,0);if(c){var
e=c[1],f=c[2],b=k(e[1],e[2],b),d=f;continue}return b}}function
Z(b){return J(b,z)}function
y(b,a){if(b){var
c=b[2],d=b[1],f=e(b[3],b[4]);return[0,[0,d,c],function(b){return y(f,b)}]}return 0}function
_(b){var
c=e(b,0);return function(b){return y(c,b)}}function
K(e,d){var
b=e,c=d;for(;;){if(b){var
f=[0,b[2],b[3],b[1],c],b=b[4],c=f;continue}return c}}function
L(b,f){if(b){var
c=b[2],d=b[1],e=K(b[3],b[4]);return[0,[0,d,c],function(b){return L(e,b)}]}return 0}function
$(b){var
c=K(b,0);return function(b){return L(c,b)}}return[0,z,M,T,k,q,n,p,i,j,W,X,C,D,E,F,t,v,w,x,Y,l,A,U,V,l,A,g,N,S,O,P,Q,R,r,s,_,$,function(j,i){var
b=i,c=0;for(;;){if(b){var
d=b[4],a=b[3],e=b[2],k=b[1],g=ar(f[1],e,j);if(0!==g){if(0<=g){var
b=k,c=[0,e,a,d,c];continue}var
b=d;continue}var
h=[0,e,a,d,c]}else
var
h=c;return function(b){return y(h,b)}}},J,Z]}function
hy(b){return[0,0,0]}function
hz(b){b[1]=0;b[2]=0;return 0}function
fB(c,b){b[1]=[0,c,b[1]];b[2]=b[2]+1|0;return 0}function
f8(b){var
c=b[1];if(c){var
d=c[1];b[1]=c[2];b[2]=b[2]-1|0;return[0,d]}return 0}function
f9(c){var
b=c[1];return b?[0,b[1]]:0}var
Kj=[bl,Ki,c1(0)];function
n_(b){b[1]=0;b[2]=0;b[3]=0;return 0}function
sj(e,b){var
c=[0,e,0],d=b[3];return d?(b[1]=b[1]+1|0,d[2]=c,b[3]=c,0):(b[1]=1,b[2]=c,b[3]=c,0)}function
hA(b){var
c=1<=b?b:1,d=hv<c?hv:c,e=b_(d);return[0,e,0,d,e]}function
hB(b){return je(b[1],0,b[2])}function
sk(b){b[2]=0;return 0}function
n$(b,d){var
e=b[2],c=[0,b[3]];for(;;){if(c[1]<(e+d|0)){c[1]=2*c[1]|0;continue}if(hv<c[1])if((e+d|0)<=hv)c[1]=hv;else
aE(Kn);var
f=b_(c[1]);sg(b[1],0,f,0,b[2]);b[1]=f;b[3]=c[1];if((b[2]+d|0)<=b[3]){if((e+d|0)<=b[3])return 0;throw[0,bi,Kl]}throw[0,bi,Km]}}function
bw(b,d){var
c=b[2];if(b[3]<=c)n$(b,1);b0(b[1],c,d);b[2]=c+1|0;return 0}function
jh(b,e,d,c){var
f=d<0?1:0;if(f)var
a=f;else
var
h=c<0?1:0,a=h||((aM(e)-c|0)<d?1:0);if(a)b$(Ko);var
g=b[2]+c|0;if(b[3]<g)n$(b,c);er(e,d,b[1],b[2],c);b[2]=g;return 0}function
ct(b,d){var
c=aM(d),e=b[2]+c|0;if(b[3]<e)n$(b,c);er(d,0,b[1],b[2],c);b[2]=e;return 0}function
oa(b){return 5===b[2]?12:-6}function
sl(b){return[0,0,b_(b)]}function
sm(b,h){var
c=dv(b[2]),d=b[1]+h|0,e=c<d?1:0;if(e){var
f=c*2|0,i=d<=f?f:d,a=b_(i);sg(b[2],0,a,0,c);b[2]=a;var
g=0}else
var
g=e;return g}function
f_(b,c){sm(b,1);hm(b[2],b[1],c);b[1]=b[1]+1|0;return 0}function
cu(b,d){var
c=aM(d);sm(b,c);ew(d,0,b[2],b[1],c);b[1]=b[1]+c|0;return 0}function
sn(b){return je(b[2],0,b[1])}function
so(b){if(typeof
b==="number")switch(b){case
0:return Kp;case
1:return Kq;case
2:return Kr;case
3:return Ks;case
4:return Kt;case
5:return Ku;default:return Kv}else
switch(b[0]){case
0:return b[1];case
1:return b[1];default:return b1(Kw,jf(1,b[1]))}}function
ob(c,d){var
b=d;for(;;)if(typeof
b==="number")return 0;else
switch(b[0]){case
0:var
e=b[1];cu(c,Kx);var
b=e;continue;case
1:var
f=b[1];cu(c,Ky);var
b=f;continue;case
2:var
a=b[1];cu(c,Kz);var
b=a;continue;case
3:var
g=b[1];cu(c,KA);var
b=g;continue;case
4:var
h=b[1];cu(c,KB);var
b=h;continue;case
5:var
i=b[1];cu(c,KC);var
b=i;continue;case
6:var
j=b[1];cu(c,KD);var
b=j;continue;case
7:var
k=b[1];cu(c,KE);var
b=k;continue;case
8:var
l=b[2],m=b[1];cu(c,KF);ob(c,m);cu(c,KG);var
b=l;continue;case
9:var
n=b[3],o=b[1];cu(c,KH);ob(c,o);cu(c,KI);var
b=n;continue;case
10:var
p=b[1];cu(c,KJ);var
b=p;continue;case
11:var
q=b[1];cu(c,KK);var
b=q;continue;case
12:var
r=b[1];cu(c,KL);var
b=r;continue;case
13:var
s=b[1];cu(c,KM);var
b=s;continue;default:var
t=b[1];cu(c,KN);var
b=t;continue}}function
b5(b){if(typeof
b==="number")return 0;else
switch(b[0]){case
0:return[0,b5(b[1])];case
1:return[1,b5(b[1])];case
2:return[2,b5(b[1])];case
3:return[3,b5(b[1])];case
4:return[4,b5(b[1])];case
5:return[5,b5(b[1])];case
6:return[6,b5(b[1])];case
7:return[7,b5(b[1])];case
8:var
c=b[1];return[8,c,b5(b[2])];case
9:var
d=b[2],e=b[1];return[9,d,e,b5(b[3])];case
10:return[10,b5(b[1])];case
11:return[11,b5(b[1])];case
12:return[12,b5(b[1])];case
13:return[13,b5(b[1])];default:return[14,b5(b[1])]}}function
cv(b){if(typeof
b==="number"){var
r=function(b){return 0},s=function(b){return 0},t=function(b){return 0};return[0,function(b){return 0},t,s,r]}else
switch(b[0]){case
0:var
c=cv(b[1]),v=c[4],w=c[3],x=c[2],y=c[1],z=function(b){u(x,0);return 0};return[0,function(b){u(y,0);return 0},z,w,v];case
1:var
d=cv(b[1]),A=d[4],B=d[3],C=d[2],D=d[1],E=function(b){u(C,0);return 0};return[0,function(b){u(D,0);return 0},E,B,A];case
2:var
e=cv(b[1]),F=e[4],G=e[3],H=e[2],I=e[1],J=function(b){u(H,0);return 0};return[0,function(b){u(I,0);return 0},J,G,F];case
3:var
f=cv(b[1]),K=f[4],L=f[3],M=f[2],N=f[1],O=function(b){u(M,0);return 0};return[0,function(b){u(N,0);return 0},O,L,K];case
4:var
a=cv(b[1]),P=a[4],Q=a[3],R=a[2],S=a[1],T=function(b){u(R,0);return 0};return[0,function(b){u(S,0);return 0},T,Q,P];case
5:var
g=cv(b[1]),U=g[4],V=g[3],W=g[2],X=g[1],Y=function(b){u(W,0);return 0};return[0,function(b){u(X,0);return 0},Y,V,U];case
6:var
h=cv(b[1]),Z=h[4],_=h[3],$=h[2],aa=h[1],ab=function(b){u($,0);return 0};return[0,function(b){u(aa,0);return 0},ab,_,Z];case
7:var
i=cv(b[1]),ac=i[4],ad=i[3],ae=i[2],af=i[1],ag=function(b){u(ae,0);return 0};return[0,function(b){u(af,0);return 0},ag,ad,ac];case
8:var
j=cv(b[2]),ah=j[4],ai=j[3],aj=j[2],ak=j[1],al=function(b){u(aj,0);return 0};return[0,function(b){u(ak,0);return 0},al,ai,ah];case
9:var
am=b[2],an=b[1],k=cv(b[3]),ao=k[4],ap=k[3],aq=k[2],ar=k[1],l=cv(ca(b5(an),am)),as=l[4],at=l[3],au=l[2],av=l[1],aw=function(b){u(as,0);u(ao,0);return 0},ax=function(b){u(ap,0);u(at,0);return 0},ay=function(b){u(au,0);u(aq,0);return 0};return[0,function(b){u(ar,0);u(av,0);return 0},ay,ax,aw];case
10:var
m=cv(b[1]),az=m[4],aA=m[3],aB=m[2],aC=m[1],aD=function(b){u(aB,0);return 0};return[0,function(b){u(aC,0);return 0},aD,aA,az];case
11:var
n=cv(b[1]),aE=n[4],aF=n[3],aG=n[2],aH=n[1],aI=function(b){u(aG,0);return 0};return[0,function(b){u(aH,0);return 0},aI,aF,aE];case
12:var
o=cv(b[1]),aJ=o[4],aK=o[3],aL=o[2],aM=o[1],aN=function(b){u(aL,0);return 0};return[0,function(b){u(aM,0);return 0},aN,aK,aJ];case
13:var
p=cv(b[1]),aO=p[4],aP=p[3],aQ=p[2],aR=p[1],aS=function(b){u(aO,0);return 0},aT=function(b){u(aP,0);return 0},aU=function(b){u(aQ,0);return 0};return[0,function(b){u(aR,0);return 0},aU,aT,aS];default:var
q=cv(b[1]),aV=q[4],aW=q[3],aX=q[2],aY=q[1],aZ=function(b){u(aV,0);return 0},a0=function(b){u(aW,0);return 0},a1=function(b){u(aX,0);return 0};return[0,function(b){u(aY,0);return 0},a1,a0,aZ]}}function
ca(d,c){var
b=0;if(typeof
d==="number")if(typeof
c==="number")return 0;else
switch(c[0]){case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;case
8:b=5;break;case
9:b=6;break;default:throw[0,bi,KO]}else
switch(d[0]){case
0:var
e=0,s=d[1];if(typeof
c!=="number")switch(c[0]){case
0:return[0,ca(s,c[1])];case
8:b=5;e=1;break;case
9:b=6;e=1;break;case
10:e=1;break;case
11:b=1;e=1;break;case
12:b=2;e=1;break;case
13:b=3;e=1;break;case
14:b=4;e=1;break}if(!e)b=7;break;case
1:var
f=0,t=d[1];if(typeof
c!=="number")switch(c[0]){case
1:return[1,ca(t,c[1])];case
8:b=5;f=1;break;case
9:b=6;f=1;break;case
10:f=1;break;case
11:b=1;f=1;break;case
12:b=2;f=1;break;case
13:b=3;f=1;break;case
14:b=4;f=1;break}if(!f)b=7;break;case
2:var
a=0,v=d[1];if(typeof
c==="number")a=1;else
switch(c[0]){case
2:return[2,ca(v,c[1])];case
8:b=5;break;case
9:b=6;break;case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:a=1}if(a)b=7;break;case
3:var
g=0,w=d[1];if(typeof
c==="number")g=1;else
switch(c[0]){case
3:return[3,ca(w,c[1])];case
8:b=5;break;case
9:b=6;break;case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:g=1}if(g)b=7;break;case
4:var
h=0,x=d[1];if(typeof
c==="number")h=1;else
switch(c[0]){case
4:return[4,ca(x,c[1])];case
8:b=5;break;case
9:b=6;break;case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:h=1}if(h)b=7;break;case
5:var
i=0,y=d[1];if(typeof
c==="number")i=1;else
switch(c[0]){case
5:return[5,ca(y,c[1])];case
8:b=5;break;case
9:b=6;break;case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:i=1}if(i)b=7;break;case
6:var
j=0,z=d[1];if(typeof
c==="number")j=1;else
switch(c[0]){case
6:return[6,ca(z,c[1])];case
8:b=5;break;case
9:b=6;break;case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:j=1}if(j)b=7;break;case
7:var
k=0,A=d[1];if(typeof
c==="number")k=1;else
switch(c[0]){case
7:return[7,ca(A,c[1])];case
8:b=5;break;case
9:b=6;break;case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:k=1}if(k)b=7;break;case
8:var
l=0,B=d[2],C=d[1];if(typeof
c==="number")l=1;else
switch(c[0]){case
8:var
D=c[1],E=ca(B,c[2]);return[8,ca(C,D),E];case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:l=1}if(l)throw[0,bi,KX];break;case
9:var
m=0,F=d[3],G=d[2],H=d[1];if(typeof
c==="number")m=1;else
switch(c[0]){case
8:b=5;break;case
9:var
I=c[3],J=c[2],K=c[1],r=cv(ca(b5(G),K)),L=r[4];u(r[2],0);u(L,0);return[9,H,J,ca(F,I)];case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:b=4;break;default:m=1}if(m)throw[0,bi,KY];break;case
10:var
M=d[1];if(typeof
c!=="number"&&10===c[0])return[10,ca(M,c[1])];throw[0,bi,KZ];case
11:var
n=0,N=d[1];if(typeof
c==="number")n=1;else
switch(c[0]){case
10:break;case
11:return[11,ca(N,c[1])];default:n=1}if(n)throw[0,bi,K0];break;case
12:var
o=0,O=d[1];if(typeof
c==="number")o=1;else
switch(c[0]){case
10:break;case
11:b=1;break;case
12:return[12,ca(O,c[1])];default:o=1}if(o)throw[0,bi,K1];break;case
13:var
p=0,P=d[1];if(typeof
c==="number")p=1;else
switch(c[0]){case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:return[13,ca(P,c[1])];default:p=1}if(p)throw[0,bi,K2];break;default:var
q=0,Q=d[1];if(typeof
c==="number")q=1;else
switch(c[0]){case
10:break;case
11:b=1;break;case
12:b=2;break;case
13:b=3;break;case
14:return[14,ca(Q,c[1])];default:q=1}if(q)throw[0,bi,K3]}switch(b){case
0:throw[0,bi,KR];case
1:throw[0,bi,KS];case
2:throw[0,bi,KT];case
3:throw[0,bi,KU];case
4:throw[0,bi,KV];case
5:throw[0,bi,KP];case
6:throw[0,bi,KQ];default:throw[0,bi,KW]}}var
cl=[bl,K4,c1(0)];function
ji(c,b){if(typeof
c==="number")return[0,0,b];else{if(0===c[0])return[0,[0,c[1],c[2]],b];if(typeof
b!=="number"&&2===b[0])return[0,[1,c[1]],b[1]];throw cl}}function
hC(f,c,e){var
b=ji(f,e);if(typeof
c==="number"){if(c){var
d=b[2];if(typeof
d!=="number"&&2===d[0])return[0,b[1],1,d[1]];throw cl}return[0,b[1],0,b[2]]}return[0,b[1],[0,c[1]],b[2]]}function
c3(e,d,c){var
b=bx(d,c);return[0,[23,e,b[1]],b[2]]}function
bx(c,b){if(typeof
c==="number")return[0,0,b];else
switch(c[0]){case
0:if(typeof
b!=="number"&&0===b[0]){var
s=bx(c[1],b[1]);return[0,[0,s[1]],s[2]]}break;case
1:if(typeof
b!=="number"&&0===b[0]){var
t=bx(c[1],b[1]);return[0,[1,t[1]],t[2]]}break;case
2:var
aa=c[2],u=ji(c[1],b),f=u[2],ab=u[1];if(typeof
f!=="number"&&1===f[0]){var
v=bx(aa,f[1]);return[0,[2,ab,v[1]],v[2]]}throw cl;case
3:var
ac=c[2],w=ji(c[1],b),a=w[2],ad=w[1];if(typeof
a!=="number"&&1===a[0]){var
x=bx(ac,a[1]);return[0,[3,ad,x[1]],x[2]]}throw cl;case
4:var
ae=c[4],af=c[1],g=hC(c[2],c[3],b),h=g[3],ag=g[1];if(typeof
h!=="number"&&2===h[0]){var
ah=g[2],y=bx(ae,h[1]);return[0,[4,af,ag,ah,y[1]],y[2]]}throw cl;case
5:var
ai=c[4],aj=c[1],i=hC(c[2],c[3],b),j=i[3],ak=i[1];if(typeof
j!=="number"&&3===j[0]){var
al=i[2],z=bx(ai,j[1]);return[0,[5,aj,ak,al,z[1]],z[2]]}throw cl;case
6:var
am=c[4],an=c[1],k=hC(c[2],c[3],b),l=k[3],ao=k[1];if(typeof
l!=="number"&&4===l[0]){var
ap=k[2],A=bx(am,l[1]);return[0,[6,an,ao,ap,A[1]],A[2]]}throw cl;case
7:var
aq=c[4],ar=c[1],m=hC(c[2],c[3],b),n=m[3],as=m[1];if(typeof
n!=="number"&&5===n[0]){var
at=m[2],B=bx(aq,n[1]);return[0,[7,ar,as,at,B[1]],B[2]]}throw cl;case
8:var
au=c[4],av=c[1],o=hC(c[2],c[3],b),p=o[3],aw=o[1];if(typeof
p!=="number"&&6===p[0]){var
ax=o[2],C=bx(au,p[1]);return[0,[8,av,aw,ax,C[1]],C[2]]}throw cl;case
9:var
ay=c[2],D=ji(c[1],b),q=D[2],az=D[1];if(typeof
q!=="number"&&7===q[0]){var
E=bx(ay,q[1]);return[0,[9,az,E[1]],E[2]]}throw cl;case
10:var
F=bx(c[1],b);return[0,[10,F[1]],F[2]];case
11:var
aA=c[1],G=bx(c[2],b);return[0,[11,aA,G[1]],G[2]];case
12:var
aB=c[1],H=bx(c[2],b);return[0,[12,aB,H[1]],H[2]];case
13:if(typeof
b!=="number"&&8===b[0]){var
I=b[1],aC=b[2],aD=c[3],aE=c[1];if(i_([0,c[2]],[0,I]))throw cl;var
J=bx(aD,aC);return[0,[13,aE,I,J[1]],J[2]]}break;case
14:if(typeof
b!=="number"&&9===b[0]){var
K=b[1],aF=b[3],aG=c[3],aH=c[2],aI=c[1],aJ=[0,bK(K)];if(i_([0,bK(aH)],aJ))throw cl;var
L=bx(aG,bK(aF));return[0,[14,aI,K,L[1]],L[2]]}break;case
15:if(typeof
b!=="number"&&10===b[0]){var
M=bx(c[1],b[1]);return[0,[15,M[1]],M[2]]}break;case
16:if(typeof
b!=="number"&&11===b[0]){var
N=bx(c[1],b[1]);return[0,[16,N[1]],N[2]]}break;case
17:var
aK=c[1],O=bx(c[2],b);return[0,[17,aK,O[1]],O[2]];case
18:var
P=c[2],r=c[1];if(0===r[0]){var
T=r[1],aO=T[2],U=bx(T[1],b),aP=U[1],V=bx(P,U[2]);return[0,[18,[0,[0,aP,aO]],V[1]],V[2]]}var
W=r[1],aQ=W[2],X=bx(W[1],b),aR=X[1],Y=bx(P,X[2]);return[0,[18,[1,[0,aR,aQ]],Y[1]],Y[2]];case
19:if(typeof
b!=="number"&&13===b[0]){var
Q=bx(c[1],b[1]);return[0,[19,Q[1]],Q[2]]}break;case
20:if(typeof
b!=="number"&&1===b[0]){var
aL=c[2],aM=c[1],R=bx(c[3],b[1]);return[0,[20,aM,aL,R[1]],R[2]]}break;case
21:if(typeof
b!=="number"&&2===b[0]){var
aN=c[1],S=bx(c[2],b[1]);return[0,[21,aN,S[1]],S[2]]}break;case
23:var
e=c[2],d=c[1];if(typeof
d==="number")switch(d){case
0:return c3(d,e,b);case
1:return c3(d,e,b);case
2:if(typeof
b!=="number"&&14===b[0]){var
Z=bx(e,b[1]);return[0,[23,2,Z[1]],Z[2]]}throw cl;default:return c3(d,e,b)}else
switch(d[0]){case
0:return c3(d,e,b);case
1:return c3(d,e,b);case
2:return c3(d,e,b);case
3:return c3(d,e,b);case
4:return c3(d,e,b);case
5:return c3(d,e,b);case
6:return c3(d,e,b);case
7:return c3(d,e,b);case
8:return c3([8,d[1],d[2]],e,b);case
9:var
aS=d[1],_=cR(d[2],e,b),$=_[2];return[0,[23,[9,aS,_[1]],$[1]],$[2]];case
10:return c3(d,e,b);default:return c3(d,e,b)}}throw cl}function
cR(c,d,b){if(typeof
c==="number")return[0,0,bx(d,b)];else
switch(c[0]){case
0:if(typeof
b!=="number"&&0===b[0]){var
a=cR(c[1],d,b[1]);return[0,[0,a[1]],a[2]]}break;case
1:if(typeof
b!=="number"&&1===b[0]){var
g=cR(c[1],d,b[1]);return[0,[1,g[1]],g[2]]}break;case
2:if(typeof
b!=="number"&&2===b[0]){var
h=cR(c[1],d,b[1]);return[0,[2,h[1]],h[2]]}break;case
3:if(typeof
b!=="number"&&3===b[0]){var
i=cR(c[1],d,b[1]);return[0,[3,i[1]],i[2]]}break;case
4:if(typeof
b!=="number"&&4===b[0]){var
j=cR(c[1],d,b[1]);return[0,[4,j[1]],j[2]]}break;case
5:if(typeof
b!=="number"&&5===b[0]){var
k=cR(c[1],d,b[1]);return[0,[5,k[1]],k[2]]}break;case
6:if(typeof
b!=="number"&&6===b[0]){var
l=cR(c[1],d,b[1]);return[0,[6,l[1]],l[2]]}break;case
7:if(typeof
b!=="number"&&7===b[0]){var
m=cR(c[1],d,b[1]);return[0,[7,m[1]],m[2]]}break;case
8:if(typeof
b!=="number"&&8===b[0]){var
n=b[1],w=b[2],x=c[2];if(i_([0,c[1]],[0,n]))throw cl;var
o=cR(x,d,w);return[0,[8,n,o[1]],o[2]]}break;case
9:if(typeof
b!=="number"&&9===b[0]){var
e=b[2],f=b[1],y=b[3],z=c[3],A=c[2],B=c[1],C=[0,bK(f)];if(i_([0,bK(B)],C))throw cl;var
D=[0,bK(e)];if(i_([0,bK(A)],D))throw cl;var
p=cv(ca(b5(f),e)),E=p[4];u(p[2],0);u(E,0);var
q=cR(bK(z),d,y),F=q[2];return[0,[9,f,e,b5(q[1])],F]}break;case
10:if(typeof
b!=="number"&&10===b[0]){var
r=cR(c[1],d,b[1]);return[0,[10,r[1]],r[2]]}break;case
11:if(typeof
b!=="number"&&11===b[0]){var
s=cR(c[1],d,b[1]);return[0,[11,s[1]],s[2]]}break;case
13:if(typeof
b!=="number"&&13===b[0]){var
t=cR(c[1],d,b[1]);return[0,[13,t[1]],t[2]]}break;case
14:if(typeof
b!=="number"&&14===b[0]){var
v=cR(c[1],d,b[1]);return[0,[14,v[1]],v[2]]}break}throw cl}function
c4(k,g,b){var
c=aM(b),h=0<=g?k:0,e=ht(g);if(e<=c)return b;var
l=2===h?48:32,d=fA(e,l);switch(h){case
0:ew(b,0,d,0,c);break;case
1:ew(b,0,d,e-c|0,c);break;default:var
f=0;if(0<c){var
i=0;if(43!==bJ(b,0)&&45!==bJ(b,0)&&32!==bJ(b,0)){f=1;i=1}if(!i){hm(d,0,bJ(b,0));ew(b,1,d,(e-c|0)+1|0,c-1|0)}}else
f=1;if(f){var
a=0;if(1<c&&48===bJ(b,0)){var
j=0;if(lM!==bJ(b,1)&&88!==bJ(b,1)){a=1;j=1}if(!j){hm(d,1,bJ(b,1));ew(b,2,d,(e-c|0)+2|0,c-2|0)}}else
a=1;if(a)ew(b,0,d,e-c|0,c)}}return cQ(d)}function
f$(k,c){var
d=ht(k),b=aM(c),e=bJ(c,0),f=0;if(58<=e){if(71<=e){if(!(5<e+qq>>>0))f=1}else
if(65<=e)f=1}else{var
a=0;if(32!==e)if(43<=e)switch(e+xB|0){case
5:if(b<(d+2|0)&&1<b){var
j=0;if(lM===bJ(c,1)||88===bJ(c,1))j=1;if(j){var
h=fA(d+2|0,48);hm(h,1,bJ(c,1));ew(c,2,h,(d-b|0)+4|0,b-2|0);return cQ(h)}}f=1;a=1;break;case
0:case
2:break;case
1:case
3:case
4:a=1;break;default:f=1;a=1}else
a=1;if(!a&&b<(d+1|0)){var
g=fA(d+1|0,48);hm(g,0,e);ew(c,1,g,(d-b|0)+2|0,b-1|0);return cQ(g)}}if(f&&b<d){var
i=fA(d,48);ew(c,0,i,d-b|0,b);return cQ(i)}return c}function
K5(k){var
j=0,C=aM(k);for(;;){if(C<=j)var
o=k;else{var
n=dh(k,j)+xo|0,p=0;if(59<n>>>0){if(33<n-61>>>0)p=1}else
if(2===n)p=1;if(!p){var
j=j+1|0;continue}var
f=fw(k),b=[0,0],t=dv(f)-1|0,y=0;if(!(t<0)){var
i=y;for(;;){var
a=nJ(f,i),g=0;if(32<=a){var
l=a-34|0,q=0;if(58<l>>>0){if(93<=l)q=1}else
if(56<l-1>>>0){g=1;q=1}if(!q){var
m=1;g=2}}else
if(11<=a){if(13===a)g=1}else
if(8<=a)g=1;switch(g){case
0:var
m=4;break;case
1:var
m=2;break}b[1]=b[1]+m|0;var
B=i+1|0;if(t!==i){var
i=B;continue}break}}if(b[1]===dv(f)){var
r=dv(f),s=b_(r);eZ(f,0,s,0,r);var
v=s}else{var
c=b_(b[1]);b[1]=0;var
u=dv(f)-1|0,z=0;if(!(u<0)){var
h=z;for(;;){var
d=nJ(f,h),e=0;if(35<=d)if(92===d)e=2;else
if(j6<=d)e=1;else
e=3;else
if(32<=d)if(34<=d)e=2;else
e=3;else
if(14<=d)e=1;else
switch(d){case
8:b0(c,b[1],92);b[1]++;b0(c,b[1],98);break;case
9:b0(c,b[1],92);b[1]++;b0(c,b[1],qu);break;case
10:b0(c,b[1],92);b[1]++;b0(c,b[1],qP);break;case
13:b0(c,b[1],92);b[1]++;b0(c,b[1],qG);break;default:e=1}switch(e){case
1:b0(c,b[1],92);b[1]++;b0(c,b[1],48+(d/de|0)|0);b[1]++;b0(c,b[1],48+((d/10|0)%10|0)|0);b[1]++;b0(c,b[1],48+(d%10|0)|0);break;case
2:b0(c,b[1],92);b[1]++;b0(c,b[1],d);break;case
3:b0(c,b[1],d);break}b[1]++;var
A=h+1|0;if(u!==h){var
h=A;continue}break}}var
v=c}var
o=cQ(v)}var
w=aM(o),x=fA(w+2|0,34);er(o,0,x,1,w);return cQ(x)}}function
sp(f,g){var
h=ht(g),a=LU[1];switch(f[2]){case
0:var
c=k1;break;case
1:var
c=fn;break;case
2:var
c=69;break;case
3:var
c=iU;break;case
4:var
c=71;break;case
5:var
c=a;break;case
6:var
c=104;break;case
7:var
c=72;break;default:var
c=70}var
e=sl(16);f_(e,37);switch(f[1]){case
0:break;case
1:f_(e,43);break;default:f_(e,32)}if(8<=f[2])f_(e,35);f_(e,46);cu(e,b(d+h));f_(e,c);return sn(e)}function
jj(m,b){if(13<=m){var
g=[0,0],h=aM(b)-1|0,n=0;if(!(h<0)){var
d=n;for(;;){if(!(9<dh(b,d)+yf>>>0))g[1]++;var
q=d+1|0;if(h!==d){var
d=q;continue}break}}var
i=g[1],j=b_(aM(b)+((i-1|0)/3|0)|0),k=[0,0],e=function(b){hm(j,k[1],b);k[1]++;return 0},f=[0,((i-1|0)%3|0)+1|0],l=aM(b)-1|0,o=0;if(!(l<0)){var
c=o;for(;;){var
a=dh(b,c);if(9<a+yf>>>0)e(a);else{if(0===f[1]){e(95);f[1]=3}f[1]+=-1;e(a)}var
p=c+1|0;if(l!==c){var
c=p;continue}break}}return cQ(j)}return b}function
LV(c,d){switch(c){case
1:var
b=K7;break;case
2:var
b=K8;break;case
4:var
b=K_;break;case
5:var
b=K$;break;case
6:var
b=La;break;case
7:var
b=Lb;break;case
8:var
b=Lc;break;case
9:var
b=Ld;break;case
10:var
b=Le;break;case
11:var
b=Lf;break;case
0:case
13:var
b=K6;break;case
3:case
14:var
b=K9;break;default:var
b=Lg}return jj(c,nN(b,d))}function
LW(c,d){switch(c){case
1:var
b=Lv;break;case
2:var
b=Lw;break;case
4:var
b=Ly;break;case
5:var
b=Lz;break;case
6:var
b=LA;break;case
7:var
b=LB;break;case
8:var
b=LC;break;case
9:var
b=LD;break;case
10:var
b=LE;break;case
11:var
b=LF;break;case
0:case
13:var
b=Lu;break;case
3:case
14:var
b=Lx;break;default:var
b=LG}return jj(c,nN(b,d))}function
LX(c,d){switch(c){case
1:var
b=LI;break;case
2:var
b=LJ;break;case
4:var
b=LL;break;case
5:var
b=LM;break;case
6:var
b=LN;break;case
7:var
b=LO;break;case
8:var
b=LP;break;case
9:var
b=LQ;break;case
10:var
b=LR;break;case
11:var
b=LS;break;case
0:case
13:var
b=LH;break;case
3:case
14:var
b=LK;break;default:var
b=LT}return jj(c,nN(b,d))}function
LY(c,d){switch(c){case
1:var
b=Li;break;case
2:var
b=Lj;break;case
4:var
b=Ll;break;case
5:var
b=Lm;break;case
6:var
b=Ln;break;case
7:var
b=Lo;break;case
8:var
b=Lp;break;case
9:var
b=Lq;break;case
10:var
b=Lr;break;case
11:var
b=Ls;break;case
0:case
13:var
b=Lh;break;case
3:case
14:var
b=Lk;break;default:var
b=Lt}return jj(c,b06(b,d))}function
ex(d,i,c){function
j(e){switch(d[1]){case
0:var
b=45;break;case
1:var
b=43;break;default:var
b=32}return b03(c,i,b)}function
q(d){var
b=nK(c);return 3===b?c<0.?L0:L1:4<=b?L2:d}switch(d[2]){case
5:var
f=rM(sp(d,i),c),e=0,u=aM(f);for(;;){if(e===u)var
p=0;else{var
k=bJ(f,e)-46|0,l=0;if(23<k>>>0){if(55===k)l=1}else
if(21<k-1>>>0)l=1;if(!l){var
e=e+1|0;continue}var
p=1}var
v=p?f:b1(f,LZ);return q(v)}case
6:return j(0);case
7:var
h=fw(j(0)),a=dv(h);if(0===a)var
o=h;else{var
m=b_(a),n=a-1|0,r=0;if(!(n<0)){var
b=r;for(;;){var
g=nJ(h,b),s=25<g+qq>>>0?g:g+xo|0;b0(m,b,s);var
t=b+1|0;if(n!==b){var
b=t;continue}break}}var
o=m}return cQ(o);case
8:return q(j(0));default:return rM(sp(d,i),c)}}function
jk(a,f,e,g,d,c,b){if(typeof
g==="number"){if(typeof
d==="number")return d?function(g,d){return bc(a,[4,f,f$(g,ar(c,b,d))],e)}:function(d){return bc(a,[4,f,ar(c,b,d)],e)};var
k=d[1];return function(d){return bc(a,[4,f,f$(k,ar(c,b,d))],e)}}else{if(0===g[0]){var
h=g[2],i=g[1];if(typeof
d==="number")return d?function(g,d){return bc(a,[4,f,c4(i,h,f$(g,ar(c,b,d)))],e)}:function(d){return bc(a,[4,f,c4(i,h,ar(c,b,d))],e)};var
l=d[1];return function(d){return bc(a,[4,f,c4(i,h,f$(l,ar(c,b,d)))],e)}}var
j=g[1];if(typeof
d==="number")return d?function(h,g,d){return bc(a,[4,f,c4(j,h,f$(g,ar(c,b,d)))],e)}:function(g,d){return bc(a,[4,f,c4(j,g,ar(c,b,d))],e)};var
m=d[1];return function(g,d){return bc(a,[4,f,c4(j,g,f$(m,ar(c,b,d)))],e)}}}function
oc(f,e,d,b,c){if(typeof
b==="number")return function(b){return bc(f,[4,e,u(c,b)],d)};else{if(0===b[0]){var
a=b[2],g=b[1];return function(b){return bc(f,[4,e,c4(g,a,u(c,b))],d)}}var
h=b[1];return function(a,b){return bc(f,[4,e,c4(h,a,u(c,b))],d)}}}function
hY(e,x,w,v){var
c=x,b=w,d=v;for(;;)if(typeof
d==="number")return u(c,b);else
switch(d[0]){case
0:var
y=d[1];return function(d){return bc(c,[5,b,d],y)};case
1:var
z=d[1];return function(d){var
f=0;if(40<=d)if(92===d)var
e=JS;else
if(j6<=d)f=1;else
f=2;else
if(32<=d)if(39<=d)var
e=JT;else
f=2;else
if(14<=d)f=1;else
switch(d){case
8:var
e=JU;break;case
9:var
e=JV;break;case
10:var
e=JW;break;case
13:var
e=JX;break;default:f=1}switch(f){case
1:var
a=b_(4);b0(a,0,92);b0(a,1,48+(d/de|0)|0);b0(a,2,48+((d/10|0)%10|0)|0);b0(a,3,48+(d%10|0)|0);var
e=cQ(a);break;case
2:var
g=b_(1);b0(g,0,d);var
e=cQ(g);break}var
h=aM(e),i=fA(h+2|0,39);er(e,0,i,1,h);return bc(c,[4,b,cQ(i)],z)};case
2:var
A=d[2],B=d[1];return oc(c,b,A,B,function(b){return b});case
3:return oc(c,b,d[2],d[1],K5);case
4:return jk(c,b,d[4],d[2],d[3],LV,d[1]);case
5:return jk(c,b,d[4],d[2],d[3],LW,d[1]);case
6:return jk(c,b,d[4],d[2],d[3],LX,d[1]);case
7:return jk(c,b,d[4],d[2],d[3],LY,d[1]);case
8:var
g=d[4],h=d[3],i=d[2],a=d[1];if(typeof
i==="number"){if(typeof
h==="number")return h?function(e,d){return bc(c,[4,b,ex(a,e,d)],g)}:function(d){return bc(c,[4,b,ex(a,oa(a),d)],g)};var
S=h[1];return function(d){return bc(c,[4,b,ex(a,S,d)],g)}}else{if(0===i[0]){var
l=i[2],m=i[1];if(typeof
h==="number")return h?function(e,d){return bc(c,[4,b,c4(m,l,ex(a,e,d))],g)}:function(d){return bc(c,[4,b,c4(m,l,ex(a,oa(a),d))],g)};var
T=h[1];return function(d){return bc(c,[4,b,c4(m,l,ex(a,T,d))],g)}}var
n=i[1];if(typeof
h==="number")return h?function(f,e,d){return bc(c,[4,b,c4(n,f,ex(a,e,d))],g)}:function(e,d){return bc(c,[4,b,c4(n,e,ex(a,oa(a),d))],g)};var
U=h[1];return function(e,d){return bc(c,[4,b,c4(n,e,ex(a,U,d))],g)}}case
9:return oc(c,b,d[2],d[1],JI);case
10:var
b=[7,b],d=d[1];continue;case
11:var
b=[2,b,d[1]],d=d[2];continue;case
12:var
b=[3,b,d[1]],d=d[2];continue;case
13:var
C=d[3],D=d[2],o=sl(16);ob(o,D);var
t=sn(o);return function(d){return bc(c,[4,b,t],C)};case
14:var
E=d[3],F=d[2];return function(e){var
f=e[1],d=bx(f,bK(b5(F)));if(typeof
d[2]==="number")return bc(c,b,bD(d[1],E));throw cl};case
15:var
G=d[1];return function(e,d){return bc(c,[6,b,function(b){return ar(e,b,d)}],G)};case
16:var
H=d[1];return function(d){return bc(c,[6,b,d],H)};case
17:var
b=[0,b,d[1]],d=d[2];continue;case
18:var
k=d[1];if(0===k[0]){var
I=d[2],J=k[1][1],K=0,c=function(c,d,e){return function(b){return bc(d,[1,c,[0,b]],e)}}(b,c,I),b=K,d=J;continue}var
L=d[2],M=k[1][1],N=0,c=function(c,d,e){return function(b){return bc(d,[1,c,[1,b]],e)}}(b,c,L),b=N,d=M;continue;case
19:throw[0,bi,L4];case
20:var
O=d[3],P=[8,b,L5];return function(b){return bc(c,P,O)};case
21:var
Q=d[2];return function(d){return bc(c,[4,b,nN(L6,d)],Q)};case
22:var
R=d[1];return function(d){return bc(c,[5,b,d],R)};case
23:var
f=d[2],j=d[1];if(typeof
j==="number")switch(j){case
0:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
1:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
2:throw[0,bi,L7];default:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f])}else
switch(j[0]){case
0:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
1:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
2:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
3:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
4:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
5:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
6:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
7:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
8:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);case
9:var
s=j[2];return e<50?o0(e+1|0,c,b,s,f):cs(o0,[0,c,b,s,f]);case
10:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f]);default:return e<50?bs(e+1|0,c,b,f):cs(bs,[0,c,b,f])}default:var
p=d[3],q=d[1],r=u(d[2],0);return e<50?oZ(e+1|0,c,b,p,q,r):cs(oZ,[0,c,b,p,q,r])}}function
o0(f,e,d,b,c){if(typeof
b==="number")return f<50?bs(f+1|0,e,d,c):cs(bs,[0,e,d,c]);else
switch(b[0]){case
0:var
a=b[1];return function(b){return dj(e,d,a,c)};case
1:var
g=b[1];return function(b){return dj(e,d,g,c)};case
2:var
h=b[1];return function(b){return dj(e,d,h,c)};case
3:var
i=b[1];return function(b){return dj(e,d,i,c)};case
4:var
j=b[1];return function(b){return dj(e,d,j,c)};case
5:var
k=b[1];return function(b){return dj(e,d,k,c)};case
6:var
l=b[1];return function(b){return dj(e,d,l,c)};case
7:var
m=b[1];return function(b){return dj(e,d,m,c)};case
8:var
n=b[2];return function(b){return dj(e,d,n,c)};case
9:var
o=b[3],p=b[2],q=ca(b5(b[1]),p);return function(b){return dj(e,d,cB(q,o),c)};case
10:var
r=b[1];return function(f,b){return dj(e,d,r,c)};case
11:var
s=b[1];return function(b){return dj(e,d,s,c)};case
12:var
t=b[1];return function(b){return dj(e,d,t,c)};case
13:throw[0,bi,L8];default:throw[0,bi,L9]}}function
bs(e,c,f,b){var
d=[8,f,L_];return e<50?hY(e+1|0,c,d,b):cs(hY,[0,c,d,b])}function
oZ(g,c,f,b,e,d){if(e){var
h=e[1];return function(e){return L3(c,f,b,h,u(d,e))}}var
a=[4,f,d];return g<50?hY(g+1|0,c,a,b):cs(hY,[0,c,a,b])}function
bc(b,c,d){return rZ(hY(0,b,c,d))}function
dj(b,c,d,e){return rZ(o0(0,b,c,d,e))}function
L3(b,c,d,e,f){return rZ(oZ(0,b,c,d,e,f))}function
ey(c,f){var
b=f;for(;;)if(typeof
b==="number")return 0;else
switch(b[0]){case
0:var
a=b[1],g=so(b[2]);ey(c,a);return hu(c,g);case
1:var
d=b[2],e=b[1];if(0===d[0]){var
h=d[1];ey(c,e);hu(c,L$);var
b=h;continue}var
i=d[1];ey(c,e);hu(c,Ma);var
b=i;continue;case
6:var
l=b[2];ey(c,b[1]);return u(l,c);case
7:ey(c,b[1]);return et(c);case
8:var
m=b[2];ey(c,b[1]);return b$(m);case
2:case
4:var
j=b[2];ey(c,b[1]);return hu(c,j);default:var
k=b[2];ey(c,b[1]);return Jk(c,k)}}function
ez(c,f){var
b=f;for(;;)if(typeof
b==="number")return 0;else
switch(b[0]){case
0:var
a=b[1],g=so(b[2]);ez(c,a);return ct(c,g);case
1:var
d=b[2],e=b[1];if(0===d[0]){var
h=d[1];ez(c,e);ct(c,Mb);var
b=h;continue}var
i=d[1];ez(c,e);ct(c,Mc);var
b=i;continue;case
6:var
l=b[2];ez(c,b[1]);return ct(c,u(l,0));case
7:var
b=b[1];continue;case
8:var
m=b[2];ez(c,b[1]);return b$(m);case
2:case
4:var
j=b[2];ez(c,b[1]);return ct(c,j);default:var
k=b[2];ez(c,b[1]);return bw(c,k)}}function
Md(b){if(rY(b,Me))return Mf;var
e=aM(b);function
a(e){var
d=Mg[1],c=hA(fc);return u(bc(function(b){ez(c,b);return aE(hB(c))},0,d),b)}function
g(f){var
c=f;for(;;){if(c===e)return c;var
d=bJ(b,c);if(9!==d&&32!==d)return c;var
c=c+1|0;continue}}function
m(f,d){var
c=d;for(;;){if(c===e)return c;if(25<bJ(b,c)+qq>>>0)return c;var
c=c+1|0;continue}}function
o(g,a){var
c=a;for(;;){if(c===e)return c;var
d=bJ(b,c),f=0;if(48<=d){if(!(58<=d))f=1}else
if(45===d)f=1;if(f){var
c=c+1|0;continue}return c}}var
f=g(0),j=m(f,f),c=f7(b,f,j-f|0),d=g(j),h=o(d,d);if(d===h)var
i=0;else
try{var
p=nR(f7(b,d,h-d|0)),i=p}catch(b){b=n(b);if(b[1]!==jc)throw b;var
i=a(0)}if(g(h)!==e)a(0);var
l=0;if(R(c,Mh)&&R(c,Mi))var
k=R(c,Mj)?R(c,Mk)?R(c,Ml)?R(c,Mm)?a(0):1:2:3:0;else
l=1;if(l)var
k=4;return[0,i,k]}function
sq(e,d){var
b=d[1],c=0;return bc(function(b){ey(e,b);return 0},c,b)}function
hD(b){return sq(d5,b)}function
aN(c){var
b=c[1];return bc(function(c){var
b=hA(64);ez(b,c);return hB(b)},0,b)}var
od=[0,0];function
of(h,g){var
b=h[1+g];if(1-(typeof
b==="number"?1:0)){if(nW(b)===kb)return u(aN(Mn),b);if(nW(b)===mw){var
d=rM(JM,b),c=0,a=aM(d);for(;;){if(a<=c)return b1(d,JL);var
e=bJ(d,c),f=0;if(48<=e){if(!(58<=e))f=1}else
if(45===e)f=1;if(f){var
c=c+1|0;continue}return d}}return Mo}return u(aN(Mp),b)}function
sr(c,b){if(c.length-1<=b)return Mq;var
d=sr(c,b+1|0),e=of(c,b);return ar(aN(Mr),e,d)}function
og(b){function
n(f){var
c=f;for(;;){if(c){var
a=c[2],g=c[1];try{var
e=0,d=u(g,b);e=1}catch(a){}if(e&&d)return[0,d[1]];var
c=a;continue}return 0}}var
g=n(od[1]);if(g)return g[1];if(b===n3)return Mw;if(b===r8)return Mx;if(b[1]===r7){var
d=b[2],h=d[3],o=d[2],p=d[1];return jP(aN(oe),p,o,h,h+5|0,My)}if(b[1]===bi){var
e=b[2],i=e[3],q=e[2],r=e[1];return jP(aN(oe),r,q,i,i+6|0,Mz)}if(b[1]===r_){var
f=b[2],j=f[3],s=f[2],t=f[1];return jP(aN(oe),t,s,j,j+6|0,MA)}if(0===nW(b)){var
a=b.length-1,v=b[1][1];if(2<a>>>0)var
k=sr(b,2),l=of(b,1),c=ar(aN(Ms),l,k);else
switch(a){case
0:var
c=Mt;break;case
1:var
c=Mu;break;default:var
m=of(b,1),c=u(aN(Mv),m)}return b1(v,c)}return b[1]}function
oh(s,r){var
e=b0V(r),a=e.length-1-1|0,o=0;if(!(a<0)){var
c=o;for(;;){var
b=c0(e,c)[1+c],f=function(b){return function(c){return c?0===b?MB:MC:0===b?MD:ME}}(c);if(0===b[0])var
g=b[5],h=b[4],i=b[3],j=b[6]?MF:MH,k=b[2],l=b[7],m=f(b[1]),d=[0,b0N(aN(MG),m,l,k,j,i,h,g)];else
if(b[1])var
d=0;else
var
n=f(0),d=[0,u(aN(MI),n)];if(d){var
p=d[1];u(sq(s,MJ),p)}var
q=c+1|0;if(a!==c){var
c=q;continue}break}}return 0}function
ss(d){for(;;){var
b=od[1],c=1-n2(od,b,[0,d,b]);if(c)continue;return c}}var
ML=MK.slice();function
MM(e,d){var
f=og(e);u(hD(MN),f);oh(d5,d);var
b=b1g(0);if(b<0){var
c=ht(b);sb(c0(ML,c)[1+c])}return et(d5)}var
MO=[0];rW(b(z9),function(e,h){try{try{var
b=h?MO:Jd(0);try{n6(0)}catch(a){}try{var
g=MM(e,b),d=g}catch(c){c=n(c);var
f=og(e);u(hD(MQ),f);oh(d5,b);var
a=og(c);u(hD(MR),a);oh(d5,Jd(0));var
d=et(d5)}var
c=d}catch(b){b=n(b);if(b!==n3)throw b;var
c=sb(MP)}return c}catch(a){return 0}});try{var
b0J=Jr(b0I),su=b0J}catch(b){b=n(b);if(b!==di)throw b;try{var
b0H=Jr(b0G),st=b0H}catch(b){b=n(b);if(b!==di)throw b;var
st=MS}var
su=st}n7(su,82);var
oi=[bl,MT,c1(0)],jl=0,sv=-1;function
hE(b,c){b[13]=b[13]+c[3]|0;return sj(c,b[28])}var
sw=1000000010;function
oj(c,b){return cm(c[17],b,0,aM(b))}function
jm(b){return u(b[19],0)}function
sx(b,d,c){b[9]=b[9]-d|0;oj(b,c);b[11]=0;return 0}function
jn(d,b){var
c=R(b,MU);return c?sx(d,aM(b),b):c}function
fC(b,c,f){var
a=c[3],g=c[2];jn(b,c[1]);jm(b);b[11]=1;var
d=(b[6]-f|0)+g|0,e=b[8],h=e<=d?e:d;b[10]=h;b[9]=b[6]-b[10]|0;u(b[21],b[10]);return jn(b,a)}function
sy(c,b){return fC(c,MV,b)}function
ga(b,c){var
d=c[2],e=c[3];jn(b,c[1]);b[9]=b[9]-d|0;u(b[20],d);return jn(b,e)}function
MW(b,i,c){if(typeof
c==="number")switch(c){case
0:var
r=f9(b[3]);if(r){var
s=r[1][1],t=function(c,b){if(b){var
d=b[1],e=b[2];return Ji(c,d)?[0,c,b]:[0,d,t(c,e)]}return[0,c,0]};s[1]=t(b[6]-b[9]|0,s[1]);return 0}return 0;case
1:f8(b[2]);return 0;case
2:f8(b[3]);return 0;case
3:var
v=f9(b[2]);return v?sy(b,v[1][2]):jm(b);case
4:var
w=b[10]!==(b[6]-b[9]|0)?1:0;if(w){var
f=b[28],g=f[2];if(g){var
m=g[1];if(g[2]){var
J=g[2];f[1]=f[1]-1|0;f[2]=J;var
h=[0,m]}else{n_(f);var
h=[0,m]}}else
var
h=0;if(h){var
q=h[1],L=q[1];b[12]=b[12]-q[3]|0;b[9]=b[9]+L|0;return 0}return 0}return w;default:var
x=f8(b[5]);return x?oj(b,u(b[25],x[1])):0}else
switch(c[0]){case
0:return sx(b,i,c[1]);case
1:var
d=c[2],a=c[1],y=d[1],M=d[2],z=f9(b[2]);if(z){var
A=z[1],e=A[2];switch(A[1]){case
0:return ga(b,a);case
1:return fC(b,d,e);case
2:return fC(b,d,e);case
3:return b[9]<(i+aM(y)|0)?fC(b,d,e):ga(b,a);case
4:return b[11]?ga(b,a):b[9]<(i+aM(y)|0)?fC(b,d,e):((b[6]-e|0)+M|0)<b[10]?fC(b,d,e):ga(b,a);default:return ga(b,a)}}return 0;case
2:var
k=b[6]-b[9]|0,N=c[2],O=c[1],B=f9(b[3]);if(B){var
C=B[1][1],D=C[1];if(D){var
j=C[1],P=D[1];for(;;){if(j){var
E=j[1],Q=j[2];if(!(k<=E)){var
j=Q;continue}var
F=E}else
var
F=P;var
l=F;break}}else
var
l=k;var
G=l-k|0;return 0<=G?ga(b,[0,MY,G+O|0,MX]):fC(b,[0,M0,l+N|0,MZ],b[6])}return 0;case
3:var
H=c[2],R=c[1];if(b[8]<(b[6]-b[9]|0)){var
n=f9(b[2]);if(n){var
o=n[1],p=o[2],K=o[1];if(b[9]<p&&!(3<K-1>>>0))sy(b,p)}else
jm(b)}var
S=b[9]-R|0,T=1===H?1:b[9]<i?H:5;return fB([0,T,S],b[2]);case
4:return fB(c[1],b[3]);default:var
I=c[1];oj(b,u(b[24],I));return fB(I,b[5])}}function
sz(b){for(;;){var
a=b[28][2],g=a?[0,a[1]]:0;if(g){var
e=g[1],f=e[1],m=0<=f?1:0,j=e[3],k=e[2],l=b[13]-b[12]|0,h=m||(b[9]<=l?1:0);if(h){var
c=b[28],d=c[2];if(d){if(d[2]){var
i=d[2];c[1]=c[1]-1|0;c[2]=i}else
n_(c);var
n=0<=f?f:sw;MW(b,n,k);b[12]=j+b[12]|0;continue}throw Kj}return h}return 0}}function
sA(b,c){hE(b,c);return sz(b)}function
sB(d,b,c){return sA(d,[0,b,[0,c],b])}function
ok(b){hz(b);return fB([0,-1,[0,sv,M1,0]],b)}function
ol(b,d){var
e=f9(b[1]);if(e){var
f=e[1],c=f[2],a=c[1];if(f[1]<b[12])return ok(b[1]);var
g=c[2];if(typeof
g!=="number")switch(g[0]){case
3:var
h=1-d,j=h?(c[1]=b[13]+a|0,f8(b[1]),0):h;return j;case
1:case
2:var
i=d?(c[1]=b[13]+a|0,f8(b[1]),0):d;return i}return 0}return 0}function
sC(b,d,c){hE(b,c);if(d)ol(b,1);return fB([0,b[13],c],b[1])}function
sD(b,f,e){b[14]=b[14]+1|0;if(b[14]<b[15])return sC(b,0,[0,-b[13]|0,[3,f,e],0]);var
c=b[14]===b[15]?1:0;if(c){var
d=b[16];return sB(b,aM(d),d)}return c}function
sE(b,e){var
c=1<b[14]?1:0;if(c){if(b[14]<b[15]){hE(b,[0,jl,1,0]);ol(b,1);ol(b,0)}b[14]=b[14]-1|0;var
d=0}else
var
d=c;return d}function
sF(b,f){if(b[23])hE(b,[0,jl,5,0]);var
c=b[22];if(c){var
d=f8(b[4]);if(d)return u(b[27],d[1]);var
e=0}else
var
e=c;return e}function
om(b,e){var
c=b[4][1];for(;;){if(c){var
d=c[2];sF(b,0);var
c=d;continue}for(;;){if(1<b[14]){sE(b,0);continue}b[13]=sw;sz(b);if(e)jm(b);b[12]=1;b[13]=1;n_(b[28]);ok(b[1]);hz(b[2]);hz(b[3]);hz(b[4]);hz(b[5]);b[10]=0;b[14]=0;b[9]=b[6];return sD(b,0,3)}}}function
on(b,e,d){var
c=b[14]<b[15]?1:0;return c?sB(b,e,d):c}function
sG(d,c,b){return on(d,c,b)}function
hF(c,b){return sG(c,1,jf(1,b))}function
hG(b,c){om(b,0);return u(b[18],0)}var
sH=jf(80,32);function
sI(c,e){var
b=e;for(;;){var
d=0<b?1:0;if(d){if(80<b){cm(c[17],sH,0,80);var
b=b-80|0;continue}return cm(c[17],sH,0,b)}return d}}function
M7(b){return b[1]===oi?b1(M9,b1(b[2],M8)):M_}function
M$(b){return b[1]===oi?b1(Nb,b1(b[2],Na)):Nc}function
Nd(b){return 0}function
Ne(b){return 0}function
sJ(i,h){function
j(b){return 0}function
k(b){return 0}var
d=[0,0,0,0],e=[0,sv,Nf,0];function
l(b){return 0}sj(e,d);var
c=hy(0);ok(c);fB([0,1,e],c);var
f=hy(0),a=hy(0),g=hy(0),b=[0,c,hy(0),g,a,f,78,10,68,78,0,1,1,1,1,JD,Ng,i,h,l,k,j,0,0,M7,M$,Nd,Ne,d];b[19]=function(c){return cm(b[17],M6,0,1)};b[20]=function(c){return sI(b,c)};b[21]=function(c){return sI(b,c)};return b}function
sK(d){function
b(b){return et(d)}return sJ(function(e,b,c){if(0<=b&&0<=c&&!((aM(e)-c|0)<b))return rT(d,e,b,c);return b$(JP)},b)}function
oo(b){function
c(b){return 0}return sJ(function(c,d,e){return jh(b,c,d,e)},c)}var
Nh=pI;function
sL(b){return hA(Nh)}var
Ni=sL(0),Nj=sK(JN),Nk=sK(d5);oo(Ni);function
sM(a,f){var
b=hA(16),d=oo(b);ar(a,d,f);hG(d,0);var
e=b[2];if(2<=e){var
c=e-2|0,g=1;if(0<=c&&!((b[2]-c|0)<1))return je(b[1],g,c);return b$(Kk)}return hB(b)}function
c5(b,c){var
d=0;if(typeof
c==="number")return 0;else
switch(c[0]){case
0:var
e=c[2];c5(b,c[1]);if(typeof
e==="number")switch(e){case
0:return sE(b,0);case
1:return sF(b,0);case
2:return hG(b,0);case
3:var
s=b[14]<b[15]?1:0;return s?sA(b,[0,jl,3,0]):s;case
4:om(b,1);return u(b[18],0);case
5:return hF(b,64);default:return hF(b,37)}else
switch(e[0]){case
0:var
i=[0,M5,e[2],M4],t=b[14]<b[15]?1:0,N=[0,M3,e[3],M2],K=i[3],L=i[2],M=i[1];return t?sC(b,1,[0,-b[13]|0,[1,i,N],(aM(M)+L|0)+aM(K)|0]):t;case
1:return 0;default:var
O=e[1];hF(b,64);return hF(b,O)}case
1:var
j=c[2],v=c[1];if(0===j[0]){var
P=j[1];c5(b,v);var
k=[0,oi,sM(c5,P)];if(b[22]){fB(k,b[4]);u(b[26],k)}var
r=b[23];return r?hE(b,[0,jl,[5,k],0]):r}var
Q=j[1];c5(b,v);var
w=Md(sM(c5,Q));return sD(b,w[1],w[2]);case
2:var
f=c[1],G=0;if(typeof
f!=="number"&&0===f[0]){var
m=f[2],T=0;if(typeof
m!=="number"&&1===m[0]){var
A=c[2],z=m[2],y=f[1];G=1;T=1}}if(!G){var
l=c[2],x=f;d=2}break;case
3:var
a=c[1],H=0;if(typeof
a!=="number"&&0===a[0]){var
n=a[2],U=0;if(typeof
n!=="number"&&1===n[0]){var
F=c[2],E=n[2],D=a[1];d=1;H=1;U=1}}if(!H){var
C=c[2],B=a;d=3}break;case
4:var
g=c[1],I=0;if(typeof
g!=="number"&&0===g[0]){var
o=g[2],V=0;if(typeof
o!=="number"&&1===o[0]){var
A=c[2],z=o[2],y=g[1];I=1;V=1}}if(!I){var
l=c[2],x=g;d=2}break;case
5:var
h=c[1],q=0;if(typeof
h==="number"||!(0===h[0]))q=1;else{var
p=h[2],J=0;if(typeof
p!=="number"&&1===p[0]){var
F=c[2],E=p[2],D=h[1];d=1;J=1}if(!J)q=1}if(q){var
C=c[2],B=h;d=3}break;case
6:var
R=c[2];c5(b,c[1]);return u(R,b);case
7:c5(b,c[1]);return hG(b,0);default:var
S=c[2];c5(b,c[1]);return b$(S)}switch(d){case
0:c5(b,y);return on(b,z,A);case
1:c5(b,D);return on(b,E,jf(1,F));case
2:c5(b,x);return sG(b,aM(l),l);default:c5(b,B);return hF(b,C)}}function
sN(d){return function(e){var
b=e[1],c=0;return bc(function(b){c5(d,b);return 0},c,b)}}function
op(e){var
d=e[1],b=sL(0),c=oo(b);return bc(function(e){c5(c,e);om(c,0);var
d=hB(b);b[2]=0;b[1]=b[4];b[3]=dv(b[1]);return d},0,d)}JQ(function(b){hG(Nj,0);return hG(Nk,0)});function
sO(c,b){var
d=nW(b)===bl?b:b[1];return rW(c,d)}var
Nl=2;function
Nm(d){var
b=[0,0],e=aM(d)-1|0,f=0;if(!(e<0)){var
c=f;for(;;){var
g=bJ(d,c);b[1]=(pq*b[1]|0)+g|0;var
h=c+1|0;if(e!==c){var
c=h;continue}break}}b[1]=b[1]&p3;var
a=1073741823<b[1]?b[1]-kd|0:b[1];return a}var
oq=jg([0,rX]),jo=jg([0,rX]),jp=jg([0,fy]),sP=Jm(0,0),Nn=[0,0];function
sQ(b){return 2<b?sQ((b+1|0)/2|0)*2|0:b}function
sR(e){Nn[1]++;var
c=e.length-1,d=nU((c*2|0)+2|0,sP);c0(d,0)[1]=c;var
g=((sQ(c)*32|0)/8|0)-1|0;c0(d,1)[2]=g;var
f=c-1|0,h=0;if(!(f<0)){var
b=h;for(;;){var
a=(b*2|0)+3|0,i=c0(e,b)[1+b];c0(d,a)[1+a]=i;var
j=b+1|0;if(f!==b){var
b=j;continue}break}}return[0,Nl,d,jo[1],jp[1],0,0,oq[1],0]}function
or(c,e){var
b=c[2].length-1,f=b<e?1:0;if(f){var
d=nU(e,sP),a=c[2],h=0;if(0<=b&&!((a.length-1-b|0)<0)&&!((d.length-1-b|0)<0)){b0P(a,0,d,0,b);h=1}if(!h)b$(J$);c[2]=d;var
g=0}else
var
g=f;return g}var
sS=[0,0],No=[0,0];function
os(b){var
c=b[2].length-1;or(b,c+1|0);return c}function
Np(b,e){try{var
c=ar(jo[28],e,b[3]);return c}catch(c){c=n(c);if(c===di){var
d=os(b);b[3]=cm(jo[4],e,d,b[3]);b[4]=cm(jp[4],d,1,b[4]);return d}throw c}}function
jq(c,b){return ck(function(b){return Np(c,b)},b)}function
Nq(b){var
c=b[1];b[1]=c+1|0;return c}function
jr(b,c){try{var
d=ar(oq[28],c,b[7]);return d}catch(d){d=n(d);if(d===di){var
e=Nq(b);if(R(c,Nr))b[7]=cm(oq[4],c,e,b[7]);return e}throw d}}function
js(d){if(0===d)return sR([0]);var
c=sR(ck(Nm,d)),e=d.length-1-1|0,a=0;if(!(e<0)){var
b=a;for(;;){var
f=(b*2|0)+2|0;c[3]=cm(jo[4],d[1+b],f,c[3]);c[4]=cm(jp[4],f,1,c[4]);var
g=b+1|0;if(e!==b){var
b=g;continue}break}}return c}function
jt(b){sS[1]=(sS[1]+b[1]|0)-1|0;b[8]=ev(b[8]);return or(b,3+((c0(b[2],1)[2]*16|0)/32|0)|0)}function
ju(c,b){if(c)return c;var
d=Jm(bl,b[1]);d[1]=b[2];return b1o(d)}function
jv(b){var
d=os(b),e=0;if(0!==(d%2|0)&&!((2+((c0(b[2],1)[2]*16|0)/32|0)|0)<d)){var
c=os(b);e=1}if(!e)var
c=d;c0(b[2],c)[1+c]=0;return c}function
jw(d,g){var
e=[0,0],al=g.length-1;for(;;){if(e[1]<al){var
h=e[1],f=c0(g,h)[1+h],b=function(c){e[1]++;var
b=e[1];return c0(g,b)[1+b]},a=b(0);if(typeof
a==="number")switch(a){case
0:var
i=b(0),c=function(b){return function(c){return b}}(i);break;case
1:var
j=b(0),c=function(c){return function(b){return b[1+c]}}(j);break;case
2:var
k=b(0),l=b(0),c=function(c,d){return function(b){return b[1+c][1+d]}}(k,l);break;case
3:var
m=b(0),c=function(c){return function(b){return u(b[1][1+c],b)}}(m);break;case
4:var
n=b(0),c=function(d){return function(c,b){c[1+d]=b;return 0}}(n);break;case
5:var
o=b(0),p=b(0),c=function(b,c){return function(d){return u(b,c)}}(o,p);break;case
6:var
q=b(0),r=b(0),c=function(c,d){return function(b){return u(c,b[1+d])}}(q,r);break;case
7:var
s=b(0),t=b(0),v=b(0),c=function(c,d,e){return function(b){return u(c,b[1+d][1+e])}}(s,t,v);break;case
8:var
w=b(0),x=b(0),c=function(c,d){return function(b){return u(c,u(b[1][1+d],b))}}(w,x);break;case
9:var
y=b(0),z=b(0),A=b(0),c=function(b,c,d){return function(e){return ar(b,c,d)}}(y,z,A);break;case
10:var
B=b(0),C=b(0),D=b(0),c=function(c,d,e){return function(b){return ar(c,d,b[1+e])}}(B,C,D);break;case
11:var
E=b(0),F=b(0),G=b(0),H=b(0),c=function(c,d,e,f){return function(b){return ar(c,d,b[1+e][1+f])}}(E,F,G,H);break;case
12:var
I=b(0),J=b(0),K=b(0),c=function(c,d,e){return function(b){return ar(c,d,u(b[1][1+e],b))}}(I,J,K);break;case
13:var
L=b(0),M=b(0),N=b(0),c=function(c,d,e){return function(b){return ar(c,b[1+d],e)}}(L,M,N);break;case
14:var
O=b(0),P=b(0),Q=b(0),R=b(0),c=function(c,d,e,f){return function(b){return ar(c,b[1+d][1+e],f)}}(O,P,Q,R);break;case
15:var
S=b(0),T=b(0),U=b(0),c=function(c,d,e){return function(b){return ar(c,u(b[1][1+d],b),e)}}(S,T,U);break;case
16:var
V=b(0),W=b(0),c=function(c,d){return function(b){return ar(b[1][1+c],b,d)}}(V,W);break;case
17:var
X=b(0),Y=b(0),c=function(c,d){return function(b){return ar(b[1][1+c],b,b[1+d])}}(X,Y);break;case
18:var
Z=b(0),_=b(0),$=b(0),c=function(c,d,e){return function(b){return ar(b[1][1+c],b,b[1+d][1+e])}}(Z,_,$);break;case
19:var
aa=b(0),ab=b(0),c=function(d,e){return function(b){var
c=u(b[1][1+e],b);return ar(b[1][1+d],b,c)}}(aa,ab);break;case
20:var
ac=b(0),ad=b(0);jv(d);var
c=function(c,b){return function(d){return u(nO(b,c,0),b)}}(ac,ad);break;case
21:var
ae=b(0),af=b(0);jv(d);var
c=function(d,e){return function(c){var
b=c[1+e];return u(nO(b,d,0),b)}}(ae,af);break;case
22:var
ag=b(0),ah=b(0),ai=b(0);jv(d);var
c=function(d,e,f){return function(c){var
b=c[1+e][1+f];return u(nO(b,d,0),b)}}(ag,ah,ai);break;default:var
aj=b(0),ak=b(0);jv(d);var
c=function(d,e){return function(b){var
c=u(b[1][1+e],b);return u(nO(c,d,0),c)}}(aj,ak)}else
var
c=a;No[1]++;if(ar(jp[28],f,d[4])){or(d,f+1|0);c0(d[2],f)[1+f]=c}else
d[6]=[0,[0,f,c],d[6]];e[1]++;continue}return 0}}var
ot=[bl,Ns,c1(0)],ou=[bl,Nt,c1(0)];function
Nu(c,b){var
d=b[3],e=b[2],f=b[1];return ud(sN(c),Nv,f,e,d)}function
gb(c,b){return[0,c[1]+b[1]|0,c[2]+b[2]|0,c[3]+b[3]|0]}function
sT(b){if(0===b[1]&&0===b[2])return b[3];throw ou}function
hH(b){var
c=0===(b%kc|0)?1:0;if(c)var
d=c;else
var
e=0===(b%4|0)?1:0,d=e?0!==(b%de|0)?1:0:e;return d}function
hI(d,c){var
b=d-1|0;if(11<b>>>0)throw ot;switch(b){case
1:return c?29:28;case
3:case
5:case
8:case
10:return 30;default:return 31}}function
hJ(b){try{var
c=1<=b[3]?1:0;if(c)var
e=hH(b[1]),f=hI(b[2],e),d=b[3]<=f?1:0;else
var
d=c;return d}catch(b){b=n(b);if(b===ot)return 0;throw b}}function
sU(e,d,c){var
b=[0,e,d,c];if(hJ(b))return b;throw ot}function
hK(a,f,e){var
c=a,b=e;for(;;){var
d=f+b|0;if(1<=d&&!(12<d))return[0,c,d];if(12<d){var
c=c+1|0,b=b+zH|0;continue}var
c=c-1|0,b=b+12|0;continue}}function
hL(c,b){return 0===fy(c[1],b[1])?0===fy(c[2],b[2])?fy(c[3],b[3]):fy(c[2],b[2]):fy(c[1],b[1])}function
NA(c,b){var
d=b[3],e=b[2],f=b[1];return ud(sN(c),NB,f,e,d)}function
jx(c,b){if(c[1]===b[1]&&c[2]===b[2])return[0,0,0,c[3]-b[3]|0];if(0<=hL(c,b)){var
e=hK(b[1],b[2],1),f=jx(c,[0,e[1],e[2],1]),a=b[3],g=hH(b[1]);return gb([0,0,0,(hI(b[2],g)-a|0)+1|0],f)}var
d=jx(b,c);return[0,-d[1]|0,-d[2]|0,-d[3]|0]}b1H(0);sO(NE,[bl,ND,c1(0)]);function
fD(b){if(typeof
b==="number"&&b!==kd)return-b|0;return b1L(b)}function
e4(c,b){if(typeof
c==="number"&&typeof
b==="number"){var
d=c+b|0;return 0<=((d^c)&(d^b))?d:Jx(c,b)}return Jx(c,b)}function
jy(b,c){if(typeof
b==="number"&&typeof
c==="number"){var
d=b-c|0;return 0<=((b^c)&(d^b))?d:r3(b,c)}return r3(b,c)}function
cC(c,b){if(typeof
c==="number"&&typeof
b==="number"&&!b1K(c,b))return hp(c,b);return b1J(c,b)}function
sV(c,b){return typeof
b==="number"?-1===b?fD(c):typeof
c==="number"?Ja(c,b):Jy(c,b):Jy(c,b)}function
jz(b){return typeof
b==="number"?0<=b?b:b!==kd?-b|0:Jw(b):Jw(b)}function
e5(c,b){if(typeof
c==="number"&&0<=b&&b<32){var
d=c<<b;return d>>b===c?d:JA(c,b)}return JA(c,b)}function
sW(b){return typeof
b==="number"?b:b1R(b)}var
eA=0,jA=1,NF=-1;function
sX(b){return f5(0,b,0,aM(b))}function
NG(c,b){return f5(c,b,0,aM(b))}function
ov(b){if(typeof
b==="number")return b;var
f=r2(b);if(63<f){var
c=f-55|0,a=0;if(typeof
b==="number"&&0<=c){var
g=c<32?c:31,d=b>>g;a=1}if(!a)var
d=b1P(b,c);var
i=b1C(b,e5(d,c)),e=n1(d),h=i?e:b1b(e,NH);return nT(nQ(h),c)}return nQ(n1(b))}function
gc(b,c){if(b!==0&&c!==1){var
d=b1F(b,c);if(d===1)return[0,b,c];var
e=sV(c,d);return[0,sV(b,d),e]}return[0,b,jA]}function
sY(c,b){var
d=c2(b);if(0===d)return[0,c2(c),eA];if(0<d)return gc(c,b);var
e=fD(b);return gc(fD(c),e)}function
d6(b){return[0,b,jA]}function
sZ(b){return d6(b)}var
s0=d6(eA),jB=[0,jA,eA],jC=[0,NF,eA],gd=[0,eA,eA];function
fE(b){if(b[2]===0){var
c=c2(b[1])+1|0;if(!(2<c>>>0))switch(c){case
0:return 2;case
1:break;default:return 1}return 3}return b[1]===0?0:4}function
ow(e,d){var
f=fE(e),c=fE(d),b=0;switch(f){case
1:var
j=c-1|0;if(!(2<j>>>0))switch(j){case
0:b=2;break;case
1:break;default:b=1}break;case
2:if(1===c)b=1;else
if(c)switch(c-2|0){case
1:b=1;break;case
2:break;default:b=2}break;case
3:if(3!==c)return-1;b=2;break;default:b=1}var
k=0;switch(b){case
1:var
i=c-1|0;if(!(2<i>>>0))switch(i){case
0:k=1;break;case
1:break;default:return 1}break;case
0:break;default:return 0}if(!k){var
g=0;if(!(4<=f))switch(f){case
0:break;case
2:g=1;break;default:g=2}var
h=0;switch(g){case
0:if(2!==c){if(a(e[2],d[2]))return eu(e[1],d[1]);var
l=cC(d[1],e[2]);return eu(cC(e[1],d[2]),l)}h=1;break;case
1:break;default:h=1}if(h)return 1}return-1}function
s1(b){var
c=b[2];return[0,fD(b[1]),c]}function
s2(d,b,c){if(b[2]===c[2]){var
e=b[2];return gc(ar(d,b[1],c[1]),e)}var
f=cC(b[2],c[2]),a=cC(c[1],b[2]);return gc(ar(d,cC(b[1],c[2]),a),f)}function
hM(c,b){if(c[2]!==0&&b[2]!==0){var
d=cC(c[2],b[2]);return gc(cC(c[1],b[1]),d)}return[0,hp(c2(c[1]),c2(b[1])),eA]}function
ox(c,b){if(0<=c2(b[1]))return hM(c,[0,b[2],b[1]]);var
d=fD(b[1]);return hM(c,[0,fD(b[2]),d])}function
oy(b){switch(b){case
0:return 2;case
1:return 8;case
2:return 10;default:return 16}}function
oz(f,e,d,c){var
b=e;for(;;){if(d<=b)return 0;if(u(c,bJ(f,b)))return[0,b];var
b=b+1|0;continue}}function
NK(b){if(R(b,NL)){if(R(b,NM)){if(!R(b,NN))return jC;if(R(b,NO)){if(R(b,NP))try{var
r=J7(b,47),X=f5(0,b,r+1|0,(aM(b)-r|0)-1|0),Y=sY(f5(0,b,0,r),X);return Y}catch(r){r=n(r);if(r===di){var
i=aM(b),x=0;if(i<1)var
s=[0,0,x];else{var
M=bJ(b,0)+xB|0,P=0;if(!(2<M>>>0)){var
Q=0;switch(M){case
0:var
O=[0,0,1];break;case
1:Q=1;break;default:var
O=[0,1,1]}if(!Q){var
N=O;P=1}}if(!P)var
N=[0,0,x];var
s=N}var
d=s[2];if(i<(d+2|0))var
t=[0,2,d];else{var
W=bJ(b,d),g=bJ(b,d+1|0),q=0;if(48===W){var
h=0;if(89<=g){if(98===g)h=2;else
if(ir===g)h=1;else
if(lM!==g){q=1;h=3}}else
if(66===g)h=2;else
if(79===g)h=1;else
if(!(88<=g)){q=1;h=3}switch(h){case
3:break;case
0:var
p=[0,3,d+2|0];break;case
1:var
p=[0,1,d+2|0];break;default:var
p=[0,0,d+2|0]}}else
q=1;if(q)var
p=[0,2,d];var
t=p}var
e=t[2],c=t[1],S=2===c?function(b){if(69!==b&&fn!==b)return 0;return 1}:3<=c?function(b){if(80!==b&&rD!==b)return 0;return 1}:function(b){return 0},y=oz(b,e,i,S);if(y)var
z=y[1],A=z+1|0,f=z,B=sW(f5(10,b,A,i-A|0));else
var
f=i,B=0;if(2<=c){var
C=oz(b,e,f,function(b){return 46===b?1:0});if(C){var
u=C[1];if(2===c)var
D=1;else{if(!(3<=c))throw[0,bi,NR];var
D=4}var
F=u+1|0,G=f-1|0,E=0;if(G<F)var
H=E;else{var
m=F,l=E;for(;;){var
a=bJ(b,m),j=0;if(71<=a){if(97<=a){if(!(iU<=a))j=1}else
if(95===a){var
o=l;j=2}}else
if(58<=a){if(65<=a)j=1}else
if(48<=a)j=1;switch(j){case
0:b$(NQ);var
o=l;break;case
1:var
o=l+1|0;break}var
V=m+1|0;if(G!==m){var
m=V,l=o;continue}var
H=o;break}}var
I=oz(b,u+1|0,f,function(b){return 95!==b?1:0}),J=I?I[1]:f,T=f7(b,J,f-J|0),U=b1(f7(b,e,u-e|0),T),v=hp(H,D),k=NG(oy(c),U)}else
var
v=0,k=f5(oy(c),b,e,f-e|0)}else
var
v=0,k=f5(oy(c),b,e,f-e|0);var
w=B-v|0,K=2===c?10:3<=c?2:1,L=0<=w?d6(cC(k,Jz(K,w))):sY(k,Jz(K,-w|0));return s[1]?s1(L):L}throw r}return gd}}return jB}return s0}var
NT=[bl,NS,c1(0)];function
s3(b){throw[0,NT,b]}var
NV=[0,function(b){throw[0,bi,NU]}];NV[1]=function(b){var
c=rp;for(;;){var
d=rS(NW,c,b);if(0===d)return n9(b);u(b[1],b);var
c=d;continue}};function
s4(b){var
c=10<=b?b+87|0:b+48|0;return sc(c)}function
fF(f,b,d,c,e){jh(c,f,b[1],d-b[1]|0);ct(c,e);b[1]=d+1|0;return 0}function
NY(c,b,d){try{var
a=jh(d,c,b[1],aM(c)-b[1]|0);return a}catch(d){d=n(d);var
e=aM(c)-b[1]|0,f=b[1];cm(hD(NZ),c,f,e);throw d}}function
fG(b,e){bw(b,34);var
d=[0,0],g=aM(e)-1|0,i=0;if(!(g<0)){var
c=i;for(;;){var
f=bJ(e,c);if(92===f)fF(e,d,c,b,N0);else{var
a=0;if(35<=f)if(j6===f)a=1;else
a=2;else
if(8<=f){var
h=0;switch(f-8|0){case
0:fF(e,d,c,b,N1);break;case
1:fF(e,d,c,b,N2);break;case
2:fF(e,d,c,b,N3);break;case
4:fF(e,d,c,b,N4);break;case
5:fF(e,d,c,b,N5);break;case
26:fF(e,d,c,b,N6);break;case
24:case
25:a=2;h=1;break;default:a=1;h=1}}else
a=1;switch(a){case
2:break;case
1:jh(b,e,d[1],c-d[1]|0);ct(b,NX);bw(b,s4(f>>>4|0));bw(b,s4(f&15));d[1]=c+1|0;break}}var
j=c+1|0;if(g!==c){var
c=j;continue}break}}NY(e,d,b);return bw(b,34)}function
s5(b,c){return ct(b,N7)}function
s6(c,b){var
d=b?N8:N9;return ct(c,d)}function
oA(c,b){return 0===b?0:(oA(c,b/10|0),bw(c,sc(ht(b%10|0)+48|0)))}function
s7(c,b){return 0<b?oA(c,b):0<=b?bw(c,48):(bw(c,45),oA(c,b))}function
s8(e){try{var
f=aM(e)-1|0,a=0;if(!(f<0)){var
b=a;for(;;){var
c=bJ(e,b),d=0;if(48<=c){if(!(58<=c))d=1}else
if(45===c)d=1;if(!d)throw r6;var
h=b+1|0;if(f!==b){var
b=h;continue}break}}var
g=1;return g}catch(b){b=n(b);if(b===r6)return 0;throw b}}function
ge(e,g,d,c){if(c){var
h=c[2];ar(e,d,c[1]);var
b=h;for(;;){if(b){var
f=b[2],a=b[1];u(g,d);ar(e,d,a);var
b=f;continue}return 0}}return 0}function
gf(b){return bw(b,44)}function
hN(b,c){if(typeof
c==="number")return s5(b,0);var
d=c[1];if(vx<=d){if(vA===d){var
l=c[2];bw(b,40);ge(hN,gf,b,l);return bw(b,41)}if(bY<=d){if(fN<=d){var
m=c[2],p=function(b,c){var
d=c[2];fG(b,c[1]);bw(b,58);return hN(b,d)};bw(b,d1);ge(p,gf,b,m);return bw(b,ef)}var
n=c[2];bw(b,91);ge(hN,gf,b,n);return bw(b,93)}if(q2<=d)return s6(b,c[2]);var
i=c[2],j=i[2],o=i[1];bw(b,60);fG(b,o);if(j){var
q=j[1];bw(b,58);hN(b,q)}return bw(b,62)}if(l9<=d){if(mI<=d){var
e=c[2],f=nK(e);if(3===f){var
k=0.<e?N_:N$;return ct(b,k)}if(4<=f)return ct(b,Oa);var
a=u(aN(Ob),e),g=Jc(a)==e?a:u(aN(Od),e);ct(b,g);var
h=s8(g);return h?ct(b,Oc):h}return s7(b,c[2])}return yK<=d?ct(b,c[2]):fG(b,c[2])}function
hO(b,c){if(typeof
c==="number")return s5(b,0);var
d=c[1];if(vx<=d){if(vA===d){var
m=c[2];bw(b,91);ge(hO,gf,b,m);return bw(b,93)}if(bY<=d){if(fN<=d){var
n=c[2],p=function(b,c){var
d=c[2];fG(b,c[1]);bw(b,58);return hO(b,d)};bw(b,d1);ge(p,gf,b,n);return bw(b,ef)}var
o=c[2];bw(b,91);ge(hO,gf,b,o);return bw(b,93)}if(q2<=d)return s6(b,c[2]);var
i=c[2],j=i[2],k=i[1];if(j){var
q=j[1];bw(b,91);fG(b,k);bw(b,44);hO(b,q);return bw(b,93)}return fG(b,k)}if(l9<=d){if(mI<=d){var
e=c[2],f=nK(e);if(3===f){var
l=0.<e?Oe:Of;return s3(l)}if(4<=f)return s3(Og);var
a=u(aN(Oh),e),g=Jc(a)==e?a:u(aN(Oj),e);ct(b,g);var
h=s8(g);return h?ct(b,Oi):h}return s7(b,c[2])}return yK<=d?ct(b,c[2]):fG(b,c[2])}function
jD(a,f,e,d,c){var
i=f?f[1]:fc,j=e?e[1]:Ok;if(a){var
g=a[1];sk(g);var
b=g}else
var
b=hA(i);var
h=d?d[1]:0;if(h)hO(b,c);else
hN(b,c);ct(b,j);var
k=hB(b);sk(b);return k}var
Om=[0,function(b){throw[0,bi,Ol]}];Om[1]=function(b){var
c=rp;for(;;){var
d=rS(On,c,b);if(0===d)return n9(b);u(b[1],b);var
c=d;continue}};var
Op=[0,function(b){throw[0,bi,Oo]}];Op[1]=function(b){var
c=rp;for(;;){var
d=rS(Oq,c,b);if(0===d)return n9(b);u(b[1],b);var
c=d;continue}};function
s9(b){return[0,q2,b]}function
fH(b){return[0,ch,b]}function
jE(b){return[0,l9,b]}function
s_(c,b){return b?u(c,b[1]):870828711}function
d7(f,e){var
c=0,b=e;for(;;){if(b){var
d=b[2],c=[0,u(f,b[1]),c],b=d;continue}return[0,bY,ev(c)]}}function
s$(c){var
d=c[1],e=[0,[0,Ou,s9(c[2])],0];switch(d){case
0:var
b=Or;break;case
1:var
b=Os;break;default:var
b=Ot}return[0,fN,[0,[0,Ov,b],e]]}var
k=[bl,OD,c1(0)],bT=[bl,OE,c1(0)],ta=[bl,OF,c1(0)],q=[bl,OK,c1(0)];function
Ow(b){var
c=b[5],d=b[4],e=b[3],f=b[2],a=b[1],g=[0,[0,Ox,d7(fH,b[6])],0],h=[0,[0,Oy,jE(c)],g],i=[0,[0,Oz,jE(d)],h],j=[0,[0,OA,jE(e)],i],k=[0,[0,OB,jE(f)],j];return[0,fN,[0,[0,OC,fH(a)],k]]}var
OH=[bl,OG,c1(0)],OJ=[bl,OI,c1(0)];function
c(b){return sX(b)}function
aO(b){return ov(b)/100.}function
aF(e){var
d=hM(e,sZ(de)),b=d[2],c=d[1];return typeof
b==="number"?-1===b?fD(c):typeof
c==="number"?Ja(c,b):hs(c,b):hs(c,b)}function
fI(d){var
c=r1(d,de),b=c[1];return Ji(jz(c[2]),50)?cC(b,de):cC(e4(b,c2(b)),de)}function
s(b){return NK(b)}function
c6(k){switch(fE(k)){case
0:return 0.;case
1:return r$;case
2:return sa;case
3:return JH;default:var
d=k[1],g=k[2],o=r2(d),p=r2(g);if(!(53<o)&&!(53<p)){var
A=nQ(n1(g));return nQ(n1(d))/A}var
q=0<=c2(d)?1:-1,e=o-p|0;if(0<=e)var
c=e5(g,e),h=d;else
var
c=g,h=e5(d,-e|0);if(0<=eu(jz(h),c))var
f=e,r=h;else
var
f=e-1|0,r=e5(h,1);var
l=r1(e5(r,54),c),a=l[2],b=l[1];if(0<=c2(a))var
i=[0,b,a];else
if(0<=c2(c)){var
u=0,w=e4(a,c);if(typeof
b==="number"&&b!==kd){var
m=b-1|0;u=1}if(!u)var
m=b1N(b);var
i=[0,m,w]}else{var
v=0,x=jy(a,c);if(typeof
b==="number"&&b!==p3){var
n=b+1|0;v=1}if(!v)var
n=b1Q(b);var
i=[0,n,x]}if(zl<f){var
s=GY<f?eA:e5(q,55+(GY-f|0)|0),j=e4(s,i[1]);if(0===c2(i[2]))var
t=j;else
var
z=typeof
j==="number"?1|j:b1I(1,j),t=z;var
y=ov(t);return nT(y-ov(s),f-54|0)}return nT(q,zl)}}function
aG(b){if(b==r$)return jB;if(b==sa)return jC;if(4===nK(b))return gd;var
d=b0Z(b),c=d[2]-53|0,e=b1M(nT(d[1],53));return 0<=c?d6(e5(e,c)):gc(e,e5(jA,-c|0))}function
x(b){return d6(b)}function
eB(b){var
c=b[2],d=b[1],e=cC(2,c);return d6(b1D(e4(cC(2,d),c),e))}function
e6(b){var
c=sZ(de);return ox(d6(b),c)}function
f(b){return sX(b)}function
hP(b){return sW(b)}function
i(d,c,b){try{var
e=sU(d,c,b);return e}catch(a){throw OJ}}function
tb(b){return ar(op(OL),NA,b)}function
gg(b){if(typeof
b==="number")return 0===b?ON:OO;else
switch(b[0]){case
0:return[0,bY,[0,OP,[0,s9(b[1]),0]]];case
1:return[0,bY,[0,OQ,[0,[0,mI,aO(b[1])],0]]];case
2:return[0,bY,[0,OR,[0,[0,l9,hP(b[1])],0]]];case
3:return[0,bY,[0,OS,[0,[0,mI,c6(b[1])],0]]];case
4:return[0,bY,[0,OT,[0,[0,ch,tb(b[1])],0]]];case
5:var
i=b[1];return[0,bY,[0,OU,[0,[0,ch,ar(op(OM),Nu,i)],0]]];case
6:var
f=b[2],j=d7(fH,b[1]),k=f[2],l=fH(f[1]);return[0,bY,[0,OV,[0,j,[0,[0,bY,[0,l,[0,gg(k),0]]],0]]]];case
7:var
m=b[2],n=d7(fH,b[1]);return[0,bY,[0,OW,[0,n,[0,d7(function(b){var
c=b[2],d=fH(b[1]);return[0,bY,[0,d,[0,gg(c),0]]]},m),0]]]];default:var
a=b[1],d=[0,0],e=a.length-1-1|0;if(!(e<0)){var
c=e;for(;;){var
g=d[1];d[1]=[0,gg(c0(a,c)[1+c]),g];var
h=c-1|0;if(0!==c){var
c=h;continue}break}}return[0,bY,[0,OX,[0,[0,bY,d[1]],0]]]}}function
ay(b){return 1}function
ai(b){return[0,b]}function
D(b){return[1,b]}function
bA(b){return[2,b]}function
aS(b){return[3,b]}function
aK(b){return[4,b]}function
dT(b){return[5,b]}function
c7(c,b){return[8,ck(c,b)]}function
oB(b){return d7(fH,b)}function
oC(b){switch(b[0]){case
0:return[0,bY,[0,OY,[0,jF(b[1]),0]]];case
1:return[0,bY,[0,OZ,[0,tc(b[1]),0]]];default:var
c=b[2],d=b[1],e=[0,[0,O0,d7(oC,b[3])],0],f=[0,[0,O1,d7(jF,c)],e];return[0,bY,[0,O3,[0,[0,fN,[0,[0,O2,oB(d)],f]],0]]]}}function
jF(b){var
c=b[5],d=b[4],e=b[3],f=b[2],a=b[1],g=0,h=[0,[0,O4,s_(function(b){return d7(tc,b)},c)],g],i=[0,[0,O5,gg(d)],h],j=[0,[0,O6,s$(e)],i],k=[0,[0,O7,oB(f)],j];return[0,fN,[0,[0,O8,s_(Ow,a)],k]]}function
tc(b){var
c=b[3],d=b[2],e=b[1],f=[0,[0,O9,jF(b[4])],0],a=[0,[0,O_,d7(oC,c)],f],g=[0,[0,O$,d7(jF,d)],a];return[0,fN,[0,[0,Pa,oB(e)],g]]}var
d8=[0,0];function
Pb(b){d8[1]=0;return 0}function
td(b){return ev(d8[1])}function
Q(c,b){d8[1]=[0,[0,c],d8[1]];return b}function
O(c,b){d8[1]=[0,[1,c],d8[1]];return b}function
j(e,d,c,b){var
f=d8[1];d8[1]=[0,[2,e,d,u(c,b)],f];return b}function
g(c,b){if(b)d8[1]=[0,[3,c],d8[1]];return b}var
hQ=jg([0,J_]),jG=hQ[1],te=0,Pc=[0,jG,0,0];function
tf(b){switch(b[0]){case
0:var
l=b1(hw(Pn,b[1]),Pm);return b1(aN(Po),l);case
1:var
m=b1(hw(Pq,b[1]),Pp);return b1(aN(Pr),m);case
2:var
c=b[2],n=b[1],o=jD(0,0,0,0,gg(b[3])),g=0,i=c[2];if(!c[1]&&!i){var
a=Pl;g=1}if(!g){var
j=c[2]?Pd:Pk,h=0,k=c[2];if(c[1]&&k){var
f=Pe;h=1}if(!h)var
f=Pj;switch(c[1]){case
0:var
e=Pf;break;case
1:var
e=Ph;break;default:var
e=Pi}var
a=cm(aN(Pg),e,f,j)}var
p=hw(Ps,n);return cm(aN(Pt),p,a,o);default:var
d=b[1],q=d[5],r=d[4],s=d[3],t=d[2],u=d[1];return jP(aN(Pu),u,t,s,r,q)}}function
oD(c,b){if(b){var
d=b[1],f=b[2];if(u(c,d)){var
e=oD(c,f);return[0,[0,d,e[1]],e[2]]}return[0,0,b]}return Pv}function
Pw(c){var
S=e3(c);function
i(b){return 2===e3(b)?1:0}function
B(b){return 2===e3(b)?1:0}function
m(U){var
c=U;a:for(;;){var
a=c[3];if(a){var
g=a[1];switch(g[0]){case
0:var
j=g[1],V=a[2];if(3===e3(j)){if(j){var
n=j[2];if(n){var
F=n[2];if(F&&!F[2]){var
W=n[1],G=m([0,jG,te,V]),A=ar(hQ[29],W,c[1]),X=A?A[1]:0,c=[0,c[1],[0,[2,j,X,G[2]],c[2]],G[3]];continue}}}return aE(Pz)}break;case
1:var
Y=a[2],Z=ev(c[2]);return[0,c[1],Z,Y];case
2:var
o=a[2];if(B(g[1])){var
c=[0,c[1],c[2],o];continue}if(o){var
H=o[1];if(0===H[0]&&i(H[1])){var
I=E(c[3]),c=[0,c[1],[0,[1,I[2]],c[2]],I[1]];continue}}break;default:var
p=a[2];if(p){var
k=p[1];if(2===k[0]){var
l=p[2],J=k[3],K=k[2],e=k[1],q=g[1],D=2===e3(e)?1:0,_=D?n7(jd(e,1),46):D;if(_){if(e){var
r=e[2];if(r&&!r[2]){var
s=jd(n8(46,r[1]),0),t=c[1],L=[0,[0,q],e,K,J,0],$=c[2],z=ar(hQ[29],s,t),af=z?cm(hQ[4],s,[0,L,z[1]],t):cm(hQ[4],s,[0,L,0],t),c=[0,af,$,l];continue}}return aE(PB)}var
y=0;if(B(e))y=1;else{var
C=3===e3(e)?1:0,T=C?rY(Px,jd(e,2)):C;if(T)y=1;else
if(l){var
M=l[1];if(0===M[0]){var
u=M[1];if(i(u)){var
v=0,f=se(c[3]);for(;;){var
N=oD(function(b){return 2===b[0]?1:0},f)[2];if(N){var
O=N[1];if(0===O[0]&&i(O[1])){var
P=E(f),v=[0,P[2],v],f=P[1];continue}}var
aa=ev(v);if(f){var
h=f[1];if(2===h[0])var
x=[0,[0,[0,q],h[1],h[2],h[3],[0,aa]]],w=f[2];else
var
ab=b1(PD,b1(b(d+((S-e3(f)|0)+1|0)),PC)),ac=b1(PE,b1(tf(h),ab)),Q=aE(b1(PG,b1(hw(PF,u),ac))),x=Q[2],w=Q[1]}else
var
R=aE(b1(PJ,b1(hw(PI,u),PH))),x=R[2],w=R[1];var
c=[0,c[1],[0,x,c[2]],w];continue a}}}}}if(y){var
c=[0,c[1],[0,[0,[0,[0,q],e,K,J,0]],c[2]],l];continue}}}}return aE(b1(PA,tf(g)))}var
ad=c[3],ae=ev(c[2]);return[0,c[1],ae,ad]}}function
E(h){var
c=oD(function(f){if(2===f[0]){var
a=f[1],d=3===e3(a)?1:0;if(d){var
e=jd(a,2),c=5<=aM(e)?1:0;if(c){var
b=0;for(;;){if(b===5)return 1;if(dh(e,b)!==dh(Py,b))return 0;var
b=b+1|0;continue}}return c}return d}return 0},h),b=c[2];if(b){var
d=b[1];if(0===d[0]){var
e=d[1],j=b[2],k=c[1];if(i(e)){var
l=f6(function(b){if(2===b[0])return[0,0,b[1],b[2],b[3],0];throw[0,bi,PK]},k),f=m([0,jG,0,j]),a=ev(f[2]),g=sd(a),n=ev(se(a)),o=f[3],p=0===g[0]?g[1]:aE(PL);return[0,o,[0,e,l,n,p]]}}}return aE(PM)}try{var
a=m([0,jG,te,c]),e=a}catch(b){b=n(b);if(b[1]!==jc)throw b;var
f=b[2];u(hD(PN),f);var
e=Pc}return e[2]}function
e(f,e,d,c){var
a=0,b=si(function(b,d){try{var
e=[0,u(d,0)],c=e}catch(b){b=n(b);if(b!==k)throw b;var
c=0}if(b){if(c)throw[0,ta,f];return b}return c},a,e);if(b)return b[1];if(u(d,0))return u(c,0);throw k}function
tg(c,b){try{var
d=sT(c),e=fy(d,sT(b));return e}catch(b){b=n(b);if(b===ou)throw OH;throw b}}function
h(b,c){var
d=b?c:b;return d}function
H(c,b){var
d=c||b;return d}function
gh(g,a,c){var
e=c.length-1;if(0===e)return a;var
d=[0,c0(c,0)[1]],f=e-1|0,h=1;if(!(f<1)){var
b=h;for(;;){var
i=c0(c,b)[1+b];d[1]=ar(g,d[1],i);var
j=b+1|0;if(f!==b){var
b=j;continue}break}}return d[1]}function
c8(i,g){var
c=g.length-1-1|0,e=0;for(;;){if(0<=c){var
h=[0,g[1+c],e],c=c-1|0,e=h;continue}var
d=0,b=e;for(;;){if(b){var
f=b[2],a=b[1];if(u(i,a)){var
d=[0,a,d],b=f;continue}var
b=f;continue}return hx(ev(d))}}}function
hR(c,b){return e4(c,b)}function
dk(e,d){if(e[2]!==0&&d[2]!==0)return s2(e4,e,d);var
g=fE(e),c=fE(d),b=0;switch(g){case
0:return d;case
1:switch(c){case
2:b=3;break;case
0:case
3:break;default:b=1}break;case
2:switch(c){case
2:b=2;break;case
1:b=3;break;case
4:b=4;break}break;case
4:switch(c){case
4:return aE(NI);case
0:case
3:break;default:b=2}break}var
f=0;switch(b){case
0:if(3===c)f=1;else
if(!c)return e;break;case
1:break;case
2:f=2<=c?3:2;break;case
3:return gd;default:f=3}var
a=0;switch(f){case
0:if(!(3<=g))a=1;break;case
1:break;case
2:a=1;break;default:return jC}return a?jB:gd}function
t(c,b){return e4(c,b)}function
b6(y,h,g){var
u=h[3],l=hK(h[1]+g[1]|0,h[2],g[2]),b=[0,l[1],l[2],u];if(hJ(b))var
d=b;else
switch(y){case
0:var
q=0;if(1<=b[2]&&!(12<b[2])){var
i=0;if(1<=b[3]&&!(31<b[3]))if(hJ(b)){var
d=b;i=1}else{var
k=hK(b[1],b[2],1),d=[0,k[1],k[2],1];i=1}if(!i)throw[0,bi,Nz]}else
q=1;if(q)throw[0,bi,Ny];break;case
1:var
r=0;if(1<=b[2]&&!(12<b[2])){var
j=0;if(1<=b[3]&&!(31<b[3]))if(hJ(b)){var
d=b;j=1}else{var
s=hH(b[1]),t=hI(b[2],s),d=[0,b[1],b[2],t];j=1}if(!j)throw[0,bi,Nx]}else
r=1;if(r)throw[0,bi,Nw];break;default:throw ou}var
c=d,e=g[3];for(;;){var
v=hH(c[1]),a=hI(c[2],v),f=c[3]+e|0;if(1<=f&&f<=a)return[0,c[1],c[2],f];if(a<=f){var
m=hK(c[1],c[2],1),w=(e-(a-c[3]|0)|0)-1|0,c=[0,m[1],m[2],1],e=w;continue}var
n=hK(c[1],c[2],-1),o=n[2],p=n[1],x=e+c[3]|0,c=[0,p,o,hI(o,hH(p))],e=x;continue}}function
C(c,b){return jy(c,b)}function
bL(e,d){if(e[2]!==0&&d[2]!==0)return s2(jy,e,d);var
g=fE(e),c=fE(d),b=0;switch(g){case
0:return s1(d);case
1:switch(c){case
1:b=3;break;case
0:case
3:break;default:b=1}break;case
2:switch(c){case
1:b=2;break;case
2:b=3;break;case
4:b=4;break}break;case
4:switch(c){case
4:return aE(NJ);case
0:case
3:break;default:b=2}break}var
f=0;switch(b){case
0:if(3===c)f=1;else
if(!c)return e;break;case
1:break;case
2:f=2<=c?2:3;break;case
3:return gd;default:f=3}var
a=0;switch(f){case
0:if(!(3<=g))a=1;break;case
1:break;case
2:a=1;break;default:return jC}return a?jB:gd}function
aC(c,b){return jy(c,b)}function
a7(c,b){return hM(c,b)}function
m(d,b){var
i=jz(d),g=b[2],h=[0,jz(b[1]),g],e=hp(c2(d),c2(b[1])),c=hM(d6(i),h),f=r1(c[1],c[2]),a=f[1],j=c[2];return b01(cC(2,f[2]),j)?cC(e4(a,1),e):cC(a,e)}function
bM(c,b){if(a(s0,b))throw n4;return ox(c,b)}function
fJ(c,b){if(a(eA,b))throw n4;var
d=d6(b);return ox(d6(c),d)}function
d9(c,b){return ow(c,b)<0?1:0}function
cw(c,b){return eu(c,b)<0?1:0}function
E(c,b){return hL(c,b)<0?1:0}function
jH(c,b){return ow(c,b)<=0?1:0}function
bU(c,b){return eu(c,b)<=0?1:0}function
ag(c,b){return hL(c,b)<=0?1:0}function
aX(c,b){return 0<eu(c,b)?1:0}function
aZ(c,b){return 0<eu(c,b)?1:0}function
c9(c,b){return 0<hL(c,b)?1:0}function
aL(c,b){return 0<=eu(c,b)?1:0}function
dl(c,b){return 0<=ow(c,b)?1:0}function
cb(c,b){return 0<=eu(c,b)?1:0}function
l(c,b){return 0<=hL(c,b)?1:0}var
th=[bl,PO,c1(0)];sO(PP,[0,th,[0]]);var
e7=bz,ti=undefined;e7.String;e7.RegExp;e7.Date;e7.Math;e7.Error;e7.JSON;function
PQ(b){throw b}var
PR=e7.Object,PS=e7.Array;ss(function(b){return b[1]===th?[0,a4(b[2].toString())]:0});ss(function(b){return b
instanceof
PS?0:[0,a4(b.toString())]});function
tj(c,b){return b1y[c]=b}function
tk(c,b){return tj(dR(c),b)}function
PT(b){var
c=PR.keys(b);return c.forEach(bh(function(c,e,d){return tj(c,b[c])}))}function
jI(b){return[0,b.years,b.months,b.days]}function
jJ(b){return{"years":b[1],"months":b[2],"days":b[3]}}function
aH(f){var
b=a4(f),a=n7(b,84)?sd(n8(84,b)):b,c=n8(45,a);if(c){var
d=c[2];if(d){var
e=d[2];if(e&&!e[2]){var
g=d[1],h=c[1],j=nR(e[1]),k=nR(g);return i(nR(h),k,j)}}}return aE(PW)}function
oE(b){return dR(tb(b))}var
oF=[0,0,0,0];function
PX(g,a,f,e){if(!oF[1]){var
b=js(PV),c=jr(b,PY),d=jq(b,PU),h=d[1],i=d[2],j=d[3],k=function(d){var
b=d[1+c];return u(b[2],b[1])},l=function(d){var
b=d[1+c];return u(b[3],b[1])};jw(b,[0,j,function(d){var
b=d[1+c];return u(b[4],b[1])},i,l,h,k]);var
m=function(e){var
d=ju(0,b);d[1+c]=e;return d};jt(b);oF[1]=m}return u(oF[1],[0,g,e,f,a])}function
PZ(b){return am(function(c){var
b=td(0);return fz(hx(f6(function(b){if(3===b[0])var
c=b[1],j=fz(hx(f6(dR,c[6]))),e={"fileName":dR(c[1]),"startLine":c[2],"endLine":c[4],"startColumn":c[3],"endColumn":c[5],"lawHeadings":j};else
var
e=ti;var
f=2===b[0]?b[3]:1,a=dR(jD(0,0,0,0,gg(f))),g=2===b[0]?dR(jD(0,0,0,0,s$(b[2]))):"unavailable",h=3===b[0]?0:f6(dR,b[1]),i=fz(hx(h));switch(b[0]){case
0:var
d=P0;break;case
1:var
d=P1;break;case
2:var
d=P2;break;default:var
d=P3}return{"eventType":dR(d),"information":i,"loggedIOJson":g,"loggedValueJson":a,"sourcePosition":e}},b)))})}function
P4(b){return am(function(c){var
b=Pw(td(0));return fz(hx(f6(function(b){return{"data":dR(jD(0,0,0,0,oC(b)))}},b)))})}function
P5(b){return am(Pb)}var
P6=function(d,c,b,e){return{"resetLog":am(d),"retrieveEvents":am(c),"retrieveRawEvents":am(b)}}(P5,P4,PZ,PX);function
tl(b){function
c(d,b){var
e=b[5],f=b[4],a=b[3],g=b[2],h=b[1],c=dR(b0O(op(P7),d,h,g,a,f,e));return u(PQ,{"name":"CatalaError","message":c,"stack":ti,"toString":am(function(b){return c})})}try{var
d=u(b,0);return d}catch(b){b=n(b);if(b[1]===q)return c(P8,b[2]);if(b[1]===ta)return c(P9,b[2]);if(b[1]===bT)return c(P_,b[2]);throw b}}function
tm(c){switch(c[0]){case
0:var
b=[0,Qj,0];break;case
1:var
b=[0,Ql,0];break;default:var
b=[0,Qm,0]}return[6,Qk,b]}function
oG(c){switch(c[0]){case
0:var
b=[0,Qn,0];break;case
1:var
b=[0,Qp,0];break;case
2:var
b=[0,Qq,0];break;case
3:var
b=[0,Qr,0];break;case
4:var
b=[0,Qs,0];break;case
5:var
b=[0,Qt,0];break;case
6:var
b=[0,Qu,0];break;case
7:var
b=[0,Qv,0];break;default:var
b=[0,Qw,0]}return[6,Qo,b]}function
b2(b){var
e=[0,[0,Qy,[0,b[6]]],[0,[0,Qx,[0,b[7]]],0]];switch(b[5][0]){case
0:var
c=[0,P$,0];break;case
1:var
c=[0,Qb,0];break;case
2:var
c=[0,Qc,0];break;case
3:var
c=[0,Qd,0];break;default:var
c=[0,Qe,0]}var
f=[0,[0,QB,[1,b[3]]],[0,[0,QA,[4,b[4]]],[0,[0,Qz,[6,Qa,c]],e]]];switch(b[2][0]){case
0:var
d=[0,Qf,0];break;case
1:var
d=[0,Qh,0];break;default:var
d=[0,Qi,0]}return[7,QE,[0,[0,QD,[2,b[1]]],[0,[0,QC,[6,Qg,d]],f]]]}function
tn(d){try{var
b=function(b){return[0,16,0,0]},c=e(QH,[0],function(b){return g(QG,1)},b)}catch(b){b=n(b);if(b===k)throw[0,q,QF];throw b}return[0,j(QJ,QI,dT,c)]}function
to(b){var
d=b[1];try{var
a=function(g){var
b=i(Fc,12,31),e=c(QM),a=[0,f(QO),QN,e,b,QL,0,0];return gh(function(c,b){return E(c[4],b[4])?c:b},a,d)},h=e(QQ,[0],function(b){return g(QP,1)},a)}catch(b){b=n(b);if(b===k)throw[0,q,QK];throw b}return[0,j(QS,QR,b2,h)]}function
QT(b){var
c=b[1],d=b[2],f=b[3];try{var
a=function(b){return ag(b6(0,c,f),d)},h=e(QW,[0],function(b){return g(QV,1)},a)}catch(b){b=n(b);if(b===k)throw[0,q,QU];throw b}return[0,j(QY,QX,ai,h)]}function
QZ(b){var
c=b[1],d=b[2],f=b[3];try{var
a=function(b){return c9(b6(0,c,f),d)},h=e(Q2,[0],function(b){return g(Q1,1)},a)}catch(b){b=n(b);if(b===k)throw[0,q,Q0];throw b}return[0,j(Q4,Q3,ai,h)]}function
tp(f){var
d=f[1],b=f[2];try{var
m=l(d,i(W,1,1))}catch(b){b=n(b);if(b===k)throw[0,q,Q5];throw b}if(m){try{var
o=function(B){function
f(b){throw k}function
j(b){return 0}function
m(j){function
f(b){return c(Q7)}return e(Q_,[0],function(e){var
c=a(b,Q8);return g(Q9,h(l(d,i(aI,5,1)),c))},f)}function
n(j){function
f(b){return c(Q$)}return e(Rj,[0],function(o){var
c=H(a(b,Rb),a(b,Ra)),e=H(a(b,Rc),c),f=H(a(b,Rd),e),j=H(a(b,Re),f),k=H(a(b,Rf),j),m=H(a(b,Rg),k),n=H(a(b,Rh),m);return g(Ri,h(l(d,i(aI,5,1)),n))},f)}function
o(j){function
f(b){return c(Rk)}return e(Rn,[0],function(f){var
c=a(b,Rl),e=h(E(d,i(aI,5,1)),c);return g(Rm,h(l(d,i(aI,1,1)),e))},f)}function
p(j){function
f(b){return c(Ro)}return e(Ry,[0],function(p){var
c=H(a(b,Rq),a(b,Rp)),e=H(a(b,Rr),c),f=H(a(b,Rs),e),j=H(a(b,Rt),f),k=H(a(b,Ru),j),m=H(a(b,Rv),k),n=H(a(b,Rw),m),o=h(E(d,i(aI,5,1)),n);return g(Rx,h(l(d,i(aI,1,1)),o))},f)}function
q(j){function
f(b){return c(Rz)}return e(RC,[0],function(f){var
c=a(b,RA),e=h(ag(d,i(G,12,31)),c);return g(RB,h(l(d,i(G,8,1)),e))},f)}function
r(j){function
f(b){return c(RD)}return e(RN,[0],function(p){var
c=H(a(b,RF),a(b,RE)),e=H(a(b,RG),c),f=H(a(b,RH),e),j=H(a(b,RI),f),k=H(a(b,RJ),j),m=H(a(b,RK),k),n=H(a(b,RL),m),o=h(ag(d,i(G,12,31)),n);return g(RM,h(l(d,i(G,8,1)),o))},f)}function
s(j){function
f(b){return c(RO)}return e(RR,[0],function(f){var
c=a(b,RP),e=h(ag(d,i(G,7,31)),c);return g(RQ,h(l(d,i(G,5,1)),e))},f)}function
t(j){function
f(b){return c(RS)}return e(R2,[0],function(p){var
c=H(a(b,RU),a(b,RT)),e=H(a(b,RV),c),f=H(a(b,RW),e),j=H(a(b,RX),f),k=H(a(b,RY),j),m=H(a(b,RZ),k),n=H(a(b,R0),m),o=h(ag(d,i(G,7,31)),n);return g(R1,h(l(d,i(G,5,1)),o))},f)}function
u(j){function
f(b){return c(R3)}return e(R6,[0],function(f){var
c=a(b,R4),e=h(ag(d,i(G,4,30)),c);return g(R5,h(l(d,i(G,1,1)),e))},f)}function
v(j){function
f(b){return c(R7)}return e(Sf,[0],function(p){var
c=H(a(b,R9),a(b,R8)),e=H(a(b,R_),c),f=H(a(b,R$),e),j=H(a(b,Sa),f),k=H(a(b,Sb),j),m=H(a(b,Sc),k),n=H(a(b,Sd),m),o=h(ag(d,i(G,4,30)),n);return g(Se,h(l(d,i(G,1,1)),o))},f)}function
w(j){function
f(b){return c(Sg)}return e(Sj,[0],function(f){var
c=a(b,Sh),e=h(ag(d,i(U,12,31)),c);return g(Si,h(l(d,i(U,1,1)),e))},f)}function
x(j){function
f(b){return c(Sk)}return e(Su,[0],function(p){var
c=H(a(b,Sm),a(b,Sl)),e=H(a(b,Sn),c),f=H(a(b,So),e),j=H(a(b,Sp),f),k=H(a(b,Sq),j),m=H(a(b,Sr),k),n=H(a(b,Ss),m),o=h(ag(d,i(U,12,31)),n);return g(St,h(l(d,i(U,1,1)),o))},f)}function
y(j){function
f(b){return c(Sv)}return e(Sy,[0],function(f){var
c=a(b,Sw),e=h(ag(d,i(F,12,31)),c);return g(Sx,h(l(d,i(F,1,1)),e))},f)}function
z(j){function
f(b){return c(Sz)}return e(SJ,[0],function(p){var
c=H(a(b,SB),a(b,SA)),e=H(a(b,SC),c),f=H(a(b,SD),e),j=H(a(b,SE),f),k=H(a(b,SF),j),m=H(a(b,SG),k),n=H(a(b,SH),m),o=h(ag(d,i(F,12,31)),n);return g(SI,h(l(d,i(F,1,1)),o))},f)}function
A(j){function
f(b){return c(SK)}return e(SN,[0],function(f){var
c=a(b,SL),e=h(ag(d,i(W,12,31)),c);return g(SM,h(l(d,i(W,1,1)),e))},f)}return e(SZ,[0,function(j){function
f(b){return c(SO)}return e(SY,[0],function(p){var
c=H(a(b,SQ),a(b,SP)),e=H(a(b,SR),c),f=H(a(b,SS),e),j=H(a(b,ST),f),k=H(a(b,SU),j),m=H(a(b,SV),k),n=H(a(b,SW),m),o=h(ag(d,i(W,12,31)),n);return g(SX,h(l(d,i(W,1,1)),o))},f)},A,z,y,x,w,v,u,t,s,r,q,p,o,n,m],j,f)},p=e(S0,[0],function(b){return 1},o)}catch(b){b=n(b);if(b===k)throw[0,q,Q6];throw b}return[0,j(S2,S1,D,p)]}throw[0,bT,S3]}function
tq(d){var
b=d[1];try{var
f=l(b,i(W,4,1))}catch(b){b=n(b);if(b===k)throw[0,q,S4];throw b}if(f){try{var
a=function(o){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(b){return c(S6)}return e(S8,[0],function(c){return g(S7,l(b,i(aI,4,1)))},d)}function
j(f){function
d(b){return c(S9)}return e(S$,[0],function(d){var
c=E(b,i(aI,4,1));return g(S_,h(l(b,i(G,4,1)),c))},d)}function
m(f){function
d(b){return c(Ta)}return e(Tc,[0],function(d){var
c=E(b,i(G,4,1));return g(Tb,h(l(b,i(U,4,1)),c))},d)}function
n(f){function
d(b){return c(Td)}return e(Tf,[0],function(d){var
c=E(b,i(U,4,1));return g(Te,h(l(b,i(F,4,1)),c))},d)}return e(Tj,[0,function(f){function
d(b){return c(Tg)}return e(Ti,[0],function(d){var
c=E(b,i(F,4,1));return g(Th,h(l(b,i(W,4,1)),c))},d)},n,m,j,a],f,d)},m=e(Tk,[0],function(b){return 1},a)}catch(b){b=n(b);if(b===k)throw[0,q,S5];throw b}return[0,j(Tm,Tl,D,m)]}throw[0,bT,Tn]}function
tr(c){var
d=c[1],b=c[2];try{var
p=function(b){return[0,20,0,0]},r=e(Tq,[0],function(b){return g(Tp,1)},p)}catch(b){b=n(b);if(b===k)throw[0,q,To];throw b}var
f=j(Ts,Tr,dT,r);try{var
t=function(b){return d},v=j(Tx,Tw,aK,e(Tv,[0],function(b){return g(Tu,1)},t))}catch(b){b=n(b);if(b===k)throw[0,q,Tt];throw b}try{var
w=function(c){return b},x=j(TC,TB,oG,e(TA,[0],function(b){return g(Tz,1)},w))}catch(b){b=n(b);if(b===k)throw[0,q,Ty];throw b}var
i=O(TE,u(Q(TD,tp),[0,v,x]))[1];try{var
y=function(b){return 0},z=function(b){return g(TG,1)},A=e(TP,[0,function(d){function
c(b){return 1}return e(TO,[0],function(h){var
c=H(a(b,TI),a(b,TH)),d=H(a(b,TJ),c),e=H(a(b,TK),d),f=H(a(b,TL),e);return g(TN,H(a(b,TM),f))},c)}],z,y)}catch(b){b=n(b);if(b===k)throw[0,q,TF];throw b}var
l=j(TR,TQ,ai,A);try{var
B=function(c){var
b=s(TT);return m(m(i,s(TU)),b)},C=function(b){return g(TV,1)},E=e(T0,[0,function(c){function
b(c){var
b=s(TW);return m(m(i,s(TX)),b)}return e(TZ,[0],function(b){return g(TY,l)},b)}],C,B)}catch(b){b=n(b);if(b===k)throw[0,q,TS];throw b}var
o=j(T2,T1,D,E),F=j(T9,T8,ay,function(b){try{var
c=function(b){return 0},d=function(b){return g(T4,1)},f=e(T7,[0,function(d){function
c(b){return 1}return e(T6,[0],function(i){var
f=bU(b[3],o);switch(b[2][0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}switch(b[2][0]){case
0:var
d=0;break;case
1:var
d=1;break;default:var
d=0}var
a=H(d,c);switch(b[2][0]){case
0:var
e=1;break;case
1:var
e=0;break;default:var
e=0}return g(T5,h(H(e,a),f))},c)}],d,c);return f}catch(b){b=n(b);if(b===k)throw[0,q,T3];throw b}});return[0,j(Uk,Uj,ay,function(b){try{var
c=function(b){return 0},a=function(b){return g(T$,1)},i=e(Ui,[0,function(i){function
c(i){function
c(b){throw k}function
a(b){return 0}return e(Ue,[0,function(i){function
c(b){return 1}function
a(e){switch(b[2][0]){case
0:var
c=0;break;case
1:var
c=1;break;default:var
c=0}switch(b[2][0]){case
0:var
d=1;break;case
1:var
d=0;break;default:var
d=0}return g(Ua,H(d,c))}return e(Ud,[0,function(a){function
c(b){return 1}return e(Uc,[0],function(i){var
e=c9(b6(2,b[4],f),d),a=h(bU(b[3],o),e);switch(b[2][0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}return g(Ub,h(c,a))},c)}],a,c)}],a,c)}function
a(b){return 1}return e(Uh,[0,function(d){function
c(b){return 0}return e(Ug,[0],function(c){return g(Uf,b[7])},c)}],a,c)}],a,c);return i}catch(b){b=n(b);if(b===k)throw[0,q,T_];throw b}}),F,f,l]}function
ts(z){var
K=z[1],r=z[3],p=z[4],b=z[5],E=z[6],y=z[7],V=z[2],L=j(UE,UD,ay,function(b){try{var
c=function(h){function
c(b){throw k}function
d(b){return 0}function
f(f){function
c(b){return Um}function
d(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=0;break;default:var
c=0}return g(Un,c)}return e(Uu,[0,function(f){function
c(b){return Uo}function
d(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(Up,c)}return e(Ut,[0,function(d){function
c(b){return Uq}return e(Us,[0],function(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=1;break;default:var
c=0}return g(Ur,c)},c)}],d,c)}],d,c)}function
a(d){function
c(b){return Uv}return e(Ux,[0],function(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=1}return g(Uw,c)},c)}return e(UB,[0,function(d){function
c(b){return Uy}return e(UA,[0],function(d){switch(b[5][0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(Uz,c)},c)},a,f],d,c)},d=e(UC,[0],function(b){return 1},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,Ul];throw b}}),X=j(UY,UX,ay,function(b){try{var
c=function(a){function
c(b){throw k}function
d(b){return 0}function
f(f){function
c(b){return UG}function
d(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=0;break;default:var
c=0}return g(UH,c)}return e(UR,[0,function(f){function
c(b){return UI}function
d(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(UJ,c)}return e(UQ,[0,function(f){function
c(b){return UK}function
d(d){switch(b[5][0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(UL,c)}return e(UP,[0,function(d){function
c(b){return UM}return e(UO,[0],function(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=1;break;default:var
c=0}return g(UN,c)},c)}],d,c)}],d,c)}],d,c)}return e(UV,[0,function(d){function
c(b){return US}return e(UU,[0],function(d){switch(b[5][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=1}return g(UT,c)},c)},f],d,c)},d=e(UW,[0],function(b){return 1},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,UF];throw b}});try{var
Y=function(b){return f(U0)},Z=e(U2,[0],function(b){return g(U1,1)},Y)}catch(b){b=n(b);if(b===k)throw[0,q,UZ];throw b}var
_=j(U4,U3,bA,Z);try{var
$=function(b){return f(U6)},aa=e(U8,[0],function(b){return g(U7,1)},$)}catch(b){b=n(b);if(b===k)throw[0,q,U5];throw b}var
ab=j(U_,U9,bA,aa),ac=O(Va,u(Q(U$,tn),0))[1];try{var
ad=H(K,h(1-K,V))}catch(b){b=n(b);if(b===k)throw[0,q,Vb];throw b}if(ad){try{var
ae=function(c){return b},af=j(Vg,Vf,aK,e(Ve,[0],function(b){return g(Vd,1)},ae))}catch(b){b=n(b);if(b===k)throw[0,q,Vc];throw b}var
o=O(Vi,u(Q(Vh,tq),[0,af]))[1];try{var
ah=function(c){return b},aj=j(Vn,Vm,aK,e(Vl,[0],function(b){return g(Vk,1)},ah))}catch(b){b=n(b);if(b===k)throw[0,q,Vj];throw b}try{var
ak=function(b){return p},al=j(Vs,Vr,oG,e(Vq,[0],function(b){return g(Vp,1)},ak))}catch(b){b=n(b);if(b===k)throw[0,q,Vo];throw b}var
I=O(Vu,u(Q(Vt,tr),[0,aj,al])),A=I[4],am=I[1],an=I[2],ao=I[3];try{var
ap=function(b){return E},aq=e(Vx,[0],function(b){return g(Vw,1)},ap),ar=j(Vz,Vy,function(b){return c7(b2,b)},aq)}catch(b){b=n(b);if(b===k)throw[0,q,Vv];throw b}var
as=O(VB,u(Q(VA,to),[0,ar]))[1],M=j(VI,VH,ay,function(b){try{var
c=function(b){return[0,14,0,0]},d=function(b){return g(VD,1)},f=e(VG,[0,function(d){function
c(b){return ac}return e(VF,[0],function(d){var
c=i(fV,4,30);return g(VE,ag(b6(2,b[4],[0,11,0,0]),c))},c)}],d,c);return f}catch(b){b=n(b);if(b===k)throw[0,q,VC];throw b}});try{var
at=function(b){return c8(function(b){var
c=j(VL,VK,b2,b);return O(VP,j(VO,VN,ai,u(Q(VM,am),c)))},E)},au=e(VR,[0],function(b){return g(VQ,1)},at)}catch(b){b=n(b);if(b===k)throw[0,q,VJ];throw b}var
d=j(VT,VS,function(b){return c7(b2,b)},au),av=j(VY,VX,ay,function(b){try{var
c=function(c){return a(as,b)},d=e(VW,[0],function(b){return g(VV,1)},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,VU];throw b}});try{var
aw=function(f){var
b=x(d.length-1),e=m(c(V0),b);return t(c(V1),e)},ax=function(b){return g(V2,1)},az=e(Wj,[0,function(a){function
f(p){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(f){var
b=x(d.length-1),e=m(c(V3),b);return t(c(V4),e)}return e(V6,[0],function(d){var
c=ag(b,i(U,12,31));return g(V5,h(l(b,i(U,1,1)),c))},f)}function
n(a){function
f(f){var
b=x(d.length-1),e=m(c(V7),b);return t(c(V8),e)}return e(V_,[0],function(d){var
c=ag(b,i(F,12,31));return g(V9,h(l(b,i(F,1,1)),c))},f)}function
o(a){function
f(f){var
b=x(d.length-1),e=m(c(V$),b);return t(c(Wa),e)}return e(Wc,[0],function(d){var
c=ag(b,i(W,12,31));return g(Wb,h(l(b,i(W,1,1)),c))},f)}return e(Wh,[0,function(a){function
f(f){var
b=x(d.length-1),e=m(c(Wd),b);return t(c(We),e)}return e(Wg,[0],function(d){var
c=ag(b,i(cI,12,31));return g(Wf,h(l(b,i(cI,1,1)),c))},f)},o,n,j],a,f)}return e(Wi,[0],function(b){return 1},f)}],ax,aw)}catch(b){b=n(b);if(b===k)throw[0,q,VZ];throw b}var
v=j(Wl,Wk,D,az);try{var
aA=function(f){var
b=x(d.length-1),e=m(c(Wn),b);return t(c(Wo),e)},aB=function(b){return g(Wp,1)},aD=e(WI,[0,function(a){function
f(p){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(f){var
b=x(d.length-1),e=m(c(Wq),b);return t(c(Wr),e)}return e(Wt,[0],function(d){var
c=ag(b,i(U,12,31));return g(Ws,h(l(b,i(U,1,1)),c))},f)}function
n(a){function
f(f){var
b=x(d.length-1),e=m(c(Wu),b);return t(c(Wv),e)}return e(Wx,[0],function(d){var
c=ag(b,i(F,12,31));return g(Ww,h(l(b,i(F,1,1)),c))},f)}function
o(a){function
f(f){var
b=x(d.length-1),e=m(c(Wy),b);return t(c(Wz),e)}return e(WB,[0],function(d){var
c=ag(b,i(W,12,31));return g(WA,h(l(b,i(W,1,1)),c))},f)}return e(WG,[0,function(a){function
f(f){var
b=x(d.length-1),e=m(c(WC),b);return t(c(WD),e)}return e(WF,[0],function(d){var
c=ag(b,i(cI,12,31));return g(WE,h(l(b,i(cI,1,1)),c))},f)},o,n,j],a,f)}return e(WH,[0],function(b){return 1},f)}],aB,aA)}catch(b){b=n(b);if(b===k)throw[0,q,Wm];throw b}var
w=j(WK,WJ,D,aD);try{var
aE=function(b){return 0},aF=function(b){return g(WM,1)},aG=e(WS,[0,function(i){function
b(b){return 1}function
c(b){return g(WN,1)}return e(WR,[0,function(c){function
b(b){return 0}return e(WQ,[0],function(b){return g(WP,h(A,a(d.length-1,f(WO))))},b)}],c,b)}],aF,aE)}catch(b){b=n(b);if(b===k)throw[0,q,WL];throw b}var
aH=j(WU,WT,ai,aG),aI=j(W_,W9,ay,function(c){try{var
i=function(b){return 0},l=function(b){return g(WW,1)},m=e(W8,[0,function(l){function
i(b){return 1}function
k(i){var
d=j(WY,WX,b2,c),e=O(W2,j(W1,W0,ai,u(Q(WZ,an),d))),f=h(c[6],e),a=h(tg(jx(b6(2,c[4],ao),b),[0,0,0,zp])<0?1:0,f);return g(W3,h(aL(E.length-1,ab),a))}return e(W7,[0,function(c){function
b(b){return 0}return e(W6,[0],function(b){return g(W5,h(A,a(d.length-1,f(W4))))},b)}],k,i)}],l,i);return m}catch(b){b=n(b);if(b===k)throw[0,q,WV];throw b}});try{var
aJ=function(e){if(aX(d.length-1,f(Xa))){var
b=x(C(d.length-1,f(Xb)));return m(m(o,s(Xc)),b)}return c(Xd)},aM=e(Xf,[0],function(b){return g(Xe,1)},aJ)}catch(b){b=n(b);if(b===k)throw[0,q,W$];throw b}var
aN=j(Xh,Xg,D,aM);try{var
aO=function(b){return aX(d.length-1,f(Xj))?m(o,s(Xk)):c(Xl)},aP=function(b){return g(Xm,1)},aQ=e(Yl,[0,function(n){function
j(A){function
j(b){throw k}function
n(b){return 0}function
q(k){function
j(b){return aX(d.length-1,f(Xn))?m(o,s(Xo)):c(Xp)}return e(Xs,[0],function(e){var
c=ag(b,i(F,12,31)),d=h(l(b,i(F,1,1)),c);return g(Xr,h(a(p,Xq),d))},j)}function
r(k){function
j(b){return aX(d.length-1,f(Xt))?m(o,s(Xu)):c(Xv)}return e(Xy,[0],function(e){var
c=ag(b,i(W,12,31)),d=h(l(b,i(W,1,1)),c);return g(Xx,h(a(p,Xw),d))},j)}function
t(k){function
j(b){return aX(d.length-1,f(Xz))?m(o,s(XA)):c(XB)}return e(XE,[0],function(e){var
c=ag(b,i(cI,12,31)),d=h(l(b,i(cI,1,1)),c);return g(XD,h(a(p,XC),d))},j)}function
u(k){function
j(b){return aX(d.length-1,f(XF))?m(o,s(XG)):c(XH)}return e(XK,[0],function(e){var
c=ag(b,i(cJ,12,31)),d=h(l(b,i(cJ,1,1)),c);return g(XJ,h(a(p,XI),d))},j)}function
v(k){function
j(b){return aX(d.length-1,f(XL))?m(o,s(XM)):c(XN)}return e(XQ,[0],function(e){var
c=ag(b,i(gV,12,31)),d=h(l(b,i(gV,1,1)),c);return g(XP,h(a(p,XO),d))},j)}function
w(k){function
j(b){return aX(d.length-1,f(XR))?m(o,s(XS)):c(XT)}return e(XW,[0],function(e){var
c=ag(b,i(dK,12,31)),d=h(l(b,i(dK,1,1)),c);return g(XV,h(a(p,XU),d))},j)}function
x(k){function
j(b){return aX(d.length-1,f(XX))?m(o,s(XY)):c(XZ)}return e(X2,[0],function(e){var
c=ag(b,i(dn,12,31)),d=h(l(b,i(dn,1,1)),c);return g(X1,h(a(p,X0),d))},j)}function
y(k){function
j(b){return aX(d.length-1,f(X3))?m(o,s(X4)):c(X5)}return e(X8,[0],function(e){var
c=ag(b,i(eF,12,31)),d=h(l(b,i(eF,1,1)),c);return g(X7,h(a(p,X6),d))},j)}function
z(k){function
j(b){return aX(d.length-1,f(X9))?m(o,s(X_)):c(X$)}return e(Yc,[0],function(e){var
c=ag(b,i(dB,12,31)),d=h(l(b,i(dB,1,1)),c);return g(Yb,h(a(p,Ya),d))},j)}return e(Yj,[0,function(k){function
j(b){return aX(d.length-1,f(Yd))?m(o,s(Ye)):c(Yf)}return e(Yi,[0],function(e){var
c=ag(b,i(dG,12,31)),d=h(l(b,i(dG,1,1)),c);return g(Yh,h(a(p,Yg),d))},j)},z,y,x,w,v,u,t,r,q],n,j)}return e(Yk,[0],function(b){return 1},j)}],aP,aO)}catch(b){b=n(b);if(b===k)throw[0,q,Xi];throw b}var
aR=j(Yn,Ym,D,aQ);try{var
aT=function(b){return x(d.length-1)},aU=e(Yq,[0],function(b){return g(Yp,1)},aT)}catch(b){b=n(b);if(b===k)throw[0,q,Yo];throw b}var
N=j(Ys,Yr,aS,aU);try{var
aV=function(e){var
b=ck(function(b){var
c=j(Yv,Yu,b2,b);switch(O(Yz,j(Yy,Yx,tm,u(Q(Yw,L),c)))[0]){case
0:return s(YA);case
1:return s(YB);default:return s(YC)}},d),c=s(YD);return gh(function(c,b){return dk(c,b)},c,b)},aW=e(YF,[0],function(b){return g(YE,1)},aV)}catch(b){b=n(b);if(b===k)throw[0,q,Yt];throw b}var
aY=j(YH,YG,aS,aW);try{var
a0=function(b){return c(YJ)},a1=function(b){return g(YK,1)},a2=function(c){function
b(b){return m(o,s(YL))}return e(YO,[0],function(b){return g(YN,h(A,a(d.length-1,f(YM))))},b)},a3=e(ZZ,[0,function(q){function
j(b){return aX(d.length-1,f(YP))?m(o,s(YQ)):c(YR)}function
n(b){return g(YT,a(p,YS))}return e(ZY,[0,function(n){function
j(C){function
j(b){throw k}function
n(b){return 0}function
q(i){function
b(b){return aX(d.length-1,f(YU))?c(YV):c(YW)}return e(YZ,[0],function(b){return g(YY,h(a(p,YX),y))},b)}function
r(k){function
j(b){return aX(d.length-1,f(Y0))?m(o,s(Y1)):c(Y2)}return e(Y5,[0],function(e){var
c=h(ag(b,i(F,12,31)),1-y),d=h(l(b,i(F,1,1)),c);return g(Y4,h(a(p,Y3),d))},j)}function
t(k){function
j(b){return aX(d.length-1,f(Y6))?m(o,s(Y7)):c(Y8)}return e(Y$,[0],function(e){var
c=h(ag(b,i(W,12,31)),1-y),d=h(l(b,i(W,1,1)),c);return g(Y_,h(a(p,Y9),d))},j)}function
u(k){function
j(b){return aX(d.length-1,f(Za))?m(o,s(Zb)):c(Zc)}return e(Zf,[0],function(e){var
c=h(ag(b,i(cI,12,31)),1-y),d=h(l(b,i(cI,1,1)),c);return g(Ze,h(a(p,Zd),d))},j)}function
v(k){function
j(b){return aX(d.length-1,f(Zg))?m(o,s(Zh)):c(Zi)}return e(Zl,[0],function(e){var
c=h(ag(b,i(cJ,12,31)),1-y),d=h(l(b,i(cJ,1,1)),c);return g(Zk,h(a(p,Zj),d))},j)}function
w(k){function
j(b){return aX(d.length-1,f(Zm))?m(o,s(Zn)):c(Zo)}return e(Zr,[0],function(e){var
c=h(ag(b,i(gV,12,31)),1-y),d=h(l(b,i(gV,1,1)),c);return g(Zq,h(a(p,Zp),d))},j)}function
x(k){function
j(b){return aX(d.length-1,f(Zs))?m(o,s(Zt)):c(Zu)}return e(Zx,[0],function(e){var
c=h(ag(b,i(dK,12,31)),1-y),d=h(l(b,i(dK,1,1)),c);return g(Zw,h(a(p,Zv),d))},j)}function
z(k){function
j(b){return aX(d.length-1,f(Zy))?m(o,s(Zz)):c(ZA)}return e(ZD,[0],function(e){var
c=h(ag(b,i(dn,12,31)),1-y),d=h(l(b,i(dn,1,1)),c);return g(ZC,h(a(p,ZB),d))},j)}function
A(k){function
j(b){return aX(d.length-1,f(ZE))?m(o,s(ZF)):c(ZG)}return e(ZJ,[0],function(e){var
c=h(ag(b,i(eF,12,31)),1-y),d=h(l(b,i(eF,1,1)),c);return g(ZI,h(a(p,ZH),d))},j)}function
B(k){function
j(b){return aX(d.length-1,f(ZK))?m(o,s(ZL)):c(ZM)}return e(ZP,[0],function(e){var
c=h(ag(b,i(dB,12,31)),1-y),d=h(l(b,i(dB,1,1)),c);return g(ZO,h(a(p,ZN),d))},j)}return e(ZW,[0,function(k){function
j(b){return aX(d.length-1,f(ZQ))?m(o,s(ZR)):c(ZS)}return e(ZV,[0],function(e){var
c=h(ag(b,i(dG,12,31)),1-y),d=h(l(b,i(dG,1,1)),c);return g(ZU,h(a(p,ZT),d))},j)},B,A,z,x,w,v,u,t,r,q],n,j)}return e(ZX,[0],function(b){return 1},j)}],n,j)},a2],a1,a0)}catch(b){b=n(b);if(b===k)throw[0,q,YI];throw b}var
P=j(Z1,Z0,D,a3);try{var
a4=function(b){return 0},a5=function(b){return g(Z3,1)},a6=e(_e,[0,function(i){function
b(b){return 1}function
c(b){return g(Z5,aL(d.length-1,f(Z4)))}return e(_d,[0,function(c){function
b(i){function
b(b){throw k}function
c(b){return 0}return e(_b,[0,function(i){function
b(b){return 1}function
c(b){return g(Z7,h(A,aL(d.length-1,f(Z6))))}return e(_a,[0,function(c){function
b(b){return 1}return e(Z$,[0],function(c){var
b=aL(d.length-1,f(Z8));return g(Z_,h(a(p,Z9),b))},b)}],c,b)}],c,b)}return e(_c,[0],function(b){return 1},b)}],c,b)}],a5,a4)}catch(b){b=n(b);if(b===k)throw[0,q,Z2];throw b}var
J=j(_g,_f,ai,a6),B=j(_H,_G,ay,function(c){try{var
f=function(b){return 0},a=function(b){return g(_i,1)},i=e(_F,[0,function(i){function
f(b){return 1}function
a(i){var
d=j(_k,_j,b2,c),e=O(_o,j(_n,_m,dT,u(Q(_l,M),d))),f=ag(b6(2,c[4],e),b),a=j(_q,_p,b2,c);return g(_v,h(1-O(_u,j(_t,_s,ai,u(Q(_r,av),a))),f))}return e(_E,[0,function(a){function
f(b){return 1}return e(_D,[0],function(i){var
e=j(_x,_w,b2,c),f=O(_B,j(_A,_z,dT,u(Q(_y,M),e))),a=ag(b6(2,c[4],f),b);return g(_C,h(aL(d.length-1,_),a))},f)}],a,f)}],a,f);return i}catch(b){b=n(b);if(b===k)throw[0,q,_h];throw b}}),a7=j(_1,_0,ay,function(b){try{var
d=function(b){return c(_J)},f=function(b){return g(_K,1)},a=e(_Z,[0,function(d){function
c(a){function
c(b){throw k}function
d(b){return 0}function
f(d){function
c(e){var
c=s(_L),d=bM(s(_M),c);return m(aC(t(v,m(b,s(_N))),r),d)}return e(_Q,[0],function(d){var
c=bU(r,t(v,m(b,s(_O))));return g(_P,h(aZ(r,v),c))},c)}return e(_X,[0,function(d){function
c(e){var
c=s(_R),d=bM(s(_S),c);return m(aC(t(w,m(b,s(_T))),r),d)}return e(_W,[0],function(d){var
c=bU(r,t(w,m(b,s(_U))));return g(_V,h(aZ(r,w),c))},c)},f],d,c)}return e(_Y,[0],function(b){return 1},c)}],f,d);return a}catch(b){b=n(b);if(b===k)throw[0,q,_I];throw b}});try{var
a8=function(a){function
b(b){throw k}function
c(b){return 0}function
d(c){function
b(b){return m(o,s(_3))}return e(_5,[0],function(b){return g(_4,aZ(r,v))},b)}function
f(c){function
b(b){return m(o,s(_6))}return e(_8,[0],function(c){var
b=bU(r,v);return g(_7,h(aZ(r,w),b))},b)}return e($a,[0,function(c){function
b(b){return m(o,s(_9))}return e(_$,[0],function(b){return g(__,bU(r,w))},b)},f,d],c,b)},a9=e($b,[0],function(b){return 1},a8)}catch(b){b=n(b);if(b===k)throw[0,q,_2];throw b}var
a_=j($d,$c,D,a9);try{var
a$=function(l){function
b(b){throw k}function
a(b){return 0}function
i(a){function
b(e){if(aX(d.length-1,f($f))){var
b=x(C(d.length-1,f($g)));return m(m(o,s($h)),b)}return c($i)}return e($k,[0],function(b){return g($j,aZ(r,v))},b)}function
j(a){function
b(e){if(aX(d.length-1,f($l))){var
b=x(C(d.length-1,f($m)));return m(m(o,s($n)),b)}return c($o)}return e($q,[0],function(c){var
b=bU(r,v);return g($p,h(aZ(r,w),b))},b)}return e($x,[0,function(a){function
b(e){if(aX(d.length-1,f($r))){var
b=x(C(d.length-1,f($s)));return m(m(o,s($t)),b)}return c($u)}return e($w,[0],function(b){return g($v,bU(r,w))},b)},j,i],a,b)},ba=e($y,[0],function(b){return 1},a$)}catch(b){b=n(b);if(b===k)throw[0,q,$e];throw b}var
bb=j($A,$z,D,ba);try{var
bc=function(l){function
b(b){throw k}function
a(b){return 0}function
i(a){function
b(b){return aX(d.length-1,f($C))?m(o,s($D)):c($E)}return e($G,[0],function(b){return g($F,aZ(r,v))},b)}function
j(a){function
b(b){return aX(d.length-1,f($H))?m(o,s($I)):c($J)}return e($L,[0],function(c){var
b=bU(r,v);return g($K,h(aZ(r,w),b))},b)}return e($R,[0,function(a){function
b(b){return aX(d.length-1,f($M))?m(o,s($N)):c($O)}return e($Q,[0],function(b){return g($P,bU(r,w))},b)},j,i],a,b)},bd=function(b){return 1},be=e(aaW,[0,function(q){function
j(b){return aX(d.length-1,f($S))?m(o,s($T)):c($U)}function
n(b){return g($W,a(p,$V))}return e(aaV,[0,function(n){function
j(A){function
j(b){throw k}function
n(b){return 0}function
q(k){function
j(b){return aX(d.length-1,f($X))?m(o,s($Y)):c($Z)}return e($2,[0],function(e){var
c=ag(b,i(F,12,31)),d=h(l(b,i(F,1,1)),c);return g($1,h(a(p,$0),d))},j)}function
r(k){function
j(b){return aX(d.length-1,f($3))?m(o,s($4)):c($5)}return e($8,[0],function(e){var
c=ag(b,i(W,12,31)),d=h(l(b,i(W,1,1)),c);return g($7,h(a(p,$6),d))},j)}function
t(k){function
j(b){return aX(d.length-1,f($9))?m(o,s($_)):c($$)}return e(aac,[0],function(e){var
c=ag(b,i(cI,12,31)),d=h(l(b,i(cI,1,1)),c);return g(aab,h(a(p,aaa),d))},j)}function
u(k){function
j(b){return aX(d.length-1,f(aad))?m(o,s(aae)):c(aaf)}return e(aai,[0],function(e){var
c=ag(b,i(cJ,12,31)),d=h(l(b,i(cJ,1,1)),c);return g(aah,h(a(p,aag),d))},j)}function
v(k){function
j(b){return aX(d.length-1,f(aaj))?m(o,s(aak)):c(aal)}return e(aao,[0],function(e){var
c=ag(b,i(gV,12,31)),d=h(l(b,i(gV,1,1)),c);return g(aan,h(a(p,aam),d))},j)}function
w(k){function
j(b){return aX(d.length-1,f(aap))?m(o,s(aaq)):c(aar)}return e(aau,[0],function(e){var
c=ag(b,i(dK,12,31)),d=h(l(b,i(dK,1,1)),c);return g(aat,h(a(p,aas),d))},j)}function
x(k){function
j(b){return aX(d.length-1,f(aav))?m(o,s(aaw)):c(aax)}return e(aaA,[0],function(e){var
c=ag(b,i(dn,12,31)),d=h(l(b,i(dn,1,1)),c);return g(aaz,h(a(p,aay),d))},j)}function
y(k){function
j(b){return aX(d.length-1,f(aaB))?m(o,s(aaC)):c(aaD)}return e(aaG,[0],function(e){var
c=ag(b,i(eF,12,31)),d=h(l(b,i(eF,1,1)),c);return g(aaF,h(a(p,aaE),d))},j)}function
z(k){function
j(b){return aX(d.length-1,f(aaH))?m(o,s(aaI)):c(aaJ)}return e(aaM,[0],function(e){var
c=ag(b,i(dB,12,31)),d=h(l(b,i(dB,1,1)),c);return g(aaL,h(a(p,aaK),d))},j)}return e(aaT,[0,function(k){function
j(b){return aX(d.length-1,f(aaN))?m(o,s(aaO)):c(aaP)}return e(aaS,[0],function(e){var
c=ag(b,i(dG,12,31)),d=h(l(b,i(dG,1,1)),c);return g(aaR,h(a(p,aaQ),d))},j)},z,y,x,w,v,u,t,r,q],n,j)}return e(aaU,[0],function(b){return 1},j)}],n,j)}],bd,bc)}catch(b){b=n(b);if(b===k)throw[0,q,$B];throw b}var
R=j(aaY,aaX,D,be);try{var
bf=function(b){return a(N,s(aa0))?s(aa1):bM(aY,N)},bg=e(aa3,[0],function(b){return g(aa2,1)},bf)}catch(b){b=n(b);if(b===k)throw[0,q,aaZ];throw b}var
bh=j(aa5,aa4,aS,bg),bi=j(abI,abH,ay,function(b){try{var
d=function(n){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(b){return c(aa7)}return e(abd,[0],function(d){var
c=j(aa9,aa8,b2,b);return g(abc,1-O(abb,j(aba,aa$,ai,u(Q(aa_,B),c))))},d)}function
i(d){function
c(b){return m(o,s(abe))}return e(abm,[0],function(e){var
c=j(abg,abf,b2,b),d=O(abk,j(abj,abi,ai,u(Q(abh,B),c)));return g(abl,h(aZ(r,v),d))},c)}function
l(d){function
c(b){return m(o,s(abn))}return e(abv,[0],function(f){var
c=j(abp,abo,b2,b),d=O(abt,j(abs,abr,ai,u(Q(abq,B),c))),e=bU(r,v);return g(abu,h(h(aZ(r,w),e),d))},c)}return e(abF,[0,function(d){function
c(b){return m(o,s(abw))}return e(abE,[0],function(e){var
c=j(aby,abx,b2,b),d=O(abC,j(abB,abA,ai,u(Q(abz,B),c)));return g(abD,h(bU(r,w),d))},c)},l,i,a],f,d)},f=e(abG,[0],function(b){return 1},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,aa6];throw b}});try{var
bj=function(b){return m(a_,x(c8(function(b){var
c=j(abL,abK,b2,b);return O(abP,j(abO,abN,ai,u(Q(abM,aI),c)))},E).length-1))},bk=e(abR,[0],function(b){return g(abQ,1)},bj)}catch(b){b=n(b);if(b===k)throw[0,q,abJ];throw b}var
G=j(abT,abS,D,bk);try{var
bl=function(b){return t(R,bb)},bm=function(b){return g(abV,1)},bn=e(ab4,[0,function(c){function
b(j){function
b(b){throw k}function
c(b){return 0}function
i(c){function
b(b){return t(t(t(P,R),aR),aN)}return e(abY,[0],function(b){return g(abX,a(p,abW))},b)}return e(ab2,[0,function(c){function
b(b){return P}return e(ab1,[0],function(b){return g(ab0,h(A,a(d.length-1,f(abZ))))},b)},i],c,b)}return e(ab3,[0],function(b){return 1},b)}],bm,bl)}catch(b){b=n(b);if(b===k)throw[0,q,abU];throw b}var
bo=j(ab6,ab5,D,bn),bp=j(acB,acA,ay,function(c){try{var
i=function(d){var
b=j(ab9,ab8,b2,c);return O(acb,j(aca,ab$,D,u(Q(ab_,bi),b)))},l=function(b){return g(acc,1)},p=e(acz,[0,function(l){function
i(p){function
i(b){throw k}function
l(b){return 0}function
n(k){function
i(b){return m(o,s(acd))}return e(acm,[0],function(l){var
e=ag(b6(2,c[4],[0,16,0,0]),b),i=h(A,h(a(d.length-1,f(ace)),e)),k=j(acg,acf,b2,c);return g(acl,h(O(ack,j(acj,aci,ai,u(Q(ach,B),k))),i))},i)}return e(acx,[0,function(k){function
i(b){return m(o,s(acn))}return e(acw,[0],function(m){var
e=c9(b6(2,c[4],[0,16,0,0]),b),i=h(ag(b6(2,c[4],[0,11,0,0]),b),e),k=h(A,h(a(d.length-1,f(aco)),i)),l=j(acq,acp,b2,c);return g(acv,h(O(acu,j(act,acs,ai,u(Q(acr,B),l))),k))},i)},n],l,i)}return e(acy,[0],function(b){return 1},i)}],l,i);return p}catch(b){b=n(b);if(b===k)throw[0,q,ab7];throw b}});try{var
bq=function(b){return c(acD)},br=function(b){return g(acE,1)},bs=e(acT,[0,function(c){function
b(f){function
b(b){throw k}function
c(b){return 0}function
d(c){function
b(d){var
b=s(acF),c=bM(s(acG),b);return m(aC(t(v,m(G,s(acH))),r),c)}return e(acK,[0],function(c){var
b=bU(r,t(v,m(G,s(acI))));return g(acJ,h(aZ(r,v),b))},b)}return e(acR,[0,function(c){function
b(d){var
b=s(acL),c=bM(s(acM),b);return m(aC(t(w,m(G,s(acN))),r),c)}return e(acQ,[0],function(c){var
b=bU(r,t(w,m(G,s(acO))));return g(acP,h(aZ(r,w),b))},b)},d],c,b)}return e(acS,[0],function(b){return 1},b)}],br,bq)}catch(b){b=n(b);if(b===k)throw[0,q,acC];throw b}var
bt=j(acV,acU,D,bs);try{var
bu=function(b){return m(bo,bh)},bv=e(acY,[0],function(b){return g(acX,1)},bu)}catch(b){b=n(b);if(b===k)throw[0,q,acW];throw b}var
bw=j(ac0,acZ,D,bv),bx=j(adi,adh,ay,function(c){try{var
b=function(f){var
d=j(ac3,ac2,b2,c);switch(O(ac7,j(ac6,ac5,tm,u(Q(ac4,L),d)))[0]){case
0:var
b=s(ac8);break;case
1:var
b=s(add);break;default:var
b=s(ade)}var
e=j(ac_,ac9,b2,c);return m(O(adc,j(adb,ada,D,u(Q(ac$,bp),e))),b)},d=e(adg,[0],function(b){return g(adf,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,ac1];throw b}});try{var
by=function(b){return J?bw:c(adk)},bz=e(adm,[0],function(b){return g(adl,1)},by)}catch(b){b=n(b);if(b===k)throw[0,q,adj];throw b}var
S=j(ado,adn,D,bz);try{var
bB=function(e){if(J){var
b=ck(function(b){var
c=j(adr,adq,b2,b);return O(adv,j(adu,adt,D,u(Q(ads,bx),c)))},E),d=c(adw);return gh(function(c,b){return t(c,b)},d,b)}return c(adx)},bC=e(adz,[0],function(b){return g(ady,1)},bB)}catch(b){b=n(b);if(b===k)throw[0,q,adp];throw b}var
T=j(adB,adA,D,bC);try{var
bD=function(b){return t(S,T)},bE=e(adE,[0],function(b){return g(adD,1)},bD)}catch(b){b=n(b);if(b===k)throw[0,q,adC];throw b}var
bF=j(adG,adF,D,bE);try{var
bG=function(d){if(aH){var
b=j(adJ,adI,D,bF);return O(adN,j(adM,adL,D,u(Q(adK,a7),b)))}return c(adO)},bH=e(adQ,[0],function(b){return g(adP,1)},bG)}catch(b){b=n(b);if(b===k)throw[0,q,adH];throw b}var
bI=j(adS,adR,D,bH);try{var
bJ=function(b){return J?t(t(t(t(S,T),G),bI),bt):c(adU)},bK=e(adW,[0],function(b){return g(adV,1)},bJ)}catch(b){b=n(b);if(b===k)throw[0,q,adT];throw b}return[0,X,j(adY,adX,D,bK)]}throw[0,bT,adZ]}function
ad0(b){var
c=b[1],d=b[2],f=b[3],a=b[4],h=b[5],i=b[6],m=b[7];try{var
o=function(b){return ck(function(b){var
d=b[6],e=b[5],f=b[4],a=b[3],g=b[2],h=l(b6(2,b[3],[0,3,0,0]),c)?ad2:l(b6(2,b[3],[0,16,0,0]),c)?ad3:ad4;return[0,b[1],h,g,a,f,e,d]},d)},p=e(ad6,[0],function(b){return g(ad5,1)},o)}catch(b){b=n(b);if(b===k)throw[0,q,ad1];throw b}var
r=j(ad8,ad7,function(b){return c7(b2,b)},p);try{var
s=function(b){return 0},t=function(b){return g(ad_,1)},v=j(aed,aec,ai,e(aeb,[0,function(c){function
b(b){return 1}return e(aea,[0],function(b){return g(ad$,h)},b)}],t,s))}catch(b){b=n(b);if(b===k)throw[0,q,ad9];throw b}try{var
w=function(b){return 0},x=function(b){return g(aef,1)},y=j(aek,aej,ai,e(aei,[0,function(c){function
b(b){return 1}return e(aeh,[0],function(b){return g(aeg,i)},b)}],x,w))}catch(b){b=n(b);if(b===k)throw[0,q,aee];throw b}try{var
z=function(b){return f},A=j(aep,aeo,D,e(aen,[0],function(b){return g(aem,1)},z))}catch(b){b=n(b);if(b===k)throw[0,q,ael];throw b}try{var
B=function(b){return a},C=j(aeu,aet,oG,e(aes,[0],function(b){return g(aer,1)},B))}catch(b){b=n(b);if(b===k)throw[0,q,aeq];throw b}try{var
E=function(b){return c},F=j(aez,aey,aK,e(aex,[0],function(b){return g(aew,1)},E))}catch(b){b=n(b);if(b===k)throw[0,q,aev];throw b}try{var
G=function(b){return r},H=e(aeC,[0],function(b){return g(aeB,1)},G),I=j(aeE,aeD,function(b){return c7(b2,b)},H)}catch(b){b=n(b);if(b===k)throw[0,q,aeA];throw b}try{var
J=function(b){return 0},K=function(b){return g(aeG,1)},L=j(aeL,aeK,ai,e(aeJ,[0,function(c){function
b(b){return 1}return e(aeI,[0],function(b){return g(aeH,m)},b)}],K,J))}catch(b){b=n(b);if(b===k)throw[0,q,aeF];throw b}var
M=O(aeN,u(Q(aeM,ts),[0,v,y,A,C,F,I,L]))[2];try{var
N=function(b){return M},P=e(aeQ,[0],function(b){return g(aeP,1)},N)}catch(b){b=n(b);if(b===k)throw[0,q,aeO];throw b}return[0,j(aeS,aeR,D,P)]}function
tt(c){var
b=a4(c.kind);return R(b,aeV)?R(b,aeW)?R(b,aeX)?R(b,aeY)?R(b,aeZ)?aE(u(aN(ae0),b)):ae1:ae2:ae3:ae4:ae5}function
jK(c){var
b=a4(c.kind);return R(b,afb)?R(b,afc)?R(b,afd)?R(b,afe)?R(b,aff)?R(b,afg)?R(b,afh)?R(b,afi)?R(b,afj)?aE(u(aN(afk),b)):afl:afm:afn:afo:afp:afq:afr:afs:aft}function
hS(b){var
d=b.beneficieTitrePersonnelAidePersonnelleLogement|0,e=b.aDejaOuvertDroitAuxAllocationsFamiliales|0,f=tt(b.priseEnCharge),a=aH(b.dateDeNaissance),g=aF(aG(b.remunerationMensuelle)),c=a4(b.obligationScolaire.kind),h=R(c,ae6)?R(c,ae7)?R(c,ae8)?aE(u(aN(ae9),c)):ae_:ae$:afa;return[0,b.identifiant,h,g,a,f,e,d]}function
afu(b){return{"ageMinimumAlinea1L5213":jJ(tn(0)[1])}}function
afv(k){var
j=i8(k.enfantsIn),b=to([0,ck(function(b){return hS(b)},j)])[1],c=b[5],a=!!b[7],g=!!b[6];switch(c[0]){case
0:var
d={"kind":CI,"payload":c[1]};break;case
1:var
d={"kind":wE,"payload":c[1]};break;case
2:var
d={"kind":o9,"payload":c[1]};break;case
3:var
d={"kind":Fp,"payload":c[1]};break;default:var
d={"kind":vj,"payload":c[1]}}var
h=oE(b[4]),i=aO(b[3]),e=b[2];switch(e[0]){case
0:var
f={"kind":ic,"payload":e[1]};break;case
1:var
f={"kind":h9,"payload":e[1]};break;default:var
f={"kind":ri,"payload":e[1]}}return{"lePlusAge":{"identifiant":hP(b[1]),"obligationScolaire":f,"remunerationMensuelle":i,"dateDeNaissance":h,"priseEnCharge":d,"aDejaOuvertDroitAuxAllocationsFamiliales":g,"beneficieTitrePersonnelAidePersonnelleLogement":a}}}function
afw(b){var
c=jI(b.anneesIn),d=aH(b.dateCouranteIn);return{"estInferieurOuEgal":!!QT([0,aH(b.dateNaissanceIn),d,c])[1]}}function
afx(b){var
c=jI(b.anneesIn),d=aH(b.dateCouranteIn);return{"estSuperieur":!!QZ([0,aH(b.dateNaissanceIn),d,c])[1]}}function
afy(b){var
c=jK(b.residenceIn);return{"brutHoraire":aO(tp([0,aH(b.dateCouranteIn),c])[1])}}function
afz(b){return{"montant":aO(tq([0,aH(b.dateCouranteIn)])[1])}}function
afA(c){var
g=jK(c.residenceIn),b=tr([0,aH(c.dateCouranteIn),g]),d=!!b[4],e=jJ(b[3]);function
f(c){return am(function(e,c){var
d=hS(c);return!!u(b[2],d)})}var
a=am(f);return{"droitOuvert":am(function(c){return am(function(e,c){var
d=hS(c);return!!u(b[1],d)})}),"conditionsHorsAge":a,"ageL51232":e,"regimeOutreMerL7511":d}}function
afB(b){var
e=b.avaitEnfantAChargeAvant1erJanvier2012In|0,f=i8(b.enfantsAChargeIn),i=ck(function(b){return hS(b)},f),a=aH(b.dateCouranteIn),g=jK(b.residenceIn),h=aF(aG(b.ressourcesMenageIn)),c=ts([0,b.personneChargeEffectivePermanenteEstParentIn|0,b.personneChargeEffectivePermanenteRemplitTitreIIn|0,h,g,a,i,e]),d=aO(c[2]);return{"versement":am(function(b){return am(function(f,d){var
e=hS(d),b=u(c[1],e);return 0===b[0]?{"kind":"Normal","payload":b[1]}:{"kind":"AllocationVerseeAuxServicesSociaux","payload":b[1]}})}),"montantVerse":d}}function
tu(b){var
c=b.iAvaitEnfantAChargeAvant1erJanvier2012In|0,d=b.iPersonneChargeEffectivePermanenteRemplitTitreIIn|0,e=b.iPersonneChargeEffectivePermanenteEstParentIn|0,f=jK(b.iResidenceIn),a=aF(aG(b.iRessourcesMenageIn)),g=i8(b.iEnfantsIn),h=ck(function(b){var
c=b.dBeneficieTitrePersonnelAidePersonnelleLogement|0,d=b.dADejaOuvertDroitAuxAllocationsFamiliales|0,e=tt(b.dPriseEnCharge),f=aH(b.dDateDeNaissance),a=aF(aG(b.dRemunerationMensuelle));return[0,b.dIdentifiant,a,f,e,d,c]},g);return{"iMontantVerse":aO(ad0([0,aH(b.iDateCouranteIn),h,a,f,e,d,c])[1])}}var
oH=[0,0,0,0];function
afC(m,l,k,j,i,h,g,a,f,e){if(!oH[1]){var
d=js(aeT),b=jr(d,afD),c=jq(d,aeU),n=c[1],o=c[2],p=c[3],q=c[4],r=c[5],s=c[6],t=c[7],v=c[8],w=c[9],x=function(d){var
c=d[1+b];return u(c[2],c[1])},y=function(d){var
c=d[1+b];return u(c[3],c[1])},z=function(d){var
c=d[1+b];return u(c[4],c[1])},A=function(d){var
c=d[1+b];return u(c[5],c[1])},B=function(d){var
c=d[1+b];return u(c[6],c[1])},C=function(d){var
c=d[1+b];return u(c[7],c[1])},D=function(d){var
c=d[1+b];return u(c[8],c[1])},E=function(d){var
c=d[1+b];return u(c[9],c[1])};jw(d,[0,w,function(d){var
c=d[1+b];return u(c[10],c[1])},s,E,o,D,n,C,p,B,t,A,q,z,v,y,r,x]);var
F=function(e){var
c=ju(0,d);c[1+b]=e;return c};jt(d);oH[1]=F}return u(oH[1],[0,m,e,f,a,g,h,i,j,k,l])}function
afE(b){return bh(tu)}function
afF(b){return bh(afB)}function
afG(b){return bh(afA)}function
afH(b){return bh(afz)}function
afI(b){return bh(afy)}function
afJ(b){return bh(afx)}function
afK(b){return bh(afw)}function
afL(b){return bh(afv)}function
afM(b){return bh(afu)}tk(afN,function(i,h,g,a,f,e,d,c,b,j){return{"allocationFamilialesAvril2008":am(i),"enfantLePlusAge":am(h),"verificationAgeInferieurOuEgalA":am(g),"verificationAgeSuperieurA":am(a),"smic":am(f),"baseMensuelleAllocationsFamiliales":am(e),"prestationsFamiliales":am(d),"allocationsFamiliales":am(c),"interfaceAllocationsFamiliales":am(b)}}(afM,afL,afK,afJ,afI,afH,afG,afF,afE,afC));function
tv(c){switch(c[0]){case
0:var
b=[0,afO,0];break;case
1:var
b=[0,afQ,0];break;case
2:var
b=[0,afR,0];break;case
3:var
b=[0,afS,0];break;default:var
b=[0,afT,0]}return[6,afP,b]}function
tw(c){switch(c[0]){case
0:var
b=[0,afX,0];break;case
1:var
b=[0,afZ,0];break;default:var
b=[0,af0,0]}return[6,afY,b]}function
tx(c){switch(c[0]){case
0:var
b=[0,af1,0];break;case
1:var
b=[0,af3,0];break;case
2:var
b=[0,af4,0];break;default:var
b=[0,af5,0]}return[6,af2,b]}function
agd(c){switch(c[0]){case
0:var
b=[0,age,0];break;case
1:var
b=[0,agg,0];break;case
2:var
b=[0,agh,0];break;default:var
b=[0,agi,0]}return[6,agf,b]}function
ty(b){var
c=0===b[0]?[0,agj,[3,b[1]]]:[0,agl,0];return[6,agk,c]}function
dw(c){switch(c[0]){case
0:var
b=[0,agt,0];break;case
1:var
b=[0,agv,0];break;default:var
b=[0,agw,0]}return[6,agu,b]}function
tz(b){switch(b[0]){case
0:var
c=[0,agx,[1,b[1]]];break;case
1:var
c=[0,agz,[1,b[1]]];break;default:var
c=[0,agA,[1,b[1]]]}return[6,agy,c]}function
agB(b){var
c=0===b[0]?[0,agC,0]:[0,agE,0];return[6,agD,c]}function
tA(c){switch(c[0]){case
0:var
b=[0,agF,0];break;case
1:var
b=[0,agH,0];break;default:var
b=[0,agI,0]}return[6,agG,b]}function
hT(c){switch(c[0]){case
0:var
b=[0,agM,0];break;case
1:var
b=[0,agO,0];break;default:var
b=[0,agP,0]}return[6,agN,b]}function
oI(c){switch(c[0]){case
0:var
b=[0,agQ,0];break;case
1:var
b=[0,agS,[4,c[1]]];break;case
2:var
b=[0,agT,0];break;case
3:var
b=[0,agU,0];break;case
4:var
b=[0,agV,0];break;default:var
b=[0,agW,0]}return[6,agR,b]}function
hU(c){switch(c[0]){case
0:var
b=[0,agX,0];break;case
1:var
b=[0,agZ,0];break;case
2:var
b=[0,ag0,0];break;default:var
b=[0,ag1,0]}return[6,agY,b]}function
tB(c){switch(c[0]){case
0:var
b=[0,ag2,0];break;case
1:var
b=[0,ag4,0];break;case
2:var
b=[0,ag5,0];break;default:var
b=[0,ag6,0]}return[6,ag3,b]}function
cS(b){var
c=0===b[0]?[0,ag7,0]:[0,ag9,0];return[6,ag8,c]}function
cc(c){switch(c[0]){case
0:var
b=[0,ag_,0];break;case
1:var
b=[0,aha,0];break;case
2:var
b=[0,ahb,0];break;case
3:var
b=[0,ahc,0];break;case
4:var
b=[0,ahd,0];break;case
5:var
b=[0,ahe,0];break;case
6:var
b=[0,ahf,0];break;case
7:var
b=[0,ahg,0];break;default:var
b=[0,ahh,0]}return[6,ag$,b]}function
tC(c){switch(c[0]){case
0:var
b=[0,ahi,0];break;case
1:var
b=[0,ahk,0];break;default:var
b=[0,ahl,0]}return[6,ahj,b]}function
ahx(b){return[7,ahF,[0,[0,ahE,[1,b[1]]],[0,[0,ahD,[1,b[2]]],[0,[0,ahC,[1,b[3]]],[0,[0,ahB,[3,b[4]]],[0,[0,ahA,[1,b[5]]],[0,[0,ahz,[1,b[6]]],[0,[0,ahy,1],0]]]]]]]]}function
ahG(b){return[7,ahQ,[0,[0,ahP,[1,b[1]]],[0,[0,ahO,[1,b[2]]],[0,[0,ahN,[3,b[3]]],[0,[0,ahM,[1,b[4]]],[0,[0,ahL,[1,b[5]]],[0,[0,ahK,[1,b[6]]],[0,[0,ahJ,[3,b[7]]],[0,[0,ahI,[1,b[8]]],[0,[0,ahH,1],0]]]]]]]]]]}function
ahR(b){return[7,ahX,[0,[0,ahW,[1,b[1]]],[0,[0,ahV,[1,b[2]]],[0,[0,ahU,[3,b[3]]],[0,[0,ahT,[1,b[4]]],[0,[0,ahS,1],0]]]]]]}function
tD(b){return[7,ah0,[0,[0,ahZ,[1,b[1]]],[0,[0,ahY,1],0]]]}function
tE(b){return[7,ah$,[0,[0,ah_,[1,b[1]]],[0,[0,ah9,1],[0,[0,ah8,[1,b[3]]],[0,[0,ah7,[1,b[4]]],[0,[0,ah6,[1,b[5]]],[0,[0,ah5,[3,b[6]]],[0,[0,ah4,[1,b[7]]],0]]]]]]]]}function
aia(b){return[7,aig,[0,[0,aif,[1,b[1]]],[0,[0,aie,[1,b[2]]],[0,[0,aid,[3,b[3]]],[0,[0,aic,[1,b[4]]],[0,[0,aib,1],0]]]]]]}function
aih(b){return[7,aio,[0,[0,ain,[3,b[1]]],[0,[0,aim,[1,b[2]]],[0,[0,ail,[1,b[3]]],[0,[0,aik,[1,b[4]]],[0,[0,aij,[1,b[5]]],[0,[0,aii,1],0]]]]]]]}function
aip(b){return[7,air,[0,[0,aiq,[0,b[1]]],0]]}function
tF(b){return[7,ait,[0,[0,ais,[0,b[1]]],0]]}function
tG(b){if(0===b[0])var
c=[0,aiu,0];else
var
d=0===b[1][0]?[0,af6,0]:[0,af8,0],c=[0,aiw,[6,af7,d]];return[6,aiv,c]}function
aix(b){var
c=b[1],e=[0,[0,aiz,[1,b[2]]],[0,[0,aiy,[3,b[3]]],0]],d=0===c[0]?[0,af9,[1,c[1]]]:[0,af$,0];return[7,aiB,[0,[0,aiA,[6,af_,d]],e]]}function
aiC(b){var
c=b[1],e=[0,[0,aiE,[3,b[2]]],[0,[0,aiD,[3,b[3]]],0]],d=0===c[0]?[0,aga,[3,c[1]]]:[0,agc,0];return[7,aiG,[0,[0,aiF,[6,agb,d]],e]]}function
oJ(b){var
c=b[4],f=0,e=0===c[0]?[0,agJ,[4,c[1]]]:[0,agL,0],a=[0,[0,aiP,[6,agK,e]],f],d=0===b[3][0]?[0,afU,0]:[0,afW,0],g=[0,[0,aiR,[4,b[2]]],[0,[0,aiQ,[6,afV,d]],a]];return[7,aiT,[0,[0,aiS,tv(b[1])],g]]}function
tH(b){var
c=[0,[0,aiX,[0,b[10]]],[0,[0,aiW,[0,b[11]]],[0,[0,aiV,[0,b[12]]],[0,[0,aiU,[0,b[13]]],0]]]],d=[0,[0,aiY,tB(b[9])],c],e=[0,[0,ai5,[0,b[2]]],[0,[0,ai4,[0,b[3]]],[0,[0,ai3,[0,b[4]]],[0,[0,ai2,[0,b[5]]],[0,[0,ai1,[4,b[6]]],[0,[0,ai0,[0,b[7]]],[0,[0,aiZ,[1,b[8]]],d]]]]]]];return[7,ai7,[0,[0,ai6,hU(b[1])],e]]}function
hV(b){var
c=[0,[0,ai_,[1,b[3]]],[0,[0,ai9,[4,b[4]]],[0,[0,ai8,[0,b[5]]],0]]],d=[0,[0,ai$,tC(b[2])],c];return[7,ajb,[0,[0,aja,[2,b[1]]],d]]}function
tI(b){if(0===b[0])var
c=[0,ajj,0];else
var
d=b[1],c=[0,ajl,[7,ahw,[0,[0,ahv,[0,d[1]]],[0,[0,ahu,[0,d[2]]],0]]]];return[6,ajk,c]}function
tJ(b){if(0===b[0])var
c=b[1],d=[0,ajm,[7,ah3,[0,[0,ah2,[1,c[1]]],[0,[0,ah1,[1,c[2]]],0]]]];else
var
d=[0,ajo,0];return[6,ajn,d]}function
oK(b){var
c=[0,[0,ajp,[0,b[11]]],0],d=[0,[0,ajq,oJ(b[10])],c],e=[0,[0,ajr,tG(b[9])],d],f=[0,[0,aju,[0,b[6]]],[0,[0,ajt,[0,b[7]]],[0,[0,ajs,[0,b[8]]],e]]],a=[0,[0,ajv,tx(b[5])],f],g=[0,[0,ajw,tw(b[4])],a];return[7,ajA,[0,[0,ajz,[1,b[1]]],[0,[0,ajy,[1,b[2]]],[0,[0,ajx,[4,b[3]]],g]]]]}function
fK(b){var
c=[0,[0,ajD,[0,b[3]]],[0,[0,ajC,[0,b[4]]],[0,[0,ajB,[0,b[5]]],0]]],d=[0,[0,ajE,tI(b[2])],c];return[7,ajG,[0,[0,ajF,[4,b[1]]],d]]}function
oL(b){var
f=[0,[0,ajQ,tJ(b[8])],0],d=b[1],a=[0,[0,ajW,[1,b[2]]],[0,[0,ajV,[0,b[3]]],[0,[0,ajU,[0,b[4]]],[0,[0,ajT,[0,b[5]]],[0,[0,ajS,[0,b[6]]],[0,[0,ajR,[0,b[7]]],f]]]]]];switch(d[0]){case
0:var
e=d[1],c=[0,ajc,[7,aho,[0,[0,ahn,[0,e[1]]],[0,[0,ahm,[1,e[2]]],0]]]];break;case
1:var
c=[0,aje,[7,ahq,[0,[0,ahp,[0,d[1][1]]],0]]];break;default:var
c=[0,ajf,0]}return[7,ajY,[0,[0,ajX,[6,ajd,c]],a]]}function
hW(e){if(0===e[0])var
b=e[1],f=b[7],i=[0,[0,ajH,[0,b[8]]],0],g=0===f[0]?[0,agm,0]:[0,ago,[3,f[1]]],j=[0,[0,ajJ,tC(b[6])],[0,[0,ajI,[6,agn,g]],i]],k=[0,[0,ajM,[0,b[3]]],[0,[0,ajL,[4,b[4]]],[0,[0,ajK,[1,b[5]]],j]]],l=[0,[0,ajN,tI(b[2])],k],a=[0,ajZ,[7,ajP,[0,[0,ajO,[2,b[1]]],l]]];else{var
c=e[1],h=[0,[0,aiJ,[0,c[5]]],[0,[0,aiI,[0,c[6]]],[0,[0,aiH,[0,c[7]]],0]]];switch(c[4][0]){case
0:var
d=[0,agp,0];break;case
1:var
d=[0,agr,0];break;default:var
d=[0,ags,0]}var
a=[0,aj1,[7,aiO,[0,[0,aiN,[4,c[1]]],[0,[0,aiM,[1,c[2]]],[0,[0,aiL,[0,c[3]]],[0,[0,aiK,[6,agq,d]],h]]]]]]}return[6,aj0,a]}function
tK(b){switch(b[0]){case
0:var
c=[0,aj2,oL(b[1])];break;case
1:var
c=[0,aj4,oK(b[1])];break;default:var
c=[0,aj5,tH(b[1])]}return[6,aj3,c]}function
oM(b){switch(b[0]){case
0:var
c=[0,aj6,oL(b[1])];break;case
1:var
c=[0,aj8,tH(b[1])];break;case
2:var
c=[0,aj9,oK(b[1])];break;case
3:var
c=[0,aj_,oL(b[1])];break;default:var
c=[0,aj$,oK(b[1])]}return[6,aj7,c]}function
e8(b){var
k=[0,[0,akj,cc(b[9])],0],l=[0,[0,akm,[0,b[6]]],[0,[0,akl,[0,b[7]]],[0,[0,akk,[0,b[8]]],k]]],m=[0,[0,akn,oI(b[5])],l],n=[0,[0,ako,[2,b[4]]],m],o=[0,[0,akp,c7(hW,b[3])],n],c=b[2],a=[0,[0,aka,dw(c[8])],0],g=[0,[0,akc,[0,c[6]]],[0,[0,akb,[2,c[7]]],a]],h=[0,[0,akd,ty(c[5])],g],f=c[4];if(0===f[0])var
d=[0,ajg,0];else
var
e=f[1],d=[0,aji,[7,aht,[0,[0,ahs,[4,e[1]]],[0,[0,ahr,[0,e[2]]],0]]]];var
i=[0,[0,akf,ty(c[3])],[0,[0,ake,[6,ajh,d]],h]],j=[0,[0,akg,oM(c[2])],i],p=[0,[0,akq,[7,aki,[0,[0,akh,[0,c[1]]],j]]],o];return[7,aks,[0,[0,akr,c7(agd,b[1])],p]]}function
akt(b){var
c=[0,[0,aku,cc(b[14])],0],d=[0,[0,akx,[0,b[11]]],[0,[0,akw,[1,b[12]]],[0,[0,akv,[0,b[13]]],c]]],e=[0,[0,aky,hT(b[10])],d],f=[0,[0,akA,[0,b[8]]],[0,[0,akz,[0,b[9]]],e]],a=[0,[0,akB,dw(b[7])],f],g=[0,[0,akC,cS(b[6])],a];return[7,akI,[0,[0,akH,[1,b[1]]],[0,[0,akG,[1,b[2]]],[0,[0,akF,[0,b[3]]],[0,[0,akE,[4,b[4]]],[0,[0,akD,[2,b[5]]],g]]]]]]}function
akJ(b){var
c=[0,[0,akO,[4,b[9]]],[0,[0,akN,[1,b[10]]],[0,[0,akM,1],[0,[0,akL,1],[0,[0,akK,1],0]]]]],d=[0,[0,akP,dw(b[8])],c],e=[0,[0,akQ,cS(b[7])],d],f=[0,[0,akT,[4,b[4]]],[0,[0,akS,[1,b[5]]],[0,[0,akR,[2,b[6]]],e]]],a=[0,[0,akU,hU(b[3])],f],g=[0,[0,akV,[0,b[2]]],a];return[7,akX,[0,[0,akW,cc(b[1])],g]]}function
akY(b){var
c=[0,[0,akZ,cc(b[15])],0],d=[0,[0,ak0,[4,b[14]]],c],e=[0,[0,ak1,tG(b[13])],d],f=[0,[0,ak2,tv(b[12])],e],a=[0,[0,ak3,dw(b[11])],f],g=[0,[0,ak8,[4,b[6]]],[0,[0,ak7,[0,b[7]]],[0,[0,ak6,[4,b[8]]],[0,[0,ak5,[0,b[9]]],[0,[0,ak4,[0,b[10]]],a]]]]],h=[0,[0,ak9,tw(b[5])],g],i=[0,[0,ak_,cS(b[4])],h];return[7,alc,[0,[0,alb,[1,b[1]]],[0,[0,ala,[1,b[2]]],[0,[0,ak$,[2,b[3]]],i]]]]}function
tL(b){var
c=[0,[0,ald,tJ(b[15])],0],d=[0,[0,ale,cc(b[14])],c],e=[0,[0,alh,[0,b[11]]],[0,[0,alg,[1,b[12]]],[0,[0,alf,[0,b[13]]],d]]],f=[0,[0,ali,hT(b[10])],e],a=[0,[0,alk,[0,b[8]]],[0,[0,alj,[0,b[9]]],f]],g=[0,[0,all,dw(b[7])],a],h=[0,[0,alm,cS(b[6])],g];return[7,als,[0,[0,alr,[1,b[1]]],[0,[0,alq,[1,b[2]]],[0,[0,alp,[0,b[3]]],[0,[0,alo,[4,b[4]]],[0,[0,aln,[2,b[5]]],h]]]]]]}function
alt(b){var
c=[0,[0,aly,[0,b[11]]],[0,[0,alx,[4,b[12]]],[0,[0,alw,[1,b[13]]],[0,[0,alv,[0,b[14]]],[0,[0,alu,[0,b[15]]],0]]]]],d=[0,[0,alz,tx(b[10])],c],e=[0,[0,alD,[4,b[6]]],[0,[0,alC,[1,b[7]]],[0,[0,alB,[0,b[8]]],[0,[0,alA,[4,b[9]]],d]]]],f=[0,[0,alE,cc(b[5])],e],a=[0,[0,alF,dw(b[4])],f],g=[0,[0,alG,cS(b[3])],a];return[7,alJ,[0,[0,alI,[1,b[1]]],[0,[0,alH,[2,b[2]]],g]]]}function
alK(b){var
c=[0,[0,alL,tB(b[11])],0],d=[0,[0,alM,[4,b[10]]],c],e=[0,[0,alN,dw(b[9])],d],f=[0,[0,alO,cS(b[8])],e],a=[0,[0,alR,[1,b[5]]],[0,[0,alQ,[1,b[6]]],[0,[0,alP,[2,b[7]]],f]]],g=[0,[0,alS,cc(b[4])],a],h=[0,[0,alU,[0,b[2]]],[0,[0,alT,[4,b[3]]],g]];return[7,alW,[0,[0,alV,hU(b[1])],h]]}function
alX(b){return[7,al1,[0,[0,al0,[4,b[1]]],[0,[0,alZ,[4,b[2]]],[0,[0,alY,[5,b[3]]],0]]]]}function
tM(b){return[7,al5,[0,[0,al4,[4,b[1]]],[0,[0,al3,[4,b[2]]],[0,[0,al2,[5,b[3]]],0]]]]}function
gi(b){var
d=b[1],f=b[2];try{var
a=function(b){return 0},o=function(b){return g(al7,1)},p=e(al_,[0,function(c){function
b(b){return 1}return e(al9,[0],function(b){return g(al8,1)},b)}],o,a)}catch(b){b=n(b);if(b===k)throw[0,q,al6];throw b}var
r=j(ama,al$,ai,p);try{var
t=l(d,i(F,1,1))}catch(b){b=n(b);if(b===k)throw[0,q,amb];throw b}if(t){try{var
u=function(b){return s(amd)},v=e(amf,[0],function(b){return g(ame,l(d,i(F,1,1)))},u)}catch(b){b=n(b);if(b===k)throw[0,q,amc];throw b}var
w=j(amh,amg,aS,v);if(r)return[0,j(amp,amo,ay,function(b){try{var
a=function(c){return m(b,w)},j=function(b){return g(amj,l(d,i(cI,9,1)))},o=e(amn,[0,function(a){function
b(b){return c(amk)}return e(amm,[0],function(c){switch(f[0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=1;break;default:var
b=0}return g(aml,h(l(d,i(f2,2,22)),b))},b)}],j,a);return o}catch(b){b=n(b);if(b===k)throw[0,q,ami];throw b}})];throw[0,bT,amq]}throw[0,bT,amr]}function
hX(b){var
d=b[1],l=b[2],f=b[3],a=b[4];try{var
p=function(b){return f?c(amt):c(amu)},r=e(amw,[0],function(b){return g(amv,c9(d,i(W,10,1)))},p)}catch(b){b=n(b);if(b===k)throw[0,q,ams];throw b}var
m=j(amy,amx,D,r);try{var
t=function(r){var
b=s(amA),d=[0,amC,c(amB),b],e=s(amD),f=c(amE),a=[0,[0,c(amF)],f,e],g=s(amG),h=c(amH),i=[0,[0,c(amI)],h,g],j=s(amJ),k=c(amK),l=[0,[0,c(amL)],k,j],m=s(amM),n=c(amN),o=[0,[0,c(amO)],n,m],p=s(amP),q=c(amQ);return[0,[0,[0,c(amR)],q,p],o,l,i,a,d]},u=function(b){return g(amS,c9(d,i(W,10,1)))},v=e(am_,[0,function(a){function
b(o){var
b=s(amT),d=[0,amV,c(amU),b],e=s(amW),f=c(amX),a=[0,[0,c(amY)],f,e],g=s(amZ),h=c(am0),i=[0,[0,c(am1)],h,g],j=s(am2),k=c(am3),l=[0,[0,c(am4)],k,j],m=s(am5),n=c(am6);return[0,[0,[0,c(am7)],n,m],l,i,a,d]}return e(am9,[0],function(b){return g(am8,h(c9(d,i(W,10,1)),f))},b)}],u,t)}catch(b){b=n(b);if(b===k)throw[0,q,amz];throw b}var
w=j(ana,am$,function(b){return c7(aix,b)},v);try{var
x=function(b){return ck(function(b){var
d=b[3],e=a7(e6(b[2]),a),c=b[1],f=0===c[0]?[0,a7(e6(c[1]),a)]:anc;return[0,f,e,d]},w)},y=e(ane,[0],function(b){return g(and,1)},x)}catch(b){b=n(b);if(b===k)throw[0,q,anb];throw b}var
o=j(ang,anf,function(b){return c7(aiC,b)},y);try{var
z=function(g){var
c=e6(l),b=s(ani),d=a7(e6(m),a),e=ck(function(b){if(jH(c,b[2]))return s(anj);var
d=b[1];if(0===d[0]){var
e=d[1];if(dl(c,e)){var
f=b[3];return a7(bL(e,b[2]),f)}var
a=b[3];return a7(bL(c,b[2]),a)}var
g=b[3];return a7(bL(c,b[2]),g)},o),f=s(ank);return aF(bM(dk(gh(function(c,b){return dk(c,b)},f,e),d),b))},A=function(b){return g(anl,1)},B=e(anr,[0,function(c){function
b(a){var
c=e6(l),b=s(anm),d=e6(m),e=ck(function(b){if(jH(c,b[2]))return s(ann);var
d=b[1];if(0===d[0]){var
e=d[1];if(dl(c,e)){var
f=b[3];return a7(bL(e,b[2]),f)}var
a=b[3];return a7(bL(c,b[2]),a)}var
g=b[3];return a7(bL(c,b[2]),g)},o),f=s(ano);return aF(bM(dk(gh(function(c,b){return dk(c,b)},f,e),d),b))}return e(anq,[0],function(b){return g(anp,f)},b)}],A,z)}catch(b){b=n(b);if(b===k)throw[0,q,anh];throw b}return[0,j(ant,ans,D,B)]}function
oN(c){var
d=c[1],m=c[2],b=c[3],o=c[4],p=c[5];try{var
r=function(c){function
b(b){return 0}return e(anw,[0],function(b){return g(anv,1)},b)},t=function(b){return 1},v=e(anx,[0,function(b){return u(p,0)}],t,r)}catch(b){b=n(b);if(b===k)throw[0,q,anu];throw b}var
w=j(anz,any,ai,v);try{var
y=function(c){return a(b,f(anB))?0===o[0]?s(anC):s(anD):a(b,f(anE))?s(anF):a(b,f(anG))?s(anH):a(b,f(anI))?s(anJ):s(anK)},z=function(b){return g(anL,1)},A=e(anY,[0,function(d){function
c(c){return a(b,f(anM))?0===o[0]?s(anN):s(anO):a(b,f(anP))?s(anQ):a(b,f(anR))?s(anS):a(b,f(anT))?s(anU):s(anV)}return e(anX,[0],function(b){return g(anW,m)},c)}],z,y)}catch(b){b=n(b);if(b===k)throw[0,q,anA];throw b}var
B=j(an0,anZ,aS,A);try{var
D=function(d){if(aX(b,f(an2))){var
c=x(C(b,f(an3)));return a7(s(an4),c)}return s(an5)},F=function(b){return g(an6,1)},G=e(aof,[0,function(j){function
c(d){if(aX(b,f(an7))){var
c=x(C(b,f(an8)));return a7(s(an9),c)}return s(an_)}function
a(b){return g(an$,m)}return e(aoe,[0,function(a){function
c(b){return s(aoa)}return e(aod,[0],function(a){var
c=h(w,aX(b,f(aob))),e=E(d,i(aI,4,5));return g(aoc,h(h(l(d,i(W,9,1)),e),c))},c)}],a,c)}],F,D)}catch(b){b=n(b);if(b===k)throw[0,q,an1];throw b}var
H=j(aoh,aog,aS,G);try{var
I=function(b){return dk(B,H)},J=e(aok,[0],function(b){return g(aoj,1)},I)}catch(b){b=n(b);if(b===k)throw[0,q,aoi];throw b}return[0,j(aom,aol,aS,J)]}function
oO(c){var
b=c[1],d=c[2];try{var
h=function(g){if(a(b,f(aoo)))return 0===d[0]?s(aop):s(aoq);if(a(b,f(aor)))return s(aos);if(a(b,f(aot)))return s(aou);if(a(b,f(aov)))return s(aow);if(a(b,f(aox)))return s(aoy);var
c=x(C(b,f(aoz))),e=a7(s(aoA),c);return dk(s(aoB),e)},i=e(aoD,[0],function(b){return g(aoC,1)},h)}catch(b){b=n(b);if(b===k)throw[0,q,aon];throw b}return[0,j(aoF,aoE,aS,i)]}function
tN(c){var
b=c[1];try{var
d=function(q){function
c(b){throw k}function
d(b){return 0}function
j(d){function
c(b){return gb([0,61,0,0],[0,0,7,0])}return e(aoJ,[0],function(d){var
c=f(aoH);return g(aoI,a(b[1],c))},c)}function
m(d){function
c(b){return gb([0,61,0,0],[0,0,2,0])}return e(aoM,[0],function(d){var
c=f(aoK);return g(aoL,a(b[1],c))},c)}function
n(d){function
c(b){return gb([0,60,0,0],[0,0,9,0])}return e(aoP,[0],function(d){var
c=f(aoN);return g(aoO,a(b[1],c))},c)}function
o(d){function
c(b){return gb([0,60,0,0],[0,0,4,0])}return e(aoR,[0],function(d){var
c=ag(b,i(rm,12,31));return g(aoQ,h(l(b,i(rm,7,1)),c))},c)}function
p(d){function
c(b){return[0,60,0,0]}return e(aoT,[0],function(c){return g(aoS,E(b,i(rm,7,1)))},c)}return e(aoW,[0,function(d){function
c(b){return[0,62,0,0]}return e(aoV,[0],function(c){return g(aoU,l(b,i(1955,1,1)))},c)},p,o,n,m,j],d,c)},m=e(aoX,[0],function(b){return 1},d)}catch(b){b=n(b);if(b===k)throw[0,q,aoG];throw b}return[0,j(aoZ,aoY,dT,m)]}function
ao0(f){var
l=f[2],p=f[3],r=f[4],a=f[5],o=f[6],v=f[1];try{var
w=function(b){switch(v[0]){case
0:return ao2;case
1:return ao3;case
2:return ao4;case
3:return ao5;default:return ao6}},x=e(ao8,[0],function(b){return g(ao7,1)},w)}catch(b){b=n(b);if(b===k)throw[0,q,ao1];throw b}var
b=j(ao_,ao9,agB,x);try{var
y=function(f){function
c(b){throw k}function
d(b){return 0}return e(ape,[0,function(f){function
c(b){return a}function
d(d){var
c=0===b[0]?1:0;return g(apa,c)}return e(apd,[0,function(d){function
c(b){return a}return e(apc,[0],function(d){var
c=0===b[0]?0:1;return g(apb,c)},c)}],d,c)}],d,c)},z=e(apf,[0],function(b){return 1},y)}catch(b){b=n(b);if(b===k)throw[0,q,ao$];throw b}var
d=j(aph,apg,tz,z);try{var
A=function(i){function
c(b){throw k}function
f(b){return 0}function
h(d){function
c(c){switch(a[0]){case
0:var
b=a[1];return[0,aC(b,m(p,s(apj)))];case
1:return[1,aC(a[1],p)];default:return[2,a[1]]}}return e(apl,[0],function(d){var
c=0===b[0]?0:1;return g(apk,c)},c)}return e(apo,[0,function(f){function
c(b){switch(d[0]){case
0:return[0,d[1]];case
1:return[1,d[1]];default:return[2,aC(d[1],p)]}}return e(apn,[0],function(d){var
c=0===b[0]?1:0;return g(apm,c)},c)},h],f,c)},B=e(app,[0],function(b){return 1},A)}catch(b){b=n(b);if(b===k)throw[0,q,api];throw b}var
i=j(apr,apq,tz,B);try{var
C=function(p){function
f(b){throw k}function
a(b){return 0}function
j(f){function
d(f){switch(i[0]){case
0:var
b=i[1],d=s(apt);return m(b,bM(s(apu),d));case
1:var
e=i[1];return m(e,s(apv));default:return c(apw)}}return e(apy,[0],function(e){switch(l[0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}var
d=0===b[0]?0:1;return g(apx,h(d,c))},d)}function
n(a){function
f(a){switch(d[0]){case
0:var
b=d[1],e=s(apz);return m(b,bM(s(apA),e));case
1:var
f=d[1];return m(f,s(apB));default:return c(apC)}}return e(apE,[0],function(e){switch(l[0]){case
0:var
c=0;break;case
1:var
c=1;break;default:var
c=0}var
d=0===b[0]?0:1;return g(apD,h(d,c))},f)}function
o(f){function
d(e){switch(i[0]){case
0:return c(apF);case
1:return c(apG);default:var
b=i[1],d=s(apH);return m(t(b,r),d)}}return e(apJ,[0],function(e){switch(l[0]){case
0:var
c=1;break;case
1:var
c=0;break;default:var
c=0}var
d=0===b[0]?1:0;return g(apI,h(d,c))},d)}return e(apP,[0,function(a){function
f(f){switch(d[0]){case
0:return c(apK);case
1:return c(apL);default:var
b=d[1],e=s(apM);return m(t(b,r),e)}}return e(apO,[0],function(e){switch(l[0]){case
0:var
c=0;break;case
1:var
c=1;break;default:var
c=0}var
d=0===b[0]?1:0;return g(apN,h(d,c))},f)},o,n,j],a,f)},E=e(apQ,[0],function(b){return 1},C)}catch(b){b=n(b);if(b===k)throw[0,q,aps];throw b}var
u=j(apS,apR,D,E);try{var
F=function(a){function
d(b){throw k}function
f(b){return 0}return e(ap0,[0,function(a){function
d(b){return cb(o,u)?o:c(apU)}function
f(d){var
c=0===b[0]?1:0;return g(apV,c)}return e(apZ,[0,function(f){function
d(b){return cb(o,u)?o:c(apW)}return e(apY,[0],function(d){var
c=0===b[0]?0:1;return g(apX,c)},d)}],f,d)}],f,d)},G=e(ap1,[0],function(b){return 1},F)}catch(b){b=n(b);if(b===k)throw[0,q,apT];throw b}return[0,j(ap3,ap2,D,G)]}function
tO(d){var
b=d[1];try{var
f=l(b,i(W,4,1))}catch(b){b=n(b);if(b===k)throw[0,q,ap4];throw b}if(f){try{var
a=function(o){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(b){return c(ap6)}return e(ap8,[0],function(c){return g(ap7,l(b,i(aI,4,1)))},d)}function
j(f){function
d(b){return c(ap9)}return e(ap$,[0],function(d){var
c=E(b,i(aI,4,1));return g(ap_,h(l(b,i(G,4,1)),c))},d)}function
m(f){function
d(b){return c(aqa)}return e(aqc,[0],function(d){var
c=E(b,i(G,4,1));return g(aqb,h(l(b,i(U,4,1)),c))},d)}function
n(f){function
d(b){return c(aqd)}return e(aqf,[0],function(d){var
c=E(b,i(U,4,1));return g(aqe,h(l(b,i(F,4,1)),c))},d)}return e(aqj,[0,function(f){function
d(b){return c(aqg)}return e(aqi,[0],function(d){var
c=E(b,i(F,4,1));return g(aqh,h(l(b,i(W,4,1)),c))},d)},n,m,j,a],f,d)},m=e(aqk,[0],function(b){return 1},a)}catch(b){b=n(b);if(b===k)throw[0,q,ap5];throw b}return[0,j(aqm,aql,D,m)]}throw[0,bT,aqn]}function
tP(b){var
c=b[1],d=b[2],f=b[3];try{var
a=function(b){return ag(b6(0,c,f),d)},h=e(aqq,[0],function(b){return g(aqp,1)},a)}catch(b){b=n(b);if(b===k)throw[0,q,aqo];throw b}return[0,j(aqs,aqr,ai,h)]}function
oP(b){var
c=b[1],d=b[2],f=b[3];try{var
a=function(b){return c9(b6(0,c,f),d)},h=e(aqv,[0],function(b){return g(aqu,1)},a)}catch(b){b=n(b);if(b===k)throw[0,q,aqt];throw b}return[0,j(aqx,aqw,ai,h)]}function
tQ(f){var
d=f[1],b=f[2];try{var
m=l(d,i(W,1,1))}catch(b){b=n(b);if(b===k)throw[0,q,aqy];throw b}if(m){try{var
o=function(B){function
f(b){throw k}function
j(b){return 0}function
m(j){function
f(b){return c(aqA)}return e(aqD,[0],function(e){var
c=a(b,aqB);return g(aqC,h(l(d,i(aI,5,1)),c))},f)}function
n(j){function
f(b){return c(aqE)}return e(aqO,[0],function(o){var
c=H(a(b,aqG),a(b,aqF)),e=H(a(b,aqH),c),f=H(a(b,aqI),e),j=H(a(b,aqJ),f),k=H(a(b,aqK),j),m=H(a(b,aqL),k),n=H(a(b,aqM),m);return g(aqN,h(l(d,i(aI,5,1)),n))},f)}function
o(j){function
f(b){return c(aqP)}return e(aqS,[0],function(f){var
c=a(b,aqQ),e=h(E(d,i(aI,5,1)),c);return g(aqR,h(l(d,i(aI,1,1)),e))},f)}function
p(j){function
f(b){return c(aqT)}return e(aq3,[0],function(p){var
c=H(a(b,aqV),a(b,aqU)),e=H(a(b,aqW),c),f=H(a(b,aqX),e),j=H(a(b,aqY),f),k=H(a(b,aqZ),j),m=H(a(b,aq0),k),n=H(a(b,aq1),m),o=h(E(d,i(aI,5,1)),n);return g(aq2,h(l(d,i(aI,1,1)),o))},f)}function
q(j){function
f(b){return c(aq4)}return e(aq7,[0],function(f){var
c=a(b,aq5),e=h(ag(d,i(G,12,31)),c);return g(aq6,h(l(d,i(G,8,1)),e))},f)}function
r(j){function
f(b){return c(aq8)}return e(arg,[0],function(p){var
c=H(a(b,aq_),a(b,aq9)),e=H(a(b,aq$),c),f=H(a(b,ara),e),j=H(a(b,arb),f),k=H(a(b,arc),j),m=H(a(b,ard),k),n=H(a(b,are),m),o=h(ag(d,i(G,12,31)),n);return g(arf,h(l(d,i(G,8,1)),o))},f)}function
s(j){function
f(b){return c(arh)}return e(ark,[0],function(f){var
c=a(b,ari),e=h(ag(d,i(G,7,31)),c);return g(arj,h(l(d,i(G,5,1)),e))},f)}function
t(j){function
f(b){return c(arl)}return e(arv,[0],function(p){var
c=H(a(b,arn),a(b,arm)),e=H(a(b,aro),c),f=H(a(b,arp),e),j=H(a(b,arq),f),k=H(a(b,arr),j),m=H(a(b,ars),k),n=H(a(b,art),m),o=h(ag(d,i(G,7,31)),n);return g(aru,h(l(d,i(G,5,1)),o))},f)}function
u(j){function
f(b){return c(arw)}return e(arz,[0],function(f){var
c=a(b,arx),e=h(ag(d,i(G,4,30)),c);return g(ary,h(l(d,i(G,1,1)),e))},f)}function
v(j){function
f(b){return c(arA)}return e(arK,[0],function(p){var
c=H(a(b,arC),a(b,arB)),e=H(a(b,arD),c),f=H(a(b,arE),e),j=H(a(b,arF),f),k=H(a(b,arG),j),m=H(a(b,arH),k),n=H(a(b,arI),m),o=h(ag(d,i(G,4,30)),n);return g(arJ,h(l(d,i(G,1,1)),o))},f)}function
w(j){function
f(b){return c(arL)}return e(arO,[0],function(f){var
c=a(b,arM),e=h(ag(d,i(U,12,31)),c);return g(arN,h(l(d,i(U,1,1)),e))},f)}function
x(j){function
f(b){return c(arP)}return e(arZ,[0],function(p){var
c=H(a(b,arR),a(b,arQ)),e=H(a(b,arS),c),f=H(a(b,arT),e),j=H(a(b,arU),f),k=H(a(b,arV),j),m=H(a(b,arW),k),n=H(a(b,arX),m),o=h(ag(d,i(U,12,31)),n);return g(arY,h(l(d,i(U,1,1)),o))},f)}function
y(j){function
f(b){return c(ar0)}return e(ar3,[0],function(f){var
c=a(b,ar1),e=h(ag(d,i(F,12,31)),c);return g(ar2,h(l(d,i(F,1,1)),e))},f)}function
z(j){function
f(b){return c(ar4)}return e(asc,[0],function(p){var
c=H(a(b,ar6),a(b,ar5)),e=H(a(b,ar7),c),f=H(a(b,ar8),e),j=H(a(b,ar9),f),k=H(a(b,ar_),j),m=H(a(b,ar$),k),n=H(a(b,asa),m),o=h(ag(d,i(F,12,31)),n);return g(asb,h(l(d,i(F,1,1)),o))},f)}function
A(j){function
f(b){return c(asd)}return e(asg,[0],function(f){var
c=a(b,ase),e=h(ag(d,i(W,12,31)),c);return g(asf,h(l(d,i(W,1,1)),e))},f)}return e(ass,[0,function(j){function
f(b){return c(ash)}return e(asr,[0],function(p){var
c=H(a(b,asj),a(b,asi)),e=H(a(b,ask),c),f=H(a(b,asl),e),j=H(a(b,asm),f),k=H(a(b,asn),j),m=H(a(b,aso),k),n=H(a(b,asp),m),o=h(ag(d,i(W,12,31)),n);return g(asq,h(l(d,i(W,1,1)),o))},f)},A,z,y,x,w,v,u,t,s,r,q,p,o,n,m],j,f)},p=e(ast,[0],function(b){return 1},o)}catch(b){b=n(b);if(b===k)throw[0,q,aqz];throw b}return[0,j(asv,asu,D,p)]}throw[0,bT,asw]}function
tR(b){var
d=s(asx),e=c(asy);return m(fI(t(m(b,s(asz)),e)),d)}function
tS(b){return c(asA)}function
oQ(d,e,c){var
a=ag(c,i(2025,12,31)),g=h(l(c,i(G,1,1)),a);switch(e[0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=1;break;default:var
b=0}if(h(b,g)){var
j=s(asB),k=c[1],n=bM(x(C(f(asC),k)),j);return m(d,bL(s(asD),n))}return d}function
jL(o){var
J=o[1],K=o[4],y=o[5],b=o[6],p=o[7],z=o[8],d=o[9],L=o[10],V=o[2],X=o[3],Y=o[11],Z=o[12],_=o[13];try{var
$=function(c){function
b(b){return 0}return e(asG,[0],function(b){return g(asF,1)},b)},aa=function(b){return 1},ab=e(asH,[0,function(b){return u(Z,0)}],aa,$)}catch(b){b=n(b);if(b===k)throw[0,q,asE];throw b}var
ac=j(asJ,asI,ai,ab);try{var
ad=l(d,i(F,10,1))}catch(b){b=n(b);if(b===k)throw[0,q,asK];throw b}if(ad){try{var
ae=function(b){return d},af=j(asP,asO,aK,e(asN,[0],function(b){return g(asM,1)},ae))}catch(b){b=n(b);if(b===k)throw[0,q,asL];throw b}try{var
ag=function(b){return J},ah=j(asU,asT,cc,e(asS,[0],function(b){return g(asR,1)},ag))}catch(b){b=n(b);if(b===k)throw[0,q,asQ];throw b}var
aj=O(asW,u(Q(asV,gi),[0,af,ah]))[1];try{var
ak=function(b){return c(asY)},al=e(as0,[0],function(b){return g(asZ,l(d,i(W,10,1)))},ak)}catch(b){b=n(b);if(b===k)throw[0,q,asX];throw b}var
am=j(as2,as1,D,al);try{var
an=function(b){return c(as4)},ao=e(as6,[0],function(b){return g(as5,l(d,i(W,10,1)))},an)}catch(b){b=n(b);if(b===k)throw[0,q,as3];throw b}var
M=j(as8,as7,D,ao);try{var
ap=function(r){function
j(b){throw k}function
n(b){return 0}function
o(k){function
j(k){switch(z[0]){case
0:if(a(b,f(as_)))return 0===p[0]?c(as$):c(ata);if(a(b,f(atb)))return c(atc);if(a(b,f(atd)))return c(ate);if(a(b,f(atf)))return c(atg);var
d=x(C(b,f(ath))),e=m(c(ati),d);return t(c(atj),e);case
1:if(a(b,f(atk)))return 0===p[0]?c(atl):c(atm);if(a(b,f(atn)))return c(ato);if(a(b,f(atp)))return c(atq);if(a(b,f(atr)))return c(ats);var
g=x(C(b,f(att))),h=m(c(atu),g);return t(c(atv),h);default:if(a(b,f(atw)))return 0===p[0]?c(atx):c(aty);if(a(b,f(atz)))return c(atA);if(a(b,f(atB)))return c(atC);if(a(b,f(atD)))return c(atE);var
i=x(C(b,f(atF))),j=m(c(atG),i);return t(c(atH),j)}}return e(atJ,[0],function(c){var
b=l(d,i(F,10,1));return g(atI,h(E(d,i(U,10,1)),b))},j)}function
q(k){function
j(k){switch(z[0]){case
0:if(a(b,f(atK)))return 0===p[0]?c(atL):c(atM);if(a(b,f(atN)))return c(atO);if(a(b,f(atP)))return c(atQ);if(a(b,f(atR)))return c(atS);var
d=x(C(b,f(atT))),e=m(c(atU),d);return t(c(atV),e);case
1:if(a(b,f(atW)))return 0===p[0]?c(atX):c(atY);if(a(b,f(atZ)))return c(at0);if(a(b,f(at1)))return c(at2);if(a(b,f(at3)))return c(at4);var
g=x(C(b,f(at5))),h=m(c(at6),g);return t(c(at7),h);default:if(a(b,f(at8)))return 0===p[0]?c(at9):c(at_);if(a(b,f(at$)))return c(aua);if(a(b,f(aub)))return c(auc);if(a(b,f(aud)))return c(aue);var
i=x(C(b,f(auf))),j=m(c(aug),i);return t(c(auh),j)}}return e(auj,[0],function(c){var
b=E(d,i(G,7,1));return g(aui,h(l(d,i(U,10,1)),b))},j)}return e(auW,[0,function(j){function
h(k){switch(z[0]){case
0:if(a(b,f(auk)))return 0===p[0]?c(aul):c(aum);if(a(b,f(aun)))return c(auo);if(a(b,f(aup)))return c(auq);if(a(b,f(aur)))return c(aus);var
d=x(C(b,f(aut))),e=m(c(auu),d);return t(c(auv),e);case
1:if(a(b,f(auw)))return 0===p[0]?c(aux):c(auy);if(a(b,f(auz)))return c(auA);if(a(b,f(auB)))return c(auC);if(a(b,f(auD)))return c(auE);var
g=x(C(b,f(auF))),h=m(c(auG),g);return t(c(auH),h);default:if(a(b,f(auI)))return 0===p[0]?c(auJ):c(auK);if(a(b,f(auL)))return c(auM);if(a(b,f(auN)))return c(auO);if(a(b,f(auP)))return c(auQ);var
i=x(C(b,f(auR))),j=m(c(auS),i);return t(c(auT),j)}}return e(auV,[0],function(b){return g(auU,l(d,i(G,7,1)))},h)},q,o],n,j)},aq=e(auX,[0],function(b){return 1},ap)}catch(b){b=n(b);if(b===k)throw[0,q,as9];throw b}var
A=j(auZ,auY,D,aq);try{var
ar=function(b){return c(au1)},as=e(au3,[0],function(b){return g(au2,l(d,i(W,10,1)))},ar)}catch(b){b=n(b);if(b===k)throw[0,q,au0];throw b}var
N=j(au5,au4,D,as);try{var
at=function(f){function
b(c){switch(X[0]){case
0:var
b=0;break;case
1:var
b=l(K,i(cU,12,31));break;case
2:var
b=0;break;default:var
b=0}return H(h(V,l(K,i(1990,9,30))),b)}function
c(b){return g(au7,1)}return e(au_,[0,function(c){function
b(b){return 0}return e(au9,[0],function(c){switch(J[0]){case
0:var
b=1;break;case
1:var
b=1;break;case
2:var
b=1;break;case
3:var
b=1;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=0;break;default:var
b=1}return g(au8,h(l(d,i(aI,4,5)),b))},b)}],c,b)},au=function(b){return 1},av=e(au$,[0,function(b){return u(Y,0)}],au,at)}catch(b){b=n(b);if(b===k)throw[0,q,au6];throw b}var
r=j(avb,ava,ai,av),aw=j(avi,avh,ay,function(b){try{var
d=function(e){var
d=c(avd);return cb(aC(b,M),d)?aC(b,M):c(ave)},f=e(avg,[0],function(b){return g(avf,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,avc];throw b}});try{var
ax=function(b){return cb(L,A)?A:L},az=e(avl,[0],function(b){return g(avk,1)},ax)}catch(b){b=n(b);if(b===k)throw[0,q,avj];throw b}var
B=j(avn,avm,D,az);try{var
aA=function(b){return d},aB=j(avs,avr,aK,e(avq,[0],function(b){return g(avp,1)},aA))}catch(b){b=n(b);if(b===k)throw[0,q,avo];throw b}try{var
aD=function(b){return r},aE=j(avx,avw,ai,e(avv,[0],function(b){return g(avu,1)},aD))}catch(b){b=n(b);if(b===k)throw[0,q,avt];throw b}try{var
aF=function(c){return b},aG=j(avC,avB,bA,e(avA,[0],function(b){return g(avz,1)},aF))}catch(b){b=n(b);if(b===k)throw[0,q,avy];throw b}try{var
aH=function(b){return p},aJ=j(avH,avG,cS,e(avF,[0],function(b){return g(avE,1)},aH))}catch(b){b=n(b);if(b===k)throw[0,q,avD];throw b}var
aL=[0,aB,aE,aG,aJ,function(c){function
b(b){return 1}return j(avL,avK,ai,e(avJ,[0],function(c){var
b=E(d,i(aI,4,5));return g(avI,h(h(l(d,i(W,9,1)),b),ac))},b))}],aM=O(avN,u(Q(avM,oN),aL))[1];try{var
aN=function(b){return r?c(avP):c(avQ)},aO=e(avS,[0],function(b){return g(avR,l(d,i(W,10,1)))},aN)}catch(b){b=n(b);if(b===k)throw[0,q,avO];throw b}var
P=j(avU,avT,D,aO);try{var
aP=function(b){return r?c(avW):c(avX)},aQ=e(avZ,[0],function(b){return g(avY,l(d,i(W,10,1)))},aP)}catch(b){b=n(b);if(b===k)throw[0,q,avV];throw b}var
I=j(av1,av0,D,aQ),aR=j(av6,av5,ay,function(b){try{var
c=function(c){return aC(B,b)},d=e(av4,[0],function(b){return g(av3,1)},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,av2];throw b}});try{var
aT=function(c){function
b(b){return aM}return e(av9,[0],function(b){return g(av8,1)},b)},aU=function(b){return 1},aV=e(av_,[0,function(b){return u(_,0)}],aU,aT)}catch(b){b=n(b);if(b===k)throw[0,q,av7];throw b}var
v=j(awa,av$,aS,aV),aW=j(awm,awl,ay,function(d){try{var
b=function(f){var
e=j(awd,awc,D,d),b=O(awh,j(awg,awf,D,u(Q(awe,aR),e)));return bU(b,P)?aC(P,b):c(awi)},f=e(awk,[0],function(b){return g(awj,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,awb];throw b}});try{var
aX=function(b){return d},aY=j(awr,awq,aK,e(awp,[0],function(b){return g(awo,1)},aX))}catch(b){b=n(b);if(b===k)throw[0,q,awn];throw b}try{var
aZ=function(b){return y},a0=j(aww,awv,D,e(awu,[0],function(b){return g(awt,1)},aZ))}catch(b){b=n(b);if(b===k)throw[0,q,aws];throw b}try{var
a1=function(b){return r},a2=j(awB,awA,ai,e(awz,[0],function(b){return g(awy,1)},a1))}catch(b){b=n(b);if(b===k)throw[0,q,awx];throw b}try{var
a3=function(b){return v},a4=j(awG,awF,aS,e(awE,[0],function(b){return g(awD,1)},a3))}catch(b){b=n(b);if(b===k)throw[0,q,awC];throw b}var
a5=O(awI,u(Q(awH,hX),[0,aY,a0,a2,a4]))[1];try{var
a6=function(f){var
b=aC(y,m(N,v)),d=cw(b,c(awK))?c(awL):b,e=fJ(d,m(I,v));return bL(s(awM),e)},a8=function(b){return g(awN,1)},a9=e(awR,[0,function(c){function
b(c){var
b=fJ(y,m(I,v));return bL(s(awO),b)}return e(awQ,[0],function(b){return g(awP,r)},b)}],a8,a6)}catch(b){b=n(b);if(b===k)throw[0,q,awJ];throw b}var
R=j(awT,awS,aS,a9),a_=j(axa,aw$,ay,function(f){try{var
b=function(g){var
e=j(awW,awV,D,f),b=O(aw0,j(awZ,awY,D,u(Q(awX,aw),e))),a=j(aw2,aw1,D,b),d=aC(b,O(aw6,j(aw5,aw4,D,u(Q(aw3,aW),a))));return cb(d,c(aw7))?d:c(aw8)},d=e(aw_,[0],function(b){return g(aw9,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,awU];throw b}});try{var
a$=function(b){return a5},ba=e(axd,[0],function(b){return g(axc,1)},a$)}catch(b){b=n(b);if(b===k)throw[0,q,axb];throw b}var
S=j(axf,axe,D,ba);try{var
bb=function(d){var
b=s(axh),c=s(axi);return bM(eB(a7(bL(R,s(axj)),c)),b)},bc=function(b){return g(axk,1)},bd=e(axq,[0,function(c){function
b(d){var
b=s(axl),c=s(axm);return bM(eB(a7(bL(R,s(axn)),c)),b)}return e(axp,[0],function(b){return g(axo,r)},b)}],bc,bb)}catch(b){b=n(b);if(b===k)throw[0,q,axg];throw b}var
w=j(axs,axr,aS,bd),be=j(axM,axL,ay,function(f){try{var
b=function(k){var
a=j(axv,axu,D,f),d=O(axz,j(axy,axx,D,u(Q(axw,a_),a))),g=j(axB,axA,D,d),b=O(axF,j(axE,axD,D,u(Q(axC,aj),g))),h=c(axG),e=fI(aC(aC(d,b),h)),i=c(axH);return cb(t(e,b),i)?t(e,b):c(axI)},d=e(axK,[0],function(b){return g(axJ,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,axt];throw b}});try{var
bf=function(b){return dl(w,s(axO))?s(axP):w},bg=function(b){return g(axQ,1)},bh=e(axV,[0,function(c){function
b(b){return dl(w,s(axR))?s(axS):w}return e(axU,[0],function(b){return g(axT,r)},b)}],bg,bf)}catch(b){b=n(b);if(b===k)throw[0,q,axN];throw b}var
T=j(axX,axW,aS,bh),bi=j(ax9,ax8,ay,function(d){try{var
b=function(f){var
e=j(ax0,axZ,D,d),b=O(ax4,j(ax3,ax2,D,u(Q(ax1,be),e)));return cw(b,am)?c(ax5):b},f=e(ax7,[0],function(b){return g(ax6,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,axY];throw b}});try{var
bj=function(d){var
b=m(aC(B,S),T);return cw(b,c(ax$))?c(aya):b},bk=e(ayc,[0],function(b){return g(ayb,1)},bj)}catch(b){b=n(b);if(b===k)throw[0,q,ax_];throw b}return[0,I,N,v,B,A,S,T,j(aye,ayd,D,bk),bi]}throw[0,bT,ayf]}function
tT(w){var
z=w[1],A=w[2],b=w[3],d=w[4],L=w[5],K=w[6],B=w[9],v=w[11],r=w[12],p=w[13],o=w[14],aa=w[7],ab=w[8],ac=w[10],ad=w[15];try{var
ae=function(c){var
b=s(ayh);return bM(s(ayi),b)},af=e(ayk,[0],function(b){return g(ayj,1)},ae)}catch(b){b=n(b);if(b===k)throw[0,q,ayg];throw b}var
y=j(aym,ayl,aS,af);try{var
ah=function(c){return b},aj=j(ayr,ayq,bA,e(ayp,[0],function(b){return g(ayo,1)},ah))}catch(b){b=n(b);if(b===k)throw[0,q,ayn];throw b}try{var
ak=function(b){return d},al=j(ayw,ayv,cS,e(ayu,[0],function(b){return g(ayt,1)},ak))}catch(b){b=n(b);if(b===k)throw[0,q,ays];throw b}var
am=O(ayy,u(Q(ayx,oO),[0,aj,al]))[1];try{var
an=l(o,i(F,10,1))}catch(b){b=n(b);if(b===k)throw[0,q,ayz];throw b}if(an){try{var
ao=function(b){return s(ayB)},ap=e(ayD,[0],function(b){return g(ayC,l(o,i(W,10,1)))},ao)}catch(b){b=n(b);if(b===k)throw[0,q,ayA];throw b}var
aq=j(ayF,ayE,aS,ap);try{var
ar=function(b){return s(ayH)},as=e(ayJ,[0],function(b){return g(ayI,l(o,i(W,10,1)))},ar)}catch(b){b=n(b);if(b===k)throw[0,q,ayG];throw b}var
N=j(ayL,ayK,aS,as);try{var
at=function(b){return c(ayN)},au=e(ayP,[0],function(b){return g(ayO,l(o,i(W,10,1)))},at)}catch(b){b=n(b);if(b===k)throw[0,q,ayM];throw b}var
av=j(ayR,ayQ,D,au);try{var
aw=function(b){return s(ayT)},ax=e(ayV,[0],function(b){return g(ayU,l(o,i(W,10,1)))},aw)}catch(b){b=n(b);if(b===k)throw[0,q,ayS];throw b}var
P=j(ayX,ayW,aS,ax);try{var
az=function(b){return c(ayZ)},aA=e(ay1,[0],function(b){return g(ay0,l(o,i(W,10,1)))},az)}catch(b){b=n(b);if(b===k)throw[0,q,ayY];throw b}var
aB=j(ay3,ay2,D,aA);try{var
aD=function(b){return 0===p[0]?ag(K,i(lk,10,1))?s(ay5):s(ay6):0===p[1][0]?s(ay7):ag(K,i(lk,10,1))?s(ay8):s(ay9)},aE=e(ay$,[0],function(b){return g(ay_,l(o,i(W,10,1)))},aD)}catch(b){b=n(b);if(b===k)throw[0,q,ay4];throw b}var
R=j(azb,aza,aS,aE);try{var
aG=function(b){return c(azd)},aH=e(azf,[0],function(b){return g(aze,l(o,i(W,10,1)))},aG)}catch(b){b=n(b);if(b===k)throw[0,q,azc];throw b}var
aJ=j(azh,azg,D,aH);try{var
aL=function(b){return c(azj)},aM=e(azl,[0],function(b){return g(azk,l(o,i(W,10,1)))},aL)}catch(b){b=n(b);if(b===k)throw[0,q,azi];throw b}var
S=j(azn,azm,D,aM);try{var
aN=function(n){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(f){var
d=x(b),e=m(c(azp),d);return t(c(azq),e)}return e(azs,[0],function(c){var
b=l(o,i(F,10,1));return g(azr,h(E(o,i(U,10,1)),b))},d)}function
j(f){function
d(f){var
d=x(b),e=m(c(azt),d);return t(c(azu),e)}return e(azw,[0],function(c){var
b=E(o,i(G,7,1));return g(azv,h(l(o,i(U,10,1)),b))},d)}return e(azB,[0,function(f){function
d(f){var
d=x(b),e=m(c(azx),d);return t(c(azy),e)}return e(azA,[0],function(b){return g(azz,l(o,i(G,7,1)))},d)},j,a],f,d)},aO=function(b){return 1},aP=e(azT,[0,function(a){function
f(p){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(g){var
e=x(b),f=m(c(azC),e),a=0===d[0]?c(azD):c(azE);return t(a,f)}return e(azG,[0],function(c){var
b=l(o,i(F,10,1));return g(azF,h(h(E(o,i(U,10,1)),b),B))},f)}function
n(a){function
f(g){var
e=x(b),f=m(c(azH),e),a=0===d[0]?c(azI):c(azJ);return t(a,f)}return e(azL,[0],function(c){var
b=E(o,i(G,7,1));return g(azK,h(h(l(o,i(U,10,1)),b),B))},f)}return e(azR,[0,function(a){function
f(g){var
e=x(b),f=m(c(azM),e),a=0===d[0]?c(azN):c(azO);return t(a,f)}return e(azQ,[0],function(b){return g(azP,h(l(o,i(G,7,1)),B))},f)},n,j],a,f)}return e(azS,[0],function(b){return 1},f)}],aO,aN)}catch(b){b=n(b);if(b===k)throw[0,q,azo];throw b}var
T=j(azV,azU,D,aP);try{var
aQ=function(b){return o},aR=j(az0,azZ,aK,e(azY,[0],function(b){return g(azX,1)},aQ))}catch(b){b=n(b);if(b===k)throw[0,q,azW];throw b}try{var
aT=function(b){return ad},aU=j(az5,az4,cc,e(az3,[0],function(b){return g(az2,1)},aT))}catch(b){b=n(b);if(b===k)throw[0,q,az1];throw b}var
aV=O(az7,u(Q(az6,gi),[0,aR,aU]))[1],M=j(aNu,aNt,ay,function(j){try{var
s=function(b){throw k},u=function(b){return g(az9,0)},w=function(q){function
n(z){function
n(b){throw k}function
q(b){return 0}function
s(n){function
k(n){switch(v[0]){case
0:if(a(b,f(az_)))var
e=0===d[0]?c(az$):c(aAa);else
var
g=x(C(b,f(aAb))),h=m(c(aAc),g),e=t(c(aAd),h);break;case
1:if(a(b,f(aAe)))var
e=0===d[0]?c(aAf):c(aAg);else
var
i=x(C(b,f(aAh))),j=m(c(aAi),i),e=t(c(aAj),j);break;default:if(a(b,f(aAk)))var
e=0===d[0]?c(aAl):c(aAm);else
var
k=x(C(b,f(aAn))),l=m(c(aAo),k),e=t(c(aAp),l)}return m(e,y)}return e(aAr,[0],function(f){switch(r[0]){case
0:var
b=1;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(l(j,i(cU,11,27)),d);return g(aAq,h(l(o,i(W,10,1)),e))},k)}function
u(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aAs)))var
e=0===d[0]?c(aAt):c(aAu);else
var
g=x(C(b,f(aAv))),h=m(c(aAw),g),e=t(c(aAx),h);break;case
1:if(a(b,f(aAy)))var
e=0===d[0]?c(aAz):c(aAA);else
var
i=x(C(b,f(aAB))),j=m(c(aAC),i),e=t(c(aAD),j);break;default:if(a(b,f(aAE)))var
e=0===d[0]?c(aAF):c(aAG);else
var
k=x(C(b,f(aAH))),l=m(c(aAI),k),e=t(c(aAJ),l)}return m(e,y)}return e(aAL,[0],function(f){switch(r[0]){case
0:var
b=1;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(l(j,i(cU,11,27)),d);return g(aAK,h(l(o,i(W,10,1)),e))},k)}function
w(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aAM)))var
e=0===d[0]?c(aAN):c(aAO);else
var
g=x(C(b,f(aAP))),h=m(c(aAQ),g),e=t(c(aAR),h);break;case
1:if(a(b,f(aAS)))var
e=0===d[0]?c(aAT):c(aAU);else
var
i=x(C(b,f(aAV))),j=m(c(aAW),i),e=t(c(aAX),j);break;default:if(a(b,f(aAY)))var
e=0===d[0]?c(aAZ):c(aA0);else
var
k=x(C(b,f(aA1))),l=m(c(aA2),k),e=t(c(aA3),l)}return m(e,y)}return e(aA5,[0],function(a){switch(r[0]){case
0:var
b=1;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(cU,11,27)),d),f=h(l(j,i(fg,6,30)),e);return g(aA4,h(l(o,i(W,10,1)),f))},k)}return e(aBo,[0,function(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aA6)))var
e=0===d[0]?c(aA7):c(aA8);else
var
g=x(C(b,f(aA9))),h=m(c(aA_),g),e=t(c(aA$),h);break;case
1:if(a(b,f(aBa)))var
e=0===d[0]?c(aBb):c(aBc);else
var
i=x(C(b,f(aBd))),j=m(c(aBe),i),e=t(c(aBf),j);break;default:if(a(b,f(aBg)))var
e=0===d[0]?c(aBh):c(aBi);else
var
k=x(C(b,f(aBj))),l=m(c(aBk),k),e=t(c(aBl),l)}return m(e,y)}return e(aBn,[0],function(a){switch(r[0]){case
0:var
b=1;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(cU,11,27)),d),f=h(l(j,i(fg,6,30)),e);return g(aBm,h(l(o,i(W,10,1)),f))},k)},w,u,s],q,n)}return e(aBp,[0],function(b){return 1},n)},z=e(aNs,[0,function(s){function
n(ak){function
n(b){throw k}function
q(b){return 0}function
s(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aBq)))return 0===d[0]?c(aBr):c(aBs);var
e=x(C(b,f(aBt))),g=m(c(aBu),e);return t(c(aBv),g);case
1:if(a(b,f(aBw)))return 0===d[0]?c(aBx):c(aBy);var
h=x(C(b,f(aBz))),i=m(c(aBA),h);return t(c(aBB),i);default:if(a(b,f(aBC)))return 0===d[0]?c(aBD):c(aBE);var
j=x(C(b,f(aBF))),k=m(c(aBG),j);return t(c(aBH),k)}}return e(aBJ,[0],function(a){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(l(j,i(W,9,30)),d),f=h(l(o,i(F,10,1)),e);return g(aBI,h(l(o,i(W,10,1)),f))},k)}function
u(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aBK)))return 0===d[0]?c(aBL):c(aBM);var
e=x(C(b,f(aBN))),g=m(c(aBO),e);return t(c(aBP),g);case
1:if(a(b,f(aBQ)))return 0===d[0]?c(aBR):c(aBS);var
h=x(C(b,f(aBT))),i=m(c(aBU),h);return t(c(aBV),i);default:if(a(b,f(aBW)))return 0===d[0]?c(aBX):c(aBY);var
j=x(C(b,f(aBZ))),k=m(c(aB0),j);return t(c(aB1),k)}}return e(aB3,[0],function(a){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(l(j,i(W,9,30)),d),f=h(l(o,i(F,10,1)),e);return g(aB2,h(l(o,i(W,10,1)),f))},k)}function
w(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aB4)))return 0===d[0]?c(aB5):c(aB6);var
e=x(C(b,f(aB7))),g=m(c(aB8),e);return t(c(aB9),g);case
1:if(a(b,f(aB_)))return 0===d[0]?c(aB$):c(aCa);var
h=x(C(b,f(aCb))),i=m(c(aCc),h);return t(c(aCd),i);default:if(a(b,f(aCe)))return 0===d[0]?c(aCf):c(aCg);var
j=x(C(b,f(aCh))),k=m(c(aCi),j);return t(c(aCj),k)}}return e(aCl,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(W,9,30)),d),f=h(l(j,i(cJ,9,30)),e),a=h(l(o,i(F,10,1)),f);return g(aCk,h(l(o,i(W,10,1)),a))},k)}function
z(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aCm)))return 0===d[0]?c(aCn):c(aCo);var
e=x(C(b,f(aCp))),g=m(c(aCq),e);return t(c(aCr),g);case
1:if(a(b,f(aCs)))return 0===d[0]?c(aCt):c(aCu);var
h=x(C(b,f(aCv))),i=m(c(aCw),h);return t(c(aCx),i);default:if(a(b,f(aCy)))return 0===d[0]?c(aCz):c(aCA);var
j=x(C(b,f(aCB))),k=m(c(aCC),j);return t(c(aCD),k)}}return e(aCF,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(W,9,30)),d),f=h(l(j,i(cJ,9,30)),e),a=h(l(o,i(F,10,1)),f);return g(aCE,h(l(o,i(W,10,1)),a))},k)}function
A(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aCG)))return 0===d[0]?c(aCH):c(aCI);var
e=x(C(b,f(aCJ))),g=m(c(aCK),e);return t(c(aCL),g);case
1:if(a(b,f(aCM)))return 0===d[0]?c(aCN):c(aCO);var
h=x(C(b,f(aCP))),i=m(c(aCQ),h);return t(c(aCR),i);default:if(a(b,f(aCS)))return 0===d[0]?c(aCT):c(aCU);var
j=x(C(b,f(aCV))),k=m(c(aCW),j);return t(c(aCX),k)}}return e(aCZ,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(cJ,9,30)),d),f=h(l(j,i(dK,9,30)),e),a=h(l(o,i(F,10,1)),f);return g(aCY,h(l(o,i(W,10,1)),a))},k)}function
B(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aC0)))return 0===d[0]?c(aC1):c(aC2);var
e=x(C(b,f(aC3))),g=m(c(aC4),e);return t(c(aC5),g);case
1:if(a(b,f(aC6)))return 0===d[0]?c(aC7):c(aC8);var
h=x(C(b,f(aC9))),i=m(c(aC_),h);return t(c(aC$),i);default:if(a(b,f(aDa)))return 0===d[0]?c(aDb):c(aDc);var
j=x(C(b,f(aDd))),k=m(c(aDe),j);return t(c(aDf),k)}}return e(aDh,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(cJ,9,30)),d),f=h(l(j,i(dK,9,30)),e),a=h(l(o,i(F,10,1)),f);return g(aDg,h(l(o,i(W,10,1)),a))},k)}function
D(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aDi)))return 0===d[0]?c(aDj):c(aDk);var
e=x(C(b,f(aDl))),g=m(c(aDm),e);return t(c(aDn),g);case
1:if(a(b,f(aDo)))return 0===d[0]?c(aDp):c(aDq);var
h=x(C(b,f(aDr))),i=m(c(aDs),h);return t(c(aDt),i);default:if(a(b,f(aDu)))return 0===d[0]?c(aDv):c(aDw);var
j=x(C(b,f(aDx))),k=m(c(aDy),j);return t(c(aDz),k)}}return e(aDB,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(dK,9,30)),d),f=h(l(j,i(dn,9,30)),e),a=h(l(o,i(F,10,1)),f);return g(aDA,h(l(o,i(W,10,1)),a))},k)}function
G(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aDC)))return 0===d[0]?c(aDD):c(aDE);var
e=x(C(b,f(aDF))),g=m(c(aDG),e);return t(c(aDH),g);case
1:if(a(b,f(aDI)))return 0===d[0]?c(aDJ):c(aDK);var
h=x(C(b,f(aDL))),i=m(c(aDM),h);return t(c(aDN),i);default:if(a(b,f(aDO)))return 0===d[0]?c(aDP):c(aDQ);var
j=x(C(b,f(aDR))),k=m(c(aDS),j);return t(c(aDT),k)}}return e(aDV,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(dK,9,30)),d),f=h(l(j,i(dn,9,30)),e),a=h(l(o,i(F,10,1)),f);return g(aDU,h(l(o,i(W,10,1)),a))},k)}function
H(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aDW)))return 0===d[0]?c(aDX):c(aDY);var
e=x(C(b,f(aDZ))),g=m(c(aD0),e);return t(c(aD1),g);case
1:if(a(b,f(aD2)))return 0===d[0]?c(aD3):c(aD4);var
h=x(C(b,f(aD5))),i=m(c(aD6),h);return t(c(aD7),i);default:if(a(b,f(aD8)))return 0===d[0]?c(aD9):c(aD_);var
j=x(C(b,f(aD$))),k=m(c(aEa),j);return t(c(aEb),k)}}return e(aEd,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(dn,9,30)),d),f=h(l(j,i(dB,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aEc,h(l(o,i(W,10,1)),a))},k)}function
I(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aEe)))return 0===d[0]?c(aEf):c(aEg);var
e=x(C(b,f(aEh))),g=m(c(aEi),e);return t(c(aEj),g);case
1:if(a(b,f(aEk)))return 0===d[0]?c(aEl):c(aEm);var
h=x(C(b,f(aEn))),i=m(c(aEo),h);return t(c(aEp),i);default:if(a(b,f(aEq)))return 0===d[0]?c(aEr):c(aEs);var
j=x(C(b,f(aEt))),k=m(c(aEu),j);return t(c(aEv),k)}}return e(aEx,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(dn,9,30)),d),f=h(l(j,i(dB,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aEw,h(l(o,i(W,10,1)),a))},k)}function
J(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aEy)))return 0===d[0]?c(aEz):c(aEA);var
e=x(C(b,f(aEB))),g=m(c(aEC),e);return t(c(aED),g);case
1:if(a(b,f(aEE)))return 0===d[0]?c(aEF):c(aEG);var
h=x(C(b,f(aEH))),i=m(c(aEI),h);return t(c(aEJ),i);default:if(a(b,f(aEK)))return 0===d[0]?c(aEL):c(aEM);var
j=x(C(b,f(aEN))),k=m(c(aEO),j);return t(c(aEP),k)}}return e(aER,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(dB,12,31)),d),f=h(l(j,i(dG,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aEQ,h(l(o,i(W,10,1)),a))},k)}function
K(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aES)))return 0===d[0]?c(aET):c(aEU);var
e=x(C(b,f(aEV))),g=m(c(aEW),e);return t(c(aEX),g);case
1:if(a(b,f(aEY)))return 0===d[0]?c(aEZ):c(aE0);var
h=x(C(b,f(aE1))),i=m(c(aE2),h);return t(c(aE3),i);default:if(a(b,f(aE4)))return 0===d[0]?c(aE5):c(aE6);var
j=x(C(b,f(aE7))),k=m(c(aE8),j);return t(c(aE9),k)}}return e(aE$,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(dB,12,31)),d),f=h(l(j,i(dG,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aE_,h(l(o,i(W,10,1)),a))},k)}function
L(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aFa)))return 0===d[0]?c(aFb):c(aFc);var
e=x(C(b,f(aFd))),g=m(c(aFe),e);return t(c(aFf),g);case
1:if(a(b,f(aFg)))return 0===d[0]?c(aFh):c(aFi);var
h=x(C(b,f(aFj))),i=m(c(aFk),h);return t(c(aFl),i);default:if(a(b,f(aFm)))return 0===d[0]?c(aFn):c(aFo);var
j=x(C(b,f(aFp))),k=m(c(aFq),j);return t(c(aFr),k)}}return e(aFt,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(dG,12,31)),d),f=h(l(j,i(fP,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aFs,h(l(o,i(W,10,1)),a))},k)}function
M(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aFu)))return 0===d[0]?c(aFv):c(aFw);var
e=x(C(b,f(aFx))),g=m(c(aFy),e);return t(c(aFz),g);case
1:if(a(b,f(aFA)))return 0===d[0]?c(aFB):c(aFC);var
h=x(C(b,f(aFD))),i=m(c(aFE),h);return t(c(aFF),i);default:if(a(b,f(aFG)))return 0===d[0]?c(aFH):c(aFI);var
j=x(C(b,f(aFJ))),k=m(c(aFK),j);return t(c(aFL),k)}}return e(aFN,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(dG,12,31)),d),f=h(l(j,i(fP,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aFM,h(l(o,i(W,10,1)),a))},k)}function
N(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aFO)))return 0===d[0]?c(aFP):c(aFQ);var
e=x(C(b,f(aFR))),g=m(c(aFS),e);return t(c(aFT),g);case
1:if(a(b,f(aFU)))return 0===d[0]?c(aFV):c(aFW);var
h=x(C(b,f(aFX))),i=m(c(aFY),h);return t(c(aFZ),i);default:if(a(b,f(aF0)))return 0===d[0]?c(aF1):c(aF2);var
j=x(C(b,f(aF3))),k=m(c(aF4),j);return t(c(aF5),k)}}return e(aF7,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(fP,12,31)),d),f=h(l(j,i(gH,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aF6,h(l(o,i(W,10,1)),a))},k)}function
O(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aF8)))return 0===d[0]?c(aF9):c(aF_);var
e=x(C(b,f(aF$))),g=m(c(aGa),e);return t(c(aGb),g);case
1:if(a(b,f(aGc)))return 0===d[0]?c(aGd):c(aGe);var
h=x(C(b,f(aGf))),i=m(c(aGg),h);return t(c(aGh),i);default:if(a(b,f(aGi)))return 0===d[0]?c(aGj):c(aGk);var
j=x(C(b,f(aGl))),k=m(c(aGm),j);return t(c(aGn),k)}}return e(aGp,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(fP,12,31)),d),f=h(l(j,i(gH,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aGo,h(l(o,i(W,10,1)),a))},k)}function
P(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aGq)))return 0===d[0]?c(aGr):c(aGs);var
e=x(C(b,f(aGt))),g=m(c(aGu),e);return t(c(aGv),g);case
1:if(a(b,f(aGw)))return 0===d[0]?c(aGx):c(aGy);var
h=x(C(b,f(aGz))),i=m(c(aGA),h);return t(c(aGB),i);default:if(a(b,f(aGC)))return 0===d[0]?c(aGD):c(aGE);var
j=x(C(b,f(aGF))),k=m(c(aGG),j);return t(c(aGH),k)}}return e(aGJ,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(gH,12,31)),d),f=h(l(j,i(fV,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aGI,h(l(o,i(W,10,1)),a))},k)}function
Q(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aGK)))return 0===d[0]?c(aGL):c(aGM);var
e=x(C(b,f(aGN))),g=m(c(aGO),e);return t(c(aGP),g);case
1:if(a(b,f(aGQ)))return 0===d[0]?c(aGR):c(aGS);var
h=x(C(b,f(aGT))),i=m(c(aGU),h);return t(c(aGV),i);default:if(a(b,f(aGW)))return 0===d[0]?c(aGX):c(aGY);var
j=x(C(b,f(aGZ))),k=m(c(aG0),j);return t(c(aG1),k)}}return e(aG3,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(gH,12,31)),d),f=h(l(j,i(fV,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aG2,h(l(o,i(W,10,1)),a))},k)}function
R(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aG4)))return 0===d[0]?c(aG5):c(aG6);var
e=x(C(b,f(aG7))),g=m(c(aG8),e);return t(c(aG9),g);case
1:if(a(b,f(aG_)))return 0===d[0]?c(aG$):c(aHa);var
h=x(C(b,f(aHb))),i=m(c(aHc),h);return t(c(aHd),i);default:if(a(b,f(aHe)))return 0===d[0]?c(aHf):c(aHg);var
j=x(C(b,f(aHh))),k=m(c(aHi),j);return t(c(aHj),k)}}return e(aHl,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(fV,12,31)),d),f=h(l(j,i(f2,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aHk,h(l(o,i(W,10,1)),a))},k)}function
S(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aHm)))return 0===d[0]?c(aHn):c(aHo);var
e=x(C(b,f(aHp))),g=m(c(aHq),e);return t(c(aHr),g);case
1:if(a(b,f(aHs)))return 0===d[0]?c(aHt):c(aHu);var
h=x(C(b,f(aHv))),i=m(c(aHw),h);return t(c(aHx),i);default:if(a(b,f(aHy)))return 0===d[0]?c(aHz):c(aHA);var
j=x(C(b,f(aHB))),k=m(c(aHC),j);return t(c(aHD),k)}}return e(aHF,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(fV,12,31)),d),f=h(l(j,i(f2,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aHE,h(l(o,i(W,10,1)),a))},k)}function
T(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aHG)))return 0===d[0]?c(aHH):c(aHI);var
e=x(C(b,f(aHJ))),g=m(c(aHK),e);return t(c(aHL),g);case
1:if(a(b,f(aHM)))return 0===d[0]?c(aHN):c(aHO);var
h=x(C(b,f(aHP))),i=m(c(aHQ),h);return t(c(aHR),i);default:if(a(b,f(aHS)))return 0===d[0]?c(aHT):c(aHU);var
j=x(C(b,f(aHV))),k=m(c(aHW),j);return t(c(aHX),k)}}return e(aHZ,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(f2,12,31)),d),f=h(l(j,i(lG,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aHY,h(l(o,i(W,10,1)),a))},k)}function
U(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aH0)))return 0===d[0]?c(aH1):c(aH2);var
e=x(C(b,f(aH3))),g=m(c(aH4),e);return t(c(aH5),g);case
1:if(a(b,f(aH6)))return 0===d[0]?c(aH7):c(aH8);var
h=x(C(b,f(aH9))),i=m(c(aH_),h);return t(c(aH$),i);default:if(a(b,f(aIa)))return 0===d[0]?c(aIb):c(aIc);var
j=x(C(b,f(aId))),k=m(c(aIe),j);return t(c(aIf),k)}}return e(aIh,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(f2,12,31)),d),f=h(l(j,i(lG,12,31)),e),a=h(l(o,i(F,10,1)),f);return g(aIg,h(l(o,i(W,10,1)),a))},k)}function
V(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aIi)))return 0===d[0]?c(aIj):c(aIk);var
e=x(C(b,f(aIl))),g=m(c(aIm),e);return t(c(aIn),g);case
1:if(a(b,f(aIo)))return 0===d[0]?c(aIp):c(aIq);var
h=x(C(b,f(aIr))),i=m(c(aIs),h);return t(c(aIt),i);default:if(a(b,f(aIu)))return 0===d[0]?c(aIv):c(aIw);var
j=x(C(b,f(aIx))),k=m(c(aIy),j);return t(c(aIz),k)}}return e(aIB,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(lG,12,31)),d),f=h(l(j,i(g8,8,31)),e),a=h(l(o,i(F,10,1)),f);return g(aIA,h(l(o,i(W,10,1)),a))},k)}function
X(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aIC)))return 0===d[0]?c(aID):c(aIE);var
e=x(C(b,f(aIF))),g=m(c(aIG),e);return t(c(aIH),g);case
1:if(a(b,f(aII)))return 0===d[0]?c(aIJ):c(aIK);var
h=x(C(b,f(aIL))),i=m(c(aIM),h);return t(c(aIN),i);default:if(a(b,f(aIO)))return 0===d[0]?c(aIP):c(aIQ);var
j=x(C(b,f(aIR))),k=m(c(aIS),j);return t(c(aIT),k)}}return e(aIV,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(lG,12,31)),d),f=h(l(j,i(g8,8,31)),e),a=h(l(o,i(F,10,1)),f);return g(aIU,h(l(o,i(W,10,1)),a))},k)}function
Y(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aIW)))return 0===d[0]?c(aIX):c(aIY);var
e=x(C(b,f(aIZ))),g=m(c(aI0),e);return t(c(aI1),g);case
1:if(a(b,f(aI2)))return 0===d[0]?c(aI3):c(aI4);var
h=x(C(b,f(aI5))),i=m(c(aI6),h);return t(c(aI7),i);default:if(a(b,f(aI8)))return 0===d[0]?c(aI9):c(aI_);var
j=x(C(b,f(aI$))),k=m(c(aJa),j);return t(c(aJb),k)}}return e(aJd,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(g8,8,31)),d),f=h(l(j,i(gu,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aJc,h(l(o,i(W,10,1)),a))},k)}function
Z(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aJe)))return 0===d[0]?c(aJf):c(aJg);var
e=x(C(b,f(aJh))),g=m(c(aJi),e);return t(c(aJj),g);case
1:if(a(b,f(aJk)))return 0===d[0]?c(aJl):c(aJm);var
h=x(C(b,f(aJn))),i=m(c(aJo),h);return t(c(aJp),i);default:if(a(b,f(aJq)))return 0===d[0]?c(aJr):c(aJs);var
j=x(C(b,f(aJt))),k=m(c(aJu),j);return t(c(aJv),k)}}return e(aJx,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(g8,8,31)),d),f=h(l(j,i(gu,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aJw,h(l(o,i(W,10,1)),a))},k)}function
_(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aJy)))return 0===d[0]?c(aJz):c(aJA);var
e=x(C(b,f(aJB))),g=m(c(aJC),e);return t(c(aJD),g);case
1:if(a(b,f(aJE)))return 0===d[0]?c(aJF):c(aJG);var
h=x(C(b,f(aJH))),i=m(c(aJI),h);return t(c(aJJ),i);default:if(a(b,f(aJK)))return 0===d[0]?c(aJL):c(aJM);var
j=x(C(b,f(aJN))),k=m(c(aJO),j);return t(c(aJP),k)}}return e(aJR,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(gu,6,30)),d),f=h(l(j,i(en,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aJQ,h(l(o,i(W,10,1)),a))},k)}function
$(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aJS)))return 0===d[0]?c(aJT):c(aJU);var
e=x(C(b,f(aJV))),g=m(c(aJW),e);return t(c(aJX),g);case
1:if(a(b,f(aJY)))return 0===d[0]?c(aJZ):c(aJ0);var
h=x(C(b,f(aJ1))),i=m(c(aJ2),h);return t(c(aJ3),i);default:if(a(b,f(aJ4)))return 0===d[0]?c(aJ5):c(aJ6);var
j=x(C(b,f(aJ7))),k=m(c(aJ8),j);return t(c(aJ9),k)}}return e(aJ$,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(gu,6,30)),d),f=h(l(j,i(en,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aJ_,h(l(o,i(W,10,1)),a))},k)}function
aa(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aKa)))return 0===d[0]?c(aKb):c(aKc);var
e=x(C(b,f(aKd))),g=m(c(aKe),e);return t(c(aKf),g);case
1:if(a(b,f(aKg)))return 0===d[0]?c(aKh):c(aKi);var
h=x(C(b,f(aKj))),i=m(c(aKk),h);return t(c(aKl),i);default:if(a(b,f(aKm)))return 0===d[0]?c(aKn):c(aKo);var
j=x(C(b,f(aKp))),k=m(c(aKq),j);return t(c(aKr),k)}}return e(aKt,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(en,6,30)),d),f=h(l(j,i(en,1,1)),e),a=h(l(o,i(F,10,1)),f);return g(aKs,h(l(o,i(W,10,1)),a))},k)}function
ab(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aKu)))var
e=0===d[0]?c(aKv):c(aKw);else
var
g=x(C(b,f(aKx))),h=m(c(aKy),g),e=t(c(aKz),h);break;case
1:if(a(b,f(aKA)))var
e=0===d[0]?c(aKB):c(aKC);else
var
i=x(C(b,f(aKD))),j=m(c(aKE),i),e=t(c(aKF),j);break;default:if(a(b,f(aKG)))var
e=0===d[0]?c(aKH):c(aKI);else
var
k=x(C(b,f(aKJ))),l=m(c(aKK),k),e=t(c(aKL),l)}return m(e,y)}return e(aKN,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(fa,12,31)),d),f=h(l(j,i(fa,7,1)),e),a=h(l(o,i(F,10,1)),f);return g(aKM,h(l(o,i(W,10,1)),a))},k)}function
ac(n){function
k(l){switch(v[0]){case
0:if(a(b,f(aKO)))return 0===d[0]?c(aKP):c(aKQ);var
e=x(C(b,f(aKR))),g=m(c(aKS),e);return t(c(aKT),g);case
1:if(a(b,f(aKU)))return 0===d[0]?c(aKV):c(aKW);var
h=x(C(b,f(aKX))),i=m(c(aKY),h);return t(c(aKZ),i);default:if(a(b,f(aK0)))return 0===d[0]?c(aK1):c(aK2);var
j=x(C(b,f(aK3))),k=m(c(aK4),j);return t(c(aK5),k)}}return e(aK7,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(en,6,30)),d),f=h(l(j,i(en,1,1)),e),a=h(l(o,i(F,10,1)),f);return g(aK6,h(l(o,i(W,10,1)),a))},k)}function
ad(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aK8)))var
e=0===d[0]?c(aK9):c(aK_);else
var
g=x(C(b,f(aK$))),h=m(c(aLa),g),e=t(c(aLb),h);break;case
1:if(a(b,f(aLc)))var
e=0===d[0]?c(aLd):c(aLe);else
var
i=x(C(b,f(aLf))),j=m(c(aLg),i),e=t(c(aLh),j);break;default:if(a(b,f(aLi)))var
e=0===d[0]?c(aLj):c(aLk);else
var
k=x(C(b,f(aLl))),l=m(c(aLm),k),e=t(c(aLn),l)}return m(e,y)}return e(aLp,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(fa,12,31)),d),f=h(l(j,i(fa,7,1)),e),a=h(l(o,i(F,10,1)),f);return g(aLo,h(l(o,i(W,10,1)),a))},k)}function
ae(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aLq)))var
e=0===d[0]?c(aLr):c(aLs);else
var
g=x(C(b,f(aLt))),h=m(c(aLu),g),e=t(c(aLv),h);break;case
1:if(a(b,f(aLw)))var
e=0===d[0]?c(aLx):c(aLy);else
var
i=x(C(b,f(aLz))),j=m(c(aLA),i),e=t(c(aLB),j);break;default:if(a(b,f(aLC)))var
e=0===d[0]?c(aLD):c(aLE);else
var
k=x(C(b,f(aLF))),l=m(c(aLG),k),e=t(c(aLH),l)}return m(e,y)}return e(aLJ,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(ag(j,i(fa,6,30)),d),f=h(l(j,i(he,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aLI,h(l(o,i(W,10,1)),a))},k)}function
af(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aLK)))var
e=0===d[0]?c(aLL):c(aLM);else
var
g=x(C(b,f(aLN))),h=m(c(aLO),g),e=t(c(aLP),h);break;case
1:if(a(b,f(aLQ)))var
e=0===d[0]?c(aLR):c(aLS);else
var
i=x(C(b,f(aLT))),j=m(c(aLU),i),e=t(c(aLV),j);break;default:if(a(b,f(aLW)))var
e=0===d[0]?c(aLX):c(aLY);else
var
k=x(C(b,f(aLZ))),l=m(c(aL0),k),e=t(c(aL1),l)}return m(e,y)}return e(aL3,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(ag(j,i(fa,6,30)),d),f=h(l(j,i(he,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aL2,h(l(o,i(W,10,1)),a))},k)}function
ah(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aL4)))var
e=0===d[0]?c(aL5):c(aL6);else
var
g=x(C(b,f(aL7))),h=m(c(aL8),g),e=t(c(aL9),h);break;case
1:if(a(b,f(aL_)))var
e=0===d[0]?c(aL$):c(aMa);else
var
i=x(C(b,f(aMb))),j=m(c(aMc),i),e=t(c(aMd),j);break;default:if(a(b,f(aMe)))var
e=0===d[0]?c(aMf):c(aMg);else
var
k=x(C(b,f(aMh))),l=m(c(aMi),k),e=t(c(aMj),l)}return m(e,y)}return e(aMl,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(he,6,30)),d),f=h(l(j,i(cU,11,27)),e),a=h(l(o,i(F,10,1)),f);return g(aMk,h(l(o,i(W,10,1)),a))},k)}function
ai(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aMm)))var
e=0===d[0]?c(aMn):c(aMo);else
var
g=x(C(b,f(aMp))),h=m(c(aMq),g),e=t(c(aMr),h);break;case
1:if(a(b,f(aMs)))var
e=0===d[0]?c(aMt):c(aMu);else
var
i=x(C(b,f(aMv))),j=m(c(aMw),i),e=t(c(aMx),j);break;default:if(a(b,f(aMy)))var
e=0===d[0]?c(aMz):c(aMA);else
var
k=x(C(b,f(aMB))),l=m(c(aMC),k),e=t(c(aMD),l)}return m(e,y)}return e(aMF,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(he,6,30)),d),f=h(l(j,i(cU,11,27)),e),a=h(l(o,i(F,10,1)),f);return g(aME,h(l(o,i(W,10,1)),a))},k)}function
aj(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aMG)))var
e=0===d[0]?c(aMH):c(aMI);else
var
g=x(C(b,f(aMJ))),h=m(c(aMK),g),e=t(c(aML),h);break;case
1:if(a(b,f(aMM)))var
e=0===d[0]?c(aMN):c(aMO);else
var
i=x(C(b,f(aMP))),j=m(c(aMQ),i),e=t(c(aMR),j);break;default:if(a(b,f(aMS)))var
e=0===d[0]?c(aMT):c(aMU);else
var
k=x(C(b,f(aMV))),l=m(c(aMW),k),e=t(c(aMX),l)}return m(e,y)}return e(aMZ,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?0:1,d=h(c,b),e=h(E(j,i(cU,11,27)),d),f=h(l(j,i(fg,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aMY,h(l(o,i(W,10,1)),a))},k)}return e(aNi,[0,function(n){function
k(n){switch(v[0]){case
0:if(a(b,f(aM0)))var
e=0===d[0]?c(aM1):c(aM2);else
var
g=x(C(b,f(aM3))),h=m(c(aM4),g),e=t(c(aM5),h);break;case
1:if(a(b,f(aM6)))var
e=0===d[0]?c(aM7):c(aM8);else
var
i=x(C(b,f(aM9))),j=m(c(aM_),i),e=t(c(aM$),j);break;default:if(a(b,f(aNa)))var
e=0===d[0]?c(aNb):c(aNc);else
var
k=x(C(b,f(aNd))),l=m(c(aNe),k),e=t(c(aNf),l)}return m(e,y)}return e(aNh,[0],function(k){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}var
c=0===p[0]?1:0,d=h(c,b),e=h(E(j,i(cU,11,27)),d),f=h(l(j,i(fg,6,30)),e),a=h(l(o,i(F,10,1)),f);return g(aNg,h(l(o,i(W,10,1)),a))},k)},aj,ai,ah,af,ae,ad,ac,ab,aa,$,_,Z,Y,X,V,U,T,S,R,Q,P,O,N,M,L,K,J,I,H,G,D,B,A,z,w,u,s],q,n)}function
q(b){return 1}return e(aNr,[0,function(n){function
k(i){if(a(b,f(aNj)))var
e=0===d[0]?c(aNk):c(aNl);else
var
g=x(C(b,f(aNm))),h=m(c(aNn),g),e=t(c(aNo),h);return m(e,y)}return e(aNq,[0],function(m){switch(r[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;case
3:var
b=0;break;default:var
b=0}if(0===p[0])var
c=0;else
var
k=0===p[1][0]?1:0,c=k;var
d=h(c,b),e=h(ag(j,i(cU,11,27)),d),f=h(l(j,i(fg,6,30)),e),a=h(l(o,i(aI,1,1)),f);return g(aNp,h(l(o,i(W,10,1)),a))},k)}],q,n)},w],u,s);return z}catch(b){b=n(b);if(b===k)throw[0,q,az8];throw b}});try{var
aW=function(b){return am},aX=e(aNx,[0],function(b){return g(aNw,1)},aW)}catch(b){b=n(b);if(b===k)throw[0,q,aNv];throw b}var
I=j(aNz,aNy,aS,aX);try{var
aY=function(b){return bU(A,m(z,P))?m(z,P):A},a0=function(b){return g(aNB,1)},a1=e(aNE,[0,function(c){function
b(b){return A}return e(aND,[0],function(b){return g(aNC,ac)},b)}],a0,aY)}catch(b){b=n(b);if(b===k)throw[0,q,aNA];throw b}var
V=j(aNG,aNF,D,a1),a2=j(aNN,aNM,ay,function(b){try{var
d=function(e){var
d=c(aNI);return cb(aC(b,S),d)?aC(b,S):c(aNJ)},f=e(aNL,[0],function(b){return g(aNK,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,aNH];throw b}}),a3=j(aNU,aNT,ay,function(b){try{var
c=function(c){return aC(z,b)},d=function(b){return g(aNP,1)},f=e(aNS,[0,function(d){function
c(c){return aC(t(z,T),b)}return e(aNR,[0],function(b){return g(aNQ,l(K,i(kH,6,30)))},c)}],d,c);return f}catch(b){b=n(b);if(b===k)throw[0,q,aNO];throw b}});try{var
a4=function(c){var
b=j(aNX,aNW,aK,K);return O(aN1,j(aN0,aNZ,D,u(Q(aNY,M),b)))},a5=function(b){return g(aN2,1)},a6=e(aOf,[0,function(c){function
b(f){var
d=j(aN4,aN3,aK,K),b=O(aN8,j(aN7,aN6,D,u(Q(aN5,M),d))),e=j(aN_,aN9,aK,ab),c=O(aOc,j(aOb,aOa,D,u(Q(aN$,M),e)));return cw(b,c)?c:b}return e(aOe,[0],function(b){return g(aOd,aa)},b)}],a5,a4)}catch(b){b=n(b);if(b===k)throw[0,q,aNV];throw b}var
J=j(aOh,aOg,D,a6);try{var
a8=function(b){return o},a9=j(aOm,aOl,aK,e(aOk,[0],function(b){return g(aOj,1)},a8))}catch(b){b=n(b);if(b===k)throw[0,q,aOi];throw b}try{var
a_=function(b){return A},a$=j(aOr,aOq,D,e(aOp,[0],function(b){return g(aOo,1)},a_))}catch(b){b=n(b);if(b===k)throw[0,q,aOn];throw b}try{var
ba=function(b){return 0},bb=j(aOw,aOv,ai,e(aOu,[0],function(b){return g(aOt,1)},ba))}catch(b){b=n(b);if(b===k)throw[0,q,aOs];throw b}try{var
bc=function(b){return I},bd=j(aOB,aOA,aS,e(aOz,[0],function(b){return g(aOy,1)},bc))}catch(b){b=n(b);if(b===k)throw[0,q,aOx];throw b}var
be=O(aOD,u(Q(aOC,hX),[0,a9,a$,bb,bd]))[1];try{var
bf=function(c){var
b=fJ(A,m(aB,I));return bL(s(aOF),b)},bg=e(aOH,[0],function(b){return g(aOG,1)},bf)}catch(b){b=n(b);if(b===k)throw[0,q,aOE];throw b}var
bh=j(aOJ,aOI,aS,bg),bi=j(aOV,aOU,ay,function(d){try{var
b=function(f){var
e=j(aOM,aOL,D,d),b=O(aOQ,j(aOP,aOO,D,u(Q(aON,a3),e)));return bU(b,m(V,R))?aC(m(V,R),b):c(aOR)},f=e(aOT,[0],function(b){return g(aOS,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,aOK];throw b}});try{var
bj=function(d){function
b(b){throw k}function
c(b){return 0}return e(aO6,[0,function(d){function
b(b){return B?m(J,s(aOX)):J}function
c(b){return g(aOY,l(o,i(G,7,1)))}return e(aO5,[0,function(d){function
b(b){return B?m(J,s(aOZ)):J}function
c(c){var
b=E(o,i(G,7,1));return g(aO0,h(l(o,i(U,10,1)),b))}return e(aO4,[0,function(c){function
b(b){return B?m(J,s(aO1)):J}return e(aO3,[0],function(c){var
b=l(o,i(F,10,1));return g(aO2,h(E(o,i(U,10,1)),b))},b)}],c,b)}],c,b)}],c,b)},bk=e(aO7,[0],function(b){return 1},bj)}catch(b){b=n(b);if(b===k)throw[0,q,aOW];throw b}var
X=j(aO9,aO8,D,bk);try{var
bl=function(f){function
b(b){throw k}function
c(b){return 0}function
d(c){function
b(b){return be}return e(aPa,[0],function(c){switch(L[0]){case
0:var
b=0;break;case
1:var
b=1;break;default:var
b=0}return g(aO$,b)},b)}return e(aPf,[0,function(c){function
b(a){var
b=e6(A),c=e6(av),d=s(aPb),e=jH(b,a7(c,I))?a7(b,N):a7(a7(c,I),N),f=dl(b,a7(c,I))?a7(bL(b,a7(c,I)),aq):s(aPc);return aF(bM(dk(f,e),d))}return e(aPe,[0],function(d){switch(L[0]){case
0:var
b=0;break;case
1:var
b=0;break;default:var
b=1}switch(L[0]){case
0:var
c=1;break;case
1:var
c=0;break;default:var
c=0}return g(aPd,H(c,b))},b)},d],c,b)},bm=e(aPg,[0],function(b){return 1},bl)}catch(b){b=n(b);if(b===k)throw[0,q,aO_];throw b}var
Y=j(aPi,aPh,D,bm);try{var
bn=function(d){var
b=s(aPk),c=s(aPl);return bM(eB(a7(bL(bh,s(aPm)),c)),b)},bo=e(aPo,[0],function(b){return g(aPn,1)},bn)}catch(b){b=n(b);if(b===k)throw[0,q,aPj];throw b}var
Z=j(aPq,aPp,aS,bo),bp=j(aPJ,aPI,ay,function(f){try{var
b=function(g){var
e=j(aPt,aPs,D,f),b=O(aPx,j(aPw,aPv,D,u(Q(aPu,a2),e))),a=j(aPz,aPy,D,b),d=aC(b,O(aPD,j(aPC,aPB,D,u(Q(aPA,bi),a))));return cb(d,c(aPE))?d:c(aPF)},d=e(aPH,[0],function(b){return g(aPG,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,aPr];throw b}});try{var
bq=function(b){return aZ(z,X)?X:z},br=e(aPM,[0],function(b){return g(aPL,1)},bq)}catch(b){b=n(b);if(b===k)throw[0,q,aPK];throw b}var
_=j(aPO,aPN,D,br);try{var
bs=function(b){return dl(Z,s(aPQ))?s(aPR):Z},bt=e(aPT,[0],function(b){return g(aPS,1)},bs)}catch(b){b=n(b);if(b===k)throw[0,q,aPP];throw b}var
$=j(aPV,aPU,aS,bt),bu=j(aQd,aQc,ay,function(f){try{var
b=function(k){var
a=j(aPY,aPX,D,f),d=O(aP2,j(aP1,aP0,D,u(Q(aPZ,bp),a))),g=j(aP4,aP3,D,d),b=O(aP8,j(aP7,aP6,D,u(Q(aP5,aV),g))),h=c(aP9),e=fI(aC(aC(d,b),h)),i=c(aP_);return cb(t(e,b),i)?t(e,b):c(aP$)},d=e(aQb,[0],function(b){return g(aQa,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,aPW];throw b}});try{var
bv=function(d){var
b=m(aC(t(_,T),Y),$);return cw(b,c(aQf))?c(aQg):b},bw=e(aQi,[0],function(b){return g(aQh,1)},bv)}catch(b){b=n(b);if(b===k)throw[0,q,aQe];throw b}var
bx=j(aQk,aQj,D,bw);return[0,_,Y,$,bx,j(aQw,aQv,ay,function(d){try{var
b=function(f){var
e=j(aQn,aQm,D,d),b=O(aQr,j(aQq,aQp,D,u(Q(aQo,bu),e)));return cw(b,aJ)?c(aQs):b},f=e(aQu,[0],function(b){return g(aQt,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,aQl];throw b}})]}throw[0,bT,aQx]}function
oR(c){var
d=c[1],b=c[2],p=c[3];try{var
r=function(c){function
b(b){return[0,20,0,0]}return e(aQA,[0],function(b){return g(aQz,1)},b)},t=function(b){return 1},v=e(aQB,[0,function(b){return u(p,0)}],t,r)}catch(b){b=n(b);if(b===k)throw[0,q,aQy];throw b}var
f=j(aQD,aQC,dT,v);try{var
w=function(b){return d},x=j(aQI,aQH,aK,e(aQG,[0],function(b){return g(aQF,1)},w))}catch(b){b=n(b);if(b===k)throw[0,q,aQE];throw b}try{var
y=function(c){return b},z=j(aQN,aQM,cc,e(aQL,[0],function(b){return g(aQK,1)},y))}catch(b){b=n(b);if(b===k)throw[0,q,aQJ];throw b}var
i=O(aQP,u(Q(aQO,tQ),[0,x,z]))[1];try{var
A=function(b){return 0},B=function(b){return g(aQR,1)},C=e(aQ0,[0,function(d){function
c(b){return 1}return e(aQZ,[0],function(h){var
c=H(a(b,aQT),a(b,aQS)),d=H(a(b,aQU),c),e=H(a(b,aQV),d),f=H(a(b,aQW),e);return g(aQY,H(a(b,aQX),f))},c)}],B,A)}catch(b){b=n(b);if(b===k)throw[0,q,aQQ];throw b}var
l=j(aQ2,aQ1,ai,C);try{var
E=function(c){var
b=s(aQ4);return m(m(i,s(aQ5)),b)},F=function(b){return g(aQ6,1)},G=e(aQ$,[0,function(c){function
b(c){var
b=s(aQ7);return m(m(i,s(aQ8)),b)}return e(aQ_,[0],function(b){return g(aQ9,l)},b)}],F,E)}catch(b){b=n(b);if(b===k)throw[0,q,aQ3];throw b}var
o=j(aRb,aRa,D,G),I=j(aRi,aRh,ay,function(b){try{var
c=function(b){return 0},d=function(b){return g(aRd,1)},f=e(aRg,[0,function(d){function
c(b){return 1}return e(aRf,[0],function(i){var
f=bU(b[3],o);switch(b[2][0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}switch(b[2][0]){case
0:var
d=0;break;case
1:var
d=1;break;default:var
d=0}var
a=H(d,c);switch(b[2][0]){case
0:var
e=1;break;case
1:var
e=0;break;default:var
e=0}return g(aRe,h(H(e,a),f))},c)}],d,c);return f}catch(b){b=n(b);if(b===k)throw[0,q,aRc];throw b}});return[0,f,j(aRA,aRz,ay,function(b){try{var
c=function(b){return 0},a=function(b){return g(aRk,1)},i=e(aRy,[0,function(a){function
c(i){function
c(b){throw k}function
a(b){return 0}return e(aRw,[0,function(i){function
c(b){return 1}function
a(e){switch(b[2][0]){case
0:var
c=0;break;case
1:var
c=1;break;default:var
c=0}switch(b[2][0]){case
0:var
d=1;break;case
1:var
d=0;break;default:var
d=0}return g(aRl,H(d,c))}return e(aRv,[0,function(a){function
c(b){return 1}return e(aRu,[0],function(l){var
e=j(aRn,aRm,tM,[0,b[4],d,f]),a=[0,u(Q(aRo,oP),e)[1]];g(aRp,1);var
i=O(aRs,j(aRr,aRq,tF,a))[1],k=h(bU(b[3],o),i);switch(b[2][0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}return g(aRt,h(c,k))},c)}],a,c)}],a,c)}return e(aRx,[0],function(b){return 1},c)}],a,c);return i}catch(b){b=n(b);if(b===k)throw[0,q,aRj];throw b}}),I,l]}function
oS(z){var
V=z[1],b=z[4],d=z[5],o=z[6],r=z[7],J=z[8],N=z[9],y=z[11],X=z[12],p=z[14],ab=z[2],ac=z[3],ad=z[10],ae=z[13];try{var
af=function(b){return s(aRC)},ah=e(aRE,[0],function(b){return g(aRD,1)},af)}catch(b){b=n(b);if(b===k)throw[0,q,aRB];throw b}var
L=j(aRG,aRF,aS,ah);try{var
ai=l(b,i(F,10,1))}catch(b){b=n(b);if(b===k)throw[0,q,aRH];throw b}if(ai){try{var
aj=function(b){return c(aRJ)},ak=e(aRL,[0],function(c){return g(aRK,l(b,i(W,10,1)))},aj)}catch(b){b=n(b);if(b===k)throw[0,q,aRI];throw b}var
Y=j(aRN,aRM,D,ak);try{var
al=aL(d,f(aRP))}catch(b){b=n(b);if(b===k)throw[0,q,aRO];throw b}if(al){try{var
am=function(a){function
c(b){throw k}function
f(b){return 0}return e(aRX,[0,function(a){function
c(b){return x(d)}function
f(c){return g(aRR,l(b,i(G,7,1)))}return e(aRW,[0,function(a){function
c(b){return x(d)}function
f(d){var
c=E(b,i(G,7,1));return g(aRS,h(l(b,i(U,10,1)),c))}return e(aRV,[0,function(f){function
c(b){return x(d)}return e(aRU,[0],function(d){var
c=l(b,i(F,10,1));return g(aRT,h(E(b,i(U,10,1)),c))},c)}],f,c)}],f,c)}],f,c)},an=e(aRY,[0],function(b){return 1},am)}catch(b){b=n(b);if(b===k)throw[0,q,aRQ];throw b}var
H=j(aR0,aRZ,aS,an);try{var
ao=function(b){switch(ad[0]){case
0:return c(aR2);case
1:return c(aR3);default:return c(aR4)}},ap=e(aR6,[0],function(c){return g(aR5,l(b,i(W,10,1)))},ao)}catch(b){b=n(b);if(b===k)throw[0,q,aR1];throw b}var
aq=j(aR8,aR7,D,ap);try{var
ar=1-h(J,y)}catch(b){b=n(b);if(b===k)throw[0,q,aR9];throw b}if(ar){try{var
as=function(c){if(ae){var
b=s(aR$);return m(V,bM(s(aSa),b))}return V},at=e(aSc,[0],function(b){return g(aSb,1)},as)}catch(b){b=n(b);if(b===k)throw[0,q,aR_];throw b}var
K=j(aSe,aSd,D,at);try{var
au=function(c){return b},av=j(aSj,aSi,aK,e(aSh,[0],function(b){return g(aSg,1)},au))}catch(b){b=n(b);if(b===k)throw[0,q,aSf];throw b}try{var
aw=function(b){return p},ax=j(aSo,aSn,cc,e(aSm,[0],function(b){return g(aSl,1)},aw))}catch(b){b=n(b);if(b===k)throw[0,q,aSk];throw b}var
az=O(aSq,u(Q(aSp,gi),[0,av,ax]))[1];try{var
aA=function(m){function
c(b){throw k}function
j(b){return 0}return e(aTo,[0,function(k){function
c(e){if(a(d,f(aSs)))return 0===o[0]?s(aSt):s(aSu);if(a(d,f(aSv)))return s(aSw);if(a(d,f(aSx)))return s(aSy);if(a(d,f(aSz)))return s(aSA);if(a(d,f(aSB)))return s(aSC);if(a(d,f(aSD)))return s(aSE);if(a(d,f(aSF)))return s(aSG);var
b=x(C(d,f(aSH))),c=a7(s(aSI),b);return bL(s(aSJ),c)}function
j(c){return g(aSK,l(b,i(G,7,1)))}return e(aTn,[0,function(k){function
c(e){if(a(d,f(aSL)))return 0===o[0]?s(aSM):s(aSN);if(a(d,f(aSO)))return s(aSP);if(a(d,f(aSQ)))return s(aSR);if(a(d,f(aSS)))return s(aST);if(a(d,f(aSU)))return s(aSV);if(a(d,f(aSW)))return s(aSX);if(a(d,f(aSY)))return s(aSZ);var
b=x(C(d,f(aS0))),c=a7(s(aS1),b);return bL(s(aS2),c)}function
j(d){var
c=E(b,i(G,7,1));return g(aS3,h(l(b,i(U,10,1)),c))}return e(aTm,[0,function(j){function
c(e){if(a(d,f(aS4)))return 0===o[0]?s(aS5):s(aS6);if(a(d,f(aS7)))return s(aS8);if(a(d,f(aS9)))return s(aS_);if(a(d,f(aS$)))return s(aTa);if(a(d,f(aTb)))return s(aTc);if(a(d,f(aTd)))return s(aTe);if(a(d,f(aTf)))return s(aTg);var
b=x(C(d,f(aTh))),c=a7(s(aTi),b);return bL(s(aTj),c)}return e(aTl,[0],function(d){var
c=E(b,i(U,10,1));return g(aTk,h(l(b,i(F,10,1)),c))},c)}],j,c)}],j,c)}],j,c)},aB=function(b){return 1},aD=e(aU3,[0,function(j){function
c(n){function
c(b){throw k}function
j(b){return 0}function
m(k){function
c(b){return a(d,f(aTp))?0===o[0]?s(aTq):s(aTr):a(d,f(aTs))?s(aTt):a(d,f(aTu))?s(aTv):a(d,f(aTw))?s(aTx):a(d,f(aTy))?s(aTz):a(d,f(aTA))?s(aTB):s(aTC)}function
j(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(aI,1,1));return g(aTD,h(h(l(b,i(G,7,1)),d),c))}return e(aUE,[0,function(k){function
c(b){return a(d,f(aTE))?0===o[0]?s(aTF):s(aTG):a(d,f(aTH))?s(aTI):a(d,f(aTJ))?s(aTK):a(d,f(aTL))?s(aTM):a(d,f(aTN))?s(aTO):a(d,f(aTP))?s(aTQ):s(aTR)}function
j(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,7,1));return g(aTS,h(h(l(b,i(G,1,1)),d),c))}return e(aUD,[0,function(k){function
c(b){return a(d,f(aTT))?0===o[0]?s(aTU):s(aTV):a(d,f(aTW))?s(aTX):a(d,f(aTY))?s(aTZ):a(d,f(aT0))?s(aT1):a(d,f(aT2))?s(aT3):a(d,f(aT4))?s(aT5):s(aT6)}function
j(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,1,1));return g(aT7,h(h(l(b,i(U,10,1)),d),c))}return e(aUC,[0,function(k){function
c(b){return a(d,f(aT8))?0===o[0]?s(aT9):s(aT_):a(d,f(aT$))?s(aUa):a(d,f(aUb))?s(aUc):a(d,f(aUd))?s(aUe):a(d,f(aUf))?s(aUg):a(d,f(aUh))?s(aUi):s(aUj)}function
j(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(U,10,1));return g(aUk,h(h(l(b,i(F,10,1)),d),c))}return e(aUB,[0,function(j){function
c(b){return a(d,f(aUl))?0===o[0]?s(aUm):s(aUn):a(d,f(aUo))?s(aUp):a(d,f(aUq))?s(aUr):a(d,f(aUs))?s(aUt):a(d,f(aUu))?s(aUv):a(d,f(aUw))?s(aUx):s(aUy)}return e(aUA,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(F,10,1));return g(aUz,h(h(l(b,i(F,1,1)),d),c))},c)}],j,c)}],j,c)}],j,c)}],j,c)}return e(aU1,[0,function(j){function
c(e){if(a(d,f(aUF)))return 0===o[0]?s(aUG):s(aUH);if(a(d,f(aUI)))return s(aUJ);if(a(d,f(aUK)))return s(aUL);if(a(d,f(aUM)))return s(aUN);if(a(d,f(aUO)))return s(aUP);if(a(d,f(aUQ)))return s(aUR);if(a(d,f(aUS)))return s(aUT);if(a(d,f(aUU)))return s(aUV);var
b=x(C(d,f(aUW))),c=a7(s(aUX),b);return bL(s(aUY),c)}return e(aU0,[0],function(d){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(aUZ,h(l(b,i(aI,1,1)),c))},c)},m],j,c)}return e(aU2,[0],function(b){return 1},c)}],aB,aA)}catch(b){b=n(b);if(b===k)throw[0,q,aSr];throw b}var
Z=j(aU5,aU4,aS,aD);try{var
aE=function(j){function
c(b){throw k}function
a(b){return 0}return e(aVh,[0,function(j){function
c(b){return x(C(d,f(aU7)))}function
a(c){return g(aU8,l(b,i(aI,1,1)))}return e(aVg,[0,function(j){function
c(b){return x(C(d,f(aU9)))}function
a(d){var
c=ag(b,i(G,12,31));return g(aU_,h(l(b,i(G,7,1)),c))}return e(aVf,[0,function(j){function
c(b){return x(C(d,f(aU$)))}function
a(d){var
c=E(b,i(G,7,1));return g(aVa,h(l(b,i(G,1,1)),c))}return e(aVe,[0,function(a){function
c(b){return x(C(d,f(aVb)))}return e(aVd,[0],function(d){var
c=l(b,i(F,1,1));return g(aVc,h(E(b,i(G,1,1)),c))},c)}],a,c)}],a,c)}],a,c)}],a,c)},aF=function(b){return 1},aG=e(aVE,[0,function(a){function
c(j){function
c(b){throw k}function
a(b){return 0}return e(aVC,[0,function(j){function
c(b){return s(aVi)}function
a(k){var
e=aL(d,f(aVj));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(aI,1,1));return g(aVk,h(h(l(b,i(G,7,1)),j),a))}return e(aVB,[0,function(j){function
c(b){return s(aVl)}function
a(k){var
e=aL(d,f(aVm));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,7,1));return g(aVn,h(h(l(b,i(G,1,1)),j),a))}return e(aVA,[0,function(j){function
c(b){return s(aVo)}function
a(k){var
e=aL(d,f(aVp));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,1,1));return g(aVq,h(h(l(b,i(U,10,1)),j),a))}return e(aVz,[0,function(j){function
c(b){return s(aVr)}function
a(k){var
e=aL(d,f(aVs));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(U,10,1));return g(aVt,h(h(l(b,i(F,10,1)),j),a))}return e(aVy,[0,function(a){function
c(b){return s(aVu)}return e(aVx,[0],function(k){var
e=aL(d,f(aVv));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(F,10,1));return g(aVw,h(h(l(b,i(F,1,1)),j),a))},c)}],a,c)}],a,c)}],a,c)}],a,c)}],a,c)}return e(aVD,[0],function(b){return 1},c)}],aF,aE)}catch(b){b=n(b);if(b===k)throw[0,q,aU6];throw b}var
P=j(aVG,aVF,aS,aG);try{var
aH=function(j){function
c(b){throw k}function
a(b){return 0}return e(aVR,[0,function(j){function
c(b){return x(C(d,f(aVI)))}function
a(c){return g(aVJ,l(b,i(G,7,1)))}return e(aVQ,[0,function(j){function
c(b){return x(C(d,f(aVK)))}function
a(d){var
c=E(b,i(G,7,1));return g(aVL,h(l(b,i(U,10,1)),c))}return e(aVP,[0,function(a){function
c(b){return x(C(d,f(aVM)))}return e(aVO,[0],function(d){var
c=E(b,i(U,10,1));return g(aVN,h(l(b,i(F,10,1)),c))},c)}],a,c)}],a,c)}],a,c)},aJ=function(b){return 1},aM=e(aWc,[0,function(a){function
c(j){function
c(b){throw k}function
a(b){return 0}return e(aWa,[0,function(j){function
c(b){return s(aVS)}function
a(k){var
e=aL(d,f(aVT));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(aI,1,1));return g(aVU,h(h(l(b,i(G,7,1)),j),a))}return e(aV$,[0,function(j){function
c(b){return s(aVV)}function
a(k){var
e=aL(d,f(aVW));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,7,1));return g(aVX,h(h(l(b,i(G,1,1)),j),a))}return e(aV_,[0,function(j){function
c(b){return s(aVY)}function
a(k){var
e=aL(d,f(aVZ));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,1,1));return g(aV0,h(h(l(b,i(U,10,1)),j),a))}return e(aV9,[0,function(j){function
c(b){return s(aV1)}function
a(k){var
e=aL(d,f(aV2));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(U,10,1));return g(aV3,h(h(l(b,i(F,10,1)),j),a))}return e(aV8,[0,function(a){function
c(b){return s(aV4)}return e(aV7,[0],function(k){var
e=aL(d,f(aV5));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(F,10,1));return g(aV6,h(h(l(b,i(F,1,1)),j),a))},c)}],a,c)}],a,c)}],a,c)}],a,c)}],a,c)}return e(aWb,[0],function(b){return 1},c)}],aJ,aH)}catch(b){b=n(b);if(b===k)throw[0,q,aVH];throw b}var
R=j(aWe,aWd,aS,aM);try{var
aN=function(j){function
c(b){throw k}function
a(b){return 0}return e(aWv,[0,function(j){function
c(b){return x(C(d,f(aWg)))}function
a(c){return g(aWh,l(b,i(G,7,1)))}return e(aWu,[0,function(j){function
c(b){return x(C(d,f(aWi)))}function
a(d){var
c=E(b,i(G,7,1));return g(aWj,h(l(b,i(U,10,1)),c))}return e(aWt,[0,function(j){function
c(b){return x(C(d,f(aWk)))}function
a(d){var
c=h(E(b,i(G,7,1)),y);return g(aWl,h(l(b,i(U,10,1)),c))}return e(aWs,[0,function(j){function
c(b){return x(C(d,f(aWm)))}function
a(d){var
c=l(b,i(F,10,1));return g(aWn,h(E(b,i(U,10,1)),c))}return e(aWr,[0,function(a){function
c(b){return x(C(d,f(aWo)))}return e(aWq,[0],function(d){var
c=h(l(b,i(F,10,1)),y);return g(aWp,h(E(b,i(U,10,1)),c))},c)}],a,c)}],a,c)}],a,c)}],a,c)}],a,c)},aO=function(b){return 1},aP=e(aWS,[0,function(a){function
c(j){function
c(b){throw k}function
a(b){return 0}return e(aWQ,[0,function(j){function
c(b){return s(aWw)}function
a(k){var
e=aL(d,f(aWx));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(aI,1,1));return g(aWy,h(h(l(b,i(G,7,1)),j),a))}return e(aWP,[0,function(j){function
c(b){return s(aWz)}function
a(k){var
e=aL(d,f(aWA));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,7,1));return g(aWB,h(h(l(b,i(G,1,1)),j),a))}return e(aWO,[0,function(j){function
c(b){return s(aWC)}function
a(k){var
e=aL(d,f(aWD));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,1,1));return g(aWE,h(h(l(b,i(U,10,1)),j),a))}return e(aWN,[0,function(j){function
c(b){return s(aWF)}function
a(k){var
e=aL(d,f(aWG));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(U,10,1));return g(aWH,h(h(l(b,i(F,10,1)),j),a))}return e(aWM,[0,function(a){function
c(b){return s(aWI)}return e(aWL,[0],function(k){var
e=aL(d,f(aWJ));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(F,10,1));return g(aWK,h(h(l(b,i(F,1,1)),j),a))},c)}],a,c)}],a,c)}],a,c)}],a,c)}],a,c)}return e(aWR,[0],function(b){return 1},c)}],aO,aN)}catch(b){b=n(b);if(b===k)throw[0,q,aWf];throw b}var
v=j(aWU,aWT,aS,aP);try{var
aQ=jH(L,s(aWW)),aR=h(dl(L,s(aWX)),aQ)}catch(b){b=n(b);if(b===k)throw[0,q,aWV];throw b}if(aR){try{var
aT=function(n){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(d){var
b=m(c(aWZ),H);return t(c(aW0),b)}return e(aW2,[0],function(d){var
c=l(b,i(F,10,1));return g(aW1,h(E(b,i(U,10,1)),c))},d)}function
j(f){function
d(d){var
b=m(c(aW3),H);return t(c(aW4),b)}return e(aW6,[0],function(d){var
c=E(b,i(G,7,1));return g(aW5,h(l(b,i(U,10,1)),c))},d)}return e(aW$,[0,function(f){function
d(d){var
b=m(c(aW7),H);return t(c(aW8),b)}return e(aW_,[0],function(c){return g(aW9,l(b,i(G,7,1)))},d)},j,a],f,d)},aU=function(b){return 1},aV=e(aYU,[0,function(j){function
f(r){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(i){var
f=x(d),a=m(c(aXa),f),b=t(c(aXb),a),g=s(aXc),h=m(c(aXd),g),e=t(c(aXe),h);return aZ(b,e)?e:b}return e(aXg,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(F,10,1));return g(aXf,h(h(l(b,i(F,1,1)),d),c))},f)}function
n(a){function
f(i){var
f=x(d),a=m(c(aXh),f),b=t(c(aXi),a),g=s(aXj),h=m(c(aXk),g),e=t(c(aXl),h);return aZ(b,e)?e:b}return e(aXn,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(U,10,1));return g(aXm,h(h(l(b,i(F,10,1)),d),c))},f)}function
o(j){function
f(i){var
f=x(d),a=m(c(aXo),f),b=t(c(aXp),a),g=s(aXq),h=m(c(aXr),g),e=t(c(aXs),h);return aZ(b,e)?e:b}function
a(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,7,1));return g(aXt,h(h(l(b,i(G,1,1)),d),c))}return e(aXB,[0,function(a){function
f(i){var
f=x(d),a=m(c(aXu),f),b=t(c(aXv),a),g=s(aXw),h=m(c(aXx),g),e=t(c(aXy),h);return aZ(b,e)?e:b}return e(aXA,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,1,1));return g(aXz,h(h(l(b,i(U,10,1)),d),c))},f)}],a,f)}function
q(a){function
f(i){var
f=x(d),a=m(c(aXC),f),b=t(c(aXD),a),g=s(aXE),h=m(c(aXF),g),e=t(c(aXG),h);return aZ(b,e)?e:b}return e(aXI,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(aI,1,1));return g(aXH,h(h(l(b,i(G,7,1)),d),c))},f)}return e(aXN,[0,function(f){function
d(d){var
b=m(c(aXJ),H);return t(c(aXK),b)}return e(aXM,[0],function(d){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(aXL,h(l(b,i(aI,1,1)),c))},d)},q,o,n,j],a,f)}function
a(b){return 1}return e(aYT,[0,function(j){function
f(n){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(e){var
b=m(c(aXO),H),d=0===o[0]?c(aXP):c(aXQ);return t(d,b)}return e(aXS,[0],function(d){var
c=h(l(b,i(F,10,1)),y);return g(aXR,h(E(b,i(U,10,1)),c))},d)}function
j(f){function
d(e){var
b=m(c(aXT),H),d=0===o[0]?c(aXU):c(aXV);return t(d,b)}return e(aXX,[0],function(d){var
c=h(E(b,i(G,7,1)),y);return g(aXW,h(l(b,i(U,10,1)),c))},d)}return e(aX3,[0,function(f){function
d(e){var
b=m(c(aXY),H),d=0===o[0]?c(aXZ):c(aX0);return t(d,b)}return e(aX2,[0],function(c){return g(aX1,h(l(b,i(G,7,1)),y))},d)},j,a],f,d)}function
a(b){return 1}return e(aYS,[0,function(a){function
f(u){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(k){var
f=x(d),a=m(c(aX4),f),g=0===o[0]?c(aX5):c(aX_),b=t(g,a),h=s(aX6),i=m(c(aX7),h),j=0===o[0]?c(aX8):c(aX9),e=t(j,i);return aZ(b,e)?e:b}return e(aYa,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(F,10,1));return g(aX$,h(h(l(b,i(F,1,1)),d),c))},f)}function
n(a){function
f(k){var
f=x(d),a=m(c(aYb),f),g=0===o[0]?c(aYc):c(aYh),b=t(g,a),h=s(aYd),i=m(c(aYe),h),j=0===o[0]?c(aYf):c(aYg),e=t(j,i);return aZ(b,e)?e:b}return e(aYj,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(U,10,1));return g(aYi,h(h(l(b,i(F,10,1)),d),c))},f)}function
q(j){function
f(k){var
f=x(d),a=m(c(aYk),f),g=0===o[0]?c(aYl):c(aYq),b=t(g,a),h=s(aYm),i=m(c(aYn),h),j=0===o[0]?c(aYo):c(aYp),e=t(j,i);return aZ(b,e)?e:b}function
a(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,7,1));return g(aYr,h(h(l(b,i(G,1,1)),d),c))}return e(aYB,[0,function(a){function
f(k){var
f=x(d),a=m(c(aYs),f),g=0===o[0]?c(aYt):c(aYy),b=t(g,a),h=s(aYu),i=m(c(aYv),h),j=0===o[0]?c(aYw):c(aYx),e=t(j,i);return aZ(b,e)?e:b}return e(aYA,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,1,1));return g(aYz,h(h(l(b,i(U,10,1)),d),c))},f)}],a,f)}function
r(a){function
f(k){var
f=x(d),a=m(c(aYC),f),g=0===o[0]?c(aYD):c(aYI),b=t(g,a),h=s(aYE),i=m(c(aYF),h),j=0===o[0]?c(aYG):c(aYH),e=t(j,i);return aZ(b,e)?e:b}return e(aYK,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(aI,1,1));return g(aYJ,h(h(l(b,i(G,7,1)),d),c))},f)}return e(aYQ,[0,function(f){function
d(e){var
b=m(c(aYL),H),d=0===o[0]?c(aYM):c(aYN);return t(d,b)}return e(aYP,[0],function(e){switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=h(c,y);return g(aYO,h(l(b,i(aI,1,1)),d))},d)},r,q,n,j],a,f)}return e(aYR,[0],function(b){return 1},f)}],a,f)}],a,f)}],aU,aT)}catch(b){b=n(b);if(b===k)throw[0,q,aWY];throw b}var
I=j(aYW,aYV,D,aV);try{var
aW=function(s){function
j(b){throw k}function
n(b){return 0}function
p(k){function
j(g){if(a(d,f(aYY)))return 0===o[0]?c(aYZ):c(aY0);if(a(d,f(aY1)))return c(aY2);if(a(d,f(aY3)))return c(aY4);if(a(d,f(aY5)))return c(aY6);if(a(d,f(aY7)))return c(aY8);if(a(d,f(aY9)))return c(aY_);if(a(d,f(aY$)))return c(aZa);var
b=x(C(d,f(aZb))),e=m(c(aZc),b);return t(c(aZd),e)}return e(aZf,[0],function(d){var
c=l(b,i(F,1,1));return g(aZe,h(E(b,i(G,1,1)),c))},j)}function
q(k){function
j(e){if(a(d,f(aZg)))return 0===o[0]?c(aZh):c(aZi);if(a(d,f(aZj)))return c(aZk);if(a(d,f(aZl)))return c(aZm);if(a(d,f(aZn)))return c(aZo);if(a(d,f(aZp)))return c(aZq);if(a(d,f(aZr)))return c(aZs);if(a(d,f(aZt)))return c(aZu);var
b=m(c(aZv),P);return t(c(aZw),b)}return e(aZy,[0],function(d){var
c=E(b,i(G,7,1));return g(aZx,h(l(b,i(G,1,1)),c))},j)}function
r(k){function
j(e){if(a(d,f(aZz)))return 0===o[0]?c(aZA):c(aZB);if(a(d,f(aZC)))return c(aZD);if(a(d,f(aZE)))return c(aZF);if(a(d,f(aZG)))return c(aZH);if(a(d,f(aZI)))return c(aZJ);if(a(d,f(aZK)))return c(aZL);if(a(d,f(aZM)))return c(aZN);var
b=m(c(aZO),P);return t(c(aZP),b)}return e(aZR,[0],function(d){var
c=ag(b,i(G,12,31));return g(aZQ,h(l(b,i(G,7,1)),c))},j)}return e(aZ$,[0,function(j){function
h(e){if(a(d,f(aZS)))return 0===o[0]?c(aZT):c(aZU);if(a(d,f(aZV)))return c(aZW);if(a(d,f(aZX)))return c(aZY);if(a(d,f(aZZ)))return c(aZ0);if(a(d,f(aZ1)))return c(aZ2);if(a(d,f(aZ3)))return c(aZ4);if(a(d,f(aZ5)))return c(aZ6);var
b=m(c(aZ7),P);return t(c(aZ8),b)}return e(aZ_,[0],function(c){return g(aZ9,l(b,i(aI,1,1)))},h)},r,q,p],n,j)},aX=function(b){return 1},aY=function(n){function
j(w){function
j(b){throw k}function
n(b){return 0}function
q(k){function
j(b){return c(a0a)}return e(a0d,[0],function(m){var
e=a(d,f(a0b));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
j=h(c,e),k=E(b,i(F,10,1));return g(a0c,h(h(l(b,i(F,1,1)),k),j))},j)}function
r(k){function
j(b){return c(a0e)}return e(a0h,[0],function(m){var
e=a(d,f(a0f));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
j=h(c,e),k=E(b,i(G,7,1));return g(a0g,h(h(l(b,i(G,1,1)),k),j))},j)}function
s(k){function
j(g){if(a(d,f(a0i)))return 0===o[0]?c(a0j):c(a0k);if(a(d,f(a0l)))return c(a0m);if(a(d,f(a0n)))return c(a0o);if(a(d,f(a0p)))return c(a0q);if(a(d,f(a0r)))return c(a0s);if(a(d,f(a0t)))return c(a0u);if(a(d,f(a0v)))return c(a0w);var
b=x(C(d,f(a0x))),e=m(c(a0y),b);return t(c(a0z),e)}return e(a0B,[0],function(e){switch(p[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=1;break;default:var
c=0}var
d=E(b,i(aI,1,1));return g(a0A,h(h(l(b,i(G,7,1)),d),c))},j)}function
u(k){function
j(b){return c(a0C)}return e(a0F,[0],function(m){var
e=a(d,f(a0D));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
j=h(c,e),k=E(b,i(aI,1,1));return g(a0E,h(h(l(b,i(G,7,1)),k),j))},j)}function
v(k){function
j(g){if(a(d,f(a0G)))return 0===o[0]?c(a0H):c(a0I);if(a(d,f(a0J)))return c(a0K);if(a(d,f(a0L)))return c(a0M);if(a(d,f(a0N)))return c(a0O);if(a(d,f(a0P)))return c(a0Q);if(a(d,f(a0R)))return c(a0S);if(a(d,f(a0T)))return c(a0U);var
b=x(C(d,f(a0V))),e=m(c(a0W),b);return t(c(a0X),e)}return e(a0Z,[0],function(d){switch(p[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=1;break;default:var
c=0}return g(a0Y,h(l(b,i(aI,1,1)),c))},j)}return e(a04,[0,function(k){function
j(b){return c(a00)}return e(a03,[0],function(k){var
e=a(d,f(a01));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
j=h(c,e);return g(a02,h(l(b,i(aI,1,1)),j))},j)},v,u,s,r,q],n,j)}return e(a05,[0],function(b){return 1},j)},a0=e(a1M,[0,function(n){function
j(n){function
j(b){throw k}function
m(b){return 0}return e(a1c,[0,function(m){function
j(b){return c(a06)}function
k(m){var
e=a(d,f(a07));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
j=h(c,e),k=E(b,i(G,1,1));return g(a08,h(h(l(b,i(U,10,1)),k),j))}return e(a1b,[0,function(k){function
j(b){return c(a09)}return e(a1a,[0],function(m){var
e=a(d,f(a0_));switch(p[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
j=h(c,e),k=E(b,i(U,10,1));return g(a0$,h(h(l(b,i(F,10,1)),k),j))},j)}],k,j)}],m,j)}function
m(b){return 1}return e(a1L,[0,function(m){function
j(q){function
j(b){throw k}function
m(b){return 0}function
n(k){function
j(b){return a(d,f(a1d))?0===o[0]?c(a1e):c(a1f):a(d,f(a1g))?c(a1h):a(d,f(a1i))?c(a1j):a(d,f(a1k))?c(a1l):a(d,f(a1m))?c(a1n):a(d,f(a1o))?c(a1p):c(a1q)}return e(a1s,[0],function(e){switch(p[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(U,1,1));return g(a1r,h(h(l(b,i(F,1,1)),d),c))},j)}return e(a1J,[0,function(k){function
j(b){return a(d,f(a1t))?0===o[0]?c(a1u):c(a1v):a(d,f(a1w))?c(a1x):a(d,f(a1y))?c(a1z):a(d,f(a1A))?c(a1B):a(d,f(a1C))?c(a1D):a(d,f(a1E))?c(a1F):c(a1G)}return e(a1I,[0],function(e){switch(p[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,1,1));return g(a1H,h(h(l(b,i(U,1,1)),d),c))},j)},n],m,j)}return e(a1K,[0],function(b){return 1},j)}],m,j)},aY],aX,aW)}catch(b){b=n(b);if(b===k)throw[0,q,aYX];throw b}var
a1=j(a1O,a1N,D,a0);try{var
a2=function(r){function
j(b){throw k}function
n(b){return 0}function
p(k){function
j(e){if(a(d,f(a1Q)))return 0===o[0]?c(a1R):c(a1S);var
b=m(c(a1T),R);return t(c(a1U),b)}return e(a1W,[0],function(d){var
c=E(b,i(U,10,1));return g(a1V,h(l(b,i(F,10,1)),c))},j)}function
q(k){function
j(e){if(a(d,f(a1X)))return 0===o[0]?c(a1Y):c(a1Z);var
b=m(c(a10),R);return t(c(a11),b)}return e(a13,[0],function(d){var
c=E(b,i(G,7,1));return g(a12,h(l(b,i(U,10,1)),c))},j)}return e(a1$,[0,function(j){function
h(e){if(a(d,f(a14)))return 0===o[0]?c(a15):c(a16);var
b=m(c(a17),R);return t(c(a18),b)}return e(a1_,[0],function(c){return g(a19,l(b,i(G,7,1)))},h)},q,p],n,j)},a3=e(a2a,[0],function(b){return 1},a2)}catch(b){b=n(b);if(b===k)throw[0,q,a1P];throw b}var
S=j(a2c,a2b,D,a3);try{var
a4=function(A){function
j(b){throw k}function
n(b){return 0}function
p(j){function
a(f){switch(r[0]){case
0:var
b=m(c(a2e),v);return t(c(a2f),b);case
1:var
d=m(c(a2g),v);return t(c(a2h),d);default:var
e=m(c(a2i),v);return t(c(a2j),e)}}return e(a2m,[0],function(a){var
c=aL(d,f(a2k)),e=l(b,i(F,10,1));return g(a2l,h(h(E(b,i(U,10,1)),e),c))},a)}function
q(k){function
j(b){switch(r[0]){case
0:return c(a2n);case
1:return c(a2o);default:return c(a2p)}}return e(a2s,[0],function(m){var
c=a(d,f(a2q)),e=0===o[0]?0:1,j=h(e,c),k=l(b,i(F,10,1));return g(a2r,h(h(E(b,i(U,10,1)),k),j))},j)}function
s(k){function
j(b){switch(r[0]){case
0:return c(a2t);case
1:return c(a2u);default:return c(a2v)}}return e(a2y,[0],function(m){var
c=a(d,f(a2w)),e=0===o[0]?1:0,j=h(e,c),k=l(b,i(F,10,1));return g(a2x,h(h(E(b,i(U,10,1)),k),j))},j)}function
u(j){function
a(f){switch(r[0]){case
0:var
b=m(c(a2z),v);return t(c(a2A),b);case
1:var
d=m(c(a2B),v);return t(c(a2C),d);default:var
e=m(c(a2D),v);return t(c(a2E),e)}}return e(a2H,[0],function(a){var
c=aL(d,f(a2F)),e=E(b,i(G,7,1));return g(a2G,h(h(l(b,i(U,10,1)),e),c))},a)}function
w(k){function
j(b){switch(r[0]){case
0:return c(a2I);case
1:return c(a2J);default:return c(a2K)}}return e(a2N,[0],function(m){var
c=a(d,f(a2L)),e=0===o[0]?0:1,j=h(e,c),k=E(b,i(G,7,1));return g(a2M,h(h(l(b,i(U,10,1)),k),j))},j)}function
x(k){function
j(b){switch(r[0]){case
0:return c(a2O);case
1:return c(a2P);default:return c(a2Q)}}return e(a2T,[0],function(m){var
c=a(d,f(a2R)),e=0===o[0]?1:0,j=h(e,c),k=E(b,i(G,7,1));return g(a2S,h(h(l(b,i(U,10,1)),k),j))},j)}function
y(j){function
a(f){switch(r[0]){case
0:var
b=m(c(a2U),v);return t(c(a2V),b);case
1:var
d=m(c(a2W),v);return t(c(a2X),d);default:var
e=m(c(a2Y),v);return t(c(a2Z),e)}}return e(a22,[0],function(e){var
c=aL(d,f(a20));return g(a21,h(l(b,i(G,7,1)),c))},a)}function
z(k){function
j(b){switch(r[0]){case
0:return c(a23);case
1:return c(a24);default:return c(a25)}}return e(a28,[0],function(k){var
c=a(d,f(a26)),e=0===o[0]?0:1,j=h(e,c);return g(a27,h(l(b,i(G,7,1)),j))},j)}return e(a3d,[0,function(k){function
j(b){switch(r[0]){case
0:return c(a29);case
1:return c(a2_);default:return c(a2$)}}return e(a3c,[0],function(k){var
c=a(d,f(a3a)),e=0===o[0]?1:0,j=h(e,c);return g(a3b,h(l(b,i(G,7,1)),j))},j)},z,y,x,w,u,s,q,p],n,j)},a5=function(b){return 1},a6=function(a){function
d(m){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(b){switch(r[0]){case
0:return c(a3e);case
1:return c(a3f);default:return c(a3g)}}return e(a3i,[0],function(d){var
c=h(l(b,i(F,10,1)),J);return g(a3h,h(E(b,i(U,10,1)),c))},d)}function
j(f){function
d(b){switch(r[0]){case
0:return c(a3j);case
1:return c(a3k);default:return c(a3l)}}return e(a3n,[0],function(d){var
c=h(E(b,i(G,7,1)),J);return g(a3m,h(l(b,i(U,10,1)),c))},d)}return e(a3t,[0,function(f){function
d(b){switch(r[0]){case
0:return c(a3o);case
1:return c(a3p);default:return c(a3q)}}return e(a3s,[0],function(c){return g(a3r,h(l(b,i(G,7,1)),J))},d)},j,a],f,d)}function
f(b){return 1}return e(a3L,[0,function(f){function
d(m){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(b){switch(r[0]){case
0:return c(a3u);case
1:return c(a3v);default:return c(a3w)}}return e(a3y,[0],function(d){var
c=h(l(b,i(F,10,1)),J);return g(a3x,h(h(E(b,i(U,10,1)),c),N))},d)}function
j(f){function
d(b){switch(r[0]){case
0:return c(a3z);case
1:return c(a3A);default:return c(a3B)}}return e(a3D,[0],function(d){var
c=h(E(b,i(G,7,1)),J);return g(a3C,h(h(l(b,i(U,10,1)),c),N))},d)}return e(a3J,[0,function(f){function
d(b){switch(r[0]){case
0:return c(a3E);case
1:return c(a3F);default:return c(a3G)}}return e(a3I,[0],function(c){return g(a3H,h(h(l(b,i(G,7,1)),J),N))},d)},j,a],f,d)}return e(a3K,[0],function(b){return 1},d)}],f,d)},a8=e(a4N,[0,function(n){function
j(B){function
j(b){throw k}function
n(b){return 0}function
p(j){function
a(f){switch(r[0]){case
0:var
b=m(c(a3M),v);return t(c(a3N),b);case
1:var
d=m(c(a3O),v);return t(c(a3P),d);default:var
e=m(c(a3Q),v);return t(c(a3R),e)}}return e(a3U,[0],function(a){var
c=aL(d,f(a3S)),e=h(l(b,i(F,10,1)),y);return g(a3T,h(h(E(b,i(U,10,1)),e),c))},a)}function
q(k){function
j(b){switch(r[0]){case
0:return c(a3V);case
1:return c(a3W);default:return c(a3X)}}return e(a30,[0],function(m){var
c=a(d,f(a3Y)),e=0===o[0]?0:1,j=h(e,c),k=h(l(b,i(F,10,1)),y);return g(a3Z,h(h(E(b,i(U,10,1)),k),j))},j)}function
s(k){function
j(b){switch(r[0]){case
0:return c(a31);case
1:return c(a32);default:return c(a33)}}return e(a36,[0],function(m){var
c=a(d,f(a34)),e=0===o[0]?1:0,j=h(e,c),k=h(l(b,i(F,10,1)),y);return g(a35,h(h(E(b,i(U,10,1)),k),j))},j)}function
u(j){function
a(f){switch(r[0]){case
0:var
b=m(c(a37),v);return t(c(a38),b);case
1:var
d=m(c(a39),v);return t(c(a3_),d);default:var
e=m(c(a3$),v);return t(c(a4a),e)}}return e(a4d,[0],function(a){var
c=aL(d,f(a4b)),e=h(E(b,i(G,7,1)),y);return g(a4c,h(h(l(b,i(U,10,1)),e),c))},a)}function
w(k){function
j(b){switch(r[0]){case
0:return c(a4e);case
1:return c(a4f);default:return c(a4g)}}return e(a4j,[0],function(m){var
c=a(d,f(a4h)),e=0===o[0]?0:1,j=h(e,c),k=h(E(b,i(G,7,1)),y);return g(a4i,h(h(l(b,i(U,10,1)),k),j))},j)}function
x(k){function
j(b){switch(r[0]){case
0:return c(a4k);case
1:return c(a4l);default:return c(a4m)}}return e(a4p,[0],function(m){var
c=a(d,f(a4n)),e=0===o[0]?1:0,j=h(e,c),k=h(E(b,i(G,7,1)),y);return g(a4o,h(h(l(b,i(U,10,1)),k),j))},j)}function
z(j){function
a(f){switch(r[0]){case
0:var
b=m(c(a4q),v);return t(c(a4r),b);case
1:var
d=m(c(a4s),v);return t(c(a4t),d);default:var
e=m(c(a4u),v);return t(c(a4v),e)}}return e(a4y,[0],function(e){var
c=aL(d,f(a4w));return g(a4x,h(h(l(b,i(G,7,1)),y),c))},a)}function
A(k){function
j(b){switch(r[0]){case
0:return c(a4z);case
1:return c(a4A);default:return c(a4B)}}return e(a4E,[0],function(k){var
c=a(d,f(a4C)),e=0===o[0]?0:1,j=h(e,c);return g(a4D,h(h(l(b,i(G,7,1)),y),j))},j)}return e(a4L,[0,function(k){function
j(b){switch(r[0]){case
0:return c(a4F);case
1:return c(a4G);default:return c(a4H)}}return e(a4K,[0],function(k){var
c=a(d,f(a4I)),e=0===o[0]?1:0,j=h(e,c);return g(a4J,h(h(l(b,i(G,7,1)),y),j))},j)},A,z,x,w,u,s,q,p],n,j)}return e(a4M,[0],function(b){return 1},j)},a6],a5,a4)}catch(b){b=n(b);if(b===k)throw[0,q,a2d];throw b}var
A=j(a4P,a4O,D,a8);try{var
a9=function(b){switch(r[0]){case
0:return m(A,s(a4R));case
1:return m(A,s(a4S));default:return m(A,s(a4T))}},a_=e(a4V,[0],function(c){return g(a4U,l(b,i(W,10,1)))},a9)}catch(b){b=n(b);if(b===k)throw[0,q,a4Q];throw b}var
_=j(a4X,a4W,D,a_);try{var
a$=function(b){switch(r[0]){case
0:return m(A,s(a4Z));case
1:return m(A,s(a40));default:return m(A,s(a41))}},ba=e(a43,[0],function(c){return g(a42,l(b,i(W,10,1)))},a$)}catch(b){b=n(b);if(b===k)throw[0,q,a4Y];throw b}var
M=j(a45,a44,D,ba);try{var
bb=function(b){return aZ(K,A)?A:K},bc=e(a48,[0],function(b){return g(a47,1)},bb)}catch(b){b=n(b);if(b===k)throw[0,q,a46];throw b}var
B=j(a4_,a49,D,bc);try{var
bd=cb(M,m(A,s(a5a)))}catch(b){b=n(b);if(b===k)throw[0,q,a4$];throw b}if(bd){var
be=j(a5i,a5h,ay,function(b){try{var
d=function(e){if(aZ(K,_))return c(a5c);if(aZ(K,M)){var
d=aC(_,M);return aC(b,m(b,fJ(aC(K,M),d)))}return b},f=function(b){return g(a5d,1)},a=e(a5g,[0,function(d){function
c(c){return b}return e(a5f,[0],function(b){return g(a5e,ac)},c)}],f,d);return a}catch(b){b=n(b);if(b===k)throw[0,q,a5b];throw b}});try{var
bf=function(n){function
d(b){throw k}function
f(b){return 0}function
a(f){function
d(f){var
b=c(a5k),d=s(a5l);if(cb(m(t(B,I),d),b)){var
e=s(a5m);return m(t(B,I),e)}return c(a5n)}return e(a5p,[0],function(d){var
c=l(b,i(F,10,1));return g(a5o,h(E(b,i(U,10,1)),c))},d)}function
j(f){function
d(f){var
b=c(a5q),d=s(a5r);if(cb(m(t(B,I),d),b)){var
e=s(a5s);return m(t(B,I),e)}return c(a5t)}return e(a5v,[0],function(d){var
c=E(b,i(G,7,1));return g(a5u,h(l(b,i(U,10,1)),c))},d)}return e(a5C,[0,function(f){function
d(f){var
b=c(a5w),d=s(a5x);if(cb(m(t(B,I),d),b)){var
e=s(a5y);return m(t(B,I),e)}return c(a5z)}return e(a5B,[0],function(c){return g(a5A,l(b,i(G,7,1)))},d)},j,a],f,d)},bg=e(a5D,[0],function(b){return 1},bf)}catch(b){b=n(b);if(b===k)throw[0,q,a5j];throw b}var
$=j(a5F,a5E,D,bg);try{var
bh=function(f){function
c(b){throw k}function
d(b){return 0}return e(a5T,[0,function(f){function
c(d){var
b=s(a5H),c=s(a5I);return bM(eB(a7(fJ(B,S),c)),b)}function
d(c){return g(a5J,l(b,i(G,7,1)))}return e(a5S,[0,function(f){function
c(d){var
b=s(a5K),c=s(a5L);return bM(eB(a7(fJ(B,S),c)),b)}function
d(d){var
c=E(b,i(G,7,1));return g(a5M,h(l(b,i(U,10,1)),c))}return e(a5R,[0,function(d){function
c(d){var
b=s(a5N),c=s(a5O);return bM(eB(a7(fJ(B,S),c)),b)}return e(a5Q,[0],function(d){var
c=E(b,i(U,10,1));return g(a5P,h(l(b,i(F,10,1)),c))},c)}],d,c)}],d,c)}],d,c)},bi=e(a5U,[0],function(b){return 1},bh)}catch(b){b=n(b);if(b===k)throw[0,q,a5G];throw b}var
w=j(a5W,a5V,aS,bi),bj=j(a59,a58,ay,function(d){try{var
b=function(a){var
e=j(a5Z,a5Y,D,d),b=O(a53,j(a52,a51,D,u(Q(a50,be),e))),f=c(a54);return cb(aC(b,Y),f)?aC(b,Y):c(a55)},f=e(a57,[0],function(b){return g(a56,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,a5X];throw b}});try{var
bk=function(f){function
c(b){throw k}function
d(b){return 0}return e(a6P,[0,function(f){function
c(a){if(d9(w,s(a5$)))return s(a6a);var
b=d9(w,s(a6b));if(h(dl(w,s(a6c)),b)){var
c=bL(w,s(a6d));return a7(s(a6e),c)}if(dl(w,s(a6f))){var
d=bL(w,s(a6g)),e=a7(s(a6h),d),f=s(a6i);return dk(a7(s(a6j),f),e)}return s(a6k)}function
d(c){return g(a6l,l(b,i(G,7,1)))}return e(a6O,[0,function(f){function
c(a){if(d9(w,s(a6m)))return s(a6n);var
b=d9(w,s(a6o));if(h(dl(w,s(a6p)),b)){var
c=bL(w,s(a6q));return a7(s(a6r),c)}if(dl(w,s(a6s))){var
d=bL(w,s(a6t)),e=a7(s(a6u),d),f=s(a6v);return dk(a7(s(a6w),f),e)}return s(a6x)}function
d(d){var
c=E(b,i(G,7,1));return g(a6y,h(l(b,i(U,10,1)),c))}return e(a6N,[0,function(d){function
c(a){if(d9(w,s(a6z)))return s(a6A);var
b=d9(w,s(a6B));if(h(dl(w,s(a6C)),b)){var
c=bL(w,s(a6D));return a7(s(a6E),c)}if(dl(w,s(a6F))){var
d=bL(w,s(a6G)),e=a7(s(a6H),d),f=s(a6I);return dk(a7(s(a6J),f),e)}return s(a6K)}return e(a6M,[0],function(d){var
c=E(b,i(U,10,1));return g(a6L,h(l(b,i(F,10,1)),c))},c)}],d,c)}],d,c)}],d,c)},bl=e(a6Q,[0],function(b){return 1},bk)}catch(b){b=n(b);if(b===k)throw[0,q,a5_];throw b}var
T=j(a6S,a6R,aS,bl),bm=j(a7a,a6$,ay,function(f){try{var
b=function(k){var
a=j(a6V,a6U,D,f),d=O(a6Z,j(a6Y,a6X,D,u(Q(a6W,bj),a))),g=j(a61,a60,D,d),b=O(a65,j(a64,a63,D,u(Q(a62,az),g))),h=c(a66),e=fI(aC(aC(d,b),h)),i=c(a67);return cb(t(e,b),i)?t(e,b):c(a68)},d=e(a6_,[0],function(b){return g(a69,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,a6T];throw b}});try{var
bn=function(f){function
c(b){throw k}function
d(b){return 0}return e(a7o,[0,function(f){function
c(c){var
b=s(a7c);return bM(eB(a7(T,s(a7d))),b)}function
d(c){return g(a7e,l(b,i(G,7,1)))}return e(a7n,[0,function(f){function
c(c){var
b=s(a7f);return bM(eB(a7(T,s(a7g))),b)}function
d(d){var
c=E(b,i(G,7,1));return g(a7h,h(l(b,i(U,10,1)),c))}return e(a7m,[0,function(d){function
c(c){var
b=s(a7i);return bM(eB(a7(T,s(a7j))),b)}return e(a7l,[0],function(d){var
c=E(b,i(U,10,1));return g(a7k,h(l(b,i(F,10,1)),c))},c)}],d,c)}],d,c)}],d,c)},bo=e(a7p,[0],function(b){return 1},bn)}catch(b){b=n(b);if(b===k)throw[0,q,a7b];throw b}var
bp=j(a7r,a7q,aS,bo),bq=j(a7E,a7D,ay,function(d){try{var
b=function(a){var
e=j(a7u,a7t,D,d),b=O(a7y,j(a7x,a7w,D,u(Q(a7v,bm),e))),f=c(a7z);return cb(aC(b,m(X,L)),f)?aC(b,m(X,L)):c(a7A)},f=e(a7C,[0],function(b){return g(a7B,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,a7s];throw b}});try{var
br=function(b){return dk(Z,bp)},bs=e(a7H,[0],function(b){return g(a7G,1)},br)}catch(b){b=n(b);if(b===k)throw[0,q,a7F];throw b}var
bt=j(a7J,a7I,aS,bs),bu=j(a7U,a7T,ay,function(c){try{var
d=function(e){var
d=j(a7M,a7L,D,c);return oQ(O(a7Q,j(a7P,a7O,D,u(Q(a7N,bq),d))),p,b)},f=e(a7S,[0],function(b){return g(a7R,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,a7K];throw b}});try{var
bv=function(e){var
b=m(aC(ab,a1),bt),d=cw(b,c(a7W))?c(a7X):b;return t($,d)},bw=e(a7Z,[0],function(b){return g(a7Y,1)},bv)}catch(b){b=n(b);if(b===k)throw[0,q,a7V];throw b}var
aa=j(a71,a70,D,bw),bx=j(a8b,a8a,ay,function(d){try{var
b=function(f){var
e=j(a74,a73,D,d),b=O(a78,j(a77,a76,D,u(Q(a75,bu),e)));return cw(b,aq)?c(a79):b},f=e(a7$,[0],function(b){return g(a7_,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,a72];throw b}});try{var
by=function(d){var
b=aC(t(B,I),aa);return cw(b,c(a8d))?c(a8e):b},bz=e(a8g,[0],function(b){return g(a8f,1)},by)}catch(b){b=n(b);if(b===k)throw[0,q,a8c];throw b}return[0,I,A,$,Z,aa,j(a8i,a8h,D,bz),bx]}throw[0,bT,a8j]}throw[0,bT,a8k]}throw[0,bT,a8l]}throw[0,bT,a8m]}throw[0,bT,a8n]}function
tU(v){var
o=v[4],w=v[5],B=v[6],d=v[7],p=v[8],b=v[10],r=v[11],L=v[1],M=v[2],N=v[3],P=v[9];try{var
R=l(b,i(U,10,1))}catch(b){b=n(b);if(b===k)throw[0,q,a8o];throw b}if(R){try{var
S=function(c){return b},T=j(a8t,a8s,aK,e(a8r,[0],function(b){return g(a8q,1)},S))}catch(b){b=n(b);if(b===k)throw[0,q,a8p];throw b}try{var
V=function(b){return o},X=j(a8y,a8x,cc,e(a8w,[0],function(b){return g(a8v,1)},V))}catch(b){b=n(b);if(b===k)throw[0,q,a8u];throw b}var
Y=O(a8A,u(Q(a8z,gi),[0,T,X]))[1];try{var
Z=function(b){return o},_=j(a8F,a8E,cc,e(a8D,[0],function(b){return g(a8C,1)},Z))}catch(b){b=n(b);if(b===k)throw[0,q,a8B];throw b}try{var
$=function(b){return M},aa=j(a8K,a8J,ai,e(a8I,[0],function(b){return g(a8H,1)},$))}catch(b){b=n(b);if(b===k)throw[0,q,a8G];throw b}try{var
ab=function(b){return L},ac=j(a8P,a8O,hU,e(a8N,[0],function(b){return g(a8M,1)},ab))}catch(b){b=n(b);if(b===k)throw[0,q,a8L];throw b}try{var
ad=function(b){return N},ae=j(a8U,a8T,aK,e(a8S,[0],function(b){return g(a8R,1)},ad))}catch(b){b=n(b);if(b===k)throw[0,q,a8Q];throw b}try{var
af=function(b){return B},ag=j(a8Z,a8Y,D,e(a8X,[0],function(b){return g(a8W,1)},af))}catch(b){b=n(b);if(b===k)throw[0,q,a8V];throw b}try{var
ah=function(b){return d},aj=j(a84,a83,bA,e(a82,[0],function(b){return g(a81,1)},ah))}catch(b){b=n(b);if(b===k)throw[0,q,a80];throw b}try{var
ak=function(b){return p},al=j(a89,a88,cS,e(a87,[0],function(b){return g(a86,1)},ak))}catch(b){b=n(b);if(b===k)throw[0,q,a85];throw b}try{var
am=function(b){return P},an=j(a9c,a9b,dw,e(a9a,[0],function(b){return g(a8$,1)},am))}catch(b){b=n(b);if(b===k)throw[0,q,a8_];throw b}try{var
ao=function(c){return b},ap=j(a9h,a9g,aK,e(a9f,[0],function(b){return g(a9e,1)},ao))}catch(b){b=n(b);if(b===k)throw[0,q,a9d];throw b}try{var
aq=function(b){return w},ar=j(a9m,a9l,D,e(a9k,[0],function(b){return g(a9j,1)},aq))}catch(b){b=n(b);if(b===k)throw[0,q,a9i];throw b}var
as=function(c){function
b(b){return 1}return j(a9q,a9p,ai,e(a9o,[0],function(b){return g(a9n,1)},b))},at=function(d){function
c(b){return 1}return j(a9u,a9t,ai,e(a9s,[0],function(e){switch(o[0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(aI,4,5));return g(a9r,h(h(l(b,i(W,9,1)),d),c))},c))},au=[0,_,aa,ac,ae,ag,aj,al,an,ap,ar,as,at,function(b){throw k}],av=O(a9w,u(Q(a9v,jL),au))[7];try{var
aw=function(c){return b},ax=j(a9B,a9A,aK,e(a9z,[0],function(b){return g(a9y,1)},aw))}catch(b){b=n(b);if(b===k)throw[0,q,a9x];throw b}try{var
az=function(b){return 1},aA=j(a9G,a9F,ai,e(a9E,[0],function(b){return g(a9D,1)},az))}catch(b){b=n(b);if(b===k)throw[0,q,a9C];throw b}try{var
aB=function(b){return d},aD=j(a9L,a9K,bA,e(a9J,[0],function(b){return g(a9I,1)},aB))}catch(b){b=n(b);if(b===k)throw[0,q,a9H];throw b}try{var
aE=function(b){return p},aF=j(a9Q,a9P,cS,e(a9O,[0],function(b){return g(a9N,1)},aE))}catch(b){b=n(b);if(b===k)throw[0,q,a9M];throw b}var
aG=[0,ax,aA,aD,aF,function(b){throw k}],aH=O(a9S,u(Q(a9R,oN),aG))[1];try{var
aJ=function(a){function
c(b){throw k}function
f(b){return 0}return e(a9Y,[0,function(a){function
c(b){return x(d)}function
f(c){return g(a9U,l(b,i(G,7,1)))}return e(a9X,[0,function(f){function
c(b){return x(d)}return e(a9W,[0],function(d){var
c=E(b,i(G,7,1));return g(a9V,h(l(b,i(U,10,1)),c))},c)}],f,c)}],f,c)},aM=function(b){return 1},aN=e(a_j,[0,function(a){function
c(j){function
c(b){throw k}function
a(b){return 0}return e(a_h,[0,function(j){function
c(b){return s(a9Z)}function
a(k){var
e=aL(d,f(a90));switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(aI,1,1));return g(a91,h(h(l(b,i(G,7,1)),j),a))}return e(a_g,[0,function(j){function
c(b){return s(a92)}function
a(k){var
e=aL(d,f(a93));switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,7,1));return g(a94,h(h(l(b,i(G,1,1)),j),a))}return e(a_f,[0,function(j){function
c(b){return s(a95)}function
a(k){var
e=aL(d,f(a96));switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(G,1,1));return g(a97,h(h(l(b,i(U,10,1)),j),a))}return e(a_e,[0,function(j){function
c(b){return s(a98)}function
a(k){var
e=aL(d,f(a99));switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(U,10,1));return g(a9_,h(h(l(b,i(F,10,1)),j),a))}return e(a_d,[0,function(a){function
c(b){return s(a9$)}return e(a_c,[0],function(k){var
e=aL(d,f(a_a));switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(b,i(F,10,1));return g(a_b,h(h(l(b,i(F,1,1)),j),a))},c)}],a,c)}],a,c)}],a,c)}],a,c)}],a,c)}return e(a_i,[0],function(b){return 1},c)}],aM,aJ)}catch(b){b=n(b);if(b===k)throw[0,q,a9T];throw b}var
y=j(a_l,a_k,aS,aN);try{var
aO=function(b){return c(a_n)},aP=e(a_p,[0],function(c){return g(a_o,l(b,i(W,10,1)))},aO)}catch(b){b=n(b);if(b===k)throw[0,q,a_m];throw b}var
C=j(a_r,a_q,D,aP);try{var
aQ=function(b){return c(a_t)},aR=e(a_v,[0],function(c){return g(a_u,l(b,i(W,10,1)))},aQ)}catch(b){b=n(b);if(b===k)throw[0,q,a_s];throw b}var
H=j(a_x,a_w,D,aR);try{var
aT=function(b){return c(a_z)},aU=e(a_B,[0],function(c){return g(a_A,l(b,i(W,10,1)))},aT)}catch(b){b=n(b);if(b===k)throw[0,q,a_y];throw b}var
aV=j(a_D,a_C,D,aU);try{var
aW=function(u){function
d(b){throw k}function
f(b){return 0}function
a(a){function
d(b){return 0===p[0]?c(a_F):c(a_G)}function
f(e){switch(r[0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=0;break;default:var
c=0}var
d=E(b,i(U,10,1));return g(a_H,h(h(l(b,i(F,10,1)),d),c))}return e(a_M,[0,function(f){function
d(b){return 0===p[0]?c(a_I):c(a_J)}return e(a_L,[0],function(e){switch(r[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=1}var
d=E(b,i(U,10,1));return g(a_K,h(h(l(b,i(F,10,1)),d),c))},d)}],f,d)}function
j(f){function
d(b){return 0===p[0]?c(a_N):c(a_O)}return e(a_Q,[0],function(e){switch(r[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;default:var
c=0}var
d=E(b,i(U,10,1));return g(a_P,h(h(l(b,i(F,10,1)),d),c))},d)}function
m(f){function
d(b){return 0===p[0]?c(a_R):c(a_S)}return e(a_U,[0],function(e){switch(r[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=0}var
d=E(b,i(U,10,1));return g(a_T,h(h(l(b,i(F,10,1)),d),c))},d)}function
n(a){function
d(b){return 0===p[0]?c(a_V):c(a_W)}function
f(e){switch(r[0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=0;break;default:var
c=0}var
d=E(b,i(G,7,1));return g(a_X,h(h(l(b,i(U,10,1)),d),c))}return e(a_2,[0,function(f){function
d(b){return 0===p[0]?c(a_Y):c(a_Z)}return e(a_1,[0],function(e){switch(r[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=1}var
d=E(b,i(G,7,1));return g(a_0,h(h(l(b,i(U,10,1)),d),c))},d)}],f,d)}function
o(f){function
d(b){return 0===p[0]?c(a_3):c(a_4)}return e(a_6,[0],function(e){switch(r[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;default:var
c=0}var
d=E(b,i(G,7,1));return g(a_5,h(h(l(b,i(U,10,1)),d),c))},d)}function
q(f){function
d(b){return 0===p[0]?c(a_7):c(a_8)}return e(a__,[0],function(e){switch(r[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=0}var
d=E(b,i(G,7,1));return g(a_9,h(h(l(b,i(U,10,1)),d),c))},d)}function
s(a){function
d(b){return 0===p[0]?c(a_$):c(a$a)}function
f(d){switch(r[0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=0;break;default:var
c=0}return g(a$b,h(l(b,i(G,7,1)),c))}return e(a$g,[0,function(f){function
d(b){return 0===p[0]?c(a$c):c(a$d)}return e(a$f,[0],function(d){switch(r[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=1}return g(a$e,h(l(b,i(G,7,1)),c))},d)}],f,d)}function
t(f){function
d(b){return 0===p[0]?c(a$h):c(a$i)}return e(a$k,[0],function(d){switch(r[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;default:var
c=0}return g(a$j,h(l(b,i(G,7,1)),c))},d)}return e(a$p,[0,function(f){function
d(b){return 0===p[0]?c(a$l):c(a$m)}return e(a$o,[0],function(d){switch(r[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=0}return g(a$n,h(l(b,i(G,7,1)),c))},d)},t,s,q,o,n,m,j,a],f,d)},aX=e(a$q,[0],function(b){return 1},aW)}catch(b){b=n(b);if(b===k)throw[0,q,a_E];throw b}var
z=j(a$s,a$r,D,aX);try{var
aY=function(b){return av},a0=e(a$v,[0],function(b){return g(a$u,1)},aY)}catch(b){b=n(b);if(b===k)throw[0,q,a$t];throw b}var
I=j(a$x,a$w,aS,a0);try{var
a1=function(c){return b},a2=j(a$C,a$B,aK,e(a$A,[0],function(b){return g(a$z,1)},a1))}catch(b){b=n(b);if(b===k)throw[0,q,a$y];throw b}try{var
a3=function(b){return B},a4=j(a$H,a$G,D,e(a$F,[0],function(b){return g(a$E,1)},a3))}catch(b){b=n(b);if(b===k)throw[0,q,a$D];throw b}try{var
a5=function(b){return 1},a6=j(a$M,a$L,ai,e(a$K,[0],function(b){return g(a$J,1)},a5))}catch(b){b=n(b);if(b===k)throw[0,q,a$I];throw b}try{var
a7=function(b){return aH},a8=j(a$R,a$Q,aS,e(a$P,[0],function(b){return g(a$O,1)},a7))}catch(b){b=n(b);if(b===k)throw[0,q,a$N];throw b}var
a9=O(a$T,u(Q(a$S,hX),[0,a2,a4,a6,a8]))[1];try{var
a_=function(q){function
j(b){throw k}function
n(b){return 0}function
o(k){function
j(g){if(a(d,f(a$V)))return c(a$W);var
b=x(d),e=m(c(a$X),b);return t(c(a$Y),e)}return e(a$0,[0],function(d){var
c=E(b,i(U,10,1));return g(a$Z,h(l(b,i(F,10,1)),c))},j)}function
p(k){function
j(e){if(a(d,f(a$1)))return c(a$2);var
b=m(c(a$3),y);return t(c(a$4),b)}return e(a$6,[0],function(d){var
c=E(b,i(G,7,1));return g(a$5,h(l(b,i(U,10,1)),c))},j)}return e(bab,[0,function(j){function
h(e){if(a(d,f(a$7)))return c(a$8);var
b=m(c(a$9),y);return t(c(a$_),b)}return e(baa,[0],function(c){return g(a$$,l(b,i(G,7,1)))},h)},p,o],n,j)},a$=function(b){return 1},ba=e(baR,[0,function(a){function
f(r){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(i){var
f=x(d),a=m(c(bac),f),b=t(c(bad),a),g=s(bae),h=m(c(baf),g),e=t(c(bag),h);return aZ(b,e)?e:b}return e(bai,[0],function(e){switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(F,10,1));return g(bah,h(h(l(b,i(F,1,1)),d),c))},f)}function
n(a){function
f(i){var
f=x(d),a=m(c(baj),f),b=t(c(bak),a),g=s(bal),h=m(c(bam),g),e=t(c(ban),h);return aZ(b,e)?e:b}return e(bap,[0],function(e){switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(U,10,1));return g(bao,h(h(l(b,i(F,10,1)),d),c))},f)}function
p(j){function
f(i){var
f=x(d),a=m(c(baq),f),b=t(c(bar),a),g=s(bas),h=m(c(bat),g),e=t(c(bau),h);return aZ(b,e)?e:b}function
a(e){switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,7,1));return g(bav,h(h(l(b,i(G,1,1)),d),c))}return e(baD,[0,function(a){function
f(i){var
f=x(d),a=m(c(baw),f),b=t(c(bax),a),g=s(bay),h=m(c(baz),g),e=t(c(baA),h);return aZ(b,e)?e:b}return e(baC,[0],function(e){switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(G,1,1));return g(baB,h(h(l(b,i(U,10,1)),d),c))},f)}],a,f)}function
q(a){function
f(i){var
f=x(d),a=m(c(baE),f),b=t(c(baF),a),g=s(baG),h=m(c(baH),g),e=t(c(baI),h);return aZ(b,e)?e:b}return e(baK,[0],function(e){switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
d=E(b,i(aI,1,1));return g(baJ,h(h(l(b,i(G,7,1)),d),c))},f)}return e(baP,[0,function(f){function
d(d){var
b=m(c(baL),y);return t(c(baM),b)}return e(baO,[0],function(d){switch(o[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(baN,h(l(b,i(aI,1,1)),c))},d)},q,p,n,j],a,f)}return e(baQ,[0],function(b){return 1},f)}],a$,a_)}catch(b){b=n(b);if(b===k)throw[0,q,a$U];throw b}var
A=j(baT,baS,D,ba),bb=j(ba0,baZ,ay,function(b){try{var
d=function(e){var
d=c(baV);return cw(aC(b,H),d)?c(baW):aC(b,H)},f=e(baY,[0],function(b){return g(baX,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,baU];throw b}});try{var
bc=function(b){return a9},bd=e(ba3,[0],function(b){return g(ba2,1)},bc)}catch(b){b=n(b);if(b===k)throw[0,q,ba1];throw b}var
J=j(ba5,ba4,D,bd),K=j(ba_,ba9,ay,function(b){try{var
c=function(c){return aC(t(z,A),b)},d=e(ba8,[0],function(b){return g(ba7,1)},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,ba6];throw b}});try{var
be=function(b){return m(aC(t(z,A),J),I)},bf=e(bbb,[0],function(b){return g(bba,1)},be)}catch(b){b=n(b);if(b===k)throw[0,q,ba$];throw b}var
bg=j(bbd,bbc,D,bf),bh=j(bbv,bbu,ay,function(b){try{var
d=function(f){var
d=j(bbg,bbf,D,b);if(cw(O(bbk,j(bbj,bbi,D,u(Q(bbh,K),d))),C)){var
e=j(bbm,bbl,D,b);return aC(C,O(bbq,j(bbp,bbo,D,u(Q(bbn,K),e))))}return c(bbr)},f=e(bbt,[0],function(b){return g(bbs,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,bbe];throw b}}),bi=j(bbO,bbN,ay,function(f){try{var
b=function(h){var
e=j(bby,bbx,D,f),b=O(bbC,j(bbB,bbA,D,u(Q(bbz,bb),e))),a=j(bbE,bbD,D,b),d=O(bbI,j(bbH,bbG,D,u(Q(bbF,bh),a))),g=c(bbJ);return cw(aC(b,d),g)?c(bbK):aC(b,d)},d=e(bbM,[0],function(b){return g(bbL,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,bbw];throw b}}),bj=j(bbZ,bbY,ay,function(c){try{var
b=function(e){var
d=j(bbR,bbQ,D,c),b=O(bbV,j(bbU,bbT,D,u(Q(bbS,bi),d)));return aZ(b,w)?w:b},d=e(bbX,[0],function(b){return g(bbW,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,bbP];throw b}}),bk=j(bch,bcg,ay,function(f){try{var
b=function(k){var
a=j(bb2,bb1,D,f),d=O(bb6,j(bb5,bb4,D,u(Q(bb3,bj),a))),g=j(bb8,bb7,D,d),b=O(bca,j(bb$,bb_,D,u(Q(bb9,Y),g))),h=c(bcb),e=fI(aC(aC(d,b),h)),i=c(bcc);return cb(t(e,b),i)?t(e,b):c(bcd)},d=e(bcf,[0],function(b){return g(bce,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,bb0];throw b}}),bl=j(bcs,bcr,ay,function(c){try{var
d=function(e){var
d=j(bck,bcj,D,c);return oQ(O(bco,j(bcn,bcm,D,u(Q(bcl,bk),d))),o,b)},f=e(bcq,[0],function(b){return g(bcp,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,bci];throw b}});return[0,I,z,A,J,bg,j(bcE,bcD,ay,function(d){try{var
b=function(f){var
e=j(bcv,bcu,D,d),b=O(bcz,j(bcy,bcx,D,u(Q(bcw,bl),e)));return cw(b,aV)?c(bcA):b},f=e(bcC,[0],function(b){return g(bcB,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,bct];throw b}})]}throw[0,bT,bcF]}function
tV(v){var
L=v[1],p=v[2],o=v[3],r=v[4],b=v[5],d=v[6],M=v[7],w=v[9],y=v[10],z=v[14],J=v[15],$=v[8],aa=v[11],ab=v[12],ac=v[13];try{var
ad=function(c){var
b=s(bcH);return bM(s(bcI),b)},ae=e(bcK,[0],function(b){return g(bcJ,1)},ad)}catch(b){b=n(b);if(b===k)throw[0,q,bcG];throw b}var
A=j(bcM,bcL,aS,ae);try{var
af=function(b){return p},ah=j(bcR,bcQ,bA,e(bcP,[0],function(b){return g(bcO,1)},af))}catch(b){b=n(b);if(b===k)throw[0,q,bcN];throw b}try{var
aj=function(b){return o},ak=j(bcW,bcV,cS,e(bcU,[0],function(b){return g(bcT,1)},aj))}catch(b){b=n(b);if(b===k)throw[0,q,bcS];throw b}var
al=O(bcY,u(Q(bcX,oO),[0,ah,ak]))[1];try{var
am=l(d,i(U,10,1))}catch(b){b=n(b);if(b===k)throw[0,q,bcZ];throw b}if(am){try{var
an=function(b){return d},ao=j(bc4,bc3,aK,e(bc2,[0],function(b){return g(bc1,1)},an))}catch(b){b=n(b);if(b===k)throw[0,q,bc0];throw b}try{var
ap=function(c){return b},aq=j(bc9,bc8,cc,e(bc7,[0],function(b){return g(bc6,1)},ap))}catch(b){b=n(b);if(b===k)throw[0,q,bc5];throw b}var
as=O(bc$,u(Q(bc_,gi),[0,ao,aq]))[1];try{var
at=function(f){function
b(b){throw k}function
c(b){return 0}return e(bdf,[0,function(f){function
b(b){return x(p)}function
c(b){return g(bdb,l(d,i(G,7,1)))}return e(bde,[0,function(c){function
b(b){return x(p)}return e(bdd,[0],function(c){var
b=E(d,i(G,7,1));return g(bdc,h(l(d,i(U,10,1)),b))},b)}],c,b)}],c,b)},au=function(b){return 1},av=e(bdC,[0,function(a){function
c(j){function
c(b){throw k}function
a(b){return 0}return e(bdA,[0,function(j){function
c(b){return s(bdg)}function
a(k){var
e=aL(p,f(bdh));switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(d,i(aI,1,1));return g(bdi,h(h(l(d,i(G,7,1)),j),a))}return e(bdz,[0,function(j){function
c(b){return s(bdj)}function
a(k){var
e=aL(p,f(bdk));switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(d,i(G,7,1));return g(bdl,h(h(l(d,i(G,1,1)),j),a))}return e(bdy,[0,function(j){function
c(b){return s(bdm)}function
a(k){var
e=aL(p,f(bdn));switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(d,i(G,1,1));return g(bdo,h(h(l(d,i(U,10,1)),j),a))}return e(bdx,[0,function(j){function
c(b){return s(bdp)}function
a(k){var
e=aL(p,f(bdq));switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(d,i(U,10,1));return g(bdr,h(h(l(d,i(F,10,1)),j),a))}return e(bdw,[0,function(a){function
c(b){return s(bds)}return e(bdv,[0],function(k){var
e=aL(p,f(bdt));switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
a=h(c,e),j=E(d,i(F,10,1));return g(bdu,h(h(l(d,i(F,1,1)),j),a))},c)}],a,c)}],a,c)}],a,c)}],a,c)}],a,c)}return e(bdB,[0],function(b){return 1},c)}],au,at)}catch(b){b=n(b);if(b===k)throw[0,q,bda];throw b}var
I=j(bdE,bdD,aS,av);try{var
aw=function(b){return s(bdG)},ax=e(bdI,[0],function(b){return g(bdH,l(d,i(W,10,1)))},aw)}catch(b){b=n(b);if(b===k)throw[0,q,bdF];throw b}var
az=j(bdK,bdJ,aS,ax);try{var
aA=function(b){return s(bdM)},aB=e(bdO,[0],function(b){return g(bdN,l(d,i(W,10,1)))},aA)}catch(b){b=n(b);if(b===k)throw[0,q,bdL];throw b}var
aD=j(bdQ,bdP,aS,aB);try{var
aE=function(b){return c(bdS)},aF=e(bdU,[0],function(b){return g(bdT,l(d,i(W,10,1)))},aE)}catch(b){b=n(b);if(b===k)throw[0,q,bdR];throw b}var
aG=j(bdW,bdV,D,aF);try{var
aH=function(b){return c(bdY)},aJ=e(bd0,[0],function(b){return g(bdZ,l(d,i(W,10,1)))},aH)}catch(b){b=n(b);if(b===k)throw[0,q,bdX];throw b}var
aM=j(bd2,bd1,D,aJ);try{var
aN=function(b){return c(bd4)},aO=e(bd6,[0],function(b){return g(bd5,l(d,i(W,10,1)))},aN)}catch(b){b=n(b);if(b===k)throw[0,q,bd3];throw b}var
aP=j(bd8,bd7,D,aO);try{var
aQ=function(b){return c(bd_)},aR=e(bea,[0],function(b){return g(bd$,l(d,i(W,10,1)))},aQ)}catch(b){b=n(b);if(b===k)throw[0,q,bd9];throw b}var
R=j(bec,beb,D,aR);try{var
aT=l(w,i(fg,9,30))}catch(b){b=n(b);if(b===k)throw[0,q,bed];throw b}if(aT){try{var
aU=function(b){return 0},aV=function(b){return g(bef,1)},aW=e(bes,[0,function(a){function
c(b){return 1}function
f(a){var
e=l(w,i(kH,7,1));switch(y[0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=1;break;default:var
b=0}switch(y[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=0}var
f=H(c,b);switch(y[0]){case
0:var
d=0;break;case
1:var
d=0;break;case
2:var
d=0;break;default:var
d=1}return g(beg,h(H(d,f),e))}return e(ber,[0,function(f){function
c(a){function
c(b){throw k}function
f(b){return 0}return e(bep,[0,function(a){function
c(b){return 0}function
f(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(c,J);return g(beh,h(l(d,i(aI,4,5)),e))}return e(beo,[0,function(a){function
c(b){return 0}function
f(a){switch(b[0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(c,J),f=E(d,i(aI,4,5));return g(bei,h(h(l(d,i(W,9,1)),f),e))}return e(ben,[0,function(a){function
c(b){return 0}function
f(f){switch(b[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}var
e=h(c,J);return g(bej,h(l(d,i(aI,4,5)),e))}return e(bem,[0,function(f){function
c(b){return 0}return e(bel,[0],function(a){switch(b[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}var
e=h(c,J),f=E(d,i(aI,4,5));return g(bek,h(h(l(d,i(W,9,1)),f),e))},c)}],f,c)}],f,c)}],f,c)}],f,c)}return e(beq,[0],function(b){return 1},c)}],f,c)}],aV,aU)}catch(b){b=n(b);if(b===k)throw[0,q,bee];throw b}var
aX=j(beu,bet,ai,aW),K=j(bvL,bvK,ay,function(j,b){try{var
p=function(S){function
n(b){throw k}function
p(b){return 0}function
q(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bew)))return 0===o[0]?c(bex):c(bey);if(a(b,f(bez)))return c(beA);if(a(b,f(beB)))return c(beC);if(a(b,f(beD)))return c(beE);if(a(b,f(beF)))return c(beG);if(a(b,f(beH)))return c(beI);var
d=x(C(b,f(beJ))),e=m(c(beK),d);return t(c(beL),e);case
1:if(a(b,f(beM)))return 0===o[0]?c(beN):c(beO);if(a(b,f(beP)))return c(beQ);if(a(b,f(beR)))return c(beS);if(a(b,f(beT)))return c(beU);if(a(b,f(beV)))return c(beW);if(a(b,f(beX)))return c(beY);var
g=x(C(b,f(beZ))),h=m(c(be0),g);return t(c(be1),h);default:if(a(b,f(be2)))return 0===o[0]?c(be3):c(be4);if(a(b,f(be5)))return c(be6);if(a(b,f(be7)))return c(be8);if(a(b,f(be9)))return c(be_);if(a(b,f(be$)))return c(bfa);if(a(b,f(bfb)))return c(bfc);var
i=x(C(b,f(bfd))),j=m(c(bfe),i);return t(c(bff),j)}}return e(bfh,[0],function(c){var
b=l(j,i(W,10,1));return g(bfg,h(l(d,i(F,1,1)),b))},k)}function
s(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bfi)))return 0===o[0]?c(bfj):c(bfk);if(a(b,f(bfl)))return c(bfm);if(a(b,f(bfn)))return c(bfo);if(a(b,f(bfp)))return c(bfq);if(a(b,f(bfr)))return c(bfs);if(a(b,f(bft)))return c(bfu);var
d=x(C(b,f(bfv))),e=m(c(bfw),d);return t(c(bfx),e);case
1:if(a(b,f(bfy)))return 0===o[0]?c(bfz):c(bfA);if(a(b,f(bfB)))return c(bfC);if(a(b,f(bfD)))return c(bfE);if(a(b,f(bfF)))return c(bfG);if(a(b,f(bfH)))return c(bfI);if(a(b,f(bfJ)))return c(bfK);var
g=x(C(b,f(bfL))),h=m(c(bfM),g);return t(c(bfN),h);default:if(a(b,f(bfO)))return 0===o[0]?c(bfP):c(bfQ);if(a(b,f(bfR)))return c(bfS);if(a(b,f(bfT)))return c(bfU);if(a(b,f(bfV)))return c(bfW);if(a(b,f(bfX)))return c(bfY);if(a(b,f(bfZ)))return c(bf0);var
i=x(C(b,f(bf1))),j=m(c(bf2),i);return t(c(bf3),j)}}return e(bf5,[0],function(e){var
b=E(j,i(W,10,1)),c=h(l(j,i(cJ,10,1)),b);return g(bf4,h(l(d,i(F,1,1)),c))},k)}function
u(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bf6)))return 0===o[0]?c(bf7):c(bf8);if(a(b,f(bf9)))return c(bf_);if(a(b,f(bf$)))return c(bga);if(a(b,f(bgb)))return c(bgc);if(a(b,f(bgd)))return c(bge);if(a(b,f(bgf)))return c(bgg);var
d=x(C(b,f(bgh))),e=m(c(bgi),d);return t(c(bgj),e);case
1:if(a(b,f(bgk)))return 0===o[0]?c(bgl):c(bgm);if(a(b,f(bgn)))return c(bgo);if(a(b,f(bgp)))return c(bgq);if(a(b,f(bgr)))return c(bgs);if(a(b,f(bgt)))return c(bgu);if(a(b,f(bgv)))return c(bgw);var
g=x(C(b,f(bgx))),h=m(c(bgy),g);return t(c(bgz),h);default:if(a(b,f(bgA)))return 0===o[0]?c(bgB):c(bgC);if(a(b,f(bgD)))return c(bgE);if(a(b,f(bgF)))return c(bgG);if(a(b,f(bgH)))return c(bgI);if(a(b,f(bgJ)))return c(bgK);if(a(b,f(bgL)))return c(bgM);var
i=x(C(b,f(bgN))),j=m(c(bgO),i);return t(c(bgP),j)}}return e(bgR,[0],function(e){var
b=E(j,i(cJ,10,1)),c=h(l(j,i(dK,10,1)),b);return g(bgQ,h(l(d,i(F,1,1)),c))},k)}function
v(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bgS)))return 0===o[0]?c(bgT):c(bgU);if(a(b,f(bgV)))return c(bgW);if(a(b,f(bgX)))return c(bgY);if(a(b,f(bgZ)))return c(bg0);if(a(b,f(bg1)))return c(bg2);if(a(b,f(bg3)))return c(bg4);var
d=x(C(b,f(bg5))),e=m(c(bg6),d);return t(c(bg7),e);case
1:if(a(b,f(bg8)))return 0===o[0]?c(bg9):c(bg_);if(a(b,f(bg$)))return c(bha);if(a(b,f(bhb)))return c(bhc);if(a(b,f(bhd)))return c(bhe);if(a(b,f(bhf)))return c(bhg);if(a(b,f(bhh)))return c(bhi);var
g=x(C(b,f(bhj))),h=m(c(bhk),g);return t(c(bhl),h);default:if(a(b,f(bhm)))return 0===o[0]?c(bhn):c(bho);if(a(b,f(bhp)))return c(bhq);if(a(b,f(bhr)))return c(bhs);if(a(b,f(bht)))return c(bhu);if(a(b,f(bhv)))return c(bhw);if(a(b,f(bhx)))return c(bhy);var
i=x(C(b,f(bhz))),j=m(c(bhA),i);return t(c(bhB),j)}}return e(bhD,[0],function(e){var
b=E(j,i(dK,10,1)),c=h(l(j,i(dn,10,1)),b);return g(bhC,h(l(d,i(F,1,1)),c))},k)}function
w(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bhE)))return 0===o[0]?c(bhF):c(bhG);if(a(b,f(bhH)))return c(bhI);if(a(b,f(bhJ)))return c(bhK);if(a(b,f(bhL)))return c(bhM);if(a(b,f(bhN)))return c(bhO);if(a(b,f(bhP)))return c(bhQ);var
d=x(C(b,f(bhR))),e=m(c(bhS),d);return t(c(bhT),e);case
1:if(a(b,f(bhU)))return 0===o[0]?c(bhV):c(bhW);if(a(b,f(bhX)))return c(bhY);if(a(b,f(bhZ)))return c(bh0);if(a(b,f(bh1)))return c(bh2);if(a(b,f(bh3)))return c(bh4);if(a(b,f(bh5)))return c(bh6);var
g=x(C(b,f(bh7))),h=m(c(bh8),g);return t(c(bh9),h);default:if(a(b,f(bh_)))return 0===o[0]?c(bh$):c(bia);if(a(b,f(bib)))return c(bic);if(a(b,f(bid)))return c(bie);if(a(b,f(bif)))return c(big);if(a(b,f(bih)))return c(bii);if(a(b,f(bij)))return c(bik);var
i=x(C(b,f(bil))),j=m(c(bim),i);return t(c(bin),j)}}return e(bip,[0],function(e){var
b=E(j,i(dn,10,1)),c=h(l(j,i(eF,1,1)),b);return g(bio,h(l(d,i(F,1,1)),c))},k)}function
y(n){function
k(k){switch(r[0]){case
0:if(a(b,f(biq)))return 0===o[0]?c(bir):c(bis);if(a(b,f(bit)))return c(biu);if(a(b,f(biv)))return c(biw);if(a(b,f(bix)))return c(biy);if(a(b,f(biz)))return c(biA);if(a(b,f(biB)))return c(biC);var
d=x(C(b,f(biD))),e=m(c(biE),d);return t(c(biF),e);case
1:if(a(b,f(biG)))return 0===o[0]?c(biH):c(biI);if(a(b,f(biJ)))return c(biK);if(a(b,f(biL)))return c(biM);if(a(b,f(biN)))return c(biO);if(a(b,f(biP)))return c(biQ);if(a(b,f(biR)))return c(biS);var
g=x(C(b,f(biT))),h=m(c(biU),g);return t(c(biV),h);default:if(a(b,f(biW)))return 0===o[0]?c(biX):c(biY);if(a(b,f(biZ)))return c(bi0);if(a(b,f(bi1)))return c(bi2);if(a(b,f(bi3)))return c(bi4);if(a(b,f(bi5)))return c(bi6);if(a(b,f(bi7)))return c(bi8);var
i=x(C(b,f(bi9))),j=m(c(bi_),i);return t(c(bi$),j)}}return e(bjb,[0],function(e){var
b=E(j,i(eF,1,1)),c=h(l(j,i(dB,1,1)),b);return g(bja,h(l(d,i(F,1,1)),c))},k)}function
z(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bjc)))return 0===o[0]?c(bjd):c(bje);if(a(b,f(bjf)))return c(bjg);if(a(b,f(bjh)))return c(bji);if(a(b,f(bjj)))return c(bjk);if(a(b,f(bjl)))return c(bjm);if(a(b,f(bjn)))return c(bjo);var
d=x(C(b,f(bjp))),e=m(c(bjq),d);return t(c(bjr),e);case
1:if(a(b,f(bjs)))return 0===o[0]?c(bjt):c(bju);if(a(b,f(bjv)))return c(bjw);if(a(b,f(bjx)))return c(bjy);if(a(b,f(bjz)))return c(bjA);if(a(b,f(bjB)))return c(bjC);if(a(b,f(bjD)))return c(bjE);var
g=x(C(b,f(bjF))),h=m(c(bjG),g);return t(c(bjH),h);default:if(a(b,f(bjI)))return 0===o[0]?c(bjJ):c(bjK);if(a(b,f(bjL)))return c(bjM);if(a(b,f(bjN)))return c(bjO);if(a(b,f(bjP)))return c(bjQ);if(a(b,f(bjR)))return c(bjS);if(a(b,f(bjT)))return c(bjU);var
i=x(C(b,f(bjV))),j=m(c(bjW),i);return t(c(bjX),j)}}return e(bjZ,[0],function(e){var
b=E(j,i(dB,1,1)),c=h(l(j,i(dG,1,1)),b);return g(bjY,h(l(d,i(F,1,1)),c))},k)}function
B(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bj0)))return 0===o[0]?c(bj1):c(bj2);if(a(b,f(bj3)))return c(bj4);if(a(b,f(bj5)))return c(bj6);if(a(b,f(bj7)))return c(bj8);if(a(b,f(bj9)))return c(bj_);if(a(b,f(bj$)))return c(bka);var
d=x(C(b,f(bkb))),e=m(c(bkc),d);return t(c(bkd),e);case
1:if(a(b,f(bke)))return 0===o[0]?c(bkf):c(bkg);if(a(b,f(bkh)))return c(bki);if(a(b,f(bkj)))return c(bkk);if(a(b,f(bkl)))return c(bkm);if(a(b,f(bkn)))return c(bko);if(a(b,f(bkp)))return c(bkq);var
g=x(C(b,f(bkr))),h=m(c(bks),g);return t(c(bkt),h);default:if(a(b,f(bku)))return 0===o[0]?c(bkv):c(bkw);if(a(b,f(bkx)))return c(bky);if(a(b,f(bkz)))return c(bkA);if(a(b,f(bkB)))return c(bkC);if(a(b,f(bkD)))return c(bkE);if(a(b,f(bkF)))return c(bkG);var
i=x(C(b,f(bkH))),j=m(c(bkI),i);return t(c(bkJ),j)}}return e(bkL,[0],function(e){var
b=E(j,i(dG,1,1)),c=h(l(j,i(fP,1,1)),b);return g(bkK,h(l(d,i(F,1,1)),c))},k)}function
D(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bkM)))return 0===o[0]?c(bkN):c(bkO);if(a(b,f(bkP)))return c(bkQ);if(a(b,f(bkR)))return c(bkS);if(a(b,f(bkT)))return c(bkU);if(a(b,f(bkV)))return c(bkW);if(a(b,f(bkX)))return c(bkY);var
d=x(C(b,f(bkZ))),e=m(c(bk0),d);return t(c(bk1),e);case
1:if(a(b,f(bk2)))return 0===o[0]?c(bk3):c(bk4);if(a(b,f(bk5)))return c(bk6);if(a(b,f(bk7)))return c(bk8);if(a(b,f(bk9)))return c(bk_);if(a(b,f(bk$)))return c(bla);if(a(b,f(blb)))return c(blc);var
g=x(C(b,f(bld))),h=m(c(ble),g);return t(c(blf),h);default:if(a(b,f(blg)))return 0===o[0]?c(blh):c(bli);if(a(b,f(blj)))return c(blk);if(a(b,f(bll)))return c(blm);if(a(b,f(bln)))return c(blo);if(a(b,f(blp)))return c(blq);if(a(b,f(blr)))return c(bls);var
i=x(C(b,f(blt))),j=m(c(blu),i);return t(c(blv),j)}}return e(blx,[0],function(e){var
b=E(j,i(fP,1,1)),c=h(l(j,i(gH,1,1)),b);return g(blw,h(l(d,i(F,1,1)),c))},k)}function
G(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bly)))return 0===o[0]?c(blz):c(blA);if(a(b,f(blB)))return c(blC);if(a(b,f(blD)))return c(blE);if(a(b,f(blF)))return c(blG);if(a(b,f(blH)))return c(blI);if(a(b,f(blJ)))return c(blK);var
d=x(C(b,f(blL))),e=m(c(blM),d);return t(c(blN),e);case
1:if(a(b,f(blO)))return 0===o[0]?c(blP):c(blQ);if(a(b,f(blR)))return c(blS);if(a(b,f(blT)))return c(blU);if(a(b,f(blV)))return c(blW);if(a(b,f(blX)))return c(blY);if(a(b,f(blZ)))return c(bl0);var
g=x(C(b,f(bl1))),h=m(c(bl2),g);return t(c(bl3),h);default:if(a(b,f(bl4)))return 0===o[0]?c(bl5):c(bl6);if(a(b,f(bl7)))return c(bl8);if(a(b,f(bl9)))return c(bl_);if(a(b,f(bl$)))return c(bma);if(a(b,f(bmb)))return c(bmc);if(a(b,f(bmd)))return c(bme);var
i=x(C(b,f(bmf))),j=m(c(bmg),i);return t(c(bmh),j)}}return e(bmj,[0],function(e){var
b=E(j,i(gH,1,1)),c=h(l(j,i(fV,1,1)),b);return g(bmi,h(l(d,i(F,1,1)),c))},k)}function
H(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bmk)))return 0===o[0]?c(bml):c(bmm);if(a(b,f(bmn)))return c(bmo);if(a(b,f(bmp)))return c(bmq);if(a(b,f(bmr)))return c(bms);if(a(b,f(bmt)))return c(bmu);if(a(b,f(bmv)))return c(bmw);var
d=x(C(b,f(bmx))),e=m(c(bmy),d);return t(c(bmz),e);case
1:if(a(b,f(bmA)))return 0===o[0]?c(bmB):c(bmC);if(a(b,f(bmD)))return c(bmE);if(a(b,f(bmF)))return c(bmG);if(a(b,f(bmH)))return c(bmI);if(a(b,f(bmJ)))return c(bmK);if(a(b,f(bmL)))return c(bmM);var
g=x(C(b,f(bmN))),h=m(c(bmO),g);return t(c(bmP),h);default:if(a(b,f(bmQ)))return 0===o[0]?c(bmR):c(bmS);if(a(b,f(bmT)))return c(bmU);if(a(b,f(bmV)))return c(bmW);if(a(b,f(bmX)))return c(bmY);if(a(b,f(bmZ)))return c(bm0);if(a(b,f(bm1)))return c(bm2);var
i=x(C(b,f(bm3))),j=m(c(bm4),i);return t(c(bm5),j)}}return e(bm7,[0],function(e){var
b=E(j,i(fV,1,1)),c=h(l(j,i(f2,1,1)),b);return g(bm6,h(l(d,i(F,1,1)),c))},k)}function
I(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bm8)))return 0===o[0]?c(bm9):c(bm_);if(a(b,f(bm$)))return c(bna);if(a(b,f(bnb)))return c(bnc);if(a(b,f(bnd)))return c(bne);if(a(b,f(bnf)))return c(bng);if(a(b,f(bnh)))return c(bni);var
d=x(C(b,f(bnj))),e=m(c(bnk),d);return t(c(bnl),e);case
1:if(a(b,f(bnm)))return 0===o[0]?c(bnn):c(bno);if(a(b,f(bnp)))return c(bnq);if(a(b,f(bnr)))return c(bns);if(a(b,f(bnt)))return c(bnu);if(a(b,f(bnv)))return c(bnw);if(a(b,f(bnx)))return c(bny);var
g=x(C(b,f(bnz))),h=m(c(bnA),g);return t(c(bnB),h);default:if(a(b,f(bnC)))return 0===o[0]?c(bnD):c(bnE);if(a(b,f(bnF)))return c(bnG);if(a(b,f(bnH)))return c(bnI);if(a(b,f(bnJ)))return c(bnK);if(a(b,f(bnL)))return c(bnM);if(a(b,f(bnN)))return c(bnO);var
i=x(C(b,f(bnP))),j=m(c(bnQ),i);return t(c(bnR),j)}}return e(bnT,[0],function(e){var
b=E(j,i(f2,1,1)),c=h(l(j,i(g8,9,1)),b);return g(bnS,h(l(d,i(F,1,1)),c))},k)}function
J(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bnU)))return 0===o[0]?c(bnV):c(bnW);if(a(b,f(bnX)))return c(bnY);if(a(b,f(bnZ)))return c(bn0);if(a(b,f(bn1)))return c(bn2);if(a(b,f(bn3)))return c(bn4);if(a(b,f(bn5)))return c(bn6);var
d=x(C(b,f(bn7))),e=m(c(bn8),d);return t(c(bn9),e);case
1:if(a(b,f(bn_)))return 0===o[0]?c(bn$):c(boa);if(a(b,f(bob)))return c(boc);if(a(b,f(bod)))return c(boe);if(a(b,f(bof)))return c(bog);if(a(b,f(boh)))return c(boi);if(a(b,f(boj)))return c(bok);var
g=x(C(b,f(bol))),h=m(c(bom),g);return t(c(bon),h);default:if(a(b,f(boo)))return 0===o[0]?c(bop):c(boq);if(a(b,f(bor)))return c(bos);if(a(b,f(bot)))return c(bou);if(a(b,f(bov)))return c(bow);if(a(b,f(box)))return c(boy);if(a(b,f(boz)))return c(boA);var
i=x(C(b,f(boB))),j=m(c(boC),i);return t(c(boD),j)}}return e(boF,[0],function(e){var
b=E(j,i(g8,9,1)),c=h(l(j,i(gu,7,1)),b);return g(boE,h(l(d,i(F,1,1)),c))},k)}function
K(n){function
k(k){switch(r[0]){case
0:if(a(b,f(boG)))return 0===o[0]?c(boH):c(boI);if(a(b,f(boJ)))return c(boK);if(a(b,f(boL)))return c(boM);if(a(b,f(boN)))return c(boO);if(a(b,f(boP)))return c(boQ);if(a(b,f(boR)))return c(boS);var
d=x(C(b,f(boT))),e=m(c(boU),d);return t(c(boV),e);case
1:if(a(b,f(boW)))return 0===o[0]?c(boX):c(boY);if(a(b,f(boZ)))return c(bo0);if(a(b,f(bo1)))return c(bo2);if(a(b,f(bo3)))return c(bo4);if(a(b,f(bo5)))return c(bo6);if(a(b,f(bo7)))return c(bo8);var
g=x(C(b,f(bo9))),h=m(c(bo_),g);return t(c(bo$),h);default:if(a(b,f(bpa)))return 0===o[0]?c(bpb):c(bpc);if(a(b,f(bpd)))return c(bpe);if(a(b,f(bpf)))return c(bpg);if(a(b,f(bph)))return c(bpi);if(a(b,f(bpj)))return c(bpk);if(a(b,f(bpl)))return c(bpm);var
i=x(C(b,f(bpn))),j=m(c(bpo),i);return t(c(bpp),j)}}return e(bpr,[0],function(e){var
b=E(j,i(gu,7,1)),c=h(l(j,i(en,7,1)),b);return g(bpq,h(l(d,i(F,1,1)),c))},k)}function
L(n){function
k(k){switch(r[0]){case
0:if(a(b,f(bps)))return 0===o[0]?c(bpt):c(bpu);if(a(b,f(bpv)))return c(bpw);if(a(b,f(bpx)))return c(bpy);if(a(b,f(bpz)))return c(bpA);if(a(b,f(bpB)))return c(bpC);if(a(b,f(bpD)))return c(bpE);var
d=x(C(b,f(bpF))),e=m(c(bpG),d);return t(c(bpH),e);case
1:if(a(b,f(bpI)))return 0===o[0]?c(bpJ):c(bpK);if(a(b,f(bpL)))return c(bpM);if(a(b,f(bpN)))return c(bpO);if(a(b,f(bpP)))return c(bpQ);if(a(b,f(bpR)))return c(bpS);if(a(b,f(bpT)))return c(bpU);var
g=x(C(b,f(bpV))),h=m(c(bpW),g);return t(c(bpX),h);default:if(a(b,f(bpY)))return 0===o[0]?c(bpZ):c(bp0);if(a(b,f(bp1)))return c(bp2);if(a(b,f(bp3)))return c(bp4);if(a(b,f(bp5)))return c(bp6);if(a(b,f(bp7)))return c(bp8);if(a(b,f(bp9)))return c(bp_);var
i=x(C(b,f(bp$))),j=m(c(bqa),i);return t(c(bqb),j)}}return e(bqd,[0],function(e){var
b=E(j,i(en,7,1)),c=h(l(j,i(en,1,1)),b);return g(bqc,h(l(d,i(F,1,1)),c))},k)}function
M(n){function
k(l){switch(r[0]){case
0:if(a(b,f(bqe)))var
d=0===o[0]?c(bqf):c(bqg);else
if(a(b,f(bqh)))var
d=c(bqi);else
if(a(b,f(bqj)))var
d=c(bqk);else
if(a(b,f(bql)))var
d=c(bqm);else
if(a(b,f(bqn)))var
d=c(bqo);else
if(a(b,f(bqp)))var
d=c(bqq);else
var
e=x(C(b,f(bqr))),g=m(c(bqs),e),d=t(c(bqt),g);break;case
1:if(a(b,f(bqu)))var
d=0===o[0]?c(bqv):c(bqw);else
if(a(b,f(bqx)))var
d=c(bqy);else
if(a(b,f(bqz)))var
d=c(bqA);else
if(a(b,f(bqB)))var
d=c(bqC);else
if(a(b,f(bqD)))var
d=c(bqE);else
if(a(b,f(bqF)))var
d=c(bqG);else
var
h=x(C(b,f(bqH))),i=m(c(bqI),h),d=t(c(bqJ),i);break;default:if(a(b,f(bqK)))var
d=0===o[0]?c(bqL):c(bqM);else
if(a(b,f(bqN)))var
d=c(bqO);else
if(a(b,f(bqP)))var
d=c(bqQ);else
if(a(b,f(bqR)))var
d=c(bqS);else
if(a(b,f(bqT)))var
d=c(bqU);else
if(a(b,f(bqV)))var
d=c(bqW);else
var
j=x(C(b,f(bqX))),k=m(c(bqY),j),d=t(c(bqZ),k)}return m(d,A)}return e(bq1,[0],function(e){var
b=E(j,i(en,1,1)),c=h(l(j,i(fa,7,1)),b);return g(bq0,h(l(d,i(F,1,1)),c))},k)}function
N(n){function
k(l){switch(r[0]){case
0:if(a(b,f(bq2)))var
d=0===o[0]?c(bq3):c(bq4);else
if(a(b,f(bq5)))var
d=c(bq6);else
if(a(b,f(bq7)))var
d=c(bq8);else
if(a(b,f(bq9)))var
d=c(bq_);else
if(a(b,f(bq$)))var
d=c(bra);else
if(a(b,f(brb)))var
d=c(brc);else
var
e=x(C(b,f(brd))),g=m(c(bre),e),d=t(c(brf),g);break;case
1:if(a(b,f(brg)))var
d=0===o[0]?c(brh):c(bri);else
if(a(b,f(brj)))var
d=c(brk);else
if(a(b,f(brl)))var
d=c(brm);else
if(a(b,f(brn)))var
d=c(bro);else
if(a(b,f(brp)))var
d=c(brq);else
if(a(b,f(brr)))var
d=c(brs);else
var
h=x(C(b,f(brt))),i=m(c(bru),h),d=t(c(brv),i);break;default:if(a(b,f(brw)))var
d=0===o[0]?c(brx):c(bry);else
if(a(b,f(brz)))var
d=c(brA);else
if(a(b,f(brB)))var
d=c(brC);else
if(a(b,f(brD)))var
d=c(brE);else
if(a(b,f(brF)))var
d=c(brG);else
if(a(b,f(brH)))var
d=c(brI);else
var
j=x(C(b,f(brJ))),k=m(c(brK),j),d=t(c(brL),k)}return m(d,A)}return e(brN,[0],function(e){var
b=E(j,i(fa,7,1)),c=h(l(j,i(he,7,1)),b);return g(brM,h(l(d,i(F,1,1)),c))},k)}function
O(n){function
k(l){switch(r[0]){case
0:if(a(b,f(brO)))var
d=0===o[0]?c(brP):c(brQ);else
if(a(b,f(brR)))var
d=c(brS);else
if(a(b,f(brT)))var
d=c(brU);else
if(a(b,f(brV)))var
d=c(brW);else
if(a(b,f(brX)))var
d=c(brY);else
if(a(b,f(brZ)))var
d=c(br0);else
var
e=x(C(b,f(br1))),g=m(c(br2),e),d=t(c(br3),g);break;case
1:if(a(b,f(br4)))var
d=0===o[0]?c(br5):c(br6);else
if(a(b,f(br7)))var
d=c(br8);else
if(a(b,f(br9)))var
d=c(br_);else
if(a(b,f(br$)))var
d=c(bsa);else
if(a(b,f(bsb)))var
d=c(bsc);else
if(a(b,f(bsd)))var
d=c(bse);else
var
h=x(C(b,f(bsf))),i=m(c(bsg),h),d=t(c(bsh),i);break;default:if(a(b,f(bsi)))var
d=0===o[0]?c(bsj):c(bsk);else
if(a(b,f(bsl)))var
d=c(bsm);else
if(a(b,f(bsn)))var
d=c(bso);else
if(a(b,f(bsp)))var
d=c(bsq);else
if(a(b,f(bsr)))var
d=c(bss);else
if(a(b,f(bst)))var
d=c(bsu);else
var
j=x(C(b,f(bsv))),k=m(c(bsw),j),d=t(c(bsx),k)}return m(d,A)}return e(bsz,[0],function(e){var
b=E(j,i(he,7,1)),c=h(l(j,i(kH,7,1)),b);return g(bsy,h(l(d,i(F,1,1)),c))},k)}function
P(n){function
k(l){switch(r[0]){case
0:if(a(b,f(bsA)))var
d=0===o[0]?c(bsB):c(bsC);else
if(a(b,f(bsD)))var
d=c(bsE);else
if(a(b,f(bsF)))var
d=c(bsG);else
if(a(b,f(bsH)))var
d=c(bsI);else
if(a(b,f(bsJ)))var
d=c(bsK);else
if(a(b,f(bsL)))var
d=c(bsM);else
var
e=x(C(b,f(bsN))),g=m(c(bsO),e),d=t(c(bsP),g);break;case
1:if(a(b,f(bsQ)))var
d=0===o[0]?c(bsR):c(bsS);else
if(a(b,f(bsT)))var
d=c(bsU);else
if(a(b,f(bsV)))var
d=c(bsW);else
if(a(b,f(bsX)))var
d=c(bsY);else
if(a(b,f(bsZ)))var
d=c(bs0);else
if(a(b,f(bs1)))var
d=c(bs2);else
var
h=x(C(b,f(bs3))),i=m(c(bs4),h),d=t(c(bs5),i);break;default:if(a(b,f(bs6)))var
d=0===o[0]?c(bs7):c(bs8);else
if(a(b,f(bs9)))var
d=c(bs_);else
if(a(b,f(bs$)))var
d=c(bta);else
if(a(b,f(btb)))var
d=c(btc);else
if(a(b,f(btd)))var
d=c(bte);else
if(a(b,f(btf)))var
d=c(btg);else
var
j=x(C(b,f(bth))),k=m(c(bti),j),d=t(c(btj),k)}return m(d,A)}return e(btl,[0],function(e){var
b=E(j,i(kH,7,1)),c=h(l(j,i(lk,7,1)),b);return g(btk,h(l(d,i(F,1,1)),c))},k)}function
Q(n){function
k(l){switch(r[0]){case
0:if(a(b,f(btm)))var
d=0===o[0]?c(btn):c(bto);else
if(a(b,f(btp)))var
d=c(btq);else
if(a(b,f(btr)))var
d=c(bts);else
if(a(b,f(btt)))var
d=c(btu);else
if(a(b,f(btv)))var
d=c(btw);else
if(a(b,f(btx)))var
d=c(bty);else
var
e=x(C(b,f(btz))),g=m(c(btA),e),d=t(c(btB),g);break;case
1:if(a(b,f(btC)))var
d=0===o[0]?c(btD):c(btE);else
if(a(b,f(btF)))var
d=c(btG);else
if(a(b,f(btH)))var
d=c(btI);else
if(a(b,f(btJ)))var
d=c(btK);else
if(a(b,f(btL)))var
d=c(btM);else
if(a(b,f(btN)))var
d=c(btO);else
var
h=x(C(b,f(btP))),i=m(c(btQ),h),d=t(c(btR),i);break;default:if(a(b,f(btS)))var
d=0===o[0]?c(btT):c(btU);else
if(a(b,f(btV)))var
d=c(btW);else
if(a(b,f(btX)))var
d=c(btY);else
if(a(b,f(btZ)))var
d=c(bt0);else
if(a(b,f(bt1)))var
d=c(bt2);else
if(a(b,f(bt3)))var
d=c(bt4);else
var
j=x(C(b,f(bt5))),k=m(c(bt6),j),d=t(c(bt7),k)}return m(d,A)}return e(bt9,[0],function(e){var
b=E(j,i(lk,7,1)),c=h(l(j,i(zF,7,1)),b);return g(bt8,h(l(d,i(F,1,1)),c))},k)}function
R(n){function
k(l){switch(r[0]){case
0:if(a(b,f(bt_)))var
d=0===o[0]?c(bt$):c(bua);else
if(a(b,f(bub)))var
d=c(buc);else
if(a(b,f(bud)))var
d=c(bue);else
if(a(b,f(buf)))var
d=c(bug);else
if(a(b,f(buh)))var
d=c(bui);else
if(a(b,f(buj)))var
d=c(buk);else
var
e=x(C(b,f(bul))),g=m(c(bum),e),d=t(c(bun),g);break;case
1:if(a(b,f(buo)))var
d=0===o[0]?c(bup):c(buq);else
if(a(b,f(bur)))var
d=c(bus);else
if(a(b,f(but)))var
d=c(buu);else
if(a(b,f(buv)))var
d=c(buw);else
if(a(b,f(bux)))var
d=c(buy);else
if(a(b,f(buz)))var
d=c(buA);else
var
h=x(C(b,f(buB))),i=m(c(buC),h),d=t(c(buD),i);break;default:if(a(b,f(buE)))var
d=0===o[0]?c(buF):c(buG);else
if(a(b,f(buH)))var
d=c(buI);else
if(a(b,f(buJ)))var
d=c(buK);else
if(a(b,f(buL)))var
d=c(buM);else
if(a(b,f(buN)))var
d=c(buO);else
if(a(b,f(buP)))var
d=c(buQ);else
var
j=x(C(b,f(buR))),k=m(c(buS),j),d=t(c(buT),k)}return m(d,A)}return e(buV,[0],function(e){var
b=E(j,i(zF,7,1)),c=h(l(j,i(cU,7,1)),b);return g(buU,h(l(d,i(F,1,1)),c))},k)}return e(bvI,[0,function(n){function
k(l){switch(r[0]){case
0:if(a(b,f(buW)))var
d=0===o[0]?c(buX):c(buY);else
if(a(b,f(buZ)))var
d=c(bu0);else
if(a(b,f(bu1)))var
d=c(bu2);else
if(a(b,f(bu3)))var
d=c(bu4);else
if(a(b,f(bu5)))var
d=c(bu6);else
if(a(b,f(bu7)))var
d=c(bu8);else
var
e=x(C(b,f(bu9))),g=m(c(bu_),e),d=t(c(bu$),g);break;case
1:if(a(b,f(bva)))var
d=0===o[0]?c(bvb):c(bvc);else
if(a(b,f(bvd)))var
d=c(bve);else
if(a(b,f(bvf)))var
d=c(bvg);else
if(a(b,f(bvh)))var
d=c(bvi);else
if(a(b,f(bvj)))var
d=c(bvk);else
if(a(b,f(bvl)))var
d=c(bvm);else
var
h=x(C(b,f(bvn))),i=m(c(bvo),h),d=t(c(bvp),i);break;default:if(a(b,f(bvq)))var
d=0===o[0]?c(bvr):c(bvs);else
if(a(b,f(bvt)))var
d=c(bvu);else
if(a(b,f(bvv)))var
d=c(bvw);else
if(a(b,f(bvx)))var
d=c(bvy);else
if(a(b,f(bvz)))var
d=c(bvA);else
if(a(b,f(bvB)))var
d=c(bvC);else
var
j=x(C(b,f(bvD))),k=m(c(bvE),j),d=t(c(bvF),k)}return m(d,A)}return e(bvH,[0],function(e){var
b=E(j,i(cU,7,1)),c=h(l(j,i(fg,7,1)),b);return g(bvG,h(l(d,i(F,1,1)),c))},k)},R,Q,P,O,N,M,L,K,J,I,H,G,D,B,z,y,w,v,u,s,q],p,n)},s=e(bvJ,[0],function(b){return 1},p);return s}catch(b){b=n(b);if(b===k)throw[0,q,bev];throw b}});try{var
aY=function(q){function
b(b){throw k}function
j(b){return 0}function
n(j){function
b(e){if(a(p,f(bvN)))return c(bvO);var
b=x(p),d=m(c(bvP),b);return t(c(bvQ),d)}return e(bvS,[0],function(c){var
b=E(d,i(U,10,1));return g(bvR,h(l(d,i(F,10,1)),b))},b)}function
o(j){function
b(d){if(a(p,f(bvT)))return c(bvU);var
b=m(c(bvV),I);return t(c(bvW),b)}return e(bvY,[0],function(c){var
b=E(d,i(G,7,1));return g(bvX,h(l(d,i(U,10,1)),b))},b)}return e(bv5,[0,function(h){function
b(d){if(a(p,f(bvZ)))return c(bv0);var
b=m(c(bv1),I);return t(c(bv2),b)}return e(bv4,[0],function(b){return g(bv3,l(d,i(G,7,1)))},b)},o,n],j,b)},a0=function(b){return 1},a1=e(bxO,[0,function(j){function
f(n){function
b(b){throw k}function
f(b){return 0}function
a(f){function
b(f){var
b=x(p),d=m(c(bv6),b),e=0===o[0]?c(bv7):c(bv8);return t(e,d)}return e(bv_,[0],function(c){var
b=E(d,i(U,10,1));return g(bv9,h(h(l(d,i(F,10,1)),b),z))},b)}function
j(f){function
b(f){var
b=x(p),d=m(c(bv$),b),e=0===o[0]?c(bwa):c(bwb);return t(e,d)}return e(bwd,[0],function(c){var
b=E(d,i(G,7,1));return g(bwc,h(h(l(d,i(U,10,1)),b),z))},b)}return e(bwj,[0,function(f){function
b(e){var
b=m(c(bwe),I),d=0===o[0]?c(bwf):c(bwg);return t(d,b)}return e(bwi,[0],function(b){return g(bwh,h(l(d,i(G,7,1)),z))},b)},j,a],f,b)}function
a(b){return 1}return e(bxN,[0,function(j){function
f(r){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(h){var
e=x(p),f=m(c(bwk),e),b=t(c(bwl),f),a=s(bwm),g=m(c(bwn),a),d=t(c(bwo),g);return aZ(b,d)?d:b}return e(bwq,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(F,10,1));return g(bwp,h(h(l(d,i(F,1,1)),e),c))},f)}function
n(a){function
f(h){var
e=x(p),f=m(c(bwr),e),b=t(c(bws),f),a=s(bwt),g=m(c(bwu),a),d=t(c(bwv),g);return aZ(b,d)?d:b}return e(bwx,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(U,10,1));return g(bww,h(h(l(d,i(F,10,1)),e),c))},f)}function
o(j){function
f(h){var
e=x(p),f=m(c(bwy),e),b=t(c(bwz),f),a=s(bwA),g=m(c(bwB),a),d=t(c(bwC),g);return aZ(b,d)?d:b}function
a(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(G,7,1));return g(bwD,h(h(l(d,i(G,1,1)),e),c))}return e(bwL,[0,function(a){function
f(h){var
e=x(p),f=m(c(bwE),e),b=t(c(bwF),f),a=s(bwG),g=m(c(bwH),a),d=t(c(bwI),g);return aZ(b,d)?d:b}return e(bwK,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(G,1,1));return g(bwJ,h(h(l(d,i(U,10,1)),e),c))},f)}],a,f)}function
q(a){function
f(h){var
e=x(p),f=m(c(bwM),e),b=t(c(bwN),f),a=s(bwO),g=m(c(bwP),a),d=t(c(bwQ),g);return aZ(b,d)?d:b}return e(bwS,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(aI,1,1));return g(bwR,h(h(l(d,i(G,7,1)),e),c))},f)}return e(bwX,[0,function(a){function
f(d){var
b=m(c(bwT),I);return t(c(bwU),b)}return e(bwW,[0],function(e){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bwV,h(l(d,i(aI,1,1)),c))},f)},q,o,n,j],a,f)}function
a(b){return 1}return e(bxM,[0,function(a){function
f(u){function
f(b){throw k}function
a(b){return 0}function
j(a){function
f(j){var
e=x(p),f=m(c(bwY),e),a=0===o[0]?c(bwZ):c(bw4),b=t(a,f),g=s(bw0),h=m(c(bw1),g),i=0===o[0]?c(bw2):c(bw3),d=t(i,h);return aZ(b,d)?d:b}return e(bw6,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(F,10,1));return g(bw5,h(h(l(d,i(F,1,1)),e),c))},f)}function
n(a){function
f(j){var
e=x(p),f=m(c(bw7),e),a=0===o[0]?c(bw8):c(bxb),b=t(a,f),g=s(bw9),h=m(c(bw_),g),i=0===o[0]?c(bw$):c(bxa),d=t(i,h);return aZ(b,d)?d:b}return e(bxd,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(U,10,1));return g(bxc,h(h(l(d,i(F,10,1)),e),c))},f)}function
q(j){function
f(j){var
e=x(p),f=m(c(bxe),e),a=0===o[0]?c(bxf):c(bxk),b=t(a,f),g=s(bxg),h=m(c(bxh),g),i=0===o[0]?c(bxi):c(bxj),d=t(i,h);return aZ(b,d)?d:b}function
a(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(G,7,1));return g(bxl,h(h(l(d,i(G,1,1)),e),c))}return e(bxv,[0,function(a){function
f(j){var
e=x(p),f=m(c(bxm),e),a=0===o[0]?c(bxn):c(bxs),b=t(a,f),g=s(bxo),h=m(c(bxp),g),i=0===o[0]?c(bxq):c(bxr),d=t(i,h);return aZ(b,d)?d:b}return e(bxu,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(G,1,1));return g(bxt,h(h(l(d,i(U,10,1)),e),c))},f)}],a,f)}function
r(a){function
f(j){var
e=x(p),f=m(c(bxw),e),a=0===o[0]?c(bxx):c(bxC),b=t(a,f),g=s(bxy),h=m(c(bxz),g),i=0===o[0]?c(bxA):c(bxB),d=t(i,h);return aZ(b,d)?d:b}return e(bxE,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(aI,1,1));return g(bxD,h(h(l(d,i(G,7,1)),e),c))},f)}return e(bxK,[0,function(a){function
f(e){var
b=m(c(bxF),I),d=0===o[0]?c(bxG):c(bxH);return t(d,b)}return e(bxJ,[0],function(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(c,z);return g(bxI,h(l(d,i(aI,1,1)),e))},f)},r,q,n,j],a,f)}return e(bxL,[0],function(b){return 1},f)}],a,f)}],a,f)}],a0,aY)}catch(b){b=n(b);if(b===k)throw[0,q,bvM];throw b}var
S=j(bxQ,bxP,D,a1);try{var
a2=function(f){function
b(b){throw k}function
c(b){return 0}function
d(c){function
b(b){return aG}return e(bxT,[0],function(c){switch(y[0]){case
0:var
b=0;break;case
1:var
b=1;break;case
2:var
b=0;break;default:var
b=0}return g(bxS,h(c9(w,i(cU,9,30)),b))},b)}return e(bxW,[0,function(c){function
b(b){return m(M,az)}return e(bxV,[0],function(k){switch(y[0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=1;break;default:var
b=0}switch(y[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=0;break;default:var
c=0}var
e=H(c,b);switch(y[0]){case
0:var
d=0;break;case
1:var
d=0;break;case
2:var
d=0;break;default:var
d=1}var
f=H(d,e),a=h(c9(w,i(cU,9,30)),f),j=ag(w,i(cU,9,30));return g(bxU,H(h(l(w,i(fg,9,30)),j),a))},b)},d],c,b)},a3=e(bxX,[0],function(b){return 1},a2)}catch(b){b=n(b);if(b===k)throw[0,q,bxR];throw b}var
T=j(bxZ,bxY,D,a3),a4=j(bx6,bx5,ay,function(b){try{var
d=function(e){var
d=c(bx1);return cw(aC(b,R),d)?c(bx2):aC(b,R)},f=e(bx4,[0],function(b){return g(bx3,1)},d);return f}catch(b){b=n(b);if(b===k)throw[0,q,bx0];throw b}}),B=j(byM,byL,ay,function(c,b){try{var
f=function(e){var
d=j(bx9,bx8,bA,b);return O(byc,j(byb,bya,D,ar(K,j(bx$,bx_,aK,c),d)))},a=function(b){return g(byd,l(d,i(F,1,1)))},o=e(byK,[0,function(a){function
f(n){function
f(b){throw k}function
a(b){return 0}return e(byI,[0,function(k){function
f(f){var
d=s(bye),e=j(byg,byf,bA,b);return m(O(byl,j(byk,byj,D,ar(K,j(byi,byh,aK,c),e))),d)}function
a(b){return g(bym,h(l(d,i(G,7,1)),z))}return e(byH,[0,function(k){function
f(f){var
d=s(byn),e=j(byp,byo,bA,b);return m(O(byu,j(byt,bys,D,ar(K,j(byr,byq,aK,c),e))),d)}function
a(c){var
b=E(d,i(G,7,1));return g(byv,h(h(l(d,i(U,10,1)),b),z))}return e(byG,[0,function(a){function
f(f){var
d=s(byw),e=j(byy,byx,bA,b);return m(O(byD,j(byC,byB,D,ar(K,j(byA,byz,aK,c),e))),d)}return e(byF,[0],function(c){var
b=E(d,i(U,10,1));return g(byE,h(h(l(d,i(F,10,1)),b),z))},f)}],a,f)}],a,f)}],a,f)}return e(byJ,[0],function(b){return 1},f)}],a,f);return o}catch(b){b=n(b);if(b===k)throw[0,q,bx7];throw b}}),a5=j(byR,byQ,ay,function(b){try{var
c=function(c){return aC(t(ac,S),b)},d=e(byP,[0],function(b){return g(byO,1)},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,byN];throw b}});try{var
a6=function(e){if(bU(L,T)){var
b=s(byT),d=s(byU);return m(fI(m(t(T,c(byV)),d)),b)}return L},a7=function(b){return g(byW,1)},a8=e(byZ,[0,function(c){function
b(b){return L}return e(byY,[0],function(b){return g(byX,$)},b)}],a7,a6)}catch(b){b=n(b);if(b===k)throw[0,q,byS];throw b}var
N=j(by1,by0,D,a8),P=j(bz6,bz5,ay,function(c,a){try{var
m=function(d){var
b=j(by4,by3,bA,a);return O(by9,j(by8,by7,D,ar(B,j(by6,by5,aK,c),b)))},o=function(b){return g(by_,l(d,i(F,1,1)))},p=e(bz4,[0,function(n){function
m(o){function
m(b){throw k}function
n(b){return 0}return e(bz2,[0,function(n){function
k(d){var
b=j(bzb,bza,bA,f(by$));return O(bzg,j(bzf,bze,D,ar(B,j(bzd,bzc,aK,c),b)))}function
m(k){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(aL(a,f(bzh)),c),j=E(d,i(aI,1,1));return g(bzi,h(h(l(d,i(G,7,1)),j),e))}return e(bz1,[0,function(n){function
k(d){var
b=j(bzl,bzk,bA,f(bzj));return O(bzq,j(bzp,bzo,D,ar(B,j(bzn,bzm,aK,c),b)))}function
m(k){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(aL(a,f(bzr)),c),j=E(d,i(G,7,1));return g(bzs,h(h(l(d,i(G,1,1)),j),e))}return e(bz0,[0,function(n){function
k(d){var
b=j(bzv,bzu,bA,f(bzt));return O(bzA,j(bzz,bzy,D,ar(B,j(bzx,bzw,aK,c),b)))}function
m(k){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(aL(a,f(bzB)),c),j=E(d,i(G,1,1));return g(bzC,h(h(l(d,i(U,10,1)),j),e))}return e(bzZ,[0,function(n){function
k(d){var
b=j(bzF,bzE,bA,f(bzD));return O(bzK,j(bzJ,bzI,D,ar(B,j(bzH,bzG,aK,c),b)))}function
m(k){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(aL(a,f(bzL)),c),j=E(d,i(U,10,1));return g(bzM,h(h(l(d,i(F,10,1)),j),e))}return e(bzY,[0,function(m){function
k(d){var
b=j(bzP,bzO,bA,f(bzN));return O(bzU,j(bzT,bzS,D,ar(B,j(bzR,bzQ,aK,c),b)))}return e(bzX,[0],function(k){switch(b[0]){case
0:var
c=1;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=h(aL(a,f(bzV)),c),j=E(d,i(F,10,1));return g(bzW,h(h(l(d,i(F,1,1)),j),e))},k)}],m,k)}],m,k)}],m,k)}],m,k)}],n,m)}return e(bz3,[0],function(b){return 1},m)}],o,m);return p}catch(b){b=n(b);if(b===k)throw[0,q,by2];throw b}});try{var
a9=function(b){return d},a_=j(bz$,bz_,aK,e(bz9,[0],function(b){return g(bz8,1)},a9))}catch(b){b=n(b);if(b===k)throw[0,q,bz7];throw b}try{var
a$=function(b){return N},ba=j(bAe,bAd,D,e(bAc,[0],function(b){return g(bAb,1)},a$))}catch(b){b=n(b);if(b===k)throw[0,q,bAa];throw b}try{var
bb=function(b){return 1},bc=j(bAj,bAi,ai,e(bAh,[0],function(b){return g(bAg,1)},bb))}catch(b){b=n(b);if(b===k)throw[0,q,bAf];throw b}try{var
bd=function(b){return al},be=j(bAo,bAn,aS,e(bAm,[0],function(b){return g(bAl,1)},bd))}catch(b){b=n(b);if(b===k)throw[0,q,bAk];throw b}var
bf=O(bAq,u(Q(bAp,hX),[0,a_,ba,bc,be]))[1];try{var
bg=function(c){return b},bh=j(bAv,bAu,cc,e(bAt,[0],function(b){return g(bAs,1)},bg))}catch(b){b=n(b);if(b===k)throw[0,q,bAr];throw b}try{var
bi=function(b){return 0},bj=j(bAA,bAz,ai,e(bAy,[0],function(b){return g(bAx,1)},bi))}catch(b){b=n(b);if(b===k)throw[0,q,bAw];throw b}try{var
bk=function(b){return bAC},bl=j(bAG,bAF,hU,e(bAE,[0],function(b){return g(bAD,1)},bk))}catch(b){b=n(b);if(b===k)throw[0,q,bAB];throw b}try{var
bm=function(b){return i(1970,1,1)},bn=j(bAL,bAK,aK,e(bAJ,[0],function(b){return g(bAI,1)},bm))}catch(b){b=n(b);if(b===k)throw[0,q,bAH];throw b}try{var
bo=function(b){return N},bp=j(bAQ,bAP,D,e(bAO,[0],function(b){return g(bAN,1)},bo))}catch(b){b=n(b);if(b===k)throw[0,q,bAM];throw b}try{var
bq=function(b){return p},br=j(bAV,bAU,bA,e(bAT,[0],function(b){return g(bAS,1)},bq))}catch(b){b=n(b);if(b===k)throw[0,q,bAR];throw b}try{var
bs=function(b){return o},bt=j(bA0,bAZ,cS,e(bAY,[0],function(b){return g(bAX,1)},bs))}catch(b){b=n(b);if(b===k)throw[0,q,bAW];throw b}try{var
bu=function(b){return r},bv=j(bA5,bA4,dw,e(bA3,[0],function(b){return g(bA2,1)},bu))}catch(b){b=n(b);if(b===k)throw[0,q,bA1];throw b}try{var
bw=function(b){return d},bx=j(bA_,bA9,aK,e(bA8,[0],function(b){return g(bA7,1)},bw))}catch(b){b=n(b);if(b===k)throw[0,q,bA6];throw b}try{var
by=function(b){return c(bBa)},bz=j(bBe,bBd,D,e(bBc,[0],function(b){return g(bBb,1)},by))}catch(b){b=n(b);if(b===k)throw[0,q,bA$];throw b}var
bB=function(c){function
b(b){return 1}return j(bBi,bBh,ai,e(bBg,[0],function(b){return g(bBf,1)},b))},bC=function(f){function
c(a){function
c(b){throw k}function
f(b){return 0}return e(bBn,[0,function(a){function
c(b){return 1}function
f(f){switch(b[0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}var
e=E(d,i(aI,4,5));return g(bBj,h(h(l(d,i(W,9,1)),e),c))}return e(bBm,[0,function(f){function
c(b){return 1}return e(bBl,[0],function(f){switch(b[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}var
e=E(d,i(aI,4,5));return g(bBk,h(h(l(d,i(W,9,1)),e),c))},c)}],f,c)}],f,c)}return j(bBq,bBp,ai,e(bBo,[0],function(b){return 1},c))},bD=[0,bh,bj,bl,bn,bp,br,bt,bv,bx,bz,bB,bC,function(b){throw k}],bE=O(bBs,u(Q(bBr,jL),bD))[7];try{var
bF=function(b){return aM},bG=function(b){return g(bBu,1)},bH=e(bBx,[0,function(c){function
b(b){return m(N,aD)}return e(bBw,[0],function(b){return g(bBv,aX)},b)}],bG,bF)}catch(b){b=n(b);if(b===k)throw[0,q,bBt];throw b}var
V=j(bBz,bBy,D,bH);try{var
bI=function(c){var
b=j(bBC,bBB,bA,p);return O(bBH,j(bBG,bBF,D,ar(P,j(bBE,bBD,aK,w),b)))},bJ=function(b){return g(bBI,1)},bK=e(bBZ,[0,function(c){function
b(f){var
d=j(bBK,bBJ,bA,p),b=O(bBP,j(bBO,bBN,D,ar(P,j(bBM,bBL,aK,w),d))),e=j(bBR,bBQ,bA,p),c=O(bBW,j(bBV,bBU,D,ar(P,j(bBT,bBS,aK,ab),e)));return cw(b,c)?c:b}return e(bBY,[0],function(b){return g(bBX,aa)},b)}],bJ,bI)}catch(b){b=n(b);if(b===k)throw[0,q,bBA];throw b}var
X=j(bB1,bB0,D,bK);try{var
bL=function(b){return bf},bN=e(bB4,[0],function(b){return g(bB3,1)},bL)}catch(b){b=n(b);if(b===k)throw[0,q,bB2];throw b}var
Y=j(bB6,bB5,D,bN);try{var
bO=function(b){return bE},bP=e(bB9,[0],function(b){return g(bB8,1)},bO)}catch(b){b=n(b);if(b===k)throw[0,q,bB7];throw b}var
Z=j(bB$,bB_,aS,bP),bQ=j(bCl,bCk,ay,function(d){try{var
b=function(f){var
e=j(bCc,bCb,D,d),b=O(bCg,j(bCf,bCe,D,u(Q(bCd,a5),e)));return cw(b,V)?aC(V,b):c(bCh)},f=e(bCj,[0],function(b){return g(bCi,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,bCa];throw b}});try{var
bR=function(b){return aZ(M,X)?X:M},bS=e(bCo,[0],function(b){return g(bCn,1)},bR)}catch(b){b=n(b);if(b===k)throw[0,q,bCm];throw b}var
_=j(bCq,bCp,D,bS),bV=j(bCI,bCH,ay,function(f){try{var
b=function(g){var
e=j(bCt,bCs,D,f),b=O(bCx,j(bCw,bCv,D,u(Q(bCu,a4),e))),a=j(bCz,bCy,D,b),d=O(bCD,j(bCC,bCB,D,u(Q(bCA,bQ),a)));return cw(b,d)?c(bCE):aC(b,d)},d=e(bCG,[0],function(b){return g(bCF,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,bCr];throw b}});try{var
bW=function(b){return m(aC(t(_,S),Y),Z)},bX=e(bCL,[0],function(b){return g(bCK,1)},bW)}catch(b){b=n(b);if(b===k)throw[0,q,bCJ];throw b}var
bY=j(bCN,bCM,D,bX),bZ=j(bC7,bC6,ay,function(f){try{var
b=function(k){var
a=j(bCQ,bCP,D,f),d=O(bCU,j(bCT,bCS,D,u(Q(bCR,bV),a))),g=j(bCW,bCV,D,d),b=O(bC0,j(bCZ,bCY,D,u(Q(bCX,as),g))),h=c(bC1),e=fI(aC(aC(d,b),h)),i=c(bC2);return cb(t(e,b),i)?t(e,b):c(bC3)},d=e(bC5,[0],function(b){return g(bC4,1)},b);return d}catch(b){b=n(b);if(b===k)throw[0,q,bCO];throw b}}),b0=j(bDg,bDf,ay,function(c){try{var
f=function(f){var
e=j(bC_,bC9,D,c);return oQ(O(bDc,j(bDb,bDa,D,u(Q(bC$,bZ),e))),b,d)},a=e(bDe,[0],function(b){return g(bDd,1)},f);return a}catch(b){b=n(b);if(b===k)throw[0,q,bC8];throw b}});return[0,_,Y,Z,bY,j(bDs,bDr,ay,function(d){try{var
b=function(f){var
e=j(bDj,bDi,D,d),b=O(bDn,j(bDm,bDl,D,u(Q(bDk,b0),e)));return cw(b,aP)?c(bDo):b},f=e(bDq,[0],function(b){return g(bDp,1)},b);return f}catch(b){b=n(b);if(b===k)throw[0,q,bDh];throw b}})]}throw[0,bT,bDt]}throw[0,bT,bDu]}function
jM(o){var
b=o[1],p=o[2],d=o[3],J=o[4],K=o[5],L=o[6];try{var
M=function(c){function
b(b){return i(U,1,1)}return e(bDx,[0],function(b){return g(bDw,1)},b)},N=function(b){return 1},P=e(bDy,[0,function(b){return u(L,0)}],N,M)}catch(b){b=n(b);if(b===k)throw[0,q,bDv];throw b}var
R=j(bDA,bDz,aK,P);try{var
S=function(b){return s(bDC)},T=e(bDE,[0],function(b){return g(bDD,1)},S)}catch(b){b=n(b);if(b===k)throw[0,q,bDB];throw b}var
t=j(bDG,bDF,aS,T);try{var
V=function(b){return s(bDI)},X=e(bDK,[0],function(b){return g(bDJ,1)},V)}catch(b){b=n(b);if(b===k)throw[0,q,bDH];throw b}var
v=j(bDM,bDL,aS,X);try{var
Y=function(e){var
c=0===b[2][5][0]?1:0,d=0===b[2][3][0]?1:0;return H(d,c)},Z=e(bDP,[0],function(b){return g(bDO,1)},Y)}catch(b){b=n(b);if(b===k)throw[0,q,bDN];throw b}var
w=j(bDR,bDQ,ai,Z);try{var
_=function(a){var
d=b[3].length-1,e=b[4];switch(b[5][0]){case
0:var
c=f(bDT);break;case
1:var
c=f(bDU);break;case
2:var
c=f(bDV);break;case
3:var
c=f(bDW);break;case
4:var
c=f(bDX);break;default:var
c=f(bDY)}return hR(hR(c,e),d)},$=e(bD0,[0],function(b){return g(bDZ,1)},_)}catch(b){b=n(b);if(b===k)throw[0,q,bDS];throw b}var
r=j(bD2,bD1,bA,$);try{var
aa=function(b){return 0},ab=function(b){return g(bD4,1)},ac=e(bD9,[0,function(f){function
c(b){return 1}function
d(b){return g(bD5,1)}return e(bD8,[0,function(d){function
c(b){return 0}return e(bD7,[0],function(d){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bD6,c)},c)}],d,c)}],ab,aa)}catch(b){b=n(b);if(b===k)throw[0,q,bD3];throw b}var
ad=j(bD$,bD_,ai,ac);try{var
ae=function(b){return 0},af=function(b){return g(bEb,1)},ah=e(bEe,[0,function(d){function
c(b){return 1}return e(bEd,[0],function(c){return g(bEc,1-b[2][6])},c)}],af,ae)}catch(b){b=n(b);if(b===k)throw[0,q,bEa];throw b}var
aj=j(bEg,bEf,ai,ah);try{var
ak=function(b){return 0},al=function(b){return g(bEi,1)},am=e(bEl,[0,function(d){function
c(b){return 1}return e(bEk,[0],function(c){return g(bEj,b[6])},c)}],al,ak)}catch(b){b=n(b);if(b===k)throw[0,q,bEh];throw b}var
an=j(bEn,bEm,ai,am);try{var
ao=function(f){function
c(b){return 0}function
d(b){return g(bEp,1)}return e(bEs,[0,function(d){function
c(b){return 1}return e(bEr,[0],function(c){return g(bEq,b[2][1])},c)}],d,c)},ap=function(b){return 1},aq=e(bEt,[0,function(b){return u(J,0)}],ap,ao)}catch(b){b=n(b);if(b===k)throw[0,q,bEo];throw b}var
ar=j(bEv,bEu,ai,aq);try{var
as=function(b){return p[1]},at=j(bEA,bEz,aK,e(bEy,[0],function(b){return g(bEx,1)},as))}catch(b){b=n(b);if(b===k)throw[0,q,bEw];throw b}var
au=O(bEC,u(Q(bEB,tN),[0,at]))[1];try{var
av=function(c){var
b=p[2];return 0===b[0]?1:b[1][1]},aw=function(b){return g(bEE,1)},ax=e(bEH,[0,function(d){function
c(c){var
b=p[2];return 0===b[0]?0:b[1][2]}return e(bEG,[0],function(d){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bEF,c)},c)}],aw,av)}catch(b){b=n(b);if(b===k)throw[0,q,bED];throw b}var
az=j(bEJ,bEI,ai,ax);try{var
aA=l(d,i(cI,4,1))}catch(b){b=n(b);if(b===k)throw[0,q,bEK];throw b}if(aA){try{var
aB=function(p){function
b(b){throw k}function
f(b){return 0}function
a(f){function
b(b){return c(bEM)}return e(bEO,[0],function(c){var
b=E(d,i(G,1,1));return g(bEN,h(l(d,i(U,1,1)),b))},b)}function
j(f){function
b(b){return c(bEP)}return e(bER,[0],function(c){var
b=E(d,i(aI,1,1));return g(bEQ,h(l(d,i(G,1,1)),b))},b)}function
m(f){function
b(b){return c(bES)}return e(bEU,[0],function(b){return g(bET,l(d,i(aI,1,1)))},b)}function
n(f){function
b(b){return c(bEV)}return e(bEX,[0],function(c){var
b=E(d,i(U,1,1));return g(bEW,h(l(d,i(F,1,1)),b))},b)}function
o(f){function
b(b){return c(bEY)}return e(bE0,[0],function(c){var
b=E(d,i(F,1,1));return g(bEZ,h(l(d,i(W,1,1)),b))},b)}return e(bE4,[0,function(f){function
b(b){return c(bE1)}return e(bE3,[0],function(c){var
b=E(d,i(W,1,1));return g(bE2,h(l(d,i(cI,4,1)),b))},b)},o,n,m,j,a],f,b)},aC=e(bE5,[0],function(b){return 1},aB)}catch(b){b=n(b);if(b===k)throw[0,q,bEL];throw b}var
x=j(bE7,bE6,D,aC);try{var
aD=function(b){return 0},aE=function(b){return g(bE9,1)},aF=e(bFj,[0,function(a){function
c(b){return 0}function
f(d){var
c=0===b[2][4][0]?1:0;return g(bE_,c)}return e(bFi,[0,function(f){function
c(b){return 1}return e(bFh,[0],function(k){var
c=b[2][4];if(0===c[0])var
e=1;else{var
f=c[1],a=f[2],h=j(bFb,bFa,tM,[0,f[1],d,[0,30,0,0]]),i=[0,u(Q(bFc,oP),h)[1]];g(bFd,1);var
e=H(O(bFg,j(bFf,bFe,tF,i))[1],a)}return g(bE$,e)},c)}],f,c)}],aE,aD)}catch(b){b=n(b);if(b===k)throw[0,q,bE8];throw b}var
aG=j(bFl,bFk,ai,aF);try{var
aH=function(b){return d},aJ=j(bFq,bFp,aK,e(bFo,[0],function(b){return g(bFn,1)},aH))}catch(b){b=n(b);if(b===k)throw[0,q,bFm];throw b}try{var
aM=function(c){return b[9]},aN=j(bFv,bFu,cc,e(bFt,[0],function(b){return g(bFs,1)},aM))}catch(b){b=n(b);if(b===k)throw[0,q,bFr];throw b}var
aO=[0,aJ,aN,function(a){function
c(b){return[0,21,0,0]}function
f(b){return g(bFw,1)}return j(bFF,bFE,dT,e(bFD,[0,function(f){function
c(a){function
c(b){throw k}function
f(b){return 0}return e(bFB,[0,function(a){function
c(b){return[0,22,0,0]}function
f(d){switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bFx,c)}return e(bFA,[0,function(f){function
c(b){return[0,22,0,0]}return e(bFz,[0],function(e){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}return g(bFy,h(l(d,R),c))},c)}],f,c)}],f,c)}return e(bFC,[0],function(b){return 1},c)}],f,c))}],y=O(bFH,u(Q(bFG,oR),aO)),z=y[1],aP=y[2];try{var
aQ=d9(t,s(bFJ))}catch(b){b=n(b);if(b===k)throw[0,q,bFI];throw b}if(aQ){try{var
aR=d9(v,s(bFL))}catch(b){b=n(b);if(b===k)throw[0,q,bFK];throw b}if(aR){try{var
aT=function(b){return 0},aU=function(b){return g(bFN,1)},aV=e(bFW,[0,function(f){function
c(b){return 1}function
d(d){switch(b[2][2][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=b[2][1];break;case
3:var
c=1;break;default:var
c=1}return g(bFO,c)}return e(bFV,[0,function(f){function
c(b){return 0}function
d(d){switch(b[2][2][0]){case
0:var
c=w;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bFP,c)}return e(bFU,[0,function(d){function
c(b){return 1}return e(bFT,[0],function(i){var
c=b[2][5],e=0===c[0]?c[1]:s(bFS),f=d9(e,v),d=b[2][3],a=0===d[0]?d[1]:s(bFR);return g(bFQ,h(w,h(d9(a,t),f)))},c)}],d,c)}],d,c)}],aU,aT)}catch(b){b=n(b);if(b===k)throw[0,q,bFM];throw b}var
A=j(bFY,bFX,ai,aV);try{var
aW=function(i){function
c(b){return 0}function
d(b){return g(bF0,1)}return e(bGj,[0,function(i){function
c(b){return 1}function
d(l){var
i=f(bF1),a=cC(hR(b[4],b[3].length-1),i);switch(b[5][0]){case
0:var
c=f(bF2);break;case
1:var
c=f(bF7);break;case
2:var
c=f(bF8);break;case
3:var
c=f(bF9);break;case
4:var
c=f(bF_);break;default:var
c=f(bF$)}var
d=hR(c,a),j=aL(r,f(bF3));if(h(aL(d,f(bF4)),j))var
k=f(bF5),e=aL(b[2][7],k);else
var
e=aL(b[2][7],d);return g(bF6,e)}return e(bGi,[0,function(i){function
c(b){return 1}function
d(e){var
c=a(r,f(bGa))?f(bGb):f(bGd),d=aL(b[2][7],c);return g(bGc,h(b[8],d))}return e(bGh,[0,function(d){function
c(b){return 0}return e(bGg,[0],function(d){var
c=aX(r,f(bGe));return g(bGf,h(b[8],c))},c)}],d,c)}],d,c)}],d,c)},aY=function(b){return 1},aZ=e(bGk,[0,function(b){return u(K,0)}],aY,aW)}catch(b){b=n(b);if(b===k)throw[0,q,bFZ];throw b}var
a0=j(bGm,bGl,ai,aZ);try{var
a1=function(b){return au},a2=e(bGp,[0],function(b){return g(bGo,1)},a1)}catch(b){b=n(b);if(b===k)throw[0,q,bGn];throw b}var
B=j(bGr,bGq,dT,a2);try{var
a3=function(b){return 0},a4=function(b){return g(bGt,1)},a5=e(bGw,[0,function(c){function
b(b){return 1}return e(bGv,[0],function(b){return g(bGu,a0)},b)}],a4,a3)}catch(b){b=n(b);if(b===k)throw[0,q,bGs];throw b}var
a6=j(bGy,bGx,ai,a5);try{var
a7=function(b){return gb(B,[0,5,0,0])},a8=e(bGB,[0],function(b){return g(bGA,1)},a7)}catch(b){b=n(b);if(b===k)throw[0,q,bGz];throw b}var
a9=j(bGD,bGC,dT,a8);try{var
a_=function(b){return 0},a$=function(b){return g(bGF,1)},ba=e(bGK,[0,function(d){function
b(b){return 1}function
c(b){return g(bGG,h(ar,h(A,h(aG,a6))))}return e(bGJ,[0,function(c){function
b(b){return 0}return e(bGI,[0],function(b){return g(bGH,H(an,aj))},b)}],c,b)}],a$,a_)}catch(b){b=n(b);if(b===k)throw[0,q,bGE];throw b}var
bb=j(bGM,bGL,ai,ba),C=j(bG2,bG1,ay,function(c){try{var
b=function(b){return 0},f=function(b){return g(bGO,1)},i=e(bG0,[0,function(f){function
b(b){return 1}return e(bGZ,[0],function(t){if(0===c[0])var
e=0;else{var
b=c[1],f=b[6],i=h(ag(b6(2,b[1],B),d),f),k=j(bGR,bGQ,alX,[0,b[1],d,[0,65,0,0]]),l=[0,u(Q(bGS,tP),k)[1]];g(bGT,1);var
n=O(bGW,j(bGV,bGU,aip,l))[1],o=h(b[7],n),p=H(H(ag(b6(2,b[1],a9),d),o),i),q=m(x,s(bGX)),r=h(bU(b[2],q),p),e=h(a(b[4],bGY),r)}return g(bGP,e)},b)}],f,b);return i}catch(b){b=n(b);if(b===k)throw[0,q,bGN];throw b}});try{var
bc=function(b){return 0},bd=function(b){return g(bG4,1)},be=e(bG7,[0,function(c){function
b(b){return 1}return e(bG6,[0],function(b){return g(bG5,h(az,h(A,bb)))},b)}],bd,bc)}catch(b){b=n(b);if(b===k)throw[0,q,bG3];throw b}var
bf=j(bG9,bG8,ai,be),bg=j(bHD,bHC,ay,function(c){try{var
f=function(b){return 0},a=function(b){return g(bG$,1)},i=function(i){function
f(b){return 1}function
a(f){if(0===c[0])var
b=c[1],e=j(bHb,bHa,hV,[0,b[1],b[6],b[5],b[4],b[3]]),d=O(bHf,j(bHe,bHd,ai,u(Q(bHc,aP),e)));else
var
d=0;return g(bHg,d)}return e(bHp,[0,function(a){function
f(i){function
f(b){throw k}function
a(b){return 0}return e(bHn,[0,function(i){function
f(b){return 0}function
a(f){if(0===c[0])var
b=c[1][2],e=0===b[0]?0:1-b[1][1],d=e;else
var
d=0;return g(bHh,h(ad,d))}return e(bHm,[0,function(i){function
f(b){return 0}function
a(l){if(0===c[0]){var
f=c[1],j=f[8],k=h(c9(b6(2,f[4],z),d),j);switch(f[6][0]){case
0:var
a=0;break;case
1:var
a=0;break;default:var
a=1}var
i=h(a,k)}else
var
i=0;switch(b[9][0]){case
0:var
e=1;break;case
1:var
e=1;break;case
2:var
e=1;break;case
3:var
e=1;break;case
4:var
e=0;break;case
5:var
e=0;break;case
6:var
e=0;break;case
7:var
e=0;break;default:var
e=1}return g(bHi,h(e,i))}return e(bHl,[0,function(a){function
f(b){return 0}return e(bHk,[0],function(l){if(0===c[0]){var
f=c[1],j=f[8],k=h(c9(b6(2,f[4],z),d),j);switch(f[6][0]){case
0:var
a=0;break;case
1:var
a=0;break;default:var
a=1}var
i=h(a,k)}else
var
i=0;switch(b[9][0]){case
0:var
e=0;break;case
1:var
e=0;break;case
2:var
e=0;break;case
3:var
e=0;break;case
4:var
e=1;break;case
5:var
e=1;break;case
6:var
e=0;break;case
7:var
e=0;break;default:var
e=0}return g(bHj,h(e,i))},f)}],a,f)}],a,f)}],a,f)}return e(bHo,[0],function(b){return 1},f)}],a,f)},l=e(bHB,[0,function(f){function
b(b){return 1}function
d(d){var
b=j(bHr,bHq,hW,c);return g(bHw,O(bHv,j(bHu,bHt,ai,u(Q(bHs,C),b))))}return e(bHA,[0,function(d){function
b(b){return 1}return e(bHz,[0],function(n){if(0===c[0])var
a=0;else{var
b=c[1],i=m(x,s(bHy)),j=bU(b[2],i),k=h(b[5],j);switch(b[4][0]){case
0:var
d=0;break;case
1:var
d=0;break;default:var
d=1}switch(b[4][0]){case
0:var
e=0;break;case
1:var
e=1;break;default:var
e=0}var
l=H(e,d);switch(b[4][0]){case
0:var
f=1;break;case
1:var
f=0;break;default:var
f=0}var
a=h(H(f,l),k)}return g(bHx,a)},b)}],d,b)},i],a,f);return l}catch(b){b=n(b);if(b===k)throw[0,q,bG_];throw b}});try{var
bh=function(d){var
c=b[3];return c8(function(b){var
c=j(bHG,bHF,hW,b);return O(bHK,j(bHJ,bHI,ai,u(Q(bHH,bg),c)))},c)},bi=e(bHM,[0],function(b){return g(bHL,1)},bh)}catch(b){b=n(b);if(b===k)throw[0,q,bHE];throw b}var
I=j(bHO,bHN,function(b){return c7(hW,b)},bi);try{var
bj=function(c){var
b=c8(function(b){return 0===b[0]?0===b[1][7][0]?0:1:0},I);return ck(function(b){if(0===b[0]){var
c=b[1][7];return 0===c[0]?s(bHQ):c[1]}return s(bHR)},b)},bk=e(bHT,[0],function(b){return g(bHS,1)},bj)}catch(b){b=n(b);if(b===k)throw[0,q,bHP];throw b}var
bl=j(bHV,bHU,function(b){return c7(aS,b)},bk);try{var
bm=function(b){return I.length-1},bn=e(bHY,[0],function(b){return g(bHX,1)},bm)}catch(b){b=n(b);if(b===k)throw[0,q,bHW];throw b}return[0,d,bf,j(bH0,bHZ,bA,bn),bl,C]}throw[0,bT,bH1]}throw[0,bT,bH2]}throw[0,bT,bH3]}function
oT(b){var
a=b[1],f=b[15],h=b[2],i=b[3],l=b[4],m=b[5],o=b[6],p=b[7],r=b[8],s=b[9],t=b[10],v=b[11],w=b[12],x=b[13],y=b[14];try{var
z=function(b){return a},A=j(bH8,bH7,D,e(bH6,[0],function(b){return g(bH5,1)},z))}catch(b){b=n(b);if(b===k)throw[0,q,bH4];throw b}try{var
B=function(b){return h},C=j(bIb,bIa,D,e(bH$,[0],function(b){return g(bH_,1)},B))}catch(b){b=n(b);if(b===k)throw[0,q,bH9];throw b}try{var
E=function(b){return i},F=j(bIg,bIf,ai,e(bIe,[0],function(b){return g(bId,1)},E))}catch(b){b=n(b);if(b===k)throw[0,q,bIc];throw b}try{var
G=function(b){return l},H=j(bIl,bIk,aK,e(bIj,[0],function(b){return g(bIi,1)},G))}catch(b){b=n(b);if(b===k)throw[0,q,bIh];throw b}try{var
I=function(b){return m},J=j(bIq,bIp,bA,e(bIo,[0],function(b){return g(bIn,1)},I))}catch(b){b=n(b);if(b===k)throw[0,q,bIm];throw b}try{var
K=function(b){return o},L=j(bIv,bIu,cS,e(bIt,[0],function(b){return g(bIs,1)},K))}catch(b){b=n(b);if(b===k)throw[0,q,bIr];throw b}try{var
M=function(b){return p},N=j(bIA,bIz,dw,e(bIy,[0],function(b){return g(bIx,1)},M))}catch(b){b=n(b);if(b===k)throw[0,q,bIw];throw b}try{var
P=function(b){return r},R=j(bIF,bIE,ai,e(bID,[0],function(b){return g(bIC,1)},P))}catch(b){b=n(b);if(b===k)throw[0,q,bIB];throw b}try{var
S=function(b){return s},T=j(bIK,bIJ,ai,e(bII,[0],function(b){return g(bIH,1)},S))}catch(b){b=n(b);if(b===k)throw[0,q,bIG];throw b}try{var
U=function(b){return t},V=j(bIP,bIO,hT,e(bIN,[0],function(b){return g(bIM,1)},U))}catch(b){b=n(b);if(b===k)throw[0,q,bIL];throw b}try{var
W=function(b){return v},X=j(bIU,bIT,ai,e(bIS,[0],function(b){return g(bIR,1)},W))}catch(b){b=n(b);if(b===k)throw[0,q,bIQ];throw b}try{var
Y=function(b){return w},Z=j(bIZ,bIY,D,e(bIX,[0],function(b){return g(bIW,1)},Y))}catch(b){b=n(b);if(b===k)throw[0,q,bIV];throw b}try{var
_=function(b){return x},$=j(bI4,bI3,ai,e(bI2,[0],function(b){return g(bI1,1)},_))}catch(b){b=n(b);if(b===k)throw[0,q,bI0];throw b}try{var
aa=function(b){return y},ab=j(bI9,bI8,cc,e(bI7,[0],function(b){return g(bI6,1)},aa))}catch(b){b=n(b);if(b===k)throw[0,q,bI5];throw b}var
d=O(bI$,u(Q(bI_,oS),[0,A,C,F,H,J,L,N,R,T,V,X,Z,$,ab])),ac=d[1],ad=d[2],ae=d[3],af=d[4],ag=d[5],ah=d[6],aj=d[7];try{var
ak=function(b){return ag},al=e(bJc,[0],function(b){return g(bJb,1)},ak)}catch(b){b=n(b);if(b===k)throw[0,q,bJa];throw b}var
am=j(bJe,bJd,D,al);try{var
an=function(b){return af},ao=e(bJh,[0],function(b){return g(bJg,1)},an)}catch(b){b=n(b);if(b===k)throw[0,q,bJf];throw b}var
ap=j(bJj,bJi,aS,ao);try{var
aq=function(b){return ae},ar=e(bJm,[0],function(b){return g(bJl,1)},aq)}catch(b){b=n(b);if(b===k)throw[0,q,bJk];throw b}var
as=j(bJo,bJn,D,ar);try{var
at=function(b){return ad},au=e(bJr,[0],function(b){return g(bJq,1)},at)}catch(b){b=n(b);if(b===k)throw[0,q,bJp];throw b}var
av=j(bJt,bJs,D,au);try{var
aw=function(b){return ac},ax=e(bJw,[0],function(b){return g(bJv,1)},aw)}catch(b){b=n(b);if(b===k)throw[0,q,bJu];throw b}var
az=j(bJy,bJx,D,ax),aA=j(bJL,bJK,ay,function(b){try{var
c=function(d){var
c=j(bJB,bJA,D,b);return O(bJF,j(bJE,bJD,D,u(Q(bJC,aj),c)))},d=function(b){return g(bJG,1)},h=e(bJJ,[0,function(d){function
c(c){return b}return e(bJI,[0],function(c){var
b=0===f[0]?cb(a,f[1][1]):0;return g(bJH,b)},c)}],d,c);return h}catch(b){b=n(b);if(b===k)throw[0,q,bJz];throw b}});try{var
aB=function(b){return ah},aD=function(b){return g(bJN,1)},aE=e(bJR,[0,function(d){function
b(d){if(0===f[0]){var
b=f[1];return aC(a,aC(b[1],b[2]))}return c(bJO)}return e(bJQ,[0],function(c){var
b=0===f[0]?cb(a,f[1][1]):0;return g(bJP,b)},b)}],aD,aB)}catch(b){b=n(b);if(b===k)throw[0,q,bJM];throw b}return[0,j(bJT,bJS,D,aE),aA,az,av,as,ap,am]}function
tW(b){var
d=b[1],l=b[5],m=b[6],o=b[7],p=b[8],z=b[2],a=b[3],i=b[4];try{var
t=function(b){switch(d[0]){case
0:return[0,d[1]];case
1:return[2,d[1]];case
2:return[1,d[1]];case
3:return[0,d[1]];default:return[1,d[1]]}},v=e(bJW,[0],function(b){return g(bJV,1)},t)}catch(b){b=n(b);if(b===k)throw[0,q,bJU];throw b}var
h=j(bJY,bJX,tK,v);try{var
w=function(b){return tR(a)},x=e(bJ1,[0],function(b){return g(bJ0,1)},w)}catch(b){b=n(b);if(b===k)throw[0,q,bJZ];throw b}var
r=j(bJ3,bJ2,D,x);try{var
y=function(b){switch(i[0]){case
0:return bJ5;case
1:return bJ6;case
2:return bJ7;case
3:return bJ8;case
4:return bJ9;default:return bJ_}},A=e(bKa,[0],function(b){return g(bJ$,1)},y)}catch(b){b=n(b);if(b===k)throw[0,q,bJ4];throw b}var
s=j(bKc,bKb,cS,A);try{var
B=function(P){switch(h[0]){case
0:var
e=h[1],A=e[7];try{var
v=e[1];switch(v[0]){case
0:var
t=v[1][2];break;case
1:var
t=c(bKs);break;default:var
t=c(bKt)}}catch(b){b=n(b);if(b===k)throw[0,q,bKe];throw b}var
B=j(bKg,bKf,akt,[0,e[2],r,e[3],o,l,s,m,e[4],e[6],z,e[5],t,A,p]),f=u(Q(bKh,oS),B),C=function(b){var
c=j(bKj,bKi,D,b);return O(bKn,j(bKm,bKl,D,u(Q(bKk,f[7]),c)))},E=[0,f[1],f[2],f[3],f[4],f[5],f[6],C];g(bKo,1);var
w=O(bKr,j(bKq,bKp,ahx,E));return[0,w[6],w[7]];case
1:var
b=h[1],F=j(bKv,bKu,akY,[0,b[1],r,l,s,b[4],b[10][2],b[6],b[3],b[7],b[8],m,b[10][1],b[9],o,p]),a=u(Q(bKw,tT),F),G=function(b){var
c=j(bKy,bKx,D,b);return O(bKC,j(bKB,bKA,D,u(Q(bKz,a[5]),c)))},H=[0,a[1],a[2],a[3],a[4],G];g(bKD,1);var
x=O(bKG,j(bKF,bKE,ahR,H));return[0,x[4],x[5]];default:var
i=h[1],I=function(b){throw k},J=function(b){throw k},K=function(b){throw k},L=j(bKI,bKH,akJ,[0,p,i[2],i[1],i[6],r,l,s,m,o,i[8],K,J,I]),d=u(Q(bKJ,jL),L),M=function(b){var
c=j(bKL,bKK,D,b);return O(bKP,j(bKO,bKN,D,u(Q(bKM,d[9]),c)))},N=[0,d[1],d[2],d[3],d[4],d[5],d[6],d[7],d[8],M];g(bKQ,1);var
y=O(bKT,j(bKS,bKR,ahG,N));return[0,y[8],y[9]]}},C=e(bKV,[0],function(b){return g(bKU,1)},B)}catch(b){b=n(b);if(b===k)throw[0,q,bKd];throw b}var
f=j(bKX,bKW,tD,C),E=j(bK2,bK1,ay,function(b){try{var
c=function(c){return u(f[2],b)},d=e(bK0,[0],function(b){return g(bKZ,1)},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,bKY];throw b}});try{var
F=function(b){return f[1]},G=e(bK5,[0],function(b){return g(bK4,1)},F)}catch(b){b=n(b);if(b===k)throw[0,q,bK3];throw b}return[0,j(bK7,bK6,D,G),E]}function
bK8(b){var
o=b[1],d=b[3],a=b[5],p=b[6],z=b[2],A=b[4];try{var
B=function(b){return[0,0,6,0]},E=e(bK$,[0],function(b){return g(bK_,1)},B)}catch(b){b=n(b);if(b===k)throw[0,q,bK9];throw b}var
F=j(bLb,bLa,dT,E);try{var
H=function(b){return 0},I=function(b){return g(bLd,1)},J=e(bLh,[0,function(c){function
b(b){return 1}return e(bLg,[0],function(a){var
b=f(bLe),c=o[1],e=d[3];return g(bLf,aL(hR(c8(function(b){return 0===b[0]?1:0},e).length-1,c),b))},b)}],I,H)}catch(b){b=n(b);if(b===k)throw[0,q,bLc];throw b}var
K=j(bLj,bLi,ai,J);try{var
L=l(a,i(W,10,1))}catch(b){b=n(b);if(b===k)throw[0,q,bLk];throw b}if(L){try{var
M=function(b){return a},N=j(bLp,bLo,aK,e(bLn,[0],function(b){return g(bLm,1)},M))}catch(b){b=n(b);if(b===k)throw[0,q,bLl];throw b}var
r=O(bLr,u(Q(bLq,tO),[0,N]))[1];try{var
P=function(b){return d},R=j(bLw,bLv,e8,e(bLu,[0],function(b){return g(bLt,1)},P))}catch(b){b=n(b);if(b===k)throw[0,q,bLs];throw b}try{var
S=function(b){return A},T=j(bLB,bLA,fK,e(bLz,[0],function(b){return g(bLy,1)},S))}catch(b){b=n(b);if(b===k)throw[0,q,bLx];throw b}try{var
U=function(b){return a},V=j(bLG,bLF,aK,e(bLE,[0],function(b){return g(bLD,1)},U))}catch(b){b=n(b);if(b===k)throw[0,q,bLC];throw b}var
X=function(b){throw k},Y=function(b){throw k},Z=[0,R,T,V,X,Y,function(b){throw k}],v=O(bLI,u(Q(bLH,jM),Z)),_=v[1],$=v[2];try{var
aa=function(b){return 0},ab=function(b){return g(bLK,1)},ac=e(bLN,[0,function(c){function
b(b){return 1}return e(bLM,[0],function(i){var
d=o[2];if(0===d[0])var
e=0;else{var
f=d[1];switch(f[0]){case
0:var
b=b6(2,f[1],[0,2,0,0]),h=[0,0,0,-1];if(!hJ(b))throw[0,bi,NC];var
c=ag(a,b6(2,sU(b[1],b[2],1),h));break;case
1:var
c=0;break;default:var
c=1}var
e=c}return g(bLL,e)},b)}],ab,aa)}catch(b){b=n(b);if(b===k)throw[0,q,bLJ];throw b}var
ad=j(bLP,bLO,ai,ac);try{var
ae=function(j){var
e=f(bLR),a=d[3];if(aX(c8(function(b){return 0===b[0]?1:0},a).length-1,e))var
g=s(bLS),h=f(bLT),i=d[3],b=m(r,a7(x(C(c8(function(b){return 0===b[0]?1:0},i).length-1,h)),g));else
var
b=c(bLV);return t(m(r,s(bLU)),b)},af=e(bLX,[0],function(b){return g(bLW,l(a,i(W,10,1)))},ae)}catch(b){b=n(b);if(b===k)throw[0,q,bLQ];throw b}var
w=j(bLZ,bLY,D,af);try{var
ah=function(b){return 0},aj=function(b){return g(bL1,1)},ak=e(bMa,[0,function(f){function
b(b){return 1}function
c(b){return g(bL2,h($,h(K,h(ad,tg(jx(_,z),F)<=0?1:0))))}return e(bL$,[0,function(c){function
b(f){function
b(b){throw k}function
c(b){return 0}return e(bL9,[0,function(f){function
b(b){return 0}function
c(c){switch(d[9][0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=0;break;default:var
b=1}return g(bL3,b)}return e(bL8,[0,function(f){function
b(b){return 0}function
c(c){switch(d[9][0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=1;break;default:var
b=0}return g(bL4,h(l(a,i(G,1,1)),b))}return e(bL7,[0,function(c){function
b(b){return 0}return e(bL6,[0],function(c){switch(d[9][0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=0;break;default:var
b=1}return g(bL5,h(l(a,i(G,1,1)),b))},b)}],c,b)}],c,b)}],c,b)}return e(bL_,[0],function(b){return 1},b)}],c,b)}],aj,ah)}catch(b){b=n(b);if(b===k)throw[0,q,bL0];throw b}var
y=j(bMc,bMb,ai,ak);try{var
al=function(b){return y?bU(p,w)?p:w:c(bMe)},am=e(bMg,[0],function(b){return g(bMf,1)},al)}catch(b){b=n(b);if(b===k)throw[0,q,bMd];throw b}return[0,y,j(bMi,bMh,D,am)]}throw[0,bT,bMj]}function
tX(l){var
p=l[1],b=l[2],d=l[3],r=l[4];try{var
s=function(b){return[0,5,0,0]},t=e(bMm,[0],function(b){return g(bMl,1)},s)}catch(b){b=n(b);if(b===k)throw[0,q,bMk];throw b}var
v=j(bMo,bMn,dT,t);try{var
w=function(b){return p},x=j(bMt,bMs,aK,e(bMr,[0],function(b){return g(bMq,1)},w))}catch(b){b=n(b);if(b===k)throw[0,q,bMp];throw b}try{var
y=function(c){return b[9]},z=j(bMy,bMx,cc,e(bMw,[0],function(b){return g(bMv,1)},y))}catch(b){b=n(b);if(b===k)throw[0,q,bMu];throw b}var
A=[0,x,z,function(b){throw k}],m=O(bMA,u(Q(bMz,oR),A))[2];try{var
B=function(b){return 0},C=function(b){return g(bMC,1)},D=e(bML,[0,function(f){function
c(b){return 1}function
d(b){return g(bMD,1)}return e(bMK,[0,function(d){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bMI,[0,function(f){function
c(b){return 0}function
d(d){switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bME,c)}return e(bMH,[0,function(d){function
c(b){return 0}return e(bMG,[0],function(d){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}return g(bMF,c)},c)}],d,c)}],d,c)}return e(bMJ,[0],function(b){return 1},c)}],d,c)}],C,B)}catch(b){b=n(b);if(b===k)throw[0,q,bMB];throw b}var
E=j(bMN,bMM,ai,D);try{var
F=function(b){return 0},G=function(b){return g(bMP,1)},I=e(bMY,[0,function(f){function
c(b){return 1}function
d(b){return g(bMQ,1)}return e(bMX,[0,function(d){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bMV,[0,function(f){function
c(b){return 0}function
d(d){switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bMR,c)}return e(bMU,[0,function(d){function
c(b){return 0}return e(bMT,[0],function(d){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}return g(bMS,c)},c)}],d,c)}],d,c)}return e(bMW,[0],function(b){return 1},c)}],d,c)}],G,F)}catch(b){b=n(b);if(b===k)throw[0,q,bMO];throw b}var
J=j(bM0,bMZ,ai,I);try{var
K=function(b){return 0},L=function(b){return g(bM2,1)},M=e(bM$,[0,function(f){function
c(b){return 1}function
d(b){return g(bM3,1)}return e(bM_,[0,function(d){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bM8,[0,function(f){function
c(b){return 0}function
d(d){switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bM4,c)}return e(bM7,[0,function(d){function
c(b){return 0}return e(bM6,[0],function(d){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}return g(bM5,c)},c)}],d,c)}],d,c)}return e(bM9,[0],function(b){return 1},c)}],d,c)}],L,K)}catch(b){b=n(b);if(b===k)throw[0,q,bM1];throw b}var
N=j(bNb,bNa,ai,M);try{var
P=function(b){return 0},R=function(b){return g(bNd,1)},S=e(bNo,[0,function(f){function
c(b){return 1}function
d(d){switch(b[2][2][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=0;break;case
3:var
c=1;break;default:var
c=1}return g(bNe,c)}return e(bNn,[0,function(d){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bNl,[0,function(f){function
c(b){return 1}function
d(k){var
a=b[2][2];switch(a[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
f=a[1];switch(f[5][0]){case
0:var
d=1;break;case
1:var
d=0;break;case
2:var
d=0;break;default:var
d=0}switch(f[5][0]){case
0:var
e=0;break;case
1:var
e=0;break;case
2:var
e=0;break;default:var
e=1}var
i=H(e,d),j=0===f[10][3][0]?1:0,c=h(j,i);break;case
3:var
c=0;break;default:var
c=0}return g(bNf,c)}return e(bNk,[0,function(f){function
c(b){return 1}function
d(i){var
e=b[2][2];switch(e[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
f=e[1];switch(f[5][0]){case
0:var
d=0;break;case
1:var
d=1;break;case
2:var
d=0;break;default:var
d=0}var
a=0===f[10][3][0]?1:0,c=h(a,d);break;case
3:var
c=0;break;default:var
c=0}return g(bNg,c)}return e(bNj,[0,function(d){function
c(b){return 1}return e(bNi,[0],function(i){var
e=b[2][2];switch(e[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
f=e[1];switch(f[5][0]){case
0:var
d=0;break;case
1:var
d=0;break;case
2:var
d=1;break;default:var
d=0}var
a=0===f[10][3][0]?1:0,c=h(a,d);break;case
3:var
c=0;break;default:var
c=0}return g(bNh,c)},c)}],d,c)}],d,c)}],d,c)}return e(bNm,[0],function(b){return 1},c)}],d,c)}],R,P)}catch(b){b=n(b);if(b===k)throw[0,q,bNc];throw b}var
T=j(bNq,bNp,ai,S);try{var
U=d[5];switch(b[2][2][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=0;break;default:var
c=0}var
V=H(c,U),X=1-h(d[3],V)}catch(b){b=n(b);if(b===k)throw[0,q,bNr];throw b}if(X){try{var
Y=function(c){return b},Z=j(bNw,bNv,e8,e(bNu,[0],function(b){return g(bNt,1)},Y))}catch(b){b=n(b);if(b===k)throw[0,q,bNs];throw b}try{var
_=function(b){return d},$=j(bNB,bNA,fK,e(bNz,[0],function(b){return g(bNy,1)},_))}catch(b){b=n(b);if(b===k)throw[0,q,bNx];throw b}try{var
aa=function(b){return p},ab=j(bNG,bNF,aK,e(bNE,[0],function(b){return g(bND,1)},aa))}catch(b){b=n(b);if(b===k)throw[0,q,bNC];throw b}var
ac=function(d){function
c(b){return 1}return j(bNK,bNJ,ai,e(bNI,[0],function(e){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=d[1][7];break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bNH,c)},c))},ad=function(d){function
c(b){return 1}return j(bNO,bNN,ai,e(bNM,[0],function(e){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=d[1][7];break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bNL,c)},c))},ae=[0,Z,$,ab,ac,ad,function(b){throw k}],o=O(bNQ,u(Q(bNP,jM),ae)),af=o[2],ah=o[3],aj=o[4],ak=o[5];try{var
al=function(b){return aj},am=e(bNT,[0],function(b){return g(bNS,1)},al)}catch(b){b=n(b);if(b===k)throw[0,q,bNR];throw b}var
an=j(bNV,bNU,function(b){return c7(aS,b)},am);try{var
ao=function(b){return ah},ap=e(bNY,[0],function(b){return g(bNX,1)},ao)}catch(b){b=n(b);if(b===k)throw[0,q,bNW];throw b}var
aq=j(bN0,bNZ,bA,ap);try{var
ar=function(b){return H(1-af,1-T)?bN2:bN3},as=e(bN5,[0],function(b){return g(bN4,1)},ar)}catch(b){b=n(b);if(b===k)throw[0,q,bN1];throw b}var
at=j(bN7,bN6,tA,as);try{var
au=function(b){return 0},av=function(b){return g(bN9,1)},aw=e(bO9,[0,function(i){function
c(l){function
c(b){throw k}function
i(b){return 0}return e(bO7,[0,function(k){function
c(b){return 1}function
i(e){var
c=b[1],d=0;return g(bOc,h(N,si(function(c,b){var
d=H(a(b,bN$),a(b,bN_)),e=H(a(b,bOa),d);return H(c,H(a(b,bOb),e))},d,c)))}return e(bO6,[0,function(k){function
c(b){return 1}function
i(e){var
c=f(bOd),d=b[3];return g(bOk,h(J,a(c8(function(c){if(0===c[0]){var
b=c[1],d=j(bOf,bOe,hV,[0,b[1],b[6],b[5],b[4],b[3]]);return O(bOj,j(bOi,bOh,ai,u(Q(bOg,m),d)))}return 0},d).length-1,c)))}return e(bO5,[0,function(k){function
c(b){return 1}function
i(k){var
d=b[5];switch(d[0]){case
0:var
c=0;break;case
1:var
c=ag(p,b6(2,d[1],v));break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;default:var
c=0}var
e=f(bOl),i=b[3];return g(bOs,h(a(c8(function(c){if(0===c[0]){var
b=c[1],d=j(bOn,bOm,hV,[0,b[1],b[6],b[5],b[4],b[3]]);return 1-O(bOr,j(bOq,bOp,ai,u(Q(bOo,m),d)))}return 0},i).length-1,e),c))}return e(bO4,[0,function(k){function
c(b){return 1}function
i(e){var
c=f(bOt),d=b[3];return g(bOA,aL(c8(function(b){var
c=j(bOv,bOu,hW,b);return O(bOz,j(bOy,bOx,ai,u(Q(bOw,ak),c)))},d).length-1,c))}return e(bO3,[0,function(k){function
c(b){return 1}function
i(e){var
c=f(bOB),d=b[3];return g(bOC,aL(c8(function(b){if(0===b[0])return 0;var
c=b[1];return h(c[3],c[5])},d).length-1,c))}return e(bO2,[0,function(k){function
c(b){return 1}function
i(i){switch(b[5][0]){case
0:var
d=b[7],e=f(bOD),c=h(a(b[3].length-1,e),d);break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;default:var
c=0}return g(bOE,h(E,c))}return e(bO1,[0,function(i){function
c(b){return 1}function
a(i){var
d=f(bOF),e=b[3],a=aL(c8(function(c){if(0===c[0]){var
b=c[1],d=j(bOH,bOG,hV,[0,b[1],b[6],b[5],b[4],b[3]]);return O(bOL,j(bOK,bOJ,ai,u(Q(bOI,m),d)))}return 0},e).length-1,d);switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bOM,h(c,a))}return e(bO0,[0,function(i){function
c(b){return 1}function
a(f){var
e=d[4];switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bON,h(c,e))}return e(bOZ,[0,function(i){function
c(b){return 1}function
a(i){var
d=f(bOO),e=b[3],a=aL(c8(function(c){if(0===c[0]){var
b=c[1],d=j(bOQ,bOP,hV,[0,b[1],b[6],b[5],b[4],b[3]]);return O(bOU,j(bOT,bOS,ai,u(Q(bOR,m),d)))}return 0},e).length-1,d);switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}return g(bOV,h(c,a))}return e(bOY,[0,function(f){function
c(b){return 1}return e(bOX,[0],function(f){var
e=d[4];switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=1;break;case
5:var
c=1;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=0}return g(bOW,h(c,e))},c)}],a,c)}],a,c)}],a,c)}],i,c)}],i,c)}],i,c)}],i,c)}],i,c)}],i,c)}],i,c)}return e(bO8,[0],function(b){return 1},c)}],av,au)}catch(b){b=n(b);if(b===k)throw[0,q,bN8];throw b}var
ax=j(bO$,bO_,ai,aw);try{var
ay=function(b){return H(a(at,bPb),r)?bPc:ax?bPd:bPe},az=function(b){return g(bPf,1)},aA=function(c){function
b(b){return bPg}return e(bPi,[0],function(b){return g(bPh,d[3])},b)},aB=e(bPs,[0,function(a){function
c(b){return bPj}function
f(a){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
e=d[1],f=i(cJ,12,31),c=c9(e[10][2],f);break;case
3:var
c=0;break;default:var
c=0}return g(bPk,c)}return e(bPr,[0,function(a){function
c(b){return bPl}function
f(o){var
f=b[2][2];switch(f[0]){case
0:var
d=0;break;case
1:var
d=0;break;case
2:var
e=f[1],a=e[10][4];if(0===a[0])var
k=a[1],j=ag(k,i(cI,12,31));else
var
j=0;var
l=i(W,12,31),m=h(c9(e[10][2],l),j),n=i(cJ,12,31),d=H(c9(e[10][2],n),m);break;case
3:var
d=0;break;default:var
d=0}switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bPm,h(c,d))}return e(bPq,[0,function(f){function
c(b){return bPn}return e(bPp,[0],function(f){var
e=d[5];switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bPo,h(c,e))},c)}],f,c)}],f,c)},aA],az,ay)}catch(b){b=n(b);if(b===k)throw[0,q,bPa];throw b}return[0,j(bPu,bPt,tA,aB),aq,an]}throw[0,bT,bPv]}function
tY(c){var
b=c[1],d=c[3],m=c[2],o=j(bPG,bPF,ay,function(b){try{var
c=function(b){return 0},d=function(b){return g(bPx,1)},f=e(bPE,[0,function(d){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bPC,[0,function(f){function
c(b){return 1}function
d(a){switch(b[1][0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}switch(b[1][0]){case
0:var
d=1;break;case
1:var
d=0;break;case
2:var
d=0;break;case
3:var
d=0;break;default:var
d=0}var
e=H(d,c),f=0===b[3][0]?1:0;return g(bPy,h(f,e))}return e(bPB,[0,function(d){function
c(b){return 1}return e(bPA,[0],function(a){switch(b[1][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=1;break;default:var
c=0}switch(b[1][0]){case
0:var
d=0;break;case
1:var
d=0;break;case
2:var
d=1;break;case
3:var
d=0;break;default:var
d=0}var
e=H(d,c),f=0===b[3][0]?0:1;return g(bPz,h(f,e))},c)}],d,c)}],d,c)}return e(bPD,[0],function(b){return 1},c)}],d,c);return f}catch(b){b=n(b);if(b===k)throw[0,q,bPw];throw b}}),p=j(bPL,bPK,ay,function(d){try{var
b=function(b){return 0},c=e(bPJ,[0],function(b){return g(bPI,1)},b);return c}catch(b){b=n(b);if(b===k)throw[0,q,bPH];throw b}});try{var
r=function(c){return b},s=j(bPQ,bPP,e8,e(bPO,[0],function(b){return g(bPN,1)},r))}catch(b){b=n(b);if(b===k)throw[0,q,bPM];throw b}try{var
t=function(b){return m},v=j(bPV,bPU,fK,e(bPT,[0],function(b){return g(bPS,1)},t))}catch(b){b=n(b);if(b===k)throw[0,q,bPR];throw b}try{var
w=function(b){return d},x=j(bP0,bPZ,aK,e(bPY,[0],function(b){return g(bPX,1)},w))}catch(b){b=n(b);if(b===k)throw[0,q,bPW];throw b}function
y(b){throw k}function
z(b){throw k}var
A=[0,s,v,x,y,z,function(d){function
c(b){return i(U,5,1)}return j(bP4,bP3,aK,e(bP2,[0],function(d){switch(b[2][2][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=1;break;case
3:var
c=0;break;default:var
c=0}return g(bP1,c)},c))}],f=O(bP6,u(Q(bP5,jM),A)),B=f[2],C=f[3],D=f[4];try{var
G=function(b){return 0},I=function(b){return g(bP8,1)},J=e(bP$,[0,function(f){function
c(b){return 1}return e(bP_,[0],function(e){switch(b[2][8][0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}return g(bP9,h(l(d,i(W,10,1)),c))},c)}],I,G)}catch(b){b=n(b);if(b===k)throw[0,q,bP7];throw b}var
a=j(bQb,bQa,ai,J);try{var
K=function(b){return 0},L=function(b){return g(bQd,1)},M=function(d){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bQw,[0,function(f){function
c(b){return 1}function
d(f){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
e=j(bQg,bQf,oJ,d[1][10]),c=O(bQk,j(bQj,bQi,ai,u(Q(bQh,o),e)));break;case
3:var
c=0;break;default:var
c=0}return g(bQe,c)}return e(bQv,[0,function(f){function
c(b){return 1}function
d(a){var
f=b[2][2];switch(f[0]){case
0:var
d=f[1][1];switch(d[0]){case
0:var
e=d[1][1];break;case
1:var
e=d[1][1];break;default:var
e=0}var
c=e;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bQl,c)}return e(bQu,[0,function(d){function
c(b){return 1}return e(bQt,[0],function(f){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
e=j(bQo,bQn,oJ,d[1][10]),c=O(bQs,j(bQr,bQq,ai,u(Q(bQp,p),e)))}return g(bQm,c)},c)}],d,c)}],d,c)}],d,c)}return e(bQx,[0],function(b){return 1},c)},N=e(bQM,[0,function(a){function
c(f){function
c(b){throw k}function
d(b){return 0}return e(bQE,[0,function(f){function
c(b){return 1}function
d(e){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=d[1][4];break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bQy,c)}return e(bQD,[0,function(f){function
c(b){return 1}function
d(f){var
e=b[2][2];switch(e[0]){case
0:var
d=0;break;case
1:var
d=e[1][5];break;case
2:var
d=0;break;case
3:var
d=0;break;default:var
d=0}switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bQz,h(c,d))}return e(bQC,[0,function(d){function
c(b){return 1}return e(bQB,[0],function(e){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=d[1][3];break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bQA,c)},c)}],d,c)}],d,c)}],d,c)}function
f(b){return 1}return e(bQL,[0,function(f){function
c(a){function
c(b){throw k}function
f(b){return 0}return e(bQJ,[0,function(a){function
c(b){return 0}function
f(f){var
e=b[2][2];switch(e[0]){case
0:var
c=0;break;case
1:switch(e[1][1][0]){case
0:var
d=0;break;case
1:var
d=0;break;case
2:var
d=0;break;default:var
d=1}var
c=d;break;case
2:var
c=0;break;case
3:var
c=0;break;default:var
c=0}return g(bQF,c)}return e(bQI,[0,function(f){function
c(b){return 0}return e(bQH,[0],function(j){var
a=b[2][2];switch(a[0]){case
0:var
e=0;break;case
1:switch(a[1][1][0]){case
0:var
f=0;break;case
1:var
f=0;break;case
2:var
f=1;break;default:var
f=0}var
e=f;break;case
2:var
e=0;break;case
3:var
e=0;break;default:var
e=0}switch(b[9][0]){case
0:var
c=1;break;case
1:var
c=1;break;case
2:var
c=1;break;case
3:var
c=1;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=0;break;default:var
c=1}return g(bQG,h(h(l(d,i(aI,4,5)),c),e))},c)}],f,c)}],f,c)}return e(bQK,[0],function(b){return 1},c)}],f,c)},M],L,K)}catch(b){b=n(b);if(b===k)throw[0,q,bQc];throw b}var
P=j(bQO,bQN,ai,N);try{var
R=function(b){return D},S=e(bQR,[0],function(b){return g(bQQ,1)},R)}catch(b){b=n(b);if(b===k)throw[0,q,bQP];throw b}var
T=j(bQT,bQS,function(b){return c7(aS,b)},S);try{var
V=function(b){return C},X=e(bQW,[0],function(b){return g(bQV,1)},V)}catch(b){b=n(b);if(b===k)throw[0,q,bQU];throw b}var
Y=j(bQY,bQX,bA,X);try{var
Z=function(b){return 0},_=function(b){return g(bQ0,1)},$=e(bQ7,[0,function(f){function
c(b){return 1}function
d(b){return g(bQ1,1)}return e(bQ6,[0,function(f){function
c(b){return 0}function
d(j){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
e=d[1],f=i(cJ,12,31),c=l(e[10][2],f);break;case
3:var
c=0;break;default:var
a=d[1],h=i(cJ,12,31),c=l(a[10][2],h)}return g(bQ2,c)}return e(bQ5,[0,function(d){function
c(b){return 1}return e(bQ4,[0],function(u){var
d=b[2][2];switch(d[0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
e=d[1],j=0===e[9][0]?0:1,k=h(j,a),m=i(F,1,1),n=h(E(e[10][2],m),k),o=i(cI,1,1),c=h(l(e[10][2],o),n);break;case
3:var
c=0;break;default:var
f=d[1],p=0===f[9][0]?0:1,q=h(p,a),r=i(F,1,1),s=h(E(f[10][2],r),q),t=i(cI,1,1),c=h(l(f[10][2],t),s)}return g(bQ3,c)},c)}],d,c)}],d,c)}],_,Z)}catch(b){b=n(b);if(b===k)throw[0,q,bQZ];throw b}var
aa=j(bQ9,bQ8,ai,$);try{var
ab=function(b){return 0},ac=function(b){return g(bQ$,1)},ad=e(bRe,[0,function(a){function
c(b){return 1}function
f(b){return g(bRa,h(P,h(aa,B)))}return e(bRd,[0,function(f){function
c(b){return 0}return e(bRc,[0],function(e){switch(b[9][0]){case
0:var
c=0;break;case
1:var
c=0;break;case
2:var
c=0;break;case
3:var
c=0;break;case
4:var
c=0;break;case
5:var
c=0;break;case
6:var
c=0;break;case
7:var
c=1;break;default:var
c=0}return g(bRb,h(l(d,i(U,1,1)),c))},c)}],f,c)}],ac,ab)}catch(b){b=n(b);if(b===k)throw[0,q,bQ_];throw b}return[0,d,j(bRg,bRf,ai,ad),Y,T]}function
tZ(b){var
d=b[1],m=b[4],o=b[5],p=b[6],v=b[7],i=b[8],l=b[2],t=b[3];try{var
w=function(b){switch(d[0]){case
0:return[0,d[1]];case
1:return[2,d[1]];case
2:return[1,d[1]];case
3:return[0,d[1]];default:return[1,d[1]]}},x=e(bRj,[0],function(b){return g(bRi,1)},w)}catch(b){b=n(b);if(b===k)throw[0,q,bRh];throw b}var
f=j(bRl,bRk,tK,x);try{var
y=function(b){return tR(l)},z=e(bRo,[0],function(b){return g(bRn,1)},y)}catch(b){b=n(b);if(b===k)throw[0,q,bRm];throw b}var
r=j(bRq,bRp,D,z);try{var
A=function(b){switch(t[0]){case
0:return bRs;case
1:return bRt;case
2:return bRu;case
3:return bRv;case
4:return bRw;default:return bRx}},B=e(bRz,[0],function(b){return g(bRy,1)},A)}catch(b){b=n(b);if(b===k)throw[0,q,bRr];throw b}var
s=j(bRB,bRA,cS,B);try{var
C=function(T){switch(f[0]){case
0:var
d=f[1],A=d[8],B=d[7];try{var
w=d[1];switch(w[0]){case
0:var
t=w[1][2];break;case
1:var
t=c(bRR);break;default:var
t=c(bRS)}}catch(b){b=n(b);if(b===k)throw[0,q,bRD];throw b}var
C=j(bRF,bRE,tL,[0,d[2],r,d[3],p,m,s,o,d[4],d[6],v,d[5],t,B,i,A]),e=u(Q(bRG,oT),C),E=e[7],F=e[6],G=e[5],H=e[4],I=e[3],J=function(b){var
c=j(bRI,bRH,D,b);return O(bRM,j(bRL,bRK,D,u(Q(bRJ,e[2]),c)))},K=[0,e[1],J,I,H,G,F,E];g(bRN,1);var
x=O(bRQ,j(bRP,bRO,tE,K));return[0,x[1],x[2]];case
1:var
b=f[1],L=j(bRU,bRT,alt,[0,r,m,s,o,i,p,b[1],b[8],b[10][2],b[5],b[6],b[3],b[2],b[7],b[11]]),h=u(Q(bRV,tV),L),M=function(b){var
c=j(bRX,bRW,D,b);return O(bR1,j(bR0,bRZ,D,u(Q(bRY,h[5]),c)))},N=[0,h[1],h[2],h[3],h[4],M];g(bR2,1);var
y=O(bR5,j(bR4,bR3,aia,N));return[0,y[4],y[5]];default:var
l=f[1],P=j(bR7,bR6,alK,[0,l[1],l[2],l[6],i,l[8],r,m,s,o,p,l[9]]),a=u(Q(bR8,tU),P),R=function(b){var
c=j(bR_,bR9,D,b);return O(bSc,j(bSb,bSa,D,u(Q(bR$,a[6]),c)))},S=[0,a[1],a[2],a[3],a[4],a[5],R];g(bSd,1);var
z=O(bSg,j(bSf,bSe,aih,S));return[0,z[5],z[6]]}},E=function(b){return g(bSh,1)},F=e(bSC,[0,function(d){function
b(C){switch(f[0]){case
0:return[0,c(bSi),tS];case
1:return[0,c(bSj),tS];default:var
d=f[1],a=d[11];try{var
h=c(bSm)}catch(b){b=n(b);if(b===k)throw[0,q,bSl];throw b}var
l=j(bSo,bSn,tL,[0,d[8],r,d[10],p,m,s,o,d[12],0,v,d[13],h,a,i,bSk]),b=u(Q(bSp,oT),l),t=b[7],w=b[6],x=b[5],y=b[4],z=b[3],A=function(c){var
d=j(bSr,bSq,D,c);return O(bSv,j(bSu,bSt,D,u(Q(bSs,b[2]),d)))},B=[0,b[1],A,z,y,x,w,t];g(bSw,1);var
e=O(bSz,j(bSy,bSx,tE,B));return[0,e[1],e[2]]}}return e(bSB,[0],function(d){switch(f[0]){case
0:var
c=0;break;case
1:var
c=0;break;default:var
c=1}switch(i[0]){case
0:var
b=0;break;case
1:var
b=0;break;case
2:var
b=0;break;case
3:var
b=0;break;case
4:var
b=0;break;case
5:var
b=0;break;case
6:var
b=0;break;case
7:var
b=1;break;default:var
b=0}return g(bSA,h(b,c))},b)}],E,C)}catch(b){b=n(b);if(b===k)throw[0,q,bRC];throw b}var
a=j(bSE,bSD,tD,F),G=j(bSJ,bSI,ay,function(b){try{var
c=function(c){return u(a[2],b)},d=e(bSH,[0],function(b){return g(bSG,1)},c);return d}catch(b){b=n(b);if(b===k)throw[0,q,bSF];throw b}});try{var
H=function(b){return a[1]},I=e(bSM,[0],function(b){return g(bSL,1)},H)}catch(b){b=n(b);if(b===k)throw[0,q,bSK];throw b}return[0,j(bSO,bSN,D,I),G]}function
oU(f){var
b=f[1],r=f[2],a=f[3],s=f[4];try{var
z=function(b){return a},A=j(bST,bSS,aK,e(bSR,[0],function(b){return g(bSQ,1)},z))}catch(b){b=n(b);if(b===k)throw[0,q,bSP];throw b}try{var
B=function(c){return b},C=j(bSY,bSX,e8,e(bSW,[0],function(b){return g(bSV,1)},B))}catch(b){b=n(b);if(b===k)throw[0,q,bSU];throw b}try{var
E=function(b){return r},F=j(bS3,bS2,fK,e(bS1,[0],function(b){return g(bS0,1)},E))}catch(b){b=n(b);if(b===k)throw[0,q,bSZ];throw b}try{var
G=function(b){return 0},I=j(bS8,bS7,ai,e(bS6,[0],function(b){return g(bS5,1)},G))}catch(b){b=n(b);if(b===k)throw[0,q,bS4];throw b}var
t=O(bS_,u(Q(bS9,tX),[0,A,C,F,I])),i=t[1],J=t[2];try{var
K=function(c){return b},L=j(bTd,bTc,e8,e(bTb,[0],function(b){return g(bTa,1)},K))}catch(b){b=n(b);if(b===k)throw[0,q,bS$];throw b}try{var
M=function(b){return r},N=j(bTi,bTh,fK,e(bTg,[0],function(b){return g(bTf,1)},M))}catch(b){b=n(b);if(b===k)throw[0,q,bTe];throw b}try{var
P=function(b){return a},R=j(bTn,bTm,aK,e(bTl,[0],function(b){return g(bTk,1)},P))}catch(b){b=n(b);if(b===k)throw[0,q,bTj];throw b}var
l=O(bTp,u(Q(bTo,tY),[0,L,N,R])),d=l[2],S=l[3],T=l[4];try{var
U=function(c){return b[2][2]},V=j(bTu,bTt,oM,e(bTs,[0],function(b){return g(bTr,1)},U))}catch(b){b=n(b);if(b===k)throw[0,q,bTq];throw b}try{var
W=function(b){return s},X=j(bTz,bTy,D,e(bTx,[0],function(b){return g(bTw,1)},W))}catch(b){b=n(b);if(b===k)throw[0,q,bTv];throw b}try{var
Y=function(c){return b[5]},Z=j(bTE,bTD,oI,e(bTC,[0],function(b){return g(bTB,1)},Y))}catch(b){b=n(b);if(b===k)throw[0,q,bTA];throw b}try{var
_=function(b){return J},$=j(bTJ,bTI,bA,e(bTH,[0],function(b){return g(bTG,1)},_))}catch(b){b=n(b);if(b===k)throw[0,q,bTF];throw b}try{var
aa=function(c){return b[2][8]},ab=j(bTO,bTN,dw,e(bTM,[0],function(b){return g(bTL,1)},aa))}catch(b){b=n(b);if(b===k)throw[0,q,bTK];throw b}try{var
ac=function(b){return a},ad=j(bTT,bTS,aK,e(bTR,[0],function(b){return g(bTQ,1)},ac))}catch(b){b=n(b);if(b===k)throw[0,q,bTP];throw b}try{var
ae=function(b){switch(i[0]){case
0:return bTV;case
1:return bTW;default:return bTX}},af=j(bT1,bT0,hT,e(bTZ,[0],function(b){return g(bTY,1)},ae))}catch(b){b=n(b);if(b===k)throw[0,q,bTU];throw b}try{var
ag=function(c){return b[9]},ah=j(bT6,bT5,cc,e(bT4,[0],function(b){return g(bT3,1)},ag))}catch(b){b=n(b);if(b===k)throw[0,q,bT2];throw b}var
v=O(bT8,u(Q(bT7,tZ),[0,V,X,Z,$,ab,ad,af,ah])),m=v[1],w=v[2];try{var
aj=function(c){return b[2][2]},ak=j(bUb,bUa,oM,e(bT$,[0],function(b){return g(bT_,1)},aj))}catch(b){b=n(b);if(b===k)throw[0,q,bT9];throw b}try{var
al=function(b){return bUd},am=j(bUh,bUg,hT,e(bUf,[0],function(b){return g(bUe,1)},al))}catch(b){b=n(b);if(b===k)throw[0,q,bUc];throw b}try{var
an=function(b){return s},ao=j(bUm,bUl,D,e(bUk,[0],function(b){return g(bUj,1)},an))}catch(b){b=n(b);if(b===k)throw[0,q,bUi];throw b}try{var
ap=function(c){return b[5]},aq=j(bUr,bUq,oI,e(bUp,[0],function(b){return g(bUo,1)},ap))}catch(b){b=n(b);if(b===k)throw[0,q,bUn];throw b}try{var
ar=function(b){return S},as=j(bUw,bUv,bA,e(bUu,[0],function(b){return g(bUt,1)},ar))}catch(b){b=n(b);if(b===k)throw[0,q,bUs];throw b}try{var
at=function(c){return b[2][8]},au=j(bUB,bUA,dw,e(bUz,[0],function(b){return g(bUy,1)},at))}catch(b){b=n(b);if(b===k)throw[0,q,bUx];throw b}try{var
av=function(b){return a},aw=j(bUG,bUF,aK,e(bUE,[0],function(b){return g(bUD,1)},av))}catch(b){b=n(b);if(b===k)throw[0,q,bUC];throw b}try{var
ax=function(c){return b[9]},az=j(bUL,bUK,cc,e(bUJ,[0],function(b){return g(bUI,1)},ax))}catch(b){b=n(b);if(b===k)throw[0,q,bUH];throw b}var
x=O(bUN,u(Q(bUM,tW),[0,ak,am,ao,aq,as,au,aw,az])),o=x[1],y=x[2];try{var
aA=function(b){return T},aB=e(bUQ,[0],function(b){return g(bUP,1)},aA)}catch(b){b=n(b);if(b===k)throw[0,q,bUO];throw b}var
aC=j(bUS,bUR,function(b){return c7(aS,b)},aB);try{var
aD=function(c){switch(i[0]){case
0:var
b=0;break;case
1:var
b=1;break;default:var
b=1}return H(d,b)},aE=e(bUV,[0],function(b){return g(bUU,1)},aD)}catch(b){b=n(b);if(b===k)throw[0,q,bUT];throw b}var
p=j(bUX,bUW,ai,aE),aF=j(bVc,bVb,ay,function(b){try{var
c=function(k){var
a=j(bU0,bUZ,D,b),c=O(bU4,j(bU3,bU2,D,u(Q(bU1,y),a))),g=j(bU6,bU5,D,b),e=O(bU_,j(bU9,bU8,D,u(Q(bU7,w),g)));if(1-p)return b;switch(i[0]){case
0:var
f=1;break;case
1:var
f=0;break;default:var
f=0}return h(d,1-f)?aZ(c,e)?c:e:d?c:e},f=e(bVa,[0],function(b){return g(bU$,1)},c);return f}catch(b){b=n(b);if(b===k)throw[0,q,bUY];throw b}});try{var
aG=function(g){if(1-p)return c(bVe);switch(i[0]){case
0:var
b=1;break;case
1:var
b=0;break;default:var
b=0}if(h(d,1-b)){var
e=j(bVg,bVf,D,m),f=O(bVk,j(bVj,bVi,D,u(Q(bVh,w),e))),a=j(bVm,bVl,D,o);return aZ(O(bVq,j(bVp,bVo,D,u(Q(bVn,y),a))),f)?o:m}return d?o:m},aH=e(bVs,[0],function(b){return g(bVr,1)},aG)}catch(b){b=n(b);if(b===k)throw[0,q,bVd];throw b}return[0,p,j(bVu,bVt,D,aH),aF,aC]}function
bVv(d){var
b=d[1],l=d[2],o=d[3],p=d[4];try{var
v=function(j){var
c=b[9],d=b[8],e=b[7],f=b[6],a=b[5],g=b[4],h=b[3],i=c8(function(b){return 0===b[0]?0===b[1][7][0]?1:0:1},h);return[0,b[1],b[2],i,g,a,f,e,d,c]},w=e(bVy,[0],function(b){return g(bVx,1)},v)}catch(b){b=n(b);if(b===k)throw[0,q,bVw];throw b}var
y=j(bVA,bVz,e8,w);try{var
z=function(c){return b},A=j(bVF,bVE,e8,e(bVD,[0],function(b){return g(bVC,1)},z))}catch(b){b=n(b);if(b===k)throw[0,q,bVB];throw b}try{var
B=function(b){return l},C=j(bVK,bVJ,fK,e(bVI,[0],function(b){return g(bVH,1)},B))}catch(b){b=n(b);if(b===k)throw[0,q,bVG];throw b}try{var
E=function(b){return o},F=j(bVP,bVO,aK,e(bVN,[0],function(b){return g(bVM,1)},E))}catch(b){b=n(b);if(b===k)throw[0,q,bVL];throw b}try{var
G=function(b){return p},H=j(bVU,bVT,D,e(bVS,[0],function(b){return g(bVR,1)},G))}catch(b){b=n(b);if(b===k)throw[0,q,bVQ];throw b}var
h=O(bVW,u(Q(bVV,oU),[0,A,C,F,H])),I=h[1],J=h[2],K=h[3],L=h[4];try{var
M=function(b){return y},N=j(bV1,bV0,e8,e(bVZ,[0],function(b){return g(bVY,1)},M))}catch(b){b=n(b);if(b===k)throw[0,q,bVX];throw b}try{var
P=function(b){return l},R=j(bV6,bV5,fK,e(bV4,[0],function(b){return g(bV3,1)},P))}catch(b){b=n(b);if(b===k)throw[0,q,bV2];throw b}try{var
S=function(b){return o},T=j(bV$,bV_,aK,e(bV9,[0],function(b){return g(bV8,1)},S))}catch(b){b=n(b);if(b===k)throw[0,q,bV7];throw b}try{var
U=function(b){return p},V=j(bWe,bWd,D,e(bWc,[0],function(b){return g(bWb,1)},U))}catch(b){b=n(b);if(b===k)throw[0,q,bWa];throw b}var
r=O(bWg,u(Q(bWf,oU),[0,N,R,T,V]))[2];try{var
W=function(b){return I},X=e(bWj,[0],function(b){return g(bWi,1)},W)}catch(b){b=n(b);if(b===k)throw[0,q,bWh];throw b}var
Y=j(bWl,bWk,ai,X);try{var
Z=function(b){return L},_=e(bWo,[0],function(b){return g(bWn,1)},Z)}catch(b){b=n(b);if(b===k)throw[0,q,bWm];throw b}var
i=j(bWq,bWp,function(b){return c7(aS,b)},_);try{var
$=function(k){if(a(i.length-1,f(bWs)))var
b=c(bWt);else
var
e=x(i.length-1),g=s(bWA),h=bM(gh(function(c,b){return dk(c,b)},g,i),e),b=m(aC(J,r),h);var
d=j(bWv,bWu,D,t(r,b));return O(bWz,j(bWy,bWx,D,u(Q(bWw,K),d)))},aa=e(bWC,[0],function(b){return g(bWB,1)},$)}catch(b){b=n(b);if(b===k)throw[0,q,bWr];throw b}return[0,Y,j(bWE,bWD,D,aa)]}function
t0(c){var
b=a4(c.kind);return R(b,bWH)?R(b,bWI)?R(b,bWJ)?R(b,bWK)?R(b,bWL)?aE(u(aN(bWM),b)):bWN:bWO:bWP:bWQ:bWR}function
t1(c){var
b=a4(c.kind);return R(b,bWX)?R(b,bWY)?R(b,bWZ)?aE(u(aN(bW0),b)):bW1:bW2:bW3}function
t2(c){var
b=a4(c.kind);return R(b,bW4)?R(b,bW5)?R(b,bW6)?R(b,bW7)?aE(u(aN(bW8),b)):bW9:bW_:bW$:bXa}function
t3(c){var
b=a4(c.kind);return R(b,bXp)?R(b,bXq)?aE(u(aN(bXr),b)):[0,aG(c.payload)]:bXs}function
eC(c){var
b=a4(c.kind);return R(b,bXK)?R(b,bXL)?R(b,bXM)?aE(u(aN(bXN),b)):bXO:bXP:bXQ}function
jN(c){var
b=a4(c.kind);return R(b,bX6)?R(b,bX7)?R(b,bX8)?aE(u(aN(bX9),b)):bX_:bX$:bYa}function
oV(c){var
b=a4(c.kind);return R(b,bYb)?R(b,bYc)?R(b,bYd)?R(b,bYe)?R(b,bYf)?R(b,bYg)?aE(u(aN(bYh),b)):bYi:[1,aH(c.payload)]:bYj:bYk:bYl:bYm}function
oW(c){var
b=a4(c.kind);return R(b,bYn)?R(b,bYo)?R(b,bYp)?R(b,bYq)?aE(u(aN(bYr),b)):bYs:bYt:bYu:bYv}function
t4(c){var
b=a4(c.kind);return R(b,bYw)?R(b,bYx)?R(b,bYy)?R(b,bYz)?aE(u(aN(bYA),b)):bYB:bYC:bYD:bYE}function
e9(c){var
b=a4(c.kind);return R(b,bYF)?R(b,bYG)?aE(u(aN(bYH),b)):bYI:bYJ}function
dx(c){var
b=a4(c.kind);return R(b,bYK)?R(b,bYL)?R(b,bYM)?R(b,bYN)?R(b,bYO)?R(b,bYP)?R(b,bYQ)?R(b,bYR)?R(b,bYS)?aE(u(aN(bYT),b)):bYU:bYV:bYW:bYX:bYY:bYZ:bY0:bY1:bY2}function
t5(c){var
b=a4(c.kind);return R(b,bY3)?R(b,bY4)?R(b,bY5)?aE(u(aN(bY6),b)):bY7:bY8:bY9}function
t6(d){var
c=a4(d.kind);if(R(c,bY_))return R(c,bY$)?aE(u(aN(bZa),c)):bZb;var
b=a4(d.payload.kind),e=R(b,bXb)?R(b,bXc)?aE(u(aN(bXd),b)):bXe:bXf;return[1,e]}function
t7(b){var
c=b.aDejaOuvertDroitAuxAllocationsFamiliales|0,d=aH(b.dateDeNaissance),e=aF(aG(b.remunerationMensuelle)),f=t5(b.obligationScolaire);return[0,b.identifiant,f,e,d,c]}function
t8(c){var
b=a4(c.kind);if(R(b,bZp))return R(b,bZq)?aE(u(aN(bZr),b)):bZs;var
d=c.payload;return[1,[0,d.satisfaitConditionsL5122CodeSecuriteSociale|0,d.satisfaitArt4Ordonnance2002Mayotte|0]]}function
t9(c){var
b=a4(c.kind);if(R(b,bZt))return R(b,bZu)?aE(u(aN(bZv),b)):bZw;var
d=c.payload,e=aF(aG(d.ancienneAllocationLogement));return[0,[0,aF(aG(d.ancienLoyerPrincipal)),e]]}function
t_(b){var
c=b.pret,f=c.accordFinancementRepresentantEtatOutreMer,j=b.operationsLogementEvolutifsSociauxAccessionProprieteAideeEtat|0,e=a4(f.kind),a=R(e,bX2)?R(e,bX3)?aE(u(aN(bX4),e)):bX5:[0,aH(f.payload)],d=a4(c.titulairePret.kind),g=R(d,bWS)?R(d,bWT)?aE(u(aN(bWU),d)):bWV:bWW,h=aH(c.dateSignature),i=[0,t0(c.typePret),h,g,a],k=t6(b.ancienneteLogement),l=b.situationR822111317|0,m=b.copropriete|0,n=b.localHabitePremiereFoisBeneficiaire|0,o=t2(b.typeTravauxLogementR8425),p=t1(b.typeTravauxLogementD83215),q=aH(b.dateEntreeLogement),r=aF(aG(b.chargesMensuellesPret));return[0,aF(aG(b.mensualitePrincipale)),r,q,p,o,n,m,l,k,i,j]}function
gj(b){var
c=b.magistratFonctionnaireCentreInteretsMaterielsFamiliauxHorsMayotte|0,d=b.estNonSalarieAgricoleL7818L78146CodeRural|0,e=b.personneHebergeeCentreSoinLL162223SecuriteSociale|0,f=t8(b.nationalite);return[0,aH(b.dateNaissance),f,e,d,c]}function
t$(b){var
g=t9(b.changementLogementD8424),h=b.logementMeubleD8422|0,i=b.ageesOuHandicapAdultesHebergeesOnereuxParticuliers|0,j=b.colocation|0,k=b.logementEstChambre|0,l=b.beneficiaireAideAdulteOuEnfantHandicapes|0,m=aF(aG(b.loyerPrincipal)),e=b.bailleur,c=a4(e.kind);if(R(c,bZg))if(R(c,bZh))if(R(c,bZi))var
d=aE(u(aN(bZj),c));else
var
f=e.payload,a=aF(aG(f.reductionLoyerSolidaritePercue)),d=[0,[0,f.conventionneLivreIIITitreVChapIII|0,a]];else
var
d=[1,[0,e.payload.conventionneLivreIIITitreIIChapISec3|0]];else
var
d=bZk;return[0,d,m,l,k,j,i,h,g]}function
ua(f){var
a=a4(f.kind);if(R(a,bZx)){if(R(a,bZy))return aE(u(aN(bZz),a));var
b=f.payload,g=b.situationGardeAlternee,n=b.etudesApprentissageStageFormationProImpossibiliteTravail|0,e=a4(g.kind),o=R(e,bXt)?R(e,bXu)?aE(u(aN(bXv),e)):bXw:[1,aG(g.payload)],p=t5(b.obligationScolaire),q=aF(aG(b.remunerationMensuelle)),r=aH(b.dateDeNaissance),s=b.aDejaOuvertDroitAuxAllocationsFamiliales|0,t=t8(b.nationalite);return[0,[0,b.identifiant,t,s,r,q,p,o,n]]}var
c=f.payload,h=c.titulaireAllocationPersonneAgee|0,i=c.beneficiaireL16119L3518L6433Secu|0,j=c.incapacite80PourcentOuRestrictionEmploi|0,d=a4(c.parente.kind),k=R(d,bXx)?R(d,bXy)?R(d,bXz)?aE(u(aN(bXA),d)):bXB:bXC:bXD,l=c.ascendantDescendantCollateralDeuxiemeTroisiemeDegre|0,m=aF(aG(c.ressources));return[1,[0,aH(c.dateNaissance),m,l,k,j,i,h]]}function
jO(c){var
d=a4(c.kind);if(R(d,bZA)){if(R(d,bZB)){if(R(d,bZC)){if(R(d,bZD))return R(d,bZE)?aE(u(aN(bZF),d)):[3,t$(c.payload)];var
b=c.payload,e=b.colocation|0,f=b.logementEstChambre|0,a=b.logementMeubleD8422|0,g=b.beneficiaireAideAdulteOuEnfantHandicapes|0,h=t4(b.categorieEquivalenceLoyerD84216),i=aF(aG(b.redevance)),j=b.construitApplicationLoi195712III|0,k=aH(b.dateConventionnement),l=b.conventionneSelonReglesDrom|0,m=b.conventionneLivreIIITitreVChapIII|0,n=b.remplitConditionsR83221|0,o=b.logementFoyerJeunesTravailleurs|0;return[1,[0,oW(b.typeUser),o,n,m,l,k,j,i,h,g,a,f,e]]}return[4,t_(c.payload)]}return[0,t$(c.payload)]}return[2,t_(c.payload)]}function
gk(b){var
o=dx(b.residence),p=b.personnesAgeesHandicapeesFoyerR8444|0,q=b.enfantANaitreApresQuatriemeMoisGrossesse|0,r=b.conditionRattacheFoyerFiscalParentIfi|0,s=oV(b.situationFamiliale),t=b.nombreAutresOccupantsLogement,v=i8(b.personnesACharge),x=ck(function(b){return ua(b)},v),c=b.logement,h=eC(c.zone),i=c.surfaceMCarres,j=c.logementDecentL89462|0,k=t3(c.usufruit),a=c.loueOuSousLoueADesTiers,d=a4(a.kind);if(R(d,bZl))if(R(d,bZm))var
e=aE(u(aN(bZn),d));else
var
f=a.payload,g=f.conformeArticleL4421|0,e=[1,[0,aH(f.dateNaissancePersonneSousLocation),g]];else
var
e=bZo;var
l=t3(c.proprietaire),m=jO(c.modeOccupation),n=[0,c.residencePrincipale|0,m,l,e,k,j,i,h],w=i8(b.prestationsRecues);return[0,ck(function(c){var
b=a4(c.kind);return R(b,bXg)?R(b,bXh)?R(b,bXi)?R(b,bXj)?aE(u(aN(bXk),b)):bXl:bXm:bXn:bXo},w),n,x,t,s,r,q,p,o]}function
bZO(b){var
c=dx(b.lieuIn),d=gi([0,aH(b.dateCouranteIn),c]);return{"montant":am(function(b){return am(function(e,b){var
c=aF(aG(b));return aO(u(d[1],c))})})}}function
bZP(b){var
c=aG(b.nNombrePartsD83225In),d=b.condition2Du83225In|0,e=aF(aG(b.ressourcesMenageArrondiesIn));return{"montant":aO(hX([0,aH(b.dateCouranteIn),e,d,c])[1])}}function
bZQ(b){var
c=aE(bZJ),d=e9(b.situationFamilialeCalculAplIn),e=b.nombrePersonnesAChargeIn,f=b.condition2Du83225In|0;return{"nNombrePartsD83225":c6(oN([0,aH(b.dateCouranteIn),f,e,d,c])[1])}}function
bZR(b){var
c=e9(b.situationFamilialeCalculAplIn);return{"nNombrePartsD83211":c6(oO([0,b.nombrePersonnesAChargeIn,c])[1])}}function
bZS(b){return{"ageOuvertureDroit":jJ(tN([0,aH(b.dateNaissanceAssureIn)])[1])}}function
bZT(b){var
f=aF(aG(b.montantDetteIn)),e=b.depenseLogementIn,d=a4(e.kind),a=R(d,bXY)?R(d,bXZ)?R(d,bX0)?aE(u(aN(bX1),d)):[0,aF(aG(e.payload))]:[1,aF(aG(e.payload))]:[2,aF(aG(e.payload))],g=aF(aG(b.montantChargesIn)),h=aF(aG(b.montantAplIn)),c=a4(b.aideVerseeIn.kind),i=R(c,bXR)?R(c,bXS)?R(c,bXT)?aE(u(aN(bXU),c)):bXV:bXW:bXX;return{"montantImpaye":aO(ao0([0,jO(b.modeOccupationIn),i,h,g,a,f])[1])}}function
bZU(b){return{"montant":aO(tO([0,aH(b.dateCouranteIn)])[1])}}function
bZV(b){var
c=jI(b.anneesIn),d=aH(b.dateCouranteIn);return{"estInferieurOuEgal":!!tP([0,aH(b.dateNaissanceIn),d,c])[1]}}function
bZW(b){var
c=jI(b.anneesIn),d=aH(b.dateCouranteIn);return{"estSuperieur":!!oP([0,aH(b.dateNaissanceIn),d,c])[1]}}function
bZX(b){var
c=dx(b.residenceIn);return{"brutHoraire":aO(tQ([0,aH(b.dateCouranteIn),c])[1])}}function
bZY(b){var
k=aE(bZK),l=aE(bZL),m=aE(bZM),n=aF(aG(b.redevanceIn)),o=aH(b.dateCouranteIn),p=eC(b.zoneIn),q=e9(b.situationFamilialeCalculAplIn),r=b.nombrePersonnesAChargeIn,s=aF(aG(b.ressourcesMenageArrondiesIn)),t=aH(b.dateConventionnementIn),v=oW(b.typeLogementFoyerIn),w=b.logementFoyerJeunesTravailleursIn|0,c=jL([0,dx(b.residenceIn),w,v,t,s,r,q,p,o,n,m,l,k]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[9],d))})}var
e=aO(c[8]),f=c6(c[7]),a=aO(c[6]),g=aO(c[5]),h=aO(c[4]),i=c6(c[3]),j=aO(c[2]);return{"coefficientMultiplicateurD83225":aO(c[1]),"coefficientRD83225":j,"nNombrePartsD83225":i,"equivalenceLoyerEligible":h,"plafondEquivalenceLoyerEligible":g,"equivalenceLoyerMinimale":a,"coefficientPriseEnChargeD83225":f,"aideFinaleFormule":e,"traitementAideFinale":am(d)}}function
bZZ(b){var
g=dx(b.residenceIn),h=aH(b.dateCouranteIn),i=t6(b.ancienneteLogementIn),j=t0(b.typePretIn),k=eC(b.zoneIn),l=b.situationR822111317In|0,m=b.coproprieteIn|0,n=aH(b.dateEntreeLogementIn),o=b.localHabitePremiereFoisBeneficiaireIn|0,p=aH(b.dateSignaturePretIn),q=t1(b.typeTravauxLogementIn),r=e9(b.situationFamilialeCalculAplIn),s=b.nombrePersonnesAChargeIn,t=aF(aG(b.ressourcesMenageArrondiesIn)),c=tT([0,aF(aG(b.mensualitePrincipaleIn)),t,s,r,q,p,o,n,m,l,k,j,i,h,g]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[5],d))})}var
e=aO(c[4]),f=c6(c[3]),a=aO(c[2]);return{"mensualiteEligible":aO(c[1]),"mensualiteMinimale":a,"coefficientPriseEnChargeD83210":f,"aideFinaleFormule":e,"traitementAideFinale":am(d)}}function
bZ0(c){var
a=aE(bZN),g=dx(c.residenceIn),b=oR([0,aH(c.dateCouranteIn),g,a]),d=!!b[4];function
e(c){return am(function(e,c){var
d=t7(c);return!!u(b[3],d)})}function
f(c){return am(function(e,c){var
d=t7(c);return!!u(b[2],d)})}return{"ageL51232":jJ(b[1]),"droitOuvert":am(f),"conditionsHorsAge":am(e),"regimeOutreMerL7511":d}}function
bZ1(b){var
i=dx(b.residenceIn),j=b.logementMeubleD8422In|0,k=aF(aG(b.reductionLoyerSolidariteIn)),l=b.colocationIn|0,m=jN(b.typeAideIn),n=b.ageesOuHandicapAdultesHebergeesOnereuxParticuliersIn|0,o=b.logementEstChambreIn|0,p=eC(b.zoneIn),q=e9(b.situationFamilialeCalculAplIn),r=b.nombrePersonnesAChargeIn,s=aH(b.dateCouranteIn),t=b.beneficiaireAideAdulteOuEnfantHandicapesIn|0,v=aF(aG(b.ressourcesMenageArrondiesIn)),c=oS([0,aF(aG(b.loyerPrincipalBaseIn)),v,t,s,r,q,p,o,n,m,l,k,j,i]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[7],d))})}var
e=aO(c[6]),f=aO(c[5]),a=c6(c[4]),g=aO(c[3]),h=aO(c[2]);return{"montantForfaitaireChargesD82316":aO(c[1]),"plafondLoyerD823162":h,"participationMinimale":g,"tauxCompositionFamiliale":a,"participationPersonnelle":f,"aideFinaleFormule":e,"traitementAideFinale":am(d)}}function
bZ2(b){var
h=t4(b.categorieEquivalenceLoyerD84216In),i=aH(b.dateCouranteIn),j=eC(b.zoneIn),k=e9(b.situationFamilialeCalculAplIn),l=b.nombrePersonnesAChargeIn,m=aF(aG(b.ressourcesMenageArrondiesIn)),n=aF(aG(b.redevanceIn)),o=dx(b.residenceIn),p=aH(b.dateConventionnementIn),q=b.logementFoyerJeunesTravailleursIn|0,c=tU([0,oW(b.typeLogementFoyerIn),q,p,o,n,m,l,k,j,i,h]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[6],d))})}var
e=aO(c[5]),f=aO(c[4]),a=aO(c[3]),g=aO(c[2]);return{"coefficientPriseEnCharge":c6(c[1]),"equivalenceLoyer":g,"montantForfaitaireCharges":a,"loyerMinimal":f,"aideFinaleFormule":e,"traitementAideFinale":am(d)}}function
bZ3(b){var
g=b.operationsLogementEvolutifsSociauxAccessionProprieteAideeEtatIn|0,h=b.coproprieteIn|0,i=aF(aG(b.chargesMensuellesPretIn)),j=aH(b.dateEntreeLogementIn),k=b.localHabitePremiereFoisBeneficiaireIn|0,l=t2(b.typeTravauxLogementIn),m=aH(b.dateSignaturePretIn),n=b.situationR822111317In|0,o=aF(aG(b.mensualitePrincipaleIn)),p=aH(b.dateCouranteIn),q=dx(b.residenceIn),r=eC(b.zoneIn),s=e9(b.situationFamilialeCalculAplIn),t=b.nombrePersonnesAChargeIn,c=tV([0,aF(aG(b.ressourcesMenageArrondiesBaseIn)),t,s,r,q,p,o,n,m,l,k,j,i,h,g]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[5],d))})}var
e=aO(c[4]),f=c6(c[3]),a=aO(c[2]);return{"mensualiteEligible":aO(c[1]),"mensualiteMinimale":a,"coefficientPriseEnCharge":f,"aideFinaleFormule":e,"traitementAideFinale":am(d)}}function
bZ4(c){var
h=aE(bZG),i=aE(bZH),j=aE(bZI),k=aH(c.dateCouranteIn),l=gj(c.demandeurIn),b=jM([0,gk(c.menageIn),l,k,j,i,h]);function
d(c){return am(function(e,c){var
d=ua(c);return!!u(b[5],d)})}var
e=b[4],f=fz(ck(function(b){return c6(b)},e)),a=hP(b[3]),g=!!b[2];return{"dateCourante":oE(b[1]),"eligibilite":g,"nombrePersonnesAChargePrisesEnCompte":a,"coefficentsEnfantsGardeAlterneePrisEnCompte":f,"condition2R8234":am(d)}}function
bZ5(b){var
i=t9(b.changementLogementD8424In),j=dx(b.residenceIn),k=b.logementMeubleD8422In|0,l=aF(aG(b.reductionLoyerSolidariteIn)),m=b.colocationIn|0,n=jN(b.typeAideIn),o=b.ageesOuHandicapAdultesHebergeesOnereuxParticuliersIn|0,p=b.logementEstChambreIn|0,q=eC(b.zoneIn),r=e9(b.situationFamilialeCalculAplIn),s=b.nombrePersonnesAChargeIn,t=aH(b.dateCouranteIn),v=b.beneficiaireAideAdulteOuEnfantHandicapesIn|0,w=aF(aG(b.ressourcesMenageArrondiesIn)),c=oT([0,aF(aG(b.loyerPrincipalIn)),w,v,t,s,r,q,p,o,n,m,l,k,j,i]),d=aO(c[7]),e=c6(c[6]),f=aO(c[5]),a=aO(c[4]),g=aO(c[3]);function
h(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[2],d))})}return{"aideFinaleFormule":aO(c[1]),"traitementAideFinale":am(h),"montantForfaitaireChargesD82316":g,"plafondLoyerD823162":a,"participationMinimale":f,"tauxCompositionFamiliale":e,"participationPersonnelle":d}}function
bZ6(b){var
e=dx(b.residenceIn),f=aH(b.dateCouranteIn),a=eC(b.zoneIn),g=b.nombrePersonnesAChargeIn,h=oV(b.situationFamilialeIn),i=aF(aG(b.ressourcesMenageSansArrondiIn)),j=jN(b.typeAideIn),c=tW([0,jO(b.modeOccupationIn),j,i,h,g,a,f,e]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[2],d))})}return{"aideFinaleFormule":aO(c[1]),"traitementAideFinale":am(d)}}function
bZ7(b){var
k=aF(aG(b.depensesJustifieesReellementEngageesIn)),l=aH(b.dateCouranteIn),m=gj(b.demandeurIn),n=gk(b.menageIn),o=aH(b.dateEmmenagementIn),g=b.informationsIn,a=g.dateNaissanceTroisiemeEnfantOuDernierSiPlus,d=a4(a.kind);if(R(d,bZc))if(R(d,bZd))var
e=aE(u(aN(bZe),d));else
var
f=a.payload,c=a4(f.kind),j=R(c,bXE)?R(c,bXF)?R(c,bXG)?aE(u(aN(bXH),c)):[0,aH(f.payload)]:bXI:bXJ,e=[1,j];else
var
e=bZf;var
h=bK8([0,[0,g.nombreEnfantsANaitreApresTroisiemeMoisGrossesse,e],o,n,m,l,k]),i=aO(h[2]);return{"eligibilite":!!h[1],"montantPrimeDemenagement":i}}function
bZ8(c){var
h=c.beneficieAidePersonnaliseeLogementIn|0,i=gj(c.demandeurIn),j=gk(c.menageIn),e=tX([0,aH(c.dateCouranteIn),j,i,h]),f=e[3],a=fz(ck(function(b){return c6(b)},f)),g=hP(e[2]),b=e[1];switch(b[0]){case
0:var
d={"kind":"PasEligible","payload":b[1]};break;case
1:var
d={"kind":nv,"payload":b[1]};break;default:var
d={"kind":ku,"payload":b[1]}}return{"eligibilite":d,"nombrePersonnesAChargePrisesEnCompte":g,"coefficentsEnfantsGardeAlterneePrisEnCompte":a}}function
bZ9(c){var
g=aH(c.dateCouranteIn),h=gj(c.demandeurIn),b=tY([0,gk(c.menageIn),h,g]),d=b[4],e=fz(ck(function(b){return c6(b)},d)),f=hP(b[3]),a=!!b[2];return{"dateCourante":oE(b[1]),"eligibilite":a,"nombrePersonnesAChargePrisesEnCompte":f,"coefficentsEnfantsGardeAlterneePrisEnCompte":e}}function
bZ_(b){var
e=dx(b.residenceIn),f=jN(b.typeAideIn),a=aH(b.dateCouranteIn),g=eC(b.zoneIn),h=b.nombrePersonnesAChargeIn,i=oV(b.situationFamilialeIn),j=aF(aG(b.ressourcesMenageSansArrondiIn)),c=tZ([0,jO(b.modeOccupationIn),j,i,h,g,a,f,e]);function
d(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[2],d))})}return{"aideFinaleFormule":aO(c[1]),"traitementAideFinale":am(d)}}function
bZ$(b){var
g=aF(aG(b.ressourcesMenagePrisesEnCompteIn)),h=aH(b.dateCouranteIn),i=gj(b.demandeurIn),c=oU([0,gk(b.menageIn),i,h,g]),d=c[4],e=fz(ck(function(b){return c6(b)},d));function
f(b){return am(function(e,b){var
d=aF(aG(b));return aO(u(c[3],d))})}var
a=aO(c[2]);return{"eligibilite":!!c[1],"aideFinaleFormule":a,"traitementAideFinale":am(f),"coefficentsEnfantsGardeAlterneePrisEnCompte":e}}function
ub(b){var
e=aF(aG(b.ressourcesMenagePrisesEnCompteIn)),f=aH(b.dateCouranteIn),a=gj(b.demandeurIn),c=bVv([0,gk(b.menageIn),a,f,e]),d=aO(c[2]);return{"eligibilite":!!c[1],"aideFinale":d}}var
oX=[0,0,0,0];function
b0a(D,C,B,A,z,y,x,w,v,t,s,r,q,p,o,n,m,l,k,j,i,h,g,a,f,e){if(!oX[1]){var
d=js(bWF),b=jr(d,b0b),c=jq(d,bWG),E=c[1],F=c[2],G=c[3],H=c[4],I=c[5],J=c[6],K=c[7],L=c[8],M=c[9],N=c[10],O=c[11],P=c[12],Q=c[13],R=c[14],S=c[15],T=c[16],U=c[17],V=c[18],W=c[19],X=c[20],Y=c[21],Z=c[22],_=c[23],$=c[24],aa=c[25],ab=function(d){var
c=d[1+b];return u(c[2],c[1])},ac=function(d){var
c=d[1+b];return u(c[3],c[1])},ad=function(d){var
c=d[1+b];return u(c[4],c[1])},ae=function(d){var
c=d[1+b];return u(c[5],c[1])},af=function(d){var
c=d[1+b];return u(c[6],c[1])},ag=function(d){var
c=d[1+b];return u(c[7],c[1])},ah=function(d){var
c=d[1+b];return u(c[8],c[1])},ai=function(d){var
c=d[1+b];return u(c[9],c[1])},aj=function(d){var
c=d[1+b];return u(c[10],c[1])},ak=function(d){var
c=d[1+b];return u(c[11],c[1])},al=function(d){var
c=d[1+b];return u(c[12],c[1])},am=function(d){var
c=d[1+b];return u(c[13],c[1])},an=function(d){var
c=d[1+b];return u(c[14],c[1])},ao=function(d){var
c=d[1+b];return u(c[15],c[1])},ap=function(d){var
c=d[1+b];return u(c[16],c[1])},aq=function(d){var
c=d[1+b];return u(c[17],c[1])},ar=function(d){var
c=d[1+b];return u(c[18],c[1])},as=function(d){var
c=d[1+b];return u(c[19],c[1])},at=function(d){var
c=d[1+b];return u(c[20],c[1])},au=function(d){var
c=d[1+b];return u(c[21],c[1])},av=function(d){var
c=d[1+b];return u(c[22],c[1])},aw=function(d){var
c=d[1+b];return u(c[23],c[1])},ax=function(d){var
c=d[1+b];return u(c[24],c[1])},ay=function(d){var
c=d[1+b];return u(c[25],c[1])};jw(d,[0,O,function(d){var
c=d[1+b];return u(c[26],c[1])},T,ay,S,ax,R,aw,H,av,I,au,aa,at,F,as,E,ar,G,aq,Z,ap,_,ao,K,an,Y,am,V,al,W,ak,M,aj,U,ai,$,ah,J,ag,L,af,N,ae,X,ad,Q,ac,P,ab]);var
az=function(e){var
c=ju(0,d);c[1+b]=e;return c};jt(d);oX[1]=az}return u(oX[1],[0,D,e,f,a,g,h,i,j,k,l,m,n,o,p,q,r,s,t,v,w,x,y,z,A,B,C])}function
b0c(b){return bh(ub)}function
b0d(b){return bh(bZ$)}function
b0e(b){return bh(bZ_)}function
b0f(b){return bh(bZ9)}function
b0g(b){return bh(bZ8)}function
b0h(b){return bh(bZ7)}function
b0i(b){return bh(bZ6)}function
b0j(b){return bh(bZ5)}function
b0k(b){return bh(bZ4)}function
b0l(b){return bh(bZ3)}function
b0m(b){return bh(bZ2)}function
b0n(b){return bh(bZ1)}function
b0o(b){return bh(bZ0)}function
b0p(b){return bh(bZZ)}function
b0q(b){return bh(bZY)}function
b0r(b){return bh(bZX)}function
b0s(b){return bh(bZW)}function
b0t(b){return bh(bZV)}function
b0u(b){return bh(bZU)}function
b0v(b){return bh(bZT)}function
b0w(b){return bh(bZS)}function
b0x(b){return bh(bZR)}function
b0y(b){return bh(bZQ)}function
b0z(b){return bh(bZP)}function
b0A(b){return bh(bZO)}tk(b0B,function(y,x,w,v,u,t,s,r,q,p,o,n,m,l,k,j,i,h,g,a,f,e,d,c,b,z){return{"contributionsSocialesAidesPersonnelleLogement":am(y),"calculEquivalenceLoyerMinimale":am(x),"calculNombrePartLogementFoyer":am(w),"calculNombrePartsAccessionPropriete":am(v),"ouvertureDroitsRetraite":am(u),"impayeDepenseLogement":am(t),"baseMensuelleAllocationsFamiliales":am(s),"verificationAgeInferieurOuEgalA":am(r),"verificationAgeSuperieurA":am(q),"smic":am(p),"calculAidePersonnaliseeLogementFoyer":am(o),"calculAidePersonnaliseeLogementAccessionPropriete":am(n),"eligibilitePrestationsFamiliales":am(m),"calculAidePersonnaliseeLogementLocatif":am(l),"calculAllocationLogementFoyer":am(k),"calculAllocationLogementAccessionPropriete":am(j),"eligibiliteAidesPersonnelleLogement":am(i),"calculAllocationLogementLocatif":am(h),"calculAidePersonnaliseeLogement":am(g),"eligibilitePrimeDeDemenagement":am(a),"eligibiliteAllocationLogement":am(f),"eligibiliteAidePersonnaliseeLogement":am(e),"calculAllocationLogement":am(d),"calculetteAidesAuLogement":am(c),"calculetteAidesAuLogementGardeAlternee":am(b)}}(b0A,b0z,b0y,b0x,b0w,b0v,b0u,b0t,b0s,b0r,b0q,b0p,b0o,b0n,b0m,b0l,b0k,b0j,b0i,b0h,b0g,b0f,b0e,b0d,b0c,b0a));var
oY=[0,0,0,0];function
b0C(g,a,f,e){if(!oY[1]){var
b=js(uc),c=jr(b,b0D),d=jq(b,uc),h=d[1],i=d[2],j=d[3],k=function(d){var
b=d[1+c];return u(b[2],b[1])},l=function(d){var
b=d[1+c];return u(b[3],b[1])};jw(b,[0,h,function(b){return b[1+c][4]},i,l,j,k]);var
m=function(e){var
d=ju(0,b);d[1+c]=e;return d};jt(b);oY[1]=m}return u(oY[1],[0,g,e,f,a])}function
b0E(b){return bh(function(b){return tl(function(c){return ub(b).aideFinale})})}function
b0F(b){return bh(function(b){return tl(function(c){return tu(b).iMontantVerse})})}PT(function(d,c,b,e){return{"eventsManager":d,"computeAllocationsFamiliales":am(c),"computeAidesAuLogement":am(b)}}(P6,b0F,b0E,b0C));n6(0);return}(globalThis));
